import * as i0 from '@angular/core';
import { Injectable, Inject, Pipe, Directive, HostListener, Input, HostBinding, Component, EventEmitter, Output, ViewChild, Renderer2, APP_INITIALIZER, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Subject, BehaviorSubject, of, throwError, Observable, iif } from 'rxjs';
import * as i3 from '@angular/platform-browser';
import { filter, map, tap, catchError, switchMap, timeout, first, debounceTime, distinctUntilChanged, take, retry, takeUntil } from 'rxjs/operators';
import * as i2 from '@angular/router';
import { NavigationEnd, NavigationStart, NavigationCancel, NavigationError, PRIMARY_OUTLET, ActivationEnd, Router, ActivatedRoute, RouterModule } from '@angular/router';
import * as i3$1 from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import * as i2$1 from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import * as i1$1 from '@angular/forms';
import { Validators, FormGroup, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject as BehaviorSubject$1 } from 'rxjs/internal/BehaviorSubject';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i8 from 'ng-lazyload-image';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { trigger, transition, query, stagger, animate, style, state } from '@angular/animations';
import * as i6$1 from 'ng2-nouislider';
import { NouisliderModule } from 'ng2-nouislider';
import * as i10 from 'ngx-bootstrap/rating';
import { RatingModule } from 'ngx-bootstrap/rating';
import * as i12 from 'ngx-bootstrap/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import * as i5 from 'ngx-bootstrap/modal';
import { ModalModule } from 'ngx-bootstrap/modal';
import * as i4 from '@angular/cdk/layout';
import { LayoutModule } from '@angular/cdk/layout';
import * as i12$1 from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import * as i13 from 'ngx-bootstrap/carousel';
import { CarouselModule as CarouselModule$1 } from 'ngx-bootstrap/carousel';
import * as i15 from 'ngx-owl-carousel';
import { OwlModule } from 'ngx-owl-carousel';
import * as i17 from 'ngx-bootstrap/tabs';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { map as map$1 } from 'rxjs/internal/operators/map';
import * as i5$1 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i4$1 from 'ngx-bootstrap/pagination';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import * as i5$2 from 'primeng/carousel';
import { CarouselModule } from 'primeng/carousel';
import * as i7 from 'primeng/api';
import * as i6$2 from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import * as i3$2 from 'ngx-bootstrap/timepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import * as i4$2 from 'ngx-bootstrap/accordion';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import * as i1$2 from 'ngx-bootstrap/dropdown';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClickOutsideModule } from 'ng-click-outside';
import { toNumber } from 'lodash';

const environment = {
    production: true,
    apiUrl: '',
    apiVersion: 'v3',
    apiVersionV4: 'v4',
    taxonApiVersion: '',
    sliderApiVersion: '',
    imageUrl: '',
    maestroUrl: '',
    languageBaseUrl: '',
    defaultImage: '',
    localMaestroUrl: '',
    localStore: '',
    version: '0.12.4'
};

class CustomThemeService {
    constructor(http) {
        this.http = http;
        this.currencySelectorSubject = new Subject();
    }
    getCustomTheme() {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/get_custom_theme`);
    }
}
CustomThemeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CustomThemeService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
CustomThemeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CustomThemeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CustomThemeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

/** This service is used for initializing any configurations that is needed before the application is started.*/
class AppInitService {
    /**inject the environment variables witch passed to the lib throw your application module */
    constructor(http, environment, customThemeService, meta) {
        this.http = http;
        this.environment = environment;
        this.customThemeService = customThemeService;
        this.meta = meta;
        /**loaded theme data you can subscribe to it any where across your app*/
        this.themeDataLoaded = new BehaviorSubject({ theme: null });
    }
    /**
     *This method is called before the application is loaded using angular APP_INITIALIZER mechanism.
    you can use this method to add any additional configuration while the application is loaded
     * @returns void
     */
    init() {
        /**Initialize Custom theme before the app gets started and Inject the theme into html*/
        return new Promise((resolve) => {
            this.http
                .get(`${this.environment.apiUrl}v3/get_custom_theme`
            // `${this.environment.apiUrl}${this.environment.apiVersion}/get_custom_theme`
            )
                .subscribe((themeData) => {
                if (themeData && themeData.response.theme) {
                    //I dont know if some one reads this value in other places or not so let it as it :)
                    localStorage.setItem('theme', JSON.stringify(themeData.response.theme));
                    let htmlTag = document.documentElement;
                    let headElem = document.head;
                    //inject the css variables into the HTML tag;
                    const theme = themeData.response.theme;
                    let style = '';
                    for (const property in theme) {
                        //you may think that this if condition is crazy, but the response comming from the API
                        //contains this values and we dont want them to be injected into styles , you can use 'delete' keyword to delete this Properties.'
                        if (theme[property] !== null &&
                            property !== 'css' &&
                            property !== 'fontName' &&
                            // property !== '--font-family' &&
                            property !== '--show-currency-selector') {
                            style += `${property}: ${theme[property]} !important;`;
                        }
                    }
                    const oldAtrr = htmlTag.getAttribute('style') !== null
                        ? htmlTag.getAttribute('style')
                        : '';
                    htmlTag.setAttribute('style', oldAtrr + `;${style}`);
                    const fontName = themeData.response.theme.fontName;
                    const currencySelector = themeData.response.theme['--show-currency-selector'];
                    //inform the people who are interested in themeData
                    this.themeDataLoaded.next(themeData.response);
                    // Fire the subject with the value from api
                    this.customThemeService.currencySelectorSubject.next(currencySelector);
                    /**to make sure that we will not make an http request untill we have a non empty font name,
                     * you know ! we should care about performance issues:)*/
                    fontName && this.createGoogleFontLink(headElem, fontName);
                    resolve(); // watch out ! after calling this function angular will start to load the application , so be aware where it is gets called !
                }
            });
        });
    }
    /**
     *create Google Font Link on the head element
     * */
    createGoogleFontLink(headElm, fontName) {
        const fontLink = document.createElement('link');
        fontLink.href = `https://fonts.googleapis.com/css?family=${fontName}&display=swap`;
        fontLink.rel = 'stylesheet';
        headElm.appendChild(fontLink);
    }
}
AppInitService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppInitService, deps: [{ token: i1.HttpClient }, { token: 'env' }, { token: CustomThemeService }, { token: i3.Meta }], target: i0.ɵɵFactoryTarget.Injectable });
AppInitService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppInitService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppInitService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }, { type: CustomThemeService }, { type: i3.Meta }]; } });

class TaxonService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.taxons = new BehaviorSubject([]);
        this.taxonApiVersion = environment.taxonApiVersion;
        if (!this.taxonApiVersion || this.taxonApiVersion == '') {
            this.taxonApiVersion = environment.apiVersion;
            this.getTaxonsFromApi();
        }
        else {
            this.getTaxonsFromApi();
        }
    }
    // return array of the taxons
    getTaxons() {
        return this.taxons.pipe(filter(taxons => {
            return Object.keys(taxons).length > 0;
        }));
    }
    static getImage(taxon) {
        // case 1 :: if no taxon exists return default image
        if (!taxon) {
            return environment.defaultImage;
        }
        else if (taxon && taxon.images && taxon.images.length > 0) {
            return taxon.images[0].path ? environment.imageUrl + taxon.images[0].path : taxon.images[0].length > 0 ? environment.imageUrl + taxon.images[0] : environment.defaultImage;
        }
        else {
            return environment.defaultImage;
        }
    }
    getTaxonsFromApi() {
        this.httpClient.get(`${environment.apiUrl}${this.taxonApiVersion}/taxons?channelCode=WEB`).pipe(map((data) => {
            return data['children'];
        })).subscribe(taxons => {
            this.taxons.next(taxons);
        });
    }
}
TaxonService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TaxonService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
TaxonService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TaxonService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TaxonService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class ConfService {
    constructor(httpClient, env) {
        this.httpClient = httpClient;
        this.env = env;
        this.notAvailableStore = new BehaviorSubject(false);
        this.storeId = new BehaviorSubject(0);
        this.popupObject = new BehaviorSubject(null);
        this.verifyMobileRequired = new BehaviorSubject(false);
        this.slides = new BehaviorSubject([]);
        this.slidesLoaded = false;
        this.slidesLoading = false;
        this.init = false;
        this.conf = new BehaviorSubject(null);
        this._logo = new BehaviorSubject(null);
        this.logo$ = this._logo.asObservable();
        this._store = new BehaviorSubject(null);
        this.featuresLoading = false;
        this.featuresLoaded = false;
        this.features = new BehaviorSubject(null);
        this.storeIsActivated = new BehaviorSubject(null);
        this.storeEnabledTestOrder = new BehaviorSubject(null);
        this.storeIsMultiLocations = new BehaviorSubject(null);
        this.storeEnableSubCategory = new BehaviorSubject(null);
        this.branch = new BehaviorSubject(null);
        this.openPopupModal = new BehaviorSubject(null);
        // isUnderConstructionStoreSubject = new Subject<boolean>();
        // isUnderConstructionStoreSubject = new Subject<any>();
        this.isUnderConstructionStoreSubject = new BehaviorSubject(false);
        this.storeIsExpired = new BehaviorSubject(null);
        this.scrollSubject = new Subject();
        for (const key of Object.keys(env)) {
            environment[key] = env[key];
        }
        this.defaultCurrency = {
            name: 'Egyptian Pound',
            code: 'EGP',
            is_default: false,
            min_order_amount: null
        };
        this.storeIsActivated.next(null);
        this.storeEnabledTestOrder.next(null);
    }
    emitScrollEvent() {
        this.scrollSubject.next();
    }
    getScrollObservable() {
        return this.scrollSubject.asObservable();
    }
    getMostViewedCategories() {
        return this.httpClient.get(`${environment.apiUrl}most-sold-taxons`);
    }
    static getStoreName() {
        if (window.location.hostname === 'localhost') {
            return environment.localStore;
        }
        else {
            return window.location.hostname;
        }
    }
    get slides$() {
        if (!this.slidesLoaded && !this.slidesLoading) {
            this.getSlider();
        }
        return this.slides.pipe(filter(() => this.slidesLoaded));
    }
    get store$() {
        return this._store.pipe(filter((data) => !!data));
    }
    getMustLogged() {
        const popupStatus = (localStorage.getItem('popupStatus') && localStorage.getItem('popupStatus') == 'lifetime') ? 'lifetime' : 'firsttime';
        return this.httpClient.get(`${environment.apiUrl}${environment.apiVersion}/getStoreIdentity?popup=${popupStatus}`);
    }
    getConf() {
        if (!this.init) {
            this.getConfFromApi();
            this.init = true;
        }
        return this.conf.pipe(filter((conf) => conf !== null));
    }
    getDefaultCurrency() {
        return this.getConf().pipe(map((conf) => {
            if (conf.currencies.length === 0) {
                return this.defaultCurrency;
            }
            const defaultCurrency = conf.currencies.find((currency) => currency.is_default);
            // if(localStorage.getItem('currentCurrency'))
            if (!defaultCurrency) {
                return conf.currencies[0];
            }
            return defaultCurrency;
        }));
    }
    checkLoggedUserToCart() {
        let isChecked;
        this.httpClient.get(`${environment.apiUrl}v3/getStoreIdentity?popup=firsttime`).subscribe((data) => {
            isChecked = data.response.isCheckLoggedUserToCart;
            localStorage.setItem('isCheckLoggedUserToCart', JSON.stringify(isChecked));
        });
    }
    getStoreID() {
        const storeName = ConfService.getStoreName();
        const body = {
            domain: storeName,
            channel: 'WEB',
        };
        return this.httpClient
            .post(`${environment.maestroUrl}stores/login/stores`, body);
    }
    checkBranchPopup(key) {
        if (this.storeIsMultiLocations.getValue() !== true) {
            return;
        }
        const branch = JSON.parse(localStorage.getItem('branch'));
        const branchId = localStorage.getItem('branchId');
        const branchStatus = localStorage.getItem('branchStatus');
        if (branchId && branch && branch.id || branchStatus && (branchStatus === 'skipped' || branchStatus === 'skipped-selected')) {
            branchId && branch && branch.id ? this.branch.next(JSON.parse(localStorage.getItem('branch'))) : this.branch.next(null);
            branchId && branch && branch.id ? localStorage.setItem('branchStatus', 'skipped-selected') : localStorage.setItem('branchStatus', 'skipped');
            if (key === 'init') {
                this.openPopupModal.next(false);
            }
            if (key === 'cart') {
                branchId && branch && branch.id ? this.openPopupModal.next(false) : this.openPopupModal.next(true);
            }
        }
        else {
            this.openPopupModal.next(true);
        }
    }
    get branch$() {
        const branch = JSON.parse(localStorage.getItem('branch'));
        const branchId = localStorage.getItem('branchId');
        if (branchId && branch && branch.id && branchId) {
            return JSON.parse(localStorage.getItem('branch'));
        }
        else {
            return null;
        }
    }
    checkStoreOrdersLimit(id) {
        const body = {
            domain_name: ConfService.getStoreName(),
            store_id: id
        };
        return this.httpClient.post(`${environment.maestroUrl}stores/orders-limit-check`, body);
    }
    getConfFromApi() {
        const storeName = ConfService.getStoreName();
        const body = {
            domain: storeName,
            channel: 'WEB',
        };
        if (window['ip_address']) {
            body['ip'] = window['ip_address'];
        }
        // loading spinner
        const loading = document.getElementById('loading');
        this.httpClient
            .post(`${environment.maestroUrl}stores/login/stores`, body)
            .pipe(tap((data) => {
            this.storeId.next(data['response']['id']);
            if (data.status !== 'Success' ||
                (data.response.login &&
                    // tslint:disable-next-line: triple-equals
                    data.response.login.original.status == 'Failure')) {
                this.notAvailableStore.next(true);
                if (loading) {
                    loading.remove();
                }
            }
            const dateNow = new Date();
            const expiryDate = new Date(data.response.expires_at);
            // const expiryDate = new Date('2020-10-19 00:00:00');
            if (expiryDate <= dateNow) {
                this.storeIsExpired.next(true);
                if (loading) {
                    loading.remove();
                }
            }
            if (data.response.is_active) {
                this.storeIsActivated.next(true);
            }
            else {
                this.storeIsActivated.next(false);
            }
            if (data.response.test_orders) {
                this.storeEnabledTestOrder.next(true);
            }
            else {
                this.storeEnabledTestOrder.next(false);
            }
            this.checkStoreCommingSoon(data.response.is_coming_soon);
            return Object.keys(data).length > 0 && data.status === 'success';
        }), map((data) => data.response))
            .subscribe((data) => {
            localStorage.setItem('countryCode', data.countryCode);
            localStorage.setItem('countryCodes', data.countryCodes);
            localStorage.setItem('api_url', data.api_url);
            environment.apiUrl = data.api_url;
            environment.imageUrl = data.images_url;
            this.conf.next(data);
            this.getStoreIdentity();
            if (loading) {
                setTimeout(() => {
                    loading.remove();
                }, 1000);
            }
        }, (err) => {
            if (err.status === 422) {
                //why this is usless ? cause throwing an error here prevent instanciate the app component
                // loading.remove();
                // this.storeIsExpired.next(true);
            }
            else {
                this.storeIsExpired.next(false);
            }
        });
    }
    getStoreActivation(value) {
        return this.storeIsActivated.next(value);
    }
    getStoreEnabledTest(value) {
        return this.storeEnabledTestOrder.next(value);
    }
    getStoreIsMultiLocations(value) {
        return this.storeIsMultiLocations.next(value);
    }
    getStoreIsEnableSubCategory(value) {
        return this.storeEnableSubCategory.next(value);
    }
    checkStoreCommingSoon(is_under_construction) {
        const isValid = sessionStorage.getItem('isValid');
        if (isValid) {
            const loading = document.getElementById('loading');
            if (loading) {
                loading.remove();
            }
            // return this.isUnderConstructionStoreSubject.next(false);
            return this.isUnderConstructionStoreSubject.next(false);
        }
        else {
            // return this.isUnderConstructionStoreSubject.next(is_under_construction);
            return this.isUnderConstructionStoreSubject.next(is_under_construction);
        }
    }
    getStoreIdentity() {
        const popupStatus = (localStorage.getItem('popupStatus') && localStorage.getItem('popupStatus') == 'lifetime') ? 'lifetime' : 'firsttime';
        const popupSeen = (sessionStorage.getItem('popupSeen') && sessionStorage.getItem('popupSeen') == 'seen') ? 'seent' : 'notseen';
        this.httpClient
            .get(`${environment.apiUrl}${environment.apiVersion}/getStoreIdentity?popup=${popupStatus}`)
            .pipe(map((data) => data.response))
            .subscribe((store) => {
            // this.titleService.setTitle(store.name);
            document.getElementById('favicon').href = environment.imageUrl + store.favicon;
            document.getElementById('apple').href = environment.imageUrl + store.favicon;
            this._logo.next(environment.imageUrl + store.logo);
            store.mapsApiKeyDefault = 'AIzaSyBiT3nISMJZ9Z-6ynBRj25PCW3Ld3ImHPA';
            this._store.next(store);
            localStorage.setItem('googleOauth', store.googleOauth);
            localStorage.setItem('FacebookAppId', store.appId);
            localStorage.setItem('orderTextCheckout', store.orderTextCheckout);
            localStorage.setItem('showInvoiceAfterBuy', JSON.stringify(store.showInvoiceAfterBuy));
            localStorage.setItem('loginByMobile', JSON.stringify(store.isMobileEssential));
            localStorage.setItem('mustLogged', JSON.stringify(store.mustLogged));
            localStorage.setItem('isCheckLoggedUserToCart', JSON.stringify(store.isCheckLoggedUserToCart));
            //localStorage.setItem('countryCodes', store.countryCodes);
            (store.countryCodes && store.countryCodes.length > 0) ? localStorage.setItem('countryCodes', JSON.stringify(store.countryCodes)) : localStorage.removeItem('countryCodes');
            ((store.popup && store.popup['img'] && store.mutipleBranch == false) || (store.popup && store.popup['img'] && store.mutipleBranch == true && localStorage.getItem('branchId') != null)) ? store.popup['img'] = environment.imageUrl + store.popup['img'] : store.popup = null;
            if ((popupStatus == 'lifetime' && popupSeen == 'notseen') || (localStorage.getItem('popupObject') != JSON.stringify(store.popup)) || (popupStatus == 'firsttime')) {
                this.popupObject.next(store.popup);
            }
            if (store.mutipleBranch && store.allowGeofence) {
                //stop-auto-detect//	this.storeIsMultiLocations.next(true);
                //stop-auto-detect//	this.checkBranchPopup('init')
            }
            else {
                //stop-auto-detect// this.openPopupModal.next(false)
                //stop-auto-detect// this.storeIsMultiLocations.next(false)
                //if ((!store.mutipleBranch )   ){
                //localStorage.removeItem('branchId')
                //localStorage.removeItem('branch')
                //localStorage.removeItem('branchStatus')
                //localStorage.removeItem('pos')
                //this.branch.next(null)
                //}
            }
            (store && store['enableSubCategory'] && store['enableSubCategory'] == true) ? this.storeEnableSubCategory.next(true) : this.storeEnableSubCategory.next(false);
            this.verifyMobileRequired.next((store.loginByMobile && store.loginByMobile == true && store.otpStatus && store.otpStatus == true) ? true : false);
        });
    }
    getbrandsAndAds() {
        return this.httpClient
            .get(`${environment.apiUrl}${environment.apiVersion}/ads`);
    }
    getSlider() {
        this.slidesLoading = true;
        this.httpClient
            .get(`${environment.apiUrl}${environment.sliderApiVersion == '' || !environment.sliderApiVersion ? environment.sliderApiVersion = environment.apiVersion : environment.sliderApiVersion}/home_slider_show`)
            .pipe(map((slides) => {
            return slides.sliders.map((slide) => {
                slide.picture = environment.imageUrl + slide.picture;
                return slide;
            });
        }))
            .subscribe((slides) => {
            this.slidesLoading = false;
            this.slidesLoaded = true;
            this.slides.next(slides);
        });
    }
    getFeatures() {
        if (!this.featuresLoaded && !this.featuresLoading) {
            this.getFeaturesFromApi();
        }
        return this.features.pipe(filter(() => this.featuresLoaded));
    }
    getFeaturesFromApi() {
        this.featuresLoading = true;
        this.getConf().subscribe((features) => {
            this.featuresLoaded = true;
            this.featuresLoading = false;
            if (features.login && features.login.original.status === 'Success') {
                this.features.next(features);
            }
            else {
                this.features.next({
                    login: { original: { response: { response: { features } } } },
                });
            }
        });
    }
    validateStorePassword(password) {
        const passBody = {
            password: password,
        };
        return this.httpClient.post(`${environment.apiUrl}v3.1/validate_visitor`, passBody, {
            observe: 'response',
        });
    }
    getSWManifest() {
        return this.httpClient.get(`${environment.apiUrl}${environment.apiVersion}/sw-manifest`);
    }
}
ConfService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ConfService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable });
ConfService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ConfService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ConfService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class LanguageService {
    constructor(http, _router, confService, _customTheme) {
        this.http = http;
        this._router = _router;
        this.confService = confService;
        this._customTheme = _customTheme;
        this.lastLocale = '';
        this.localeChange = new Subject();
        this.defaultLocale = '';
        this.defaultLocales = {
            en: 'en_US',
            ar: 'ar_EG'
        };
        this.availableLocales = new BehaviorSubject([]);
        this.language = new BehaviorSubject({});
        this.readUrl();
        this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.readUrl();
        });
        this.getAvailableLocalesFromApi();
    }
    setLocale(locale) {
        this.lastLocale = locale;
        localStorage.setItem('language', locale);
        this.getLocalesFromApi();
        this.localeChange.next(null);
    }
    getLanguage() {
        return this.language.pipe(filter(data => {
            return Object.keys(data).length > 0;
        }));
    }
    readUrl() {
        let locale;
        locale = this._router.url.split('/').filter(url => url !== '')[0];
        if (locale === undefined) {
            return;
        }
        if (locale === this.lastLocale) {
            return;
        }
        if (locale !== this.lastLocale) {
            locale = this._router.url.split('?').filter(url => url !== '')[0].split('/')[1];
            if (locale === undefined) {
                return;
            }
        }
        this.is_available(locale).subscribe(data => {
            const currentLang = localStorage.getItem('language') ? localStorage.getItem('language') : this.defaultLocale;
            // handle invalid language
            if (!data && this._router.url.indexOf('/admin') < 0) {
                this._router.navigateByUrl(currentLang + this._router.url, { replaceUrl: true });
            }
            else {
                // handle repeated locale codes in url
                if (this._router.url.lastIndexOf(currentLang) > 1) {
                    let routeWithoutLocale = this._router.url.split('/');
                    routeWithoutLocale = routeWithoutLocale.filter(r => r !== '').filter(r => r !== currentLang);
                    const redirectTo = routeWithoutLocale[0] ? routeWithoutLocale[0] : '';
                    let fullPath = redirectTo !== '' ? currentLang + '/' + redirectTo : currentLang;
                    fullPath = fullPath.indexOf('?') > -1 ? '?' + fullPath.split('?')[1] : fullPath;
                    this._router.navigateByUrl(fullPath, { replaceUrl: true });
                }
                this.setLocale(locale === 'admin' ? this.defaultLocale : locale);
            }
        });
    }
    getAvailableLocales() {
        return this.availableLocales.pipe(filter(data => {
            return data.length > 0;
        }));
    }
    is_available(locale) {
        return this.availableLocales.pipe(filter(data => {
            return data.length > 0;
        }), map(data => {
            return data.findIndex(availableLocale => {
                return availableLocale.code === locale;
            }) !== -1;
        }));
    }
    getLocalesFromApi() {
        this.getAvailableLocales().subscribe(availableLocales => {
            const selectedLocale = availableLocales.find(locale => locale.code === this.lastLocale);
            const url = selectedLocale.json;
            this.http
                .get(url).pipe(catchError(() => {
                const locale = this.defaultLocales[this.lastLocale.split('_')[0]];
                return this.http.get(`${environment.languageBaseUrl}${locale}.json`);
            })).subscribe(data => {
                data['LANGUAGE_CODE'] = selectedLocale.code;
                data['LANGUAGE_NAME'] = selectedLocale.name;
                this.changeLangAttrBasedOnLanguage(data['LANGUAGE_CODE']);
                document.documentElement.dir = data['DIR'];
                this.confService.getDefaultCurrency().subscribe((currency) => {
                    this.confService.getConf().subscribe(conf => {
                        if (!localStorage.getItem('currentCurrency') || (conf['show_currency_selector'] === false) && localStorage.getItem('FirstTime') == null) {
                            localStorage.setItem('FirstTime', 'true');
                            localStorage.setItem('currentCurrency', currency.code);
                        }
                    });
                    if (data[currency.code]) {
                        data['egyptianPound'] = data[currency.code];
                    }
                    else {
                        data['egyptianPound'] = '$';
                    }
                    this.language.next(data);
                });
            });
        });
    }
    getAvailableLocalesFromApi() {
        this.confService.getConf().subscribe(data => {
            const defaultLocale = data.locales.find(locale => locale.is_default);
            if (defaultLocale) {
                this.defaultLocale = defaultLocale.code;
            }
            else {
                this.defaultLocale = data.locales[0].code;
            }
            this.availableLocales.next(data.locales);
        });
    }
    /**
   * Returns void
   * @param langCode languageCode return from getAvailableLocales
   *
   * @returns void
   *
   * @method
   * check if the languageCode is en_US so lang attribute in document will be lang="en"
   * check if the languageCode is ar_EG so lang attribute in document will be lang="ar"
   * lang attribute in the HTML will be lang="ar"
   * */
    changeLangAttrBasedOnLanguage(langCode) {
        switch (langCode) {
            case 'en_US':
                document.documentElement.lang = 'en';
                break;
            case 'ar_EG':
                document.documentElement.lang = 'ar';
                break;
        }
    }
}
LanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LanguageService, deps: [{ token: i1.HttpClient }, { token: i2.Router }, { token: ConfService }, { token: CustomThemeService }], target: i0.ɵɵFactoryTarget.Injectable });
LanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LanguageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.Router }, { type: ConfService }, { type: CustomThemeService }]; } });

class TranslatePipe {
    constructor(languageService) {
        this.languageService = languageService;
    }
    transform(translation, attributeName) {
        if (!translation || !translation.translations) {
            return '!TR';
        }
        if (!translation.translations[this.languageService.lastLocale]) {
            if (!translation.translations[this.languageService.defaultLocale]) {
                return translation.translations[Object.keys(translation.translations)[0]][attributeName];
            }
            return translation.translations[this.languageService.defaultLocale][attributeName];
        }
        return translation.translations[this.languageService.lastLocale][attributeName];
    }
}
TranslatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TranslatePipe, deps: [{ token: LanguageService }], target: i0.ɵɵFactoryTarget.Pipe });
TranslatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TranslatePipe, name: "translate", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TranslatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'translate',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }]; } });

class AuthService {
    constructor(confService, toastr) {
        this.confService = confService;
        this.toastr = toastr;
        this.updatedProfilePic = new Subject();
        this.hexDigits = '0123456789ABCDEF';
        this.hexLookup = Array(256);
        this.authStorePath = 'zvendo.auth.';
        for (let i = 0; i < 256; i++) {
            this.hexLookup[i] = this.hexDigits.indexOf(String.fromCharCode(i));
        }
    }
    static toDateTime(secs) {
        const t = new Date(1970, 0, 1, 2, 0, 0);
        t.setSeconds(secs);
        return t;
    }
    static needsAuth(req) {
        return (req.url.indexOf('register.zvendo') === -1
            &&
                req.url.indexOf('oauth/v3/token') === -1
            &&
                req.url.indexOf('assets') === -1
            &&
                req.url.indexOf('eshtery.biz') === -1);
    }
    set(where, what) {
        localStorage.setItem(this.authStorePath + where, what);
    }
    get(where) {
        return localStorage.getItem(this.authStorePath + where);
    }
    has(where) {
        return !!localStorage.getItem(this.authStorePath + where);
    }
    setsyliusHeaders(req, defaultCurrency, show_currency_selector) {
        const jwtToken = localStorage.getItem('jwt_token') ? localStorage.getItem('jwt_token') : sessionStorage.getItem('jwt_token');
        const locale = localStorage.getItem('language') ? localStorage.getItem('language') : 'en_US';
        const countryCode = localStorage.getItem('countryCode') ? localStorage.getItem('countryCode') : 'EG';
        /**
   *@description : get current currency from localstorage
   * check it to make sure the currency does not equal null or undefined then
   * if equal EGP (Defult Currency) set currency in header 'empty string'
   * else set currenct in localstorage EGP & pass it to current currency then
   * set it in the header
   * @author Ahmed Nader
   *
   */
        const currentCurrency = localStorage.getItem('currentCurrency');
        const selectedBranchId = localStorage.getItem('branchId') || '';
        let newReq;
        if (selectedBranchId) {
            newReq = req.clone({
                headers: req.headers
                    .set('JWT', 'Bearer ' + jwtToken)
                    // .set('Content-Type', 'application/json')
                    .set('Accept', 'application/json')
                    // .set('currency', (currentCurrency && show_currency_selector) ? currentCurrency : defaultCurrency)
                    .set('countryCode', countryCode)
                    .set('branchId', selectedBranchId)
                    .set('locale', locale)
                    .set('channelCode', 'WEB')
            });
        }
        else {
            newReq = req.clone({
                headers: req.headers
                    .set('JWT', 'Bearer ' + jwtToken)
                    // .set('Content-Type', 'application/json')
                    .set('Accept', 'application/json')
                    // .set('currency', (currentCurrency && show_currency_selector) ? currentCurrency : defaultCurrency)
                    .set('countryCode', countryCode)
                    .set('locale', locale)
                    .set('channelCode', 'WEB')
            });
        }
        return of(newReq);
    }
    // handle401Error<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    //   if (!this.tokenLoading) {
    //     this.getTokenFromApi();
    //   }
    //   return this.setsyliusHeaders(req).pipe(
    //     switchMap(request => {
    //       return next.handle(request);
    //     })
    //   );
    // }
    handle0Error(req, next) {
        return this.setsyliusHeaders(req).pipe(switchMap(request => {
            return next.handle(request);
        }));
    }
    setHeaders(req, next) {
        if (!AuthService.needsAuth(req)) {
            return next.handle(req.clone({
                headers: req.headers
                    // .set('Content-Type', 'application/json')
                    .set('Accept', 'application/json')
            })).pipe(timeout(20000));
        }
        return this.confService.getConf().pipe(switchMap((res) => {
            const dCurrency = res['currencies'].length ? res.currencies.find(d => d.is_default).code : '';
            const httpRequest = { url: req.url.replace('API_DEFAULT_URL', environment.apiUrl) + '' };
            req = Object.assign(req, httpRequest);
            return this.setsyliusHeaders(req, dCurrency, res['show_currency_selector']).pipe(first(), switchMap(request => {
                return next.handle(request).pipe(timeout(20000), catchError((error) => {
                    if (error.status === 401) {
                        // return this.handle401Error(req, next);
                        if (error.url.indexOf('/getStoreIdentity') > -1) {
                            this.toastr.error('Authorization Problem', ``, { enableHtml: true, closeButton: true });
                        }
                    }
                    if (error.status === 0) {
                        return this.handle0Error(req, next);
                    }
                    return throwError(error);
                }));
            }));
        }));
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AuthService, deps: [{ token: ConfService }, { token: i3$1.ToastrService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AuthService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ConfService }, { type: i3$1.ToastrService }]; } });

class CollectionService {
    constructor(_http, _router, languageService, auth, taxonService, meta, translatePipe) {
        this._http = _http;
        this._router = _router;
        this.languageService = languageService;
        this.auth = auth;
        this.taxonService = taxonService;
        this.meta = meta;
        this.translatePipe = translatePipe;
        this.pages_count = new BehaviorSubject(0);
        this.productsCount = new BehaviorSubject(0);
        this.filter = new BehaviorSubject(null);
        this.defaultLimit = 12;
        this.params$ = new BehaviorSubject([]);
        this.homePageItems = new BehaviorSubject(null);
        this.loading = false;
        this.gridClassSubject = new BehaviorSubject(true);
        this.hasViewMoreBtn = new BehaviorSubject(false);
        this.array = [
            'options',
            'attributes',
        ];
        this.primitive = [
            'q',
            'page',
            'price',
            'order',
            'rating',
            'sort',
            'limit',
            'featured',
            'bestseller',
            'new',
            'codes',
            'discounted',
        ];
        this.taxonService.getTaxons().subscribe(taxons => this.taxons = taxons);
    }
    static implode(options) {
        const array = [];
        for (const option of options) {
            const key = Object.keys(option)[0];
            array.push(`${key}:${option[key]}`);
        }
        return array.join(',');
    }
    static explode(options) {
        const array = options.split(',');
        const optionsArray = [];
        for (const element of array) {
            const split = element.split(':');
            const newOption = {};
            newOption[split[0]] = split[1];
            optionsArray.push(newOption);
        }
        return optionsArray;
    }
    getCollection(params, listenToChanges = true) {
        const body = {};
        const keys = Object.keys(params);
        if (keys.indexOf('limit') === -1) {
            body['limit'] = this.defaultLimit;
        }
        for (const key of keys) {
            if (this.primitive.indexOf(key) !== -1) {
                body[key] = params[key];
            }
            else if (key === 'taxons') {
                if (params[key][0] !== undefined && params[key][0] !== 'undefined') {
                    body[key] = params[key];
                }
                if (typeof params['taxons'] === 'string') {
                    body[key] = params[key].split(',');
                }
            }
            else if (this.array.indexOf(key) !== -1) {
                body[key] = CollectionService.explode(params[key]);
            }
            else {
                return;
            }
        }
        const currentCurrency = localStorage.getItem('currentCurrency');
        const countryCode = localStorage.getItem('countryCode') ? localStorage.getItem('countryCode') : 'EG';
        const branchId = localStorage.getItem('branchId') ? localStorage.getItem('branchId') : ' ';
        const headerDict = {
            'currency': currentCurrency,
            'countryCode': countryCode,
            'branchId': branchId
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        console.log("header is here");
        return this._http.post(`${environment.apiUrl}${environment.apiVersion}/WEB/products/filter?_locale=${localStorage.getItem('language')}`, body, requestOptions).pipe(map(data => {
            this.pages_count.next(+data['pages_count']);
            this.productsCount.next(data['products_count']);
            for (let i = 0; i < data['products'].length; i++) {
                data['products'][i] = this.filterOptions(data['products'][i]);
            }
            if (listenToChanges) {
                this.filter.next(data['filter']);
            }
            return data['products'];
        }));
    }
    getCollectionForAutocomplete(params) {
        return this._http.post(`${environment.apiUrl}${environment.apiVersion}/WEB/products/auto_complete?_locale=${localStorage.getItem('language')}`, params).pipe(map(data => {
            return data['products'];
        }));
    }
    // add/remove taxon to/from the url
    changeTaxon(taxon, addRemove) {
        let newParams;
        newParams = Object.assign({}, this.params);
        let taxons = [];
        if (this.params['taxons'] !== undefined) {
            taxons = this.params['taxons'].split(',');
        }
        if (addRemove) {
            this.clearTaxonParents(taxon, taxons);
            taxons.push(taxon);
        }
        else {
            const key = Object.keys(taxons).find(i => {
                return taxons[i] === taxon;
            });
            taxons.splice(+key, 1);
        }
        if (taxons.length > 0) {
            newParams['taxons'] = taxons.join(',');
        }
        else {
            delete newParams['taxons'];
        }
        newParams['page'] = 1;
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    /**
     * @inputs
     * type: attributes or options
     * option: attributes/options name
     * value: attributes/options value
     * addRemove: add or remove this value to/from the url
     *
     * @output
     * void
     *
     * @functionality
     * add/remove the select value to the url and reroute to it so it get executed
     * */
    changeFilter(type, option, value, addRemove) {
        const newParams = Object.assign({}, this.params);
        let options = [];
        if (this.params[type] !== undefined) {
            options = CollectionService.explode(this.params[type]);
        }
        if (addRemove) {
            const newOption = {};
            newOption[option] = value;
            options.push(newOption);
        }
        else {
            const key = Object.keys(options).find(i => {
                return options[i][option] === value;
            });
            options.splice(+key, 1);
        }
        if (options.length > 0) {
            newParams[type] = CollectionService.implode(options);
        }
        else {
            delete newParams[type];
        }
        newParams['page'] = 1;
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    setParams(params) {
        this.params = params;
        this.params$.next(params);
    }
    changeX(x, value) {
        let newParams;
        newParams = Object.assign({}, this.params);
        if (value === false) {
            delete newParams[x];
        }
        else {
            newParams[x] = value;
        }
        if (x !== 'page') {
            newParams['page'] = 1;
        }
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    changeSort(sort, order) {
        let newParams;
        newParams = Object.assign({}, this.params);
        if (sort === false) {
            delete newParams['sort'];
        }
        else {
            newParams['sort'] = sort;
        }
        if (order === false) {
            delete newParams['order'];
        }
        else {
            newParams['order'] = order;
        }
        newParams['page'] = 1;
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    filterOptions(product) {
        const options = [];
        if (product.variants.length === 0) {
            return product;
        }
        else if (product.variants[0].optionValues.length === 0) {
            return product;
        }
        else {
            for (const option of product.variants[0].optionValues) {
                options.push({
                    name: option.name,
                    code: option.code,
                    translations: option.translations,
                    option_values: [],
                    view_as_thumbnail: option.view_as_thumbnail
                });
            }
        }
        for (const variant of product.variants) {
            for (const option of options) {
                const optionValue = variant.optionValues.find(_optionValue => _optionValue.code === option.code);
                if (!optionValue) {
                    continue;
                }
                if (!option.option_values.find(_optionValue => _optionValue.code === optionValue.value.code)) {
                    option.option_values.push(optionValue.value);
                }
            }
        }
        product.options = options;
        return product;
    }
    filterOptionsWithoutConnect(product) {
        const options = [];
        if (product.variants.length === 0) {
            return product;
        }
        else if (product.variants[0].optionValues.length === 0) {
            return product;
        }
        else {
            for (const option of product.variants[0].optionValues) {
                options.push({
                    name: option.name,
                    code: option.code,
                    translations: option.translations,
                    option_values: [],
                    view_as_thumbnail: option.view_as_thumbnail
                });
            }
        }
        for (const variant of product.variants) {
            for (const option of options) {
                const optionValue = variant.optionValues.find(_optionValue => _optionValue.code === option.code);
                if (!optionValue) {
                    continue;
                }
                if (!option.option_values.find(_optionValue => _optionValue.code === optionValue.value.code)) {
                    option.option_values.push(optionValue.value);
                }
            }
        }
        product.options = options;
        return product;
    }
    checkAvailiableVariables(product, code, Optionindex) {
        product.options.map((Optionvalue, index) => {
            if (index != 0 && index > Optionindex) {
                product.options[index].option_values = [];
                product.variants.map((Vairantevalue) => {
                    const variantoption = Vairantevalue.optionValues.find((optionsValue) => optionsValue.value.code == code);
                    if (variantoption) {
                        (Vairantevalue.optionValues.map(optionValue => {
                            if (optionValue.code == Optionvalue.code) {
                                product.options[index].option_values.push(optionValue.value);
                            }
                        }));
                    }
                    product.selectedVariante = Vairantevalue;
                });
            }
        });
        // product.selectedVariante.optionValues = product.options as any
        return product;
    }
    is_parent(parentCode, childCode) {
        const parent = this.getTaxon(parentCode, this.taxons);
        if (!parent['children']) {
            return false;
        }
        for (const child of parent['children']) {
            if (child.code === childCode) {
                return true;
            }
            if (this.is_parent(child.code, childCode)) {
                return true;
            }
        }
        return false;
    }
    getTaxon(code, taxons) {
        const taxon = this.getTaxonFrom(code, taxons);
        if (!taxon) {
            return null;
        }
        return taxon;
    }
    getTaxonFrom(code, taxons) {
        if (!taxons) {
            return null;
        }
        for (const taxon of taxons) {
            if (taxon.code === code) {
                return taxon;
            }
            if (taxon.children === undefined) {
                continue;
            }
            const taxon_ = this.getTaxonFrom(code, taxon.children);
            if (taxon_) {
                return taxon_;
            }
        }
    }
    clearTaxonParents(value, values) {
        for (const taxon of values) {
            if (this.is_parent(taxon, value)) {
                this.remove(taxon, values);
            }
        }
    }
    remove(value, array) {
        const key = Object.keys(array).find(i => {
            return array[i] === value;
        });
        array.splice(+key, 1);
    }
    getHomePageProducts(params) {
        if (this.homePageItems.getValue() !== null) {
            return new Observable(data => {
                data.next(this.homePageItems.getValue());
                data.complete();
            });
        }
        else {
            return this.loadFromApi();
        }
    }
    getHomeProducts(params) {
        const currentCurrency = localStorage.getItem('currentCurrency');
        const countryCode = localStorage.getItem('countryCode') ? localStorage.getItem('countryCode') : 'EG';
        const branchId = localStorage.getItem('branchId') ? localStorage.getItem('branchId') : '';
        const headerDict = {
            'currency': currentCurrency,
            'countryCode': countryCode,
            'branchId': branchId
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        let limit;
        params ? params['limit'] ? limit = params['limit'] : limit = this.defaultLimit : limit = this.defaultLimit;
        return this._http.get(`${environment.apiUrl}${environment.apiVersion}/WEB/products/homepage?limit=${limit}`, requestOptions);
    }
    loadFromApi(params) {
        const currentCurrency = localStorage.getItem('currentCurrency');
        const countryCode = localStorage.getItem('countryCode') ? localStorage.getItem('countryCode') : 'EG';
        const branchId = localStorage.getItem('branchId') ? localStorage.getItem('branchId') : '';
        const headerDict = {
            'currency': currentCurrency,
            'countryCode': countryCode,
            'branchId': branchId
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        return new Observable(resolver => {
            let limit;
            params ? params['limit'] ? limit = params['limit'] : limit = this.defaultLimit : limit = this.defaultLimit;
            this._http.get(`${environment.apiUrl}${environment.apiVersion}/WEB/products/homepage?limit=${limit}`, requestOptions).subscribe(data => {
                this.loading = true;
                // Add Meta Tags
                let keyWords;
                if (data['SEOMetaDescription']) {
                    keyWords = data['SEOMetaDescription'].split(' ').toString();
                }
                if (this.meta.getTag('name="keywords"')) {
                    this.meta.updateTag({ name: 'keywords', content: keyWords });
                }
                else {
                    this.meta.addTag({ name: 'keywords', content: keyWords });
                }
                if (this.meta.getTag('name="description"')) {
                    this.meta.updateTag({ name: 'description', content: data['SEOMetaDescription'] });
                }
                else {
                    this.meta.addTag({ name: 'description', content: data['SEOMetaDescription'] });
                }
                resolver.next(data['products']);
                this.homePageItems.next(data['products']);
                resolver.complete();
            });
        });
    }
}
CollectionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CollectionService, deps: [{ token: i1.HttpClient }, { token: i2.Router }, { token: LanguageService }, { token: AuthService }, { token: TaxonService }, { token: i3.Meta }, { token: TranslatePipe }], target: i0.ɵɵFactoryTarget.Injectable });
CollectionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CollectionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CollectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.Router }, { type: LanguageService }, { type: AuthService }, { type: TaxonService }, { type: i3.Meta }, { type: TranslatePipe }]; } });

class BreadcrumbService {
    constructor(languageService) {
        this.languageService = languageService;
        this.custom = new BehaviorSubject([]);
        this.backgroundImage = new BehaviorSubject('');
        this.language = {};
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            const breadcrumbs = this.custom.getValue();
            for (const breadcrumb of breadcrumbs) {
                breadcrumb.url[1] = language['LANGUAGE_CODE'];
            }
            this.custom.next(breadcrumbs);
        });
    }
    setCustom(breadcrumbs) {
        for (const breadcrumb of breadcrumbs) {
            breadcrumb.url.path = ['/', this.language['LANGUAGE_CODE'], ...breadcrumb.url.path];
        }
        this.custom.next(breadcrumbs);
    }
    getCustom() {
        return this.custom.asObservable();
    }
    setBackground(image) {
        this.backgroundImage.next(image);
    }
    getBackground() {
        return this.backgroundImage.asObservable();
    }
}
BreadcrumbService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BreadcrumbService, deps: [{ token: LanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
BreadcrumbService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BreadcrumbService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BreadcrumbService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }]; } });

class GoogleAnalyticsService {
    constructor() {
        this.currencyCode = localStorage.getItem('currentCurrency') || 'EGP';
    }
    viewItem(id, name, price, category, quantity) {
        if (typeof gtag !== "undefined") {
            gtag("event", "view_item", {
                currency: this.currencyCode,
                items: [
                    {
                        item_id: JSON.stringify(id),
                        item_name: name,
                        currency: this.currencyCode,
                        price: price / 100,
                        item_category: category,
                        quantity: quantity,
                    },
                ],
            });
        }
    }
    // pageView(e) {
    //   if (typeof gtag !== 'undefined') {
    //     console.log(e.urlAfterRedirects)
    //     gtag('send', 'pageview', e.urlAfterRedirects);
    //   }
    // }
    pageView(e) {
        if (typeof gtag !== 'undefined') {
            // gtag('send', 'pageview', e.urlAfterRedirects);
            gtag('event', 'page_view', {
                page_title: e.urlAfterRedirects,
                page_location: e.urlAfterRedirects,
                page_path: e.urlAfterRedirects
            });
        }
    }
    addToCart(id, name, price, category, quantity) {
        if (typeof gtag !== "undefined") {
            gtag("event", "add_to_cart", {
                currency: this.currencyCode,
                items: [
                    {
                        item_id: JSON.stringify(id),
                        item_name: name,
                        currency: this.currencyCode,
                        price: price / 100,
                        item_category: category,
                        quantity: quantity,
                    },
                ],
            });
        }
    }
    removeFromCart(id, name, price, category, quantity) {
        if (typeof gtag !== "undefined") {
            gtag("event", "remove_from_cart", {
                currency: this.currencyCode,
                items: [
                    {
                        item_id: JSON.stringify(id),
                        item_name: name,
                        currency: this.currencyCode,
                        item_category: category,
                        price: price / 100,
                        quantity: quantity,
                    },
                ],
            });
        }
    }
    begainCheckout(id, name, price, category, variant, quantity) {
        if (typeof gtag !== "undefined") {
            gtag("event", "begin_checkout", {
                currency: this.currencyCode,
                items: [
                    {
                        item_id: JSON.stringify(id),
                        item_name: name,
                        currency: this.currencyCode,
                        price: price / 100,
                        item_category: category,
                        item_variant: variant,
                        quantity: quantity,
                    },
                ],
            });
        }
    }
    placeOrder(order) {
        if (typeof gtag !== "undefined") {
            let items = [];
            for (let item in order.items) {
                items.push({
                    id: order.items[item].id,
                    name: order.items[item].variant.code,
                    category: order.items[item].variant.product.main_taxon,
                    variant: order.items[item].variant.code,
                    quantity: order.items[item].quantity,
                    price: order.items[item].unitPrice / 100,
                });
            }
            gtag("event", "purchase", {
                transaction_id: order.number,
                value: order.itemsTotal / 100,
                currency: order.currencyCode,
                items: items,
            });
        }
    }
    addToWishlist(id, name) {
        if (typeof gtag !== "undefined") {
            gtag("event", "add_to_wishlist", {
                currency: this.currencyCode,
                // value: value,
                items: [
                    {
                        item_id: JSON.stringify(id),
                        item_name: name,
                        currency: this.currencyCode,
                        // discount: discount,
                        // item_category: category,
                        // price: price,
                        // quantity: quantity
                    }
                ],
            });
        }
    }
    refund(transaction_id, value, shipping, tax, id, name, discount, category, variant, price, quantity) {
        if (typeof gtag !== "undefined") {
            gtag("event", "refund", {
                currency: this.currencyCode,
                transaction_id: JSON.stringify(transaction_id),
                value: value,
                shipping: shipping,
                tax: tax,
                items: [
                    {
                        item_id: JSON.stringify(id),
                        item_name: name,
                        currency: this.currencyCode,
                        discount: discount,
                        item_category: category,
                        item_variant: variant,
                        price: price / 100,
                        quantity: quantity
                    }
                ]
            });
        }
    }
    selectPromotion(creative_slot, coupon) {
        if (typeof gtag !== "undefined") {
            gtag("event", "select_promotion", {
                creative_slot: creative_slot,
                items: [
                    {
                        coupon: coupon,
                        currency: this.currencyCode,
                    }
                ]
            });
        }
    }
    addPaymentInfo(id, location_id, price, quantity) {
        if (typeof gtag !== "undefined") {
            gtag("event", "add_payment_info", {
                currency: this.currencyCode,
                value: 7.77,
                coupon: "SUMMER_FUN",
                payment_type: "Credit Card",
                items: [
                    {
                        item_id: id,
                        item_name: name,
                        currency: this.currencyCode,
                        location_id: location_id,
                        price: price / 100,
                        quantity: quantity
                    }
                ]
            });
        }
    }
}
GoogleAnalyticsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GoogleAnalyticsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GoogleAnalyticsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GoogleAnalyticsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GoogleAnalyticsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class WishListService {
    constructor(collectionService, toastr, languageService, router, http, analyticService) {
        this.collectionService = collectionService;
        this.toastr = toastr;
        this.languageService = languageService;
        this.router = router;
        this.http = http;
        this.analyticService = analyticService;
        this.wishList = new BehaviorSubject([]);
        this.wishListCounter = new BehaviorSubject(0);
        this.language = {};
        languageService.getLanguage().subscribe(language => this.language = language);
        this.initWishList();
    }
    initWishList() {
        if (localStorage.getItem('user_id') || sessionStorage.getItem('user_id')) {
            this.getFromApi();
        }
        else {
            const wishList = JSON.parse(localStorage.getItem('wish-list') ? localStorage.getItem('wish-list') : sessionStorage.getItem('wish-list'));
            if (wishList) {
                this.wishList.next(wishList);
                this.wishListCounter.next(wishList.length);
            }
            else {
                this.wishList.next([]);
                this.wishListCounter.next(0);
            }
        }
    }
    toggleWishList(code) {
        const wishList = this.wishList.getValue();
        let fav;
        if (!this.inWishListSync(code)) {
            wishList.push(code);
            fav = true;
        }
        else {
            wishList.splice(wishList.findIndex(p => p === code), 1);
            fav = false;
        }
        this.wishList.next(wishList);
        this.wishListCounter.next(wishList.length);
        if (localStorage.getItem('user_id') || sessionStorage.getItem('user_id')) {
            this.addToApi(code);
        }
        else {
            localStorage.getItem('wish-list') ? localStorage.setItem('wish-list', JSON.stringify(wishList)) : sessionStorage.setItem('wish-list', JSON.stringify(wishList));
        }
        if (fav) {
            this.toastr.success(`${this.language['successfullyAddedToWishList']}<br>${this.language['clickToGoToWishlist']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true }).onTap.subscribe(() => {
                this.router.navigate([this.language['LANGUAGE_CODE'], 'wish-list']);
            });
        }
        else {
            this.toastr.success(`${this.language['successfullyRemovedFromWishList']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
        }
    }
    inWishList(code) {
        return this.wishList.pipe(map(list => {
            return list !== null && list.indexOf(code) !== -1;
        }));
    }
    inWishListSync(code) {
        return this.wishList.getValue().indexOf(code) !== -1;
    }
    getWishList() {
        return this.wishList.pipe(switchMap(codes => {
            if (codes.length === 0) {
                return of([]);
            }
            return this.collectionService.getCollection({ codes: codes });
        }));
    }
    getWishListCounter() {
        return this.wishListCounter.asObservable();
    }
    clearWishList() {
        this.wishList.next([]);
        this.wishListCounter.next(0);
        if (localStorage.getItem('user_id') || sessionStorage.getItem('user_id')) {
            this.clearAllFromApi();
        }
        else {
            localStorage.setItem('wish-list', JSON.stringify([]));
        }
        this.toastr.success(`${this.language['successfullyClearedWishList']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
    }
    // dynamic wish list
    addToApi(code) {
        const body = { userId: localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id'), productCode: code };
        this.http.post(`${environment.apiUrl}${environment.apiVersion}/wishlists`, body).subscribe(res => {
        }, err => {
        });
        this.analyticService.addToWishlist(body.userId, body.productCode);
    }
    getFromApi() {
        const userId = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id');
        this.http.get(`${environment.apiUrl}${environment.apiVersion}/wishlists/${userId}`).pipe(map(res => res['products'])).subscribe(res => {
            const codes = [];
            res.forEach(wishlistItem => {
                codes.push(wishlistItem.code);
            });
            this.wishList.next(codes);
            this.wishListCounter.next(codes.length);
        }, err => {
        });
    }
    clearAllFromApi() {
        const userId = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id');
        this.http.delete(`${environment.apiUrl}${environment.apiVersion}/wishlists/bulk-remove/${userId}`).subscribe(res => {
        }, err => {
        });
    }
}
WishListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListService, deps: [{ token: CollectionService }, { token: i3$1.ToastrService }, { token: LanguageService }, { token: i2.Router }, { token: i1.HttpClient }, { token: GoogleAnalyticsService }], target: i0.ɵɵFactoryTarget.Injectable });
WishListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: CollectionService }, { type: i3$1.ToastrService }, { type: LanguageService }, { type: i2.Router }, { type: i1.HttpClient }, { type: GoogleAnalyticsService }]; } });

class FacebookPixelService {
    constructor(translatePipe) {
        this.translatePipe = translatePipe;
        this.currencyCode = localStorage.getItem('currentCurrency') || 'EGP';
    }
    ViewContent(content_ids, content_category, content_name, content_type, value) {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'ViewContent', {
                'content_ids': JSON.stringify(content_ids),
                'content_category': content_category,
                'content_name': content_name,
                'content_type': content_category,
                'currency': this.currencyCode,
                'value': value
            });
        }
    }
    AddToCart(content_ids, content_name, content_type, value) {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'AddToCart', {
                'content_ids': JSON.stringify(content_ids),
                'content_name': content_name,
                'content_type': content_type,
                'currency': this.currencyCode,
                'value': value / 100,
            });
        }
    }
    InitiateCheckout(content_category, content_ids, value) {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'InitiateCheckout', {
                'content_category': content_category,
                'content_type': content_category,
                'content_ids': JSON.stringify(content_ids),
                'currency': this.currencyCode,
                'value': value / 100,
            });
        }
    }
    AddToWishlist(content_name, content_category, content_ids, value) {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'AddToWishlist', {
                'content_name': content_name,
                'content_category': content_category,
                'content_ids': JSON.stringify(content_ids),
                'value': value / 100,
                'currency': this.currencyCode
            });
        }
    }
    Purchase(content_ids, content_name, content_type, contents, num_items, value) {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'Purchase', {
                'content_ids': JSON.stringify(content_ids),
                'order_id': content_name,
                'content_type': content_type,
                'currency': this.currencyCode,
                'value': value
            });
        }
    }
    pageView() {
        if (typeof fbq !== 'undefined') {
            fbq('track', 'PageView');
        }
    }
}
FacebookPixelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FacebookPixelService, deps: [{ token: TranslatePipe }], target: i0.ɵɵFactoryTarget.Injectable });
FacebookPixelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FacebookPixelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FacebookPixelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: TranslatePipe }]; } });

var StoresName;
(function (StoresName) {
    StoresName[StoresName["OdaId"] = 11905] = "OdaId";
    StoresName[StoresName["Promil"] = 12284] = "Promil";
    StoresName[StoresName["DoctormId"] = 12264] = "DoctormId";
    StoresName[StoresName["TamaraId"] = 11930] = "TamaraId";
    StoresName[StoresName["nilestockId"] = 12058] = "nilestockId";
    StoresName[StoresName["kanawatId"] = 12116] = "kanawatId";
    StoresName[StoresName["TawzeeaId"] = 12245] = "TawzeeaId";
    StoresName[StoresName["natureWorks"] = 4818] = "natureWorks";
    StoresName[StoresName["KFC"] = 12770] = "KFC";
    StoresName[StoresName["Dukes"] = 4315] = "Dukes";
})(StoresName || (StoresName = {}));

class ProductService {
    constructor(languageService, http, collectionService, fbService, Conf_s) {
        this.languageService = languageService;
        this.http = http;
        this.collectionService = collectionService;
        this.fbService = fbService;
        this.Conf_s = Conf_s;
        this.language = {};
        this.storeId = 0;
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.Conf_s.storeId.subscribe((id) => {
            this.storeId = id;
        });
    }
    static getImage(product, storeId) {
        var _a, _b;
        if (!product) {
            return environment.defaultImage;
        }
        else if (product && !product.isMainImage && product.main_taxon) {
            if (product['image']) {
                return product.image.length ? environment.imageUrl + product.image[0].path : environment.defaultImage;
            }
            else {
                return product.images.length ? environment.imageUrl + product.images[0].path : environment.defaultImage;
            }
        }
        else if (product.isMainImagee) {
            if (storeId === '9963') {
                if (product['image']) {
                    return environment.imageUrl + product.image[0].path;
                }
                else {
                    return environment.imageUrl + product.images[0].path;
                }
            }
            else {
                return environment.imageUrl + product.thumbnailImage.path;
            }
        }
        else if (((_a = product === null || product === void 0 ? void 0 : product.images) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = product === null || product === void 0 ? void 0 : product.image) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            if (product['image']) {
                return environment.imageUrl + product.image[0].path;
            }
            else {
                return environment.imageUrl + product.images[0].path;
            }
        }
        else {
            return environment.defaultImage;
        }
    }
    getProduct(slug, variantCode) {
        const vCode = variantCode ? variantCode : '';
        const currentCurrency = localStorage.getItem('currentCurrency');
        const headerDict = {
            currency: currentCurrency
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        console.log(requestOptions);
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/WEB/product/${slug}?variantCode=${vCode}`, requestOptions).pipe(map(data => {
            this.fbService.ViewContent(data.code, data.mainTaxon.name, data.name, data.slug, (data.combinationPrice.price / 100));
            const index = data.variants.findIndex(object => {
                return object.code === vCode;
            });
            if (index !== -1) {
                let fisrtVariant = data.variants[0];
                let currentVariant = data.variants[index];
                data.variants[0] = currentVariant;
                data.variants[index] = fisrtVariant;
            }
            if (StoresName.Promil == this.storeId) {
                return data;
            }
            else {
                return this.collectionService.filterOptionsWithoutConnect(data);
            }
        }));
    }
    getProductReview(code) {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/products/${code}/reviews/?limit=1000`).pipe(map(reviews => reviews['_embedded']['items']), map((reviews) => {
            return reviews.filter(review => {
                return review.status === 'accepted';
            });
        }));
    }
    addReview(review, code) {
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/products/${code}/reviews/`, review);
    }
}
ProductService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductService, deps: [{ token: LanguageService }, { token: i1.HttpClient }, { token: CollectionService }, { token: FacebookPixelService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Injectable });
ProductService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i1.HttpClient }, { type: CollectionService }, { type: FacebookPixelService }, { type: ConfService }]; } });

class Cart {
}
class Web {
}
class ChannelStocks {
}
class CartItem {
}
class CartItemProduct {
}
class HLink {
}
class Link {
}
class Customer {
}
class Adjustment {
}
class Variant$1 {
}

class GoogleTagManagerService {
    constructor() {
        this.currencyCode = localStorage.getItem('currentCurrency') || 'EGP';
    }
    eventEmitter(eventCategory, eventAction, eventLabel = '', eventValue = 1) {
        ga('send', 'event', {
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: eventLabel,
            eventValue: eventValue,
        });
    }
    priceEventEmitter(transactionId, orderValue, orderCurrency) {
        if (typeof ga !== 'undefined') {
            ga('ecommerce:addTransaction', {
                id: transactionId,
                revenue: orderValue,
                currency: orderCurrency,
            });
            ga('ecommerce:send');
        }
    }
    viewItem(id, name, price, category, quantity) {
        if (typeof ga !== 'undefined') {
            ga('ec:addProduct', {
                id: JSON.stringify(id),
                name: name,
                price: price / 100,
                category: category,
                quantity: quantity,
                currency: this.currencyCode,
            });
            ga('ec:setAction', 'detail');
            ga('send', 'pageview');
        }
    }
    pageView(e) {
        if (typeof ga !== 'undefined') {
            ga('send', 'pageview', e.urlAfterRedirects);
        }
    }
    addItemEventEmitter({ id, name, sku, category, price, quantity, }) {
        if (typeof ga !== 'undefined') {
            ga('ecommerce:addItem', {
                id: id,
                name: name,
                sku: sku,
                category: category,
                price: price,
                quantity: quantity,
            });
            ga('ecommerce:send');
        }
    }
    createProductObject(products, listType) {
        let gaProduct = [];
        let gtmProduct = [];
        let i = 0;
        products.forEach((product) => {
            i++;
            let price = 0;
            if (product['variants'] &&
                product['variants'].length > 0 &&
                product['variants'][0].price) {
                price = product['variants'][0].price;
            }
            else {
                if (product.combinationPrice) {
                    price = product.combinationPrice.price;
                }
            }
            gaProduct.push({
                id: product.slug,
                name: product.name,
                list_name: listType,
                brand: 'zVendo',
                category: product.mainTaxon
                    ? product.mainTaxon.name
                    : product.main_taxon,
                variant: '',
                list_position: i,
                quantity: 1,
                price: price / 100,
            });
            gtmProduct.push({
                name: product.name,
                id: product.slug,
                price: price / 100,
                brand: 'zVendo',
                category: product.mainTaxon
                    ? product.mainTaxon.name
                    : product.main_taxon,
                variant: '',
                list: listType,
                position: i,
            });
        });
        if (typeof gtag !== 'undefined' && typeof dataLayer !== 'undefined') {
            gtag('event', 'view_item_list', {
                items: gaProduct,
            });
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                ecommerce: {
                    currencyCode: localStorage.getItem('currentCurrency'),
                    impressions: gtmProduct,
                },
            });
        }
    }
    createSingleProductObject(product, listType) {
        let price = 0;
        if (product['variants'] &&
            product['variants'].length > 0 &&
            product['variants'][0].price) {
            price = product['variants'][0].price;
        }
        else {
            if (product.combinationPrice) {
                price = product.combinationPrice.price;
            }
        }
        if (typeof gtag !== 'undefined' && typeof dataLayer !== 'undefined') {
            gtag('event', 'view_item', {
                items: [
                    {
                        id: product.slug,
                        name: product.name,
                        list_name: 'collections',
                        brand: 'zVendo',
                        category: product.mainTaxon
                            ? product.mainTaxon.name
                            : product.main_taxon,
                        variant: '',
                        list_position: 1,
                        quantity: 1,
                        price: price / 100,
                    },
                ],
            });
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'productClick',
                ecommerce: {
                    click: {
                        products: [
                            {
                                name: product.name,
                                id: product.slug,
                                price: price / 100,
                                brand: 'zVendo',
                                category: product.mainTaxon
                                    ? product.mainTaxon.name
                                    : product.main_taxon,
                                variant: '',
                                position: 1,
                            },
                        ],
                    },
                },
            });
        }
    }
    addToCartEventEmitter(product, quantity, type) {
        let price = 0;
        if (product['variants'] &&
            product['variants'].length > 0 &&
            product['variants'][0].price) {
            price = product['variants'][0].price;
        }
        else {
            if (product.combinationPrice) {
                price = product.combinationPrice.price;
            }
        }
        if (typeof gtag !== 'undefined' && typeof dataLayer !== 'undefined') {
            if (type === 'add') {
                gtag('event', 'add_to_cart', {
                    currency: product.ChannelCurrency,
                    items: [
                        {
                            id: product.slug,
                            name: product.name,
                            list_name: 'collections',
                            brand: 'zVendo',
                            category: product.mainTaxon
                                ? product.mainTaxon.name
                                : product.main_taxon,
                            variant: '',
                            list_position: 1,
                            quantity: quantity,
                            price: price / 100,
                        },
                    ],
                });
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'addToCart',
                    ecommerce: {
                        currencyCode: localStorage.getItem('currentCurrency'),
                        add: {
                            products: [
                                {
                                    name: product.name,
                                    id: product.slug,
                                    price: price / 100,
                                    brand: 'zVendo',
                                    category: product.mainTaxon
                                        ? product.mainTaxon.name
                                        : product.main_taxon,
                                    variant: '',
                                    quantity: quantity,
                                },
                            ],
                        },
                    },
                });
            }
            else {
                gtag('event', 'remove_from_cart', {
                    items: [
                        {
                            id: product.slug,
                            name: product.name,
                            list_name: 'collections',
                            brand: 'zVendo',
                            category: product.mainTaxon
                                ? product.mainTaxon.name
                                : product.main_taxon,
                            variant: '',
                            list_position: 1,
                            quantity: quantity,
                            price: price / 100,
                        },
                    ],
                });
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                        remove: {
                            products: [
                                {
                                    name: product.name,
                                    id: product.slug,
                                    price: price / 100,
                                    brand: 'zVendo',
                                    category: product.mainTaxon
                                        ? product.mainTaxon.name
                                        : product.main_taxon,
                                    variant: '',
                                    quantity: quantity,
                                },
                            ],
                        },
                    },
                });
            }
        }
    }
    checkoutEventEmitter(products) {
        let gaProduct = [];
        let gtmProduct = [];
        let i = 0;
        products.forEach((product) => {
            i++;
            gaProduct.push({
                id: product.variant.product.translations.en_US.slug,
                name: product.variant.product.translations.en_US.name,
                list_name: 'collections',
                brand: 'zVendo',
                category: product.variant.product.main_taxon,
                variant: '',
                list_position: i,
                quantity: product.quantity,
                price: product.unitPrice / 100,
            });
            gtmProduct.push({
                name: product.variant.product.translations.en_US.name,
                id: product.variant.product.translations.en_US.slug,
                price: product.unitPrice / 100,
                brand: 'zVendo',
                category: product.variant.product.main_taxon,
                variant: '',
                quantity: product.quantity,
            });
        });
        if (typeof gtag !== 'undefined' && typeof dataLayer !== 'undefined') {
            gtag('event', 'begin_checkout', {
                items: gaProduct,
                coupon: localStorage.getItem('currentCoupon'),
            });
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    checkout: {
                        actionField: { step: 1, option: 'Visa' },
                        products: gtmProduct,
                    },
                },
            });
        }
    }
    purchaseEventEmitter(products, orderNumber, orderValue, orderCurrency) {
        let gaProduct = [];
        let gtmProduct = [];
        let i = 0;
        products.forEach((product) => {
            i++;
            gaProduct.push({
                id: product.variant.product.translations.en_US.slug,
                name: product.variant.product.translations.en_US.name,
                list_name: 'collections',
                brand: 'zVendo',
                category: product.variant.product.main_taxon,
                variant: '',
                list_position: i,
                quantity: product.quantity,
                price: product.unitPrice / 100,
            });
            gtmProduct.push({
                name: product.variant.product.translations.en_US.name,
                id: product.variant.product.translations.en_US.slug,
                price: product.unitPrice / 100,
                brand: 'zVendo',
                category: product.variant.product.main_taxon,
                variant: '',
                quantity: product.quantity,
            });
        });
        if (typeof gtag !== 'undefined' && typeof dataLayer !== 'undefined') {
            gtag('event', 'purchase', {
                transaction_id: orderNumber,
                affiliation: 'zVendo Store',
                value: orderValue / 100,
                currency: orderCurrency,
                tax: 0,
                shipping: 0,
                items: gaProduct,
            });
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: orderNumber,
                            affiliation: 'Online Store',
                            revenue: orderValue / 100,
                            tax: '0',
                            shipping: '0',
                            coupon: localStorage.getItem('currentCoupon'),
                        },
                        products: gtmProduct,
                    },
                },
            });
        }
    }
}
GoogleTagManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GoogleTagManagerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GoogleTagManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GoogleTagManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GoogleTagManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class TiktokPixelService {
    constructor() {
        this.currencyCode = localStorage.getItem('currentCurrency') || 'EGP';
    }
    viewItem(id, name, price, category, quantity) {
        if (typeof ttq !== "undefined") {
            var addToCartParams = {
                content_id: JSON.stringify(id),
                content_type: name,
                currency: this.currencyCode,
                value: price,
                event_time: Date.now() // Optional: Timestamp of the event
            };
            ttq.track('Pageview', addToCartParams);
        }
    }
    // pageView(e) {
    //   if (typeof gtag !== 'undefined') {
    //     console.log(e.urlAfterRedirects)
    //     gtag('send', 'pageview', e.urlAfterRedirects);
    //   }
    // }
    pageView(e) {
        if (typeof ttq !== 'undefined') {
            // gtag('send', 'pageview', e.urlAfterRedirects);
            var PageviewtParams = {
                url: e.urlAfterRedirects,
                ref_url: e.urlAfterRedirects,
                event_time: Date.now() // Optional: Timestamp of the event
            };
            ttq.track('Pageview', PageviewtParams);
        }
    }
    addToCart(id, name, price, category, quantity) {
        if (typeof ttq !== "undefined") {
            var addToCartParams = {
                content_id: JSON.stringify(id),
                content_type: category,
                currency: this.currencyCode,
                value: price / 100,
                event_time: Date.now() // Optional: Timestamp of the event
            };
            ttq.track('AddToCart', addToCartParams);
        }
    }
    removeFromCart(id, name, price, category, quantity) {
        if (typeof ttq !== "undefined") {
            var addToCartParams = {
                content_id: JSON.stringify(id),
                content_type: name,
                currency: this.currencyCode,
                value: price / 100,
                event_time: Date.now() // Optional: Timestamp of the event
            };
            ttq.track('AddToCart', addToCartParams);
        }
    }
    begainCheckout(id, name, price, category, variant, quantity) {
        if (typeof ttq !== "undefined") {
            var addToCartParams = {
                content_id: JSON.stringify(id),
                content_type: 'product',
                currency: this.currencyCode,
                value: price / 100,
                num_items: quantity,
                event_time: Date.now() // Optional: Timestamp of the event
            };
            ttq.track('InitiateCheckout', addToCartParams);
        }
    }
    placeOrder(order) {
        if (typeof ttq !== "undefined") {
            let items = [];
            for (let item in order.items) {
                items.push({
                    id: order.items[item].id,
                    name: order.items[item].variant.code,
                    category: order.items[item].variant.product.main_taxon,
                    variant: order.items[item].variant.code,
                    quantity: order.items[item].quantity,
                    price: order.items[item].unitPrice / 100,
                });
            }
            var addToCartParams = {
                content_id: order.number,
                currency: order.currencyCode,
                value: order.itemsTotal / 100,
                num_items: items.length,
                event_time: Date.now() // Optional: Timestamp of the event
            };
            ttq.track('PlaceAnOrder', addToCartParams);
        }
    }
    addToWishlist(id, name) {
        if (typeof ttq !== "undefined") {
            var addToCartParams = {
                item_id: JSON.stringify(id),
                item_name: name,
                currency: this.currencyCode,
                event_time: Date.now() // Optional: Timestamp of the event
            };
            ttq.track('InitiateCheckout', addToCartParams);
        }
    }
    addPaymentInfo(id, location_id, price, quantity) {
        if (typeof ttq !== "undefined") {
            var addToCartParams = {
                currency: this.currencyCode,
                value: 7.77,
                coupon: "SUMMER_FUN",
                payment_type: "Credit Card",
                items: [
                    {
                        item_id: id,
                        item_name: name,
                        currency: this.currencyCode,
                        location_id: location_id,
                        price: price / 100,
                        quantity: quantity
                    }
                ]
            };
            ttq.track('AddPaymentInfo', addToCartParams);
        }
    }
}
TiktokPixelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TiktokPixelService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TiktokPixelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TiktokPixelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TiktokPixelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class CartService {
    constructor(httpClient, toastr, languageService, router, translatePipe, fbService, tagManagerService, confService, analyticService, tiktok) {
        this.httpClient = httpClient;
        this.toastr = toastr;
        this.languageService = languageService;
        this.router = router;
        this.translatePipe = translatePipe;
        this.fbService = fbService;
        this.tagManagerService = tagManagerService;
        this.confService = confService;
        this.analyticService = analyticService;
        this.tiktok = tiktok;
        this.cardLoading = false;
        this.cardLoaded = false;
        this.cart = new BehaviorSubject(new Cart());
        this.cartCounter = new BehaviorSubject(0);
        this.language = {};
        this.orderSubjectSource = new BehaviorSubject(null);
        this.addedToCart = new BehaviorSubject(null);
        this.disablePurchase = new BehaviorSubject(null);
        this.outOfStock = new BehaviorSubject(false);
        this.cartItems = new BehaviorSubject([]);
        this.unitAdjustments$ = new BehaviorSubject([]);
        languageService
            .getLanguage()
            .subscribe((language) => this.language = language);
        this.cartId = +localStorage.getItem('cartId');
        this.setCartCounter(+localStorage.getItem('cart-counter'));
    }
    emptyCartLastStep(notes = '', orderValue = null, orderCurrency = '') {
        localStorage.setItem('stepFour', 'true');
        this.completeCheckout(notes).subscribe((data) => {
            if (data['status'] === 'success') {
                this.orderSubjectSource.next(data);
                const cartId = JSON.parse(localStorage.getItem('cartId'));
                this.router.navigate([
                    `/${this.language['LANGUAGE_CODE']}/order-success`,
                    cartId,
                ]);
                this.checkoutCompleted();
                this.fbService.Purchase(data['id'], data['orderNumber'], data['status'], data['total'], data['total'], orderValue / 100);
            }
        });
    }
    verifyMpgsPayment(orderId, details) {
        return this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/mpgs-callback/${orderId}`, details);
    }
    emptyCartLastStepOnlinePayment(notes = '', orderValue = null, orderCurrency = '', orderId = '') {
        localStorage.setItem('stepFour', 'true');
        const cartId = JSON.parse(localStorage.getItem('cartId'));
        this.router.navigate(['order-success', cartId]);
        const data = {
            orderNumber: orderId,
        };
        this.orderSubjectSource.next(data);
        this.checkoutCompleted();
        this.fbService.Purchase('', '', '', '', '', orderValue / 100);
    }
    emptyCartLastStepWeAccept(notes = '', orderValue = null, orderCurrency = '', orderId = '') {
        localStorage.setItem('stepFour', 'true');
        const cartId = JSON.parse(localStorage.getItem('cartId'));
        this.router.navigate(['order-success', cartId], {
            queryParams: { 'we-accept': true },
        });
        const data = {
            orderNumber: orderId,
        };
        this.orderSubjectSource.next(data);
        this.checkoutCompleted();
        this.fbService.Purchase('', '', '', '', '', orderValue / 100);
    }
    emptyCartLastStepStripePayment(paymentData, cartId) {
        localStorage.setItem('stepFour', 'true');
        if (paymentData['status'] === 'success') {
            const orderValue = paymentData['total'];
            const orderCurrency = paymentData['currency'];
            this.orderSubjectSource.next(paymentData);
            this.router.navigate([
                `/${this.language['LANGUAGE_CODE']}/order-success`,
                cartId,
            ]);
            this.checkoutCompleted();
            this.fbService.Purchase('', '', '', '', '', orderValue / 100);
        }
    }
    emptyCartLastStepPayFort(notes = '', orderValue = null, orderCurrency = '') {
        localStorage.setItem('stepFour', 'true');
        const cartId = JSON.parse(localStorage.getItem('cartId'));
        this.router.navigate(['order-success', cartId], {
            queryParams: { payfort: true },
        });
        this.checkoutCompleted();
        this.fbService.Purchase('', '', '', '', '', orderValue / 100);
    }
    emptyCartLastStepAaib(notes = "", orderValue = null, orderCurrency = "") {
        localStorage.setItem("stepFour", "true");
        const cartId = JSON.parse(localStorage.getItem("cartId"));
        this.router.navigate([`order-success`, cartId], {
            queryParams: { aaib: true },
        });
        this.checkoutCompleted();
        this.fbService.Purchase("", "", "", "", "", orderValue / 100);
    }
    emptyCartLastStepKashier(notes = "", orderValue = null, orderCurrency = "", orderId = "") {
        localStorage.setItem("stepFour", "true");
        const cartId = JSON.parse(localStorage.getItem('cartId'));
        this.router.navigate(['order-success', cartId], {
            queryParams: { kashier: true },
        });
        const data = {
            orderNumber: orderId,
        };
        this.orderSubjectSource.next(data);
        this.checkoutCompleted();
        this.fbService.Purchase('', '', '', '', '', orderValue / 100);
    }
    // NOT ACTIVE
    emptyCartLastStepStripe(orderId, notes = '', orderValue = null, orderCurrency = '', order, sk, stripeId) {
        localStorage.setItem('stepFour', 'true');
        this.completeCheckoutStripe('', stripeId, sk, orderId).subscribe((data) => {
            if (data['status'] === 'success') {
                this.orderSubjectSource.next(data);
                // this.router.navigate([this.language['LANGUAGE_CODE'], 'paymentCallback' ] , { queryParams: {  'success': '1' , 'order-number' : data['orderNumber']   } });
                this.router.navigate([
                    `/${this.language['LANGUAGE_CODE']}/order-success`,
                    orderId,
                ]);
                this.checkoutCompleted();
                localStorage.removeItem('sk');
                localStorage.removeItem('paymentCallbackId');
                // fbq('track', 'Purchase', { value: (orderValue / 100), currency: orderCurrency });
                this.fbService.Purchase('', '', '', '', '', orderValue / 100);
            }
            else {
                this.router.navigate([this.language['LANGUAGE_CODE'], 'paymentCallback'], { queryParams: { success: '2', order_id: order.id } });
            }
        });
    }
    // NOT ACTIVE
    completeCheckoutStripe(note, stripeId, sk, cartId) {
        const notes = {
            notes: note,
            stripeId: stripeId,
            sk: sk,
        };
        return this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/stripe-callback/${cartId}?_channel_code=WEB`, notes);
    }
    checkOrderCompleted(orderId) {
        return this.httpClient.get(`${environment.apiUrl}${environment.apiVersion}/checkouts/` + orderId);
    }
    // NOT ACTIVE
    initializeStripePayment(sk, amount, currency, cartId) {
        // hold not working
        const success_url = `${location.origin}/${this.language['LANGUAGE_CODE']}` +
            '/paymentCallback/stripe/' +
            cartId;
        const cancel_url = `${location.origin}/${this.language['LANGUAGE_CODE']}` +
            '/paymentCallback?success=0&message=Cancelled';
        const bodyy = new HttpParams()
            .set('success_url', success_url)
            .set('cancel_url', cancel_url)
            .set('payment_method_types[0]', 'card')
            .set('line_items[0][price_data][currency]', currency.toString())
            .set('line_items[0][price_data][unit_amount]', amount.toString())
            .set('mode', 'payment')
            .set('line_items[0][quantity]', '1')
            .set('client_reference_id', cartId.toString())
            .set('line_items[0][price_data][product_data][name]', 'payment')
            .set('line_items[0][price_data][product_data][images][0]', 'payment.jpg');
        const url = 'https://api.stripe.com/v1/checkout/sessions';
        fetch(url, {
            method: 'POST',
            body: bodyy.toString(),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${sk.toString()}`,
            },
        })
            .then((response) => response.text())
            .then(function (response2) {
            const newRespons = JSON.parse(response2);
            const stripe_url = newRespons.url;
            const paymentCallbackId = newRespons.id;
            if (stripe_url) {
                localStorage.setItem('paymentCallbackId', paymentCallbackId);
                localStorage.setItem('sk', sk);
                window.location.href = stripe_url;
            }
            else {
                return;
            }
        });
    }
    // NOT ACTIVE
    getStripePayment(stripeId, order) {
        // hold not working
        const sk = localStorage.getItem('sk');
        // this.emptyCartLastStepStripe( order.id, 'notes' , order.total,order.currentCurrency , order , sk , stripeId);
        localStorage.setItem('stepFour', 'true');
        this.completeCheckoutStripe('', stripeId, sk, order.id).subscribe((data) => {
            if (data['status'] === 'success') {
                this.orderSubjectSource.next(data);
                // this.router.navigate([this.language['LANGUAGE_CODE'], 'paymentCallback' ] , { queryParams: {  'success': '1' , 'order-number' : data['orderNumber']   } });
                this.router.navigate([
                    `/${this.language['LANGUAGE_CODE']}/order-success`,
                    order.id,
                ]);
                this.checkoutCompleted();
                localStorage.removeItem('sk');
                localStorage.removeItem('paymentCallbackId');
                // fbq('track', 'Purchase', { value: (order.total / 100), currency: order.currentCurrency });
                this.fbService.Purchase('', '', '', '', '', order.total / 100);
            }
            else {
                this.router.navigate([this.language['LANGUAGE_CODE'], 'paymentCallback'], { queryParams: { success: '2', order_id: order.id } });
            }
        });
        // const headers = { 'Authorization': `Bearer ${sk}` }
        // this.httpClient.get<any>('https://api.stripe.com/v1/checkout/sessions/' + stripeId, { headers }).subscribe(payment => {
        //       if(payment['payment_status'] == 'paid' && order.checkoutState != "completed" && order.id == payment['client_reference_id'] && payment["amount_total"] == order.total ){
        //       }else{
        //         this.router.navigate([this.language['LANGUAGE_CODE'], 'paymentCallback' ] , { queryParams: {  'success': '2' , 'order_id' : order.id   } });
        //       }
        //     })
    }
    /**
     * Represents the order data that returned from the last step in checkout
     * @returns order data
     */
    getOrderData() {
        return this.orderSubjectSource.asObservable();
    }
    completeCheckout(body) {
        const notes = {
            notes: body,
        };
        return this.httpClient.put(`${environment.apiUrl}${environment.apiVersion}/checkouts/complete/${localStorage.getItem('cartId')}?_channel_code=WEB`, notes);
    }
    checkoutCompleted() {
        localStorage.setItem('stepZero', JSON.stringify(false));
        localStorage.setItem('stepOne', JSON.stringify(false));
        localStorage.setItem('stepTwo', JSON.stringify(false));
        localStorage.setItem('stepThree', JSON.stringify(false));
        localStorage.removeItem('weaccept_order_id');
        localStorage.removeItem('payment_token');
        localStorage.removeItem('payment_expiration');
        localStorage.removeItem('weaccept_order_id');
        localStorage.removeItem('iframe_Id');
        localStorage.removeItem('iframe_Id');
        this.setCartCounter(0);
        this.cart.next(null);
        localStorage.setItem('cartId', null);
        this.cartId = null;
    }
    addToCart(variant, quantity, product) {
        const branch = JSON.parse(localStorage.getItem('branch'));
        const branchId = localStorage.getItem('branchId');
        if (!(branchId && branch && branch.id && branchId) && this.confService.storeIsMultiLocations.getValue()) {
            this.confService.checkBranchPopup('cart');
            return;
        }
        this.cartId = +localStorage.getItem("cartId");
        let orderItems;
        if (quantity >= 4001) {
            this.toastr.error(`${this.language["MaxquantityMsg"]}!`);
            return;
        }
        if (this.checkIfVariantInCart(variant)) {
            const oldQty = this.checkIfVariantInCart(variant)[1];
            //this is wrong since we have a max vlue for each variant, then we should not accumulate over the previous value
            // quantity = oldQty + quantity;
            if (variant.tracked && oldQty + quantity > variant.stock) {
                this.toastr.warning(this.language['noItemsRemaining']);
                return;
            }
            if (variant.tracked && variant.limits && oldQty + quantity > variant.maximumChecks) {
                this.toastr.warning(this.language['noItemsRemaining']);
                return;
            }
            else {
                quantity = oldQty + quantity;
            }
        }
        if (!variant.length) {
            orderItems = [
                {
                    variantCode: variant.code,
                    qty: +quantity,
                },
            ];
        }
        else {
            orderItems = variant;
        }
        const body = {
            userEmail: "customer@not.registered",
            localeCode: this.languageService.lastLocale,
            orderItems: orderItems,
        };
        const email = localStorage.getItem("user_email")
            ? localStorage.getItem("user_email")
            : sessionStorage.getItem("user_email");
        const checkoutEmail = localStorage.getItem("checkout_email");
        if (email) {
            body.userEmail = email;
        }
        if (checkoutEmail) {
            body.userEmail = checkoutEmail;
        }
        if (this.cartId > 0) {
            body["cartId"] = this.cartId;
        }
        this.addedToCart.next(false);
        const headers = new HttpHeaders({
            'currency': localStorage.getItem('currentCurrency')
        });
        this.httpClient
            .post(`${environment.apiUrl}${environment.apiVersion}/WEB/cart/items`, body, { headers: headers })
            .pipe()
            .subscribe((data) => {
            localStorage.setItem("cartId", data.response.cartId.toString());
            this.disablePurchase.next(data.response["disablePurchase"]);
            this.cartId = data.response.cartId;
            this.setCartCounter(data.response.countCartItems);
            this.loadCart();
            this.addedToCart.next(true);
            this.tagManagerService.addToCartEventEmitter(product, quantity, "add");
            this.fbService.AddToCart(product.id, product.name, product.main_taxon, data.response.itemsTotal);
            if (product.productType) {
                this.analyticService.addToCart(product.id, product.name, variant.price, product.main_taxon, quantity);
                this.tiktok.addToCart(product.id, product.name, variant.price, product.main_taxon, quantity);
            }
            else {
                this.analyticService.addToCart(product.id, product.name, variant.prices[0].price, product.main_taxon, quantity);
                this.tiktok.addToCart(product.id, product.name, variant.prices[0].price, product.main_taxon, quantity);
            }
            this.toastr
                .success(`${this.language["successfullyAddedToCart"].replace("PRODUCT_NAME", product.productType
                ? product.name
                : this.translatePipe.transform(product, "name"))}<br>
          ${this.language["clickToGoToCart"]}`, `${this.language["success"]}!`, { enableHtml: true, closeButton: true })
                .onTap.subscribe(() => {
                this.router.navigate([this.language["LANGUAGE_CODE"], "cart"]);
            });
        }, (error) => {
            //   this.addedToCart.next(true);
            if (error.status === 0) {
                this.toastr.error("no internet connection", `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
            if (error.status == 400 && error.error && error.error.code && error.error.code === 400) {
                localStorage.removeItem('cartId');
                location.reload();
                this.toastr.error(error.error.response, `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
            if (error.error.errors.length && error.status !== 306 && error.status !== 400) {
                this.toastr.error(error.error.errors[0], `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
            if (error.status === 306) {
                this.toastr.error(error.error.errors, `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
            if (error.status === 400) {
                this.toastr.error(error.error.errors[0], `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
        });
    }
    addToCartAddOns(id, quantity, product) {
        const branch = JSON.parse(localStorage.getItem('branch'));
        const branchId = localStorage.getItem('branchId');
        if ((!(branchId && branch && branch.id && branchId)) && this.confService.storeIsMultiLocations.getValue()) {
            this.confService.checkBranchPopup('cart');
            return;
        }
        let orderItems;
        orderItems = [
            {
                ids: id,
                qty: +quantity,
            },
        ];
        const body = {
            userEmail: "customer@not.registered",
            localeCode: this.languageService.lastLocale,
            orderItems: orderItems,
        };
        const email = localStorage.getItem("user_email")
            ? localStorage.getItem("user_email")
            : sessionStorage.getItem("user_email");
        const checkoutEmail = localStorage.getItem("checkout_email");
        if (email) {
            body.userEmail = email;
        }
        if (checkoutEmail) {
            body.userEmail = checkoutEmail;
        }
        if (this.cartId > 0) {
            body["cartId"] = this.cartId;
        }
        this.addedToCart.next(false);
        const headers = new HttpHeaders({
            'currency': localStorage.getItem('currentCurrency')
        });
        this.httpClient
            .post(`${environment.apiUrl}${environment.apiVersion}/WEB/cart/items`, body, { headers: headers })
            .pipe()
            .subscribe((data) => {
            localStorage.setItem("cartId", data.response.cartId.toString());
            this.cartId = data.response.cartId;
            this.setCartCounter(data.response.countCartItems);
            this.loadCart();
            this.addedToCart.next(true);
            this.fbService.AddToCart(product.id, product.name, product.main_taxon, data.response.itemsTotal);
            this.tagManagerService.addToCartEventEmitter(product, quantity, "add");
            this.toastr
                .success(`${this.language["successfullyAddedToCart"].replace("PRODUCT_NAME", product
                ? this.translatePipe.transform(product, "name")
                : this.language["products"])}<br>
          ${this.language["clickToGoToCart"]}`, `${this.language["success"]}!`, { enableHtml: true, closeButton: true })
                .onTap.subscribe(() => {
                this.router.navigate([this.language["LANGUAGE_CODE"], "cart"]);
            });
        }, (error) => {
            this.addedToCart.next(true);
            if (error.status === 0) {
                this.toastr.error("no internet connection", `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
            if (error.status == 507 && error.error && error.error.code && error.error.code === 507) {
                this.toastr.error(error.error.response, `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
            if (error.error.errors.length) {
                this.toastr.error(error.error.errors, `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
            }
        });
    }
    removeItem(code) {
        const variantCode = code["variant"]["code"];
        const cartId = +localStorage.getItem("cartId");
        const email = localStorage.getItem("user_email")
            ? localStorage.getItem("user_email")
            : sessionStorage.getItem("user_email");
        let body = {};
        const ids = [];
        if (code["units"][0]["subVariant"]) {
            code["units"].forEach((element) => {
                if (element["subVariant"]) {
                    ids.push(element["subVariant"]["id"]);
                }
            });
            body = {
                localeCode: localStorage.getItem("language"),
                cartId: cartId,
                orderItems: [
                    {
                        ids: ids,
                        variantCode: variantCode,
                        qty: 0,
                    },
                ],
            };
        }
        else {
            body = {
                localeCode: localStorage.getItem("language"),
                cartId: cartId,
                orderItems: [
                    {
                        variantCode: variantCode,
                        qty: 0,
                    },
                ],
            };
        }
        this.httpClient
            .post(`${environment.apiUrl}${environment.apiVersion}/WEB/cart-web/items`, body)
            .subscribe((data) => {
            this.analyticService.removeFromCart(code["id"], this.translatePipe.transform(code.variant, "name"), code.total, code.variant.product["main_taxon"], code.quantity);
            this.setCartCounter(data["response"]["countCartItems"]);
            this.loadCart();
            this.toastr.success(`${this.language["successfullyRemovedFromCart"]}`, `${this.language["success"]}!`, { enableHtml: true, closeButton: true });
            const cartCounter = localStorage.getItem("cart-counter");
            if (cartCounter === "0") {
                const coupon = localStorage.getItem("currentCoupon");
                if (coupon !== null || undefined) {
                    this.cartId = null;
                    localStorage.removeItem("cartId");
                    this.getCart();
                    this.loadCart();
                }
            }
        });
    }
    clearCart(items) {
        const email = localStorage.getItem("user_email")
            ? localStorage.getItem("user_email")
            : sessionStorage.getItem("user_email");
        const cartId = +localStorage.getItem("cartId");
        const body = {
            localeCode: localStorage.getItem("language"),
            cartId: cartId,
            orderItems: items,
        };
        const headers = new HttpHeaders({
            'currency': localStorage.getItem('currentCurrency')
        });
        this.httpClient
            .post(`${environment.apiUrl}${environment.apiVersion}/WEB/cart/items`, body, { headers: headers })
            .subscribe((data) => {
            this.setCartCounter(data["response"]["countCartItems"]);
            this.loadCart();
            this.toastr.success(`${this.language["successfullyClearCart"]}`, `${this.language["success"]}!`, { enableHtml: true, closeButton: true });
        }, (err) => {
            this.toastr.error(`${this.language["somthingWentWrong"]}`, `${this.language["error"]}!`, { enableHtml: true, closeButton: true });
        });
    }
    /**
     * inputs
     * @param item the item we need to change its quantity
     * EG: quantity was 3, send quantity value 1 the quantity will be 1 and NOT 4
     *
     * @return void
     *
     * @functionality
     * change the quantity of the selected item and send it to the api
     * */
    changeQuantity(item) {
        const cartId = +localStorage.getItem("cartId");
        const email = localStorage.getItem("user_email")
            ? localStorage.getItem("user_email")
            : sessionStorage.getItem("user_email");
        let orderitems;
        if (item["type"]) {
            const ids = [];
            item["units"].forEach((element) => {
                element["subVariant"]["id"];
                ids.push(element["subVariant"]["id"]);
            });
            const newIds = [...new Set(ids)];
            orderitems = {
                // userEmail: email ? email : 'customer@not.registered',
                localeCode: localStorage.getItem("language"),
                cartId: cartId,
                orderItems: [
                    {
                        ids: newIds,
                        qty: +item.quantity,
                    },
                ],
            };
        }
        else {
            orderitems = {
                // userEmail: email ? email : 'customer@not.registered',
                localeCode: localStorage.getItem("language"),
                cartId: cartId,
                orderItems: [
                    {
                        variantCode: item.variant.code,
                        qty: +item.quantity,
                    },
                ],
            };
        }
        if (cartId !== 0) {
            const headers = new HttpHeaders({
                'currency': localStorage.getItem('currentCurrency')
            });
            this.httpClient
                .post(`${environment.apiUrl}${environment.apiVersion}/WEB/cart/items`, orderitems, { headers: headers })
                .subscribe((data) => {
                this.setCartCounter(data["response"]["countCartItems"]);
                this.loadCart();
            }, (error) => {
                alert(error.error.errors[0]);
            });
        }
    }
    /**
     * inputs
     * @variant the variant we are looking to check if exists on the cart or not
     * output
     *
   * !why you return array while you actually in fn return type is opject ?!
   * TODO: we should fix the return type to match what actually returned
     * @return [
     *   0: index of the cart item and its quantity
     *   1: item quantity in the cart
     * ]
     * or FALSE if this variant doesn't exists
     * */
    checkIfVariantInCart(variant) {
        const cart = this.cart.getValue();
        if (!cart || !cart.items) {
            return false;
        }
        let i = 0;
        for (const item of cart.items) {
            if (item.variant.code === variant.code) {
                return [i, item.quantity];
            }
            i++;
        }
        return false;
    }
    /**
     * get the specific variant of this product with these options
     * @param product the product that we need to search in
     * @param options the options we need to find the variant based on
     * @returns variant if found, undefined if not
     * */
    getVariant(product, options) {
        return product.variants.find((variant) => {
            for (const optionValue of variant.optionValues) {
                if (options[optionValue.code] !== optionValue.value.code) {
                    return false;
                }
            }
            return true;
        });
    }
    setCartCounter(count) {
        localStorage.setItem("cart-counter", count.toString());
        this.cartCounter.next(count);
    }
    getCartCounter() {
        return this.cartCounter.asObservable();
    }
    getCartItems() {
        if (!this.cartId) {
            return of([]);
        }
        if (!this.cardLoading) {
            this.loadCart();
        }
        //why I have added this check? --> thats because once we have completed checkout by calling @function 'checkoutCompleted'?
        //we set the cart value to null, and as it is an ovservable it will emmit this value to every one who is listining to it , and thats exactl,
        //what we are doing here.so the cart items will be null wich will throw an error on the console :)
        //note that this will ocurr on each place that subscribe to the cart.
        return this.cart.pipe(filter(() => this.cardLoaded), map((cart) => cart === null || cart === void 0 ? void 0 : cart.items));
    }
    getCart() {
        if (!this.cartId) {
            return of(new Cart());
        }
        if (!this.cardLoading) {
            this.loadCart();
        }
        return this.cart.pipe(filter(() => this.cardLoaded));
    }
    applyCoupon(coupon) {
        if (!this.cartId) {
            return;
        }
        this.httpClient
            .post(`${environment.apiUrl}${environment.apiVersion}/carts/${this.cartId}/apply-promotion-coupon`, {
            promCode: coupon,
            channelCode: "WEB",
        })
            .subscribe((res) => {
            localStorage.setItem("currentCoupon", coupon);
            this.loadCart();
            this.toastr.success(`${this.language["couponAddedSuccessfully"]}`, `${this.language["success"]}!`, { enableHtml: true, closeButton: true });
            this.analyticService.selectPromotion("WEB", coupon);
        }, (error) => {
            this.toastr.error(null, `${(error && error.error && error.error.message) ? error.error.message : this.language["couponError"]}`, {
                enableHtml: true,
                closeButton: true,
            });
        });
    }
    removeCoupon(coupon) {
        if (!this.cartId) {
            return;
        }
        this.httpClient
            .post(`${environment.apiUrl}${environment.apiVersion}/carts/${this.cartId}/remove-promotion-coupon`, {
            promCode: coupon,
            channelCode: "WEB",
        })
            .subscribe(() => {
            this.loadCart();
            this.toastr.success(`${this.language["couponRemovedSuccessfully"]}`, `${this.language["success"]}!`, { enableHtml: true, closeButton: true });
        }, (error) => {
            this.toastr.error(null, `${this.language["couponError"]}`, {
                enableHtml: true,
                closeButton: true,
            });
        });
    }
    loadCart() {
        const currentCurrency = localStorage.getItem('currentCurrency');
        const headerDict = {
            currency: currentCurrency
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        this.cardLoading = true;
        if (this.cartId) {
            this.httpClient
                .get(`${environment.apiUrl}${environment.apiVersion}/carts/${this.cartId}`, requestOptions)
                .subscribe((data) => {
                this.outOfStock.next(false);
                for (const item of data.items) {
                    if (!item.variant.stockCheck) {
                        this.outOfStock.next(true);
                    }
                }
                this.cardLoaded = true;
                data && data.items && data.items.length > 0
                    ? this.cartItems.next(data.items)
                    : this.cartItems.next([]);
                this.cart.next(data);
                this.disablePurchase.next(data["disablePurchase"]);
                //this.setCartCounter(data['items'].length);
                if (data.items) {
                    for (const item of data.items) {
                        this.manageItemUnits(item);
                    }
                }
            });
        }
    }
    getCartDisable() {
        let disablePurchase;
        this.httpClient
            .get(`${environment.apiUrl}${environment.apiVersion}/orders/${this.cartId}`)
            .subscribe((data) => {
            disablePurchase = data["disablePurchase"];
        });
        if (disablePurchase === true) {
            return true;
        }
        else {
            return false;
        }
    }
    manageItemUnits(item) {
        // get unit adjustments
        this.orderPromoAmonut = 0;
        this.taxAmount = 0;
        item.units.forEach((unit) => {
            item["orderPromoAmonut"] = 0;
            item["taxAmount"] = 0;
            unit.adjustments.forEach((unitAdj) => {
                switch (unitAdj.type) {
                    case "order_promotion":
                        item["orderPromoAmonut"] += unitAdj.amount;
                        break;
                    case "tax":
                        item["taxAmount"] += unitAdj.amount;
                        break;
                    default:
                        break;
                }
            });
        });
    }
    //
    checkExist(item) {
        const cartItems = this.cart.getValue().items;
        for (let i = 0; i < cartItems.length; i++) {
            const itemInCart = cartItems[i];
            if (itemInCart.variant.code === item.variantCode) {
                return true;
            }
        }
        return false;
    }
    validateGeofence(area) {
        return this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/geolocation/validate`, area);
    }
}
CartService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CartService, deps: [{ token: i1.HttpClient }, { token: i3$1.ToastrService }, { token: LanguageService }, { token: i2.Router }, { token: TranslatePipe }, { token: FacebookPixelService }, { token: GoogleTagManagerService }, { token: ConfService }, { token: GoogleAnalyticsService }, { token: TiktokPixelService }], target: i0.ɵɵFactoryTarget.Injectable });
CartService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CartService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CartService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i3$1.ToastrService }, { type: LanguageService }, { type: i2.Router }, { type: TranslatePipe }, { type: FacebookPixelService }, { type: GoogleTagManagerService }, { type: ConfService }, { type: GoogleAnalyticsService }, { type: TiktokPixelService }]; } });
class AddToCart {
}

class CompareService {
    constructor(http, collectionService, toastr, languageService, router) {
        this.http = http;
        this.collectionService = collectionService;
        this.toastr = toastr;
        this.languageService = languageService;
        this.router = router;
        this.compareList = new BehaviorSubject([]);
        this.compareCounter = new BehaviorSubject(0);
        this.language = {};
        languageService.getLanguage().subscribe(language => this.language = language);
        const compareList = JSON.parse(localStorage.getItem('compare'));
        if (compareList) {
            this.compareList.next(compareList);
            this.compareCounter.next(compareList.length);
        }
    }
    getCompareCounter() {
        return this.compareCounter.asObservable();
    }
    getCompareList() {
        return this.compareList.pipe(switchMap(codes => {
            if (codes.length === 0) {
                return of([]);
            }
            return this.http.post(`${environment.apiUrl}${environment.apiVersion}/WEB/products/filter?_locale=${localStorage.getItem('language')}&type=compare`, {
                codes: codes
            }).pipe(map(data => {
                for (let i = 0; i < data['products'].length; i++) {
                    data['products'][i] = this.collectionService.filterOptions(data['products'][i]);
                }
                return data;
            }));
        }));
    }
    inCompare(code) {
        return this.compareList.pipe(map(list => {
            return list !== null && list.indexOf(code) !== -1;
        }));
    }
    inCompareSync(code) {
        const compareList = this.compareList.getValue();
        return compareList !== null && compareList.indexOf(code) !== -1;
    }
    toggleCompare(code) {
        const compareList = this.compareList.getValue();
        let compare;
        if (!this.inCompareSync(code)) {
            compareList.push(code);
            compare = true;
        }
        else {
            compareList.splice(compareList.findIndex(p => p === code), 1);
            compare = false;
        }
        this.compareList.next(compareList);
        this.compareCounter.next(compareList.length);
        localStorage.setItem('compare', JSON.stringify(compareList));
        if (compare) {
            this.toastr.success(`${this.language['successfullyAddedToCompare']}<br>${this.language['clickToGoToCompare']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true }).onTap.subscribe(() => {
                this.router.navigate([this.language['LANGUAGE_CODE'], 'compare']);
            });
        }
        else {
            this.toastr.success(`${this.language['successfullyRemovedFromCompare']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
        }
        return compare;
    }
    clearCompare() {
        this.compareList.next([]);
        this.compareCounter.next(0);
        localStorage.setItem('compare', JSON.stringify([]));
        this.toastr.success(`${this.language['successfullyClearedCompareList']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
    }
}
CompareService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompareService, deps: [{ token: i1.HttpClient }, { token: CollectionService }, { token: i3$1.ToastrService }, { token: LanguageService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
CompareService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompareService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompareService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: CollectionService }, { type: i3$1.ToastrService }, { type: LanguageService }, { type: i2.Router }]; } });

class ContactUsService {
    constructor(http) {
        this.http = http;
        this.contactUs = new BehaviorSubject(null);
        this.loading = false;
    }
    sendContactUs(data) {
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/contactusformsubmit?_channel_code=WEB`, data);
    }
    getContactDetails() {
        if (!this.contactUs.getValue() && !this.loading) {
            this.getContactDetailsFromApi();
        }
        return this.contactUs.pipe(filter(data => !!data));
    }
    getContactDetailsFromApi() {
        this.loading = true;
        const headerDict = {
            CustomerId: localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : ""
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        this.http.get(`${environment.apiUrl}${environment.apiVersion}/getcontactinfo`, requestOptions).subscribe(data => {
            this.loading = false;
            this.contactUs.next(data);
        });
    }
    getContactBranches() {
        const headerDict = {
            CustomerId: localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : ""
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/getcontactinfo`, requestOptions);
    }
    getContactDetailsPostion(pos) {
        let obj = {
            "latitude": pos['lat'],
            "longitude": pos['lng'],
        };
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/getBranchBasedOnLocation`, obj);
        //return this.http.get<ContactUs>(`${environment.apiUrl}${environment.apiVersion}/getcontactinfo`);
    }
}
ContactUsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ContactUsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
ContactUsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ContactUsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ContactUsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class LoaderService {
    constructor() {
        this.requests = new BehaviorSubject(0);
    }
    requestBegin() {
        this.requests.next(this.requests.getValue() + 1);
    }
    requestEnded() {
        this.requests.next(this.requests.getValue() - 1);
        if (this.requests.getValue() <= 0) {
            const loading = document.getElementById('loading');
            if (loading) {
                loading.remove();
            }
        }
    }
    loading() {
        return this.requests.pipe(map(requests => requests > 0), debounceTime(100), distinctUntilChanged(), take(2));
    }
}
LoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class LoginService {
    constructor(httpClient, authService, router, languageService, wishListService, toastr) {
        this.httpClient = httpClient;
        this.authService = authService;
        this.router = router;
        this.languageService = languageService;
        this.wishListService = wishListService;
        this.toastr = toastr;
        this.logged = new BehaviorSubject(false);
        this.displayPopUp = new BehaviorSubject(false);
        this.language = {};
        languageService.getLanguage().subscribe(language => this.language = language);
        if (localStorage.getItem('user_id') || sessionStorage.getItem('user_id')) {
            this.logged.next(true);
        }
        else {
            this.logged.next(false);
        }
    }
    openLoginPopUp() {
        this.displayPopUp.next(true);
    }
    closeLoginPopUp() {
        this.displayPopUp.next(false);
    }
    isLoggedIn() {
        if (localStorage.getItem('user_id') || sessionStorage.getItem('user_id')) {
            this.logged.next(true);
            return true;
        }
        this.logged.next(false);
        return false;
    }
    signUp(newCustomer) {
        return this.httpClient.post(`${environment.apiUrl}v4/customers/`, newCustomer).pipe(tap(user => {
            console.log(user);
            localStorage.setItem('user_id', user.user.id.toString());
            localStorage.setItem('customer_id', user.id.toString());
            localStorage.setItem('user_firstName', user.firstName);
            localStorage.setItem('user_lastName', user.lastName);
            localStorage.setItem('user_phone', user.phoneNumber);
            localStorage.setItem('user_email', user.email);
            localStorage.setItem('jwt_token', user.token);
            this.loggedIn();
        }));
    }
    getphoneNumberOTP(phoneNumber, id, email) {
        // window['ip_address'] = "192.168.1.4"
        let request = 'validate_phone_number?phoneNumber=' + phoneNumber + '&deviceKey=' + window['ip_address'];
        if (id && id !== null) {
            request += '&id=' + id;
        }
        if (email && email !== null) {
            request += '&email=' + email;
        }
        return this.httpClient.get(`${environment.apiUrl}v3/${request}`);
    }
    sendPhoneNumberOTP(phoneNumber, code, id) {
        const data = {
            phoneNumber: phoneNumber,
            code: code
        };
        if (id && id !== null) {
            data['id'] = id;
        }
        return this.httpClient.post(`${environment.apiUrl}v3/validate_phone_number`, data);
    }
    getIP() {
        return this.httpClient.get('https://api.ipify.org?format=string');
    }
    login(email, password) {
        const data = {
            username: email,
            password: password
        };
        return this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/shop-users/login`, data);
    }
    loggedInFromPopUp(returnUrl) {
        this.logged.next(true);
        if (+localStorage.getItem('cartId')) {
            this.httpClient
                .post(`${environment.apiUrl}${environment.apiVersion}/assign-cart-to-customer-email`, {
                userEmail: localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email'),
                cartId: +localStorage.getItem('cartId')
            });
        }
        // add cached wish list into database;
        this.saveWishList();
        returnUrl ? this.router.navigateByUrl(returnUrl) : this.closeLoginPopUp();
    }
    loggedIn(returnUrl) {
        this.logged.next(true);
        if (+localStorage.getItem('cartId')) {
            this.httpClient
                .post(`${environment.apiUrl}${environment.apiVersion}/assign-cart-to-customer-email`, {
                userEmail: localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email'),
                cartId: +localStorage.getItem('cartId')
            });
        }
        // add cached wish list into database;
        this.saveWishList();
        returnUrl ? this.router.navigateByUrl(returnUrl) : this.router.navigate(['/', this.languageService.lastLocale, 'profile', 'dashboard']);
    }
    logOut() {
        localStorage.getItem('user_id') ? localStorage.removeItem('user_id') : sessionStorage.removeItem('user_id');
        localStorage.getItem('user_firstName') ? localStorage.removeItem('user_firstName') : sessionStorage.removeItem('user_firstName');
        localStorage.getItem('user_lastName') ? localStorage.removeItem('user_lastName') : sessionStorage.removeItem('user_lastName');
        localStorage.getItem('user_phone') ? localStorage.removeItem('user_phone') : sessionStorage.removeItem('user_phone');
        localStorage.getItem('user_email') ? localStorage.removeItem('user_email') : sessionStorage.removeItem('user_email');
        localStorage.getItem('customer_id') ? localStorage.removeItem('customer_id') : sessionStorage.removeItem('customer_id');
        localStorage.getItem('jwt_token') ? localStorage.removeItem('jwt_token') : sessionStorage.removeItem('jwt_token');
        localStorage.getItem('wish-list') ? localStorage.removeItem('wish-list') : sessionStorage.removeItem('wish-list');
        this.authService.signOut();
        this.wishListService.initWishList();
        this.logged.next(false);
        this.router.navigate(['/', this.languageService.lastLocale, 'accounts', 'login'], { replaceUrl: true });
    }
    socialLogin(socialUser) {
        const socialUserData = {
            firstName: socialUser.firstName,
            lastName: socialUser.lastName,
            email: socialUser.email,
            loginType: socialUser.provider,
            identifier: socialUser.id,
            accessToken: socialUser.authToken
        };
        this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/social_login`, socialUserData).subscribe((data) => {
            localStorage.setItem('user_id', data.shopUserId.toString());
            localStorage.setItem('customer_id', data.customerId.toString());
            localStorage.setItem('user_firstName', socialUserData.firstName);
            localStorage.setItem('user_lastName', socialUserData.lastName);
            localStorage.setItem('user_email', socialUserData.email);
            localStorage.setItem('jwt_token', data.token);
            this.loggedIn();
            this.router.navigate(['/profile/dashboard']);
        });
    }
    requestResetPassword(email) {
        return this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/shop-users/reset-password`, { email: email });
    }
    verifyToken(email, token) {
        return this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/shop-users/verify-password-reset-token`, {
            email: email,
            token: token,
        });
    }
    resetPassword(email, token, password, confirm_password) {
        return this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/shop-users/create-new-password`, {
            email: email,
            token: token,
            password: password,
            confirm_password: confirm_password,
        });
    }
    saveWishList() {
        const wishList = JSON.parse(localStorage.getItem('wish-list') ? localStorage.getItem('wish-list') : sessionStorage.getItem('wish-list')); // [code , code , ....]
        const userId = localStorage.getItem('user_id') ? +localStorage.getItem('user_id') : +sessionStorage.getItem('user_id');
        if (userId && wishList) {
            const body = { userId: userId, products: wishList };
            this.httpClient.post(`${environment.apiUrl}${environment.apiVersion}/wishlists/bulk-insert`, body).subscribe(() => {
                this.toastr.success(`${this.language['wishListInitiatedSuccessfully']}<br>${this.language['clickToGoToWishlist']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true }).onTap.subscribe(() => {
                    this.router.navigate([this.language['LANGUAGE_CODE'], 'wish-list']);
                });
            }, () => {
                this.toastr.error(`${this.language['wishListInitiatedFaild']}<br>${this.language['clickToGoToWishlist']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true }).onTap.subscribe(() => {
                    this.router.navigate(['wish-list']);
                });
            });
        }
        this.wishListService.initWishList();
    }
}
LoginService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginService, deps: [{ token: i1.HttpClient }, { token: i2$1.SocialAuthService }, { token: i2.Router }, { token: LanguageService }, { token: WishListService }, { token: i3$1.ToastrService }], target: i0.ɵɵFactoryTarget.Injectable });
LoginService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2$1.SocialAuthService }, { type: i2.Router }, { type: LanguageService }, { type: WishListService }, { type: i3$1.ToastrService }]; } });

class StaticPagesService {
    constructor(http) {
        this.http = http;
        this.allPagesLoading = false;
        this.allPagesLoaded = false;
        this.allPages = new BehaviorSubject([]);
    }
    getAllPages(type) {
        if (!this.allPagesLoaded && !this.allPagesLoading) {
            this.getAllPagesFromApi();
        }
        return this.allPages.pipe(map(data => {
            return data.filter(page => page.type.indexOf(type) !== -1);
        }));
    }
    getPage(code) {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/pages/${code}`);
    }
    getAllPagesFromApi() {
        this.allPagesLoading = true;
        this.http.get(`${environment.apiUrl}${environment.apiVersion}/pages`).pipe(map(data => data['items'])).subscribe((data) => {
            this.allPages.next(data);
            this.allPagesLoading = false;
            this.allPagesLoaded = true;
        });
    }
}
StaticPagesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StaticPagesService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
StaticPagesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StaticPagesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StaticPagesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class AddressingService {
    constructor(_httpClient, toastr) {
        this._httpClient = _httpClient;
        this.toastr = toastr;
        this.addresses = new BehaviorSubject(null);
        this.countries = new BehaviorSubject(null);
        this.getAddressesFromApi();
    }
    static getUserId() {
        return localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id');
    }
    getAddresses() {
        return this.addresses.pipe(filter(data => {
            return !!data;
        }));
    }
    editAddress(id, updatedAddress) {
        return this._httpClient.post(`${environment.apiUrl}v5/addressingInfoByUserID/${AddressingService.getUserId()}/update/${id}`, updatedAddress).pipe(map((res) => {
            const addresses = this.addresses.getValue();
            const key = Object.keys(addresses).find(i => addresses[i].ID === id);
            const newAddress = addresses[key];
            const keys = Object.keys(updatedAddress);
            for (const i of keys) {
                newAddress[i.charAt(0).toUpperCase() + i.slice(1)] = updatedAddress[i];
            }
            newAddress['FullName'] = updatedAddress['firstName'] + ' ' + updatedAddress['lastName'];
            addresses[key] = newAddress;
            this.addresses.next(addresses);
            return res;
        }));
    }
    deleteAddress(id) {
        this._httpClient.delete(`${environment.apiUrl}${environment.apiVersion}/addressingInfoByUserID/${AddressingService.getUserId()}/delete/${id}`).subscribe((res) => {
            if (res.status === 'success') {
                const addresses = this.addresses.getValue();
                const key = +Object.keys(addresses).find(i => {
                    return addresses[i].ID === id;
                });
                addresses.splice(key, 1);
                this.addresses.next(addresses);
                this.toastr.success(res.response);
            }
            else {
                this.toastr.error(res.response);
            }
        });
    }
    addAddress(newAddress) {
        return this._httpClient.post(`${environment.apiUrl}v5/addressingInfoByUserID/${AddressingService.getUserId()}/add`, JSON.stringify(newAddress))
            .pipe(map((res) => {
            this.getAddressesFromApi();
            const addresses = this.addresses.getValue();
            addresses.push(newAddress);
            this.addresses.next(addresses);
            return res;
        }));
    }
    getCountries() {
        if (!this.countries.getValue()) {
            this.getCountriesFromApi();
        }
        return this.countries.pipe(filter(countries => {
            return !!countries;
        }));
    }
    getCountriesFromApi() {
        this._httpClient.get(`${environment.apiUrl}v5/shop/countries`).subscribe(data => {
            this.countries.next(data.response);
        });
    }
    getAddressesFromApi() {
        const userId = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id');
        if (!userId || userId == null) {
            return;
        }
        this._httpClient.get(`${environment.apiUrl}v5/addressingInfoByUserID/${userId}`).subscribe((data) => {
            if (data.status === 'success') {
                this.addresses.next(data.response);
            }
            else {
                this.addresses.next([]);
            }
        });
    }
    getCitiesFromApi(countryId) {
        return this._httpClient.get(`${environment.apiUrl}v5/shop/countries/${countryId}/cities`);
    }
    getAreasFromApi(cityId) {
        return this._httpClient.get(`${environment.apiUrl}v5/shop/cities/${cityId}/areas`);
    }
}
AddressingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AddressingService, deps: [{ token: i1.HttpClient }, { token: i3$1.ToastrService }], target: i0.ɵɵFactoryTarget.Injectable });
AddressingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AddressingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AddressingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i3$1.ToastrService }]; } });

class ChangePasswordService {
    constructor(http) {
        this.http = http;
        this.user_id = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id');
        this.changePasswordApi = `${environment.apiUrl}${environment.apiVersion}/changePasswordByUserID/${this.user_id}`;
    }
    changePassword(body) {
        return this.http.post(this.changePasswordApi, body);
    }
}
ChangePasswordService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ChangePasswordService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
ChangePasswordService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ChangePasswordService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ChangePasswordService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class OrderHistoryService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
    }
    getOrders(page) {
        const customerId = localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : sessionStorage.getItem('customer_id');
        return this._httpClient.get(`${environment.apiUrl}${environment.apiVersion}/shop/customers/${customerId}/orders/?page=${page}&_locale=${localStorage.getItem('language') || sessionStorage.getItem('language')}`);
    }
    getOrder(orderId) {
        return this._httpClient.get(`${environment.apiUrl}${environment.apiVersion}/orders/${orderId}`);
    }
    onCancelRequests(body, orderId) {
        return this._httpClient.put(`${environment.apiUrl}${environment.apiVersion}/orders/${orderId}/cancel`, body);
    }
}
OrderHistoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderHistoryService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
OrderHistoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderHistoryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderHistoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class PersonalInfoService {
    constructor(http) {
        this.http = http;
        this.user_id = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id');
    }
    getAllUsers() {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/customers`);
    }
    getUser() {
        const customerId = localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : sessionStorage.getItem('customer_id');
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/customers/${customerId}`);
    }
    updateUserInfo(body) {
        const customerId = localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : sessionStorage.getItem('customer_id');
        return this.http.put(`${environment.apiUrl}${environment.apiVersion}/customers/${customerId}`, body);
    }
    subscribeToNewsLetter(email) {
        return this.http
            .post(`${environment.apiUrl}${environment.apiVersion}/newsletter_subscribe_api`, { email: email });
    }
    getNewRecaptcha() {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/get_recaptcha`);
    }
    subscribeToNewsLetterRecaptcha(email, id, code) {
        return this.http
            .post(`${environment.apiUrl}${environment.apiVersion}/newsletter_subscribe_api`, { email: email, code: code, id: id });
    }
    verifyMail(email) {
        const body = { email: email };
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/shop-users/verify-account`, body);
    }
    verifyVerificationToken(email, token) {
        const body = { email: email, token: token };
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/shop-users/verify-verification-token`, body);
    }
}
PersonalInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PersonalInfoService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
PersonalInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PersonalInfoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PersonalInfoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class ChangeVisibilityDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.isVisible = false;
    }
    open() {
        const prevElement = this.el.nativeElement.previousElementSibling;
        this.isVisible = !this.isVisible;
        if (this.isVisible === true) {
            this.renderer.setAttribute(prevElement, 'type', 'text');
        }
        else {
            this.renderer.setAttribute(prevElement, 'type', 'password');
        }
    }
}
ChangeVisibilityDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ChangeVisibilityDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
ChangeVisibilityDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: ChangeVisibilityDirective, selector: "[appChangeVisibility]", host: { listeners: { "click": "open()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ChangeVisibilityDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appChangeVisibility]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { open: [{
                type: HostListener,
                args: ['click']
            }] } });

class Translatable {
}

class Association extends Translatable {
}
class Product extends Translatable {
}
class Product2 {
}
class Variant2 {
}
class Attribute$1 extends Translatable {
}
class CombinationPrice {
}
class Option$1 extends Translatable {
}
class Variant {
}
class AttributeValue extends Translatable {
}
class OptionValue$1 extends Translatable {
}
class VariantOptionValue extends Translatable {
}
class Value extends Translatable {
}
class Price {
}
class Image$1 {
}

class ImageDirective {
    constructor(el) {
        this.el = el;
        this.hover = false;
    }
    onMouseEnter() {
        if (this.hover) {
            this.src(ProductService.getImage(this.product, 'hover'));
        }
    }
    onMouseLeave() {
        this.src(ProductService.getImage(this.product));
    }
    ngOnInit() {
        this.el.nativeElement.classList.add('responsive-image-container');
        this.onMouseLeave();
    }
    src(path) {
        const elem = this.el.nativeElement;
        if (elem.nodeName === 'IMG') {
            elem.setAttribute('src', path);
        }
        else {
            elem.style.backgroundImage = `url("${path}")`;
        }
    }
}
ImageDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ImageDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ImageDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: ImageDirective, selector: "[appImage]", inputs: { product: "product", hover: "hover" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ImageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appImage]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { product: [{
                type: Input
            }], hover: [{
                type: Input
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class FixedWithScrollDirective {
    // handle resize event
    constructor(render, elemRef) {
        this.render = render;
        this.elemRef = elemRef;
        this.container = this.render.parentNode(this.elemRef.nativeElement);
        this.actual = this.render.parentNode(this.container);
        this.host = this.render.selectRootElement(this.elemRef.nativeElement);
        // function for handling Fixed side
        // handle scroll event
        this.isFixed = false;
    }
    // function for handling Fixed side
    handelFixedSide() {
        const pxsTop = (this.actual.offsetHeight - (this.host.offsetHeight + 75)) + 'px';
        if (window.pageYOffset > 100 && window.pageYOffset < (this.actual.offsetHeight - (this.host.offsetHeight - 200)) && this.imageNums > 1 && window.innerWidth > 991) {
            this.isFixed = true;
            this.render.removeStyle(this.host, 'margin-top');
        }
        else {
            this.isFixed = false;
            if (window.pageYOffset <= 100) {
                this.render.removeStyle(this.host, 'margin-top');
            }
            else {
                if (this.imageNums > 1 && window.innerWidth > 991) {
                    this.render.setStyle(this.host, 'margin-top', pxsTop);
                }
            }
        }
    }
    OnScroll() {
        this.handelFixedSide();
    }
    // handle scroll event
    // handle resize event
    onResize() {
        if (window.innerWidth > 991) {
            this.handelFixedSide();
        }
        else {
            this.handelFixedSide();
        }
    }
    ngAfterViewInit() {
        this.imageNums = this.actual.children[0].children[0].children[0].children[0].childElementCount;
    }
}
FixedWithScrollDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FixedWithScrollDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FixedWithScrollDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: FixedWithScrollDirective, selector: "[appFixedWithScroll]", host: { listeners: { "window:scroll": "OnScroll()", "window:resize": "onResize()" }, properties: { "class.fixed": "this.isFixed" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FixedWithScrollDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appFixedWithScroll]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { isFixed: [{
                type: HostBinding,
                args: ['class.fixed']
            }], OnScroll: [{
                type: HostListener,
                args: ['window:scroll', []]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', []]
            }] } });

class TranslationPipe {
    constructor() { }
    transform(translation, attributeName) {
        if (!translation || !translation.translation) {
            return '!TR';
        }
        return translation.translation[attributeName];
    }
}
TranslationPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TranslationPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TranslationPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TranslationPipe, name: "translation" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TranslationPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'translation'
                }]
        }], ctorParameters: function () { return []; } });

class AccountContainerBaseComponent {
}
AccountContainerBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AccountContainerBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AccountContainerBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: AccountContainerBaseComponent, selector: "app-base-account-container", ngImport: i0, template: "<router-outlet></router-outlet>\r\n", directives: [{ type: i2.RouterOutlet, selector: "router-outlet", outputs: ["activate", "deactivate"], exportAs: ["outlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AccountContainerBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-account-container',
                    templateUrl: './account-container.base-component.html'
                }]
        }] });

class QuickViewService {
    constructor(googleAnalyticsService, fbService, googleTagManagerService, tiktok) {
        this.googleAnalyticsService = googleAnalyticsService;
        this.fbService = fbService;
        this.googleTagManagerService = googleTagManagerService;
        this.tiktok = tiktok;
        this.quickViewVisibleSubject = new BehaviorSubject(false);
        this.quickViewVisible$ = this.quickViewVisibleSubject.asObservable();
        this.product = new Subject();
        this.priceSorted = 0;
        this.orininalPriceSorted = 0;
    }
    openQuickViewVisibility() {
        this.quickViewVisibleSubject.next(true);
        console.log("I turned it to true");
    }
    closeQuickViewVisibility() {
        this.quickViewVisibleSubject.next(false);
        console.log("I turned it to false");
    }
    open(product) {
        var _a;
        this.product.next(product);
        if (product.productType) {
            this.googleAnalyticsService.viewItem(product.id, product.name, product.variant.price, product.main_taxon, 1);
            this.googleTagManagerService.viewItem(product.id, product.name, product.variant.price, product.main_taxon, 1);
            this.tiktok.viewItem(product.id, product.name, product.variant.price, product.main_taxon, 1);
        }
        else {
            this.googleAnalyticsService.viewItem(product.id, product.name, product.variants[0].prices[0].price, product.main_taxon, 1);
            this.googleTagManagerService.viewItem(product.id, product.name, product.variants[0].prices[0].price, product.main_taxon, 1);
        }
        this.fbService.ViewContent(product.id, product.main_taxon.name, product.name, product.main_taxon.name, (_a = product === null || product === void 0 ? void 0 : product.variant) === null || _a === void 0 ? void 0 : _a.price);
    }
    close() {
        this.product.next(null);
    }
    get() {
        return this.product.asObservable();
    }
    sorteVariants(product) {
        let sortedVariant;
        if (product.variants.every((v) => v.prices[0].price && v.tracked && v.stock <= 0)) {
            product.variants.forEach((v) => {
                // get current variant price
                // compare price
                sortedVariant = this.getCheapestVariant(v, v.prices[0].price, v.prices[0].original_price);
            });
        }
        else {
            product.variants.forEach((v) => {
                if (v.prices[0].price && (!v.tracked || v.tracked && v.stock > 0)) {
                    // get current variant price
                    // compare price
                    sortedVariant = this.getCheapestVariant(v, v.prices[0].price, v.prices[0].original_price);
                }
            });
        }
        this.variantSorted = sortedVariant.mVariant;
        return this.variantSorted;
    }
    getCheapestVariant(mainVariant, cVariantPrice, cVariantOriginal) {
        const MainVariant = mainVariant;
        const currentVariantPrice = cVariantPrice;
        const currentVariantOriginal = cVariantOriginal;
        if (currentVariantPrice < this.priceSorted || this.priceSorted === 0) {
            this.priceSorted = currentVariantPrice;
            this.orininalPriceSorted = currentVariantOriginal;
            this.Mvaraint = MainVariant;
        }
        return { pSorted: this.priceSorted, opSorted: this.orininalPriceSorted, mVariant: this.Mvaraint };
    }
}
QuickViewService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: QuickViewService, deps: [{ token: GoogleAnalyticsService }, { token: FacebookPixelService }, { token: GoogleTagManagerService }, { token: TiktokPixelService }], target: i0.ɵɵFactoryTarget.Injectable });
QuickViewService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: QuickViewService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: QuickViewService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: GoogleAnalyticsService }, { type: FacebookPixelService }, { type: GoogleTagManagerService }, { type: TiktokPixelService }]; } });

var __awaiter$2 = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class ShopService {
    constructor(_http, _router, languageService, confService, taxonService, fbService) {
        this._http = _http;
        this._router = _router;
        this.languageService = languageService;
        this.confService = confService;
        this.taxonService = taxonService;
        this.fbService = fbService;
        this.pages_count = new BehaviorSubject(0);
        this.productsCount = new BehaviorSubject(0);
        this.filter = new BehaviorSubject(null);
        this.defaultLimit = 12;
        this.params$ = new BehaviorSubject([]);
        this.homePageItems = new BehaviorSubject(null);
        this.loading = false;
        this.gridClassSubject = new BehaviorSubject(true);
        this.hasViewMoreBtn = new BehaviorSubject(false);
        this.array = [
            'options',
            'attributes',
        ];
        this.primitive = [
            'q',
            'page',
            'price',
            'order',
            'rating',
            'sort',
            'limit',
            'featured',
            'bestseller',
            'new',
            'return_product',
            'return_filter',
            'codes',
            'discounted',
        ];
        taxonService.getTaxons().subscribe(taxons => this.taxons = taxons);
        this.confService.storeId.subscribe(response => {
            this.id = response;
        });
    }
    static implode(options) {
        const array = [];
        for (const option of options) {
            const key = Object.keys(option)[0];
            array.push(`${key}:${option[key]}`);
        }
        return array.join(',');
    }
    static explode(options) {
        const array = options.split(',');
        const optionsArray = [];
        for (const element of array) {
            const split = element.split(':');
            const newOption = {};
            newOption[split[0]] = split[1];
            optionsArray.push(newOption);
        }
        return optionsArray;
    }
    postData(url = '', data = {}) {
        return __awaiter$2(this, void 0, void 0, function* () {
            const currentCurrency = localStorage.getItem('currentCurrency');
            const countryCode = localStorage.getItem('countryCode') || 'EG';
            const branchId = localStorage.getItem('branchId') || '';
            const headerDict = {
                'currency': currentCurrency,
                'countryCode': countryCode,
                'Content-Type': 'application/json',
                'branchId': branchId
            };
            const requestOptions = {
                headers: new HttpHeaders(headerDict),
            };
            return this._http.post(url, data, requestOptions);
        });
    }
    getCollection(params, listenToChanges = true) {
        const body = {};
        const keys = Object.keys(params);
        if (keys.indexOf('limit') === -1) {
            body['limit'] = this.defaultLimit;
        }
        for (const key of keys) {
            if (this.primitive.indexOf(key) !== -1) {
                body[key] = params[key];
            }
            else if (key === 'taxons') {
                if (params[key][0] !== undefined && params[key][0] !== 'undefined') {
                    body[key] = params[key];
                }
                if (typeof params['taxons'] === 'string') {
                    body[key] = params[key].split(',');
                }
            }
            else if (this.array.indexOf(key) !== -1) {
                body[key] = ShopService.explode(params[key]);
            }
            else {
                return;
            }
        }
        if (!body['sort'] && this.id == 9273) {
            body['sort'] = 'category';
        }
        const currentCurrency = localStorage.getItem('currentCurrency');
        const countryCode = localStorage.getItem('countryCode') ? localStorage.getItem('countryCode') : 'EG';
        const branchId = localStorage.getItem('branchId') ? localStorage.getItem('branchId') : ' ';
        const headerDict = {
            'currency': currentCurrency,
            'countryCode': countryCode,
            'branchId': branchId
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        const products$ = this._http.post(`${environment.apiUrl}v4/WEB/products/filter?_locale=${localStorage.getItem('language')}`, body, requestOptions);
        products$.subscribe(data => {
            this.pages_count.next(data['pages_count']);
            this.productsCount.next(data['products_count']);
            if (listenToChanges) {
                this.filter.next(data['filter']);
            }
        });
        return products$;
    }
    getCollectionForAutocomplete(params) {
        return this._http.post(`${environment.apiUrl}${environment.apiVersion}/WEB/products/auto_complete?_locale=${localStorage.getItem('language')}`, params).pipe(map(data => {
            return data['products'];
        }));
    }
    // add/remove taxon to/from the url
    changeTaxon(taxon, addRemove) {
        let newParams;
        newParams = Object.assign({}, this.params);
        let taxons = [];
        if (this.params['taxons'] !== undefined) {
            taxons = this.params['taxons'].split(',');
        }
        if (addRemove) {
            this.clearTaxonParents(taxon, taxons);
            taxons.push(taxon);
        }
        else {
            const key = Object.keys(taxons).find(i => {
                return taxons[i] === taxon;
            });
            taxons.splice(+key, 1);
        }
        if (taxons.length > 0) {
            newParams['taxons'] = taxons.join(',');
        }
        else {
            delete newParams['taxons'];
        }
        newParams['page'] = 1;
        newParams['return_product'] = 1;
        newParams['return_filter'] = 1;
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    changeFilter(type, option, value, addRemove) {
        const newParams = Object.assign({}, this.params);
        let options = [];
        if (this.params[type] !== undefined) {
            options = ShopService.explode(this.params[type]);
        }
        if (addRemove) {
            const newOption = {};
            newOption[option] = value;
            options.push(newOption);
        }
        else {
            const key = Object.keys(options).find(i => {
                return options[i][option] === value;
            });
            options.splice(+key, 1);
        }
        if (options.length > 0) {
            newParams[type] = ShopService.implode(options);
        }
        else {
            delete newParams[type];
        }
        newParams['page'] = 1;
        newParams['return_product'] = 1;
        newParams['return_filter'] = 1;
        console.log(newParams);
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    setParams(params) {
        this.params = params;
        this.params$.next(params);
    }
    changeX(x, value) {
        let newParams;
        newParams = Object.assign({}, this.params);
        if (value === false) {
            delete newParams[x];
        }
        else {
            newParams[x] = value;
        }
        if (x !== 'page') {
            newParams['page'] = 1;
        }
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    changeSort(sort, order) {
        let newParams;
        newParams = Object.assign({}, this.params);
        if (sort === false) {
            delete newParams['sort'];
        }
        else {
            newParams['sort'] = sort;
        }
        if (order === false) {
            delete newParams['order'];
        }
        else {
            newParams['order'] = order;
        }
        newParams['page'] = 1;
        this._router.navigate([this.languageService.lastLocale, 'collection'], { queryParams: newParams });
    }
    filterOptions(product) {
        const options = [];
        if (product.variants.length === 0) {
            return product;
        }
        else if (product.variants[0].optionValues.length === 0) {
            return product;
        }
        else {
            for (const option of product.variants[0].optionValues) {
                options.push({
                    name: option.name,
                    code: option.code,
                    translations: option.translations,
                    option_values: [],
                    view_as_thumbnail: option.view_as_thumbnail
                });
            }
        }
        for (const variant of product.variants) {
            for (const option of options) {
                const optionValue = variant.optionValues.find(_optionValue => _optionValue.code === option.code);
                if (!optionValue) {
                    continue;
                }
                if (!option.option_values.find(_optionValue => _optionValue.code === optionValue.value.code)) {
                    option.option_values.push(optionValue.value);
                }
            }
        }
        product.options = options;
        return product;
    }
    is_parent(parentCode, childCode) {
        const parent = this.getTaxon(parentCode, this.taxons);
        if (!parent['children']) {
            return false;
        }
        for (const child of parent['children']) {
            if (child.code === childCode) {
                return true;
            }
            if (this.is_parent(child.code, childCode)) {
                return true;
            }
        }
        return false;
    }
    getTaxon(code, taxons) {
        const taxon = this.getTaxonFrom(code, taxons);
        if (!taxon) {
            return null;
        }
        return taxon;
    }
    getTaxonFrom(code, taxons) {
        if (!taxons) {
            return null;
        }
        for (const taxon of taxons) {
            if (taxon.code === code) {
                return taxon;
            }
            if (taxon.children === undefined) {
                continue;
            }
            const taxon_ = this.getTaxonFrom(code, taxon.children);
            if (taxon_) {
                return taxon_;
            }
        }
        // return null;
    }
    clearTaxonParents(value, values) {
        for (const taxon of values) {
            if (this.is_parent(taxon, value)) {
                this.remove(taxon, values);
            }
        }
    }
    remove(value, array) {
        const key = Object.keys(array).find(i => {
            return array[i] === value;
        });
        array.splice(+key, 1);
    }
}
ShopService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShopService, deps: [{ token: i1.HttpClient }, { token: i2.Router }, { token: LanguageService }, { token: ConfService }, { token: TaxonService }, { token: FacebookPixelService }], target: i0.ɵɵFactoryTarget.Injectable });
ShopService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShopService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShopService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.Router }, { type: LanguageService }, { type: ConfService }, { type: TaxonService }, { type: FacebookPixelService }]; } });

class InstagramService {
    constructor(http) {
        this.http = http;
        this.instaFeed = [];
    }
    getInstagram() {
        // return this.http.get(
        //   `https://api.instagram.com/v1/users/self/media/recent`,
        //   {
        //     params: {
        //       access_token: '4579569532.5f6c9fe.23807c75b0d945b0a864a409098dacff',
        //       count: '10'
        //     }
        //   }
        //   );
        return this.http.get(`${environment.apiUrl}v3/fetch-instagram-media`);
    }
}
InstagramService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InstagramService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
InstagramService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InstagramService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InstagramService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class BrandsService {
    constructor(http) {
        this.http = http;
    }
    getBrands() {
        return this.http
            .get(`${environment.apiUrl}${environment.apiVersion}/attributes/brand?locale=${localStorage.getItem('language')}`)
            .pipe(take(1));
    }
    getBrand(code) {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/attributes/brand?locale=${localStorage.getItem('language')}`)
            .pipe(map(res => {
            const selectedBrand = res['values'].filter(value => value.code === code);
            return selectedBrand ? selectedBrand[0] : null;
        }));
    }
}
BrandsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BrandsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
BrandsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BrandsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BrandsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class WeAcceptService {
    constructor(http) {
        this.http = http;
        this.cartId = localStorage.getItem('cartId');
    }
    /**
   * Return the we accept token for current order
   * @returns the token
   * */
    getOrderToken(paymentCode) {
        const paymentExpiration = localStorage.getItem('payment_expiration');
        if (paymentExpiration && +paymentExpiration < Date.now()) {
            return this.getRefreshToken(paymentCode);
        }
        // disable payment-token chaching
        // const paymentToken = localStorage.getItem('payment_token');
        // if (!paymentToken) {
        return this.getTokenFromApi(paymentCode);
        // }
        // return of(paymentToken);
    }
    /**
   * send the payment response to the api
   * @param params {Params} - the parameters of the response
   * */
    weAccept(params) {
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/payment`, params);
    }
    getTokenFromApi(paymentCode) {
        const payments = {
            'payments': [
                {
                    'method': paymentCode
                }
            ]
        };
        if (paymentCode.includes("we-accept")) {
            return this.http.put(`${environment.apiUrl}v4/checkouts/select-payment/${localStorage.getItem('cartId')}`, payments, { observe: 'response' })
                .pipe(tap(data => {
                localStorage.setItem('payment_token', data['body']['configurations']['paymentToken']);
                localStorage.setItem('iframe_Id', data['body']['configurations']['iframeId']);
                // localStorage.setItem('weaccept_order_id', data['weaccept_order_id']);
                localStorage.setItem('payment_expiration', (Date.now() + data['body']['configurations']['expiration'] * 1000).toString());
                this.paymentToken = data['body']['configurations']['paymentToken'];
            }), map(data => {
                return data['body']['configurations']['paymentToken'];
            }));
        }
        else {
            return this.http.put(`${environment.apiUrl}${environment.apiVersion}/checkouts/select-payment/${localStorage.getItem('cartId')}`, payments, { observe: 'response' })
                .pipe(tap(data => {
                localStorage.setItem('payment_token', data['body']['configurations']['paymentToken']);
                localStorage.setItem('iframe_Id', data['body']['configurations']['iframeId']);
                // localStorage.setItem('weaccept_order_id', data['weaccept_order_id']);
                localStorage.setItem('payment_expiration', (Date.now() + data['body']['configurations']['expiration'] * 1000).toString());
                this.paymentToken = data['body']['configurations']['paymentToken'];
            }), map(data => {
                return data['body']['configurations']['paymentToken'];
            }));
        }
    }
    getRefreshToken(paymentCode) {
        const payments = {
            'payments': [
                {
                    'method': paymentCode
                }
            ]
        };
        return this.http.put(`${environment.apiUrl}${environment.apiVersion}/checkouts/select-payment/${localStorage.getItem('cartId')}`, payments, { observe: 'response' })
            .pipe(tap(data => {
            localStorage.setItem('payment_token', data['body']['configurations']['paymentToken']);
            localStorage.setItem('payment_expiration', (Date.now() + data['body']['configurations']['expiration'] * 1000).toString());
            this.paymentToken = data['body']['configurations']['paymentToken'];
        }), map(data => {
            return data['body']['configurations']['paymentToken'];
        }));
    }
}
WeAcceptService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WeAcceptService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
WeAcceptService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WeAcceptService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WeAcceptService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class CheckoutService {
    constructor(http, router, confService, toastr, fbService, analyticService, tiktok) {
        this.http = http;
        this.router = router;
        this.confService = confService;
        this.toastr = toastr;
        this.fbService = fbService;
        this.analyticService = analyticService;
        this.tiktok = tiktok;
        this.errorMsgPayFort = new BehaviorSubject(false);
        this.errorMsgAaib = new BehaviorSubject(false);
        this.nextStep = new Subject();
        this.fullData = new Subject();
        this.hideNextButtonSubject = new Subject();
        this.checkCheckoutStateSubject = new Subject();
        this.checkoutStateSource = this.checkCheckoutStateSubject.asObservable();
        this.cartId = JSON.parse(localStorage.getItem('cartId'));
        // Order Placed Subject it will recieve the Order Id when checkout completed
        this.orderPlacedSubject = new BehaviorSubject({});
        this.checkoutData = new Subject();
        this.orderPlacedSource = this.orderPlacedSubject.asObservable();
        this.checkToAddNewAddress = new BehaviorSubject(null);
        this.isCheckToSaveAddress = this.checkToAddNewAddress.asObservable();
        // if (this.cartId) {
        // 	this.getFullyCheckoutData();
        // }
    }
    /**
     * Represent the countries that will be displayed in the checkout addressing
     * @returns the countries From Api
     */
    getCountriesFromApi() {
        return this.http.get(`${environment.apiUrl}v5/shop/countries`);
    }
    /**
     * Represent the cities that will be displayed in the checkout addressing
     * @returns the cities From Api
     */
    getCitiesFromApi(countryId) {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/shop/countries/${countryId}/cities`);
    }
    /**
     * Represent the areas that will be displayed in the checkout addressing
     * @returns the areas From Api
     */
    getAreasFromApi(cityId) {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/shop/cities/${cityId}/areas`);
    }
    /**
     * represent the countries that has cities and provinces
     */
    getCountriesCitiesProvinces() {
        return this.http.get(`${environment.apiUrl}v5/shop/countries`);
    }
    /**
     *  Represents the old address
     * @returns the old address if the type of the end user is USER
     */
    selectOldAddressing() {
        const USER_ID = localStorage.getItem('user_id') !== null
            ? localStorage.getItem('user_id')
            : sessionStorage.getItem('user_id');
        return this.http.get(`${environment.apiUrl}v5/addressingInfoByUserID/${USER_ID}`);
    }
    /**
     *  Represents the addressing info for the end user in checkout details
     * @returns return {}
     *  message: "A cart updated successfully"
     *  status: "success"
     */
    sendShippingAddressing(body) {
        return this.http.put(`${environment.apiUrl}v5/checkouts/addressing/${localStorage.getItem('cartId')}`, JSON.stringify(body), { observe: 'response' });
    }
    /**
     *  Represents the shipping methods from api that will display in the checkout shipping
     * @returns the shipping methods
     */
    getShippingMethods() {
        const currentCurrency = localStorage.getItem('currentCurrency');
        const headerDict = {
            currency: currentCurrency
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        console.log(requestOptions);
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/checkouts/select-shipping/${localStorage.getItem('cartId')}`, requestOptions);
    }
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
            this.toastr.warning(`${error.error.message}`);
        }
        else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            this.toastr.warning(`${error.message}`);
        }
        return throwError(errorMessage);
    }
    /**
     *  Represents the shipping methods from api that will display in the checkout shipping
     * @param methodCode the shipping method that will be selected from the end user
     * @returns the shipping methods
     */
    selectShippingMethod(methodCode) {
        return this.http.put(`${environment.apiUrl}${environment.apiVersion}/checkouts/select-shipping/${localStorage.getItem('cartId')}`, methodCode, { observe: 'response' });
    }
    /**
     *  Represents the payment methos that will be displayed in the payment page
     * @returns the payment methods
     */
    getPaymentsMethodsFromApi() {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/checkouts/select-payment/${localStorage.getItem('cartId')}`);
    }
    /**
     *  Represents the payment methos that will be displayed in the payment page.
     * @param paymentCode the payment code that will be selected by the end user.
     * @returns the payment methods.
     */
    selectPaymentMethod(paymentCode, paynow) {
        const payments = {
            payments: [
                {
                    method: paymentCode,
                },
            ],
        };
        if (paymentCode.includes("we-accept")) {
            return this.http.put(`${environment.apiUrl}v4/checkouts/select-payment/${localStorage.getItem('cartId')}?pay=true`, payments, { observe: 'response' }).pipe(catchError(this.handleError));
        }
        else {
            return this.http.put(`${environment.apiUrl}${environment.apiVersion}/checkouts/select-payment/${localStorage.getItem('cartId')}?pay=${paynow}`, payments, { observe: 'response' }).pipe(catchError(this.handleError));
        }
    }
    upgSuccess(data) {
        data['orderId'] = localStorage.getItem('cartId');
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/callback/upg`, data);
    }
    payFortMethod(payFortData) {
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/payment-callback`, payFortData);
    }
    /**
     *  Represents the full checkout data from Api.
     * @returns checkout data.
     */
    getFullyCheckoutData() {
        this.getFullyCheckoutDataFromApi();
        return this.fullData.pipe(filter((data) => {
            this.checkoutData.next(data);
            return Object.keys(data).length > 0;
        }));
    }
    getCheckoutData() {
        // fbq('track', 'InitiateCheckout');
        return this.fullData.pipe(filter((data) => {
            this.checkoutData.next(data);
            return Object.keys(data).length > 0;
        }));
    }
    getShippingData() {
        // fbq('track', 'InitiateCheckout');
        return this.fullData.pipe(filter((data) => {
            // this.checkoutData.next(data)
            return Object.keys(data).length > 0;
        }));
    }
    /**
     *  Represents the next step for checkout.
     * @returns the next page of checkout page.
     */
    getNextStep(active) {
        return this.nextStep.pipe(filter((nextStep) => nextStep === active));
    }
    /**
     *  Represents the nagivation to top of the checkout pages.
     * @returns the top of the page.
     */
    nagivateTop() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
    /**
     *  Represents the nagivation to top of the checkout pages.
     * @param orders this is the checkout data;
     * @param adjustments this will represent the final adjustments
     * @returns the adjustment from the checkout data.
     */
    getItemsAdjustment(orders, adjustments) {
        const orderAdjustment = orders['adjustments'];
        for (const adjustmentType of orderAdjustment) {
            adjustments.push(adjustmentType);
        }
        return new Set([...adjustments]);
    }
    /**
     *  Represents the summary of the checkout.
     * @param orders this is the checkout data;
     * @param orderSummary this will represent the final adjustments
     * @returns the summary of the checkout
     */
    getOrderSummary(orders, orderSummary) {
        const items = orders.items;
        const itemsQty = items.reduce((sum, acc) => sum + acc['quantity'], 0);
        if (orders !== undefined) {
            orderSummary.adjustmentsTotal = orders['adjustmentsTotal'];
            orderSummary.itemsTotal = orders.itemsTotal;
            orderSummary.promotions = orders.promotionTotal;
            orderSummary.currencyCode = orders.currencyCode;
            orderSummary.total = orders.total;
            orderSummary.itemsQty = itemsQty;
        }
        return orderSummary;
    }
    saveOrderInfo(order) {
        this.orderPlacedSubject.next(order);
    }
    /**
   *  Represents the checkout data from the api.
   * @returns the checkout data from the api
   */
    getFullyCheckoutDataFromApi() {
        const currentCurrency = localStorage.getItem('currentCurrency');
        const headerDict = {
            currency: currentCurrency
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        return this.http.get(`${environment.apiUrl}v5/checkouts/${localStorage.getItem('cartId')}`, requestOptions).subscribe(data => {
            var _a, _b;
            this.fullData.next(data);
            /*If you check the api response you will find that some times there is no property called 'billingAddress'
             so it will throw an error in facebook analytics
            `and it will prevent emittng the fullData observerable data. */
            this.analyticService.addPaymentInfo(data['id'], (_a = data['billingAddress']) === null || _a === void 0 ? void 0 : _a.id, data['total'], data['itemsTotal']);
            this.tiktok.addPaymentInfo(data['id'], (_b = data['billingAddress']) === null || _b === void 0 ? void 0 : _b.id, data['total'], data['itemsTotal']);
        });
    }
    getOrder(orderId) {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/orders/${orderId}`);
    }
    getStoreInfo() {
        const headerDict = {
            CustomerId: localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : "0"
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        return this.http
            .get(`${environment.apiUrl}${environment.apiVersion}/getcontactinfo`, requestOptions)
            .pipe(map((store) => store.branches[0]));
    }
    /**
     * @Todo get the avaliable time slot
     */
    getTimeSlotsFromApi() {
        return this.http.get(`${environment.apiUrl}v4/checkouts/time-slots/${localStorage.getItem('cartId')}`);
    }
    /**
     * @Todo send time slot to api
     * @param order_id
     * @param selected_date
     * @param selected_time
     * @param selectedDayName
     */
    getCart() {
        return this.http.get(`${environment.apiUrl}v5/checkouts/${localStorage.getItem('cartId')}`);
    }
    sendTimeSlotsToApi(order_id, selected_date, selected_time, selectedDayName) {
        return this.http.put(`${environment.apiUrl}${environment.apiVersion}/set_order_time_slot/${order_id}/${selected_date}/${selected_time}/${selectedDayName}`, {});
    }
    setShippingAddressData(formName, value) {
        let separateFloorApp;
        this.storeIdentitySubscription = this.confService.store$.subscribe((store) => {
            separateFloorApp = store['separateFloorApp'];
        });
        formName.controls['firstName'].setValue(value['shippingAddress']['firstName']);
        formName.controls['lastName'].setValue(value['shippingAddress']['lastName']);
        formName.controls['country'].setValue(value['shippingAddress']['countryCode']);
        formName.controls['phoneKey'].setValue(value['shippingAddress']['phoneKey']);
        const phoneNumber = this.getPhoneNumberWithoutKey(value['shippingAddress']['phoneKey'], value['shippingAddress']['phoneNumber']);
        formName.controls['phoneNumber'].setValue(phoneNumber);
        formName.controls['shipping_notes'].setValue(value['shipping_notes']);
        formName.controls['userEmail'].setValue(value['customer']['email']);
        formName.controls['city'].setValue(value['shippingAddress']['city']);
        // formName.controls['provinceCode'].setValue(value['shippingAddress']['provinceCode']);
        formName.controls['areaCode'].setValue(value['shippingAddress']['areaCode']);
        if (separateFloorApp) {
            const address = this.separateFloor(value['shippingAddress']['street']);
            formName.controls['building'].setValue(address[0]);
            formName.controls['floor'].setValue(+address[1]);
            formName.controls['apartement'].setValue(address[2]);
            formName.controls['neighbourhood'].setValue(address[3]);
            formName.controls['street'].setValue(address[4]);
        }
        else {
            formName.controls['street'].setValue(value['shippingAddress']['street']);
        }
    }
    setBillingAddressData(formName, value) {
        formName.controls['billingAddressFirstName'].setValue(value['billingAddress']['firstName']);
        formName.controls['billingAddressLastName'].setValue(value['billingAddress']['lastName']);
        formName.controls['billingAddressCountry'].setValue(value['billingAddress']['countryCode']);
        formName.controls['billingAddressStreet'].setValue(value['billingAddress']['street']);
        formName.controls['billingAddressPhoneKey'].setValue(value['billingAddress']['phoneKey']);
        const phoneNumber = this.getPhoneNumberWithoutKey(value['billingAddress']['phoneKey'], value['billingAddress']['phoneNumber']);
        formName.controls['billingAddressPhoneNumber'].setValue(phoneNumber);
        formName.controls['billingAddressCity'].setValue(value['billingAddress']['city']);
        // formName.controls['billingAdderssProvinceCode'].setValue(value['billingAddress']['provinceCode']);
        formName.controls['billingAdderssAreaCode'].setValue(value['billingAddress']['areaCode']);
    }
    kashierChecker(data) {
        const orderId = localStorage.getItem('cartId');
        return this.http.post(`${environment.apiUrl}${environment.apiVersion}/kashier-callback/${orderId}`, data);
    }
    getPhoneNumberWithoutKey(phoneKey, phoneNumber) {
        const phoneKeyExp = new RegExp(phoneKey + '(.+)');
        const number = phoneNumber.split(phoneKeyExp)[1];
        return number.indexOf('-') >= 0 ? number.split('-')[1] : number;
    }
    separateFloor(street) {
        const splitted = street.split('-');
        const filtered = splitted.filter(function (element, index, array) {
            return index % 2 !== 0;
        });
        return filtered;
    }
    downloadInvoice(url) {
        return this.http.get(url, {
            responseType: 'blob'
        });
    }
}
CheckoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutService, deps: [{ token: i1.HttpClient }, { token: i2.Router }, { token: ConfService }, { token: i3$1.ToastrService }, { token: FacebookPixelService }, { token: GoogleAnalyticsService }, { token: GoogleAnalyticsService }], target: i0.ɵɵFactoryTarget.Injectable });
CheckoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.Router }, { type: ConfService }, { type: i3$1.ToastrService }, { type: FacebookPixelService }, { type: GoogleAnalyticsService }, { type: GoogleAnalyticsService }]; } });

class CheckoutAddressingGuard {
    constructor(router) {
        this.router = router;
        this.checkoutState = false;
        this.stepZero = JSON.parse(localStorage.getItem('stepZero'));
    }
    canActivate() {
        if (this.stepZero === true) {
            return true;
        }
        else {
            this.router.navigate(['']);
            return false;
        }
    }
}
CheckoutAddressingGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutAddressingGuard, deps: [{ token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
CheckoutAddressingGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutAddressingGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutAddressingGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }]; } });

class PaymentGuardCheckout {
    constructor(checkoutService, router) {
        this.checkoutService = checkoutService;
        this.router = router;
        this.paymentStateBehavior = new BehaviorSubject$1(null);
        this.paymentState = null;
        this.paymentLocalState = '';
        this.stepTwo = JSON.parse(localStorage.getItem('stepTwo'));
        this.paymentStateBehavior.subscribe(data => {
            this.paymentState = data;
        });
    }
    canActivate() {
        if (this.paymentState === true || this.stepTwo === true) {
            return true;
        }
        else {
            this.router.navigate(['']);
            return false;
        }
    }
}
PaymentGuardCheckout.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentGuardCheckout, deps: [{ token: CheckoutService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
PaymentGuardCheckout.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentGuardCheckout });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentGuardCheckout, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CheckoutService }, { type: i2.Router }]; } });

class ShippingGuardCheckout {
    constructor(router) {
        this.router = router;
        this.st = new BehaviorSubject$1(false);
        this.checkoutState = null;
        this.shippingStatus = '';
        this.stepOne = JSON.parse(localStorage.getItem('stepOne'));
        this.st.subscribe(data => {
            this.checkoutState = data;
        });
    }
    canActivate() {
        if (this.checkoutState === true || this.stepOne === true) {
            return true;
        }
        else {
            this.router.navigate(['']);
            return false;
        }
    }
}
ShippingGuardCheckout.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShippingGuardCheckout, deps: [{ token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
ShippingGuardCheckout.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShippingGuardCheckout });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShippingGuardCheckout, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }]; } });

class CompleteGuardCheckout {
    constructor(checkoutService, router) {
        this.checkoutService = checkoutService;
        this.router = router;
        this.completeStateBehavior = new BehaviorSubject$1(null);
        this.completeState = null;
        this.completeLocalState = '';
        this.stepThree = JSON.parse(localStorage.getItem('stepThree'));
        this.completeStateBehavior.subscribe(data => {
            this.completeState = data;
        });
    }
    canActivate() {
        if (this.completeState === true || this.stepThree === true) {
            return true;
        }
        else {
            this.router.navigate(['']);
            return false;
        }
    }
}
CompleteGuardCheckout.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompleteGuardCheckout, deps: [{ token: CheckoutService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
CompleteGuardCheckout.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompleteGuardCheckout });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompleteGuardCheckout, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CheckoutService }, { type: i2.Router }]; } });

class CheckoutMyDetailsGuard {
    constructor(router) {
        this.router = router;
        this.addressingBehvior = new BehaviorSubject(null);
        this.CARD_ID = JSON.parse(localStorage.getItem('cardId'));
        this.addressingBehvior.subscribe(canOpenAddressing => this.canOpenAddressing = canOpenAddressing);
    }
    canActivate() {
        if (this.canOpenAddressing === true) {
            return true;
        }
        else {
            this.router.navigate(['']);
            return false;
        }
    }
}
CheckoutMyDetailsGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutMyDetailsGuard, deps: [{ token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
CheckoutMyDetailsGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutMyDetailsGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutMyDetailsGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }]; } });

class DisablePurchaseGuard {
    constructor(cartService, router) {
        this.cartService = cartService;
        this.router = router;
    }
    canActivate() {
        return this.cartService.getCart().pipe(map(data => {
            if (data['disablePurchase'] === true) {
                this.router.navigate(['/cart']);
                return false;
            }
            return !data['disablePurchase'];
        }));
    }
}
DisablePurchaseGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DisablePurchaseGuard, deps: [{ token: CartService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
DisablePurchaseGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DisablePurchaseGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DisablePurchaseGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CartService }, { type: i2.Router }]; } });

// services

class ForgetPasswordBaseComponent {
    constructor(loginService, languageService, formBuilder, confService) {
        this.loginService = loginService;
        this.languageService = languageService;
        this.formBuilder = formBuilder;
        this.confService = confService;
        this.language = {};
        this.success = null;
        this.errors = [];
        this.logByPhone = false;
    }
    ngOnInit() {
        this.store$ = this.confService.store$;
        this.currentLang = this.languageService.lastLocale;
        this.languageService.localeChange.subscribe(() => {
            this.currentLang = this.languageService.lastLocale;
        });
        this.logo$ = this.confService.logo$;
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        this.store$.subscribe(res => {
            this.logByPhone = res.isMobileEssential;
        });
        this.forgetPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, this.logByPhone ? Validators.pattern('^[0-9]{6,15}$') : Validators.email]]
        });
    }
    submitForm() {
        this.errors = [];
        this.loginService.requestResetPassword(this.forgetPasswordForm.value.email).subscribe(data => {
            this.success = true;
            this.success = data.code === 200;
            this.message = data.message;
        }, error => {
            this.success = false;
            this.message = error.error.message;
            this.errors = Object.values(error.error.errors);
        });
    }
}
ForgetPasswordBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ForgetPasswordBaseComponent, deps: [{ token: LoginService }, { token: LanguageService }, { token: i1$1.FormBuilder }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
ForgetPasswordBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ForgetPasswordBaseComponent, selector: "app-base-forget-password", ngImport: i0, template: "<div class=\"page-container\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row no-gutters\">\r\n      <!--Store logo-->\r\n      <div class=\"col-lg-6 col-md-5\">\r\n        <div class=\"image-container\">\r\n          <img *ngIf=\"logo$ as logo\" [lazyLoad]=\"logo |async\" alt=\"\" [errorImage]=\"defaultImage\">\r\n        </div>\r\n      </div>\r\n      <!--Form forget password-->\r\n      <div class=\"col-lg-6 col-md-7 d-flex justify-content-center align-items-center\">\r\n        <div class=\"accounts-form\">\r\n          <div class=\"accounts-form-head\">\r\n            <ng-container *ngIf=\"store$ | async as store\">\r\n              <a *ngIf=\"!store['mustLogged']\" routerLink=\"/{{language['LANGUAGE_CODE']}}\" class=\"backToWebsite align-items-center\">\r\n                <i [ngClass]=\"language['DIR'] === 'rtl'? 'fa fa-angle-right ml-2' : 'fa fa-angle-left mr-2'\"></i>\r\n                {{language['backToWebsite']}}\r\n              </a>\r\n            </ng-container>\r\n          </div><!--End accounts-form-head-->\r\n          <div class=\"accounts-form-content\">\r\n              <div class=\"form-container col-9\">\r\n                <h3 class=\"account-title h3--custom\">{{language['forgetYourPassword']}} </h3>\r\n                <p>\r\n  \r\n                  {{ logByPhone ? (\r\n                    language['LANGUAGE_CODE'] === 'en_US' \r\n                    ? \"Enter the Phone Number you used when you registered, and we'll send you instructions to reset your password\"\r\n                    : \"\u0645\u0646 \u0641\u0636\u0644\u0643 \u0627\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u064A \u0627\u0633\u062A\u062E\u062F\u0645\u062A\u0647 \u0639\u0646\u062F \u0627\u0644\u0625\u0634\u062A\u0631\u0627\u0643 \u0648\u0633\u0648\u0641 \u0646\u0631\u0633\u0644 \u0644\u0643 \u0628\u0639\u0636 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0644\u0623\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643\"\r\n                  ) : language['forgetPassStatement']\r\n                }}\r\n                \r\n                </p>\r\n                <form [formGroup]=\"forgetPasswordForm\" (ngSubmit)=\"submitForm()\">\r\n                  <div class=\"form-group\">\r\n                    <label for=\"email\" [innerHTML]=\"logByPhone ? language['phone_number'] + ' *': language['email'] + ' *'\"></label>\r\n                    <input type=\"email\" name=\"email\" id=\"email\" class=\"form-control input-lg\" tabindex=\"3\" formControlName=\"email\">\r\n                    <div class=\"validation-text\">\r\n                      <span *ngIf=\"forgetPasswordForm.controls['email'].touched  && forgetPasswordForm.controls['email'].errors?.required\">\r\n                        {{ logByPhone ? (\r\n                          language['LANGUAGE_CODE'] === 'en_US' \r\n                          ? \"Please enter the Phone Number\"\r\n                          : \"\u0645\u0646 \u0641\u0636\u0644\u0643 \u0627\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641\"\r\n                        ) : language['enter_your_email']\r\n                      }}\r\n                      \r\n                      </span>\r\n                      <span *ngIf=\"forgetPasswordForm.controls['email'].touched && forgetPasswordForm.controls['email'].errors?.pattern\">\r\n                        {{ logByPhone ? (\r\n                          language['LANGUAGE_CODE'] === 'en_US' \r\n                          ? \"Please enter a valid Phone Number\"\r\n                          : \"\u0645\u0646 \u0641\u0636\u0644\u0643 \u0627\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0635\u062D\u064A\u062D\"\r\n                        ) : language['enterValidEmail']\r\n\r\n                      }}                      \r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                  <button type=\"submit\" class=\"main-btn\" [disabled]=\"!forgetPasswordForm.valid\">{{language['send']}}</button>\r\n                  <p *ngIf=\"success !== null\" class=\"alert\" [ngClass]=\"{'alert-success': success, 'alert-danger': !success}\">\r\n                    {{message}}\r\n                  </p>\r\n                  <ng-container *ngIf=\"errors.length > 0\">\r\n                    <div class=\"alert alert-danger\" *ngFor=\"let error of errors\">{{error}}</div>\r\n                  </ng-container>\r\n                </form>\r\n              </div><!--End form-container-->\r\n          </div><!--End accounts-form-conetent-->\r\n        </div><!--End accounts-form-->\r\n      </div><!--End col-->\r\n    </div><!--End row-->\r\n  </div><!--End container-fluid-->\r\n</div><!--End page-container-->\r\n", styles: ["@charset \"UTF-8\";:host .page-container .container-fluid{padding:0}:host .page-container .container-fluid>.row{min-height:100vh}:host .page-container .account-title{color:var(--h3-color, #000);font-size:var(--h3-font-size, 28px);text-transform:capitalize;font-weight:600;margin-bottom:10px}:host .page-container .image-container{background:#0d0d0d;min-height:100%;display:flex;align-items:center;justify-content:center;padding:20px}:host .page-container .image-container img{max-width:300px}:host .page-container .accounts-form{padding:10px}:host .page-container .accounts-form .accounts-form-head .backToWebsite{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 16px)}:host .page-container .accounts-form .accounts-form-content{position:absolute;width:400px;transform:translate(-50%,-50%);top:50%;left:50%}@media all and (max-width: 767.98px){:host .page-container .accounts-form .accounts-form-content{position:static;transform:none;width:auto;max-width:400px;margin:30px auto 0}}:host .page-container .accounts-form .form-container .form-control{border-radius:0}:host .page-container .accounts-form .form-container .forget-password{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 1.4rem)}:host .page-container .with-cursor{cursor:pointer}:host .custom-checkbox{position:relative}:host .custom-checkbox input[type=checkbox]{width:0;height:0;opacity:0;position:absolute}:host .custom-checkbox input[type=checkbox]~.label{position:relative;padding-left:25px;text-transform:capitalize;cursor:pointer}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label{padding-left:0;padding-right:25px}:host .custom-checkbox input[type=checkbox]~.label:after{position:absolute;content:\"\";top:4px;left:0;font-family:\"fontAwesome\";width:17px;height:17px;line-height:14px;text-align:center;border-radius:2px;border:2px solid #d3cac5;color:#000;font-size:14px}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label:after{left:auto;right:0}:host .custom-checkbox input[type=checkbox]:checked~.label:after{content:\"\\f00c\";border-color:var(--main-color, var(--main-color, orange));background-color:var(--main-color, var(--main-color, orange))}:host .custom-checkbox input[type=checkbox]:focus~.label:after{border-color:var(--main-color, var(--main-color, orange))}:host .social-btns{margin-bottom:10px}:host .main-btn{background:transparent;border:1px solid var(--main-color, orange);color:#444;font-weight:600;transition:all .4s ease;min-width:100px;padding:5px 0;margin:0 auto;text-align:center;display:block}:host .main-btn:enabled:hover{background:var(--main-color, orange);color:#fff!important;cursor:pointer}:host .main-btn:disabled{cursor:not-allowed;background:#999;color:#fff;border-color:#999}:host .or-section hr{width:40%;border-top:1px solid #ced4da}:host hr{border-top:1px solid #ced4da}:host button.social{background:transparent;border:2px solid;border-radius:0;width:110px;height:35px;display:flex;align-items:center;justify-content:center}:host button.social.facebook{border-color:#29487d;transition:all .4s ease;cursor:pointer}:host button.social.facebook i{color:#29487d;margin:0 5px}:host button.social.google{border-color:#dd5347;transition:all .4s ease;cursor:pointer}:host button.social.google i{color:#dd5347;margin:0 5px}:host button.social.facebook:hover{background:#29487d;color:#fff}:host button.social.facebook:hover i{color:#fff}:host button.social.google:hover{background:#dd5347;color:#fff}:host button.social.google:hover i{color:#fff}:host .form-control{box-shadow:none}:host .form-control.ng-invalid.ng-touched{border-color:#bd2130}:host .validation-text{font-size:14px;color:#bd2130;position:relative;top:-10px;margin-top:15px}:host .validation-text span{display:block}:host .not-member{display:flex;justify-content:center;align-items:center;margin-top:10px}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ForgetPasswordBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-forget-password',
                    templateUrl: './forget-password.base-component.html',
                    styleUrls: ['./forget-password.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LoginService }, { type: LanguageService }, { type: i1$1.FormBuilder }, { type: ConfService }]; } });

class ResetPasswordBaseComponent {
    constructor(activatedRoute, router, loginService, formBuilder, languageService, confService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.loginService = loginService;
        this.formBuilder = formBuilder;
        this.languageService = languageService;
        this.confService = confService;
        this.language = {};
        this.success = null;
        this.errors = [];
        this.logByPhone = false;
    }
    ngOnInit() {
        this.store$ = this.confService.store$;
        this.currentLang = this.languageService.lastLocale;
        this.languageService.localeChange.subscribe(() => {
            this.currentLang = this.languageService.lastLocale;
        });
        this.logo$ = this.confService.logo$;
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.store$.subscribe(res => {
            this.logByPhone = res.isMobileEssential;
        });
        this.resetPasswordForm = this.formBuilder.group({
            password: [
                '',
                [Validators.required, Validators.minLength(6)]
            ],
            confirm_password: [
                '',
                [Validators.required, Validators.minLength(6)]
            ]
        }, {
            validator: [
                this.passwordMatch.bind(this)
            ]
        });
        this.activatedRoute.params.subscribe(params => {
            this.token = params['token'];
            this.email = params['email'];
            this.loginService.verifyToken(this.email, this.token).subscribe(() => {
                this.error = '';
            }, error => {
                this.error = error.error.message;
            });
        });
        this.sendMailForm = this.formBuilder.group({
            email: ['', [Validators.required, this.logByPhone ? Validators.pattern('^[0-9]{6,15}$') : Validators.email]]
        });
    }
    passwordMatch() {
        if (!this.resetPasswordForm) {
            return null;
        }
        if (this.resetPasswordForm.value.password === this.resetPasswordForm.value.confirm_password) {
            return null;
        }
        return { error: this.language['passwordsDoNotMatch'] };
    }
    resetPassword() {
        this.loginService.resetPassword(this.email, this.token, this.resetPasswordForm.value.password, this.resetPasswordForm.value.confirm_password).subscribe(() => {
            alert('password reset successfully');
            this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'accounts', 'login']);
        });
    }
    sendMailFormSubmit() {
        this.errors = [];
        this.loginService.requestResetPassword(this.sendMailForm.value.email).subscribe(data => {
            this.success = true;
            this.success = data['code'] === 200;
            this.message = data['message'];
        }, error => {
            this.success = false;
            this.message = error.error.message;
            this.errors = Object.values(error.error.errors);
        });
    }
}
ResetPasswordBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ResetPasswordBaseComponent, deps: [{ token: i2.ActivatedRoute }, { token: i2.Router }, { token: LoginService }, { token: i1$1.FormBuilder }, { token: LanguageService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
ResetPasswordBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ResetPasswordBaseComponent, selector: "app-base-reset-password", ngImport: i0, template: "<div class=\"page-container\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row no-gutters\">\r\n      <!--Store logo-->\r\n      <div class=\"col-lg-6 col-md-5\">\r\n        <div class=\"image-container\" *ngIf=\"store$ | async as store\">\r\n          <img *ngIf=\"logo$ as logo\" [lazyLoad]=\"logo |async\" alt=\"{{ store.name }}\" [errorImage]=\"defaultImage\">\r\n        </div>\r\n      </div>\r\n      <!--Form reset password-->\r\n      <div class=\"col-lg-6 col-md-7 d-flex justify-content-center align-items-center\">\r\n        <div class=\"accounts-form col-9\">\r\n          <div class=\"accounts-form-head\">\r\n            <ng-container *ngIf=\"store$ | async as store\">\r\n              <a *ngIf=\"!store['mustLogged']\" routerLink=\"/{{language['LANGUAGE_CODE']}}\" class=\"backToWebsite align-items-center\">\r\n                <i [ngClass]=\"language['DIR'] === 'rtl'? 'fa fa-angle-right ml-2' : 'fa fa-angle-left mr-2'\"></i>\r\n                {{language['backToWebsite']}}\r\n              </a>\r\n            </ng-container>\r\n          </div><!--End accounts-form-head-->\r\n          <div class=\"accounts-form-content\">\r\n            <!-- Form -->\r\n            <div class=\"form-container\" *ngIf=\"!error\">\r\n              <h3 class=\"account-title h3--custom\">{{language['resetPassword']}}</h3>\r\n              <form [formGroup]=\"resetPasswordForm\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"password\">{{language['new_password']}}</label>\r\n                  <input type=\"password\" id=\"password\" class=\"form-control\" formControlName=\"password\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label for=\"confirm_password\">{{language['confirmPassword']}}</label>\r\n                  <input type=\"password\" id=\"confirm_password\" class=\"form-control\" formControlName=\"confirm_password\">\r\n                </div>\r\n                <div class=\"alert alert-danger\" *ngIf=\"resetPasswordForm.controls['password'].dirty  && resetPasswordForm.controls['password'].errors?.minlength\">\r\n                  {{language['please_make_sure_your_password_is_not_less_than_6_characters']}}\r\n                </div>\r\n                <div class=\"alert alert-danger\" *ngIf=\"resetPasswordForm.controls['confirm_password'].dirty  && resetPasswordForm.errors\">\r\n                  {{resetPasswordForm.errors['error']}}\r\n                </div>\r\n                <div class=\"form-group text-center\">\r\n                  <button type=\"submit\" (click)=\"resetPassword()\" class=\"main-btn\" [disabled]=\"resetPasswordForm.invalid\">\r\n                    {{language['reset']}}\r\n                  </button>\r\n                </div>\r\n              </form>\r\n            </div><!-- End form-container-->\r\n\r\n            <!-- Form errors -->\r\n          <div class=\"form-container\" *ngIf=\"error\">\r\n              <h3 class=\"account-title h3--custom\">{{language['resetCodeInvalid']}}</h3>\r\n              <p *ngIf=\"error\" class=\"validation-text\">\r\n                {{language['somthingWentWrong']}}\r\n                <br>\r\n                {{error}}\r\n              </p>\r\n              <form [formGroup]=\"sendMailForm\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"email\" [innerHTML]=\"logByPhone ? language['phone_number'] + ' *': language['email'] + ' *'\"></label>\r\n                  <input type=\"email\" name=\"email\" id=\"email\" class=\"form-control input-lg\" tabindex=\"3\" formControlName=\"email\">\r\n                  <div class=\"validation-text\">\r\n                    <span *ngIf=\"sendMailForm.controls['email'].touched  && sendMailForm.controls['email'].errors?.required\">\r\n                      {{ logByPhone ? (\r\n                        language['LANGUAGE_CODE'] === 'en_US' \r\n                        ? \"Please enter the Phone Number\"\r\n                        : \"\u0645\u0646 \u0641\u0636\u0644\u0643 \u0627\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641\"\r\n                      ) : language['enter_your_email']\r\n                    }}                    </span>\r\n                    <span *ngIf=\"sendMailForm.controls['email'].touched && sendMailForm.controls['email'].errors?.pattern\">\r\n                      {{ logByPhone ? (\r\n                        language['LANGUAGE_CODE'] === 'en_US' \r\n                        ? \"Please enter a valid Phone Number\"\r\n                        : \"\u0645\u0646 \u0641\u0636\u0644\u0643 \u0627\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0635\u062D\u064A\u062D\"\r\n                      ) : language['enterValidEmail']\r\n                                          }}                    </span>\r\n                  </div>\r\n                </div><!--End form-group-->\r\n                <div class=\"form-group\">\r\n                  <button (click)=\"sendMailFormSubmit()\" class=\"main-btn\" [disabled]=\"!sendMailForm.valid\">\r\n                    {{language['send']}}\r\n                  </button>\r\n                </div><!--End form-group-->\r\n                <p *ngIf=\"success !== null\" class=\"alert\" [ngClass]=\"{'alert-success': success, 'alert-danger': !success}\">\r\n                  {{message}}\r\n                </p>\r\n                <ng-container *ngIf=\"errors.length > 0\">\r\n                  <div class=\"alert alert-danger\" *ngFor=\"let error of errors\">{{error}}</div>\r\n                </ng-container>\r\n              </form>\r\n              <hr>\r\n              <div class=\"horizontal-btns d-flex align-items-center justify-content-between mt-3\">\r\n                <a routerLink=\"/{{language['LANGUAGE_CODE']}}/accounts/login\" class=\"main-btn\">{{language['login']}}</a>\r\n                <a routerLink=\"/{{language['LANGUAGE_CODE']}}/accounts/sign-up\" class=\"main-btn\">{{language['register']}}</a>\r\n              </div>\r\n            </div><!--End form-container-->\r\n\r\n          </div><!--End accounts-form-content-->\r\n        </div><!--End accounts-form-->\r\n      </div><!--End col-->\r\n    </div><!--End row-->\r\n  </div><!--End container-fluid-->\r\n</div><!--End oage-contianer-->\r\n", styles: ["@charset \"UTF-8\";:host .page-container .container-fluid{padding:0}:host .page-container .container-fluid>.row{min-height:100vh}:host .page-container .account-title{color:var(--h3-color, #000);font-size:var(--h3-font-size, 28px);text-transform:capitalize;font-weight:600;margin-bottom:10px}:host .page-container .image-container{background:#0d0d0d;min-height:100%;display:flex;align-items:center;justify-content:center;padding:20px}:host .page-container .image-container img{max-width:300px}:host .page-container .accounts-form{padding:10px}:host .page-container .accounts-form .accounts-form-head .backToWebsite{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 16px)}:host .page-container .accounts-form .accounts-form-content{position:absolute;width:400px;transform:translate(-50%,-50%);top:50%;left:50%}@media all and (max-width: 767.98px){:host .page-container .accounts-form .accounts-form-content{position:static;transform:none;width:auto;max-width:400px;margin:30px auto 0}}:host .page-container .accounts-form .form-container .form-control{border-radius:0}:host .page-container .accounts-form .form-container .forget-password{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 1.4rem)}:host .page-container .with-cursor{cursor:pointer}:host .custom-checkbox{position:relative}:host .custom-checkbox input[type=checkbox]{width:0;height:0;opacity:0;position:absolute}:host .custom-checkbox input[type=checkbox]~.label{position:relative;padding-left:25px;text-transform:capitalize;cursor:pointer}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label{padding-left:0;padding-right:25px}:host .custom-checkbox input[type=checkbox]~.label:after{position:absolute;content:\"\";top:4px;left:0;font-family:\"fontAwesome\";width:17px;height:17px;line-height:14px;text-align:center;border-radius:2px;border:2px solid #d3cac5;color:#000;font-size:14px}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label:after{left:auto;right:0}:host .custom-checkbox input[type=checkbox]:checked~.label:after{content:\"\\f00c\";border-color:var(--main-color, var(--main-color, orange));background-color:var(--main-color, var(--main-color, orange))}:host .custom-checkbox input[type=checkbox]:focus~.label:after{border-color:var(--main-color, var(--main-color, orange))}:host .social-btns{margin-bottom:10px}:host .main-btn{background:transparent;border:1px solid var(--main-color, orange);color:#444;font-weight:600;transition:all .4s ease;min-width:100px;padding:5px 0;margin:0 auto;text-align:center;display:block}:host .main-btn:enabled:hover{background:var(--main-color, orange);color:#fff!important;cursor:pointer}:host .main-btn:disabled{cursor:not-allowed;background:#999;color:#fff;border-color:#999}:host .or-section hr{width:40%;border-top:1px solid #ced4da}:host hr{border-top:1px solid #ced4da}:host button.social{background:transparent;border:2px solid;border-radius:0;width:110px;height:35px;display:flex;align-items:center;justify-content:center}:host button.social.facebook{border-color:#29487d;transition:all .4s ease;cursor:pointer}:host button.social.facebook i{color:#29487d;margin:0 5px}:host button.social.google{border-color:#dd5347;transition:all .4s ease;cursor:pointer}:host button.social.google i{color:#dd5347;margin:0 5px}:host button.social.facebook:hover{background:#29487d;color:#fff}:host button.social.facebook:hover i{color:#fff}:host button.social.google:hover{background:#dd5347;color:#fff}:host button.social.google:hover i{color:#fff}:host .form-control{box-shadow:none}:host .form-control.ng-invalid.ng-touched{border-color:#bd2130}:host .validation-text{font-size:14px;color:#bd2130;position:relative;top:-10px;margin-top:15px}:host .validation-text span{display:block}:host .not-member{display:flex;justify-content:center;align-items:center;margin-top:10px}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ResetPasswordBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-reset-password',
                    templateUrl: './reset-password.base-component.html',
                    styleUrls: ['./reset-password.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: i2.Router }, { type: LoginService }, { type: i1$1.FormBuilder }, { type: LanguageService }, { type: ConfService }]; } });

function validatePassword(control1, control2) {
    return (formGroup) => {
        const password = formGroup.controls[control1];
        const confirmPassword = formGroup.controls[control2];
        if (password.dirty && confirmPassword.dirty && password.value !== confirmPassword.value) {
            confirmPassword.setErrors({
                wrongPassword: true
            });
        }
        return null;
    };
}

class Url {
}
class Breadcrumb {
}

class Conf {
}
class AccessToken {
}
// export abstract class Login {
//   login: any;
//   original: any;
//   accessToken: AccessToken;
//   locales: Locale[];
//   userId: number;
//   features: Features;
// }

class Country {
}
class City {
}
class Area {
}

class Filter {
}
class Attribute extends Translatable {
}
class Option extends Translatable {
}
class Taxon extends Translatable {
}
class PriceRange {
}
class DefaultPriceRange {
}
class OptionValue extends Translatable {
}
class AttributeValues {
}

class Locale {
}

class Currency {
}

class Review {
}
class Author {
}

class AllPage extends Translatable {
}
class Image {
}
class Page extends Translatable {
}

class StoreIdentity {
}

class ApiResponse {
}
class OldApiResponse {
}

class Slider {
}
class Sliders {
}

class Features {
}

class Categories {
}

class Orders {
}
class Order {
}
class OrderItem {
}
class OrderCustomer {
}
class CustomerAddress {
}
class ShopUser {
}
class Channel {
}
class OrderAddress {
}
class Payment extends Translatable {
}
class PaymentMethod {
}
class Shipment {
}
class ShipmentMethod {
}

class Translation {
}
class Children {
}
class NavigationMenu {
}

// classes

function conditionalRequiredValidator$1(showField) {
    return (control) => {
        if (showField) {
            if (!control.value) {
                return { required: 'This field is required.' };
            }
        }
        return null;
    };
}
class SignUpBaseComponent {
    constructor(formBuilder, loginService, languageService, confService, router, toastr, checkoutService, personalInfoService, contactUsService) {
        this.formBuilder = formBuilder;
        this.loginService = loginService;
        this.languageService = languageService;
        this.confService = confService;
        this.router = router;
        this.toastr = toastr;
        this.checkoutService = checkoutService;
        this.personalInfoService = personalInfoService;
        this.contactUsService = contactUsService;
        this.selectedBranchId = localStorage.getItem('branchId') || null;
        this.currentLanguage = localStorage.getItem('language') || 'en_US';
        this.branchAvailable = false;
        this.errors = [];
        this.language = {};
        this.pattern = /^[a-zA-Z\u0600-\u06FF]+$/;
        this.email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        this.logged = this.loginService.logged.getValue();
        this.allowEditPhone = true;
        this.verifyMobileRequired$ = this.confService.verifyMobileRequired;
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.showGender = StoresName.DoctormId ? true : false;
        this.showField = (this.id == StoresName.natureWorks) ? true : false;
        this.Ramco = (this.id == 13246) ? true : false;
        this.data = this.router.getCurrentNavigation().extras.state;
        if (this.data && this.data.errors && this.data.errors.length > 0) {
            this.data.errors.forEach(element => {
                this.errors.push(element);
            });
        }
    }
    ngOnInit() {
        this.confService.storeId.subscribe((id) => {
            this.storeId = id;
        });
        this.branches$ = this.contactUsService
            .getContactDetails()
            .pipe(map((data) => data.branches));
        this.getCurrentBranchName();
        this.branches$.subscribe((data) => {
            this.branchAvailable = data.length > 1;
        });
        this.phoneNumberRequired = JSON.parse(localStorage.getItem('loginByMobile'));
        this.confService.getConf().subscribe(res => {
            this.mustLoggin = res['mustLogged'];
        });
        this.store$ = this.confService.store$;
        this.currentLang = this.languageService.lastLocale;
        this.languageService.localeChange.subscribe(() => {
            this.currentLang = this.languageService.lastLocale;
        });
        this.logo$ = this.confService.logo$;
        this.languageService.getLanguage().subscribe((language) => {
            this.language = language;
        });
        this.verifyMobileRequired$.subscribe(verifyMobileRequired => {
            this.verifyMobileRequired = verifyMobileRequired;
            this.dataBackFromVerify = (this.data && this.data != null && this.data.data && this.data.data != null && this.verifyMobileRequired == true) ? true : false;
            this.statusBackFromVerify = (this.data && this.data != null && this.data.data && this.data.data != null && this.verifyMobileRequired == true && this.data.info && this.data.info != null && this.data.info.status && this.data.info.status == 'verified') ? true : false;
            this.allowEditPhone = !this.statusBackFromVerify;
            this.signUpForm = this.formBuilder.group({
                firstName: [
                    (this.dataBackFromVerify && this.data.data.firstName) ? this.data.data.firstName : '',
                    [
                        Validators.required,
                        Validators.minLength(2),
                        Validators.maxLength(255),
                        Validators.pattern(this.pattern),
                    ],
                ],
                lastName: [
                    (this.dataBackFromVerify && this.data.data.lastName) ? this.data.data.lastName : '',
                    [
                        Validators.required,
                        Validators.minLength(2),
                        Validators.maxLength(255),
                        Validators.pattern(this.pattern),
                    ],
                ],
                gender: ['u', [Validators.required]],
                email: [
                    (this.dataBackFromVerify && this.data.data.email) ? this.data.data.email : '',
                    [Validators.required, Validators.email, Validators.pattern(this.email)],
                ],
                password: [
                    (this.dataBackFromVerify && this.data.data.user && this.data.data.user.plainPassword) ? this.data.data.user.plainPassword : '',
                    [Validators.required, Validators.minLength(6)]
                ],
                companyName: (this.dataBackFromVerify && this.data.data.companyName) ? this.data.data.companyName : '',
                branch: [(this.dataBackFromVerify && this.data.data.branch) ? this.data.data.branch : '',
                    [conditionalRequiredValidator$1(this.showField)]],
                phoneNumber: [
                    (this.dataBackFromVerify && this.data.data.phoneNumber) ? this.data.data.phoneNumber : '',
                    [this.phoneNumberRequired ? Validators.required : Validators.minLength(2)]
                ],
                companyCode: (this.dataBackFromVerify && this.data.data.companyCode) ? this.data.data.companyCode : '',
                passwordConfirmation: [
                    (this.dataBackFromVerify && this.data.data.user && this.data.data.user.plainPassword) ? this.data.data.user.plainPassword : '',
                    [Validators.required, Validators.minLength(6)],
                ],
                // acceptTerms: [false, [Validators.requiredTrue]]
            }, { validator: validatePassword('password', 'passwordConfirmation') });
            console.log(this.storeId);
            if (this.storeId == 5582) { /// تاجر السعادة
                this.signUpForm.get('email').touched = true;
                this.signUpForm.get('email').clearValidators();
                this.signUpForm.get('email').setErrors(null);
            }
        });
        this.checkoutService.getCountriesCitiesProvinces().pipe(map(data => data['response'])).subscribe((data) => {
            this.countries = data;
        });
    }
    getCurrentBranchName() {
        this.branches$.subscribe((branches) => {
            if (this.selectedBranchId && branches) {
                this.currentBranchName = branches.filter((branch) => branch.id == this.selectedBranchId)[0].translations[this.currentLanguage].name;
            }
            else {
                this.currentBranchName = branches.length != 0 && branches[0].translations[this.currentLanguage].name;
            }
        });
    }
    enableEditPhone() {
        this.allowEditPhone = true;
    }
    changePhoneNumber(event) {
        if (this.data && this.data.info && this.data.info.phoneNumber) {
            if (event.target.value.toString() != this.data.info.phoneNumber.toString()) {
                this.data.info.status = 'notVerified';
            }
            if (event.target.value.toString() == this.data.info.phoneNumber.toString()) {
                this.allowEditPhone = false;
                this.data.info.status = 'verified';
            }
            this.statusBackFromVerify = (this.data && this.data != null && this.data.data && this.data.data != null && this.verifyMobileRequired == true && this.data.info && this.data.info != null && this.data.info.status && this.data.info.status == 'verified') ? true : false;
        }
    }
    checkExist() {
        let Users;
        let emails;
        this.personalInfoService.getAllUsers().subscribe((res) => {
            Users = res;
            console.log(Users);
            emails = Users._embedded.items.map(item => item.email);
        });
        for (let i = 0; i <= emails.length; i++) {
            if (this.signUpForm.controls.email.value == emails[i]) {
                this.signUpForm.controls.email.setErrors({ emailExists: true });
            }
        }
        return null;
    }
    numberOnly(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        return charCode > 31 && (charCode < 48 || charCode > 57) ? false : true;
    }
    verifyOTP(newCustomer) {
        const navigationExtras = {
            state: {
                info: { from: 'sign-up', to: 'verify-phone', 'status': 'notVerified', 'phoneNumber': newCustomer.phoneNumber },
                data: newCustomer
            }
        };
        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'verify-phone'], navigationExtras);
    }
    signUp() {
        this.errors = [];
        const newCustomer = {
            firstName: this.signUpForm.value.firstName,
            lastName: this.signUpForm.value.lastName,
            email: this.signUpForm.value.email ? this.signUpForm.value.email : this.signUpForm.value['phoneNumber'] + "@gmail.com",
            companyName: this.signUpForm.value.companyName,
            companyCode: this.signUpForm.value.companyCode,
            gender: this.signUpForm.value.gender,
            branch: this.signUpForm.value.branch,
            phoneNumber: this.signUpForm.value['phoneNumber'],
            user: {
                plainPassword: this.signUpForm.value.password,
                enabled: true,
            },
        };
        if (!newCustomer.firstName ||
            !newCustomer.lastName ||
            !newCustomer.email ||
            !newCustomer.user.plainPassword
        // this.signUpForm.value.acceptTerms !== true
        ) {
            this.errors.push('Please complete your data');
        }
        else {
            if ((this.verifyMobileRequired == true && this.statusBackFromVerify == false)) {
                this.loginService.getphoneNumberOTP(newCustomer.phoneNumber, null, newCustomer.email).subscribe({
                    next: data => {
                        if (data && data.success && data.success == 'sms_sent') {
                            this.verifyOTP(newCustomer);
                            return;
                        }
                        if (data && data.success && data.success == 'already_verified') {
                            this.statusBackFromVerify = true;
                            this.signUp();
                            return;
                        }
                        (!data.success && data.message) ? this.errors.push(data.message) : '';
                    },
                    error: error => {
                        (error && error.error && error.error.message) ? this.errors.push(error.error.message) : '';
                    }
                });
                return;
            }
            this.loginService.signUp(newCustomer).subscribe(() => { }, (httpError) => {
                if (httpError.status === 401) {
                    this.toastr.info('Thank you for your registration, please wait while the admin approves your account to have an access to your profile.', 'Note');
                    if (this.mustLoggin && !this.logged) {
                        this.router.navigate(['/accounts/login'], { replaceUrl: true, skipLocationChange: true });
                    }
                    else {
                        this.router.navigateByUrl(`/${localStorage.getItem('language')}`);
                    }
                }
                else if (httpError.error.errors.children) {
                    const keys = Object.keys(httpError.error.errors.children);
                    for (const key of keys) {
                        const error = httpError.error.errors.children[key];
                        if (error.errors !== undefined && error.errors.length > 0) {
                            for (const e of error.errors) {
                                this.errors.push(e);
                            }
                        }
                    }
                }
                else if (httpError.error.errors) {
                    this.errors.push(httpError.error.errors);
                }
            });
        }
    }
}
SignUpBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SignUpBaseComponent, deps: [{ token: i1$1.FormBuilder }, { token: LoginService }, { token: LanguageService }, { token: ConfService }, { token: i2.Router }, { token: i3$1.ToastrService }, { token: CheckoutService }, { token: PersonalInfoService }, { token: ContactUsService }], target: i0.ɵɵFactoryTarget.Component });
SignUpBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: SignUpBaseComponent, selector: "app-base-sign-up", ngImport: i0, template: "<div class=\"page-container\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row no-gutters\">\r\n      <!--Store logo-->\r\n      <div class=\"col-lg-6 col-md-5\">\r\n        <div class=\"image-container\" *ngIf=\"store$ | async as store\">\r\n          <img *ngIf=\"logo$ as logo\" [lazyLoad]=\"logo |async\" alt=\"{{ store.name }}\" [errorImage]=\"defaultImage\" />\r\n        </div>\r\n      </div>\r\n      <!-- Sign up Form -->\r\n      <div class=\"col-lg-6 col-md-7 align-self-center py-0 px-5\">\r\n        <div class=\"accounts-form pt-3 pb-0\">\r\n          <div class=\"accounts-form-head d-flex align-items-center justify-content-between\">\r\n            <ng-container *ngIf=\"store$ | async as store\">\r\n              <a *ngIf=\"!store['mustLogged']\" routerLink=\"/{{language['LANGUAGE_CODE']}}\"\r\n                class=\"backToWebsite align-items-center\">\r\n                <i [ngClass]=\"language['DIR'] === 'rtl'? 'fa fa-angle-right ml-2' : 'fa fa-angle-left mr-2'\"></i>\r\n                {{language['backToWebsite']}}\r\n              </a>\r\n            </ng-container>\r\n          </div>\r\n          <!--End accounts-form-head-->\r\n          <div class=\"sign-up-accounts-form-content pt-5\">\r\n            <!-- Form -->\r\n            <div class=\"form-container\">\r\n              <h3 class=\"account-title h3--custom\">{{language['register']}}</h3>\r\n              <form [formGroup]=\"signUpForm\" (ngSubmit)=\"signUp()\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"firstName\">{{language['firstName']}}</label>\r\n                  <input id=\"firstName\" type=\"text\" name=\"firstName\" class=\"form-control input-lg\"\r\n                    formControlName=\"firstName\" />\r\n                  <div class=\"validation-text\">\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['firstName'].touched  && signUpForm.controls['firstName'].errors?.required\">\r\n                      {{language['Please_enter_your_first_name']}}\r\n                    </span>\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['firstName'].touched  && signUpForm.controls['firstName'].errors?.minlength\">\r\n                      {{language['Please_make_your_name_not_less_than_2_letters']}}\r\n                    </span>\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['firstName'].touched  && signUpForm.controls['firstName'].errors?.pattern\">\r\n                      {{language['Please_make_your_name_doesnt_contain_numbers_or_symbols']}}\r\n                    </span>\r\n                  </div>\r\n                  <!--End validation-text-->\r\n                </div>\r\n                <!--End form-group-->\r\n                <div class=\"form-group\">\r\n                  <label for=\"lastName\">{{language['lastName']}}</label>\r\n                  <input type=\"text\" name=\"lastName\" id=\"lastName\" class=\"form-control input-lg\"\r\n                    formControlName=\"lastName\" />\r\n                  <div class=\"validation-text\">\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['lastName'].touched  && signUpForm.controls['lastName'].errors?.required\">\r\n                      {{language['please_enter_your_last_name']}}\r\n                    </span>\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['lastName'].touched  && signUpForm.controls['lastName'].errors?.minlength\">\r\n                      {{language['Please_make_your_name_not_less_than_2_letters']}}\r\n                    </span>\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['lastName'].touched  && signUpForm.controls['lastName'].errors?.pattern\">\r\n                      {{language['Please_make_your_name_doesnt_contain_numbers_or_symbols']}}\r\n                    </span>\r\n                  </div>\r\n                  <!--End validation-text-->\r\n                </div>\r\n                <!--End form-group-->\r\n                <div  *ngIf=\"allowEditPhone == true\"  class=\"form-group\">\r\n                  <label>{{language['phone_number']}}</label>\r\n                  <div class=\"phoneNumber\">\r\n                    <input (mouseleave)=\"changePhoneNumber($event)\"  (keyup)=\"changePhoneNumber($event)\"  class=\"form-control mx-1\"\r\n                      placeholder=\"{{language['phone_number']}}\" formControlName=\"phoneNumber\" id=\"phoneNumberInput\"\r\n                      type=\"text\">\r\n                  </div>\r\n                  <div class=\"validation-text\">\r\n                    <div\r\n                      *ngIf=\"signUpForm.controls['phoneNumber'].touched && (errors['phoneNumber'] || signUpForm.controls['phoneNumber'].errors?.required)\">\r\n                      {{ errors['phoneNumber'] }}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div style=\"margin-bottom: 7px;\" *ngIf=\"allowEditPhone == false\" class=\"form-group\">\r\n                  <div  class=\"input-group\">\r\n\r\n                    <input disabled style=\"width: auto;     border-color: green;\"\r\n                       class=\"form-control mx-1\"\r\n                        value=\"{{signUpForm.controls['phoneNumber'].value}}\"\r\n                        id=\"phoneNumberInput2\"\r\n                        type=\"text\">\r\n                        <a class=\"editVerfyLink\" style=\"position: absolute;\r\n                        bottom: -20px;\" (click)=\"enableEditPhone()\">  edit</a>\r\n                      <div style=\"height: 33px;\r\n                      width: 33px;\r\n                      text-align: center;\r\n                      display: inline-block;\r\n                      background-color: green;\">\r\n                       <span class=\"checkmark\">\r\n                         <div class=\"checkmark_circle\"></div>\r\n                         <div class=\"checkmark_stem\"></div>\r\n                         <div class=\"checkmark_kick\"></div>\r\n                     </span>\r\n                      </div>\r\n               </div>\r\n                </div>\r\n\r\n\r\n                <div class=\"pt-2\" style=\"clear: both;\">\r\n\r\n                </div>\r\n                <div class=\"form-group\" *ngIf=\"showGender\">\r\n                  <label for=\"gender\">{{language['gender']}} :</label>\r\n                  <div class=\"form-control\">\r\n                    <select class=\"form-select\" formControlName=\"gender\" id=\"gender\">\r\n                      <option disabled selected=\"selected\" value=\"null\">{{language['select_your_gender']}}</option>\r\n                      <option value=\"m\">{{language['male']}}</option>\r\n                      <option value=\"f\">{{language['female']}}</option>\r\n                    </select>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                  <label for=\"email\">{{language['email']}}</label>\r\n                  <input type=\"email\" name=\"email\" id=\"email\" class=\"form-control input-lg\" formControlName=\"email\" (change)=\"checkExist()\" />\r\n                  <div class=\"validation-text\">\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['email'].touched  && signUpForm.controls['email'].errors?.required\">\r\n                      {{language['enter_your_email']}}\r\n                    </span>\r\n                    <span *ngIf=\"signUpForm.controls['email'].touched && signUpForm.controls['email'].errors?.pattern\">\r\n                      {{language['enterValidEmail']}}\r\n                    </span>\r\n                    <span *ngIf=\"signUpForm.controls['email']?.errors?.emailExists\">Email is Exists</span>\r\n\r\n                  </div>\r\n                  <!--End validation-text-->\r\n                </div>\r\n                <!--End form-group-->\r\n\r\n                <div class=\"form-group\">\r\n                  <label for=\"password\">{{language['password']}}</label>\r\n                  <input type=\"password\" name=\"password\" id=\"password\" class=\"form-control input-lg\"\r\n                    formControlName=\"password\" />\r\n                  <div class=\"validation-text\">\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['password'].touched  && signUpForm.controls['password'].errors?.required\">\r\n                      {{language['please_write_your_password']}}\r\n                    </span>\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['password'].touched  && signUpForm.controls['password'].errors?.minlength\">\r\n                      {{language['please_make_sure_your_password_is_not_less_than_6_characters']}}\r\n                    </span>\r\n                  </div>\r\n                  <!--End validation-text-->\r\n                </div>\r\n                <!--End form-group-->\r\n                <div class=\"form-group\">\r\n                  <label for=\"passwordConfirmation\">{{language['confirmPassword']}}</label>\r\n                  <input type=\"password\" name=\"passwordConfirmation\" id=\"passwordConfirmation\"\r\n                    class=\"form-control input-lg\" formControlName=\"passwordConfirmation\" />\r\n                  <div class=\"validation-text\">\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['passwordConfirmation'].dirty  && signUpForm.controls['passwordConfirmation'].errors?.required\">\r\n                      {{language['please_write_your_password']}}\r\n                    </span>\r\n                    <span\r\n                      *ngIf=\"signUpForm.controls['passwordConfirmation'].touched  && signUpForm.controls['passwordConfirmation'].errors?.minlength\">\r\n                      {{language['please_make_sure_your_password_is_not_less_than_6_characters']}}\r\n                    </span>\r\n                    <span *ngIf=\"signUpForm.controls['passwordConfirmation'].touched && signUpForm.controls['passwordConfirmation'].errors?.wrongPassword\">\r\n                       {{language['passwordsDoNotMatch']}}\r\n                    </span>  \r\n                  </div>\r\n                  <!--End Validation-text-->\r\n                  <!-- <div class=\"validation-text col\">\r\n                    <span *ngIf=\"signUpForm.controls['passwordConfirmation'].touched && this.signUpForm.controls['password'].value !==\r\n                          this.signUpForm.controls['passwordConfirmation'].value\">\r\n                      {{language['passwordsDoNotMatch']}}\r\n                    </span>\r\n                  </div> -->\r\n                  <!--End validation-text-->\r\n                </div>\r\n                <ng-container *ngIf=\"branchAvailable\">\r\n                  <div class=\"form-group\">\r\n                    <label for=\"branch\" *ngIf=\"!Ramco\">{{language['branch']}}</label>\r\n                    <label for=\"branch\" *ngIf=\"Ramco\">{{ language['LANGUAGE_CODE'] === 'en_US' ? \"Pharmacy \" : \"\u0635\u064A\u062F\u0644\u064A\u0647\" }}</label>\r\n                    <div class=\"form-control\">\r\n\r\n                    <select formControlName=\"branch\">\r\n                      <option value=\"\" disabled  selected *ngIf=\"!Ramco\">Select branch</option>\r\n                      <option value=\"\" disabled  selected *ngIf=\"Ramco\">{{ language['LANGUAGE_CODE'] === 'en_US' ? \"Select Pharmacy \" : \" \u0627\u062E\u062A\u0631 \u0635\u064A\u062F\u0644\u064A\u0647\" }}</option>\r\n                      <option *ngFor=\"let branch of branches$ | async as branches\" [value]=\"branch.id\" type=\"area\" name=\"branch.id\" id=\"area.name\" class=\"form-control input-lg\" >{{ branch.name }}</option>\r\n                    </select>\r\n                    </div>\r\n                   \r\n                  </div>\r\n                  <!--End form-group-->\r\n                </ng-container>\r\n                <ng-container *ngIf=\"storeId==2198\">\r\n                  <div class=\"form-group\">\r\n                    <label for=\"companyName\">{{language['companyName']}}</label>\r\n                    <input type=\"text\" name=\"companyName\" id=\"companyName\" class=\"form-control mb-4 input-lg\"\r\n                      formControlName=\"companyName\" />\r\n                  </div>\r\n                  <!--End form-group-->\r\n                  <div class=\"form-group\">\r\n                    <label for=\"companyCode\">{{language['companyCode']}}</label>\r\n                    <input type=\"text\" name=\"companyCode\" id=\"companyCode\" class=\"form-control input-lg\"\r\n                      formControlName=\"companyCode\" />\r\n                  </div>\r\n                  <!--End form-group-->\r\n                </ng-container>\r\n\r\n                <!--End form-group-->\r\n                <!-- <div class=\"form-group d-flex justify-content-between align-items-center\">\r\n                  <div class=\"custom-checkbox\">\r\n                    <input\r\n                    type=\"checkbox\"\r\n                    formControlName=\"acceptTerms\"\r\n                    id=\"acceptTerms\"\r\n                    [attr.aria-checked]=\"signUpForm.controls.acceptTerms.value\"\r\n                    >\r\n                    <label class=\"label\" for=\"acceptTerms\">\r\n                        {{language['reading_Accecpt']}}\r\n                        <a href=\"https://zvendo.com/terms-and-conditions/\" target=\"_blank\"> {{language['termsAndCondition']}} </a>\r\n                    </label>\r\n                  </div><--End custom-checkbox\r\n                </div> -->\r\n                <div class=\"form-group\">\r\n                  <button type=\"submit\" class=\"main-btn my-4 w-75\" [disabled]=\"signUpForm.invalid\">\r\n                    {{language['register']}}\r\n                  </button>\r\n                </div>\r\n                <div class=\"align-items-center col\">\r\n                  <hr />\r\n                  <!-- <p class=\"text-center pt-2\"> {{language['alreadyRegistered']}}</p> -->\r\n                  <a routerLink=\"/{{language['LANGUAGE_CODE']}}/accounts/login\"\r\n                    class=\"main-btn w-25\">{{language['login']}}\r\n                  </a>\r\n                </div>\r\n                <!--End form-group-->\r\n                <ng-container *ngIf=\"storeId==2198\">\r\n                  <div class=\"form-group\">\r\n                    <div class=\"not-member\">\r\n                      <p class=\"m-0\">\r\n                        <a target=\"_blank\" href=\"https://forms.gle/64ALr71eHqtRU7t98\"\r\n                          class=\"btn-link\">{{language['JoinUsNowAsARetailer']}}\r\n                        </a>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n                <!-- Form errors -->\r\n                <div class=\"row errors my-4 justify-content-center\">\r\n                  <p *ngFor=\"let error of errors\" class=\"alert alert-danger mx-2\">\r\n                    {{error}}\r\n                  </p>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n          <!--End accounts-form-content-->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["@charset \"UTF-8\";:host .page-container .container-fluid{padding:0}:host .page-container .container-fluid>.row{min-height:100vh}:host .page-container .account-title{color:var(--h3-color, #000);font-size:var(--h3-font-size, 28px);text-transform:capitalize;font-weight:600;margin-bottom:10px}:host .page-container .image-container{background:#0d0d0d;min-height:100%;display:flex;align-items:center;justify-content:center;padding:20px}:host .page-container .image-container img{max-width:300px}:host .page-container .accounts-form{padding:10px}:host .page-container .accounts-form .accounts-form-head .backToWebsite{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 16px)}:host .page-container .accounts-form .accounts-form-content{position:absolute;width:400px;transform:translate(-50%,-50%);top:50%;left:50%}@media all and (max-width: 767.98px){:host .page-container .accounts-form .accounts-form-content{position:static;transform:none;width:auto;max-width:400px;margin:30px auto 0}}:host .page-container .accounts-form .form-container .form-control{border-radius:0}:host .page-container .accounts-form .form-container .forget-password{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 1.4rem)}:host .page-container .with-cursor{cursor:pointer}:host .custom-checkbox{position:relative}:host .custom-checkbox input[type=checkbox]{width:0;height:0;opacity:0;position:absolute}:host .custom-checkbox input[type=checkbox]~.label{position:relative;padding-left:25px;text-transform:capitalize;cursor:pointer}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label{padding-left:0;padding-right:25px}:host .custom-checkbox input[type=checkbox]~.label:after{position:absolute;content:\"\";top:4px;left:0;font-family:\"fontAwesome\";width:17px;height:17px;line-height:14px;text-align:center;border-radius:2px;border:2px solid #d3cac5;color:#000;font-size:14px}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label:after{left:auto;right:0}:host .custom-checkbox input[type=checkbox]:checked~.label:after{content:\"\\f00c\";border-color:var(--main-color, var(--main-color, orange));background-color:var(--main-color, var(--main-color, orange))}:host .custom-checkbox input[type=checkbox]:focus~.label:after{border-color:var(--main-color, var(--main-color, orange))}:host .social-btns{margin-bottom:10px}:host .main-btn{background:transparent;border:1px solid var(--main-color, orange);color:#444;font-weight:600;transition:all .4s ease;min-width:100px;padding:5px 0;margin:0 auto;text-align:center;display:block}:host .main-btn:enabled:hover{background:var(--main-color, orange);color:#fff!important;cursor:pointer}:host .main-btn:disabled{cursor:not-allowed;background:#999;color:#fff;border-color:#999}:host .or-section hr{width:40%;border-top:1px solid #ced4da}:host hr{border-top:1px solid #ced4da}:host button.social{background:transparent;border:2px solid;border-radius:0;width:110px;height:35px;display:flex;align-items:center;justify-content:center}:host button.social.facebook{border-color:#29487d;transition:all .4s ease;cursor:pointer}:host button.social.facebook i{color:#29487d;margin:0 5px}:host button.social.google{border-color:#dd5347;transition:all .4s ease;cursor:pointer}:host button.social.google i{color:#dd5347;margin:0 5px}:host button.social.facebook:hover{background:#29487d;color:#fff}:host button.social.facebook:hover i{color:#fff}:host button.social.google:hover{background:#dd5347;color:#fff}:host button.social.google:hover i{color:#fff}:host .form-control{box-shadow:none}:host .form-control.ng-invalid.ng-touched{border-color:#bd2130}:host .validation-text{font-size:14px;color:#bd2130;position:relative;top:-10px;margin-top:15px}:host .validation-text span{display:block}:host .not-member{display:flex;justify-content:center;align-items:center;margin-top:10px}:host .page-container>.row{min-height:100%}:host .sign-up-accounts-form-content{font-size:1.3rem}@media all and (max-width: 767.98px){:host .sign-up-accounts-form-content{position:static;transform:none;width:auto;max-width:400px;margin:30px auto 0}}:host .form-group{margin:0}:host input{height:3.5rem;padding:0 10px;font-size:1.25rem}:host label{margin-bottom:0}:host .phone-country-selector ::ng-deep .ng-placeholder{font-size:12px}:host .phone-country-selector ::ng-deep .ng-select.ng-select-focused.ng-touched.ng-dirty.ng-invalid>.ng-select-container{border:1px solid red}:host .phone-country-selector .ng-touched.ng-dirty.ng-invalid:not(form){border:1px solid red}:host .phoneNumber{display:flex;align-items:center;justify-content:flex-start}:host .phoneNumber ::ng-deep .ng-select.ng-select-single .ng-select-container{border:1px solid #acacac;height:36px!important;box-shadow:none;min-width:80px}:host #phoneNumberInput{width:100%}:host .editVerfyLink{right:0px!important;left:auto!important}[dir=rtl] :host .editVerfyLink{left:0px!important;right:auto!important}:host .checkmark{margin-top:5px;display:inline-block;width:22px;height:22px;transform:rotate(45deg)}:host .checkmark_circle{position:absolute;width:22px;height:22px;background-color:green;border-radius:11px;left:0}:host .checkmark_stem{position:absolute;width:3px;height:9px;background-color:#fff;left:11px;top:6px}:host .checkmark_kick{position:absolute;width:3px;height:3px;background-color:#fff;left:8px;top:12px}select{width:100%;height:35px;border:unset}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SignUpBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-sign-up',
                    templateUrl: './sign-up.base-component.html',
                    styleUrls: ['./sign-up.base-component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i1$1.FormBuilder }, { type: LoginService }, { type: LanguageService }, { type: ConfService }, { type: i2.Router }, { type: i3$1.ToastrService }, { type: CheckoutService }, { type: PersonalInfoService }, { type: ContactUsService }]; } });

class BreadcrumbBaseComponent {
    constructor(bcService, router, languageService, shopService, confService) {
        this.bcService = bcService;
        this.router = router;
        this.languageService = languageService;
        this.shopService = shopService;
        this.confService = confService;
        this.urlBreadcrumbs = [];
        this.ServiceBreadcrumbs = null;
        this.home = {
            name: 'home',
            url: {
                path: ['/'],
                params: {}
            }
        };
        this.language = {};
        this.exceptions = [
            'ar_EG',
            'en_US',
            'checkout',
            'product',
            'wish-list',
            'compare',
            'dashboard', 'order-history', 'addresses-book'
        ];
        this.taxonImage = '';
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            this.home.name = this.language['home'];
            this.readUrl();
        });
        this.bcService.getCustom().subscribe(data => {
            this.ServiceBreadcrumbs = data;
            this.setBreadcrumb();
        });
        this.bcService.getBackground().subscribe(image => {
            this.taxonImage = image;
        });
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.readUrl();
        });
        setTimeout(() => {
            this.category = localStorage.getItem('product-category');
            console.log(this.category);
        }, 3000);
    }
    setBreadcrumb() {
        if ((this.ServiceBreadcrumbs && this.ServiceBreadcrumbs.length > 0)) {
            // custom breadcrumb
            const items = this.ServiceBreadcrumbs.slice();
            this.breadcrumbs = [this.home, ...items];
            if (this.breadcrumbs.length === 4 && this.id === 12058) {
                this.breadcrumbs.splice(1, 1);
            }
            return;
        }
        if (this.urlBreadcrumbs.length === 0) {
            // no breadcrumb
            this.breadcrumbs = [];
            return;
        }
        // this.breadcrumbs = [this.home, ...this.urlBreadcrumbs];
    }
    readUrl() {
        const urlArray = location.pathname.split('/');
        const routerBreadcrumb = urlArray[urlArray.length - 1];
        if (this.exceptions.indexOf(routerBreadcrumb) === -1) {
            this.urlBreadcrumbs = [{
                    name: this.language[routerBreadcrumb] || routerBreadcrumb,
                    url: {
                        path: [location.pathname],
                        params: {}
                    }
                }];
            this.setBreadcrumb();
        }
        else {
            this.urlBreadcrumbs = [];
            this.setBreadcrumb();
        }
    }
}
BreadcrumbBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BreadcrumbBaseComponent, deps: [{ token: BreadcrumbService }, { token: i2.Router }, { token: LanguageService }, { token: ShopService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: BreadcrumbBaseComponent, selector: "app-base-breadcrumb", ngImport: i0, template: "<div class=\"page-head\" *ngIf=\"breadcrumbs.length > 0\">\r\n  <div class=\"container\">\r\n    <nav aria-label=\"breadcrumb\">\r\n      <ol class=\"breadcrumb\">\r\n        <li class=\"breadcrumb-item\" *ngFor=\"let breadcrumb of breadcrumbs; let l = last\">\r\n          <a *ngIf=\"breadcrumb.name === 'cart'\" [routerLink]=\"breadcrumb.url.path\"\r\n            [queryParams]=\"breadcrumb.url.params\">{{language['Shopping_Cart']}}</a>\r\n            <a *ngIf=\"breadcrumb.name !== 'cart'\" [routerLink]=\"breadcrumb.url.path\"\r\n              [queryParams]=\"breadcrumb.url.params\">{{ breadcrumb.name }}</a>\r\n        </li>\r\n        <!-- <li class=\"breadcrumb-item\"><a href=\"#\">Library</a></li>\r\n        <li class=\"breadcrumb-item active\" aria-current=\"page\">Data</li> -->\r\n      </ol>\r\n    </nav>\r\n  </div><!--End Container-->\r\n</div><!--End Page-head-->\r\n", styles: [":host .page-head{background-color:#e6e6e6;padding:20px 0}:host .page-head .breadcrumb{background-color:transparent;border:0;margin:auto;padding:0;font-size:1.6rem}:host .page-head .breadcrumb .breadcrumb-item a{color:#000;text-transform:capitalize}:host .page-head .breadcrumb .breadcrumb-item:last-child:not(:first-child) a{font-weight:bold;position:relative}:host .page-head .breadcrumb .breadcrumb-item:last-child:not(:first-child) a:after{position:absolute;content:\"\";bottom:-8px;right:0;width:50%;height:2px;background-color:var(--main-color, orange)}[dir=rtl] :host .page-head .breadcrumb .breadcrumb-item:last-child:not(:first-child) a:after{right:auto;left:0}[dir=rtl] :host .breadcrumb-item+.breadcrumb-item:before{float:right;padding-left:.5rem;color:#6c757d;content:\"/\"}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BreadcrumbBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-breadcrumb',
                    templateUrl: './breadcrumb.base-component.html',
                    styleUrls: ['./breadcrumb.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: BreadcrumbService }, { type: i2.Router }, { type: LanguageService }, { type: ShopService }, { type: ConfService }]; } });

class SpinnerComponent {
    constructor(loaderService) {
        this.loaderService = loaderService;
    }
}
SpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SpinnerComponent, deps: [{ token: LoaderService }], target: i0.ɵɵFactoryTarget.Component });
SpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: SpinnerComponent, selector: "app-spinner", ngImport: i0, template: "<!-- <svg class=\"lds-spinner\" width=\"100px\"  height=\"100px\"  xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" style=\"background: none;\"><g transform=\"rotate(0 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.8250000000000001s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(30 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.75s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(60 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.6749999999999999s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(90 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.6s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(120 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.525s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(150 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.45s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(180 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.375s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(210 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.3s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(240 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.225s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(270 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.15s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(300 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"-0.075s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n  </g><g transform=\"rotate(330 50 50)\">\r\n    <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"3\" height=\"6\" fill=\"#337ab7\">\r\n      <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"0.9s\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\r\n    </rect>\r\n</g></svg> -->\r\n\r\n<div class=\"lds-default\">\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n</div>", styles: [".lds-default{display:inline-block;position:relative;width:64px;height:64px}.lds-default div{position:absolute;width:2px;height:2px;background:#007bff;border-radius:50%;animation:lds-default 1.2s linear infinite}.lds-default div:nth-child(1){animation-delay:0s;top:29px;left:53px}.lds-default div:nth-child(2){animation-delay:-.1s;top:18px;left:50px}.lds-default div:nth-child(3){animation-delay:-.2s;top:9px;left:41px}.lds-default div:nth-child(4){animation-delay:-.3s;top:6px;left:29px}.lds-default div:nth-child(5){animation-delay:-.4s;top:9px;left:18px}.lds-default div:nth-child(6){animation-delay:-.5s;top:18px;left:9px}.lds-default div:nth-child(7){animation-delay:-.6s;top:29px;left:6px}.lds-default div:nth-child(8){animation-delay:-.7s;top:41px;left:9px}.lds-default div:nth-child(9){animation-delay:-.8s;top:50px;left:18px}.lds-default div:nth-child(10){animation-delay:-.9s;top:53px;left:29px}.lds-default div:nth-child(11){animation-delay:-1s;top:50px;left:41px}.lds-default div:nth-child(12){animation-delay:-1.1s;top:41px;left:50px}@keyframes lds-default{0%,20%,80%,to{transform:scale(1)}50%{transform:scale(1.5)}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-spinner',
                    templateUrl: './spinner.component.html',
                    styleUrls: ['./spinner.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LoaderService }]; } });

class NumberDirective {
    constructor(_el) {
        this._el = _el;
    }
    onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
NumberDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NumberDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
NumberDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: NumberDirective, selector: "input[numbersOnly]", host: { listeners: { "input": "onInputChange($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NumberDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[numbersOnly]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onInputChange: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

class CartBaseComponent {
    constructor(languageService, cartService, formBuilder, addressingGuard, router, wishListService, confService, translatePipe, breadcrumbService, toastrService, analyticService, tagManagerService, tiktok) {
        this.languageService = languageService;
        this.cartService = cartService;
        this.formBuilder = formBuilder;
        this.addressingGuard = addressingGuard;
        this.router = router;
        this.wishListService = wishListService;
        this.confService = confService;
        this.translatePipe = translatePipe;
        this.breadcrumbService = breadcrumbService;
        this.toastrService = toastrService;
        this.analyticService = analyticService;
        this.tagManagerService = tagManagerService;
        this.tiktok = tiktok;
        this.language = {};
        this.disabled = false;
        this.alert = false;
        this.quantity = [];
        this.wishListFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.WISH_LIST));
        this.compareFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.COMPARE));
        this.languageUrl = '';
        this.amount = 0;
        this.unitAdjustments = this.cartService.unitAdjustments$;
        this.itemUnAvaliable = false;
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.loading = false;
        this.unitPriceTotal = 0;
        this.itmesAdjustmentsTotal = 0;
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.hidepromo = this.id == StoresName.nilestockId ? false : true;
        this.selfOrder = this.id == StoresName.KFC ? true : false;
    }
    ngOnInit() {
        this.confService.getDefaultCurrency().subscribe(conf => {
            this.defaultCurrency = conf;
        });
        this.couponForm = this.formBuilder.group({
            coupon: ['', Validators.required]
        });
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        this.getCarts();
        this.cartService.outOfStock.subscribe(data => {
            this.itemUnAvaliable = data;
        });
        this.handleBreadcrumb();
        this.confService.storeId.subscribe(response => {
            if (response !== 0) {
                this.getStoreOrderLimit(response);
            }
        });
        this.store$ = this.confService.store$;
    }
    redirectToSelfOrder() {
        this.router.navigate(['/self-ordering']);
    }
    getStoreOrderLimit(id) {
        this.confService.checkStoreOrdersLimit(id).subscribe(response => {
            this.exceededLimit = response.success;
            this.exceedLimitMessage = response.payload.message;
        });
    }
    handleBreadcrumb() {
        const breadCrumbArr = [
            {
                name: 'cart',
                url: {
                    path: ['cart'],
                    params: [],
                },
            },
        ];
        this.breadcrumbService.setCustom(breadCrumbArr);
    }
    changeApiQuantity(item) {
        if (this.quantity[item.id] <= 0) {
            this.loading = false;
            return;
        }
        else if (this.quantity[item.id] >= 4001) {
            this.toastrService.error(`${this.language['MaxquantityMsg']}!`);
            this.loading = false;
            return;
        }
        if (item.variant.limits == false && item.variant.tracked == true) {
            if (item.quantity > item.variant.stock) {
                this.quantity[item.id] = item.variant.stock;
            }
        }
        else if (item.variant.limits && item.quantity > item.variant.maximumChecks) {
            this.quantity[item.id] = item.variant.maximumChecks;
        }
        if (!item.variant.limits && item.variant.tracked && item.variant.channelStocks.WEB.stock < this.quantity[item.id]) {
            this.quantity[item.id] = item.variant.channelStocks.WEB.stock;
        }
        const newItem = Object.assign({}, item);
        newItem.quantity = this.quantity[item.id];
        this.quantity[item.id] = newItem.quantity;
        this.cartService.changeQuantity(newItem);
    }
    removeItem(item) {
        if (confirm(`${this.language['deleteFromCart']
            .replace('PRODUCT_NAME', item ? this.translatePipe.transform(item.variant.product, 'name') : this.language['products'])}`)) {
            this.cartService.removeItem(item);
        }
        return;
    }
    clearCart(items) {
        const orderItems = [];
        items.forEach(item => {
            orderItems.push({ variantCode: item.variant.code, qty: 0 });
        });
        if (confirm(`${this.language['deleteAllcart']}`)) {
            this.cartService.clearCart(orderItems);
        }
    }
    quantityChanged(item) {
        this.loading = true;
        if (item.variant.limits == false && item.variant.tracked == true) {
            if (item.quantity > item.variant.stock) {
                this.quantity[item.id] = item.variant.stock;
            }
        }
        else if (item.variant.limits && item.quantity >= item.variant.maximumChecks) {
            if (item.quantity > item.variant.maximumChecks) {
                this.quantity[item.id] = item.variant.maximumChecks;
                item.quantity = item.variant.maximumChecks;
            }
            else if (item.quantity == item.variant.maximumChecks) {
                this.quantity[item.id] = this.quantity[item.id];
                item.quantity = this.quantity[item.id];
            }
        }
        if (!item.variant.limits && item.variant.tracked && item.quantity > item.variant.channelStocks.WEB.stock) {
            item.quantity = item.variant.channelStocks.WEB.stock;
        }
        this.changeApiQuantity(item);
        this.loading = false;
    }
    applyCoupon() {
        this.cartService.applyCoupon(this.couponForm.value.coupon);
    }
    removeCoupon() {
        this.cartService.removeCoupon(this.couponForm.value.coupon);
    }
    checkLogin() {
        let isChecked;
        this.store$.subscribe((data) => {
            isChecked = data.isCheckLoggedUserToCart;
        });
        const userEmail = localStorage.getItem('user_email');
        const userId = localStorage.getItem('user_id');
        console.log(userId, userEmail);
        if (isChecked == false) {
            this.canOpenCheckout();
        }
        else {
            if (userEmail && userId) {
                this.canOpenCheckout();
            }
            else {
                this.router.navigate(['/accounts/login']);
            }
        }
    }
    canOpenCheckout() {
        const branch = JSON.parse(localStorage.getItem('branch'));
        const branchId = localStorage.getItem('branchId');
        if ((!(branchId && branch && branch.id && branchId)) && this.confService.storeIsMultiLocations.getValue()) {
            this.confService.checkBranchPopup('cart');
            return;
        }
        localStorage.setItem('stepZero', 'true');
        this.inPage = false;
        this.addressingGuard.addressingBehvior.next(true);
        this.cart$.subscribe(cart => {
            for (const item of cart.items) {
                this.tagManagerService.checkoutEventEmitter(cart.items);
                this.analyticService.begainCheckout(item.id, this.translatePipe.transform(item.variant, 'name'), item.total, item.variant.product['main_taxon'], item.variant.product['name'], item.quantity);
                this.tiktok.begainCheckout(item.id, this.translatePipe.transform(item.variant, 'name'), item.total, item.variant.product['main_taxon'], item.variant.product['name'], item.quantity);
                if (cart.items.indexOf(item) === cart.items.length - 1 && this.inPage === false) {
                    this.inPage = true;
                    this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'checkout']);
                }
            }
        });
    }
    toggleWishList(productCode) {
        this.languageUrl = this.router.url.split('/').filter(data => data !== '')[0];
        if (localStorage.getItem('user_firstName') || sessionStorage.getItem('user_firstName')) {
            this.wishListService.toggleWishList(productCode);
        }
        else {
            this.router.navigate(['/', this.languageUrl, 'accounts', 'login']);
        }
    }
    isFav(productCode) {
        return this.wishListService.inWishList(productCode);
    }
    getCarts() {
        this.cart$ = this.cartService.getCart().pipe(tap((cart) => {
            if (cart.promotion_code) {
                this.couponForm.patchValue({
                    coupon: cart.promotion_code
                });
            }
            if (cart.items) {
                this.unitPriceTotal = 0;
                this.itmesAdjustmentsTotal = 0;
                for (const item of cart.items) {
                    this.quantity[item.id] = item.quantity;
                    //unitPriceTotal represents the total price of : item unit price (wich is after discount witch means its different from the Oroiginal price) then multiply it by the quantity
                    this.unitPriceTotal += item.unitPrice * item.quantity;
                    let unitAdjustmentsTotal = 0; //per itme
                    for (const unit of item.units) {
                        unitAdjustmentsTotal += Math.abs(parseInt(unit.adjustmentsTotal));
                    }
                    this.itmesAdjustmentsTotal += unitAdjustmentsTotal; //you can think of it as the total promotion price of all itmes
                    if (item['type']) {
                        const newItems = [];
                        item.units.filter((value, index, self) => {
                            return self.findIndex(v => v.subVariant.id === value.subVariant.id) === index;
                        }).map(ele => {
                            newItems.push(ele);
                        });
                        item.units = newItems;
                    }
                }
                cart.adjustments.forEach(adjustement => {
                    if (adjustement['type'] === 'order_shipping_promotion') {
                        this.amount = adjustement['amount'];
                    }
                    else {
                        this.amount = 0;
                    }
                });
                this.loading = false;
                const branch = JSON.parse(localStorage.getItem('branch'));
                const branchId = localStorage.getItem('branchId');
                if ((!(branchId && branch && branch.id && branchId)) && this.confService.storeIsMultiLocations.getValue()) {
                    this.confService.checkBranchPopup('cart');
                    return;
                }
            }
        }));
    }
    checkBranchDetectction() {
        const branch = JSON.parse(localStorage.getItem('branch'));
        const branchId = localStorage.getItem('branchId');
        if ((!(branchId && branch && branch.id && branchId)) && this.confService.storeIsMultiLocations.getValue()) {
            this.confService.checkBranchPopup('cart');
            return;
        }
    }
    ngOnDestroy() {
        this.breadcrumbService.setBackground(null);
    }
}
CartBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CartBaseComponent, deps: [{ token: LanguageService }, { token: CartService }, { token: i1$1.FormBuilder }, { token: CheckoutMyDetailsGuard }, { token: i2.Router }, { token: WishListService }, { token: ConfService }, { token: TranslatePipe }, { token: BreadcrumbService }, { token: i3$1.ToastrService }, { token: GoogleAnalyticsService }, { token: GoogleTagManagerService }, { token: TiktokPixelService }], target: i0.ɵɵFactoryTarget.Component });
CartBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CartBaseComponent, selector: "app-base-cart", ngImport: i0, template: "<section class=\"cart-page-section\">\r\n  <div class=\"container\">\r\n\r\n\r\n    <div class='loading-spinner' *ngIf=\"loading\">\r\n        <app-spinner></app-spinner>\r\n    </div>\r\n\r\n    <div class=\"cart-page\" *ngIf=\"cart$ | async as cart\">\r\n      <div class=\"cart-content\">\r\n\r\n        <div class=\"alert alert-danger\" *ngIf=\"!exceededLimit\">{{exceedLimitMessage}}</div>\r\n        <div class=\"cart-item-wrap\" *ngIf=\"cart.items?.length > 0 ; else showmessage\">\r\n          <ng-container *ngFor=\"let item of cart.items\">\r\n            <div class=\"alert alert-danger\" *ngIf=\"!item.variant?.stockCheck\">{{language['Remove_Cart_Item']}}</div>\r\n            <div class=\"cart-item\" [ngStyle]=\"{'border-color': !item.variant?.stockCheck? '#f00' : '#dee2e6'}\">\r\n              <div class=\"cart-item-head\">\r\n                <div class=\"cart-item-img\">\r\n                  <div class=\"img\" appImage=\"\" [product]=\"item.variant.product\"></div>\r\n                </div>\r\n                <!--End cart-item-img-->\r\n                <div class=\"cart-item-name\">\r\n                  <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product',item.variant.product | translate: 'slug']\"\r\n                    class=\"cart-title link--custom-body\" title=\"{{item.variant.product | translate: 'name'}}\">\r\n                    {{ item.variant.product | translate: 'name' }}\r\n                  </a>\r\n                  <p class=\"short-desc\" *ngIf=\"item.variant?.sku\">\r\n                    {{item.variant?.sku}}\r\n                  </p>\r\n                  <div>\r\n                    <div *ngIf=\"item.variant?.optionValues?.length > 0\">\r\n                      <p *ngFor=\"let unit of item.variant.optionValues\" class=\"short-desc\">\r\n                        {{ unit | translate: 'name' }}\r\n                      </p>\r\n                    </div>\r\n                    <div *ngIf=\"item['type']\">\r\n                      <p *ngFor=\"let unit of item.units\" class=\"short-desc\">\r\n                        <ng-template *ngIf=\"unit['subVariant']['defaultRequired']; else optional\">\r\n                          {{unit['subVariant'] | translate: 'name'}}\r\n                        </ng-template>\r\n                        <ng-template #optional>\r\n                          {{unit['subVariant'] | translate: 'name'}}\r\n                        </ng-template>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n\r\n                </div>\r\n                <!--End Cart-item-name-->\r\n                <ul class=\"cart-item-action\">\r\n                  <li class=\"text-btn removeItem\" (click)=\"removeItem(item)\">\r\n                    {{language['remove']}}\r\n                    <!-- <span  aria-hidden=\"true\">\u00D7</span> -->\r\n                  </li>\r\n                  <li *ngIf=\"wishListFeature$ | async\" class=\"text-btn wishlistItem\"\r\n                    (click)=\"toggleWishList(item.variant.product.code)\">\r\n                    {{(isFav(item.variant.product.code) |async) ? language['removeFromFavorite'] :\r\n                    language['addToFavorite']}}\r\n                  </li>\r\n                </ul>\r\n                <!--End Cart-item-action-->\r\n              </div>\r\n              <!--End Widget-head-->\r\n              <div class=\"cart-item-content\">\r\n                <div class=\"cart-item-price\">\r\n                  <span class=\"item-price\">{{ item.total / item.quantity / 100 | number}}\r\n                    {{currencyCode}}</span>\r\n                  <span class=\"item-price original-price\" *ngIf=\"((item.unitPrice * item.quantity - item.total)/100) > 0\">\r\n                    {{ item.unitPrice / 100 | number }} {{currencyCode}}\r\n                  </span>\r\n\r\n                  <span class=\"item-price original-price\" *ngIf=\"item.variant.channelPricings.WEB.originalPrice\"\r\n                    style=\"text-decoration: line-through; color: #000\">\r\n                    {{ (item.variant.channelPricings['WEB'].originalPrice)/100 }} {{currencyCode}}\r\n                  </span>\r\n\r\n                  <p *ngIf=\"item.orderPromoAmonut\" class=\"offer-message\">\r\n                    {{language['discount']}} ({{(item.orderPromoAmonut)/100}} {{currencyCode}})\r\n                  </p>\r\n                  <p *ngIf=\"item.taxAmount\" class=\"offer-message\">\r\n                    {{language['taxInclusive']}} ({{(item.taxAmount)/100}} {{currencyCode}})\r\n                  </p>\r\n\r\n                  <!-- For Discounts -->\r\n                  <!-- <p class=\"offer-message\" *ngIf=\"((item.unitPrice * item.quantity - item.total)/100) > 0\">\r\n                    {{language['congratulations_cart']}}  -->\r\n                  <!-- {{(item.unitPrice * item.quantity - item.total) / (item.unitPrice * item.quantity) | percent}} -->\r\n                  <!-- {{((item.unitPrice * item.quantity - item.total)/100) | number}} {{language['egyptianPound']}}\r\n                    {{language['discount']}}\r\n                  </p>-->\r\n                  <!-- For taxes -->\r\n                  <!-- <p class=\"offer-message\" *ngIf=\"((item.unitPrice * item.quantity - item.total)/100) < 0\">\r\n                     {{language['taxInclusive']}} ({{ -((item.unitPrice * item.quantity - item.total)/100)}} {{language['egyptianPound']}})\r\n                  </p> -->\r\n                </div>\r\n\r\n                <div *ngIf=\"!item['type']\" class=\"cart-item-number\">\r\n                  <button class=\"number-down\"\r\n                    (click)=\"(quantity[item.id] == 1) ? quantity[item.id] = 1 : quantity[item.id] = quantity[item.id] - 1; quantityChanged(item)\">\r\n                    <i class=\"fa fa-minus\"></i>\r\n                  </button>\r\n                  <input class=\"form-control cart-count\" numbersOnly [(ngModel)]=\"quantity[item.id]\" title=\"quantity\"\r\n                    type=\"number\" min=\"1\" max=\"4000\" placeholder=\"quantity\" (change)=\"quantityChanged(item)\" (onmouseout)=\"quantityChanged(item)\">\r\n                  <ng-container>\r\n                    <p *ngIf=\"item.variant.channelStocks?.WEB?.stock > 0\" class=\"text-truncate\">\r\n                      {{language['max_quantity']}} {{item.variant.channelStocks?.WEB?.stock}}</p>\r\n                  </ng-container>\r\n                  <button (click)=\"(quantity[item.id] == item.variant.channelStocks.WEB?.stock)\r\n                     ? quantity[item.id] = item.variant.channelStocks.WEB.stock : quantity[item.id]\r\n                     = quantity[item.id] + 1; quantityChanged(item)\" class=\"number-up\"\r\n                    [disabled]=\"item.variant.tracked && quantity[item.id] == item.variant.channelStocks.WEB.stock\">\r\n                    <i class='fa fa-plus'></i>\r\n                  </button>\r\n                </div>\r\n\r\n                <div *ngIf=\"item['type']\" class=\"cart-item-number\">\r\n                  <button class=\"number-down\"\r\n                    (click)=\"(quantity[item.id] == 1) ? quantity[item.id] = 1 : quantity[item.id] = quantity[item.id] - 1; quantityChanged(item)\">\r\n                    <i class=\"fa fa-minus\"></i>\r\n                  </button>\r\n                  <input class=\"form-control cart-count\" numbersOnly [(ngModel)]=\"quantity[item.id]\" title=\"quantity\"\r\n                    type=\"number\" min=\"1\" placeholder=\"quantity\" (change)=\"quantityChanged(item)\">\r\n\r\n                  <button (click)=\"quantity[item.id] = quantity[item.id] + 1; quantityChanged(item)\" class=\"number-up\">\r\n                    <i class='fa fa-plus'></i>\r\n                  </button>\r\n                </div>\r\n                <!--End Crt-item-number-->\r\n                <div class=\"cart-item-total\">\r\n\r\n                  <span class=\"total\">\r\n                    {{language['total']}}:\r\n                  </span>\r\n                  <span class=\"price\">{{ item.total / 100 | number }} {{ currencyCode}}</span>\r\n                </div>\r\n                <!--End Cart-item-total-->\r\n              </div>\r\n              <!--End widget-content-->\r\n            </div>\r\n          </ng-container>\r\n          <!--End widget cart-item-->\r\n\r\n          <div class=\"cart-page-details\">\r\n            <div class=\"white-box promotion\" *ngIf=\"hidepromo\">\r\n              <span>{{language['couponCode']}}</span>\r\n              <form class=\"promote-form\" [formGroup]=\"couponForm\" (submit)=\"applyCoupon()\">\r\n                <input class=\"form-control\" type=\"text\" id=\"coupon-code\" formControlName=\"coupon\"\r\n                  placeholder=\"{{language['couponCode']}}\">\r\n                <button class=\"custom-btn reversed\" type=\"submit\" id=\"coupon-submit\"\r\n                  [disabled]=\"couponForm.invalid\">{{language['apply']}}\r\n                </button>\r\n                <a *ngIf=\"cart.promotion_code\" class=\"\" id=\"coupon-remove\"\r\n                  (click)=\"removeCoupon()\">{{language['remove']}}\r\n                </a>\r\n\r\n                <div class=\"delete_promo\" *ngIf=\"cart.promotion_code\">\r\n                  <p>Promo Code : <strong>{{cart.promotion_code}}</strong></p>\r\n                </div>\r\n\r\n              </form>\r\n            </div>\r\n\r\n            <div class=\"white-box\">\r\n              <div class=\"cart-checkout\">\r\n                <div class=\"cart-checkout-item\">\r\n                  <span>{{language['subtotal']}}</span>\r\n                  <span class=\"cart-subtotal\">{{unitPriceTotal / 100 | currency: currencyCode}}</span>\r\n                </div>\r\n                <div class=\"cart-checkout-item\">\r\n                  <span>{{language['promotions']}}</span>\r\n                  <span class=\"cart-subtotal\">{{itmesAdjustmentsTotal / 100 | currency: currencyCode}}</span>\r\n                </div>\r\n\r\n                <div class=\"cart-checkout-item\" *ngFor=\"let adjustment of cart.adjustments\">\r\n                  <ng-container *ngIf=\"adjustment.type !== 'order_shipping_promotion'\">\r\n                    <span>{{(adjustment.type)}}</span>\r\n                    <span class=\"delivery-charge\">{{adjustment.amount / 100 | currency: currencyCode}}</span>\r\n                  </ng-container>\r\n                </div>\r\n\r\n                <!-- <div class=\"cart-checkout-item\">\r\n                    <span>promotion discount</span>\r\n                    <span class=\"promotion-disc\">00.00 EGP</span>\r\n                </div> -->\r\n                <hr>\r\n                <div class=\"cart-checkout-item total-item\">\r\n                  <span>{{language['total']}}</span>\r\n                  <span class=\"cart-total\">{{cart.total / 100 - amount / 100 | currency: currencyCode}}</span>\r\n                </div>\r\n                <hr>\r\n                <!-- min order base on currancy -->\r\n                <div *ngIf=\"cart['disablePurchase']\">\r\n                  <div class=\"empty-item\">\r\n                    <span class=\"help-text\">{{language['disablePurchase']}}</span>\r\n                  </div>\r\n                </div>\r\n                <!-- <ng-container *ngFor=\"let currency of defaultCurrency\">\r\n                  <ng-container *ngIf=\"currency.code === currencyCode\"> -->\r\n                    <p class=\"min_order text-center\"\r\n                      *ngIf=\"defaultCurrency.min_order_amount && defaultCurrency.min_order_amount > cart.itemsTotal / 100\">\r\n                      {{language['min_order']}} {{defaultCurrency.min_order_amount}} {{ defaultCurrency.code}} {{language['you_have']}}\r\n                      {{defaultCurrency.min_order_amount - cart.itemsTotal / 100 | number  :'1.0-2'}} {{ defaultCurrency.code}}\r\n                    </p>\r\n                    <button  *ngIf=\"selfOrder\" class=\"custom-btn reversed\" (click)=\"$event.stopPropagation();redirectToSelfOrder()\"\r\n                      [disabled]=\"defaultCurrency.min_order_amount > cart.total / 100 || cart['disablePurchase'] || itemUnAvaliable\">\r\n                      {{language['checkout']}}\r\n                    </button>\r\n                    <button *ngIf=\"!selfOrder\" class=\"custom-btn reversed\" (click)=\"$event.stopPropagation();checkLogin()\"\r\n                      [disabled]=\"defaultCurrency.min_order_amount > cart.total / 100 || cart['disablePurchase'] || itemUnAvaliable\">\r\n                      {{language['checkout']}}\r\n                    </button>\r\n                  <!-- </ng-container>\r\n                </ng-container> -->\r\n                <!-- min order base on currancy -->\r\n              </div>\r\n            </div>\r\n            <!--End white-box-->\r\n          </div>\r\n          <!--End cart-page-details-->\r\n        </div>\r\n        <!--End item-wrap-->\r\n      </div>\r\n\r\n      <!--End cart-content-->\r\n    </div>\r\n    <!--End Cart-page-->\r\n\r\n\r\n    <ng-template #showmessage>\r\n      <div class=\"empty-item\">\r\n        <i class=\"fa fa-shopping-cart\"></i>\r\n        <span class=\"help-text\">{{language['emptyCart']}}</span>\r\n      </div>\r\n      <div class=\"text-center\">\r\n        <a class=\"custom-btn reversed\" routerLink=\"/collection\">{{language['continueShopping']}}</a>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n  <!--End Container-->\r\n</section>\r\n", styles: [":host .loading-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;display:flex;justify-content:center;align-items:center;z-index:9999;background-color:transparent}:host .cart-page-section{background-color:var(--background-color, #F5F5F5);position:relative;padding:50px 0 30px;min-height:calc(100vh - 200px)}@media (max-width: 768px){:host .cart-page-section{min-height:inherit}}:host .cart-page-section .min_order{font-weight:700;color:red}:host #coupon-remove{margin-left:8px;padding:7px;background:var(--main-color, red);border-radius:3rem;color:var(--secondary-color)}:host .delete_promo{text-align:center;margin-top:20px}:host .white-box.promotion .form-control{border:lightgray solid 1px}:host .cart-item{position:relative;display:flex;justify-content:space-between;align-items:center;border:1.5px solid #dee2e6;background-color:#fff;margin-bottom:30px;border-radius:10px;padding:15px;overflow:hidden;transition:all .35s ease-in-out}:host .cart-item .cart-item-head{position:relative;max-width:50%;flex-basis:50%;padding-right:10px;display:flex;flex-wrap:wrap}[dir=rtl] :host .cart-item .cart-item-head{padding-right:0;padding-left:10px}:host .cart-item .cart-item-head:after{position:absolute;content:\"\";top:0;right:10px;width:1px;height:100%;background:#e2e2e2}[dir=rtl] :host .cart-item .cart-item-head:after{right:auto;left:10px}:host .cart-item .cart-item-head .cart-item-img{height:100px;width:100px;background-color:#ebebeb;border-radius:10px;padding:10px;margin-right:20px;margin-bottom:20px}[dir=rtl] :host .cart-item .cart-item-head .cart-item-img{margin-right:0;margin-left:20px}:host .cart-item .cart-item-head .cart-item-img .img{width:100%;height:100%}:host .cart-item .cart-item-head .cart-item-name{width:70%}:host .cart-item .cart-item-head .cart-item-name .cart-title{display:block;font-size:20px;color:#292929;font-weight:700;text-transform:uppercase;margin-bottom:10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .cart-item .cart-item-head .cart-item-name .short-desc{margin:0;font-size:16px;color:#6b7075;max-width:100%;text-overflow:ellipsis;white-space:nowrap}:host .cart-item .cart-item-head .cart-item-action{max-width:100%;flex-basis:100%;display:flex}:host .cart-item .cart-item-head .cart-item-action .wishlistItem{border-left:1px solid #e2e2e2!important}:host .cart-item .cart-item-head .cart-item-action li{width:-moz-fit-content;width:fit-content;position:relative}:host .cart-item .cart-item-head .cart-item-action .text-btn{background-color:transparent;border:0;text-transform:capitalize;padding:6px 10px;cursor:pointer;transition:all .3s ease-in-out}:host .cart-item .cart-item-head .cart-item-action .text-btn:hover{color:var(--main-color, orange)}:host .cart-item .cart-item-head .cart-item-action .text-btn.removeItem{position:relative}:host .cart-item .cart-item-content{max-width:50%;flex-basis:50%;padding-left:10px}[dir=rtl] :host .cart-item .cart-item-content{padding-left:0;padding-right:10px}:host .cart-item .cart-item-content .cart-item-price .item-price{color:var(--main-color);font-size:1.6rem;font-weight:bold;margin-bottom:10px;display:inline-block}:host .cart-item .cart-item-content .cart-item-price .item-price.original-price{text-decoration:line-through;color:#a3a3a3;margin:0 10px;font-weight:400}:host .cart-item .cart-item-content .cart-item-price .offer-message{color:green;font-size:16px;text-transform:capitalize;margin-bottom:15px}:host .cart-item .cart-item-content .cart-item-number{position:relative;display:inline-block;min-width:130px;max-width:33.33333333%}:host .cart-item .cart-item-content .cart-item-number>button{position:absolute;top:3px;left:3px;width:30px;height:30px;line-height:30px;text-align:center;border-radius:100%;background-color:var(--main-color, orange);color:#fff!important;padding:0;border:0;cursor:pointer;transition:all .3s ease-in-out}:host .cart-item .cart-item-content .cart-item-number>button.number-up{left:auto;right:3px}:host .cart-item .cart-item-content .cart-item-number .form-control{height:36px;border:1px solid #333333;border-radius:40px;text-align:center}:host .cart-item .cart-item-content .cart-item-number .form-control[type=number]::-webkit-inner-spin-button,:host .cart-item .cart-item-content .cart-item-number .form-control[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;margin:0}:host .cart-item .cart-item-content .cart-item-number .form-control[type=number]{-moz-appearance:textfield}:host .cart-item .cart-item-content .cart-item-number .text-truncate{display:none}:host .cart-item .cart-item-content .cart-item-total{display:inline-block;margin:0 0 0 20px}[dir=rtl] :host .cart-item .cart-item-content .cart-item-total{margin:0 2rem 0 0}:host .cart-item .cart-item-content .cart-item-total .total{text-transform:capitalize;font-weight:bold;font-size:16px}:host .cart-item .cart-item-content .cart-item-total .price{color:var(--main-color);font-size:16px;font-weight:900}@media all and (max-width: 991.98px){:host .cart-item .cart-item-head .cart-item-name{width:60%}}@media all and (max-width: 767.98px){:host .cart-item{display:block}:host .cart-item .cart-item-head,:host .cart-item .cart-item-content{max-width:100%;flex-basis:100%;text-align:center}:host .cart-item .cart-item-head{padding:0 0 10px;margin-bottom:10px}:host .cart-item .cart-item-head:after{right:0;top:auto;bottom:-5px;width:100%;height:2px}[dir=rtl] :host .cart-item .cart-item-head:after{right:auto;left:0}}@media all and (max-width: 400px){:host .cart-item .cart-item-head .cart-item-img{margin:0 auto 10px;display:block;width:120px;height:120px}:host .cart-item .cart-item-head .cart-item-name{display:block;width:100%}:host .cart-item .cart-item-content .cart-item-number{display:block;max-width:70%;margin:0 auto 1px}:host .cart-item .cart-item-content .cart-item-total{display:block;margin:0}}:host .white-box{position:relative;background-color:#fff;padding:30px;border-radius:10px;margin-bottom:30px!important}:host .white-box.promotion{display:flex}:host .white-box.promotion span{font-size:24px;color:#323234;text-transform:capitalize;display:inline-block;vertical-align:middle;width:30%}:host .white-box.promotion form{display:inline-block;vertical-align:middle;width:70%}:host .white-box.promotion .form-control{padding:6px 15px;display:inline-block;vertical-align:middle;width:70%;margin:0 30px}:host .white-box.promotion .custom-btn{display:inline-block;vertical-align:middle;background-color:var(--main-color);color:var(--secondary-color)}:host .cart-checkout{text-align:left}[dir=rtl] :host .cart-checkout{text-align:right}:host .cart-checkout .cart-checkout-item{width:50%;margin:0 auto 10px;font-size:23px;text-transform:capitalize;color:#323234}:host .cart-checkout .cart-checkout-item span:last-child{float:right}[dir=rtl] :host .cart-checkout .cart-checkout-item span:last-child{float:left}:host .cart-checkout .cart-checkout-item.total-item{font-weight:700}:host .cart-checkout .custom-btn{display:block;margin:auto;min-width:50%}@media all and (max-width: 991.98px){:host .white-box.promotion .form-control{margin:0 10px 0 0}[dir=rtl] :host .white-box.promotion .form-control{margin:0 0 0 10px}}@media all and (max-width: 767.98px){:host .widget.cart-item{display:block}:host .widget.cart-item .widget-head,:host .widget.cart-item .widget-content{width:100%;text-align:center;flex-flow:column}:host .widget.cart-item .widget-head .widget-img{height:180px}:host .widget.cart-item .widget-head .widget-img img{height:100%}:host .widget.cart-item .widget-content .cart-item-name{max-width:100%;flex-basis:100%;align-self:center;font-size:20px}:host .widget.cart-item .widget-content .cart-item-name .item-price{position:relative}:host .widget.cart-item .widget-content .cart-number{width:150px;margin-bottom:10px;flex-basis:100%;max-width:100%}:host .widget.cart-item .widget-content .cart-item-total{width:auto;margin-bottom:10px}:host .white-box.promotion,:host .white-box.promotion span,:host .white-box.promotion form,:host .white-box.promotion .custom-btn{display:block;width:100%;text-align:center;margin-bottom:5px}:host .white-box.promotion .custom-btn:disabled{background-color:var(--main-color);color:var(--footer-link-color)}:host .white-box.promotion .form-control{display:block;width:100%;text-align:center;margin:0 0 .5rem;border:lightgray 1px solid}[dir=rtl] :host .white-box.promotion .form-control{margin:0 0 .5rem}:host .cart-checkout .cart-checkout-item{width:100%}:host .cart-checkout .custom-btn{min-width:100%}}:host .empty-item{background-color:#fff;margin-bottom:30px;border-radius:10px;text-align:center;padding:20px 10px;border:1px solid var(--main-color, orange)}:host .empty-item i{display:block;font-size:130px;color:var(--main-color-opacity, rgba(251, 201, 0, .59));margin-bottom:10px}@media (max-width: 768px){:host .empty-item i{font-size:90px}}:host .empty-item .help-text{font-size:16px;text-transform:capitalize;font-weight:bold}@media (max-width: 768px){:host .empty-item .help-text{font-size:12px}}:host ul{margin:0;padding:0}:host ul li{list-style:none}.cart-item-number .text-truncate{display:none}\n"], components: [{ type: SpinnerComponent, selector: "app-spinner" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: ImageDirective, selector: "[appImage]", inputs: ["product", "hover"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: NumberDirective, selector: "input[numbersOnly]" }, { type: i1$1.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i1$1.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { type: i1$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }], pipes: { "async": i6.AsyncPipe, "translate": TranslatePipe, "number": i6.DecimalPipe, "currency": i6.CurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CartBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-cart',
                    templateUrl: './cart.base-component.html',
                    styleUrls: ['./cart.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CartService }, { type: i1$1.FormBuilder }, { type: CheckoutMyDetailsGuard }, { type: i2.Router }, { type: WishListService }, { type: ConfService }, { type: TranslatePipe }, { type: BreadcrumbService }, { type: i3$1.ToastrService }, { type: GoogleAnalyticsService }, { type: GoogleTagManagerService }, { type: TiktokPixelService }]; } });

const listStaggerAnimation = trigger('listAnimation', [
    transition('* => *', [
        query(':leave', [
            stagger(100, [
                animate('0.5s', style({ opacity: 0 }))
            ])
        ], { optional: true }),
        query(':enter', [
            style({ opacity: 0 }),
            stagger(100, [
                animate('0.5s', style({ opacity: 1 }))
            ])
        ], { optional: true })
    ])
]);

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class CollectionBaseComponent {
    constructor(languageService, shopService, confService, activatedRoute, router, breadcrumbService, brandsService) {
        this.languageService = languageService;
        this.shopService = shopService;
        this.confService = confService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.breadcrumbService = breadcrumbService;
        this.brandsService = brandsService;
        this.products = [];
        this.loading = true;
        this.language = {};
        this.mobileFilter = false;
        this.sortOptions = [];
        this.page = 1;
        this.showProducts = true;
        this.changeSort = this.shopService.changeSort;
        this.gridClassSubject = this.shopService.gridClassSubject;
        this.isGrid = true;
        this.imageUrl = environment.imageUrl;
    }
    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.mobileFilter = false;
            }
            if (event instanceof NavigationCancel) {
                setTimeout(() => {
                    this.mobileFilter = false;
                }, 2000);
            }
            if (event instanceof NavigationError) {
                setTimeout(() => {
                    this.mobileFilter = false;
                }, 2000);
            }
        });
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            this.imageUrl = environment.imageUrl;
            this.sortOptions = [
                {
                    name: this.language['sort'],
                    sort: '',
                    order: '',
                },
                {
                    name: this.language['alphabeticalAscending'],
                    sort: 'name',
                    order: 'asc',
                },
                {
                    name: this.language['alphabeticalDescending'],
                    sort: 'name',
                    order: 'desc',
                },
                {
                    name: this.language['priceAscending'],
                    sort: 'price',
                    order: 'asc',
                },
                {
                    name: this.language['priceDescending'],
                    sort: 'price',
                    order: 'desc',
                },
                {
                    name: this.language['dateAscending'],
                    sort: 'date',
                    order: 'asc',
                },
                {
                    name: this.language['dateDescending'],
                    sort: 'date',
                    order: 'desc',
                }
            ];
            this.activatedRoute.queryParams.subscribe((params) => {
                this.manageCollection(params);
            });
        });
        this.shopService.pages_count.subscribe(pages_count => {
            this.pages_count = Array(pages_count);
        });
        this.gridClassSubjectSub = this.shopService.gridClassSubject.subscribe(res => {
            this.isGrid = res;
        });
    }
    manageCollection(params) {
        this.params = params;
        if (!this.params['page']) {
            this.page = 1;
        }
        else {
            this.page = +this.params['page'];
        }
        const { utm_content, utm_medium, moon, utm_source, utm_campaign, utm_term, fbclid, utm_id } = params, noUnNeededParams = __rest(params, ["utm_content", "utm_medium", "moon", "utm_source", "utm_campaign", "utm_term", "fbclid", "utm_id"]);
        this.shopService.setParams(params);
        this.products = [];
        this.loading = true;
        if (this.collectionSubscription) {
            this.collectionSubscription.unsubscribe();
        }
        this.collectionSubscription = this.shopService.getCollection(noUnNeededParams).subscribe((data) => {
            this.breadcrumbService.setBackground('/assets/images/banner-default.jpg');
            this.products = data['products'];
            this.productsCount$ = this.shopService.productsCount;
            this.productsCount$.subscribe(data => {
                this.productsCount = data;
            });
            // this.productsCount = this.shopService.productsCount;
            this.loading = false;
            this.showProducts = data['products'].length >= 1;
            if (this.params['taxons'] && this.params['taxons'].length) {
                const selectedTaxonCode = this.params['taxons'].indexOf(',') < 0 ? this.params['taxons'] : null;
                this.shopService.filter.subscribe(taxons => {
                    this.selectedTaxon = this.shopService.getTaxon(selectedTaxonCode, taxons['taxons']);
                    for (const taxon in taxons['taxons']) {
                        if (taxons['taxons'][taxon]['selected']) {
                            for (const i in taxons['taxons'][taxon]['images']) {
                                if (taxons['taxons'][taxon]['images'][i]['type'] === 'collection_page_banner') {
                                    this.breadcrumbService.setBackground(environment.imageUrl + taxons['taxons'][taxon]['images'][i]['path']);
                                    break;
                                }
                                else {
                                    this.breadcrumbService.setBackground('/assets/images/banner-default.jpg');
                                }
                            }
                        }
                        else if (taxons['taxons'][taxon]['children']) {
                            for (const i in taxons['taxons'][taxon]['children']) {
                                if (taxons['taxons'][taxon]['children'][i]['selected']) {
                                    for (const x in taxons['taxons'][taxon]['children'][i]['images']) {
                                        if (taxons['taxons'][taxon]['children'][i]['images'][x]['type'] === 'collection_page_banner') {
                                            this.breadcrumbService.setBackground(environment.imageUrl + taxons['taxons'][taxon]['children'][i]['images'][x]['path']);
                                            break;
                                        }
                                        else {
                                            this.breadcrumbService.setBackground('/assets/images/banner-default.jpg');
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.handleBreadcrumb();
                });
            }
            else {
                this.selectedTaxon = null;
                this.handleBreadcrumb();
            }
            // Get Selected Attribute
            if (this.params['attributes'] && this.params['attributes'].length) {
                const selectedAttribute = this.params['attributes'].indexOf(',') < 0 ? this.params['attributes'] : null;
                const selectedAttributeCode = selectedAttribute ? selectedAttribute.split(':')[1] : null;
                this.brandsService.getBrand(selectedAttributeCode).subscribe(brand => {
                    this.selectedBrand = brand;
                }, err => this.selectedBrand = null);
            }
            else {
                this.selectedBrand = null;
            }
            this.handleBreadcrumb();
            this.moreProductsLoading = false;
        }, () => {
            this.loading = false;
            this.showProducts = false;
        });
    }
    pageChanged(e) {
        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'collection'], { queryParams: { page: e.page }, queryParamsHandling: 'merge' });
    }
    onViewGrid() {
        this.gridClassSubject.next(true);
    }
    onViewList() {
        this.gridClassSubject.next(false);
    }
    handleBreadcrumb() {
        const breadCrumbArr = [
            {
                name: this.selectedTaxon ? this.selectedTaxon.name : this.language['collection'],
                url: {
                    path: ['collection'],
                    params: this.params
                }
            }
        ];
        this.breadcrumbService.setCustom(breadCrumbArr);
    }
    changeCol(cols) {
        this.columns = cols;
    }
    backToPreviousCollection() {
        const searchParamsArr = location.search.split('&');
        const lastParam = searchParamsArr[searchParamsArr.length - 1];
        const latestParamIndex = location.search.indexOf('&' + lastParam);
        const latestsearchParams = location.search.slice(0, latestParamIndex);
        if (location.search.indexOf('&') < 0) {
            this.router.navigateByUrl('/collection');
        }
        else {
            this.router.navigateByUrl('/collection' + latestsearchParams);
        }
    }
    loadMoreProducts() {
        this.isLoadMore = true;
        // show loader spinner
        this.moreProductsLoading = true;
        this.shopService.hasViewMoreBtn.next(true);
        // create new params and set page count
        const newParams = JSON.parse(JSON.stringify(this.params));
        newParams['page'] = (++this.page).toString();
        newParams['return_product'] = 1;
        newParams['return_filter'] = 1;
        const { utm_content, utm_medium, moon, utm_source, utm_campaign, utm_term, fbclid } = newParams, noUnNeededParams = __rest(newParams, ["utm_content", "utm_medium", "moon", "utm_source", "utm_campaign", "utm_term", "fbclid"]);
        // call method with new params generated and receive data
        this.loaded = false;
        this.shopService.getCollection(noUnNeededParams)
            .subscribe((data) => {
            if (this.params['taxons'] && this.params['taxons'].length) {
                const selectedTaxonCode = this.params['taxons'].indexOf(',') < 0 ? this.params['taxons'] : null;
                this.shopService.filter.subscribe(taxons => {
                    this.selectedTaxon = this.shopService.getTaxon(selectedTaxonCode, taxons['taxons']);
                    for (const taxon in taxons['taxons']) {
                        if (taxons['taxons'][taxon]['selected']) {
                            for (const i in taxons['taxons'][taxon]['images']) {
                                if (taxons['taxons'][taxon]['images'][i]['type'] === 'collection_page_banner') {
                                    this.breadcrumbService.setBackground(environment.imageUrl + taxons['taxons'][taxon]['images'][i]['path']);
                                    // this.taxonImage = environment.imageUrl + taxons[taxon].images[i].path;
                                    break;
                                }
                                else {
                                    this.breadcrumbService.setBackground('/assets/images/banner-default.jpg');
                                    // this.taxonImage = '';
                                }
                            }
                        }
                        else if (taxons['taxons'][taxon]['children']) {
                            for (const i in taxons['taxons'][taxon]['children']) {
                                if (taxons['taxons'][taxon]['children'][i]['selected']) {
                                    for (const x in taxons['taxons'][taxon]['children'][i]['images']) {
                                        if (taxons['taxons'][taxon]['children'][i]['images'][x]['type'] === 'collection_page_banner') {
                                            this.breadcrumbService.setBackground(environment.imageUrl + taxons['taxons'][taxon]['children'][i]['images'][x]['path']);
                                            break;
                                        }
                                        else {
                                            this.breadcrumbService.setBackground('/assets/images/banner-default.jpg');
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }
            else {
                this.selectedTaxon = null;
            }
            this.products.push(...data['products']);
            this.moreProductsLoading = data['products'].length <= 0;
            this.loaded = true;
            this.pageChanged({ page: newParams['page'] });
        }, () => {
            this.moreProductsLoading = false;
            this.loaded = true;
        });
    }
    toTop() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
    ngOnDestroy() {
        if (this.collectionSubscription) {
            this.collectionSubscription.unsubscribe();
        }
        if (this.gridClassSubjectSub) {
            this.gridClassSubjectSub.unsubscribe();
        }
        this.breadcrumbService.setBackground(null);
    }
}
CollectionBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CollectionBaseComponent, deps: [{ token: LanguageService }, { token: ShopService }, { token: ConfService }, { token: i2.ActivatedRoute }, { token: i2.Router }, { token: BreadcrumbService }, { token: BrandsService }], target: i0.ɵɵFactoryTarget.Component });
CollectionBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CollectionBaseComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true, animations: [
        listStaggerAnimation
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CollectionBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    animations: [
                        listStaggerAnimation
                    ],
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ShopService }, { type: ConfService }, { type: i2.ActivatedRoute }, { type: i2.Router }, { type: BreadcrumbService }, { type: BrandsService }]; } });

class TaxonBaseComponent {
    constructor(languageService, shopService) {
        this.languageService = languageService;
        this.shopService = shopService;
        this.language = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
    }
}
TaxonBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TaxonBaseComponent, deps: [{ token: LanguageService }, { token: ShopService }], target: i0.ɵɵFactoryTarget.Component });
TaxonBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: TaxonBaseComponent, selector: "app-base-taxon", inputs: { taxons: "taxons" }, ngImport: i0, template: "<div class=\"category-container \">\r\n  <label *ngFor=\"let taxon of taxons\" class=\"custom-checkbox\" [ngClass]=\"{'d-none': taxon.count < 1 }\">\r\n    <input type=\"checkbox\" name=\"category\" (change)=\"shopService.changeTaxon(taxon.code, $event.target.checked)\"\r\n      [checked]=\"taxon.selected\">\r\n    <span class=\"title\">{{taxon.name}}</span>\r\n    <span class=\"label-number\">({{taxon.count}})</span>\r\n    <span class=\"icon\">\r\n      <i class=\"fa fa-check\"></i>\r\n    </span>\r\n    <app-base-taxon [taxons]=\"taxon.children\"></app-base-taxon>\r\n  </label>\r\n</div>\r\n", styles: ["@charset \"UTF-8\";:host .filter{padding-left:0;background-color:#fff;padding-right:20px}[dir=rtl] :host .filter{padding-right:0;padding-left:20px;text-align:right}:host .filter .btn-filter{width:99%;background-color:#09f;margin-bottom:20px}:host .side-filter .side-filter-content{padding:0 1rem}:host .side-filter .side-item{position:relative;border-bottom:1px solid #adadad;margin-bottom:15px;padding-bottom:15px}:host .side-filter .side-item:last-child{border-bottom:0}:host .side-filter .side-item .side-item-head .side-item-name{text-transform:capitalize;font-size:2.2rem}:host .side-filter .side-item .side-item-head.accordionBtn{position:relative;cursor:pointer;transition:all .3s ease-in-out}:host .side-filter .side-item .side-item-head.accordionBtn:hover{color:#09f}:host .side-filter .side-item .side-item-head.accordionBtn:after{position:absolute;content:\"\\f067\";font-family:\"FontAwesome\";top:5px;right:0;color:#09f;font-size:1.8rem;transition:all .3s ease-in-out}[dir=rtl] :host .side-filter .side-item .side-item-head.accordionBtn:after{right:auto;left:0}:host .side-filter .side-item .side-item-head.accordionBtn~.side-item-content{max-height:0;overflow:hidden;transition:max-height .3s ease-in-out}:host .side-filter .side-item .side-item-head.accordionBtn.opened:after{content:\"\\f068\"}:host .side-filter .side-item .side-item-head.accordionBtn.opened~.side-item-content{max-height:290px;overflow:hidden;overflow-y:auto}:host .side-filter .side-item .side-item-content .price-range{display:flex;justify-content:space-between}:host .side-filter .side-item .side-item-content .price-range span{font-weight:bold}:host .side-filter .side-item .side-item-content .btn-filter{position:absolute;right:0;top:0;border:1px solid var(--main-second-color, #ffffff);background-color:var(--main-color, orange);border-radius:2px;color:var(--main-second-color, #ffffff);padding:3px 10px;text-transform:capitalize;font-size:1.4rem;cursor:pointer;transition:all .3s ease-in-out}:host .side-filter .side-item .side-item-content .btn-filter:hover{background-color:var(--main-second-color, #ffffff);color:var(--main-color, orange)}[dir=rtl] :host .side-filter .side-item .side-item-content .btn-filter{right:auto;left:0;position:unset;margin-top:2rem}:host .custom-checkbox{position:relative;display:block;text-transform:capitalize;margin-bottom:10px;font-size:1.6rem;padding-left:26px;cursor:pointer;transition:all .3s ease-in-out}[dir=rtl] :host .custom-checkbox{padding-left:0;padding-right:26px}:host .custom-checkbox input[type=radio],:host .custom-checkbox input[type=checkbox]{position:absolute;width:0;height:0;opacity:0}:host .custom-checkbox input[type=radio]:checked~span.title,:host .custom-checkbox input[type=checkbox]:checked~span.title{color:#090909;font-weight:bold}:host .custom-checkbox input[type=radio]:checked~span.icon,:host .custom-checkbox input[type=checkbox]:checked~span.icon{border-color:transparent;background-color:var(--main-color, orange);color:var(--main-second-color, #ffffff)}:host .custom-checkbox input[type=radio]:checked~span.icon i,:host .custom-checkbox input[type=checkbox]:checked~span.icon i{display:block;width:100%}:host .custom-checkbox span.icon{display:inline-flex;position:absolute;left:0;top:3px;width:18px;height:18px;line-height:18px;text-align:center;background-color:var(--background-color, #F5F5F5);color:var(--main-color, orange);border:1.5px solid #dfdddd;border-radius:2px;font-size:1.4rem}[dir=rtl] :host .custom-checkbox span.icon{left:0;right:0}:host .custom-checkbox span.icon i{display:none}:host .custom-checkbox.with-img .title.img{background-size:contain;width:30px;height:30px;display:inline-block;vertical-align:middle;margin-right:10px}[dir=rtl] :host .custom-checkbox.with-img .title.img{margin-right:auto;margin-left:10px}:host .fa-star{color:#ffc107}:host .fa-star.empty{color:gray}::ng-deep nouislider{margin:20px 0!important;padding:0 10px!important}::ng-deep .noUi-horizontal{height:7px}::ng-deep .noUi-connect{background:var(--main-second-color, #ffffff)}::ng-deep .noUi-horizontal .noUi-handle{width:25px;height:25px;border-radius:100%;border:4px solid var(--main-second-color, #ffffff);background-color:var(--main-color, orange);right:-10px;top:-10px;cursor:pointer}::ng-deep .filter #slider-range .noUi-connect{background-color:var(--main-second-color, #ffffff)}::ng-deep html:not([dir=rtl]) .noUi-horizontal .noUi-handle{right:-10px}::ng-deep .noUi-handle:after,::ng-deep .noUi-handle:before,::ng-deep .noUi-handle:after,::ng-deep .noUi-handle:after{display:none}:host{display:block;margin-top:15px}:host .label-number{margin:0 5px}\n"], components: [{ type: TaxonBaseComponent, selector: "app-base-taxon", inputs: ["taxons"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TaxonBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-taxon',
                    templateUrl: './taxon.base-component.html',
                    styleUrls: ['./taxon.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ShopService }]; }, propDecorators: { taxons: [{
                type: Input
            }] } });

class AccordionDirective {
    constructor(el) {
        this.el = el;
        this.opened = false;
    }
    ngOnInit() {
        this.clicked();
    }
    clicked() {
        if (this.opened) {
            this.el.nativeElement.classList.add('opened');
        }
        else {
            this.el.nativeElement.classList.remove('opened');
        }
        this.opened = !this.opened;
    }
}
AccordionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AccordionDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
AccordionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: AccordionDirective, selector: "[appAccordion]", inputs: { opened: "opened" }, host: { listeners: { "click": "clicked()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AccordionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appAccordion]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { opened: [{
                type: Input
            }], clicked: [{
                type: HostListener,
                args: ['click']
            }] } });

class FilterBaseComponent {
    constructor(languageService, shopService, collectionService, confService, meta, translatePipe, route, router) {
        this.languageService = languageService;
        this.shopService = shopService;
        this.collectionService = collectionService;
        this.confService = confService;
        this.meta = meta;
        this.translatePipe = translatePipe;
        this.route = route;
        this.router = router;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.someRange = [75, 300];
        this.language = {};
        this.stars = [1, 2, 3, 4, 5];
        this.rates = [0, 1, 2, 3, 4, 5];
        this.params$ = this.shopService.params$;
        this.advancedFiltersFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.ADVANCED_FILTERS));
        this.reviewsFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.REVIEWS));
        this.imageUrl = environment.imageUrl;
        this.filteredTaxons$ = new EventEmitter();
        this.randomDiscounted = [];
        this.stores = {
            oda: 11905
        };
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.getHomePageProducts();
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            this.imageUrl = environment.imageUrl;
        });
        if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
        }
        this.filterSubscription = this.shopService.filter.subscribe(filter => {
            this.filter = filter;
            this.filteredTaxons$.emit(filter);
            if (filter) {
                const children = filter.taxons;
                const taxonsChildren = [];
                children.forEach(child => {
                    const _1Children = child['children'];
                    if (_1Children) {
                        _1Children.forEach(_1child => {
                            taxonsChildren.push(_1child);
                            if (_1child['children']) {
                                _1child['children'].forEach(_2child => {
                                    taxonsChildren.push(_2child);
                                    if (_2child['children']) {
                                        _2child['children'].forEach(_3child => {
                                            taxonsChildren.push(_3child);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
                const allTaxons = filter.taxons.concat(...taxonsChildren);
                let selectedTaxonCode;
                this.route.queryParams.subscribe(taxon => selectedTaxonCode = taxon['taxons']);
                if (selectedTaxonCode) {
                    selectedTaxonCode = selectedTaxonCode.indexOf(',') > -1 ? selectedTaxonCode.split(',')[0] : selectedTaxonCode;
                }
                this.selectedTaxon = allTaxons.find(taxon => taxon.code === selectedTaxonCode);
                //  Add Meta Tags
                if (this.selectedTaxon) {
                    if (this.meta.getTag('name="keywords"')) {
                        this.meta.updateTag({ name: 'keywords', content: this.selectedTaxon.meta_keywords });
                    }
                    else {
                        this.meta.addTag({ name: 'keywords', content: this.selectedTaxon.meta_keywords });
                    }
                    if (this.meta.getTag('name="description"')) {
                        this.meta.updateTag({ name: 'description', content: this.selectedTaxon.meta_description });
                    }
                    else {
                        this.meta.addTag({ name: 'description', content: this.selectedTaxon.meta_description });
                    }
                }
            }
            if (this.shopService.params && this.shopService.params['price']) {
                const split = this.shopService.params['price'].split(':');
                this.someRange = [split[0] / 100, split[1] / 100];
            }
            else {
                if (this.filter && this.filter.price_range) {
                    this.someRange = [this.filter.price_range.min / 100, this.filter.price_range.max / 100];
                }
                else {
                    this.someRange = [0, 0];
                }
            }
        });
        this.route.queryParamMap.subscribe(param => {
            this.filteredItemsParams = param['params'];
        });
    }
    changeX(x, value) {
        this.shopService.changeX(x, value);
    }
    changeFilter(options, optionCode, colorCode, addRemove) {
        this.shopService.changeFilter(options, optionCode, colorCode, addRemove);
    }
    clearFilter(paramName) {
        let newParams;
        newParams = Object.assign({}, this.filteredItemsParams);
        delete newParams[paramName];
        newParams['page'] = 1;
        this.shopService.getCollection(newParams);
        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'collection'], { queryParams: newParams });
    }
    getHomePageProducts() {
        this.collectionService.getHomePageProducts().subscribe(res => {
            let randomIndex = Math.floor(Math.random() * res['discounted'].length);
            this.discounted = res['discounted'];
            if (this.discounted.length < 4) {
                this.randomDiscounted = [...this.discounted];
            }
            if (this.discounted.length > 3 && (randomIndex === this.discounted.length - 1 || randomIndex === 0)) {
                randomIndex = 1;
            }
            this.getRandom(randomIndex);
        });
    }
    getRandom(index) {
        this.randomDiscounted = [];
        this.randomDiscounted.push(this.discounted[index]);
        this.randomDiscounted.push(this.discounted[index - 1]);
        this.randomDiscounted.push(this.discounted[index + 1]);
    }
    ngOnDestroy() {
        if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
        }
    }
}
FilterBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FilterBaseComponent, deps: [{ token: LanguageService }, { token: ShopService }, { token: CollectionService }, { token: ConfService }, { token: i3.Meta }, { token: TranslatePipe }, { token: i2.ActivatedRoute }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
FilterBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: FilterBaseComponent, selector: "app-base-filter", outputs: { filteredTaxons$: "filteredTaxons$" }, ngImport: i0, template: "<!-- Side filter-->\r\n<div class=\"side-filter\" *ngIf=\"filter && filter.taxons\">\r\n  <!--  Side fiter heading -->\r\n  <div class=\"side-filter-head\">\r\n    <div [ngClass]=\"{'d-none': !mobileFilter}\" class=\"d-md-none hide-filter-button\" (click)=\"mobileFilter = false\">\r\n      <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\r\n    </div>\r\n  </div>\r\n  <!-- Side filter content\r\n  ====================================== -->\r\n  <div class=\"side-filter-content\">\r\n    <div class=\"side-item\">\r\n      <div class=\"side-item-head accordionBtn\" appAccordion [opened]=\"true\">\r\n        <h3 class=\"side-item-name filter-by-category\">{{language['category']}}</h3>\r\n      </div>\r\n      <!-- Filter by [taxons] -->\r\n      <div class=\"side-item-content\">\r\n        <app-base-taxon [taxons]=\"filter.taxons\"></app-base-taxon>\r\n      </div>\r\n    </div>\r\n    <!-- Advanced filter -->\r\n    <div class=\"advanced-filter\" *ngIf=\"advancedFiltersFeature$ | async\">\r\n\r\n      <!-- Filter by [price]\r\n      ============================== -->\r\n      <div class=\"side-item\"\r\n        *ngIf=\"this.filter.price_range && this.filter.price_range.min !== this.filter.price_range.max\">\r\n        <div class=\"side-item-head d-flex justify-content-between\">\r\n          <span class=\"side-item-name filter-by-price\">{{language['filterBy']}} {{language['price']}}</span>\r\n          <!-- Apply filter by [price] btn -->\r\n          <button class=\"btn-filter\" (click)=\"changeX('price', someRange[0] * 100 + ':' + someRange[1] * 100)\">\r\n            {{language['filter']}}\r\n          </button>\r\n        </div>\r\n        <div class=\"side-item-content\">\r\n          <!-- Price range slider -->\r\n          <div id=\"slider-range\" *ngIf=\"language['DIR']\">\r\n            <nouislider [config]=\"{direction: language['DIR']}\" [connect]=\"true\"\r\n              [min]=\"(this.filter?.defaultPriceRange?.min) ? this.filter.defaultPriceRange.min / 100 : this.filter.price_range.min / 100\" [max]=\"(this.filter?.defaultPriceRange?.max)?(this.filter.defaultPriceRange.max / 100) + 1 : this.filter.price_range.max / 100\"\r\n              [(ngModel)]=\"someRange\" [step]=\"1\">\r\n            </nouislider>\r\n          </div>\r\n          <!-- Price range values -->\r\n          <div class=\"price-range\">\r\n            <span>{{someRange[0] | currency: currencyCode}}</span>\r\n\r\n            <span>{{someRange[1] | currency: currencyCode}}</span>\r\n          </div>\r\n        </div>\r\n        <!--End side-item-content-->\r\n      </div>\r\n      <!--End side-item-->\r\n\r\n      <!-- Filter by [Options] (Colors , text or thumbnails)\r\n      ===================================================== -->\r\n      <ng-container *ngFor=\"let option of filter.options\">\r\n        <div class=\"side-item\" *ngIf=\"option.code === 'color'\">\r\n          <div class=\"side-item-head accordionBtn\" appAccordion>\r\n            <h3 class=\"side-item-name filter-by-option-color\">\r\n              {{language['color']}}\r\n            </h3>\r\n          </div>\r\n          <div class=\"side-item-content\">\r\n            <label *ngFor=\"let color of option.option_values\" class=\"custom-checkbox\">\r\n              <input type=\"checkbox\" [name]=\"option.code\" [value]=\"color.code\" [checked]=\"color.selected\"\r\n                (change)=\"changeFilter('options', option.code, color.code, $event.target.checked)\">\r\n              <div class=\"title\" [ngStyle]=\"{'background': color.name, 'width': '24px', 'height': '17px'}\"></div>\r\n              <span class=\"icon\" style=\"top: 0\"><i class=\"fa fa-check\"></i></span>\r\n            </label>\r\n          </div>\r\n          <!-- <div class=\"side-item-content\">\r\n            <label *ngFor=\"let color of option.option_values\" class=\"custom-checkbox\" [ngClass]=\"{'d-none': color.count < 1 }\">\r\n              <input type=\"checkbox\" name=\"option.code\" value=\"color.code\" [checked]=\"color.selected\" (change)=\"changeFilter('options', option.code, color.code, $event.target.checked)\">\r\n              <span class=\"title\" [ngStyle]=\"{background: color.name}\"></span>\r\n              <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n            </label>\r\n          </div> -->\r\n          <!--End side-item-content-->\r\n        </div>\r\n        <!--End Side-item-->\r\n\r\n        <div class=\"side-item\" *ngIf=\"option.code !== 'color'\">\r\n          <div *ngIf=\"!option.view_as_thumbnail; else viewThumbnail\">\r\n            <div class=\"side-item-head accordionBtn\" appAccordion>\r\n              <h3 class=\"side-item-name filter-by-option\">{{option.name}}</h3>\r\n            </div>\r\n            <div class=\"side-item-content\">\r\n              <label *ngFor=\"let optionValue of option.option_values\" class=\"custom-checkbox\">\r\n                <input type=\"checkbox\" [name]=\"option.code\" [value]=\"optionValue.code\" [checked]=\"optionValue.selected\"\r\n                  (change)=\"changeFilter('options', option.code, optionValue.code, $event.target.checked)\">\r\n                <span class=\"title\"> {{optionValue.name}} ({{optionValue.count}})</span>\r\n                <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n              </label>\r\n            </div>\r\n            <!--End side-item-content-->\r\n          </div>\r\n\r\n          <!-- If View-as-Thumbnials is true-->\r\n          <ng-template #viewThumbnail>\r\n            <div class=\"side-item-head accordionBtn\" appAccordion>\r\n              <h3 class=\"side-item-name filter-by-option-color\">\r\n                {{option.name}}\r\n              </h3>\r\n            </div>\r\n            <div class=\"side-item-content\">\r\n              <label *ngFor=\"let o of option.option_values\" class=\"custom-checkbox with-img\">\r\n                <input type=\"checkbox\" [name]=\"option.code\" [value]=\"o.code\" [checked]=\"o.selected\"\r\n                  (change)=\"changeFilter('options', o.code, o.code, $event.target.checked)\">\r\n                <div [class.img]=\"o?.thumbnail\" class=\"title \"\r\n                  [ngStyle]=\"{'background-image':  'url(' + imageUrl + o?.thumbnail  + ')'}\">\r\n                  {{ o?.thumbnail ? '':o.name}}</div>\r\n                <span class=\"icon\" style=\"top: 0\"><i class=\"fa fa-check\"></i></span>\r\n              </label>\r\n            </div>\r\n            <!--End side-item-content-->\r\n          </ng-template>\r\n        </div>\r\n        <!--End Side-item-->\r\n      </ng-container>\r\n\r\n\r\n      <!-- Filter by [attributes] (Colors , text or thumbnails)\r\n      ========================================================== -->\r\n      <ng-container *ngFor=\"let attribute of filter.attribute\">\r\n        <!-- radio box style -->\r\n        <div class=\"side-item\">\r\n          <div class=\"side-item-head accordionBtn\" appAccordion>\r\n            <h3 class=\"side-item-name filter-by-attribute\">{{attribute.name}}</h3>\r\n          </div>\r\n          <div class=\"side-item-content\" *ngIf=\"!attribute.view_as_thumbnail; else attributeViewThumbnail\">\r\n            <label *ngFor=\"let attributeValue of attribute.values\" class=\"custom-checkbox\">\r\n              <span class=\"title\">{{attributeValue.name.name}} ({{attributeValue.count}})</span>\r\n              <input type=\"checkbox\" [name]=\"attribute.code\" [value]=\"attributeValue.code\"\r\n                [checked]=\"attributeValue.selected\"\r\n                (change)=\"changeFilter('attributes', attribute.code, attributeValue.code, $event.target.checked)\">\r\n              <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n            </label>\r\n          </div>\r\n          <!-- If View-as-Thumbnials is true-->\r\n          <ng-template #attributeViewThumbnail>\r\n            <div class=\"side-item-content\">\r\n              <label *ngFor=\"let attributeValue of attribute.values\" class=\"custom-checkbox with-img\">\r\n                <input type=\"checkbox\" [name]=\"attribute.code\" [value]=\"attributeValue.code\"\r\n                  [checked]=\"attributeValue.selected\"\r\n                  (change)=\"changeFilter('attributes', attribute.code, attributeValue.code, $event.target.checked)\">\r\n                <div [class.img]=\"attributeValue?.thumbnail\" class=\"title \"\r\n                  [ngStyle]=\"{'background-image':  'url(' + imageUrl + attributeValue?.thumbnail  + ')'}\">\r\n                  {{ attributeValue?.thumbnail ? '': attributeValue.name.name }}\r\n                </div>\r\n                <!-- <span class=\"count\"> ({{attributeValue.count}})</span> -->\r\n                <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n              </label>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n        <!--End Side-item-->\r\n      </ng-container>\r\n\r\n      <!-- Filter by [rate]\r\n      =============================-->\r\n      <div class=\"side-item\" *ngIf=\"id != stores.oda && rates?.length && (reviewsFeature$ | async)\">\r\n        <div class=\"side-item-head accordionBtn\" appAccordion>\r\n          <h3 class=\"side-item-name filter-by-rating\">{{language['rating']}}</h3>\r\n        </div>\r\n        <!--End Side-item-head-->\r\n        <div class=\"side-item-content\">\r\n          <label class=\"custom-checkbox\" *ngFor=\"let rate of rates\">\r\n            <ng-container *ngFor=\"let star of stars\" class=\"title\">\r\n              <i *ngIf=\"rate >= star\" class=\"fa fa-star\" aria-hidden=\"true\"></i>\r\n              <i *ngIf=\"rate < star\" class=\"fa fa-star empty\" aria-hidden=\"true\"></i>\r\n            </ng-container>\r\n            <input type=\"radio\" name=\"rating\" (click)=\"changeX('rating', $event.target.checked && rate)\"\r\n              [checked]=\"(params$ | async)?.rating == rate\">\r\n            <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n          </label>\r\n        </div>\r\n        <!--End Side-item-content-->\r\n      </div>\r\n\r\n      <!-- Features filter (Discounted , Featured , bestSellers and New Arrival)\r\n      ==========================================================================-->\r\n      <div class=\"side-item\"  *ngIf=\"id != stores.oda \">\r\n        <!-- Features filter Title -->\r\n        <div class=\"side-item-head accordionBtn\" appAccordion>\r\n          <h3 class=\"side-item-name filter-by-features\">{{language['features']}}</h3>\r\n        </div>\r\n        <!-- checkbox filter by [features] -->\r\n        <div class=\"side-item-content\">\r\n          <!-- Filter by [discount] -->\r\n          <label class=\"custom-checkbox\">\r\n            <span class=\"title\">\r\n              {{language['discount']}}\r\n            </span>\r\n            <input type=\"checkbox\" name=\"discounted\" value=\"discounted\" [checked]=\"(params$ | async).discounted\"\r\n              (change)=\"changeX('discounted', $event.target.checked)\">\r\n            <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n          </label>\r\n          <!-- Filter by [feature] -->\r\n          <label class=\"custom-checkbox\">\r\n            <span class=\"title\">\r\n              {{language['featuredProducts']}}\r\n            </span>\r\n            <input type=\"checkbox\" name=\"featured\" value=\"featured\" [checked]=\"(params$ | async).featured\"\r\n              (change)=\"changeX('featured', $event.target.checked)\">\r\n            <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n          </label>\r\n          <!-- Filter by [best seller] -->\r\n          <label class=\"custom-checkbox\">\r\n            <span class=\"title\">\r\n              {{language['bestSellers']}}\r\n            </span>\r\n            <input type=\"checkbox\" name=\"bestseller\" value=\"bestseller\" [checked]=\"(params$ | async).bestseller\"\r\n              (change)=\"changeX('bestseller', $event.target.checked)\">\r\n            <span class=\"icon\"><i class=\"fa fa-check\"></i></span>\r\n          </label>\r\n          <!-- Filter by [new products] -->\r\n          <label class=\"custom-checkbox\">\r\n            <span class=\"title\">{{language['new']}}</span>\r\n            <input type=\"checkbox\" name=\"new\" value=\"new\" [checked]=\"(params$ | async).new\"\r\n              (change)=\"changeX('new', $event.target.checked)\">\r\n            <span class=\"icon\">\r\n              <i class=\"fa fa-check\"></i>\r\n            </span>\r\n          </label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["@charset \"UTF-8\";:host .filter{padding-left:0;background-color:#fff;padding-right:20px}[dir=rtl] :host .filter{padding-right:0;padding-left:20px;text-align:right}:host .filter .btn-filter{width:99%;background-color:#09f;margin-bottom:20px}:host .side-filter .side-filter-content{padding:0 1rem}:host .side-filter .side-item{position:relative;border-bottom:1px solid #adadad;margin-bottom:15px;padding-bottom:15px}:host .side-filter .side-item:last-child{border-bottom:0}:host .side-filter .side-item .side-item-head .side-item-name{text-transform:capitalize;font-size:2.2rem}:host .side-filter .side-item .side-item-head.accordionBtn{position:relative;cursor:pointer;transition:all .3s ease-in-out}:host .side-filter .side-item .side-item-head.accordionBtn:hover{color:#09f}:host .side-filter .side-item .side-item-head.accordionBtn:after{position:absolute;content:\"\\f067\";font-family:\"FontAwesome\";top:5px;right:0;color:#09f;font-size:1.8rem;transition:all .3s ease-in-out}[dir=rtl] :host .side-filter .side-item .side-item-head.accordionBtn:after{right:auto;left:0}:host .side-filter .side-item .side-item-head.accordionBtn~.side-item-content{max-height:0;overflow:hidden;transition:max-height .3s ease-in-out}:host .side-filter .side-item .side-item-head.accordionBtn.opened:after{content:\"\\f068\"}:host .side-filter .side-item .side-item-head.accordionBtn.opened~.side-item-content{max-height:290px;overflow:hidden;overflow-y:auto}:host .side-filter .side-item .side-item-content .price-range{display:flex;justify-content:space-between}:host .side-filter .side-item .side-item-content .price-range span{font-weight:bold}:host .side-filter .side-item .side-item-content .btn-filter{position:absolute;right:0;top:0;border:1px solid var(--main-second-color, #ffffff);background-color:var(--main-color, orange);border-radius:2px;color:var(--main-second-color, #ffffff);padding:3px 10px;text-transform:capitalize;font-size:1.4rem;cursor:pointer;transition:all .3s ease-in-out}:host .side-filter .side-item .side-item-content .btn-filter:hover{background-color:var(--main-second-color, #ffffff);color:var(--main-color, orange)}[dir=rtl] :host .side-filter .side-item .side-item-content .btn-filter{right:auto;left:0;position:unset;margin-top:2rem}:host .custom-checkbox{position:relative;display:block;text-transform:capitalize;margin-bottom:10px;font-size:1.6rem;padding-left:26px;cursor:pointer;transition:all .3s ease-in-out}[dir=rtl] :host .custom-checkbox{padding-left:0;padding-right:26px}:host .custom-checkbox input[type=radio],:host .custom-checkbox input[type=checkbox]{position:absolute;width:0;height:0;opacity:0}:host .custom-checkbox input[type=radio]:checked~span.title,:host .custom-checkbox input[type=checkbox]:checked~span.title{color:#090909;font-weight:bold}:host .custom-checkbox input[type=radio]:checked~span.icon,:host .custom-checkbox input[type=checkbox]:checked~span.icon{border-color:transparent;background-color:var(--main-color, orange);color:var(--main-second-color, #ffffff)}:host .custom-checkbox input[type=radio]:checked~span.icon i,:host .custom-checkbox input[type=checkbox]:checked~span.icon i{display:block;width:100%}:host .custom-checkbox span.icon{display:inline-flex;position:absolute;left:0;top:3px;width:18px;height:18px;line-height:18px;text-align:center;background-color:var(--background-color, #F5F5F5);color:var(--main-color, orange);border:1.5px solid #dfdddd;border-radius:2px;font-size:1.4rem}[dir=rtl] :host .custom-checkbox span.icon{left:0;right:0}:host .custom-checkbox span.icon i{display:none}:host .custom-checkbox.with-img .title.img{background-size:contain;width:30px;height:30px;display:inline-block;vertical-align:middle;margin-right:10px}[dir=rtl] :host .custom-checkbox.with-img .title.img{margin-right:auto;margin-left:10px}:host .fa-star{color:#ffc107}:host .fa-star.empty{color:gray}::ng-deep nouislider{margin:20px 0!important;padding:0 10px!important}::ng-deep .noUi-horizontal{height:7px}::ng-deep .noUi-connect{background:var(--main-second-color, #ffffff)}::ng-deep .noUi-horizontal .noUi-handle{width:25px;height:25px;border-radius:100%;border:4px solid var(--main-second-color, #ffffff);background-color:var(--main-color, orange);right:-10px;top:-10px;cursor:pointer}::ng-deep .filter #slider-range .noUi-connect{background-color:var(--main-second-color, #ffffff)}::ng-deep html:not([dir=rtl]) .noUi-horizontal .noUi-handle{right:-10px}::ng-deep .noUi-handle:after,::ng-deep .noUi-handle:before,::ng-deep .noUi-handle:after,::ng-deep .noUi-handle:after{display:none}\n"], components: [{ type: TaxonBaseComponent, selector: "app-base-taxon", inputs: ["taxons"] }, { type: i6$1.NouisliderComponent, selector: "nouislider", inputs: ["config", "disabled", "behaviour", "connect", "limit", "min", "max", "snap", "animate", "range", "step", "format", "pageSteps", "ngModel", "keyboard", "onKeydown", "formControl", "tooltips"], outputs: ["change", "update", "slide", "set", "start", "end"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: AccordionDirective, selector: "[appAccordion]", inputs: ["opened"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "async": i6.AsyncPipe, "currency": i6.CurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FilterBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-filter',
                    templateUrl: './filter.base-component.html',
                    styleUrls: ['./filter.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ShopService }, { type: CollectionService }, { type: ConfService }, { type: i3.Meta }, { type: TranslatePipe }, { type: i2.ActivatedRoute }, { type: i2.Router }]; }, propDecorators: { filteredTaxons$: [{
                type: Output
            }] } });

class ProductBaseComponent {
    constructor(loginService, languageService, wishListService, compareService, quickViewService, confService, productService, collectionService, router, cartService, analyticService, decimalPipe) {
        this.loginService = loginService;
        this.languageService = languageService;
        this.wishListService = wishListService;
        this.compareService = compareService;
        this.quickViewService = quickViewService;
        this.confService = confService;
        this.productService = productService;
        this.collectionService = collectionService;
        this.router = router;
        this.cartService = cartService;
        this.analyticService = analyticService;
        this.decimalPipe = decimalPipe;
        this.featured = false;
        this.gridClass = true;
        this.defaultImage = environment.defaultImage;
        this.language = {};
        this.modal = false;
        // tslint:disable-next-line: deprecation
        this.fav = Observable.create(false);
        // tslint:disable-next-line: deprecation
        this.compare = Observable.create(false);
        this.imageUrl = environment.imageUrl;
        this.wishListFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.WISH_LIST));
        this.compareFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.COMPARE));
        this.reviewsFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.REVIEWS));
        this.imgIsLoaded = false;
        this.imgSrc = '';
        this.maxRate = 5;
        this.rate = 5;
        this.rates = [0, 1, 2, 3, 4, 5];
        this.languageUrl = '';
        this.canAddToCart = true;
        this.prices = [];
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.storeIdentitySubscription = this.confService.store$.subscribe(store => {
            this.disableOutOfStockVariants = store.disableOutOfStockVariants;
        });
        this.confService.storeId.subscribe((data) => {
            this.storeid = data;
        });
        this.gridClassSubjectSub = this.collectionService.gridClassSubject.subscribe((res) => {
            this.gridClass = res;
        });
        this.rate = this.product.rating;
        this.fav = this.wishListService.inWishList(this.product.code);
        this.compare = this.compareService.inCompare(this.product.code);
        this.languageService.getLanguage().subscribe((language) => this.language = language);
        this.collectionService.filterOptions(this.product);
        this.Mvaraint = this.product.variants[0];
        this.getMinAndMaxPriceofVarient();
        this.getProductImg();
        this.manageVariant(this.Mvaraint);
    }
    buyNow() {
        const variant = this.product.variants[0];
        this.cartService.addToCart(variant, 1, this.product);
        this.cartService.addedToCart.subscribe(data => {
            if (data) {
                console.log(data);
                this.router.navigate([`/${this.language['LANGUAGE_CODE']}/cart`]);
            }
        });
    }
    isLoggedIn() {
        const isChecked = JSON.parse(localStorage.getItem('isCheckLoggedUserToCart'));
        const userEmail = localStorage.getItem('user_email');
        const userId = localStorage.getItem('user_id');
        if (isChecked == false) {
            this.openQuickView();
        }
        else {
            if (userEmail && userId) {
                this.openQuickView();
            }
            else {
                this.loginService.openLoginPopUp();
            }
        }
    }
    getProductImg() {
        this.imgSrc = ProductService.getImage(this.product);
    }
    getMinAndMaxPriceofVarient() {
        for (const variant of this.product.variants) {
            this.prices.push(variant.prices[0].price);
        }
        this.minPrice = Math.min(...this.prices);
        this.maxPrice = Math.max(...this.prices);
    }
    toggleWishList() {
        this.languageUrl = this.router.url.split('/').filter((data) => data !== '')[0];
        if (localStorage.getItem('user_firstName') || sessionStorage.getItem('user_firstName')) {
            this.wishListService.toggleWishList(this.product.code);
        }
        else {
            this.router.navigate(['/', this.languageUrl, 'accounts', 'login']);
        }
    }
    toggleCompare() {
        this.compareService.toggleCompare(this.product.code);
    }
    openQuickViewOnly() {
        this.quickViewService.openQuickViewVisibility();
        this.quickViewService.open(this.product);
    }
    openQuickView() {
        this.quickViewService.openQuickViewVisibility();
        if (!this.product.options || this.product.options && this.product.options.length === 0 && this.canAddToCart) {
            const variant = this.product.variants[0];
            this.cartService.addToCart(variant, 1, this.product);
            this.analyticService.addToCart(this.product.id, this.product.name, variant.prices[0].price, this.product.main_taxon, 1);
            return;
        }
        this.quickViewService.open(this.product);
    }
    ngOnDestroy() {
        this.quickViewService.close();
        if (this.gridClassSubjectSub) {
            this.gridClassSubjectSub.unsubscribe();
        }
    }
    manageVariant(variant) {
        if (variant.tracked === false) {
            // variant isn't tracked
            this.canAddToCart = true;
            return;
        }
        if (variant['stock'] <= 0) {
            // variant doesn't have stock
            this.canAddToCart = false;
            return;
        }
    }
}
ProductBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductBaseComponent, deps: [{ token: LoginService }, { token: LanguageService }, { token: WishListService }, { token: CompareService }, { token: QuickViewService }, { token: ConfService }, { token: ProductService }, { token: CollectionService }, { token: i2.Router }, { token: CartService }, { token: GoogleAnalyticsService }, { token: i6.DecimalPipe }], target: i0.ɵɵFactoryTarget.Component });
ProductBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ProductBaseComponent, selector: "app-base-product", inputs: { product: "product", featured: "featured", gridClass: "gridClass" }, ngImport: i0, template: "<div *ngIf=\"!product.addonsCheck\" [ngClass]=\"[featured ? 'list-view': '' , gridClass ? '' : 'list-view' ]\"\r\n  [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', product | translate: 'slug']\"\r\n  [queryParams]=\"{ variantCode: Mvaraint?.code }\" class=\"widget with-cursor\">\r\n  <div class=\"widget-head\">\r\n    <div class=\"widget-img\">\r\n      <div *ngIf=\"!imgIsLoaded\" class=\"spinner\">\r\n        <app-spinner></app-spinner>\r\n      </div>\r\n      <img class=\"animate-fade\" [lazyLoad]=\"imgSrc\" (load)=\"imgIsLoaded = true\" [errorImage]=\"defaultImage\" [alt]=\"product.name\" />\r\n    </div>\r\n    <div class=\"widget-labels\">\r\n      <ng-container *ngTemplateOutlet=\"labels\"></ng-container>\r\n      <ng-template #labels>\r\n        <span class=\"discount\"\r\n          *ngIf=\"product.discounted && (Mvaraint?.prices[0].original_price > Mvaraint?.prices[0].price) && !product.hidePrice \"\r\n          placement=\"right\" tooltip=\"{{language['discount']}}\">\r\n          {{ (Mvaraint?.prices[0].original_price - Mvaraint?.prices[0].price) / Mvaraint?.prices[0].original_price |\r\n          percent }}\r\n        </span>\r\n        <span class=\"bg-light-green new\" *ngIf=\"product.new\"> {{language['new']}} </span>\r\n        <span class=\"bg-red outOfStock\" *ngIf=\"Mvaraint?.tracked && Mvaraint?.stock == 0\">\r\n          {{language['outOfStock']}}\r\n        </span>\r\n        <span class=\"bg-gray outOfStock\" *ngIf=\"product.limited_quantity\">\r\n          {{language['limited_quantity']}}\r\n        </span>\r\n        <span *ngIf=\"product.bestseller\" class=\"bg-tomato best-sellers\" placement=\"right\"\r\n          tooltip=\"{{language['bestSellers']}}\">\r\n          <i class=\"fa fa-line-chart\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <span *ngIf=\"product.featured\" class=\"featured-product\" placement=\"right\"\r\n          tooltip=\"{{language['featureProduct']}}\">\r\n          <i class=\"fa fa-star\"></i>\r\n        </span>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"widget-icons\">\r\n      <button *ngIf=\"wishListFeature$ | async\" class=\"icon-btn wishlist\" [ngClass]=\"{active: fav | async}\"\r\n        aria-hidden=\"true\" (click)=\"$event.stopPropagation();toggleWishList()\" tooltip=\"{{language['wishList']}}\">\r\n        <i class=\"fa fa-heart\"></i>\r\n      </button>\r\n      <button *ngIf=\"compareFeature$ | async\" class=\"icon-btn compare-list\" [ngClass]=\"{active: compare | async}\"\r\n        aria-hidden=\"true\" tooltip=\"{{language['compare']}}\" (click)=\"$event.stopPropagation();toggleCompare()\">\r\n        <i class=\"fa fa-random\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"widget-content\">\r\n    <div class=\"product-rating\" *ngIf=\"rates?.length && (reviewsFeature$ | async)\">\r\n      <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\"> </rating>\r\n    </div>\r\n    <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', product | translate: 'slug']\"\r\n      [queryParams]=\"{ variantCode: Mvaraint?.code }\" class=\"widget-title\">\r\n      {{product | translate: 'name'}}\r\n    </a>\r\n    <p class=\"product-description\">\r\n      {{ ((product | translate: 'short_description')?.length > 85) ? ((product | translate: 'short_description') |\r\n      slice:0:85) + '...' : ((product | translate: 'short_description')) }}\r\n    </p>\r\n    <div class=\"widget-foot\" *ngIf=\"!product.hidePrice\">\r\n      <div class=\"widget-price product-price\">\r\n        <div class=\"price\" *ngIf=\"maxPrice === minPrice; else fromPrice\">\r\n          <div class=\"price__sale\">{{ Mvaraint?.prices[0].price / 100 | number}} {{currencyCode}}</div>\r\n          <div class=\"price__original price__original--discount\" *ngIf=\"Mvaraint?.prices[0].original_price > 0\">\r\n            {{Mvaraint?.prices[0].original_price / 100 | number}} {{currencyCode}}\r\n          </div>\r\n        </div>\r\n        <ng-template #fromPrice>\r\n          <div class=\"price\">\r\n            <div class=\"price__sale\">{{language['from']}} {{ Mvaraint?.prices[0].price / 100 | number}} {{currencyCode}}</div>\r\n          </div>\r\n          <div class=\"price__original price__original--discount\" *ngIf=\"Mvaraint?.prices[0].original_price > 0\">\r\n            {{Mvaraint?.prices[0].original_price / 100 | number}} {{currencyCode}}\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n      \r\n      <div class=\"text-center\">\r\n        <button (click)=\"openQuickView()\"\r\n          class=\"custom-btn addToCartBtn d-none d-md-block m-auto\">\r\n          {{ language['addToCart']  }}\r\n        </button>\r\n        <!-- <button (click)=\"$event.stopPropagation(); openQuickView()\"\r\n          class=\"custom-btn addToCartBtn d-none d-md-block m-auto\">\r\n          {{ (!product.options || product.options?.length === 0 ) && canAddToCart ? language['addToCart'] :\r\n        language['quickView'] }}\r\n        </button> -->\r\n        <button *ngIf=\"(!product.options || (product.options && product.options.length === 0))\" (click)=\"$event.stopPropagation();openQuickView()\" \r\n         class=\"custom-btn addToCartBtn d-md-none\">\r\n          {{language['addToCart']}}\r\n        </button>\r\n        <button *ngIf=\"!(!product.options || (product.options && product.options.length === 0))\" [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', product | translate: 'slug']\"\r\n        [queryParams]=\"{ variantCode: product.variants[0].code }\" class=\"custom-btn addToCartBtn d-md-none\">\r\n          {{language['viewDetails']}}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"product.addonsCheck\" [ngClass]=\"[featured ? 'list-view': '' , gridClass ? '' : 'list-view' ]\"\r\n  [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product | translate: 'slug']\" class=\"widget with-cursor\">\r\n  <div class=\"widget-head\">\r\n    <div class=\"widget-img\">\r\n      <div *ngIf=\"!imgIsLoaded\" class=\"spinner\">\r\n        <app-spinner></app-spinner>\r\n      </div>\r\n      <img class=\"animate-fade\" [lazyLoad]=\"imgSrc\" (load)=\"imgIsLoaded = true\" [errorImage]=\"defaultImage\" [alt]=\"product.name\" />\r\n    </div>\r\n    <!--End widget-img-->\r\n    <div class=\"widget-labels\">\r\n      <ng-container *ngTemplateOutlet=\"labels\"></ng-container>\r\n      <ng-template #labels>\r\n        <span class=\"discount\"\r\n          *ngIf=\"product.discounted && (Mvaraint?.prices[0].original_price > Mvaraint?.prices[0].price)  \"\r\n          placement=\"right\" tooltip=\"{{language['discount']}}\">\r\n          {{ (Mvaraint?.prices[0].original_price - Mvaraint?.prices[0].price) / Mvaraint?.prices[0].original_price |\r\n          percent }}\r\n        </span>\r\n        <span class=\"bg-light-green new\" *ngIf=\"product.new\"> {{language['new']}} </span>\r\n        <span class=\"bg-red outOfStock\" *ngIf=\"Mvaraint?.tracked && Mvaraint?.stock == 0\">\r\n          {{language['outOfStock']}}\r\n        </span>\r\n        <span *ngIf=\"product.bestseller\" class=\"bg-tomato best-sellers\" placement=\"right\"\r\n          tooltip=\"{{language['bestSellers']}}\">\r\n          <i class=\"fa fa-line-chart\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <span *ngIf=\"product.featured\" class=\"featured-product\" placement=\"right\"\r\n          tooltip=\"{{language['featureProduct']}}\">\r\n          <i class=\"fa fa-star\"></i>\r\n        </span>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"widget-icons\">\r\n      <button *ngIf=\"wishListFeature$ | async\" class=\"icon-btn wishlist\" [ngClass]=\"{active: fav | async}\"\r\n        aria-hidden=\"true\" (click)=\"$event.stopPropagation();toggleWishList()\" tooltip=\"{{language['wishList']}}\">\r\n        <i class=\"fa fa-heart\"></i>\r\n      </button>\r\n      <button *ngIf=\"compareFeature$ | async\" class=\"icon-btn compare-list\" [ngClass]=\"{active: compare | async}\"\r\n        aria-hidden=\"true\" tooltip=\"{{language['compare']}}\" (click)=\"$event.stopPropagation();toggleCompare()\">\r\n        <i class=\"fa fa-random\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"widget-content\">\r\n    <div class=\"product-rating\" *ngIf=\"rates?.length && (reviewsFeature$ | async)\">\r\n      <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\"> </rating>\r\n    </div>\r\n    <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product | translate: 'slug']\" class=\"widget-title\">\r\n      {{product | translate: 'name'}}\r\n    </a>\r\n    <p class=\"product-description\">\r\n      {{ ((product | translate: 'short_description')?.length > 85) ? ((product | translate: 'short_description') |\r\n      slice:0:85) + '...' : ((product | translate: 'short_description')) }}\r\n    </p>\r\n    <div class=\"widget-foot\">\r\n      <div *ngIf=\"(Mvaraint.prices[0].original_price / 100 > 0 ||  Mvaraint.prices[0].price / 100 > 0)else priceOnSelection\">\r\n\r\n      <div class=\"widget-price product-price\"> \r\n        <div class=\"price\" *ngIf=\"maxPrice === minPrice; else fromPrice\">\r\n        <div class=\"price__sale\">{{ Mvaraint?.prices[0].price / 100 | number}} {{currencyCode}}</div>\r\n        <div class=\"price__original price__original--discount\" *ngIf=\"Mvaraint?.prices[0].original_price > 0\">\r\n          {{Mvaraint?.prices[0].original_price / 100 | number}} {{currencyCode}}\r\n        </div>\r\n      </div>\r\n      <ng-template #fromPrice>\r\n        <div class=\"price\">\r\n          <div class=\"price__sale\">{{language['from']}} {{ Mvaraint?.prices[0].price / 100 | number}} {{currencyCode}}</div>\r\n        </div>\r\n        <div class=\"price__original price__original--discount\" *ngIf=\"Mvaraint?.prices[0].original_price > 0\">\r\n          {{Mvaraint?.prices[0].original_price / 100 | number}} {{currencyCode}}\r\n        </div>\r\n      </ng-template>\r\n      </div>\r\n    </div>\r\n    <ng-template #priceOnSelection>\r\n      <div class=\"widget-price\">\r\n        \r\n        <span class=\"price priceOnSelection\">\r\n          {{language['priceOnSelection'] || 'Price on selection '}} \r\n        </span>\r\n      </div>\r\n    </ng-template>\r\n      <div *ngIf=\"product.addonsCheck\" class=\"text-center\">\r\n        <button\r\n          [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product | translate: 'slug']\" class=\"custom-btn addToCartBtn m-auto\">\r\n          {{language['addToCart']}}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":host .widget{position:relative;display:block;border-radius:1rem;margin-bottom:3rem;border:1.5px solid #dee2e6;overflow:hidden;transition:all .35s ease-in-out}:host .widget:after{content:\"\";display:block;clear:both}:host .widget.with-hover:hover{transform:translateY(-.3rem);box-shadow:0 2px 3px #007dbe80}:host .widget.with-cursor{cursor:pointer}:host .widget .widget-head{position:relative;border-radius:0 0 1rem 1rem;background-color:#ebebeb;text-align:center}:host .widget .widget-head:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background-color:#ffffff80;opacity:0;visibility:hidden;transition:all .35s ease-in-out}:host .widget .widget-head .widget-img{height:265px;display:flex;align-items:center;justify-content:center}:host .widget .widget-head .widget-img .spinner{position:absolute;display:flex;align-items:center;justify-content:center;height:265px;width:100%}:host .widget .widget-head .widget-img img{max-width:100%;max-height:100%;width:auto;height:auto;margin:auto}:host .widget .widget-head .animate-fade{position:relative;-webkit-animation-name:animatefade;-webkit-animation-duration:1s;animation-name:animatefade;animation-duration:1s}@keyframes animatefade{0%{opacity:0}to{opacity:1}}:host .widget .widget-head .spinner{position:absolute;left:0;width:100%}:host .widget .widget-head .widget-labels{position:absolute;top:2.5rem;left:0;text-align:left;z-index:1}[dir=rtl] :host .widget .widget-head .widget-labels{left:auto;right:0;text-align:right}:host .widget .widget-head .widget-labels span{display:block;background-color:var(--main-color, #0099ff);border-radius:0 2rem 2rem 0;padding:0 1rem;height:3.3rem;width:max-content;line-height:3.3rem;color:#fff;text-align:center;margin-bottom:1rem;text-transform:capitalize}[dir=rtl] :host .widget .widget-head .widget-labels span{border-radius:2rem 0 0 2rem}:host .widget .widget-head .widget-icons{position:absolute;width:100%;bottom:5px;left:0;opacity:0;visibility:hidden;z-index:1;transition:all .35s ease-in-out}:host .widget .widget-head .widget-icons .icon-btn{margin:0 1rem}:host .widget .widget-content{padding:2rem;background-color:#fff}:host .widget .widget-content .product-rating{display:none}:host .widget .widget-content .widget-title{display:block;color:var(--body-link-color, #292929);font-size:var(--body-link-font-size, 2rem);font-weight:700;text-transform:capitalize;margin-bottom:1rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .widget .widget-content .product-description{color:#18181a;margin-bottom:.5rem;font-size:1.5rem;line-height:2.2rem;display:none}:host .widget .widget-content .widget-price{color:#09f;text-transform:uppercase;margin-bottom:2.5rem}:host .widget .widget-content .widget-price .price{font-weight:700;font-size:1.8rem}:host .widget .widget-content .widget-price .price-old{text-decoration:line-through;font-size:1.6rem;color:gray;float:right}[dir=rtl] :host .widget .widget-content .widget-price .price-old{float:left}:host .widget .widget-content .widget-price .instalment{display:block;font-size:1.6rem;margin-top:.5rem}:host .widget:hover .widget-head:after{opacity:1;visibility:visible}:host .widget:hover .widget-head .widget-icons{opacity:1;visibility:visible;bottom:25px}:host .widget.list-view{display:flex}:host .widget.list-view .widget-head{width:45%;background-color:#ccc;border-radius:0}:host .widget.list-view .widget-head .widget-img{padding:2rem}:host .widget.list-view .widget-content{width:55%;position:relative}:host .widget.list-view .widget-content p{display:block}:host .widget.list-view .widget-content .widget-foot{position:absolute;bottom:0;left:0;width:100%;padding:0 2rem 2rem}:host .widget.list-view .widget-content .widget-price{min-height:auto;margin-bottom:1rem}@media all and (max-width: 767.98px){:host .widget.list-view{display:block}:host .widget.list-view .widget-head,:host .widget.list-view .widget-content{width:100%;min-height:22rem}:host .widget.list-view .widget-head p,:host .widget.list-view .widget-content p{text-overflow:ellipsis;max-width:100%;overflow:hidden;white-space:nowrap}}:host .widget .product-price .price{margin-top:10px;display:flex;justify-content:space-between}:host .widget .product-price .price__sale{color:var(--main-color, orange)}:host .widget .product-price .price__original{color:var(--main-color, orange)}:host .widget .product-price .price__original--discount{color:#8e8e8e;text-decoration:line-through}:host .widget .product-price div{display:inline-block;margin-right:1rem}:host .widget .product-price div:last-child{margin:0!important}:host .widget .product-price div.hidden{display:none!important}[dir=rtl] :host .widget .product-price div{margin-right:auto;margin-left:1rem}\n"], components: [{ type: SpinnerComponent, selector: "app-spinner" }, { type: i10.RatingComponent, selector: "rating", inputs: ["max", "readonly", "titles", "customTemplate"], outputs: ["onHover", "onLeave"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i12.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["adaptivePosition", "placement", "triggers", "containerClass", "isDisabled", "delay", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "tooltipIsOpen", "tooltipEnable", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "tooltipTrigger", "boundariesElement"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "translate": TranslatePipe, "percent": i6.PercentPipe, "async": i6.AsyncPipe, "slice": i6.SlicePipe, "number": i6.DecimalPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-product',
                    templateUrl: './product.base-component.html',
                    styleUrls: ['./product.base-component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: LoginService }, { type: LanguageService }, { type: WishListService }, { type: CompareService }, { type: QuickViewService }, { type: ConfService }, { type: ProductService }, { type: CollectionService }, { type: i2.Router }, { type: CartService }, { type: GoogleAnalyticsService }, { type: i6.DecimalPipe }]; }, propDecorators: { product: [{
                type: Input
            }], featured: [{
                type: Input
            }], gridClass: [{
                type: Input
            }] } });

// import {DialogService} from 'primeng/dynamicdialog';
class HomeProductBaseComponent {
    constructor(loginService, languageService, wishListService, compareService, quickViewService, confService, productService, shopService, router, cartService, decimalPipe) {
        this.loginService = loginService;
        this.languageService = languageService;
        this.wishListService = wishListService;
        this.compareService = compareService;
        this.quickViewService = quickViewService;
        this.confService = confService;
        this.productService = productService;
        this.shopService = shopService;
        this.router = router;
        this.cartService = cartService;
        this.decimalPipe = decimalPipe;
        this.featured = false;
        this.gridClass = true;
        this.defaultImage = environment.defaultImage;
        this.language = {};
        // tslint:disable-next-line: deprecation
        this.fav = Observable.create(false);
        // tslint:disable-next-line: deprecation
        this.compare = Observable.create(false);
        this.imageUrl = environment.imageUrl;
        this.wishListFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.WISH_LIST));
        this.compareFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.COMPARE));
        this.reviewsFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.REVIEWS));
        this.imgIsLoaded = false;
        this.imgSrc = '';
        this.maxRate = 5;
        this.rate = 5;
        this.rates = [0, 1, 2, 3, 4, 5];
        this.languageUrl = '';
        this.canAddToCart = true;
        this.prices = [];
        this.priceSorted = 0;
        this.orininalPriceSorted = 0;
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.storeIdentitySubscription = this.confService.store$.subscribe(store => {
            this.disableOutOfStockVariants = store.disableOutOfStockVariants;
        });
        this.confService.storeId.subscribe((data) => {
            this.storeid = data;
        });
        this.gridClassSubjectSub = this.shopService.gridClassSubject.subscribe((res) => {
            this.gridClass = res;
        });
        this.rate = this.product.rating;
        this.fav = this.wishListService.inWishList(this.product.code);
        this.compare = this.compareService.inCompare(this.product.code);
        this.languageService.getLanguage().subscribe((language) => this.language = language);
        this.getProductImg();
    }
    addToCart() {
        this.cartService.addToCart(this.product.variant, 1, this.product);
        setTimeout(() => {
            this.router.navigate([`/${this.language['LANGUAGE_CODE']}/cart`]);
        }, 500);
    }
    isLoggedIn() {
        const isChecked = JSON.parse(localStorage.getItem('isCheckLoggedUserToCart'));
        const userEmail = localStorage.getItem('user_email');
        const userId = localStorage.getItem('user_id');
        if (isChecked == false) {
            this.openQuickView();
        }
        else {
            if (userEmail && userId) {
                this.openQuickView();
            }
            else {
                this.loginService.openLoginPopUp();
            }
        }
    }
    getProductImg() {
        if (!this.product) {
            this.imgSrc = environment.defaultImage;
        }
        if (this.product && !this.product.thumbnailImage) {
            this.imgSrc = this.product.image ? environment.imageUrl + this.product.image.path : environment.defaultImage;
        }
        if (this.product && this.product.thumbnailImage) {
            this.imgSrc = environment.imageUrl + this.product.thumbnailImage.path;
        }
    }
    toggleWishList() {
        this.languageUrl = this.router.url.split('/').filter((data) => data !== '')[0];
        if (localStorage.getItem('user_firstName') || sessionStorage.getItem('user_firstName')) {
            this.wishListService.toggleWishList(this.product.code);
        }
        else {
            this.router.navigate(['/', this.languageUrl, 'accounts', 'login']);
        }
    }
    toggleCompare() {
        this.compareService.toggleCompare(this.product.code);
    }
    openQuickViewOnly() {
        this.quickViewService.openQuickViewVisibility();
        this.quickViewService.open(this.product);
    }
    openQuickView() {
        this.quickViewService.openQuickViewVisibility();
        if (this.product.productType !== 'configrable' && this.canAddToCart) {
            this.cartService.addToCart(this.product.variant, 1, this.product);
            return;
        }
        this.quickViewService.open(this.product);
    }
    ngOnDestroy() {
        this.quickViewService.close();
        if (this.gridClassSubjectSub) {
            this.gridClassSubjectSub.unsubscribe();
        }
    }
}
HomeProductBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HomeProductBaseComponent, deps: [{ token: LoginService }, { token: LanguageService }, { token: WishListService }, { token: CompareService }, { token: QuickViewService }, { token: ConfService }, { token: ProductService }, { token: ShopService }, { token: i2.Router }, { token: CartService }, { token: i6.DecimalPipe }], target: i0.ɵɵFactoryTarget.Component });
HomeProductBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: HomeProductBaseComponent, selector: "app-base-home-product", inputs: { product: "product", featured: "featured", gridClass: "gridClass" }, providers: [], ngImport: i0, template: "<div *ngIf=\"product.productType !=='addons'\" [ngClass]=\"[featured ? 'list-view': '' , gridClass ? '' : 'list-view' ]\"\r\n  [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', product.slug]\"\r\n  [queryParams]=\"{ variantCode: product.variant.code }\" class=\"widget with-cursor\">\r\n  <div class=\"widget-head\">\r\n    <div class=\"widget-img\">\r\n      <div *ngIf=\"!imgIsLoaded\" class=\"spinner\">\r\n        <app-spinner></app-spinner>\r\n      </div>\r\n      <img class=\"animate-fade\" [lazyLoad]=\"imgSrc\" (load)=\"imgIsLoaded = true\" [errorImage]=\"defaultImage\" [alt]=\"product.name\" />\r\n    </div>\r\n    <div class=\"widget-labels\">\r\n      <ng-container *ngTemplateOutlet=\"labels\"></ng-container>\r\n      <ng-template #labels>\r\n        <span class=\"discount\" *ngIf=\"product.discounted && (product.variant.original_price > product.variant.price) && !product.hidePrice\"\r\n          placement=\"right\" tooltip=\"{{language['discount']}}\">\r\n          {{ (product.variant.original_price - product.variant.price) / product.variant.original_price |\r\n          percent }}\r\n        </span>\r\n        <span class=\"bg-light-green new\" *ngIf=\"product.new\"> {{language['new']}} </span>\r\n        <span class=\"bg-red outOfStock\" *ngIf=\"product.variant.tracked && product.variant.stock == 0\">\r\n          {{language['outOfStock']}}\r\n        </span>\r\n        <span class=\"bg-gray outOfStock\" *ngIf=\"product.limited_quantity\">\r\n          {{language['limited_quantity']}}\r\n        </span>\r\n        <span *ngIf=\"product.bestseller\" class=\"bg-tomato best-sellers\" placement=\"right\"\r\n          tooltip=\"{{language['bestSellers']}}\">\r\n          <i class=\"fa fa-line-chart\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <span *ngIf=\"product.featured\" class=\"featured-product\" placement=\"right\"\r\n          tooltip=\"{{language['featureProduct']}}\">\r\n          <i class=\"fa fa-star\"></i>\r\n        </span>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"widget-icons\">\r\n      <button *ngIf=\"wishListFeature$ | async\" class=\"icon-btn wishlist\" [ngClass]=\"{active: fav | async}\"\r\n        aria-hidden=\"true\" (click)=\"$event.stopPropagation();toggleWishList()\" tooltip=\"{{language['wishList']}}\">\r\n        <i class=\"fa fa-heart\"></i>\r\n      </button>\r\n      <button *ngIf=\"compareFeature$ | async\" class=\"icon-btn compare-list\" [ngClass]=\"{active: compare | async}\"\r\n        aria-hidden=\"true\" tooltip=\"{{language['compare']}}\" (click)=\"$event.stopPropagation();toggleCompare()\">\r\n        <i class=\"fa fa-random\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"widget-content\">\r\n    <div class=\"product-rating\" *ngIf=\"rates?.length && (reviewsFeature$ | async)\">\r\n      <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\"> </rating>\r\n    </div>\r\n    <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', product.slug]\"\r\n      [queryParams]=\"{ variantCode: product.variant.code }\" class=\"widget-title\">\r\n      {{product.name}}\r\n    </a>\r\n    <p class=\"product-description\">\r\n      {{ (product.shortDescription ?.length > 85) ? (product.shortDescription |\r\n      slice:0:85) + '...' : (product.shortDescription) }}\r\n    </p>\r\n    <div class=\"widget-foot\" *ngIf=\"!product.hidePrice\">\r\n      <div class=\"widget-price product-price\">\r\n        <div class=\"price\" *ngIf=\"product.PriceFrom === product.PriceTo; else fromPrice\">\r\n          <h3 class=\"price__sale\">{{ product.variant.price / 100 | number}} {{currencyCode}}</h3>\r\n          <h3 class=\"price__original price__original--discount\" *ngIf=\"product.discounted\">\r\n            {{product.variant.original_price / 100 | number}} {{currencyCode}}\r\n          </h3>\r\n        </div>\r\n        <ng-template #fromPrice>\r\n          <div class=\"price\">\r\n            <h3 class=\"price__sale\">{{language['from']}} {{product.variant.price / 100 | number}} {{currencyCode}}</h3>\r\n          </div>\r\n          <h3 class=\"price__original price__original--discount\" *ngIf=\"product.discounted\">\r\n            {{product.variant.original_price / 100 | number}} {{currencyCode}}\r\n          </h3>\r\n        </ng-template>\r\n      </div>\r\n      <div class=\"text-center\">\r\n        <!-- <button (click)=\"openQuickView()\"\r\n          class=\"custom-btn addToCartBtn d-none d-md-block m-auto\">\r\n          {{ language['addToCart']  }}\r\n        </button> -->\r\n        <button (click)=\"$event.stopPropagation(); openQuickView()\"\r\n          class=\"custom-btn addToCartBtn d-none d-md-block m-auto\">\r\n          {{ (product.productType === \"simple\" ) ? language['addToCart'] :\r\n          language['quickView'] }}\r\n        </button>\r\n        <button *ngIf=\"(product.productType && product.productType == 'simple')\" (click)=\"$event.stopPropagation(); openQuickView()\"\r\n         class=\"custom-btn addToCartBtn d-md-none\">\r\n        {{language['addToCart']}}\r\n      </button>\r\n        <button *ngIf=\"(product.productType && product.productType != 'simple')\" [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', product.slug]\"\r\n          [queryParams]=\"{ variantCode: product.variant.code }\" class=\"custom-btn addToCartBtn d-md-none\">\r\n          {{language['viewDetails']}}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"product.productType === 'addons'\" [ngClass]=\"[featured ? 'list-view': '' , gridClass ? '' : 'list-view' ]\"\r\n  [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product.slug]\" class=\"widget with-cursor\">\r\n  <div class=\"widget-head\">\r\n    <div class=\"widget-img\">\r\n      <div *ngIf=\"!imgIsLoaded\" class=\"spinner\">\r\n        <app-spinner></app-spinner>\r\n      </div>\r\n      <img class=\"animate-fade\" [lazyLoad]=\"imgSrc\" (load)=\"imgIsLoaded = true\" [errorImage]=\"defaultImage\" [alt]=\"product.name\"/>\r\n    </div>\r\n    <div class=\"widget-labels\">\r\n      <ng-container *ngTemplateOutlet=\"labels\"></ng-container>\r\n      <ng-template #labels>\r\n        <span class=\"discount\" *ngIf=\"product.discounted && (product.variant.original_price > product.variant.price)\"\r\n          placement=\"right\" tooltip=\"{{language['discount']}}\">\r\n          {{ (product.variant.original_price - product.variant.price) / product.variant.original_price |\r\n          percent }}\r\n        </span>\r\n        <span class=\"bg-light-green new\" *ngIf=\"product.new\"> {{language['new']}} </span>\r\n        <span class=\"bg-red outOfStock\" *ngIf=\"product.variant.tracked && product.variant.stock == 0\">\r\n          {{language['outOfStock']}}\r\n        </span>\r\n        <span *ngIf=\"product.bestseller\" class=\"bg-tomato best-sellers\" placement=\"right\"\r\n          tooltip=\"{{language['bestSellers']}}\">\r\n          <i class=\"fa fa-line-chart\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <span *ngIf=\"product.featured\" class=\"featured-product\" placement=\"right\"\r\n          tooltip=\"{{language['featureProduct']}}\">\r\n          <i class=\"fa fa-star\"></i>\r\n        </span>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"widget-icons\">\r\n      <button *ngIf=\"wishListFeature$ | async\" class=\"icon-btn wishlist\" [ngClass]=\"{active: fav | async}\"\r\n        aria-hidden=\"true\" (click)=\"$event.stopPropagation();toggleWishList()\" tooltip=\"{{language['wishList']}}\">\r\n        <i class=\"fa fa-heart\"></i>\r\n      </button>\r\n      <button class=\"icon-btn compare-list\" [ngClass]=\"{active: compare | async}\" aria-hidden=\"true\"\r\n        tooltip=\"{{language['compare']}}\" (click)=\"$event.stopPropagation();toggleCompare()\">\r\n        <i class=\"fa fa-random\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"widget-content\">\r\n    <div class=\"product-rating\" *ngIf=\"rates?.length && (reviewsFeature$ | async)\">\r\n      <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\"> </rating>\r\n    </div>\r\n    <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product.slug]\" class=\"widget-title\">\r\n      {{product.name}}\r\n    </a>\r\n    <p class=\"product-description\">\r\n      {{ (product.shortDescription ?.length > 85) ? (product.shortDescription |\r\n      slice:0:85) + '...' : (product.shortDescription) }}\r\n    </p>\r\n    <div class=\"widget-foot\">\r\n      <div *ngIf=\"(product.variant?.original_price / 100 > 0 ||  product.variant?.price / 100 > 0);else priceOnSelection\">\r\n      <div class=\"widget-price product-price\">\r\n        <div class=\"price\" *ngIf=\"product.PriceFrom === product.PriceTo; else fromPrice\">\r\n          <h3 class=\"price__sale\">{{ product.variant.price / 100 | number}} {{currencyCode}}</h3>\r\n          <div class=\"price__original price__original--discount\" *ngIf=\"product.discounted\">\r\n            {{product.variant.original_price / 100 | number}} {{currencyCode}}\r\n          </div>\r\n        </div>\r\n        <ng-template #fromPrice>\r\n          <div class=\"price\">\r\n            <h3 class=\"price__sale\">{{language['from']}} {{product.variant.price / 100 | number}} {{currencyCode}}</h3>\r\n          </div>\r\n          <div class=\"price__original price__original--discount\" *ngIf=\"product.discounted\">\r\n            {{product.variant.original_price / 100 | number}} {{currencyCode}}\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n    <ng-template #priceOnSelection>\r\n      <div class=\"widget-price\">\r\n        \r\n        <span class=\"price priceOnSelection\">\r\n          {{language['priceOnSelection'] || 'Price on selection '}} \r\n        </span>\r\n      </div>\r\n    </ng-template>\r\n      <div class=\"text-center\">\r\n        <button [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product.slug]\"\r\n          class=\"custom-btn addToCartBtn m-auto\">\r\n          {{language['addToCart'] }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":host .widget{position:relative;display:block;border-radius:1rem;margin-bottom:3rem;border:1.5px solid #dee2e6;overflow:hidden;transition:all .35s ease-in-out}:host .widget:after{content:\"\";display:block;clear:both}:host .widget.with-hover:hover{transform:translateY(-.3rem);box-shadow:0 2px 3px #007dbe80}:host .widget.with-cursor{cursor:pointer}:host .widget .widget-head{position:relative;border-radius:0 0 1rem 1rem;background-color:var(--body-bg-color, #fff);text-align:center}:host .widget .widget-head:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background-color:#ffffff80;opacity:0;visibility:hidden;transition:all .35s ease-in-out}:host .widget .widget-head .widget-img{height:265px;display:flex;align-items:center;justify-content:center}:host .widget .widget-head .widget-img .spinner{position:absolute;display:flex;align-items:center;justify-content:center;height:265px;width:100%}:host .widget .widget-head .widget-img img{max-width:100%;max-height:100%;width:auto;height:auto;margin:auto}:host .widget .widget-head .animate-fade{position:relative;-webkit-animation-name:animatefade;-webkit-animation-duration:1s;animation-name:animatefade;animation-duration:1s}@keyframes animatefade{0%{opacity:0}to{opacity:1}}:host .widget .widget-head .spinner{position:absolute;left:0;width:100%}:host .widget .widget-head .widget-labels{position:absolute;top:2.5rem;left:0;text-align:left;z-index:1}[dir=rtl] :host .widget .widget-head .widget-labels{left:auto;right:0;text-align:right}:host .widget .widget-head .widget-labels span{display:block;background-color:var(--main-color, #0099ff);border-radius:0 2rem 2rem 0;padding:0 1rem;height:3.3rem;width:max-content;line-height:3.3rem;color:#fff;text-align:center;margin-bottom:1rem;text-transform:capitalize}[dir=rtl] :host .widget .widget-head .widget-labels span{border-radius:2rem 0 0 2rem}:host .widget .widget-head .widget-icons{position:absolute;width:100%;bottom:5px;left:0;opacity:0;visibility:hidden;z-index:1;transition:all .35s ease-in-out}:host .widget .widget-head .widget-icons .icon-btn{margin:0 1rem}:host .widget .widget-content{padding:2rem;background-color:#fff}:host .widget .widget-content .product-rating{display:none}:host .widget .widget-content .widget-title{display:block;color:var(--body-link-color, #292929);font-size:var(--body-link-font-size, 2rem);font-weight:700;text-transform:capitalize;margin-bottom:1rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .widget .widget-content .product-description{color:#18181a;margin-bottom:.5rem;font-size:1.5rem;line-height:2.2rem;display:none}:host .widget .widget-content .widget-price{color:#09f;text-transform:uppercase;margin-bottom:2.5rem}:host .widget .widget-content .widget-price .price{font-weight:700;font-size:1.8rem}:host .widget .widget-content .widget-price .price-old{text-decoration:line-through;font-size:1.6rem;color:gray;float:right}[dir=rtl] :host .widget .widget-content .widget-price .price-old{float:left}:host .widget .widget-content .widget-price .instalment{display:block;font-size:1.6rem;margin-top:.5rem}:host .widget:hover .widget-head:after{opacity:1;visibility:visible}:host .widget:hover .widget-head .widget-icons{opacity:1;visibility:visible;bottom:25px}:host .widget.list-view{display:flex}:host .widget.list-view .widget-head{width:45%;background-color:var(--body-bg-color, #fff);border-radius:0}:host .widget.list-view .widget-head .widget-img{padding:2rem}:host .widget.list-view .widget-content{width:55%;position:relative}:host .widget.list-view .widget-content p{display:block}:host .widget.list-view .widget-content .widget-foot{position:absolute;bottom:0;left:0;width:100%;padding:0 2rem 2rem}:host .widget.list-view .widget-content .widget-price{min-height:auto;margin-bottom:1rem}@media all and (max-width: 767.98px){:host .widget.list-view{display:block}:host .widget.list-view .widget-head,:host .widget.list-view .widget-content{width:100%;min-height:22rem}:host .widget.list-view .widget-head p,:host .widget.list-view .widget-content p{text-overflow:ellipsis;max-width:100%;overflow:hidden;white-space:nowrap}}:host .widget .product-price .price{margin-top:10px;display:flex;justify-content:space-between}:host .widget .product-price .price__sale{color:var(--main-color, orange)}:host .widget .product-price .price__original{color:var(--main-color, orange)}:host .widget .product-price .price__original--discount{color:#8e8e8e;text-decoration:line-through}:host .widget .product-price div{display:inline-block;margin-right:1rem}:host .widget .product-price div:last-child{margin:0!important}:host .widget .product-price div.hidden{display:none!important}[dir=rtl] :host .widget .product-price div{margin-right:auto;margin-left:1rem}\n"], components: [{ type: SpinnerComponent, selector: "app-spinner" }, { type: i10.RatingComponent, selector: "rating", inputs: ["max", "readonly", "titles", "customTemplate"], outputs: ["onHover", "onLeave"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i12.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["adaptivePosition", "placement", "triggers", "containerClass", "isDisabled", "delay", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "tooltipIsOpen", "tooltipEnable", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "tooltipTrigger", "boundariesElement"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "percent": i6.PercentPipe, "async": i6.AsyncPipe, "slice": i6.SlicePipe, "number": i6.DecimalPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HomeProductBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-home-product',
                    templateUrl: './home-product.base-component.html',
                    styleUrls: ['./home-product.base-component.scss'],
                    providers: []
                }]
        }], ctorParameters: function () { return [{ type: LoginService }, { type: LanguageService }, { type: WishListService }, { type: CompareService }, { type: QuickViewService }, { type: ConfService }, { type: ProductService }, { type: ShopService }, { type: i2.Router }, { type: CartService }, { type: i6.DecimalPipe }]; }, propDecorators: { product: [{
                type: Input
            }], featured: [{
                type: Input
            }], gridClass: [{
                type: Input
            }] } });

class InnerLoadingComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
InnerLoadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InnerLoadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InnerLoadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: InnerLoadingComponent, selector: "app-inner-loading", ngImport: i0, template: "<div class=\"collection__spinner\">\r\n  <div class=\"lds-ellipsis\">\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n  </div>\r\n</div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InnerLoadingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-inner-loading',
                    templateUrl: './inner-loading.component.html',
                    styleUrls: ['./inner-loading.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

class NoSanitizeHtmlPipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(html) {
        return (this.domSanitizer.bypassSecurityTrustHtml(html));
    }
}
NoSanitizeHtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NoSanitizeHtmlPipe, deps: [{ token: i3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
NoSanitizeHtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NoSanitizeHtmlPipe, name: "noSanitizeHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NoSanitizeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'noSanitizeHtml' }]
        }], ctorParameters: function () { return [{ type: i3.DomSanitizer }]; } });

class ProductDetailsBaseComponent {
    constructor(route, languageService, productDetailsService, collectionService, cartService, wishlistService, compareService, breadcrumbService, translatePipe, loginService, formBuilder, modalService, location, toastr, titleService, meta, confService, router, googleAnalyticsService, tagManagerService, langaugeService, breakpointObserver, checkoutService, contactUsService, config) {
        var _a;
        this.route = route;
        this.languageService = languageService;
        this.productDetailsService = productDetailsService;
        this.collectionService = collectionService;
        this.cartService = cartService;
        this.wishlistService = wishlistService;
        this.compareService = compareService;
        this.breadcrumbService = breadcrumbService;
        this.translatePipe = translatePipe;
        this.loginService = loginService;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.location = location;
        this.toastr = toastr;
        this.titleService = titleService;
        this.meta = meta;
        this.confService = confService;
        this.router = router;
        this.googleAnalyticsService = googleAnalyticsService;
        this.tagManagerService = tagManagerService;
        this.langaugeService = langaugeService;
        this.breakpointObserver = breakpointObserver;
        this.checkoutService = checkoutService;
        this.contactUsService = contactUsService;
        this.config = config;
        this.carouselOptions = {
            margin: 10,
            items: 1,
            autoplayHoverPause: true,
            dots: false,
            nav: true,
            navSpeed: 1000,
            autoplaySpeed: 2000,
            slideTransition: 'linear'
        };
        this.bestsellersOption = {
            items: 4,
            responsive: {
                0: {
                    stagePadding: 20,
                    items: 1,
                    nav: false,
                    dots: true
                },
                576: {
                    stagePadding: 25,
                    items: 2,
                    nav: false,
                    dots: true
                },
                768: {
                    items: 3,
                    nav: false,
                    dots: true
                },
                992: {
                    items: 4,
                    nav: false,
                    dots: true
                }
            }
        };
        this.SamirCustomOption = {
            margin: 25,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                576: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 20,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    dots: true,
                    nav: false,
                },
                992: {
                    items: 4,
                    dots: true,
                    nav: false,
                },
                1024: {
                    items: 4,
                    dots: true,
                    nav: false
                },
                1100: {
                    items: 4,
                    dots: false,
                    nav: true
                }
            }
        };
        this.thumbnialOptions = {
            items: 5,
            margin: 5,
            navSpeed: 300,
            nav: true,
            dots: false,
            autoplaySpeed: 1000,
            responsive: {
                0: {
                    items: 3
                },
                576: {
                    items: 4
                },
                768: {
                    items: 3
                },
                991: {
                    items: 4
                },
                1199: {
                    items: 5
                }
            }
        };
        this.OwlCustom_3 = {
            margin: 30,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                576: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    margin: 15,
                    dots: true,
                    nav: true,
                },
                992: {
                    items: 3,
                    dots: true,
                    nav: true,
                },
                1024: {
                    items: 3,
                    dots: true,
                    nav: true
                },
                1100: {
                    items: 3,
                    dots: true,
                    nav: true
                }
            }
        };
        this.language = {};
        this.selectedOption = {};
        this.quantity = 1;
        this.options = {};
        this.price = 0;
        this.variantExists = false;
        this.cartId = +localStorage.getItem('cartId');
        this.fav = Observable.create(false);
        this.compare = Observable.create(false);
        this.imageUrl = environment.imageUrl;
        this.defaultImage = environment.defaultImage;
        this.maxRate = 5;
        this.rate = 5;
        this.rating = 0;
        this.email = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email');
        this.wishListFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.WISH_LIST));
        this.compareFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.COMPARE));
        this.reviewsFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.REVIEWS));
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.natureWorkB2b = (this.id == 12710) ? false : true;
        this.childreenBreadcrumbs = [];
        this.defaultVariantCode = (_a = this.config.data) === null || _a === void 0 ? void 0 : _a.id; //get DataFrom PopUp
        this.notFound = false;
        this.imgIsLoaded = false;
        this.showDetails = true;
        this.toggleHeight = false;
        this.increment = 0;
        this.highImage = '';
        this.mediumImage = '';
        this.lowImage = '';
        this.submitted = false;
        this.isDisabled = true;
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    identify(index, item) {
        return this.selectedVariant[index].images;
    }
    ngOnInit() {
        this.logged$ = this.loginService.logged;
        this.reviewForm = this.formBuilder.group({
            title: ['', Validators.required],
            comment: ['', Validators.required],
            email: [this.email, [Validators.required, Validators.email]],
        });
        this.route.queryParams.subscribe((queryParams) => {
            this.defaultVariantCode = queryParams.variantCode;
        });
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // Set the scroll position to (0, 0) to prevent scrolling to the top
                window.scrollTo(0, 0);
            }
        });
        this.route.params.subscribe(params => {
            var _a;
            this.slug = ((_a = this.config.data) === null || _a === void 0 ? void 0 : _a.code) || params['code'];
            if (this.productInput === undefined) {
                this.productSubscription = this.productDetailsService.getProduct(this.slug, this.defaultVariantCode).subscribe(product => {
                    this.product = product;
                    for (const taxon in product['mainTaxon']) {
                        if (product['mainTaxon'].images) {
                            for (const i in product['mainTaxon'].images) {
                                if (product['mainTaxon'].images[i]['type'] === 'collection_page_banner') {
                                    this.breadcrumbService.setBackground(environment.imageUrl + product['mainTaxon'].images[i]['path']);
                                    break;
                                }
                                else {
                                    this.breadcrumbService.setBackground('/assets/images/banner-default.jpg');
                                }
                            }
                        }
                    }
                    this.actualCode = product.code;
                    this.storeSubscription = this.confService.store$.subscribe((store) => {
                        this.myStore = store;
                        console.log(this.myStore.isContactUsInsteadAddCart);
                        this.titleService.setTitle(this.myStore.name + ' | ' + this.translatePipe.transform(this.product, 'name'));
                    });
                    // Add Meta Tags
                    if (this.meta.getTag('name="keywords"')) {
                        this.meta.updateTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
                    }
                    else {
                        this.meta.addTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
                    }
                    if (this.meta.getTag('name="description"')) {
                        this.meta.updateTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
                    }
                    else {
                        this.meta.addTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
                    }
                    if (this.product.options && this.product['options'].length > 0) {
                        for (const option of this.product['options']) {
                            this.options[option.code] = '';
                        }
                    }
                    this.autoSelect();
                    this.handleBreadcrumb();
                    this.manageVariant();
                    this.rate = product.rating;
                    this.fav = this.wishlistService.inWishList(product.code);
                    this.compare = this.compareService.inCompare(product.code);
                    if (product.images.length > 0) {
                        this.src = `${environment.imageUrl}c/${product.images[0].path}`;
                    }
                    else {
                        this.src = this.defaultImage;
                    }
                    this.variant = this.selectedVariant
                        ? this.selectedVariant
                        : this.product['variants'][0];
                    localStorage.setItem('product-category', this.product.mainTaxon.code);
                    this.prices = this.selectedVariant.prices.length > 0 ? this.selectedVariant.prices[0] : 0;
                    this.price = this.prices.original_price > this.prices.price ? this.prices.price : this.prices.original_price;
                    // set empty array to hold the chose options
                    this.simple = this.product.options && product.options.length === 0;
                    let maxSet = false;
                    this.existsInCart = this.selectedVariant
                        ? this.cartService.checkIfVariantInCart(this.selectedVariant)
                        : false;
                    if (this.existsInCart) {
                        this.max = this.selectedVariant.tracked ? this.selectedVariant.stock - this.existsInCart[1] : 4001;
                        this.variantExists = true;
                        maxSet = true;
                        this.quantity = 1;
                    }
                    if (!maxSet) {
                        this.max = this.selectedVariant.tracked ? this.selectedVariant.stock : 4001;
                        this.variantExists = true;
                        this.quantity = 1;
                    }
                    this.getReview();
                }, err => {
                    this.notFound = true;
                    this.toastr.error(err.error.message, `${this.language['error']}!`, { enableHtml: true, closeButton: true });
                });
            }
            else {
                // if (this.productSubscription) { this.productSubscription.unsubscribe(); }
                this.product = this.productInput;
                this.manageProduct(this.productInput);
            }
        });
        this.languageService.getLanguage().subscribe(language => {
            this.imageUrl = environment.imageUrl;
            this.language = language;
        });
        // this.productDetailsService.fetchAddToCartOption().subscribe((data:any) => {
        // 	this.isAddToCartEnabled = data.response.isContactUsInsteadAddCart;
        // 	console.log(data.response);
        // })
        this.confService.storeId.subscribe(data => {
            this.sroreId = data;
        });
    }
    openModal(template_) {
        this.modalRef = this.modalService.show(template_);
    }
    quantityChanged() {
        this.quantity = +this.quantity > this.max ? this.max : +this.quantity;
        let maxSet = false;
        this.existsInCart = this.selectedVariant
            ? this.cartService.checkIfVariantInCart(this.selectedVariant)
            : false;
        if (this.existsInCart) {
            this.max = this.selectedVariant.tracked ? this.selectedVariant.stock - this.existsInCart[1] : 4001;
            maxSet = true;
        }
        if (!maxSet) {
            this.max = this.selectedVariant.tracked ? this.selectedVariant.stock : 4001;
        }
        if (this.quantity >= 4001) {
            this.toastr.error(`${this.language['MaxquantityMsg']}!`);
            return;
        }
    }
    /**
     *this fun gets called on the quickView component and product details page with tow btns to increment and decrement.
     the difference between this fun and previous one is that handle increment and decrement properly taking in consideration
     not exceed the max quantity.
     If you are woundering why this function here  while it is not used in the template ! please let me know if you have found an answer :)
     * @param event event to the object which event is dispatched (its target) to query weather + or - btn clicked
     */
    quantityChange(event) {
        if (event.target['attributes'].target.nodeValue === 'quantityUp') {
            if (this.quantity >= this.max) {
                return;
            }
            this.quantity += 1;
        }
        else if (event.target['attributes'].target.nodeValue === 'quantityDown') {
            if (this.quantity == 1) {
                return;
            }
            this.quantity -= 1;
        }
    }
    slideThumbnail(clickedArrow) {
        const wrapper = this.thumbnailWrapper.nativeElement;
        if (clickedArrow.target['classList'].contains('arrow-down')) {
            this.increment >= wrapper.children.length / 2 ?
                this.increment = wrapper.children.length / 2 :
                this.increment++;
            wrapper.style.transform = `translateY(-${this.increment * 100}px)`;
        }
        else {
            this.increment < 0 ?
                this.increment = 0 :
                this.increment--;
            wrapper.style.transform = `translateY(-${this.increment * 100}px)`;
        }
    }
    optionChanged(code, value, index) {
        if (this.sroreId == StoresName.Promil || this.sroreId == StoresName.nilestockId) {
            console.log(index);
            this.selectedOption[code] = value;
            console.log(value);
            this.product = this.collectionService.checkAvailiableVariables(this.product, value, index);
            this.selectedVariant = this.product.selectedVariante;
            this.manageVariant();
        }
        else {
            this.selectedOption[code] = value;
            this.manageVariant();
            console.log(code);
            const selectedVariantCode = this.selectedVariant ? this.selectedVariant.code : '';
            // if (!this.productInput) {
            // 	this.router.navigate(
            // 		['/', this.language['LANGUAGE_CODE'], 'collection', 'product', this.translatePipe.transform(this.product, 'slug')],
            // 		{ queryParams: { 'variantCode': selectedVariantCode }, skipLocationChange: true });
            // }
        }
    }
    toggleWishList() {
        // this.wishlistService.toggleWishList(this.product.code);
        this.languageUrl = this.router.url.split('/').filter(data => data !== '')[0];
        if (localStorage.getItem('user_firstName') || sessionStorage.getItem('user_firstName')) {
            this.wishlistService.toggleWishList(this.product.code);
        }
        else {
            this.router.navigate(['/', this.languageUrl, 'accounts', 'login']);
        }
    }
    toggleCompare() {
        this.compareService.toggleCompare(this.product.code);
    }
    manageVariant() {
        var _a, _b;
        const variant = this.cartService.getVariant(this.product, this.selectedOption);
        if (variant === undefined) {
            this.canAddToCart = false;
            this.disableQuantity = true;
            this.variantUndefined = true;
            return;
        }
        setTimeout(() => {
            if (this.selectedVariant !== undefined) {
                if (variant.stock == 0) {
                    if (variant.tracked == true) {
                        this.canAddToCart = false;
                        this.disableQuantity = true;
                        this.variantUndefined = true;
                        return;
                    }
                    else {
                        this.canAddToCart = true;
                        this.disableQuantity = false;
                        this.variantUndefined = false;
                        this.max = variant['stock'];
                        return;
                    }
                }
            }
            if (variant === undefined) {
                this.canAddToCart = false;
                this.disableQuantity = true;
                this.variantUndefined = true;
                return;
            }
        }, 100);
        this.selectedVariant = variant;
        this.quantity = (((_a = this.selectedVariant) === null || _a === void 0 ? void 0 : _a.limits) == true ? (_b = this.selectedVariant) === null || _b === void 0 ? void 0 : _b.minimumChecks : this.quantity);
        this.max = variant['stock'];
        // if (variant['stock'] <= 0) {
        // 	this.canAddToCart = false;
        // 	this.disableQuantity = true;
        // 	this.variantUndefined = false;
        // 	return;
        // }
        // if (variant.tracked === false) {
        // 	this.canAddToCart = true;
        // 	this.disableQuantity = false;
        // 	this.max = 4001;
        // 	this.variantUndefined = false;
        // 	return;
        // } else {
        // 	this.max = variant['stock'];
        // }
        this.canAddToCart = true;
        this.variantUndefined = false;
        this.disableQuantity = false;
    }
    addToCart() {
        const variant = this.cartService.getVariant(this.product, this.selectedOption) || this.selectedVariant;
        this.cartService.addToCart(variant, this.quantity, this.product);
    }
    SwtichToContactUs() {
        const variant = this.cartService.getVariant(this.product, this.selectedOption);
        console.log(this.selectedOption);
        this.router.navigate(['/products/products-list/'], {
            queryParams: { category_id: this.selectedOption },
        });
    }
    isLoggedIn() {
        const isChecked = JSON.parse(localStorage.getItem('isCheckLoggedUserToCart'));
        const userEmail = localStorage.getItem('user_email');
        const userId = localStorage.getItem('user_id');
        if (isChecked == false) {
            this.addToCart();
        }
        else {
            if (userEmail && userId) {
                this.addToCart();
            }
            else {
                this.loginService.openLoginPopUp();
            }
        }
    }
    handleEasyZoom() {
        const $easyzoom = $('.easyzoom').easyZoom();
        const api1 = $easyzoom
            .filter('.easyzoom--with-thumbnails')
            .data('easyZoom');
        $('.thumbnails').on('click', 'a', function (e) {
            const $thisTumb = $(this);
            e.preventDefault();
            // Use EasyZoom's `swap` method
            api1.swap($thisTumb.data('standard'), $thisTumb.attr('href'));
            api1.swap($thisTumb.attr('href'), $thisTumb.attr('src'));
        });
    }
    toggleEasyZoom() {
        if (this.isDisabled) {
            $('.easyzoom').css('pointer-events', 'all');
        }
        else {
            $('.easyzoom').css('pointer-events', 'none');
        }
        this.isDisabled = !this.isDisabled;
    }
    ngOnDestroy() {
        this.breadcrumbService.setCustom([]);
        if (this.storeSubscription) {
            this.storeSubscription.unsubscribe();
        }
        this.breadcrumbService.setBackground(null);
    }
    rateChange(rate) {
        this.rating = rate;
    }
    get review() { return this.reviewForm.controls; }
    /**
    * @description Add validation to reviewsForm and check if form is submitted.
    * @author Mostafa Mahmoud
    **/
    submitReview() {
        this.submitted = true;
        if (this.reviewForm.invalid) {
            return;
        }
        const review = Object.assign({}, this.reviewForm.value);
        review.rating = this.rating;
        review.author = {};
        review.author.email = review.email;
        delete review.email;
        this.productDetailsService.addReview(review, this.actualCode)
            .subscribe(() => {
            this.toastr.success(`${this.language['reviewAddedSuccessfully']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
            this.reviewForm.reset();
        }, (err) => {
            this.toastr.error(err.error.message, `${this.language['error']}!`, { enableHtml: true, closeButton: true });
        });
    }
    changeCarouselOptions(options = {}, extras = {}) {
        if (extras['responsive']) {
            options['responsive'] = extras['responsive'];
        }
        return Object.assign(Object.assign(Object.assign({}, this.carouselOptions), options), { rtl: this.language['DIR'] === 'rtl' });
    }
    goBack() {
        this.location.back();
    }
    getReview() {
        this.reviews$ = this.productDetailsService.getProductReview(this.actualCode);
    }
    handleBreadcrumb() {
        const taxonParams = this.getTaxonParams();
        const taxonName = this.getTaxonName();
        this.getTaxonChildName();
        const breadCrumbArr = [
            {
                name: taxonName,
                url: {
                    path: ['collection'],
                    params: { taxons: taxonParams }
                }
            },
            {
                name: this.translatePipe.transform(this.product, 'name'),
                url: {
                    path: ['collection', 'product', this.translatePipe.transform(this.product, 'slug')],
                    params: {}
                }
            }
        ];
        // append children breadcrumbs of it exists
        if (this.childreenBreadcrumbs.length) {
            this.childreenBreadcrumbs.reverse().forEach(child => {
                breadCrumbArr.splice(1, 0, {
                    name: this.translatePipe.transform(child, 'name'),
                    url: {
                        path: ['collection'],
                        params: { taxons: child.code }
                    }
                });
            });
        }
        this.breadcrumbService.setCustom(breadCrumbArr);
    }
    getTaxonName() {
        let taxonName = null;
        if (this.product['productTaxons'].length) {
            taxonName = this.product['productTaxons'][0].translations[this.language['LANGUAGE_CODE']] ?
                this.product['productTaxons'][0].translations[this.language['LANGUAGE_CODE']].name :
                this.product['productTaxons'][0].translations[this.languageService.defaultLocale].name;
        }
        return !this.product.mainTaxon.translations ? taxonName : this.translatePipe.transform(this.product.mainTaxon, 'name');
    }
    getTaxonChildName() {
        let childreen = this.product.mainTaxon.children;
        if (childreen) {
            if (!this.containsObject(childreen, this.childreenBreadcrumbs)) {
                this.childreenBreadcrumbs.push(childreen);
            }
            if (childreen['children']) {
                childreen = childreen['children'];
                if (!this.containsObject(childreen, this.childreenBreadcrumbs)) {
                    this.childreenBreadcrumbs.push(childreen);
                }
            }
        }
    }
    getTaxonParams() {
        return this.product.mainTaxon.code === undefined ?
            this.product['productTaxons'][0].code :
            this.product.mainTaxon.code;
    }
    autoSelect() {
        if (!this.product.options) {
            return;
        }
        for (const [index, option] of this.product.options.entries()) {
            this.selectedOption[option.code] = option.option_values[0].code;
            if (index == 0) {
                if (option.option_values.length > 0) {
                    let option_values_found = false;
                    this.product.variants.forEach((element, e) => {
                        // if (this.sroreId == StoresName.Promil || this.sroreId == StoresName.nilestockId){
                        if (element.code === this.defaultVariantCode) {
                            if (option.option_values[e]) {
                                this.options[option.code] = option.option_values[e].code;
                                this.optionChanged(option.code, option.option_values[e].code, 0);
                                option_values_found = true;
                            }
                        }
                        if (e === this.product.variants.length - 1 && option_values_found === false) {
                            this.options[option.code] = option.option_values[0].code;
                            this.optionChanged(option.code, option.option_values[0].code, 0);
                        }
                    });
                }
            }
        }
    }
    //
    manageProduct(product) {
        this.product = product;
        // Update Meta Tags
        if (this.meta.getTag('name="keywords"')) {
            this.meta.updateTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
        }
        else {
            this.meta.addTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
        }
        if (this.meta.getTag('name="description"')) {
            this.meta.updateTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
        }
        else {
            this.meta.addTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
        }
        if (this.product.options && this.product['options'].length > 0) {
            for (const option of this.product['options']) {
                this.options[option.code] = '';
            }
        }
        this.autoSelect();
        this.manageVariant();
        this.rate = product.rating;
        this.fav = this.wishlistService.inWishList(product.code);
        this.compare = this.compareService.inCompare(product.code);
        if (product.images.length > 0) {
            this.src = `${environment.imageUrl}${product.images[0].path}`;
        }
        else {
            this.src = this.defaultImage;
        }
        this.variant = this.selectedVariant;
        this.prices = this.selectedVariant.prices[0];
        this.price = this.prices.original_price > this.prices.price ? this.prices.price : this.prices.original_price;
        // set empty array to hold the chose options
        this.simple = this.product.options && product.options.length === 0;
        let maxSet = false;
        this.existsInCart = this.selectedVariant ? this.cartService.checkIfVariantInCart(this.selectedVariant) : false;
        if (this.existsInCart) {
            this.max = this.selectedVariant.tracked ? this.selectedVariant.stock - this.existsInCart[1] : 4001;
            this.variantExists = true;
            maxSet = true;
            this.quantity = 1;
        }
        if (!maxSet) {
            this.max = this.selectedVariant.tracked ? this.selectedVariant.stock : 4001;
            this.variantExists = true;
            this.quantity = 1;
        }
    }
    containsObject(obj, list) {
        let i;
        for (i = 0; i < list.length; i++) {
            if (obj.code && list[i].code === obj.code) {
                return true;
            }
        }
        return false;
    }
    toggleShow() {
        this.showDetails = !this.showDetails;
    }
    toggleDescriptionHeight() {
        this.toggleHeight = !this.toggleHeight;
    }
    toggleShowElement(element) {
        if (element.style.display === 'block') {
            element.classList.remove('sliceDown');
            setTimeout(() => {
                element.style.display = 'none';
            }, 300);
        }
        else {
            element.style.display = 'block';
            setTimeout(() => {
                element.classList.add('sliceDown');
            }, 50);
        }
    }
    toggleProperties() {
        document.getElementById('element_attribute').classList.toggle('showproperties');
        document.getElementById('attribute_icon').classList.toggle('fa-minus');
    }
    // downloadCatalogue
    downloadCatalogue() {
        localStorage.setItem('downloadCatalogue', 'true');
        this.download();
    }
    download() {
        this.checkoutService.downloadInvoice(this.product['catalogPDF'])
            .subscribe(blob => {
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = `${this.product['name']}catalog.pdf`;
            a.click();
            URL.revokeObjectURL(objectUrl);
        });
    }
}
ProductDetailsBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductDetailsBaseComponent, deps: [{ token: i2.ActivatedRoute }, { token: LanguageService }, { token: ProductService }, { token: CollectionService }, { token: CartService }, { token: WishListService }, { token: CompareService }, { token: BreadcrumbService }, { token: TranslatePipe }, { token: LoginService }, { token: i1$1.FormBuilder }, { token: i5.BsModalService }, { token: i6.Location }, { token: i3$1.ToastrService }, { token: i3.Title }, { token: i3.Meta }, { token: ConfService }, { token: i2.Router }, { token: GoogleAnalyticsService }, { token: GoogleTagManagerService }, { token: LanguageService }, { token: i4.BreakpointObserver }, { token: CheckoutService }, { token: ContactUsService }, { token: i12$1.DynamicDialogConfig }], target: i0.ɵɵFactoryTarget.Component });
ProductDetailsBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ProductDetailsBaseComponent, selector: "app-base-product-details", inputs: { productInput: "productInput" }, providers: [TranslatePipe, DynamicDialogConfig], viewQueries: [{ propertyName: "thisImage", first: true, predicate: ["thisImage"], descendants: true }, { propertyName: "thumbnailWrapper", first: true, predicate: ["thumbnailWrapper"], descendants: true }], ngImport: i0, template: "<section *ngIf=\"selectedVariant\" class=\"singleProduct\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6\">\r\n        <div class=\"gallery\">\r\n          <carousel *ngIf=\"(selectedVariant.images.length > 0) ; else displayImage\" [interval]=\"false\">\r\n            <slide *ngFor=\"let image of (selectedVariant.images)\" class=\"main-image-product\">\r\n              <div class=\"easyzoom easyzoom--overlay easyzoom--with-thumbnails\" style=\"width:100%\">\r\n                <a [href]=\"imageUrl + image.path\" class=\"image-wrapper\">\r\n                  <img #thisImage (error)=\"thisImage.src = defaultImage\" [alt]=\"product.name\"\r\n                    [src]=\"imageUrl + image.path\" alt=\"first slide\" class=\"animate-fade\"\r\n                    (load)=\"handleEasyZoom(); imgIsLoaded = true\" [hidden]=\"imgIsLoaded == false\">\r\n                  <div *ngIf=\"!imgIsLoaded\" class=\"loading-spinner\">\r\n                    <app-spinner></app-spinner>\r\n                  </div>\r\n                </a>\r\n              </div>\r\n            </slide>\r\n          </carousel>\r\n          <button class=\"icon-btn compare-btn toggle\" (click)='toggleEasyZoom()'><i\r\n              class=\"fa fa-search-plus\"></i></button>\r\n          <ng-template #displayImage>\r\n            <div class=\"easyzoom--with-thumbnails\">\r\n              <img [alt]=\"product.name\" [lazyLoad]=\"defaultImage\" alt=\"first slide\" class=\"img-fluid\"\r\n                style=\"width: 100%\">\r\n            </div>\r\n          </ng-template>\r\n\r\n          <owl-carousel [options]=\"changeCarouselOptions(thumbnialOptions)\" [items]=\"selectedVariant.images\"\r\n            [carouselClasses]=\"['owl-theme', 'owl-flex']\">\r\n            <div class=\"imgSlide thumbnails\" *ngFor=\"let image of (selectedVariant.images)\">\r\n              <a [href]=\"imageUrl + image.path\">\r\n                <img [lazyLoad]=\"imageUrl + image.path\" [alt]=\"product.name\" #thisImage\r\n                  (error)=\"thisImage.src = defaultImage\">\r\n              </a>\r\n            </div>\r\n          </owl-carousel>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <div class=\"product-info\">\r\n          <div class=\"product-name\">\r\n            <h3 class=\"title\">\r\n              {{product | translate: 'name'}}\r\n            </h3>\r\n            <div class=\"product-review\">\r\n              <div class=\"rating\" *ngIf=\"reviewsFeature$ | async\">\r\n                <div class=\"rating--body\">\r\n                  <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\"></rating>\r\n                </div>\r\n              </div>\r\n              <!--End rating-->\r\n\r\n\r\n            </div>\r\n          </div>\r\n          <hr>\r\n\r\n          <!--End Product-review-->\r\n          <!-- <hr *ngIf=\"(reviewsFeature$ | async) || (compareFeature$ | async) ||  (wishListFeature$ | async)\"> -->\r\n\r\n          <div class=\"product-description\" *ngIf=\"product?.translations[language['LANGUAGE_CODE']].short_description\">\r\n            <p class=\"product-code\" *ngIf=\"selectedVariant.sku\">\r\n              <strong>SKU: </strong>{{ selectedVariant?.sku }}\r\n            </p>\r\n            <h3 class=\"short-desc\">\r\n              {{language['shortDescription']}}\r\n            </h3>\r\n            <p>\r\n              {{product | translate: 'short_description'}}\r\n            </p>\r\n          </div>\r\n          <!--End Product-description-->\r\n          <hr *ngIf=\"product.translations[language['LANGUAGE_CODE']]?.short_description\">\r\n\r\n          <div class=\"product-options\">\r\n\r\n            <!-- Dynamic For Names-->\r\n            <div class=\"form-group\" *ngFor=\"let option of product.options;let i = index;\">\r\n              <label class=\"control-label\">\r\n                {{ option | translate: 'name' }}\r\n              </label>\r\n              <div *ngIf=\"!option.view_as_thumbnail; else thumbnails\">\r\n\r\n                <select class=\"form-control\" [id]=\"option.code\" [title]=\"option.name\" [(ngModel)]=\"options[option.code]\"\r\n                  (change)=\"optionChanged(option.code, $event.target.value,i)\">\r\n                  <option disabled=\"true\">{{language['selectA']}}\r\n                    {{ (option | translate: 'name').toLowerCase() }}</option>\r\n                  <option *ngFor=\"let variant of option.option_values\" [value]=\"variant.code\">\r\n                    {{variant | translate: 'name'}}\r\n                  </option>\r\n                </select>\r\n              </div>\r\n              <ng-template #thumbnails>\r\n                <div class=\"check-radio-item inline with-img\" *ngFor=\"let variant of option.option_values;let i = index;\">\r\n                  <input type=\"radio\" [name]=\"option.name\" [value]=\"variant.code\" [id]=\"variant.code\"\r\n                    (click)=\"optionChanged(option.code, variant.code,i)\" onError=\"this.src=defaultImage;\">\r\n                  <label [for]=\"variant.code\" class=\"tooltip\">\r\n                    <img [lazyLoad]=\"imageUrl+variant.thumbnail\" alt=\"option image\" />\r\n                    <span class=\"tooltiptext\">{{variant | translate: 'name'}}</span>\r\n                  </label>\r\n                </div>\r\n\r\n              </ng-template>\r\n            </div>\r\n            <div class=\"form-group\" *ngIf=\"!product.hidePrice\">\r\n              <label>{{language['price']}}:</label>\r\n              <div class=\"product-price\">\r\n                <div *ngIf=\"variantUndefined; else variantAvailable\">{{language['itemNotAvailable']}}\r\n                </div>\r\n                <ng-template #variantAvailable>\r\n                  <div class=\"product-price\">\r\n                    <div class=\"price\" *ngIf=\"product.discounted\">\r\n                      <div class=\"price__sale\">\r\n                        {{ selectedVariant.prices[0].price / 100 | number}} {{currencyCode}}\r\n                      </div>\r\n                      <div class=\"price__original  price__original--discount\"\r\n                        *ngIf=\"selectedVariant.prices[0].original_price > 0\" [ngClass]=\"{hidden:!product.discounted}\">\r\n                        {{selectedVariant.prices[0].original_price / 100 | number}} {{currencyCode}}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"price\" *ngIf=\"!product.discounted\">\r\n                      <div class=\"price__sale\">\r\n                        {{ selectedVariant.prices[0].price / 100 | number}} {{currencyCode}}\r\n                      </div>\r\n                      <div class=\"price__original  price__original--discount\" [ngClass]=\"{hidden:!product.discounted}\">\r\n                        {{selectedVariant.prices[0].original_price / 100 | number}} {{currencyCode}}\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n\r\n                </ng-template>\r\n              </div>\r\n            </div>\r\n            <div *ngFor=\"let attribute of product.attributes;\">\r\n              <div *ngIf=\"attribute?.view_checked_attribute\" class=\"form-group\">\r\n                <label>{{attribute | translate: 'name'}}:</label>\r\n                <div class=\"product-price\">\r\n                  <div class=\"product-price\">\r\n                    <div *ngFor=\"let value of attribute.values; let l = last;\" class=\"price\">\r\n                      <div *ngIf=\"value?.view_checked_attribute\" class=\"price__sale\">\r\n                        {{value | translate: 'name'}}\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--End product-price-->\r\n          </div>\r\n          <!--End Product-options-->\r\n          <hr *ngIf=\"product.options?.length\">\r\n          <div class=\"product-action\">\r\n            <!-- <input class=\"form-control\" numbersOnly type=\"number\" title=\"quantity\" [(ngModel)]=\"quantity\"\r\n              (change)=\"quantityChanged()\" min=\"1\" [max]=\"max\" [disabled]=\"disableQuantity\"> -->\r\n\r\n            <div class=\"item-number\" *ngIf=\"!product.hidePrice\">\r\n              <button class=\"number-down\" (click)=\"quantity = quantity - 1\" [disabled]=\"quantity === 1 \"><i\r\n                  class=\"fa fa-minus\"></i></button>\r\n\r\n              <input class=\"form-control\" numbersOnly title=\"quantity\" type=\"number\" placeholder=\"quantity\"\r\n                (change)=\"quantityChanged()\" [(ngModel)]=\"quantity\" min=\"1\" [max]=\"max\" [disabled]=\"disableQuantity\">\r\n\r\n              <ng-container *ngIf=\"quantity === variant?.stock\">\r\n                <small class=\"text-danger\">{{language['max_quantity']}}</small>\r\n              </ng-container>\r\n              <button class=\"number-up\" (click)=\"quantity = quantity + 1\"\r\n                [disabled]=\"quantity === max || quantity>=4001  \"> <i class='fa fa-plus'></i> </button>\r\n\r\n            </div>\r\n          \r\n            <div *ngIf=\"!this.myStore.isContactUsInsteadAddCart; else elseBlock\">\r\n              <button class=\"custom-btn\" [ngClass]=\"{'no-items-remaining':max==0}\" (click)=\"addToCart()\" *ngIf=\"!product.hidePrice\"\r\n              [disabled]=\"(!canAddToCart || cartService.addedToCart.getValue() == false || max==0) && natureWorkB2b\" role=\"button\"\r\n              aria-label=\"add to cart\">\r\n              {{\r\n              max==0?language['noItemsRemaining']:\r\n              variantUndefined ? language['unavailbleItem'] :\r\n              (canAddToCart ? (cartService.addedToCart.getValue() !== false ? language['addToCart'] : language['addToCart'] )\r\n              : language['outOfStock'])\r\n              }}\r\n            </button>\r\n            <button class=\"custom-btn call-us\" *ngIf=\"product.isSupportCall\">\r\n              <a class=\"e-btn\" [href]=\"'tel:' + product.supprotNumber\">\r\n                <i class=\"fa fa-phone\" aria-hidden=\"true\"></i> Hotline\r\n              </a>\r\n            </button>\r\n\r\n            </div>\r\n            <ng-template #elseBlock>\r\n\r\n              <button class=\"custom-btn\" (click)=\"SwtichToContactUs()\" *ngIf=\"!product.hidePrice\"\r\n            \r\n              aria-label=\"contactUS\">\r\n              {{\r\n          language['contactUs']\r\n              }}\r\n            </button>\r\n\r\n\r\n\r\n            </ng-template>\r\n          \r\n\r\n            <div class=\"product-icon-btns\">\r\n              <button class=\"icon-btn\" *ngIf=\"wishListFeature$ | async\" [ngClass]=\"{'active': fav | async}\"\r\n                (click)=\"toggleWishList()\">\r\n                <i class=\"fa fa-heart\" aria-hidden=\"true\"></i>\r\n              </button>\r\n              <button class=\"icon-btn\" *ngIf=\"compareFeature$ | async\" [ngClass]=\"{'active': compare | async}\"\r\n                (click)=\"toggleCompare()\">\r\n                <i class=\"fa fa-random\" aria-hidden=\"true\"></i>\r\n              </button>\r\n            </div>\r\n            <!--End Product-icon-btns-->\r\n\r\n          </div>\r\n          <!--End Product-action-->\r\n\r\n          <!-- <hr>\r\n          <div class=\"product-share\">\r\n            <span class=\"share-text\">\r\n              {{language['share']}}\r\n            </span>\r\n            <ul class=\"social-list style2\">\r\n              <li>\r\n                <a href=\"\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i> </a>\r\n              </li>\r\n              <li>\r\n                <a href=\"\"><i class=\"fa fa-twitter\" aria-hidden=\"true\"></i> </a>\r\n              </li>\r\n              <li>\r\n                <a href=\"\"><i class=\"fa fa-google-plus\" aria-hidden=\"true\"></i> </a>\r\n              </li>\r\n            </ul>\r\n          </div> -->\r\n\r\n          <!--End Product-share-->\r\n          <hr>\r\n          <!-- <div class=\"product-action\">\r\n            <button class=\"custom-btn d-none\" (click)=\"downloadCatalogue()\" \r\n            [disabled]=\"!product['catalogPDF'] || product['catalogPDF'] == Null\" role=\"button\">\r\n            Download product catalogue\r\n          </button>\r\n          </div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!--End Row-->\r\n    <div class=\"reviews-section\">\r\n      <tabset>\r\n        <tab  [heading]=\"language['description']\"\r\n          [innerHTML]=\" product | translate: 'description' | noSanitizeHtml\" class=\"description\">\r\n        </tab>\r\n        <tab *ngIf=\"product.attributes?.length\" [heading]=\"language['specifications']\">\r\n          <table class=\"table table-hover\" id=\"attributes-table\">\r\n            <tr *ngFor=\"let attribute of product.attributes\">\r\n              <td>{{attribute | translate: 'name'}}</td>\r\n              <td>\r\n                <span *ngFor=\"let value of attribute.values; let l = last;\">\r\n                  {{value | translate: 'name'}}\r\n                  <ng-container *ngIf=\"!l\">, </ng-container>\r\n                </span>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </tab>\r\n        <tab *ngIf=\"reviewsFeature$ | async\" [heading]=\"language['reviews']\">\r\n          <div class=\"reviews\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-8\">\r\n                <form (submit)=\"submitReview()\" [formGroup]=\"reviewForm\" class=\"review-form\">\r\n                  <div class=\"form-group\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-8\">\r\n                        <input class=\"form-control\" formControlName=\"title\" placeholder=\"{{language['reviewTitle']}}\">\r\n                      </div>\r\n                      <!--End Col-->\r\n                      <div class=\"col-lg-4\">\r\n                        <div class=\"rating\">\r\n                          <rating (onLeave)=\"rateChange($event)\" [max]=\"maxRate\"></rating>\r\n                          <!--[(ngModel)]=\"rating\"-->\r\n                        </div>\r\n                      </div>\r\n                      <!--End Col-->\r\n                    </div>\r\n                    <!--End Row-->\r\n                  </div>\r\n                  <!--End form-group-->\r\n                  <div class=\"form-group\">\r\n                    <textarea class=\"form-control\" formControlName=\"comment\"\r\n                      placeholder=\"{{language['addYourcomment']}}\" rows=\"6\">\r\n                    </textarea>\r\n                  </div>\r\n                  <!--End class=\"form-group\"-->\r\n                  <div class=\"form-group\">\r\n                    <div class=\"row\">\r\n                      <div [ngClass]=\"{'d-none': logged$ | async}\" class=\"col-md-8\">\r\n                        <input class=\"form-control\" formControlName=\"email\" placeholder=\"{{language['email']}}\"\r\n                          type=\"email\">\r\n                      </div>\r\n                      <!--End col-->\r\n                      <div class=\"col-md-4\">\r\n                        <button [disabled]=\"reviewForm.invalid\" class=\"custom-btn\" type=\"submit\">\r\n                          {{language['add']}}\r\n                        </button>\r\n                      </div>\r\n                      <!--End Col-->\r\n                    </div>\r\n                    <!--End Row-->\r\n                  </div>\r\n                  <!--End class=\"form-group\"-->\r\n                </form>\r\n              </div>\r\n              <div class=\"col-md-4 align-self-center\">\r\n                <div class=\"rate-container\">\r\n                  <div class=\"circle m-auto\">{{rate | number: '1.1-1'}}</div>\r\n                  <div class=\"text-center\">\r\n                    <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\"></rating>\r\n                  </div>\r\n                </div>\r\n                <!--End rate=container-->\r\n              </div>\r\n              <!--End Col-->\r\n            </div>\r\n            <!--End row-->\r\n          </div>\r\n          <!--End reviews-->\r\n          <div class=\"row\">\r\n            <div class=\"col-md-8\">\r\n              <div *ngFor=\"let review of reviews$ | async\" class=\"review-comment\">\r\n                <div class=\"review-comment-head\">\r\n                  <rating [(ngModel)]=\"review.rating\" [max]=\"maxRate\" [readonly]=\"true\"></rating>\r\n                  <div class=\"user-date\">\r\n                    <span class=\"user-name\">{{review.author?.firstName}} {{review.author?.lastName}}</span>\r\n                    <span class=\"date\">On {{review.createdAt | date: 'yyyy-MM-dd hh:mm'}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"review-comment-content\">\r\n                  <h3 class=\"comment-title\">\r\n                    {{review.title}}\r\n                  </h3>\r\n                  <p>\r\n                    {{review.comment}}\r\n                  </p>\r\n                </div>\r\n              </div>\r\n              <!--End Review-comment-->\r\n            </div>\r\n            <!--End Col-->\r\n          </div>\r\n          <!--End Row-->\r\n\r\n        </tab>\r\n      </tabset>\r\n    </div>\r\n    <!--End Reviews-section-->\r\n\r\n  </div>\r\n  <!--End Container-->\r\n  <ng-content></ng-content>\r\n</section>\r\n<div *ngIf=\"!selectedVariant && !notFound\">\r\n  <app-inner-loading></app-inner-loading>\r\n</div>\r\n<!--End collection__spinner-->\r\n\r\n<div class=\"container\" *ngIf=\"notFound\">\r\n  <div class=\"empty-div\">\r\n    <p>\r\n      {{language['productNotFound']}}\r\n    </p>\r\n  </div>\r\n  <div class=\"text-center\">\r\n    <button routerLink=\"/collection\" class=\"custom-btn\">{{language['backToCollection']}}</button>\r\n  </div>\r\n</div>\r\n<!--End Container-->\r\n", styles: [":host .singleProduct{padding:5rem 0}:host .singleProduct .product-price .price{margin-top:10px;display:flex;justify-content:space-between}:host .singleProduct .product-price .price__sale{color:var(--main-color, orange);font-weight:700}:host .singleProduct .product-price .price__original{color:var(--main-color, orange);font-weight:700}:host .singleProduct .product-price .price__original--discount{color:#8e8e8e;text-decoration:line-through}:host .singleProduct .product-price div{display:inline-block;margin-right:1rem}:host .singleProduct .product-price div:last-child{margin:0!important}:host .singleProduct .product-price div.hidden{display:none!important}[dir=rtl] :host .singleProduct .product-price div{margin-right:auto;margin-left:1rem}:host .singleProduct .gallery .main-image-product{margin:auto;height:400px}:host .singleProduct .gallery .main-image-product .image-wrapper{display:flex;align-items:center;justify-content:center;height:400px}:host .singleProduct .gallery .main-image-product .image-wrapper img{width:auto;height:auto;max-width:100%;max-height:100%}:host .singleProduct .gallery .main-image-product .image-wrapper .loading-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host .singleProduct .gallery button.icon-btn.compare-btn.toggle{display:none}:host .singleProduct .gallery .gallery--img{width:100%}:host .singleProduct .gallery .thumbnails-wrapper{margin-top:1rem}:host .singleProduct .gallery .imgSlide.thumbnails{border-radius:7px;margin-top:1rem}:host .singleProduct .gallery .imgSlide.thumbnails a{display:flex;height:100px;align-items:center;justify-content:center}:host .singleProduct .gallery .imgSlide.thumbnails a:active,:host .singleProduct .gallery .imgSlide.thumbnails a:focus{border:1px solid var(--main-color, orange);padding:3px}:host .singleProduct .gallery .imgSlide.thumbnails img{width:auto;height:auto;max-width:100%;max-height:100%;border-radius:5px;overflow:hidden}:host .singleProduct .gallery ::ng-deep .carousel-control-prev,:host .singleProduct .gallery ::ng-deep .carousel-control-next{display:none}:host .singleProduct .gallery ::ng-deep .owl-carousel .owl-nav button.owl-prev,:host .singleProduct .gallery ::ng-deep .owl-carousel .owl-nav button.owl-next{position:absolute;top:40%;background:var(--main-color, orange);color:#fff;text-decoration:none;font-size:26px;width:30px;height:30px;line-height:26px;border-radius:4px;margin:0}:host .singleProduct .gallery ::ng-deep .owl-carousel .owl-nav button.owl-next{right:0}[dir=rtl] :host .singleProduct .gallery ::ng-deep .owl-carousel .owl-nav button.owl-next{right:auto;left:0}:host .singleProduct .gallery ::ng-deep .owl-carousel .owl-nav button.owl-prev{left:0}[dir=rtl] :host .singleProduct .gallery ::ng-deep .owl-carousel .owl-nav button.owl-prev{left:auto;right:0}:host .singleProduct .gallery .animate-fade{position:relative;-webkit-animation-name:animatefade;-webkit-animation-duration:1s;animation-name:animatefade;animation-duration:1s}@keyframes animatefade{0%{opacity:0}to{opacity:1}}:host .singleProduct .product-info .product-name{padding:1.5rem 0;display:block;align-items:center;justify-content:space-between}:host .singleProduct .product-info .product-name .title{font-weight:bold;color:var(--h3-color, #333);font-size:var(--h3-font-size, 1.8rem);margin:0}:host .singleProduct .product-info .product-review{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:1rem 0}:host .singleProduct .product-info .product-icon-btns .icon-btn{margin:0 .3rem}:host .singleProduct .product-info .product-description{padding:1rem 0}:host .singleProduct .product-info .product-description .short-desc{text-transform:capitalize;font-weight:bold}:host .singleProduct .product-info .product-options{padding:1.5rem 0}:host .singleProduct .product-info .product-options .no-items-remaining{background-color:#ff4500;width:auto}:host .singleProduct .product-info .product-options .form-group{display:flex;align-items:center;margin-bottom:2rem}:host .singleProduct .product-info .product-options .form-group label{width:30%;font-weight:bold}:host .singleProduct .product-info .product-options .form-group .form-control,:host .singleProduct .product-info .product-options .form-group .product-price{width:65%;border-radius:.5rem}:host .singleProduct .product-info .product-options .product-price{display:flex;align-items:center;justify-content:space-between}:host .singleProduct .product-info .product-options .product-price span.current-price{font-weight:bold;color:var(--main-color, #0099ff)}:host .singleProduct .product-info .product-options .product-price span.original-price{text-decoration:line-through;color:#9e9e9e}:host .singleProduct .product-info .product-options .check-radio-item{margin-bottom:1rem;margin-inline-end:1rem}:host .singleProduct .product-info .product-options .check-radio-item:last-child{margin-inline-end:0}:host .singleProduct .product-info .product-options .check-radio-item.inline{display:inline-block;vertical-align:middle}:host .singleProduct .product-info .product-options .check-radio-item.with-img input[type=radio]+label,:host .singleProduct .product-info .product-options .check-radio-item.with-img input[type=checkbox]+label{border-radius:3px;padding:0;width:50px;height:50px;border:1px solid transparent;transition:all .3s ease-in-out}:host .singleProduct .product-info .product-options .check-radio-item.with-img input[type=radio]+label img,:host .singleProduct .product-info .product-options .check-radio-item.with-img input[type=checkbox]+label img{max-width:100%;max-height:100%}:host .singleProduct .product-info .product-options .check-radio-item.with-img input[type=radio]:checked+label,:host .singleProduct .product-info .product-options .check-radio-item.with-img input[type=checkbox]:checked+label{border:1px solid var(--main-color, orange)}:host .singleProduct .product-info .product-options .check-radio-item input[type=radio],:host .singleProduct .product-info .product-options .check-radio-item input[type=checkbox]{position:absolute;width:0;height:0}:host .singleProduct .product-info .product-options .check-radio-item input[type=radio]+label,:host .singleProduct .product-info .product-options .check-radio-item input[type=checkbox]+label{position:relative;width:auto;padding:5px 20px;border:1px solid var(--main-color, orange);border-radius:3rem;background-color:#fff;color:#09f;font-size:1.4rem;line-height:2.5rem;text-transform:capitalize;cursor:pointer;margin-bottom:0}:host .singleProduct .product-info .product-options .check-radio-item input[type=radio]+label.tooltip,:host .singleProduct .product-info .product-options .check-radio-item input[type=checkbox]+label.tooltip{opacity:1}:host .singleProduct .product-info .product-options .check-radio-item input[type=radio]:checked+label,:host .singleProduct .product-info .product-options .check-radio-item input[type=checkbox]:checked+label{color:#fff;background-color:var(--main-color, orange);border-color:var(--main-color, orange)}:host .singleProduct .product-info .product-options .tooltip{position:relative;display:inline-block;border-bottom:1px dotted black}:host .singleProduct .product-info .product-options .tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;top:-50%;left:50%;transform:translate(-50%,-50%);z-index:1070}:host .singleProduct .product-info .product-options .tooltip .tooltiptext:after{content:\" \";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:black transparent transparent transparent}:host .singleProduct .product-info .product-options .tooltip:hover .tooltiptext{visibility:visible}:host .singleProduct .product-info .product-action{display:flex;flex-wrap:wrap;align-items:center;padding:1.5rem 0}@media (max-width: 315px){:host .singleProduct .product-info .product-action{flex-direction:column}}:host .singleProduct .product-info .product-action .item-number{position:relative;display:inline-block;min-width:108px;max-width:30.33333333%}:host .singleProduct .product-info .product-action .item-number>button{position:absolute;top:3px;left:3px;width:30px;height:30px;line-height:30px;text-align:center;border-radius:100%;background-color:transparent;color:var(--main-color)!important;border:1px solid var(--main-color);padding:0;cursor:pointer;transition:all .3s ease-in-out}:host .singleProduct .product-info .product-action .item-number>button.number-up{left:auto;right:3px}:host .singleProduct .product-info .product-action .item-number .form-control{height:36px;border:1px solid #333333;border-radius:40px;text-align:center;font-size:13px}:host .singleProduct .product-info .product-action .item-number .form-control[type=number]::-webkit-inner-spin-button,:host .singleProduct .product-info .product-action .item-number .form-control[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;margin:0}:host .singleProduct .product-info .product-action .item-number .form-control[type=number]{-moz-appearance:textfield}:host .singleProduct .product-info .product-action .custom-btn{width:auto;margin:0 10px;color:var(--main-color)}:host .singleProduct .product-info .product-action .custom-btn:hover{background-color:var(--main-color);color:#fff!important}@media (max-width: 315px){:host .singleProduct .product-info .product-action .custom-btn{margin:10px 0}}:host .singleProduct .product-info .product-share{display:flex;align-items:center;justify-content:flex-end;padding:1.5rem 0}:host .singleProduct .product-info .product-share .share-text{font-weight:bold;margin:0 1rem;text-transform:capitalize;font-size:1.8rem}:host .singleProduct .product-info .product-share .social-list{margin-bottom:0}:host .singleProduct .product-info .product-share .social-list.style2 li a .fa{display:block;line-height:3.8rem;color:#fff}:host .singleProduct .product-info .product-share .social-list.style2 li a .fa.fa-facebook{background-color:#2c42e7}:host .singleProduct .product-info .product-share .social-list.style2 li a .fa.fa-twitter{background-color:#09f}:host .singleProduct .product-info .product-share .social-list.style2 li a .fa.fa-google-plus{background-color:#c72323}:host .singleProduct .reviews-section{margin-top:3rem}:host .singleProduct .reviews-section ::ng-deep .tab-content>.tab-pane{padding:2.5rem;color:#575757;font-weight:600;font-size:1.6rem;background-color:#fff}:host .singleProduct .reviews-section ::ng-deep .tab-container .nav-tabs{border:0;padding-right:0}:host .singleProduct .reviews-section ::ng-deep .tab-container .nav-tabs .nav-item .nav-link{font-size:1.8rem;text-transform:uppercase;font-weight:600;padding:2rem;border:0;background-color:#e6e6e6}:host .singleProduct .reviews-section ::ng-deep .tab-container .nav-tabs .nav-item .nav-link.active{background-color:#fff;color:var(--main-color, #0099ff);border:0}:host .singleProduct .reviews-section ::ng-deep tab.description{word-break:break-word}:host .singleProduct .reviews-section .reviews{border-bottom:1px solid #f1f1f1}:host .singleProduct .reviews-section .reviews>.row>.col-md-8{border-right:1px solid #f1f1f1}[dir=rtl] :host .singleProduct .reviews-section .reviews>.row>.col-md-8{border-right:none;border-left:1px solid #f1f1f1}@media screen and (max-width: 767.98px){:host .singleProduct .reviews-section .reviews>.row>.col-md-8{border-right:0;border-left:0}[dir=rtl] :host .singleProduct .reviews-section .reviews>.row>.col-md-8{border-left:0}}:host .singleProduct .reviews-section .reviews .review-form .form-group{margin-bottom:1.5rem}:host .singleProduct .reviews-section .reviews .review-form .form-control{padding:.6rem 1.2rem;border-radius:.5rem}:host .singleProduct .reviews-section .reviews .review-form .custom-btn{min-width:12rem}@media all and (max-width: 767.98px){:host .singleProduct .reviews-section .reviews .review-form .custom-btn{margin-top:1.5rem;display:block;width:100%}}:host .singleProduct .reviews-section .reviews .rate-container{padding:1.5rem 0}:host .singleProduct .reviews-section .reviews .rate-container .circle{height:10rem;width:10rem;line-height:10rem;border:1px solid var(--main-color, orange);border-radius:50%;text-align:center;color:var(--main-color, orange);font-weight:600;font-size:3.5rem}:host .singleProduct .reviews-section .review-comment{padding:1.5rem 0}:host .singleProduct .reviews-section .review-comment .review-comment-head{display:flex;align-self:center;justify-content:space-between}:host .singleProduct .reviews-section .review-comment .review-comment-head .user-date .user-name{text-transform:capitalize;margin:0 10px;font-weight:bold}:host .singleProduct .reviews-section .review-comment .comment-title{text-transform:capitalize;font-weight:bold}:host .singleProduct .related-items .section-head .section-title{font-size:2.4rem}:host .d-none{display:none}:host #attributes-table td:first-child{color:#000;text-transform:uppercase;font-size:18px}:host #attributes-table td:last-child{width:100%;color:gray;font-size:16px}::ng-deep .main-image-product .item{background:#fff;text-align:center}::ng-deep .main-image-product .item a{width:400px;height:400px;display:inline-block}::ng-deep .gallery .carousel-control-prev-icon{background-color:var(--main-color, orange)}::ng-deep .gallery .carousel-control-next-icon{background-color:var(--main-color, orange)}::ng-deep .main-image-product .item a{width:100%;height:100%}::ng-deep .img-fluid{width:100%;height:100%}@media (max-width: 767px){::ng-deep button.icon-btn.compare-btn.toggle{display:block!important;position:absolute;top:0;right:36px;background:transparent;border:none;color:#5b5b5b}::ng-deep .easyzoom{pointer-events:none}}\n"], components: [{ type: i13.CarouselComponent, selector: "carousel", inputs: ["noWrap", "noPause", "showIndicators", "pauseOnFocus", "indicatorsByChunk", "itemsPerSlide", "singleSlideOffset", "isAnimated", "startFromIndex", "activeSlide", "interval"], outputs: ["activeSlideChange", "slideRangeChange"] }, { type: i13.SlideComponent, selector: "slide", inputs: ["active"] }, { type: SpinnerComponent, selector: "app-spinner" }, { type: i15.OwlCarousel, selector: "owl-carousel", inputs: ["carouselClasses", "options", "items"] }, { type: i10.RatingComponent, selector: "rating", inputs: ["max", "readonly", "titles", "customTemplate"], outputs: ["onHover", "onLeave"] }, { type: i17.TabsetComponent, selector: "tabset", inputs: ["vertical", "justified", "type"] }, { type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: NumberDirective, selector: "input[numbersOnly]" }, { type: i1$1.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i1$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i1$1.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i17.TabDirective, selector: "tab, [tab]", inputs: ["disabled", "removable", "customClass", "active", "heading", "id"], outputs: ["selectTab", "deselect", "removed"], exportAs: ["tab"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i2.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "translate": TranslatePipe, "async": i6.AsyncPipe, "number": i6.DecimalPipe, "noSanitizeHtml": NoSanitizeHtmlPipe, "date": i6.DatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductDetailsBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-product-details',
                    templateUrl: './product-details.base-component.html',
                    styleUrls: ['./product-details.base-component.scss'],
                    providers: [TranslatePipe, DynamicDialogConfig]
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: LanguageService }, { type: ProductService }, { type: CollectionService }, { type: CartService }, { type: WishListService }, { type: CompareService }, { type: BreadcrumbService }, { type: TranslatePipe }, { type: LoginService }, { type: i1$1.FormBuilder }, { type: i5.BsModalService }, { type: i6.Location }, { type: i3$1.ToastrService }, { type: i3.Title }, { type: i3.Meta }, { type: ConfService }, { type: i2.Router }, { type: GoogleAnalyticsService }, { type: GoogleTagManagerService }, { type: LanguageService }, { type: i4.BreakpointObserver }, { type: CheckoutService }, { type: ContactUsService }, { type: i12$1.DynamicDialogConfig }]; }, propDecorators: { thisImage: [{
                type: ViewChild,
                args: ['thisImage', { static: false }]
            }], productInput: [{
                type: Input
            }], thumbnailWrapper: [{
                type: ViewChild,
                args: ['thumbnailWrapper']
            }] } });

class QuickViewBaseComponent {
    constructor(languageService, compareService, wishlistService, cartService, confService, productService, router, quickViewService, toastr, langaugeService) {
        this.languageService = languageService;
        this.compareService = compareService;
        this.wishlistService = wishlistService;
        this.cartService = cartService;
        this.confService = confService;
        this.productService = productService;
        this.router = router;
        this.quickViewService = quickViewService;
        this.toastr = toastr;
        this.langaugeService = langaugeService;
        this.thumbnialOptions = {
            items: 2,
            margin: 5,
            autoWidth: true,
            autoHeight: true,
            navText: [
                '<i class="fa fa-angle-left"></i>',
                '<i class="fa fa-angle-right"></i>',
            ],
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 2,
                },
                576: {
                    items: 3,
                },
                768: {
                    items: 3,
                },
                991: {
                    items: 4,
                },
                1199: {
                    items: 4,
                },
            },
        };
        this.language = {};
        this.selectedOption = {};
        this.myEvent = new EventEmitter();
        this.max = new BehaviorSubject(1);
        this.quantity = 1;
        this.options = {};
        this.price = 0;
        this.imageUrl = environment.imageUrl;
        this.defaultImage = environment.defaultImage;
        this.variantExists = false;
        this.wishListFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.WISH_LIST));
        this.fav = Observable.create(false);
        this.isLoading = true;
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.modal = false;
        this.cartId = +localStorage.getItem('cartId');
        this.compare = Observable.create(false);
        this.maxRate = 5;
        this.rate = 5;
        this.compareFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.COMPARE));
        this.reviewsFeature$ = this.confService
            .getFeatures()
            .pipe(map((data) => data.login.original.response.response.features.REVIEWS));
        this.imgIsLoaded = false;
        this.imgSrc = '';
        this.carouselOptions = {
            margin: 10,
            items: 1,
            autoplayHoverPause: true,
            dots: false,
            nav: true,
            navSpeed: 1000,
            autoplaySpeed: 2000,
            slideTransition: 'linear',
        };
    }
    ngOnInit() {
        var _a, _b;
        if (this.product.productType) {
            this.productService
                .getProduct(this.product.slug, this.product.variant.code)
                .subscribe((product) => {
                this.isLoading = false;
                this.product = product;
                this.rate = product.rating;
                this.compare = this.compareService.inCompare(product.code);
                if (this.product.options && this.product['options'].length > 0) {
                    for (const option of this.product['options']) {
                        this.options[option.code] = '';
                    }
                }
                this.srtedVariant = this.quickViewService.sorteVariants(product);
                this.autoSelect();
                this.manageVariant();
                this.fav = this.wishlistService.inWishList(product.code);
                this.variant = this.selectedVariant
                    ? this.selectedVariant
                    : this.product['variants'][0];
                if (this.selectedVariant.images.length > 0) {
                    this.src = `${this.imageUrl}${this.selectedVariant.images[0].path}`;
                    this.thumbImgs = [...this.selectedVariant.images];
                }
                else {
                    this.src = `${this.imageUrl}${product.images[0].path}`;
                    this.thumbImgs = [...product.images];
                }
                this.prices = this.selectedVariant.prices[0];
                this.price =
                    this.prices.original_price > this.prices.price
                        ? this.prices.price
                        : this.prices.original_price;
                this.simple = this.product.options && product.options.length === 0;
                let maxSet = false;
                this.existsInCart = this.selectedVariant
                    ? this.cartService.checkIfVariantInCart(this.selectedVariant)
                    : false;
                if (this.existsInCart) {
                    this.max.next(this.selectedVariant.tracked
                        ? this.selectedVariant.stock - this.existsInCart[1]
                        : 4001);
                    this.variantExists = true;
                    maxSet = true;
                    this.quantity = 1;
                }
                if (!maxSet) {
                    this.max.next(this.selectedVariant.tracked
                        ? this.selectedVariant.stock
                        : 4001);
                    this.variantExists = true;
                    this.quantity = 1;
                }
            });
            this.modal = true;
        }
        else {
            this.isLoading = false;
            this.rate = this.product.rating;
            this.compare = this.compareService.inCompare(this.product.code);
            this.fav = this.wishlistService.inWishList(this.product.code);
            if (this.product.options && this.product['options'].length > 0) {
                for (const option of this.product['options']) {
                    this.options[option.code] = '';
                }
            }
            this.srtedVariant = this.quickViewService.sorteVariants(this.product);
            this.autoSelect();
            this.manageVariant();
            this.fav = this.wishlistService.inWishList(this.product.code);
            if (this.product.images.length > 0) {
                this.src = `${this.imageUrl}${this.product.images[0].path}`;
            }
            else {
                this.src = this.defaultImage;
            }
            this.variant = this.selectedVariant
                ? this.selectedVariant
                : this.product['variants'][0];
            if (((_b = (_a = this.selectedVariant) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                this.src = `${this.imageUrl}${this.selectedVariant.images[0].path}`;
                this.thumbImgs = [...this.selectedVariant.images];
            }
            else {
                this.src = `${this.imageUrl}${this.product.images[0].path}`;
                this.thumbImgs = [...this.product.images];
            }
            this.prices = this.selectedVariant.prices[0];
            this.price =
                this.prices.original_price > this.prices.price
                    ? this.prices.price
                    : this.prices.original_price;
            this.simple = this.product.options && this.product.options.length === 0;
            let maxSet = false;
            this.existsInCart = this.selectedVariant
                ? this.cartService.checkIfVariantInCart(this.selectedVariant)
                : false;
            if (this.existsInCart) {
                this.max.next(this.selectedVariant.tracked
                    ? this.selectedVariant.stock - this.existsInCart[1]
                    : 4001);
                this.variantExists = true;
                maxSet = true;
                this.quantity = 1;
            }
            if (!maxSet) {
                this.max.next(this.selectedVariant.tracked
                    ? this.selectedVariant.stock
                    : 4001);
                this.variantExists = true;
                this.quantity = 1;
            }
            this.modal = true;
        }
        this.getProductImg(this.product);
        this.languageService.getLanguage().subscribe((language) => {
            this.language = language;
        });
    }
    quantityChanged() {
        this.quantity = +this.quantity > this.max.value ? this.max.value : +this.quantity;
        if (this.quantity >= 4001) {
            this.toastr.error(`${this.language['MaxquantityMsg']}!`);
            return;
        }
    }
    /**
     *this fun gets called on the quickView component and product details page with tow btns to increment and decrement.
     the difference between this fun and previous one is that handle increment and decrement properly taking in consideration
     not exceed the max quantity.
     * @param event event to the object which event is dispatched (its target) to query weather + or - btn clicked
     */
    quantityChange(event) {
        if (event.target['attributes'].target.nodeValue === 'quantityUp') {
            if (this.quantity >= this.max.value) {
                return;
            }
            this.quantity += 1;
        }
        else if (event.target['attributes'].target.nodeValue === 'quantityDown') {
            if (this.quantity == 1) {
                return;
            }
            this.quantity -= 1;
        }
    }
    optionChanged(code, value) {
        var _a, _b;
        this.selectedOption[code] = value;
        this.manageVariant();
        const selectedVariantCode = this.selectedVariant
            ? this.selectedVariant.code
            : '';
        if (((_b = (_a = this.selectedVariant) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            this.src = `${this.imageUrl}${this.selectedVariant.images[0].path}`;
            this.thumbImgs = [...this.selectedVariant.images];
        }
        else {
            this.src = `${this.imageUrl}${this.product.images[0].path}`;
            this.thumbImgs = [...this.product.images];
        }
    }
    toggleWishList() {
        this.languageUrl = this.router.url
            .split('/')
            .filter((data) => data !== '')[0];
        if (localStorage.getItem('user_firstName') ||
            sessionStorage.getItem('user_firstName')) {
            this.wishlistService.toggleWishList(this.product.code);
        }
        else {
            this.quickViewService.close();
            this.myEvent.emit();
            this.router.navigate(['/', this.languageUrl, 'accounts', 'login']);
        }
    }
    manageVariant() {
        if (this.product === undefined) {
            return;
        }
        const variant = this.cartService.getVariant(this.product, this.selectedOption);
        if (variant === undefined) {
            this.canAddToCart = false;
            this.disableQuantity = true;
            this.variantUndefined = true;
            // Imm, so the selectedVariant is undefined!! , so lets set a default one:)
            this.selectedVariant = this.product['variants'][0];
            return;
        }
        this.selectedVariant = variant;
        if (variant.tracked === false) {
            this.canAddToCart = true;
            this.disableQuantity = false;
            this.max.next(4001);
            this.variantUndefined = false;
            return;
        }
        else {
            this.max.next(variant['stock']);
        }
        this.max.next(variant['stock']);
        if (variant['stock'] <= 0) {
            this.canAddToCart = false;
            this.disableQuantity = true;
            this.variantUndefined = false;
            return;
        }
        this.canAddToCart = true;
        this.variantUndefined = false;
        this.disableQuantity = false;
    }
    addToCart() {
        const variant = this.cartService.getVariant(this.product, this.selectedOption);
        if (variant) {
            this.cartService.addToCart(variant, this.quantity, this.product);
            this.myEvent.emit();
        }
        else {
            throw 'cant get product varinat ';
        }
    }
    autoSelect() {
        if (!this.product.options) {
            return;
        }
        for (const option of this.product.options) {
            if (option.option_values.length > 0) {
                let option_values_found = false;
                this.product.variants.forEach((element, e) => {
                    if (element.code === this.defaultVariantCode) {
                        if (option.option_values[e]) {
                            this.options[option.code] = option.option_values[e].code;
                            this.optionChanged(option.code, option.option_values[e].code);
                            option_values_found = true;
                        }
                    }
                    if (e === this.product.variants.length - 1 &&
                        option_values_found === false) {
                        this.options[option.code] = option.option_values[0].code;
                        this.optionChanged(option.code, option.option_values[0].code);
                    }
                });
            }
        }
    }
    toggleCompare() {
        this.compareService.toggleCompare(this.product.code);
    }
    getProductImg(product) {
        this.imgIsLoaded = false;
        this.imgSrc = null;
        this.imgSrc = ProductService.getImage(product);
    }
    close() {
        this.quickViewService.closeQuickViewVisibility();
    }
    ngOnDestroy() {
        this.quickViewService.close();
    }
    changeCarouselOptions(options = {}) {
        return Object.assign(Object.assign(Object.assign({}, this.carouselOptions), options), { rtl: this.language['DIR'] === 'rtl' });
    }
}
QuickViewBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: QuickViewBaseComponent, deps: [{ token: LanguageService }, { token: CompareService }, { token: WishListService }, { token: CartService }, { token: ConfService }, { token: ProductService }, { token: i2.Router }, { token: QuickViewService }, { token: i3$1.ToastrService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
QuickViewBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: QuickViewBaseComponent, selector: "app-base-quick-view", inputs: { product: "product" }, outputs: { myEvent: "myEvent" }, ngImport: i0, template: "<div class=\"modal-dialog modal-dialog-centered modal-md\">\r\n  <div class=\"modal-content\">\r\n    <!-- Close the model -->\r\n    <div class=\"modal-header p-0\">\r\n      <button (click)=\"myEvent.emit();close()\" aria-label=\"Close\" class=\"close\" type=\"button\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <!-- Model content -->\r\n    <div class=\"modal-body p-0\">\r\n      <div class=\"container-fluid\">\r\n        <!--Spinner loading-->\r\n        <div *ngIf=\"!selectedVariant\">\r\n          <app-inner-loading></app-inner-loading>\r\n        </div>\r\n        <!-- Quick view content -->\r\n        <div class=\"quickview_product\" *ngIf=\"selectedVariant\">\r\n          <div class=\"row sm-gutters\">\r\n            <!--Image of product-->\r\n            <div class=\"col-md-5 d-flex justify-content-center align-items-center\">\r\n              <!-- <div class=\"spinner widget-img d-inline-flex justify-content-center align-items-center\"\r\n                *ngIf=\"!imgIsLoaded\">\r\n                <app-spinner></app-spinner>\r\n              </div> -->\r\n              <img class=\"quickview_product-img responsive-image-container\" [lazyLoad]=\"src\" (load)=\"imgIsLoaded = true\" [errorImage]=\"defaultImage\"\r\n                [alt]=\"product.name\">\r\n            </div>\r\n\r\n            <!--Product info-->\r\n            <div class=\"col-md-7\">\r\n              <div class=\"quickview_product-content\">\r\n                <!-- Product name -->\r\n                <div>\r\n                  <h2 class=\"modal-title\" id=\"dialog-child-name\">\r\n                    <a class=\"product-title\" (click)=\"myEvent.emit()\"\r\n                      [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product',  product | translate: 'slug']\">\r\n                      {{product | translate : 'name'}}\r\n                    </a>\r\n                  </h2>\r\n                </div>\r\n                <div class=\"rating--icons\"\r\n                  *ngIf=\"(reviewsFeature$ | async) || (wishListFeature$ | async) || (compareFeature$ | async)\">\r\n                  <!-- Rating product -->\r\n                  <div class=\"product-rating\" *ngIf=\"reviewsFeature$ | async\">\r\n                    <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\">\r\n                    </rating>\r\n                  </div>\r\n\r\n                  <div>\r\n                    <!-- Add to wishlist btn -->\r\n                    <button *ngIf=\"wishListFeature$ | async\" [ngClass]=\"{'active': fav | async}\" class=\"icon-btn\"\r\n                      (click)=\"toggleWishList()\">\r\n                      <i class=\"fa fa-heart icon--hover\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    <!-- Add to compare btn -->\r\n                    <button *ngIf=\"compareFeature$ | async\" [ngClass]=\"{ 'active' : compare | async}\" class=\"icon-btn\"\r\n                      (click)=\"toggleCompare()\">\r\n                      <i class=\"fa fa-random icon--hover\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                  </div>\r\n\r\n                </div>\r\n                <!-- Product description -->\r\n                <div class=\"description--code\">\r\n                  <p class=\"product-code\" *ngIf=\"selectedVariant.sku\">\r\n                    <strong>SKU: </strong>{{ selectedVariant?.sku }}\r\n                  </p>\r\n                  <!-- Short description for the product -->\r\n                  <p class=\"product-short-desc\" [innerHTML]=\"product | translate: 'short_description'\"></p>\r\n                </div>\r\n                <!-- Actions to the product [quantity, options] -->\r\n                <div class=\"product-actions\">\r\n                  <div class=\"product-options\" *ngFor=\"let option of product.options\">\r\n                    <div class=\"form-group\">\r\n                      <div class=\"row pt-3\">\r\n                        <div class=\"col-4 d-flex align-items-center\">\r\n                          <label class=\"m-0\">{{option | translate: 'name'}}</label>\r\n                        </div>\r\n                        <div class=\"col-8\">\r\n                          <div *ngIf=\"!option.view_as_thumbnail; else thumbnails\">\r\n\r\n                            <select class=\"form-control\" [(ngModel)]=\"options[option.code]\"\r\n                              (change)=\"optionChanged(option.code, $event.target.value)\"\r\n                              title=\"{{option | translate: 'name'}}\">\r\n                              <option value=\"\" disabled=\"true\">{{language['selectA']}}\r\n                                {{option | translate: 'name'}}</option>\r\n                              <option *ngFor=\"let variant of option.option_values\" [value]=\"variant.code\">\r\n                                {{variant | translate: 'name'}}\r\n                              </option>\r\n                            </select>\r\n                          </div>\r\n                          <ng-template #thumbnails>\r\n                            <div class=\"check-radio-item inline with-img\" *ngFor=\"let variant of option.option_values\">\r\n                              <input type=\"radio\" [name]=\"option.name\" [value]=\"variant.code\" [id]=\"variant.code\"\r\n                                (click)=\"optionChanged(option.code, variant.code)\" onError=\"this.src=defaultImage;\">\r\n                              <label [for]=\"variant.code\" class=\"tooltip\">\r\n                                <img [lazyLoad]=\"imageUrl+variant.thumbnail\" [alt]=\"variant.name\"  [errorImage]=\"defaultImage\"/>\r\n                                <span class=\"tooltiptext\">{{variant.name}}</span>\r\n                              </label>\r\n                            </div>\r\n\r\n                          </ng-template>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <!--End Form-group-->\r\n                  </div>\r\n                  <!--End Options-->\r\n                  <div class=\"product-price row m-0\" *ngIf=\"!product.hidePrice\">\r\n                    <div class=\"col-3 pl-0\">\r\n                      <span class=\"text-uppercase\">{{language['price']}}</span>\r\n                    </div>\r\n                    <div class=\"current--original col-9 p-0 text-center\">\r\n                      <div *ngIf=\"variantUndefined; else variantAvailable\">{{language['itemNotAvailable']}}</div>\r\n                      <div #variantAvailable>\r\n                        <div *ngIf=\"product.productType\">\r\n                          <span class=\"current-price pr-3\">\r\n                            {{selectedVariant.prices[0].price / 100 | number }} {{currencyCode}}\r\n                          </span>\r\n                          <span class=\"original-price\"\r\n                            *ngIf=\"product.discounted && selectedVariant.prices[0].original_price > 0\">\r\n                            {{selectedVariant.prices[0].original_price / 100 | number }} {{currencyCode}}\r\n                          </span>\r\n                        </div>\r\n                        <div *ngIf=\"!product.productType\">\r\n                          <span class=\"current-price pr-3\">\r\n                            {{selectedVariant.prices[0].price / 100 | number }} {{currencyCode}}\r\n                          </span>\r\n                          <span class=\"original-price\"\r\n                            *ngIf=\"product.discounted && selectedVariant.prices[0].original_price > 0\">\r\n                            {{selectedVariant.prices[0].original_price / 100 | number }} {{currencyCode}}\r\n                          </span>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!--End Product-price-->\r\n                </div>\r\n              </div>\r\n              <div class=\"btn--quantity pt-4 row m-0\" *ngIf=\"!product.hidePrice\">\r\n                <div class=\"form-group col-4 \">\r\n                  <input class=\"form-control\" numbersOnly type=\"number\" [(ngModel)]=\"quantity\"\r\n                    (change)=\"quantityChanged()\" min=\"1\" [max]=\"max\" [disabled]=\"disableQuantity\" title=\"quantity\">\r\n                </div>\r\n                <!--End Form-group-->\r\n                <div class=\"form-group col-8 p-0\">\r\n                  <button class=\"custom-btn w-100\" [ngClass]=\"{'no-items-remaining':max.value==0}\" (click)=\"addToCart()\"\r\n                    [disabled]=\"!canAddToCart || cartService.addedToCart.getValue() == false || max.value==0\">\r\n                    <!-- {{canAddToCart ? language['addToCart'] : language['outOfStock']}} -->\r\n                    {{language['addToCart']}}\r\n                    </button>\r\n                </div>\r\n                <!--End Form-group-->\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":host ::ng-deep ::-webkit-scrollbar{width:.5rem;-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out}:host ::ng-deep ::-webkit-scrollbar-track{background:#f1f1f1}:host ::ng-deep ::-webkit-scrollbar-thumb{background-color:#ccc;-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out;border-radius:15px}:host ::ng-deep ::-webkit-scrollbar-thumb:hover{background-color:var(--main-color, orange);cursor:pointer}:host ::ng-deep .modal.show .modal-dialog{transform:unset}:host ::ng-deep .modal-dialog{width:700px;height:370px;min-height:unset;max-width:unset;position:absolute;transform:translate(-50%,-50%)!important;top:50%;left:50%}:host ::ng-deep .modal-content{position:absolute;transform:translate(-50%,-50%);top:50%;left:50%}:host ::ng-deep .modal-dialog-centered{min-height:unset}:host ::ng-deep .modal.fade .modal-dialog{transform:unset}:host ::ng-deep .modal-dialog{margin:1.75rem auto;max-width:700px}:host ::ng-deep .modal-dialog .modal-content{height:auto;border-radius:1.5rem}:host ::ng-deep .modal-dialog .modal-content .modal-header{border-bottom:none}:host ::ng-deep .modal-dialog .modal-content .modal-header .modal-title{text-transform:capitalize;font-size:22px;font-weight:bold;padding:15px!important}:host ::ng-deep .modal-dialog .modal-content .modal-header .close{cursor:pointer;padding:0;width:4rem;height:4rem;line-height:4rem;font-size:2.5rem;background-color:var(--main-color, orange);color:var(--main-second-color, #ffffff);font-weight:bold;font-family:fantasy;position:absolute;z-index:10;border-radius:50%;top:-2px;right:0;opacity:1;text-shadow:none;transition:all .3s ease-in-out}[dir=rtl] :host ::ng-deep .modal-dialog .modal-content .modal-header .close{right:auto;left:0;margin-left:-1rem!important}:host ::ng-deep .modal-dialog .modal-content .modal-header .close:hover,:host ::ng-deep .modal-dialog .modal-content .modal-header .close:focus{background-color:var(--main-second-color, #ffffff);color:#fff}:host ::ng-deep .check-radio-item{margin-bottom:1rem;margin-inline-end:1rem}:host ::ng-deep .check-radio-item:last-child{margin-inline-end:0}:host ::ng-deep .check-radio-item.inline{display:inline-block;vertical-align:middle}:host ::ng-deep .check-radio-item.with-img input[type=radio]+label,:host ::ng-deep .check-radio-item.with-img input[type=checkbox]+label{border-radius:3px;padding:0;width:50px;height:50px;border:1px solid transparent;transition:all .3s ease-in-out}:host ::ng-deep .check-radio-item.with-img input[type=radio]+label img,:host ::ng-deep .check-radio-item.with-img input[type=checkbox]+label img{max-width:100%;max-height:100%}:host ::ng-deep .check-radio-item.with-img input[type=radio]:checked+label,:host ::ng-deep .check-radio-item.with-img input[type=checkbox]:checked+label{border:1px solid var(--main-color, orange)}:host ::ng-deep .check-radio-item input[type=radio],:host ::ng-deep .check-radio-item input[type=checkbox]{position:absolute;width:0;height:0}:host ::ng-deep .check-radio-item input[type=radio]+label,:host ::ng-deep .check-radio-item input[type=checkbox]+label{position:relative;width:auto;padding:5px 20px;border:1px solid var(--main-color, orange);border-radius:3rem;background-color:#fff;color:#09f;font-size:1.4rem;line-height:2.5rem;text-transform:capitalize;cursor:pointer;margin-bottom:0}:host ::ng-deep .check-radio-item input[type=radio]+label.tooltip,:host ::ng-deep .check-radio-item input[type=checkbox]+label.tooltip{opacity:1}:host ::ng-deep .check-radio-item input[type=radio]:checked+label,:host ::ng-deep .check-radio-item input[type=checkbox]:checked+label{color:#fff;background-color:var(--main-color, orange);border-color:var(--main-color, orange)}@media all and (max-width: 767.98px){:host ::ng-deep .modal-dialog{margin:1rem}}:host ::ng-deep .form-control:focus{border-color:inherit;box-shadow:none;outline:none}:host .icon-btn{margin:0 5px}:host .quickview_product .quickview_product-img{flex-shrink:0;height:auto;max-width:100%}:host .quickview_product .no-items-remaining{background-color:#ff4500;width:auto}:host .quickview_product .quickview_product-content{max-height:350px;overflow-Y:auto;margin-top:20px;margin-right:3px;padding-right:30px;border-bottom:1px solid #ddd}:host .quickview_product .quickview_product-content .product-title{color:var(--body-link-color, #000);font-size:var(--body-link-font-size, 22px);display:block;padding-bottom:12px;border-bottom:1px solid #ddd}:host .quickview_product .quickview_product-content .product-price{display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;padding:1rem 0;margin-bottom:2rem}:host .quickview_product .quickview_product-content .product-price .current-price{color:#1ca60c;font-weight:bold;font-size:1.8rem}:host .quickview_product .quickview_product-content .product-price .original-price{font-size:1.6rem;color:#6c757d;text-decoration:line-through;font-weight:bold}:host .quickview_product .quickview_product-content .product-short-desc{font-size:16px;color:#505050}:host .quickview_product .quickview_product-content .product-actions .custom-btn,:host .quickview_product .quickview_product-content .product-actions .icon-btn{margin:0 .5rem;display:inline-block;vertical-align:middle}:host .quickview_product .quickview_product-content .product-actions .product-options{padding:1.5rem 0}:host .quickview_product .quickview_product-content .product-actions .product-options .form-group{display:flex;align-items:center;margin-bottom:2rem}:host .quickview_product .quickview_product-content .product-actions .product-options .form-group label{width:30%;font-weight:bold}:host .quickview_product .quickview_product-content .product-actions .product-options .form-group .form-control,:host .quickview_product .quickview_product-content .product-actions .product-options .form-group .product-price{width:65%;border-radius:.5rem}:host .quickview_product .quickview_product-content .product-actions .product-options .product-price{display:flex;align-items:center;justify-content:space-between}:host .quickview_product .quickview_product-content .product-actions .product-options .product-price span.current-price{font-weight:bold;color:var(--main-color, #0099ff)}:host .quickview_product .quickview_product-content .product-actions .product-options .product-price span.original-price{text-decoration:line-through;color:#9e9e9e}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item{margin-bottom:1rem;margin-inline-end:1rem}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item:last-child{margin-inline-end:0}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item.inline{display:inline-block;vertical-align:middle}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item.with-img input[type=radio]+label,:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item.with-img input[type=checkbox]+label{border-radius:3px;padding:0;width:50px;height:50px;border:1px solid transparent;transition:all .3s ease-in-out}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item.with-img input[type=radio]+label img,:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item.with-img input[type=checkbox]+label img{max-width:100%;max-height:100%}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item.with-img input[type=radio]:checked+label,:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item.with-img input[type=checkbox]:checked+label{border:1px solid var(--main-color, orange)}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=radio],:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=checkbox]{position:absolute;width:0;height:0}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=radio]+label,:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=checkbox]+label{position:relative;width:auto;padding:5px 20px;border:1px solid var(--main-color, orange);border-radius:3rem;background-color:#fff;color:#09f;font-size:1.4rem;line-height:2.5rem;text-transform:capitalize;cursor:pointer;margin-bottom:0}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=radio]+label.tooltip,:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=checkbox]+label.tooltip{opacity:1}:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=radio]:checked+label,:host .quickview_product .quickview_product-content .product-actions .product-options .check-radio-item input[type=checkbox]:checked+label{color:#fff;background-color:var(--main-color, orange);border-color:var(--main-color, orange)}:host .quickview_product .quickview_product-content .product-actions .product-options .tooltip{position:relative;display:inline-block;border-bottom:1px dotted black}:host .quickview_product .quickview_product-content .product-actions .product-options .tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;top:-50%;left:50%;transform:translate(-50%,-50%);z-index:1070}:host .quickview_product .quickview_product-content .product-actions .product-options .tooltip .tooltiptext:after{content:\" \";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:black transparent transparent transparent}:host .quickview_product .quickview_product-content .product-actions .product-options .tooltip:hover .tooltiptext{visibility:visible}:host .quickview_product .quickview_product-content a{text-decoration:none}:host .quickview_product .quickview_product-content .rating--icons{display:flex;justify-content:space-between;border-bottom:1px solid #ddd;padding:12px 0}:host .quickview_product .quickview_product-content .description--code{border-bottom:1px solid #ddd;padding-top:12px}:host .quickview_product-content .description--code{padding:12px 0}:host .quickview_product .quickview_product-content{padding:0}:host .current--original{display:flex;justify-content:flex-end}:host .icon-btn:last-child{margin-right:0}:host .form-group{margin-bottom:0}:host .btn--quantity{align-items:center;justify-content:space-between}:host .btn--quantity>div{margin-left:-15px;margin-right:15px}[dir=rtl] :host .btn--quantity>div{margin-right:-15px;margin-left:15px}:host .btn--quantity>div:last-child{margin-right:0}[dir=rtl] :host .btn--quantity>div:last-child{margin-left:0}:host .quickview_product{padding:15px 0}[dir=rtl] :host .product-price div:first-child span{margin-right:-15px}[dir=rtl] :host .quickview_product-content .product-price .current-price{margin-left:10px;display:inline-block}:host input.form-control{border:1px solid!important}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }, { type: i10.RatingComponent, selector: "rating", inputs: ["max", "readonly", "titles", "customTemplate"], outputs: ["onHover", "onLeave"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: NumberDirective, selector: "input[numbersOnly]" }, { type: i1$1.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i1$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i1$1.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }], pipes: { "translate": TranslatePipe, "async": i6.AsyncPipe, "number": i6.DecimalPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: QuickViewBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-quick-view',
                    templateUrl: './quick-view.base-component.html',
                    styleUrls: ['./quick-view.base-component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CompareService }, { type: WishListService }, { type: CartService }, { type: ConfService }, { type: ProductService }, { type: i2.Router }, { type: QuickViewService }, { type: i3$1.ToastrService }, { type: LanguageService }]; }, propDecorators: { product: [{
                type: Input
            }], myEvent: [{
                type: Output
            }] } });

class TagsBaseComponent {
    constructor(collectionService, _router, _activatedRoute, languageService) {
        this.collectionService = collectionService;
        this._router = _router;
        this._activatedRoute = _activatedRoute;
        this.languageService = languageService;
        this.attributes = {};
        this.options = {};
        this.taxons = [];
        this.designers = [];
        this.taxonsArray = [];
        this.designersArray = [];
        this.tags = [];
        this.language = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.collectionService.filter.subscribe(filter => {
            if (!filter ||
                filter['attribute'].length === 0 &&
                    filter['options'].length === 0 &&
                    filter['taxons'].length === 0) {
                this.filter = false;
                return;
            }
            this.filter = filter;
            for (const attribute of filter['attribute']) {
                this.attributes[attribute.code] = {};
                for (const value of attribute.values) {
                    this.attributes[attribute.code][value.code] = value.name;
                }
            }
            for (const option of filter['options']) {
                this.options[option.code] = {};
                for (const value of option.option_values) {
                    this.options[option.code][value.code] = value.name;
                }
            }
            const stack = filter['taxons'].slice();
            while (stack.length > 0) {
                const taxon = stack.pop();
                if (taxon.children) {
                    stack.push(...taxon.children);
                }
                this.taxonsArray[taxon.code] = taxon;
            }
            this._activatedRoute.queryParams.subscribe(params => {
                this.tags = [];
                this.params = params;
                this.taxons = params['taxons'] ? params['taxons'].split(',') : [];
                this.designers = params['designers'] ? params['designers'].split(',') : [];
                let options;
                let attributes;
                // set price
                if (params['price']) {
                    const price = params['price'].split(':');
                    this.price = `${price[0] / 100}:${price[1] / 100}`;
                }
                else {
                    this.price = false;
                }
                // set the option tags
                if (params['options']) {
                    options = CollectionService.explode(params['options']);
                }
                else {
                    options = [];
                }
                for (const option of options) {
                    const key = Object.keys(option)[0];
                    let i = this.tags.find(tag => {
                        return tag.key === key;
                    });
                    if (i === undefined) {
                        this.tags.push({
                            type: 'options',
                            key: key,
                            values: [],
                        });
                    }
                    i = this.tags.length - 1;
                    this.tags[i]['values'].push({
                        name: this.options[key][option[key]],
                        code: option[key]
                    });
                }
                // set the attribute tags
                if (params['attributes']) {
                    attributes = CollectionService.explode(params['attributes']);
                }
                else {
                    attributes = [];
                }
                for (const attribute of attributes) {
                    const key = Object.keys(attribute)[0];
                    let i = this.tags.find(tag => {
                        return tag.key === key;
                    });
                    if (i === undefined) {
                        this.tags.push({
                            type: 'attributes',
                            key: key,
                            values: [],
                        });
                    }
                    i = this.tags.length - 1;
                    this.tags[i]['values'].push({
                        name: this.attributes[key][attribute[key]],
                        code: attribute[key]
                    });
                }
            });
        });
    }
    /**
   * @inputs
   * type: attributes or options
   * option: attributes/options name
   * value: attributes/options value
   *
   * @output
   * void
   *
   * @functionality
   * remove the select value from the url and reroute to it so it get executed
   * */
    remove(type, option, code) {
        this.collectionService.changeFilter(type, option, code, false);
    }
    // change price range in the url
    removeX(x) {
        let newParams;
        newParams = Object.assign({}, this.params);
        delete newParams[x];
        newParams['page'] = 1;
        this._router.navigate(['/', this.language['LANGUAGE_CODE'], 'collection'], { queryParams: newParams });
    }
    // remove taxon from the url
    removeTaxon(taxon) {
        this.collectionService.changeTaxon(taxon, false);
    }
}
TagsBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TagsBaseComponent, deps: [{ token: CollectionService }, { token: i2.Router }, { token: i2.ActivatedRoute }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
TagsBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: TagsBaseComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: TagsBaseComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return [{ type: CollectionService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: LanguageService }]; } });

class CompareBaseComponent {
    constructor(languageService, compareService, quickViewService, breakpointObserver, translatePipe, confService) {
        this.languageService = languageService;
        this.compareService = compareService;
        this.quickViewService = quickViewService;
        this.breakpointObserver = breakpointObserver;
        this.translatePipe = translatePipe;
        this.confService = confService;
        this.language = {};
        this.defaultImage = environment.defaultImage;
        this.noProducts = false;
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.showContent = this.id == 12849 ? true : false;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.compareService.getCompareList().subscribe(data => {
            this.products = data['products'];
            this.options = data['filter']['options'];
            this.attributes = data['filter']['attribute'];
            if (!this.products || !this.products.length) {
                this.noProducts = true;
                return;
            }
        });
    }
    getProdOpt(product, option) {
        let optionVlaues = [];
        if (product.options.length > 0) {
            for (let prodOpt of product.options) {
                if (prodOpt.code == option.code) {
                    if (prodOpt.option_values.length > 0) {
                        for (let prodOptionVal of prodOpt.option_values) {
                            optionVlaues.push(prodOptionVal.name);
                        }
                    }
                }
            }
        }
        return optionVlaues.length > 0 ? optionVlaues.join(" , ") : "-";
    }
    getProdAttr(product, attr) {
        let attrValues = [];
        if (product.attributes.length > 0) {
            for (let prodAttr of product.attributes) {
                if (prodAttr.code == attr.code) {
                    if (prodAttr.values.length > 0) {
                        for (let value of prodAttr.values) {
                            attrValues.push(this.translatePipe.transform(value, 'name'));
                        }
                    }
                }
            }
        }
        return attrValues.length > 0 ? attrValues.join(" , ") : "-";
    }
    removeCompare(code) {
        this.compareService.toggleCompare(code);
    }
    clearCompare() {
        this.compareService.clearCompare();
    }
    openQuickView(product) {
        this.quickViewService.open(product);
    }
    ngOnDestroy() {
        this.quickViewService.close();
    }
}
CompareBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompareBaseComponent, deps: [{ token: LanguageService }, { token: CompareService }, { token: QuickViewService }, { token: i4.BreakpointObserver }, { token: TranslatePipe }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
CompareBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CompareBaseComponent, selector: "app-base-compare", ngImport: i0, template: "<div class=\"compare-page\">\r\n  <div class=\"compare-page-head\">\r\n    <div class=\"container\">\r\n      <div class=\"d-flex justify-content-between align-items-center\">\r\n        <div class=\"\">\r\n          <p class=\"header-title\"> {{language['compare']}}</p>\r\n        </div>\r\n        <div class=\"\">\r\n          <div class=\"header-buttons\" *ngIf=\"products && products.length > 0 \">\r\n            <button class=\"custom-btn\" (click)=\"clearCompare()\">{{language['remove']}}</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- Start Loading Spinner-->\r\n  <div *ngIf=\"products?.length < 1 && !noProducts\">\r\n    <app-inner-loading></app-inner-loading>\r\n  </div>\r\n  <!--End collection__spinner-->\r\n  <div class=\"container\" *ngIf=\" !noProducts; else showMessage\">\r\n    <div *ngIf=\"products\" style=\"overflow-x: auto\">\r\n      <table aria-describedby=\"Compared products list\">\r\n        <tr>\r\n          <th *ngIf=\"!showContent\">{{products.length}} {{language['product/s']}}</th>\r\n          <th *ngIf=\"showContent\">{{products.length}} {{(language['LANGUAGE_CODE'] === 'en_US' ? \"Course/s\" : \"\u0643\u0648\u0631\u0633\")}}</th>\r\n          <td class=\"compare-item\" *ngFor=\"let product of products\">\r\n            <div class=\"compare-item-head\">\r\n              <!-- Quick view div  -->\r\n              <div class=\"compare-item-hover\">\r\n                <button (click)=\"openQuickView(product)\" class=\"custom-btn d-none d-md-inline\">\r\n                  {{language['quickView']}}\r\n                </button>\r\n                <a class=\"custom-btn d-inline d-md-none\"\r\n                  [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product',  product | translate: 'slug']\">\r\n                  <i class=\"fa fa-shopping-cart\"></i>\r\n                  <!--<span>{{language['addToCart']}}</span>-->\r\n                </a>\r\n                <button class=\"remove\" (click)=\"removeCompare(product.code)\">\r\n                  <span aria-hidden=\"true\">\u00D7</span>\r\n                </button>\r\n              </div>\r\n              <!-- Product img -->\r\n              <div class=\"compare-item-img\">\r\n                <div appImage=\"\" [product]=\"product\"></div>\r\n              </div>\r\n              <!-- Product name -->\r\n              <p class=\"compare-item-name\">\r\n                <a\r\n                  [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product',  product | translate: 'slug']\">\r\n                  {{product | translate:'name'}}\r\n                </a>\r\n              </p>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n        <tr>\r\n          <th>{{language['price']}}</th>\r\n          <td *ngFor=\"let product of products; even as isEven\" [ngClass]=\"{'even':isEven}\">\r\n            {{product?.variants[0]?.prices[0]?.price / 100 | number }}\r\n            {{currencyCode}}</td>\r\n        </tr>\r\n        <tr *ngFor=\"let option of options\">\r\n          <!-- Options -->\r\n          <th>{{option.name}}</th>\r\n          <ng-container *ngFor=\"let product of products;even as isEven\">\r\n            <td [ngClass]=\"{'even':isEven}\">{{getProdOpt(product,option)}}</td>\r\n          </ng-container>\r\n        </tr>\r\n        <tr *ngFor=\"let attribute of attributes\">\r\n          <th>{{attribute.name}}</th>\r\n          <ng-container *ngFor=\"let product of products;even as isEven\">\r\n            <td [ngClass]=\"{'even':isEven}\">{{getProdAttr(product,attribute)}}</td>\r\n          </ng-container>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <!-- If compare is empty -->\r\n  <ng-template #showMessage>\r\n    <div class=\"empty-compare\">\r\n      <div class=\"container\">\r\n        <div class=\"empty-item\">\r\n          <i class=\"fa fa-random\"></i>\r\n          <span class=\"help-text\">{{language['compareEmpty']}}</span>\r\n        </div>\r\n        <div class=\"text-center\">\r\n          <a class=\"custom-btn reversed\" routerLink=\"/collection\">{{language['continueShopping']}}</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".even{background-color:#fff}.compare-page{background-color:#f5f5f5;margin-bottom:15px}.compare-page .compare-page-head{background-color:#09f;color:#fff;font-size:18px;padding:15px 0;margin-bottom:30px;overflow:hidden;width:100%}[dir=rtl] .compare-page .compare-page-head{text-align:right}.compare-page .compare-page-head .header-title{position:relative;display:inline-block;font-weight:bold;margin:0;text-transform:uppercase}.compare-page .compare-page-head .header-title:before{position:absolute;content:\"\";right:0;bottom:-5px;width:50%;height:2px;background:#fff}[dir=rtl] .compare-page .compare-page-head .header-title:before{right:auto;left:0}.compare-page .compare-page-head .header-buttons{text-align:right}[dir=rtl] .compare-page .compare-page-head .header-buttons{text-align:left}.compare-page .compare-page-head .header-buttons .custom-btn{background-color:var(--secondary-color, black);color:var(--main-color, white);border:1px solid #fff!important;text-transform:capitalize;cursor:pointer;transition:all .3s ease-in-out}.compare-page .compare-page-head .header-buttons .custom-btn:hover{background:transparent}.compare-page table{border-collapse:collapse;width:100%}.compare-page table .compare-item{position:relative;margin-bottom:20px}.compare-page table .compare-item:hover .compare-item-head .compare-item-hover{opacity:1;visibility:visible}.compare-page table .compare-item .compare-item-head{position:relative;display:flex;flex-flow:column;justify-content:center;height:260px;border:1px solid var(--border-color, rgba(0, 0, 0, .05));border-radius:10px;background-color:#fff;overflow:hidden;margin-bottom:15px;box-shadow:0 4px 8px #0003;transition:.3s}.compare-page table .compare-item .compare-item-head:hover{box-shadow:0 8px 16px #0003}.compare-page table .compare-item .compare-item-head .compare-item-hover{position:absolute;display:flex;align-items:center;justify-content:space-between;top:0;left:0;width:100%;padding:6px;background-color:#000c;transition:all .3s ease-in-out;opacity:0;visibility:hidden}.compare-page table .compare-item .compare-item-head .compare-item-hover .custom-btn{padding:5px 20px;border:0;color:var(--secondary-color, #fff);font-size:80%;text-transform:uppercase;border-radius:20px;cursor:pointer}.compare-page table .compare-item .compare-item-head .compare-item-hover .custom-btn:hover{background-color:var(--main-color, #fff);opacity:.9}.compare-page table .compare-item .compare-item-head .compare-item-hover .remove{width:30px;height:30px;line-height:28px;text-align:center;border:1px solid var(--main-color, orange);border-radius:100%;background-color:#fff;color:#000;font-size:26px;font-family:sans-serif;cursor:pointer;transition:all .3s ease-in-out}.compare-page table .compare-item .compare-item-head .compare-item-hover .remove:hover{background-color:var(--main-color, orange);color:#fff}.compare-page table .compare-item .compare-item-head .compare-item-img{background-color:#fff}.compare-page table .compare-item .compare-item-head .compare-item-img div{height:150px;background-position:center;background-size:contain;background-repeat:no-repeat}.compare-page table .compare-item .compare-item-head .compare-item-name{padding:0 15px;color:#000;font-weight:bold}.compare-page table .compare-item .compare-item-head .compare-item-name a{color:#0d0d0d}.compare-page .tr{vertical-align:top}.compare-page th,.compare-page td{text-align:center;padding:5px;max-width:165px;min-width:150px}.compare-page th{min-width:-moz-fit-content;min-width:fit-content;max-width:-moz-fit-content;max-width:fit-content;white-space:nowrap}.compare-page tr:nth-child(even){background-color:#f2f2f2}.empty-compare{padding:30px 0}.empty-compare .custom-btn{background-color:var(--secondary-color, black);color:var(--main-color, white);padding:6px 15px;border-radius:20px;text-transform:capitalize}.empty-compare .custom-btn:hover{background-color:var(--background-color, white)}.empty-item{background-color:#fff;margin-bottom:30px;border-radius:10px;text-align:center;padding:20px 10px;border:1px solid var(--main-color, orange)}.empty-item i{display:block;font-size:130px;color:var(--main-color-opacity, rgba(251, 201, 0, .59));margin-bottom:10px}.empty-item .help-text{font-size:16px;text-transform:capitalize;font-weight:bold}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: ImageDirective, selector: "[appImage]", inputs: ["product", "hover"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": TranslatePipe, "number": i6.DecimalPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompareBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-compare',
                    templateUrl: './compare.base-component.html',
                    styleUrls: ['./compare.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CompareService }, { type: QuickViewService }, { type: i4.BreakpointObserver }, { type: TranslatePipe }, { type: ConfService }]; } });

class ContactUsBaseComponent {
    constructor(formBuilder, toastr, contactUsService, languageService, domSanitizer, confService, breadcrumbService, router) {
        this.formBuilder = formBuilder;
        this.toastr = toastr;
        this.contactUsService = contactUsService;
        this.languageService = languageService;
        this.domSanitizer = domSanitizer;
        this.confService = confService;
        this.breadcrumbService = breadcrumbService;
        this.router = router;
        this.user_fname = localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName');
        this.user_email = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email');
        this.user_phone = localStorage.getItem('user_phone') ? localStorage.getItem('user_phone') : sessionStorage.getItem('user_phone');
        this.language = {};
        this.mapSources = [];
        this.EGMobRegEx = '^(01)[0-9]{9}$';
        this.regExp = '^[0-9]+$';
        this.branch$ = this.confService.branch;
        this.carouselOptions = {
            margin: 10,
            items: 1,
            navigation: false,
            autoplay: true,
            autoplayHoverPause: true,
            dots: true,
            navSpeed: 1000,
            autoplaySpeed: 2000,
            slideTransition: 'linear',
            loop: false
        };
        languageService.getLanguage().subscribe(language => this.language = language);
        //	this.getContactInfo();
    }
    ngOnInit() {
        this.branch$.subscribe(branch => {
            this.currentBranch = branch;
        });
        this.initiatContactUs();
        this.handleBreadcrumb();
        this.router.queryParams.subscribe(params => {
            var orderText = '';
            if (params["OrderData"]) {
                const orderDataArray = JSON.parse(params["OrderData"]);
                console.log(orderDataArray);
                orderDataArray.map(data => {
                    orderText += `\n`;
                    orderText += `${data[0].addonsName}\n`;
                    data.map(addDetails => {
                        orderText += `${addDetails.name}\n`;
                    });
                });
                console.log(orderText);
            }
            this.contactUsForm.controls['message'].setValue(orderText);
        });
    }
    handleBreadcrumb() {
        const breadCrumbArr = [
            {
                name: 'contact us',
                url: {
                    path: ['contact-us'],
                    params: [],
                },
            },
        ];
        this.breadcrumbService.setCustom(breadCrumbArr);
        this.breadcrumbService.setBackground('/assets/images/banner-default.jpg');
    }
    initiatContactUs() {
        this.contactUsForm = this.formBuilder.group({
            name: [this.user_fname ? this.user_fname : '', Validators.compose([
                    Validators.required,
                    Validators.pattern(/^[^-\s][a-zA-Z_\s- \u0600-\u06FF-]+$/)
                ])],
            phoneNumber: [this.user_phone ? this.user_phone : '', Validators.compose([
                    Validators.required,
                    Validators.pattern(/^[^-\s][0-9]+$/)
                ])],
            email: [this.user_email ? this.user_email : '', Validators.compose([
                    Validators.required,
                    Validators.pattern(/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/)
                ])],
            subject: ['', Validators.required],
            message: [null, Validators.required]
        });
    }
    get name() { return this.contactUsForm.get('name'); }
    get phoneNumber() { return this.contactUsForm.get('phoneNumber'); }
    get email() { return this.contactUsForm.get('email'); }
    get subject() { return this.contactUsForm.get('subject'); }
    get message() { return this.contactUsForm.get('message'); }
    getContactInfo() {
        this.contactInfo$ = this.contactUsService.getContactDetails().pipe(map(data => data.branches), tap(data => {
            const branchId = +localStorage.getItem('branchId');
            if (branchId && data.length !== 0) {
                this.currentBranch = data.find(bid => bid.id === branchId);
            }
            else if (!branchId && data.length !== 0) {
                this.currentBranch = data[0];
            }
            data.forEach(branch => {
                this.mapSources[branch.id] = this.getMapUrl(branch);
            });
        }));
    }
    submitContactUs() {
        this.sendBtnLoading = true;
        this.confService.store$.pipe(take(1)).subscribe(store => {
            this.sendContactFormToService(null);
        });
    }
    getMapUrl(branch) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.google.com/maps/embed/v1/place?key=AIzaSyCqAo_nYI5hSUx_cQQKF6lz1tllHQtHBzY&q='
            + branch.longtitude + ',' + branch.latitude
        // 'https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2965.0824050173574!2d'
        // + branch.latitude + '!3d'
        // + branch.longtitude +
        // '!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sWebFilings%2C+University+Boulevard%2C+Ames%2C+IA!5e0!3m2!1sen!2sus!4v1390839289319'
        );
    }
    changeCarouselOptions(options = {}, extras = {}) {
        if (extras['responsive']) {
            options['responsive'] = extras['responsive'];
        }
        return Object.assign(Object.assign(Object.assign({}, this.carouselOptions), options), { rtl: this.language['DIR'] === 'rtl' });
    }
    sendContactFormToService(userToken) {
        let contactUsdata = this.contactUsForm.value;
        if (userToken !== null || undefined) {
            contactUsdata = Object.assign({ token: userToken }, this.contactUsForm.value);
        }
        this.contactUsService.sendContactUs(contactUsdata).subscribe((res) => {
            this.sendBtnLoading = false;
            this.toastr.success(res.response);
            this.contactUsForm.reset(this.initiatContactUs());
        }, (err) => {
            if (err.status === 401) {
                this.toastr.error(`${this.language['recaptchaError']}`);
            }
            else {
                this.toastr.error(`${this.language['sorrySomethingWentWrong']}`);
            }
            this.sendBtnLoading = false;
        });
    }
    ngOnDestroy() {
        // Called once, before the instance is destroyed.a
        // Add 'implements OnDestroy' to the class.
        if (this.recaptchaSubscription) {
            this.recaptchaSubscription.unsubscribe();
        }
    }
}
ContactUsBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ContactUsBaseComponent, deps: [{ token: i1$1.FormBuilder }, { token: i3$1.ToastrService }, { token: ContactUsService }, { token: LanguageService }, { token: i3.DomSanitizer }, { token: ConfService }, { token: BreadcrumbService }, { token: i2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
ContactUsBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ContactUsBaseComponent, selector: "app-base-contact-us", ngImport: i0, template: "<section class=\"contact-wrapper\">\r\n  <div class=\"container\">\r\n    <div class=\"contact-info bg-color\">\r\n      <div class=\"row\" *ngIf=\"contactInfo$ | async as contactInfo\">\r\n        <section *ngIf=\"currentBranch\" class=\"col-12 col-md-6 pt-4 pb-4\">\r\n          <h1 class=\"text-capitalize h1--custom\">{{language['contact_info']}}</h1>\r\n\r\n          <div class=\"address pt-4 pt-md-5 contact-field\">                              \r\n            <h2 class=\"text-capitalize d-inline h2--custom\">{{language['address']}}: </h2>\r\n            <p class=\"d-inline\">{{currentBranch | translate:'address'}}</p>\r\n          </div>\r\n\r\n          <section class=\"contact-field mail\" *ngIf=\"currentBranch?.email\">\r\n            <h2 class=\"text-capitalize  h2--custom\">{{language['email']}}: </h2>\r\n            <p class=\"\">{{currentBranch?.email}}</p> \r\n          </section>\r\n\r\n          <section class=\"contact-field mobile\"  *ngIf=\"currentBranch?.phone\">\r\n            <h2 class=\"text-capitalize  h2--custom\">{{language['phone_number']}}: </h2>\r\n            <p class=\"\">{{currentBranch?.phone}}</p>\r\n          </section>\r\n\r\n          <section class=\"contact-field phone\" *ngIf=\"currentBranch?.mobile\">\r\n            <h2 class=\"text-capitalize  h2--custom\">{{language['mobile_number']}}: </h2>\r\n            <p class=\"\">{{currentBranch?.mobile}}</p>\r\n          </section>\r\n\r\n          <section class=\"contact-field fax\" *ngIf=\"currentBranch?.fax\">\r\n            <h2 class=\"text-capitalize  h2--custom\">{{language['fax']}}: </h2>\r\n            <p class=\"\">{{currentBranch.fax}}</p>\r\n          </section>\r\n\r\n        </section>\r\n\r\n        <section class=\"col-12 col-md-6 p-md-0\">\r\n          <iframe *ngIf=\"currentBranch?.latitude && currentBranch?.longtitude\" [src]=\"mapSources[currentBranch?.id]\"\r\n            frameborder=\"0\" width=\"100%\" height=\"100%\" [title]=\"currentBranch?.name\">\r\n          </iframe>\r\n        </section>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"contactInfo$ | async as contactInfo\" class=\"row our-branches bg-color d-none\">\r\n      <div *ngIf=\"contactInfo.length\" class=\"col-12 mb-4 pt-4\">\r\n        <h1 class=\"text-capitalize h1--custom\">{{language['our-branches']}}</h1>\r\n      </div>\r\n\r\n      <ng-container *ngFor=\"let branch of contactInfo\">\r\n        <div *ngIf=\"branch\" class=\"col-12 col-md-6 pt-3 pb-4\">\r\n\r\n          <section class=\"address\">\r\n            <h2 class=\"text-capitalize ml-3 branch-name h2--custom\">{{language['branch']}} {{branch.id}} : {{branch |\r\n              translate:'name'}} </h2>\r\n            <div class=\"address-details ml-3\" *ngIf=\"branch?.address\">\r\n              <h2 class=\"text-capitalize d-inline h2--custom\">{{language['address']}}: </h2>\r\n              <p class=\"d-inline\">{{branch | translate:'address'}}</p>\r\n            </div>\r\n          </section>\r\n\r\n          <section class=\"mail pt-4 ml-3\" *ngIf=\"branch?.email\">\r\n            <h2 class=\"text-capitalize d-inline h2--custom\">{{language['email']}}: </h2>\r\n            <p class=\"d-inline\">{{branch.email}}</p>\r\n          </section>\r\n\r\n          <section class=\"phone pt-3 ml-3\" *ngIf=\"branch?.phone\">\r\n            <h2 class=\"text-capitalize d-inline h2--custom\">{{language['phone_number']}}: </h2>\r\n            <p class=\"d-inline\">{{branch.phone}}</p>\r\n          </section>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-12 col-md-6 pb-4\" *ngIf=\"branch?.latitude && branch?.longtitude\">\r\n          <iframe *ngIf=\"branch\" [src]=\"mapSources[branch.id]\" frameborder=\"0\" width=\"100%\" height=\"100%\">\r\n          </iframe>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n    <div [formGroup]=\"contactUsForm\" class=\"messages bg-color\">\r\n      <div class=\"row\">\r\n        <div class=\"col-12 mb-3 pt-4\">\r\n          <h1 class=\"text-capitalize h1--custom\">{{language['message-us']}}</h1>\r\n        </div>\r\n\r\n        <div class=\"col-sm-6 inputs-section w-contact\">\r\n          <div class=\"form-group\">\r\n            <input class=\"form-control\" id=\"name\" type=\"text\" formControlName=\"name\" autocomplete=\"given-name\">\r\n            <label class=\"text-capitalize form-label\" for=\"name\">{{language['firstName']}} <span\r\n                class=\"required text-danger\">*</span></label>              \r\n\r\n              <div *ngIf=\"name.invalid && (name.dirty || name.touched)\" >\r\n                <p class=\"validation-text\" *ngIf=\"name.errors.required\">\r\n                    {{language['required']}}\r\n                </p>\r\n                <p class=\"validation-text\" *ngIf=\"name.errors.pattern\">\r\n                  {{language['nameNoSpace']}}\r\n                </p>\r\n              </div><!--End alert-->\r\n          </div><!--End form-group--> \r\n          <div class=\"form-group\">\r\n            <input class=\"form-control remove-default\" type=\"tel\" id=\"phoneNumber\" formControlName=\"phoneNumber\"\r\n            autocomplete=\"tel\" minlength=\"7\" maxlength=\"14\">\r\n            <label class=\"text-capitalize form-label\" for=\"phoneNumber\">{{language['phone_number']}} <span\r\n                class=\"required text-danger\">*</span></label>\r\n\r\n              <div *ngIf=\"phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)\" >\r\n                <p class=\"validation-text\" *ngIf=\"phoneNumber.errors.required\">\r\n                  {{language['required']}}\r\n                </p>\r\n                <p class=\"validation-text\" *ngIf=\"phoneNumber.errors.pattern\">\r\n                  {{language['phone_min2']}}\r\n                </p>\r\n                <p class=\"validation-text\" *ngIf=\"(phoneNumber.errors?.minlength || phoneNumber.errors?.maxlength)\">\r\n                    {{language['phone_limit2']}}\r\n                  </p>\r\n              </div><!--End alert-->\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <input class=\"form-control\" type=\"email\" id=\"email\" formControlName=\"email\" autocomplete=\"email\">\r\n            <label class=\"text-capitalize form-label\" for=\"email\">{{language['email']}} <span\r\n                class=\"required text-danger\">*</span></label>\r\n                <div *ngIf=\"email.invalid && (email.dirty || email.touched)\" >\r\n                  <p class=\"validation-text\" *ngIf=\"email.errors.required\">\r\n                      {{language['required']}}\r\n                  </p>\r\n                  <p class=\"validation-text\" *ngIf=\"email.errors.pattern\">\r\n                    {{language['enterValidEmail']}}\r\n                  </p>\r\n                </div><!--End alert-->\r\n                \r\n          </div>\r\n          <div class=\"form-group\">\r\n            <select class=\"form-control\" title=\"{{language['subject']}}\" formControlName=\"subject\" id=\"subject\">\r\n              <option value=\"\" selected disabled>{{language['chooseSubject']}}</option>\r\n              <option>{{language['general']}}</option>\r\n              <option>{{language['feedback']}}</option>\r\n              <option>{{language['enquiry']}}</option>\r\n              <option>{{language['complaint']}}</option>\r\n            </select>\r\n            <label class=\"text-capitalize form-label\" for=\"subject\">{{language['subject']}} <span\r\n                class=\"required text-danger\">*</span></label>\r\n                <div *ngIf=\"subject.invalid && (subject.dirty || subject.touched)\" >\r\n                  <p class=\"validation-text\" *ngIf=\"subject.errors.required\">\r\n                      {{language['required']}}\r\n                  </p>\r\n                </div><!--End alert-->\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-sm-6  txt-area w-contact\">\r\n          <div class=\"form-group\">\r\n            <textarea class=\"form-control\" formControlName=\"message\" id=\"message\"></textarea>\r\n            <label class=\"text-capitalize form-label\" for=\"message\">{{language['message-content']}}</label>\r\n            <div *ngIf=\"message.invalid && (message.dirty || message.touched)\" >\r\n              <p class=\"validation-text\" *ngIf=\"message.errors.required\">\r\n                  {{language['required']}}\r\n              </p>\r\n            </div><!--End alert-->\r\n          </div>\r\n          <div class=\"d-flex justify-content-between\">\r\n            <div class=\"form-group\">\r\n              <button type=\"submit\" (click)='submitContactUs()' class=\"btn btn-submit\"\r\n                [disabled]=\"contactUsForm.invalid || sendBtnLoading\">\r\n                {{sendBtnLoading ? language['sending'] : language['send']}}\r\n                <span class=\"spinner-border\" role=\"form\" *ngIf=\"sendBtnLoading\">\r\n                  <span class=\"sr-only\">Loading...</span>\r\n                </span>\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>", styles: [":host h1{font-size:22px;position:relative;font-weight:bold;display:inline-block}:host h1:after{display:block;content:\"\";width:100%;height:2px;background-color:var(--main-color, orange);position:absolute;left:0;margin:15px 0}[dir=rtl] :host h1:after{left:inherit;right:0}:host h2{font-size:18px;font-weight:bold}@media (max-width: 768px){:host h2{font-size:14px}}:host .contact-field{display:flex}:host .contact-field h2{width:30%;flex-basis:15%}:host .contact-field p{width:70%;flex-basis:70%}@media (max-width: 767px){:host .contact-field h2{width:max-content;flex-basis:auto}:host .contact-field p{width:auto;flex-basis:auto;padding:0 6px}}:host span{font-size:17px}@media (max-width: 768px){:host span{font-size:14px}}:host label{font-size:18px;font-weight:bold;color:#939393}@media (max-width: 768px){:host label{font-size:14px}}:host .mail span:first-child,:host .phone span:first-child{font-weight:bold}:host textarea{min-height:202px}:host p{font-size:18px}@media (max-width: 768px){:host p{font-size:14px}}:host .bg-color{background-color:#fff;border-radius:10px;padding:0 15px}:host .contact-wrapper{background-color:#f5f5f5;padding:3rem 0}:host .contact-wrapper .our-branches .address{position:relative}:host .contact-wrapper .our-branches .address:before{content:\"\";width:3px;height:40px;background-color:var(--main-color, orange);position:absolute;margin-top:3px}:host .contact-wrapper .our-branches .address .address-details span:first-child{font-weight:bold}[dir=rtl] :host .contact-wrapper .our-branches .address .address-details{margin-right:20px}[dir=rtl] :host .contact-wrapper .our-branches .address .branch-name{margin-right:20px}:host .contact-wrapper .messages{padding-bottom:1.5rem}:host .contact-wrapper .messages .submit--input input{height:18px;width:18px;cursor:pointer;margin-right:1rem}[dir=rtl] :host .contact-wrapper .messages .submit--input input{margin-right:0;margin-left:1rem}:host .contact-wrapper .messages .btn-submit{background-color:var(--main-color, orange);color:#fff;border-color:var(--main-color, orange);min-width:80px;padding:8px 10px;font-size:18px;text-transform:capitalize;display:flex;align-items:center;justify-content:center}:host .contact-wrapper .messages .btn-submit .spinner-border{font-size:1rem;width:1.5rem;height:1.5rem;margin-inline-start:5px}:host .contact-wrapper .messages .txt-area:before{width:1px;height:90%;background-color:#ced4da;position:absolute;margin-top:10px}@media (max-width: 768px){:host .contact-wrapper .messages .txt-area:before{display:none}}:host .contact-wrapper .messages .form-group{margin-top:30px;margin-bottom:0}:host .contact-wrapper .messages .form-control{padding:10px 15px;height:55px;border-radius:5px}:host .contact-wrapper .messages .form-control:focus{border-color:var(--main-color, orange);box-shadow:unset}:host .contact-wrapper .messages .form-label{font-size:14px;font-weight:400;position:absolute;top:9px;left:10px;transition:top .3s ease-in-out,left .3s ease-in-out,right .3s ease-in-out;background-color:#fff;margin:0;height:calc(100% - 2px);max-height:40px;width:50%;display:flex;align-items:center;border-radius:20px}[dir=rtl] :host .contact-wrapper .messages .form-label{left:unset;right:10px}:host .contact-wrapper .messages .form-control:focus+.form-label,:host .contact-wrapper .messages .form-control.ng-dirty+.form-label{top:-30px;left:0;background-color:transparent}[dir=rtl] :host .contact-wrapper .messages .form-control:focus+.form-label,[dir=rtl] :host .contact-wrapper .messages .form-control.ng-dirty+.form-label{left:unset;right:0}:host .validation-text{color:#ff5a5a;font-size:16px;margin-bottom:0;margin-top:5px}@media (max-width: 991px){.w-contact{max-width:100%;flex:100%}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i1$1.MinLengthValidator, selector: "[minlength][formControlName],[minlength][formControl],[minlength][ngModel]", inputs: ["minlength"] }, { type: i1$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "async": i6.AsyncPipe, "translate": TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ContactUsBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-contact-us',
                    templateUrl: './contact-us.base-component.html',
                    styleUrls: ['./contact-us.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$1.FormBuilder }, { type: i3$1.ToastrService }, { type: ContactUsService }, { type: LanguageService }, { type: i3.DomSanitizer }, { type: ConfService }, { type: BreadcrumbService }, { type: i2.ActivatedRoute }]; } });

class RecaptchaBaseComponent {
    constructor(languageService, renderer, personalInfoService, toastr) {
        this.languageService = languageService;
        this.renderer = renderer;
        this.personalInfoService = personalInfoService;
        this.toastr = toastr;
        this.code = '';
        this.language = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
        if (this.recaptchaEmail && this.recaptchaId && this.recaptchaImg) {
            this.invokePopup();
        }
    }
    invokePopup() {
        const modal = document.querySelector('.modal');
        const overlay = document.querySelector('.overlay');
        const close = document.querySelector('#close');
        close.addEventListener('click', () => {
            this.renderer.removeStyle(document.querySelector('html'), 'overflow');
            this.renderer.setStyle(document.querySelector('html'), 'height', 'auto');
            this.renderer.setStyle(document.querySelector('body'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('body'), 'height', 'auto');
            this.renderer.setStyle(overlay, 'visibility', 'hidden');
            this.renderer.setStyle(overlay, 'opacity', '0');
            this.renderer.setStyle(overlay, 'transform', 'translateY(-1000px)');
            this.recaptchaEmail = '';
            this.recaptchaId = '';
            this.recaptchaImg = '';
        });
        modal.addEventListener('click', (e) => {
            e.stopPropagation();
        });
        setTimeout(() => {
            this.renderer.setStyle(document.querySelector('html'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('html'), 'height', '100%');
            this.renderer.setStyle(document.querySelector('html'), 'margin', '0');
            this.renderer.setStyle(document.querySelector('body'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('body'), 'height', '100%');
            this.renderer.setStyle(document.querySelector('body'), 'margin', '0');
            this.renderer.setStyle(overlay, 'visibility', 'visible');
            this.renderer.setStyle(overlay, 'opacity', '1');
            this.renderer.setStyle(overlay, 'transform', 'translateY(0px)');
        }, 200);
    }
    getRecaptcha() {
        this.personalInfoService.getNewRecaptcha().subscribe(response => {
            if (response['id'] && response['path']) {
                this.recaptchaImg = 'data:image/png;base64,' + response['path'];
                this.recaptchaId = response['id'];
            }
        }, err => {
            if (err['error']['response']) {
                this.error = err['error']['response'];
            }
        });
    }
    submitEmail() {
        if (this.recaptchaImg && this.recaptchaEmail && this.recaptchaId && this.code && this.code.length == 6) {
            this.personalInfoService.subscribeToNewsLetterRecaptcha(this.recaptchaEmail, this.recaptchaId, this.code).subscribe(response => {
                if (response['status'] === 'success') {
                    this.error = '';
                    this.toastr.success(`${response['response']}!`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
                    document.getElementById("close").click();
                }
            }, err => {
                this.code = '';
                if (err['error']['response']) {
                    this.error = err['error']['response'];
                }
                this.getRecaptcha();
            });
        }
    }
}
RecaptchaBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RecaptchaBaseComponent, deps: [{ token: LanguageService }, { token: i0.Renderer2 }, { token: PersonalInfoService }, { token: i3$1.ToastrService }], target: i0.ɵɵFactoryTarget.Component });
RecaptchaBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: RecaptchaBaseComponent, selector: "app-base-recaptcha", inputs: { recaptchaEmail: "recaptchaEmail", recaptchaId: "recaptchaId", recaptchaImg: "recaptchaImg" }, ngImport: i0, template: "\r\n<div  class=\"overlay\">\r\n  <div style=\"margin: auto; text-align: center;\"  class=\"modal\">\r\n    <span id=\"close\"><i class=\"fa fa-times\"></i></span>\r\n    <div class=\"title\">\r\n      <h6>{{language['recaptchaTitle'] || 'I am not a robot !'}}</h6>\r\n    </div>\r\n  <div  class=\"modalContent\" >\r\n    <div  class=\"row sendRecaptchaImgDiv\">\r\n      <div style=\"display: block;margin: auto;\">\r\n          <img style=\"max-width: 100%;\" lazyLoad=\"{{recaptchaImg}}\" alt=\"\">    \r\n      </div>\r\n      <div  style=\"display: block;margin: auto;margin-top: 20px;\">\r\n        <input  id=\"code\" [(ngModel)]=\"code\" type=\"text\" name=\"code\" class=\"form-control input-lg\">\r\n      </div>\r\n    </div>\r\n    \r\n    <div  class=\"row sendRecaptchaDiv\">\r\n      <button [disabled]=\"code.length != 6\" (click)=\"submitEmail()\" style=\"font-size: 2rem;\" class=\"btn btn-primary\" >{{language['sendRecaptchaCode'] || 'Submit' }}</button>\r\n\r\n    </div>\r\n    <a name=\"resendClick\" id=\"resendClick\" (click)=\"getRecaptcha()\" > {{language['resendRecaptchaCode'] || 'Resend Code' }}  </a>\r\n\r\n\r\n    <div class=\"row errors my-4 justify-content-center recaptchaMsgs\">\r\n      <p *ngIf=\"error\"  class=\"alert alert-danger mx-2\">\r\n        {{error}}\r\n      </p>\r\n    </div>\r\n  </div>\r\n  \r\n  </div>\r\n</div>", styles: [".overlay{position:absolute;inset:0;background:rgba(0,0,0,.8);display:flex;justify-content:center;align-items:center;color:#fff;visibility:hidden;opacity:0;transition:all .5s ease;z-index:9999999}.modal{width:600px;max-width:100%;min-height:300px;background:white;color:#666;padding:3.3rem 0 0;display:flex;align-items:center;position:relative;transition:.35s ease;z-index:99999;height:350px}.modalContent{width:100%;height:100%;align-items:center;flex-wrap:wrap;position:relative;background-repeat:no-repeat;background-size:cover;background-position:center}#close{position:absolute;top:0px;right:0px;padding:5px 10px;background-color:#000;z-index:9999999;color:#fff}.title{position:absolute;top:0px;right:0px;left:0;height:35px;width:100%;text-align:center;margin:auto;background-color:#fff}.title h6{font-size:2rem;line-height:1.5;color:var(--textColor, #000)}#close:hover{cursor:pointer}h1{color:#fff}.recaptchaMsgs{display:block;position:absolute;bottom:0;width:100%;padding:0;margin:0}#resendClick{text-decoration:underline;font-size:small}#code{display:inline-block;width:auto;border-radius:0;text-align:left}.sendRecaptchaDiv{display:block;margin-top:30px}.sendRecaptchaImgDiv{display:block;margin:30px 0}@media screen and (max-width: 600px){.modalContent{flex-direction:column;align-items:center;justify-content:center}}\n"], directives: [{ type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RecaptchaBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-recaptcha',
                    templateUrl: './recaptcha.base-component.html',
                    styleUrls: ['./recaptcha.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i0.Renderer2 }, { type: PersonalInfoService }, { type: i3$1.ToastrService }]; }, propDecorators: { recaptchaEmail: [{
                type: Input
            }], recaptchaId: [{
                type: Input
            }], recaptchaImg: [{
                type: Input
            }] } });

class WhatsappBaseComponent {
    constructor(languageService, confService) {
        this.languageService = languageService;
        this.confService = confService;
        this.language = {};
        this.branch$ = this.confService.branch;
    }
    ngOnInit() {
        this.branch$.subscribe(branch => {
            this.currentBranch = branch;
        });
        this.languageService.getLanguage().subscribe(language => this.language = language);
    }
}
WhatsappBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WhatsappBaseComponent, deps: [{ token: LanguageService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
WhatsappBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: WhatsappBaseComponent, selector: "app-base-whatsapp", ngImport: i0, template: "<ng-container *ngIf=\"currentBranch && (currentBranch?.mobile && currentBranch?.isWhatsApp)\">\r\n  <div class=\"whatsApp_link\">\r\n    <a class=\"whatsApp_href\"\r\n      [href]=\"'https://api.whatsapp.com/send?phone='+(currentBranch?.mobile.startsWith('01') ? '20' + currentBranch?.mobile : currentBranch?.mobile)\"\r\n      target=\"_blank\">\r\n      <span>{{language['letsChat']}}</span>\r\n      <i class=\"whatsApp_icon fa fa-whatsapp\"></i>\r\n    </a>\r\n  </div>\r\n</ng-container>", styles: [":host .whatsApp_link{position:fixed;z-index:100000;bottom:46px;left:20px;right:unset}[dir=rtl] :host .whatsApp_link{right:20px;left:unset}:host .whatsApp_link a{display:flex;justify-items:center;box-shadow:0 1px 3px #999;border-radius:18px;color:#fff}@media (max-width: 576px){:host .whatsApp_link a{border-radius:50%}}[dir=rtl] :host .whatsApp_link a{flex-direction:row-reverse}:host .whatsApp_link span{font-size:14px;padding:12px 15px;background-color:#0dc152;display:flex;justify-content:center;align-items:center;border-bottom-left-radius:18px;border-top-left-radius:18px;transition:all .3s ease}:host .whatsApp_link span:hover{background-color:#0cb74e}@media (max-width: 576px){:host .whatsApp_link span{display:none}}:host .whatsApp_link I{background-color:#0cb74e;padding:12px 15px;border-bottom-right-radius:18px;border-top-right-radius:18px;display:flex;justify-content:center;align-items:center;font-size:20px}@media (max-width: 576px){:host .whatsApp_link I{border-radius:50%;padding:14px 15px;font-size:25px}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WhatsappBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-whatsapp',
                    templateUrl: './whatsapp.base-component.html',
                    styleUrls: ['./whatsapp.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ConfService }]; } });

/* eslint-disable no-useless-escape */
class FooterBaseComponent {
    constructor(languageService, staticPagesService, personalInfoService, confService, contactUsService, toastr, taxonService, elementRef) {
        this.languageService = languageService;
        this.staticPagesService = staticPagesService;
        this.personalInfoService = personalInfoService;
        this.confService = confService;
        this.contactUsService = contactUsService;
        this.toastr = toastr;
        this.taxonService = taxonService;
        this.elementRef = elementRef;
        this.language = {};
        this.submited = false;
        this.version = environment.version;
        this.currentYear = new Date().getFullYear();
        this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.branch$ = this.confService.branch;
        this.recaptchaData = { id: '', img: '', email: '' };
    }
    ngOnInit() {
        this.confService.getMostViewedCategories().subscribe((data) => {
            this.mostViewed = data;
            console.log(this.mostViewed);
        });
        this.confService.getStoreID().subscribe((data) => {
            this.storeID = data.response.id;
        });
        this.branch$.subscribe(branch => {
            this.currentBranch = branch;
        });
        this.getTaxons();
        this.store$ = this.confService.store$;
        this.logo$ = this.confService.store$.pipe(map(store => environment.imageUrl + store.logoFooter));
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.staticPagesService.getAllPages('footer').subscribe(staticPages => {
            this.staticPages = staticPages;
        });
        this.subscribeForm = new FormGroup({
            email: new FormControl(null, [
                Validators.email,
                Validators.required,
                Validators.pattern(this.emailRegex)
            ])
        });
        this.contactUsService.getContactBranches().subscribe((data) => {
            this.contactBranche = data;
        });
    }
    getTaxons() {
        this.taxonService.getTaxons().subscribe(taxons => {
            this.taxons = taxons;
        });
    }
    // eslint-disable-next-line no-empty-function
    updateContactInfoBasedOnBranch() { }
    getRecaptcha() {
        this.submited = true;
        if (this.subscribeForm.invalid) {
            return;
        }
        const email = this.subscribeForm.get('email').value;
        if (this.subscribeForm.valid) {
            this.recaptchaData = { id: '', img: '', email: '' };
            this.personalInfoService.getNewRecaptcha().subscribe(response => {
                if (response['id'] && response['path']) {
                    this.recaptchaData.email = email;
                    this.recaptchaData.img = 'data:image/png;base64,' + response['path'];
                    this.recaptchaData.id = response['id'];
                    setTimeout(() => {
                        this.subscribeForm.reset();
                    }, 500);
                }
            }, err => {
                this.toastr.error(err['error']['response'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            });
        }
    }
    submitEmail() {
        this.submited = true;
        if (this.subscribeForm.invalid) {
            return;
        }
        const email = this.subscribeForm.get('email').value;
        if (this.subscribeForm.valid) {
            this.personalInfoService.subscribeToNewsLetter(email).subscribe(response => {
                if (response.status === 'success') {
                    this.subscribeForm.reset();
                    this.toastr.success(`${this.language['youHaveSubscribedToNewsletterSuccessfully']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
                }
            }, err => {
                this.toastr.error(err['error']['response'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            });
        }
    }
}
FooterBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FooterBaseComponent, deps: [{ token: LanguageService }, { token: StaticPagesService }, { token: PersonalInfoService }, { token: ConfService }, { token: ContactUsService }, { token: i3$1.ToastrService }, { token: TaxonService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FooterBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: FooterBaseComponent, selector: "app-base-footer", ngImport: i0, template: "<!-- Start page-footer\r\n=======================================-->\r\n<footer class=\"footer footer--custom\">\r\n  <div class=\"main-footer\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-6 col-md-4\">\r\n          <div class=\"foot-widget\">\r\n            <a class=\"logo--link logo\" routerLink=\"/{{language['LANGUAGE_CODE']}}\">\r\n              <img *ngIf=\"logo$ | async as logo\" [lazyLoad]=\"logo\" alt=\"logo\" [errorImage]=\"defaultImage\">\r\n            </a>\r\n            <div class=\"foot-widget-content\">\r\n              <p *ngIf=\" store$ | async as store\" class=\"taxInfo--footer\">\r\n                <span *ngIf=\"store.commercialRegistration\"> {{language['commercialRegistration'] || 'commercial Registration'}} : <span class=\"word\">{{store.commercialRegistration}}</span></span> \r\n              </p>\r\n              <p *ngIf=\" store$ | async as store\" class=\"taxInfo--footer\">\r\n              <span *ngIf=\"store.taxId\"> {{language['taxId'] || 'tax Id'}} : <span class=\"word\">{{store.taxId}}</span> </span> \r\n              </p>\r\n              <!--<p>-->\r\n              <!--Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s-->\r\n              <!--</p>-->\r\n            </div>\r\n          </div>\r\n          <!--End Foot-widget-->\r\n        </div>\r\n        <!--End Col-->\r\n        <div class=\"col-lg-3 col-md-4\">\r\n          <div class=\"foot-widget\">\r\n            <h3 class=\"title h3--custom\">{{language['quickLinks']}}</h3>\r\n            <div class=\"foot-widget-content\">\r\n              <ul class=\"links-list\">\r\n                <li>\r\n                  <a class=\"link--footer link--custom-footer\"\r\n                    routerLink=\"/{{language['LANGUAGE_CODE']}}\">{{language['home']}}</a>\r\n                </li>\r\n                <li>\r\n                  <a class=\"link--footer link--custom-footer\"\r\n                    [routerLink]=\"['/', language['LANGUAGE_CODE'], 'contact-us']\">{{language['contactUs']}}</a>\r\n                </li>\r\n                <li *ngFor=\"let staticPage of staticPages\">\r\n                  <a class=\"link--footer link--custom-footer\"\r\n                    [routerLink]=\"['/', language['LANGUAGE_CODE'], 'page', staticPage.code]\">\r\n                    {{staticPage | translate:'name'}}\r\n                  </a>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <!--End Foot-widget-->\r\n        </div>\r\n        <!--End col-->\r\n        <div class=\"col-lg-3 col-md-4\">\r\n          <div class=\"foot-widget\">\r\n            <h3 class=\"title h3--custom\">{{language['newsletter']}}</h3>\r\n            <div class=\"foot-widget-content\">\r\n              <form class=\"subscribe-form\" [formGroup]=\"subscribeForm\">\r\n                <input class=\"form-control\" type=\"email\" placeholder=\"{{language['email']}}\" formControlName=\"email\">\r\n                <button class=\"subscribe-btn\" (click)=\"getRecaptcha()\" [disabled]=\"subscribeForm.invalid\">\r\n                  <i class=\"fa fa-envelope\"></i>\r\n                </button>\r\n                <span style=\"color: red;\"\r\n                  *ngIf=\"submited && subscribeForm.controls['email'].touched && subscribeForm.invalid\">{{language['enterValidEmail']}}\r\n                </span>\r\n              </form>\r\n              <h3 class=\"title h3--custom\">{{language['followUs']}}</h3>\r\n              <ul class=\"social-list list-unstyled\" *ngIf=\"(store$ | async) as store\">\r\n                <li *ngIf=\"store.facebookLink\">\r\n                  <a [href]=\"store.facebookLink\" target=\"_blank\"><i class=\"fa fa-facebook-f\"></i></a>\r\n                </li>\r\n                <li *ngIf=\"store.twitterLink\">\r\n                  <a [href]=\"store.twitterLink\" target=\"_blank\"><i class=\"fa fa-twitter\"></i></a>\r\n                </li>\r\n                <li *ngIf=\"store.googleLink\">\r\n                  <a [href]=\"store.googleLink\" target=\"_blank\"><i class=\"fa fa-google-plus\"></i></a>\r\n                </li>\r\n                <li *ngIf=\"store.instagramLink\">\r\n                  <a [href]=\"store.instagramLink\" target=\"_blank\"><i class=\"fa fa-instagram\"></i></a>\r\n                </li>\r\n\r\n              </ul>\r\n              <!--End social list-->\r\n            </div>\r\n          </div>\r\n          <!--End Foot-widget-->\r\n        </div>\r\n        <!--End col-->\r\n      </div>\r\n      <!-- end Row-->\r\n    </div>\r\n    <!--End Container-->\r\n  </div>\r\n  <!--End main-footer-->\r\n  <div class=\"footer-copyright\">\r\n    <div class=\"container\">\r\n      <div class=\"float-left\">\r\n        <p *ngIf=\"store$ | async as store\" class=\"link--footer\">{{ currentYear }} {{store.name}}\r\n          {{language['AllRightsReserved']}}</p>\r\n      </div>\r\n      <div class=\"float-right\">\r\n        <p class=\"link--footer\">\r\n          {{language['poweredBy']}}\r\n          <a class=\"link--footer\" href=\"http://zvendo.com\"> {{language['zvendo']}} {{version}}</a>\r\n        </p>\r\n      </div>\r\n        <app-base-recaptcha *ngIf=\"recaptchaData && recaptchaData.img &&  recaptchaData.id && recaptchaData.email\"  recaptchaEmail=\"{{recaptchaData.email}}\" recaptchaId=\"{{recaptchaData.id}}\" recaptchaImg=\"{{recaptchaData.img}}\"></app-base-recaptcha>      \r\n    </div>\r\n    <!--End Container-->\r\n  </div>\r\n  <!--End Footer-copy-right-->\r\n  <app-base-whatsapp></app-base-whatsapp>\r\n</footer>\r\n<!--End Footer-->", styles: [":host .footer{background-color:var(--footer-bg-color, #333);padding:60px 0 0}:host .footer .foot-widget{position:relative;margin-bottom:25px}:host .footer .foot-widget p{color:#fff;font-size:16px;line-height:26px}:host .footer .foot-widget .logo{margin-bottom:20px;display:block;max-width:210px}:host .footer .foot-widget .title{color:var(--main-color);font-size:var(--h3-font-size, 20px);text-transform:uppercase;margin-bottom:20px}:host .footer .subscribe-form{position:relative;margin-bottom:25px}:host .footer .subscribe-form .form-control{border-radius:30px;padding:0 20px;height:40px}:host .footer .subscribe-form .subscribe-btn{position:absolute;top:1px;right:1px;width:36px;height:36px;line-height:36px;border-radius:100%;font-size:16px;padding:0;border:1px solid #e8e8e8;background-color:var(--main-color, orange);color:#fff;text-transform:uppercase;cursor:pointer;transition:all .35s ease-in-out}[dir=rtl] :host .footer .subscribe-form .subscribe-btn{left:1px;right:auto}:host .footer .subscribe-form .subscribe-btn:hover,:host .footer .subscribe-form .subscribe-btn:focus{background-color:var(--main-color, orange);color:#fff}:host .footer .subscribe-form .subscribe-btn:disabled{opacity:.5;color:#fff;cursor:not-allowed}:host .footer .link--footer{color:var(--footer-link-color, #999);font-size:var(--footer-link-font-size, 16px);text-transform:none}:host .footer-copyright{text-align:center;padding:15px 0;font-size:1.4rem;overflow:hidden}:host .footer-copyright p{color:#b4b4b8}:host .footer-copyright p a{color:var(--footer-link-color, #b4b4b8);font-size:var(--footer-link-font-size, 16px)}:host .footer-copyright p a:hover{color:var(--main-color, orange)}@media all and (max-width: 767.99px){:host .main-footer{text-align:center}:host .footer .foot-widget .logo{margin:0 auto 20px}}@media all and (max-width: 455px){:host .footer-copyright .float-left,:host .footer-copyright .float-right{float:none!important;text-align:center}}:host .taxInfo--footer{color:#999!important;font-size:14px!important;line-height:10px!important}:host .taxInfo--footer .word{font-weight:600!important}:host .whatsApp_link{position:fixed;z-index:100000;bottom:46px;left:20px}:host .whatsApp_link a{display:flex;justify-items:center;box-shadow:0 1px 3px #999;border-radius:18px;color:#fff}@media (max-width: 576px){:host .whatsApp_link a{border-radius:50%}}[dir=rtl] :host .whatsApp_link a{flex-direction:row-reverse}:host .whatsApp_link span{font-size:14px;padding:12px 15px;background-color:#0dc152;display:flex;justify-content:center;align-items:center;border-bottom-left-radius:18px;border-top-left-radius:18px;transition:all .3s ease}:host .whatsApp_link span:hover{background-color:#0cb74e}@media (max-width: 576px){:host .whatsApp_link span{display:none}}:host .whatsApp_link I{background-color:#0cb74e;padding:12px 15px;border-bottom-right-radius:18px;border-top-right-radius:18px;display:flex;justify-content:center;align-items:center;font-size:20px}@media (max-width: 576px){:host .whatsApp_link I{border-radius:50%;padding:14px 15px;font-size:25px}}\n"], components: [{ type: RecaptchaBaseComponent, selector: "app-base-recaptcha", inputs: ["recaptchaEmail", "recaptchaId", "recaptchaImg"] }, { type: WhatsappBaseComponent, selector: "app-base-whatsapp" }], directives: [{ type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }], pipes: { "async": i6.AsyncPipe, "translate": TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FooterBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-footer',
                    templateUrl: './footer.base-component.html',
                    styleUrls: ['./footer.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: StaticPagesService }, { type: PersonalInfoService }, { type: ConfService }, { type: ContactUsService }, { type: i3$1.ToastrService }, { type: TaxonService }, { type: i0.ElementRef }]; } });

class DynamicNavigationMenu {
    constructor(http) {
        this.http = http;
        this.isCloseModalBehavior = new BehaviorSubject(false);
    }
    getNavigationMenuHeader() {
        return this.http.get(`${environment.apiUrl}${environment.apiVersion}/get_navigation_menu`).pipe(map(data => {
            return data['response']['navigationMenu'];
        }));
    }
    setCloseBehaviorView(close) {
        this.isCloseModalBehavior.next(close);
    }
    getCloseBehaviorView() {
        return this.isCloseModalBehavior.asObservable();
    }
}
DynamicNavigationMenu.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamicNavigationMenu, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
DynamicNavigationMenu.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamicNavigationMenu, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamicNavigationMenu, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

const dropAcountMobile = trigger('dropAcountMobile', [
    state('void', style({
        opacity: 0,
        visibility: 'hidden'
    })),
    state('final', style({
        opacity: 1,
        visibility: 'visible'
    })),
    transition('void <=> final', animate('300ms ease-in-out'))
]);

class HeaderBaseComponent {
    constructor(languageService, router, modalService, taxonService, wishListService, compareService, cartService, activatedRoute, staticPagesService, loginService, confService, breakpointObserver, elementRef, navigationMenu, brandsService, contactUsService) {
        this.languageService = languageService;
        this.router = router;
        this.modalService = modalService;
        this.taxonService = taxonService;
        this.wishListService = wishListService;
        this.compareService = compareService;
        this.cartService = cartService;
        this.activatedRoute = activatedRoute;
        this.staticPagesService = staticPagesService;
        this.loginService = loginService;
        this.confService = confService;
        this.breakpointObserver = breakpointObserver;
        this.elementRef = elementRef;
        this.navigationMenu = navigationMenu;
        this.brandsService = brandsService;
        this.contactUsService = contactUsService;
        this.conf$ = this.confService.getConf();
        this.selected = false;
        this.search = false;
        this.login = false;
        this.showCats = false;
        this.language = {};
        this.redirectUrls = [];
        this.queryParams = {};
        this.catsFired = false;
        this.taxons = [];
        this.logged$ = this.loginService.logged;
        this.mobileHeader = false;
        this.mobileDropdown = false;
        this.isScrolled = false;
        this.compareFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.COMPARE));
        this.wishListFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.WISH_LIST));
        // chef+ Logic
        this.showCartComponent = false;
        this.showAccountComponent = false;
        this.cartState = 'initial';
        this.user = {};
        // new from egypt
        this.showSearch = false;
        this.showMenu = false;
        // new elmaaergy
        this.backgroundSearch = false;
        this.backgroundAcount = false;
        this.backgroundCart = false;
        this.showAccountMobile = false;
        this.showSearchMobile = false;
        this.backgroundSearchMobile = false;
        this.backgroundAcountMobile = false;
        this.backgroundCartMobile = false;
        this.childTaxons = [];
        this.childernTaxons = [];
        this.showBrandsMobile = false;
        this.showTaxonsMobile = false;
        this.togglestate = false;
        this.showMenus = false;
        this.newTaxons = [];
        this.branch$ = this.confService.branch;
        this.storeIsMultiLocations$ = this.confService.storeIsMultiLocations;
        this.openPopupModal$ = this.confService.openPopupModal;
        this.$contactUs = this.contactUsService.getContactDetails();
    }
    ngOnInit() {
        this.navigationMenu.getCloseBehaviorView().subscribe(response => {
            if (response) {
                this.togglestate = false;
            }
        });
        this.breakpointObserver
            .observe(['(min-width: 768px)'])
            .subscribe((state) => {
            if (state.matches) {
                this.isLargeScreen = true;
            }
            else {
                this.isLargeScreen = false;
            }
        });
        this.logo$ = this.confService.logo$;
        this.userName = this.getUserName();
        this.userAsync = this.getUser();
        this.logged$ = this.loginService.logged;
        this.cartCounter$ = this.cartService.getCartCounter();
        this.wishListCounter$ = this.wishListService.getWishListCounter();
        this.compareCounter$ = this.compareService.getCompareCounter();
        this.cart$ = this.cartService.getCart();
        this.languageSub = this.languageService.getAvailableLocales().subscribe(availableLanguages => {
            this.availableLanguages = availableLanguages;
            this.defaultImage = environment.defaultImage;
            this.imageUrl = environment.imageUrl;
            this.languageService.getLanguage().subscribe(language => {
                this.language = language;
                this.readUrl();
            });
            this.currentRoute = this.router.url;
            this.readUrl();
            this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e) => {
                this.currentRoute = e.urlAfterRedirects;
                this.readUrl();
            });
        });
        // Calling brand's service only for El-Ma3yrgee template
        this.conf$.subscribe(conf => {
            this.confService.store$.subscribe((store) => {
                /* //stop-auto-detect//
                let branchFlow = ''
                 if(store['mutipleBranch'] && store['allowGeofence']){
                     this.multipleBranchsFeature = false;
                     branchFlow = 'auto'
                 }
                if(store['mutipleBranch'] && !store['allowGeofence']){
                    this.multipleBranchsFeature = true;
                    branchFlow = 'select'
                }
                this.getContactInfo(branchFlow);
                */
                this.multipleBranchsFeature = store['mutipleBranch'];
                this.getContactInfo('select');
            });
            const confId = [637, 941, 11707];
            iif(() => confId.includes(conf.id), this.brandsService.getBrands()).subscribe(brands => {
                this.brands = brands;
            });
        });
        this.activatedRoute.queryParams.subscribe(params => {
            this.queryParams = params;
        });
        // chef+ logic
        // this.currencySubscription = this.confService.getDefaultCurrency().subscribe(curr => this.defaultCurr = curr.code);
        this.navigationMenu.getNavigationMenuHeader().subscribe(data => {
            this.menus = data;
            this.switchDynamicMenuStaticPages();
        });
        // getting contact info
        // getting store identity
        this.store$ = this.confService.store$;
    }
    generateQueryParams(attrName, attrCode) {
        return `${attrName.toString()}:${attrCode.toString()}`;
    }
    switchDynamicMenuStaticPages() {
        if (!this.menus) {
            this.renderTaxonsFromApi();
            this.renderStaticPages();
            this.hasOwnNavigationMenu = false;
        }
        if (this.menus && this.menus.length > 0) {
            this.generteUrls(this.menus);
            this.renderTaxonsFromApi();
            this.hasOwnNavigationMenu = true;
        }
    }
    renderTaxonsFromApi() {
        this.taxonService.getTaxons().subscribe(taxons => {
            this.taxons = taxons;
            this.selectedTaxon = this.taxons[0];
            this.newTaxons = this.chunkArray(this.taxons, 5);
        });
    }
    // almaayergy
    chunkArray(myArray, chunk_size) {
        let index = 0;
        const arrayLength = myArray.length;
        const tempArray = [];
        for (index = 0; index < arrayLength; index += chunk_size) {
            const myChunk = myArray.slice(index, index + chunk_size);
            tempArray.push(myChunk);
        }
        return tempArray;
    }
    viewChildernFirst(taxons) {
        for (let i = 0; i < taxons.length; i++) {
            if (this.taxons[i].children) {
                this.megaMenuIndex = i;
                this.childTaxons = this.taxons[i].children;
                this.childTaxons = this.chunkArray(this.childTaxons, 7);
                break;
            }
        }
    }
    viewCurrentChild(taxon, index) {
        this.megaMenuIndex = index;
        if (taxon.children && taxon.children.length) {
            this.childTaxons = [];
            this.childTaxons = [...taxon.children];
            this.childTaxons = this.chunkArray(this.childTaxons, 7);
        }
        else {
            this.childTaxons = [];
        }
        return this.childernTaxons = [];
    }
    viewCurrentChildren(childValue, indexVal) {
        childValue['showChildren'] = !childValue['showChildren'];
    }
    renderStaticPages() {
        this.staticPagesService.getAllPages('header').subscribe(staticPages => {
            this.staticPages = staticPages;
        });
    }
    generteUrls(array) {
        if (array) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].url_type !== 'external_link') {
                    const url = array[i].url;
                    const tree = this.router.parseUrl(url);
                    const params = tree.queryParams;
                    const g = tree.root.children[PRIMARY_OUTLET];
                    const s = g.segments;
                    const router = ['/', ...s.map(segement => segement.path)];
                    array[i]['parsedUrl'] = { router: router, params: params };
                    this.generteUrls(array[i].children);
                }
            }
            return array;
        }
    }
    getUserName() {
        return this.logged$.pipe(map(() => {
            return localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName');
        }));
    }
    getUser() {
        return this.logged$.pipe(map(() => {
            return {
                firstName: localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName'),
                lastName: localStorage.getItem('user_lastName') ? localStorage.getItem('user_lastName') : sessionStorage.getItem('user_lastName'),
                email: localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email')
            };
        }));
    }
    clickOut(event) {
        if (event.target.id || event.target.parentNode) {
            if (!(event.target.id || event.target.parentNode.id === 'select-category')) {
                this.showCats = false;
            }
        }
    }
    openModal(menu) {
        if (!this.togglestate) {
            this.modalRef = this.modalService.show(menu, Object.assign({}, { class: 'w-80' }));
            this.togglestate = true;
        }
        else {
            this.modalRef.hide();
            this.togglestate = false;
        }
    }
    readUrl() {
        for (const locale of this.availableLanguages) {
            if (this.language['LANGUAGE_CODE'] === locale.code) {
                this.currentLocale = locale;
            }
            this.redirectUrls[locale.code] = this.router.url.replace(this.language['LANGUAGE_CODE'], locale.code).split('?')[0];
        }
    }
    logout() {
        this.loginService.logOut();
    }
    focusOutFunction() {
        setTimeout(() => {
            this.selected = false;
        }, 250);
    }
    // @HostListener('window:scroll', ['$event'])
    // onWindowScroll($event) {
    // 	const number = window.pageYOffset;
    // 	if (number > 150) {
    // 		this.isScrolled = true;
    // 	} else if (this.isScrolled && number === 0) {
    // 		this.isScrolled = false;
    // 	}
    // }
    // chef+ logic
    onShowCart() {
        this.cartState = this.cartState === 'initial' ? 'final' : 'initial';
        this.showCartComponent = !this.showCartComponent;
        this.showSearch = false;
        this.backgroundAcount = false;
    }
    onShowMenu() {
        this.showMenu = !this.showMenu;
        this.showCartComponent = false;
        this.showSearch = false;
    }
    closeMenu() {
        this.showMenu = false;
    }
    onshowCartComponent() {
        this.showCartComponent = !this.showCartComponent;
        this.backgroundCart = !this.backgroundCart;
        this.showMenu = false;
        this.showSearch = false;
        this.backgroundSearch = false;
        this.showAccountComponent = false;
        this.backgroundAcount = false;
    }
    closeCartMenu() {
        this.showCartComponent = false;
    }
    closeAccountMenu() {
        this.showAccountComponent = false;
    }
    onShowAccount() {
        this.cartState = this.cartState === 'initial' ? 'final' : 'initial';
        this.showAccountComponent = !this.showAccountComponent;
        this.backgroundAcount = !this.backgroundAcount;
        this.showSearch = false;
        this.backgroundSearch = false;
        this.showCartComponent = false;
        this.backgroundCart = false;
        this.user = {
            fullName: `${localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName')} ${localStorage.getItem('user_lastName') ? localStorage.getItem('user_lastName') : sessionStorage.getItem('user_lastName')}`,
            email: `${localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email')}`
        };
    }
    onClickedOutside(e) {
        this.cartState = 'initial';
        this.showCartComponent = false;
        this.showAccountComponent = false;
        this.mobileHeader = e.srcElement['classList'].contains('toggle_submenu');
        this.showSearch = false;
        this.backgroundAcount = false;
        this.backgroundCart = false;
        this.backgroundSearch = false;
    }
    // El maeergy
    showAccountOnMobile() {
        this.showAccountMobile = !this.showAccountMobile;
        this.backgroundAcountMobile = !this.backgroundAcountMobile;
        this.backgroundSearchMobile = false;
        this.backgroundCartMobile = false;
        this.showBrandsMobile = false;
        this.showTaxonsMobile = false;
        this.showMenus = !this.showMenus;
    }
    showSearchOnMobile() {
        this.showSearchMobile = !this.showSearchMobile;
        this.backgroundSearchMobile = !this.backgroundSearchMobile;
        this.showAccountMobile = false;
        this.backgroundAcountMobile = false;
        this.backgroundCartMobile = false;
        this.showBrandsMobile = false;
        this.showTaxonsMobile = false;
        this.showMenus = !this.showMenus;
    }
    hideAcount() {
        this.showAccountMobile = false;
        this.backgroundAcountMobile = false;
        this.showSearchMobile = false;
        this.backgroundSearchMobile = false;
        this.backgroundCartMobile = !this.backgroundCartMobile;
        this.showBrandsMobile = false;
        this.showTaxonsMobile = false;
    }
    onshowSearch() {
        this.showSearch = !this.showSearch;
        this.backgroundSearch = !this.backgroundSearch;
        this.showCartComponent = false;
        this.backgroundCart = false;
        this.showAccountComponent = false;
        this.backgroundAcount = false;
    }
    showBrandsOnMobile() {
        this.showBrandsMobile = !this.showBrandsMobile;
        this.showSearchMobile = false;
        this.showAccountMobile = false;
        this.backgroundAcountMobile = false;
        this.showCartComponent = false;
        this.backgroundCartMobile = false;
        this.showSearchMobile = false;
        this.backgroundSearchMobile = false;
        this.showTaxonsMobile = false;
        this.showMenus = !this.showMenus;
        const root = document.getElementsByTagName('html')[0];
        root.classList.remove('overflow_taxon');
        if (root.classList.contains('overflow')) {
            root.classList.remove('overflow');
        }
        else {
            root.classList.add('overflow');
        }
    }
    showTaxosOnMobile() {
        this.showTaxonsMobile = !this.showTaxonsMobile;
        this.showBrandsMobile = false;
        this.showSearchMobile = false;
        this.showAccountMobile = false;
        this.backgroundAcountMobile = false;
        this.showCartComponent = false;
        this.backgroundCartMobile = false;
        this.showSearchMobile = false;
        this.backgroundSearchMobile = false;
        this.showMenus = !this.showMenus;
        const root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only HTML tag)
        root.classList.remove('overflow');
        if (root.classList.contains('overflow_taxon')) {
            root.classList.remove('overflow_taxon');
        }
        else {
            root.classList.add('overflow_taxon');
        }
    }
    toggleLoginAccountMenu() {
        if (this.loginService.isLoggedIn()) {
            this.loginMenu = true;
        }
        else {
            this.accountMenu = true;
        }
        this.onShowAccount();
    }
    addOverFlow() {
        const root = document.getElementsByTagName('html')[0];
        root.classList.add('overflow');
    }
    removeOverFlow() {
        const root = document.getElementsByTagName('html')[0];
        root.classList.remove('overflow');
        root.classList.remove('overflow_taxon');
    }
    getContactInfo(branchFlow) {
        if (branchFlow != 'auto' && branchFlow != 'select') {
            return;
        }
        if (branchFlow == 'auto') {
            this.branch$.subscribe(branch => {
                this.branch = branch;
            });
        }
        if (branchFlow == 'select') {
            this.$contactUs.subscribe((res) => {
                const branchId = +localStorage.getItem('branchId');
                if (branchId && res.branches.length !== 0) {
                    this.branch = res.branches.find(bid => bid.id == branchId);
                    this.confService.branch.next(this.branch);
                }
                else if (!branchId && res.branches.length !== 0) {
                    this.branch = res.branches[0];
                    this.confService.branch.next(this.branch);
                }
            });
        }
    }
    openBranchModal() {
        this.confService.openPopupModal.next(true);
    }
    ngOnDestroy() {
        if (this.navHeaderSub) {
            this.navHeaderSub.unsubscribe();
        }
        if (this.taxonSub) {
            this.taxonSub.unsubscribe();
        }
        if (this.staticPagesSub) {
            this.staticPagesSub.unsubscribe();
        }
        if (this.languageSub) {
            this.languageSub.unsubscribe();
        }
        if (this.currencySubscription) {
            this.currencySubscription.unsubscribe();
        }
    }
    refresh() {
        location.reload();
    }
    // add show chils taxons in side bar on responsive
    showChildTaxons(index, event) {
        event.stopPropagation();
        this.taxons[index]['selected'] = !this.taxons[index]['selected'];
        return false;
    }
}
HeaderBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HeaderBaseComponent, deps: [{ token: LanguageService }, { token: i2.Router }, { token: i5.BsModalService }, { token: TaxonService }, { token: WishListService }, { token: CompareService }, { token: CartService }, { token: i2.ActivatedRoute }, { token: StaticPagesService }, { token: LoginService }, { token: ConfService }, { token: i4.BreakpointObserver }, { token: i0.ElementRef }, { token: DynamicNavigationMenu }, { token: BrandsService }, { token: ContactUsService }], target: i0.ɵɵFactoryTarget.Component });
HeaderBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: HeaderBaseComponent, selector: "ng-component", host: { listeners: { "document:click": "clickOut($event)" } }, ngImport: i0, template: '', isInline: true, animations: [dropAcountMobile] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HeaderBaseComponent, decorators: [{
            type: Component,
            args: [{ template: '', animations: [dropAcountMobile] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i2.Router }, { type: i5.BsModalService }, { type: TaxonService }, { type: WishListService }, { type: CompareService }, { type: CartService }, { type: i2.ActivatedRoute }, { type: StaticPagesService }, { type: LoginService }, { type: ConfService }, { type: i4.BreakpointObserver }, { type: i0.ElementRef }, { type: DynamicNavigationMenu }, { type: BrandsService }, { type: ContactUsService }]; }, propDecorators: { clickOut: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

const SliceDownAnimation = trigger('sliceDown', [
    transition('void => *', [
        style({
            opacity: 0,
            transform: 'translateY(-100px)',
        }),
        animate('300ms ease-in', style({
            opacity: 1,
            transform: 'translateY(0)',
            transition: 'all 0.3s ease-in'
        }))
    ])
]);

class HomeBaseComponent {
    constructor(languageService, collectionService, confService, personalInfoService, taxonService, staticPagesService, router, toastr, activateRoute, breakpointObserver, instagramService, breadcrumbService, brandsService) {
        this.languageService = languageService;
        this.collectionService = collectionService;
        this.confService = confService;
        this.personalInfoService = personalInfoService;
        this.taxonService = taxonService;
        this.staticPagesService = staticPagesService;
        this.router = router;
        this.toastr = toastr;
        this.activateRoute = activateRoute;
        this.breakpointObserver = breakpointObserver;
        this.instagramService = instagramService;
        this.breadcrumbService = breadcrumbService;
        this.brandsService = brandsService;
        this.imageUrl = environment.imageUrl;
        this.sliderLoaded = false;
        this.bannerLoaded = false;
        this.conf$ = this.confService.getConf();
        this.carouselOptions = {
            margin: 10,
            items: 1,
            autoplay: true,
            autoplayHoverPause: true,
            dots: true,
            navSpeed: 1000,
            autoplaySpeed: 2000,
            slideTransition: 'linear',
            loop: false,
        };
        this.loaded = false;
        this.featureOption = {
            margin: 10,
            responsive: {
                0: {
                    stagePadding: 20,
                    items: 1,
                    dots: false,
                    nav: false,
                },
                992: {
                    items: 2,
                    dots: false,
                    nav: true,
                },
            },
            loop: false,
        };
        this.bestsellersOption = {
            dots: false,
            nav: false,
            responsive: {
                0: {
                    stagePadding: 20,
                    items: 1,
                    dots: false,
                    nav: false,
                },
                576: {
                    stagePadding: 20,
                    items: 2,
                    dots: false,
                    nav: false,
                },
                768: {
                    items: 3,
                    dots: false,
                    nav: true,
                },
                992: {
                    items: 4,
                    dots: false,
                    nav: true,
                },
            },
            loop: false,
        };
        this.OwlCustom_3 = {
            margin: 30,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                576: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    margin: 15,
                    dots: true,
                    nav: true,
                },
                992: {
                    items: 3,
                    dots: true,
                    nav: true,
                },
                1024: {
                    items: 3,
                    dots: true,
                    nav: true,
                },
                1100: {
                    items: 3,
                    dots: true,
                    nav: true,
                },
            },
        };
        this.taxons = [];
        this.featuredTaxons = [];
        this.language = {};
        this.featuredProducts = [];
        this.bestsellers = [];
        this.discounted = [];
        this.newArrivals = [];
        this.GlowFeatureOption = {
            margin: 20,
            nav: true,
            responsive: {
                0: {
                    stagePadding: 50,
                    items: 1,
                    dots: false,
                },
                992: {
                    items: 2,
                    dots: false,
                    nav: true,
                },
                1000: {
                    items: 4,
                    dots: false,
                    nav: true,
                },
            },
            loop: false,
        };
        this.SamirCustomOption = {
            margin: 25,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                576: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 20,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    dots: true,
                    nav: false,
                },
                992: {
                    items: 4,
                    dots: true,
                    nav: false,
                },
                1024: {
                    items: 4,
                    dots: true,
                    nav: false,
                },
                1100: {
                    items: 4,
                    dots: false,
                    nav: true,
                },
            },
            loop: false,
        };
        this.SamirBestSeller = {
            margin: 25,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 1,
                    dost: true,
                    nav: false,
                    margin: 20,
                },
                576: {
                    stagePadding: 0,
                    items: 1,
                    dost: true,
                    nav: false,
                    margin: 20,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    dots: true,
                    nav: false,
                },
                992: {
                    items: 4,
                    dots: true,
                    nav: false,
                },
                1024: {
                    items: 4,
                    dots: true,
                    nav: false,
                },
                1100: {
                    items: 4,
                    dots: false,
                    nav: true,
                },
            },
            loop: false,
        };
        this.jansportOptions = {
            margin: 25,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                576: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 20,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    dots: true,
                    nav: false,
                },
                992: {
                    items: 3,
                    dots: true,
                    nav: false,
                },
                1024: {
                    items: 3,
                    dots: true,
                    nav: false,
                },
                1400: {
                    items: 4,
                    dots: false,
                    nav: true,
                },
            },
            loop: false,
        };
        this.bestDealsOption = {
            margin: 10,
            responsive: {
                0: {
                    stagePadding: 20,
                    items: 1,
                    dots: false,
                    nav: false,
                },
                992: {
                    items: 1,
                    dots: false,
                    nav: true,
                },
            },
        };
        this.categoriesOption = {
            autoplay: true,
            autoplayHoverPause: true,
            navSpeed: 1000,
            autoplaySpeed: 2000,
            slideTransition: 'linear',
            mouseDrag: true,
            touchDrag: true,
            loop: false,
            margin: 20,
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 1,
                },
                480: {
                    items: 2,
                },
                992: {
                    items: 3,
                },
            },
        };
        this.instagramOptions = {
            items: 6,
            nav: false,
            drag: true,
            dots: false,
            margin: 0,
            responsive: {
                0: {
                    items: 2,
                },
                480: {
                    items: 3,
                },
                768: {
                    items: 4,
                },
                991: {
                    items: 5,
                },
            },
        };
        this.recaptchaData = { id: '', img: '', email: '' };
        this.slides = [];
        this.filteredSliders = [];
        this.slideConfig = {
            slidesToShow: 3,
            slidesToScroll: 3,
            rows: 2,
            dots: true,
        };
        this.featuredProduct = true;
        this.discount = true;
        this.newArrival = true;
        this.sliceStart = 0;
        this.sliceEnd = 4;
        this.isMore = true;
        this.isGrid = true;
        this.instagram = [];
        this.emailRegex = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }
    static reInit(owlCarousel) {
        if (owlCarousel) {
            owlCarousel.reInit();
        }
    }
    toggle() {
        this.featuredProduct = false;
    }
    toggle2() {
        this.discount = false;
    }
    toggle3() {
        this.newArrival = false;
    }
    get homeBanner$() {
        return this.confService.store$.pipe(map((store) => {
            return environment.imageUrl + store.homeBanner;
        }));
    }
    ngOnInit() {
        /**
         * @description  Clear bradcrumb array only on home component
         * @author Mostafa Mahmoud
         */
        this.key = true;
        this.breadcrumbService.setCustom([]);
        this.confService.storeId.subscribe((data) => {
            this.storeid = data;
        });
        this.defaultImage = environment.defaultImage;
        this.staticPagesService.getAllPages('none').subscribe((staticPages) => {
            this.staticPages = staticPages;
        });
        this.subscribeForm = new FormGroup({
            email: new FormControl(null, [
                Validators.email,
                Validators.required,
                Validators.pattern(this.emailRegex),
            ]),
        });
        this.languageService.getLanguage().subscribe((language) => {
            this.imageUrl = environment.imageUrl;
            this.language = language;
            this.currencyCode = localStorage.getItem('currentCurrency');
            this.collectionService.getHomePageProducts().subscribe((res) => {
                this.bestsellers = this.filterOutOfStockProducts(res['bestseller']);
                this.featuredProducts = this.filterOutOfStockProducts(res['featured']);
                this.newArrivals = this.filterOutOfStockProducts(res['new']);
                this.discounted = this.filterOutOfStockProducts(res['discounted']);
                this.loaded = true;
            });
        });
        // Calling brand's service only for El-Ma3yrgee template
        this.conf$.subscribe((conf) => {
            const confId = [637, 941, 11707];
            iif(() => confId.includes(conf.id), this.brandsService.getBrands(), of(this.brands)).subscribe((brands) => {
                this.brands = brands;
            });
        });
        this.taxonService.getTaxons().subscribe((taxons) => {
            this.taxons = taxons;
            this.featuredTaxons = taxons.filter((taxon) => taxon.featured);
        });
        this.confService.slides$.subscribe((slides) => {
            this.slides = slides;
            this.filteredSliders = slides.filter(slider => slider.homePagePosition === "Top");
            console.log(slides);
            if (this.slides.length > 1) {
                this.carouselOptions.loop = true;
            }
            this.slides.forEach((slide) => slide.loaded = false);
        });
        this.changeNewArrivalRow('480px', 4);
        this.changeNewArrivalRow('767.99px', 6);
        this.changeNewArrivalRow('991.99px', 8);
        this.conf$.subscribe((conf) => {
            if (conf.id === 248) {
                this.instagramService.getInstagram().subscribe((res) => {
                    // tslint:disable-next-line: triple-equals
                    if (res['status'] === 200) {
                        return this.instagram = res['response'].data;
                    }
                });
            }
        });
    }
    // Helper function
    filterOutOfStockProducts(categoryProducts) {
        return categoryProducts.filter((product) => product['variants'][0].tracked && product['variants'][0].stock > 0 || product['variants'][0].tracked === false);
    }
    generateQueryParams(attrName, attrCode) {
        return `${attrName.toString()}:${attrCode.toString()}`;
    }
    changeCarouselOptions(options = {}, extras = {}) {
        if (extras['responsive']) {
            options['responsive'] = extras['responsive'];
        }
        return Object.assign(Object.assign(Object.assign({}, this.carouselOptions), options), { rtl: this.language['DIR'] === 'rtl' });
    }
    getRecaptcha() {
        if (this.subscribeForm.invalid) {
            return;
        }
        const email = this.subscribeForm.get('email').value;
        if (this.subscribeForm.valid) {
            this.recaptchaData = { id: '', img: '', email: '' };
            this.personalInfoService.getNewRecaptcha().subscribe((response) => {
                if (response['id'] && response['path']) {
                    this.recaptchaData.email = email;
                    this.recaptchaData.img =
                        'data:image/png;base64,' + response['path'];
                    this.recaptchaData.id = response['id'];
                    setTimeout(() => {
                        this.subscribeForm.reset();
                    }, 500);
                }
            }, (err) => {
                this.toastr.error(err['error']['response'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            });
        }
    }
    submitEmail() {
        const email = this.subscribeForm.get('email').value;
        if (this.subscribeForm.valid) {
            this.personalInfoService.subscribeToNewsLetter(email).subscribe((response) => {
                if (response.status === 'success') {
                    this.subscribeForm.reset();
                    this.toastr.success(`${this.language['youHaveSubscribedToNewsletterSuccessfully']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
                }
            }, (err) => {
                this.toastr.error(err['error']['response'], `${this.language['error']}!`, {
                    enableHtml: true,
                    closeButton: true,
                });
            });
        }
    }
    goToSliderLink(slide) {
        if (!slide.externalLink && slide.taxon !== '') {
            this.router.navigate(['/', 'collection'], {
                queryParams: { taxons: slide.taxon },
            });
        }
        else if (slide.externalLink) {
            window.open(slide.externalLink);
        }
        else {
            return;
        }
    }
    viewMoreProducts() {
        this.isMore = false;
        this.sliceEnd = this.newArrivals.length;
    }
    changeNewArrivalRow(screenWidth, endNumber) {
        this.breakPointsSub = this.breakpointObserver
            .observe([`(min-width: ${screenWidth})`])
            .subscribe((state) => {
            if (state.matches) {
                this.sliceEnd = endNumber;
            }
        });
    }
    ngOnDestroy() {
        this.key = false;
        if (this.breakPointsSub) {
            this.breakPointsSub.unsubscribe();
        }
    }
    slideLoaded(slide) {
        slide.loaded = true;
        const loadedSlides = [];
        // fill loadedSlides Array
        this.slides.forEach((s) => {
            if (s.loaded) {
                loadedSlides.push(s);
            }
        });
        // check if all slides are fully loaded
        loadedSlides.length === this.slides.length ? this.sliderLoaded = true : this.sliderLoaded = false;
    }
    onViewGrid() {
        this.isGrid = true;
    }
    onViewList() {
        this.isGrid = false;
    }
}
HomeBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HomeBaseComponent, deps: [{ token: LanguageService }, { token: CollectionService }, { token: ConfService }, { token: PersonalInfoService }, { token: TaxonService }, { token: StaticPagesService }, { token: i2.Router }, { token: i3$1.ToastrService }, { token: i2.ActivatedRoute }, { token: i4.BreakpointObserver }, { token: InstagramService }, { token: BreadcrumbService }, { token: BrandsService }], target: i0.ɵɵFactoryTarget.Component });
HomeBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: HomeBaseComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true, animations: [SliceDownAnimation] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HomeBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    animations: [SliceDownAnimation],
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CollectionService }, { type: ConfService }, { type: PersonalInfoService }, { type: TaxonService }, { type: StaticPagesService }, { type: i2.Router }, { type: i3$1.ToastrService }, { type: i2.ActivatedRoute }, { type: i4.BreakpointObserver }, { type: InstagramService }, { type: BreadcrumbService }, { type: BrandsService }]; } });

class Nav {
}
class ProfileContainerBaseComponent {
    constructor(languageService, router, authService) {
        this.languageService = languageService;
        this.router = router;
        this.authService = authService;
        this.navLinks = [];
        this.language = {};
        this.user_fname = localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName');
        this.user_lname = localStorage.getItem('user_lastName') ? localStorage.getItem('user_lastName') : sessionStorage.getItem('user_lastName');
        this.user_email = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email');
        this.user_image$ = this.authService.updatedProfilePic;
        this.items = [];
    }
    ngOnInit() {
        this.user_image$.subscribe(user_image => {
            this.user_image = user_image;
        });
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            this.items = [
                {
                    name: language['orders'],
                    to: 'order-history',
                    icon: 'fa fa-list-alt'
                },
                {
                    name: language['addresses-book'],
                    to: 'addresses-book',
                    icon: 'fa fa-map-marker'
                },
                {
                    name: language['setting'],
                    to: 'dashboard',
                    icon: 'fa fa-cogs'
                }
            ];
            this.index = this.items.indexOf(this.items.find(item => this.router.url.includes(item.to)));
        });
    }
    onClick(index) {
        this.index = index;
    }
}
ProfileContainerBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProfileContainerBaseComponent, deps: [{ token: LanguageService }, { token: i2.Router }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Component });
ProfileContainerBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ProfileContainerBaseComponent, selector: "app-base-profile-container", ngImport: i0, template: "<section class=\"Profile-page\">\r\n  <div class=\"profile-page-head\">\r\n    <div class=\"container\">\r\n      <div class=\"page-head-wrapper\">\r\n        <div class=\"flaot-left\">\r\n          <div class=\"user-profile-list\">\r\n            <div class=\"user-profile-img\">\r\n              <img *ngIf=\"user_image\" [src]=\"user_image\" [alt]=\"user_lname\">\r\n              <i *ngIf=\"!user_image\" class=\"fa fa-user\"></i>\r\n            </div>\r\n            <div class=\"user-profile-info\">\r\n              <h4 class=\"user-name\">{{ user_fname + ' ' + user_lname }}</h4>\r\n              <span class=\"email\">{{ user_email }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"flaot-right\">\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!--End Container-->\r\n  </div>\r\n  <!--End Profile-page-head-->\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4\">\r\n        <aside class=\"side-menu-links\">\r\n          <ul class=\"side-menu-list\">\r\n            <li *ngFor=\"let item of items; let i=index;\">\r\n              <a class=\"side-menu-link\" (click)=\"onClick(i)\" [class.active]=\"index==i\"\r\n                [routerLink]=\" ['/', language['LANGUAGE_CODE'], 'profile', item.to]\">\r\n                <i [class]=\"item.icon\"></i> {{item.name}} </a>\r\n            </li>\r\n          </ul>\r\n        </aside>\r\n      </div>\r\n      <!--End Col-->\r\n      <div class=\"col-md-8\">\r\n        <div class=\"profile-page-content\">\r\n          <router-outlet></router-outlet>\r\n        </div>\r\n        <!--End profile-content-->\r\n      </div>\r\n      <!--End Col-->\r\n    </div>\r\n    <!--End Row-->\r\n  </div>\r\n  <!--End Container-->\r\n</section>\r\n<!--End Profile-page-->\r\n", styles: [":host .Profile-page{position:relative;background-color:var(--background-color, #F5F5F5)}:host .Profile-page .profile-page-head{background-color:#09f;padding:20px 0;margin-bottom:30px}:host .Profile-page .profile-page-head .user-profile-list{color:#fff}:host .Profile-page .profile-page-head .user-profile-list .user-profile-img{overflow:hidden;display:inline-block;vertical-align:middle;width:70px;height:70px;line-height:70px;text-align:center;background-color:#fff;color:var(--main-color, orange);font-size:40px;border-radius:15px}@media (max-width: 768px){:host .Profile-page .profile-page-head .user-profile-list .user-profile-img{width:40px;height:40px;line-height:40px;font-size:20px}}:host .Profile-page .profile-page-head .user-profile-list .user-profile-info{display:inline-block;vertical-align:middle;padding:0 15px}:host .Profile-page .profile-page-head .user-profile-list .user-profile-info .user-name{margin-bottom:5px;font-weight:600;text-transform:capitalize}@media (max-width: 768px){:host .Profile-page .profile-page-head .user-profile-list .user-profile-info h4{font-size:15px}}@media (max-width: 768px){:host .Profile-page .profile-page-head{padding:15px 0}}:host .Profile-page .side-menu-list{padding:0;margin:0;list-style:none}:host .Profile-page .side-menu-list li{margin-bottom:10px}:host .Profile-page .side-menu-list li .side-menu-link{display:block;padding:15px;text-decoration:none;background-color:#e6e6e6;border-radius:10px;color:var(--body-link-color, #6b6b6b);font-size:var(--body-link-font-size, 22px);text-transform:capitalize;transition:all .3s ease-in-out}:host .Profile-page .side-menu-list li .side-menu-link.active{font-weight:700;color:var(--main-color, orange);background-color:#fff}:host .Profile-page .side-menu-list li .side-menu-link.active i{color:var(--main-color, orange)}:host .Profile-page .side-menu-list li .side-menu-link i{margin-right:5px}[dir=rtl] :host .Profile-page .side-menu-list li .side-menu-link i{margin-right:auto;margin-left:5px}@media (max-width: 768px){:host .Profile-page .side-menu-list li .side-menu-link{font-size:15px}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i2.RouterOutlet, selector: "router-outlet", outputs: ["activate", "deactivate"], exportAs: ["outlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProfileContainerBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-profile-container',
                    templateUrl: './profile-container.base-component.html',
                    styleUrls: ['./profile-container.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i2.Router }, { type: AuthService }]; } });

class AddressBookBaseComponent {
    constructor(formBuilder, addressingService, languageService, toastr, checkoutService, confService) {
        this.formBuilder = formBuilder;
        this.addressingService = addressingService;
        this.languageService = languageService;
        this.toastr = toastr;
        this.checkoutService = checkoutService;
        this.confService = confService;
        this.addresses = [];
        this.countries = [];
        this.cities = [];
        this.errors = [];
        this.language = {};
        this.provinces = [];
        this.areas = [];
        this.validationErrors = {};
        this.addAddressForm = this.formBuilder.group({
            firstName: ['', [
                    Validators.required,
                    Validators.minLength(2),
                ]],
            lastName: ['', [
                    Validators.required,
                    Validators.minLength(2),
                ]],
            phoneKey: [null, [Validators.required]],
            phoneNumber: ['', Validators.required],
            street: ['', [
                    Validators.required,
                ]],
            countryCode: ['', [
                    Validators.required,
                ]],
            cityName: ['', [
                    Validators.required,
                ]],
            areaCode: ['', [
                    Validators.required
                ]]
        });
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        this.confService.store$.subscribe((store) => {
            this.separateFloorApp = store['separateFloorApp'];
            if (!this.separateFloorApp) {
                this.addAddressForm = this.formBuilder.group({
                    firstName: ['', [
                            Validators.required,
                            Validators.minLength(2),
                        ]],
                    lastName: ['', [
                            Validators.required,
                            Validators.minLength(2),
                        ]],
                    phoneKey: [null, [Validators.required]],
                    phoneNumber: ['', Validators.required],
                    street: ['', [
                            Validators.required,
                        ]],
                    countryCode: ['', [
                            Validators.required,
                        ]],
                    cityName: ['', [
                            Validators.required,
                        ]],
                    areaCode: ['', [
                            Validators.required
                        ]]
                });
            }
            else {
                this.addAddressForm = this.formBuilder.group({
                    firstName: ['', [
                            Validators.required,
                            Validators.minLength(2),
                        ]],
                    lastName: ['', [
                            Validators.required,
                            Validators.minLength(2),
                        ]],
                    phoneKey: [null, [Validators.required]],
                    phoneNumber: ['', Validators.required],
                    building: ['', [
                            Validators.required,
                        ]],
                    floor: ['', [
                            Validators.required,
                        ]],
                    appartement: ['', [
                            Validators.required,
                        ]],
                    neighborhood: ['', [
                            Validators.required,
                        ]],
                    street: ['', [
                            Validators.required,
                        ]],
                    countryCode: ['', [
                            Validators.required,
                        ]],
                    cityName: ['', [
                            Validators.required,
                        ]],
                    areaCode: ['', [
                            Validators.required
                        ]]
                });
            }
            this.addAddressForm.valueChanges.subscribe(() => {
                const keys = Object.keys(this.addAddressForm.controls);
                this.errors = [];
                for (const key of keys) {
                    const control = this.addAddressForm.controls[key];
                    if (control.invalid && control.dirty) {
                        if (!!control.errors.minlength) {
                            this.errors.push(`${key
                                .replace(/([A-Z])/g, ' $1')
                                .toLowerCase()} minimum length is ${control.errors.minlength.requiredLength}`);
                        }
                        else if (!!control.errors.required) {
                            this.errors.push(`${key.replace(/([A-Z])/g, ' $1').toLowerCase()} is required`);
                        }
                        else {
                            this.errors.push(`invalid ${key.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
                        }
                    }
                }
            });
        });
        this.checkoutService.getCountriesCitiesProvinces().pipe(map$1(data => data['response'])).subscribe((data) => {
            this.countries = data;
            this.addAddressForm.get('phoneKey').setValue(data[0].phoneKey);
        });
        this.addressingService.getAddresses().subscribe(addresses => {
            this.addresses = addresses;
        });
    }
    deleteAddress(id) {
        this.addressingService.deleteAddress(id);
    }
    updateAddressingCities(city) {
        this.addressingService.getCitiesFromApi(city).pipe(map$1(data => data['response'])).subscribe((data) => {
            this.cities = data;
        });
    }
    selectCity(cityid) {
        this.addressingService.getAreasFromApi(cityid).pipe(map$1(data => data['response'])).subscribe(data => {
            this.areas = data;
        });
    }
    addAddress() {
        let address;
        if (!this.separateFloorApp) {
            address = {
                areaCode: this.addAddressForm.value['areaCode'],
                cityName: this.addAddressForm.value['cityName'],
                countryCode: this.addAddressForm.value['countryCode'],
                firstName: this.addAddressForm.value['firstName'],
                lastName: this.addAddressForm.value['lastName'],
                phoneNumber: this.addAddressForm.value['phoneKey'] ?
                    this.addAddressForm.value['phoneKey'] + '-' + this.addAddressForm.value['phoneNumber']
                    : this.addAddressForm.value['phoneNumber'],
                street: this.addAddressForm.value['street']
            };
        }
        else {
            let collectAddress = 'Building-' + this.addAddressForm.value['building'].split('-') + '-floor-' + this.addAddressForm.value['floor'].split('-') + '-apartement-' + this.addAddressForm.value['appartement'].split('-') + '-neighbourhood-' + this.addAddressForm.value['neighborhood'].split('-') + '-street-' + this.addAddressForm.value['street'].split('-');
            address = {
                areaCode: this.addAddressForm.value['areaCode'],
                cityName: this.addAddressForm.value['cityName'],
                countryCode: this.addAddressForm.value['countryCode'],
                firstName: this.addAddressForm.value['firstName'],
                lastName: this.addAddressForm.value['lastName'],
                phoneNumber: this.addAddressForm.value['phoneKey'] ?
                    this.addAddressForm.value['phoneKey'] + '-' + this.addAddressForm.value['phoneNumber']
                    : this.addAddressForm.value['phoneNumber'],
                street: collectAddress
            };
        }
        this.addressingService.addAddress(address).subscribe((res) => {
            this.toastr.success(res.response, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
            this.addAddressForm.reset({ phoneKey: this.countries[0].phoneKey });
        }, (err) => {
            if (err.error) {
                this.validationErrors = err.error.errors;
            }
            let toastrMsg = this.language['sorrySomethingWentWrong'];
            if (err.error.message) {
                toastrMsg = err.error.message;
            }
            this.toastr.error(`${toastrMsg} !`);
        });
    }
    numberOnly(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        return charCode > 31 && (charCode < 48 || charCode > 57) ? false : true;
    }
}
AddressBookBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AddressBookBaseComponent, deps: [{ token: i1$1.FormBuilder }, { token: AddressingService }, { token: LanguageService }, { token: i3$1.ToastrService }, { token: CheckoutService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
AddressBookBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: AddressBookBaseComponent, selector: "app-base-address-book", ngImport: i0, template: "<div class=\"dashboard-content\">\r\n  <div class=\"title\">\r\n    <h3>\r\n      {{language['addresses-book']}}\r\n    </h3>\r\n  </div>\r\n  <!--End Title-->\r\n  <div class=\"box-item\">\r\n    <div class=\"box-item-head\">\r\n      {{language['allAddresses']}}\r\n    </div>\r\n    <div class=\"box-item-content\">\r\n      <div class=\"row sm-gutters\">\r\n        <div class=\"col-lg-6\" *ngFor=\"let address of addresses; let i = index\">\r\n          <div class=\"address-book\">\r\n            <div class=\"address-item\">\r\n              <span>{{language['address']}}</span>\r\n              <span>#{{i+1}}</span>\r\n            </div>\r\n            <div class=\"address-item\">\r\n              <span>{{language['firstName']}}</span>\r\n              <span>{{address.FirstName}}</span>\r\n            </div>\r\n            <div class=\"address-item\">\r\n              <span>{{language['lastName']}} </span>\r\n              <span>{{address.LastName}}</span>\r\n            </div>\r\n            <div class=\"address-item\">\r\n              <span>{{language['phone_number']}} </span>\r\n              <span>{{address.PhoneNumber}}</span>\r\n            </div>\r\n            <div class=\"address-item\">\r\n              <span>{{language['area']}}</span>\r\n              <span>{{address.AreaInfo?.name}}</span>\r\n            </div>\r\n            <div class=\"address-item\">\r\n              <span>{{language['city']}}</span>\r\n              <span>{{address.CityInfo?.name}}</span>\r\n            </div>\r\n            <div class=\"address-item\">\r\n              <span>{{language['CountryCode']}}</span>\r\n              <span>{{address.CountryCode}}</span>\r\n            </div>\r\n            <div class=\"address-item\">\r\n              <span>{{language['address']}}</span>\r\n              <span>{{address.Street}}</span>\r\n            </div>\r\n            <a routerLink=\"/{{language['LANGUAGE_CODE']}}/profile/edit-address/{{address.ID}}\"\r\n              class=\"btn-dit btn\">{{language['edit']}}</a>\r\n            <button (click)=\"deleteAddress(address.ID)\" class=\"btn-delete btn\"\r\n              [disabled]='address.hasOrders'>{{language['delete']}}</button>\r\n          </div>\r\n          <!--End Address-book-->\r\n        </div>\r\n        <!--End Col-->\r\n      </div>\r\n      <!--End Row-->\r\n      <div *ngIf=\"!addresses.length\" class=\"no-address\">{{language['noaddress']}}</div>\r\n      <!-- <a class=\"btn btn-primary\" routerLink=\"/{{language['LANGUAGE_CODE']}}/profile/add-address\">{{language['add_new_address']}}</a> -->\r\n    </div>\r\n    <!--End box-item=content-->\r\n  </div>\r\n  <!--End box-item-->\r\n\r\n  <div class=\"box-item\">\r\n    <div class=\"box-item-head\">\r\n      {{language['add_address']}}\r\n    </div>\r\n    <div class=\"box-item-content\">\r\n      <form class=\"inline-form\" [formGroup]=\"addAddressForm\" (ngSubmit)=\"addAddress()\">\r\n        <div class=\"form-group\">\r\n          <label>{{language['firstName']}}</label>\r\n          <input type=\"text\" name=\"firstName\" id=\"firstName\" class=\"form-control\"\r\n            placeholder=\"{{language['firstName']}}\" formControlName=\"firstName\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['firstName'].touched && addAddressForm?.controls['firstName'].errors?.required\">\r\n            {{language['Please_enter_your_first_name']}}\r\n          </div>\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['firstName'].touched && addAddressForm?.controls['firstName'].errors?.minlength\">\r\n            {{language['Please_make_your_name_not_less_than_2_letters']}}\r\n          </div>\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['firstName'].touched && addAddressForm?.controls['firstName'].errors?.pattern\">\r\n            {{language['Please_make_your_name_doesnt_contain_numbers_or_symbols']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n\r\n        <div class=\"form-group\">\r\n          <label>{{language['lastName']}}</label>\r\n          <input type=\"text\" name=\"lastName\" id=\"lastName\" class=\"form-control\" placeholder=\"{{language['lastName']}}\"\r\n            formControlName=\"lastName\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\" addAddressForm?.controls['lastName'].touched && addAddressForm?.controls['lastName'].errors?.required\">\r\n            {{language['please_enter_your_last_name']}}\r\n          </div>\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['lastName'].touched && addAddressForm?.controls['lastName'].errors?.minlength\">\r\n            {{language['Please_make_your_name_not_less_than_2_letters']}}\r\n          </div>\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['lastName'].touched && addAddressForm?.controls['lastName'].errors?.pattern\">\r\n            {{language['Please_make_your_name_doesnt_contain_numbers_or_symbols']}}\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>{{language['phone_number']}}</label>\r\n          <div class=\"phoneNumber\">\r\n            <div class=\"phone-country-selector\">\r\n              <ng-select [selectOnTab]=\"true\" [items]=\"countries\" formControlName=\"phoneKey\" bindValue=\"phoneKey\"\r\n                bindLabel=\"code\" placeholder=\"Code\" class=\"w-100\" [clearable]=\"false\">\r\n                <ng-template ng-label-tmp let-item=\"item\">\r\n                  <ng-container *ngIf=\"item.phoneKey\">\r\n                    <img [lazyLoad]=\"'https://flagcdn.com/h20/'+ item.code.toLowerCase() +'.png'\" width=\"20\" />\r\n                    {{item.phoneKey}}\r\n                  </ng-container>\r\n\r\n                </ng-template>\r\n\r\n                <ng-template ng-option-tmp let-item=\"item\">\r\n                  <img [lazyLoad]=\"'https://flagcdn.com/h20/'+ item.code.toLowerCase() +'.png'\" />\r\n                  {{item.code}}\r\n                </ng-template>\r\n              </ng-select>\r\n            </div>\r\n            <input (keypress)=\"numberOnly($event)\" class=\"form-control mx-1\" placeholder=\"{{language['phone_number']}}\"\r\n              formControlName=\"phoneNumber\" id=\"phoneNumberInput\" type=\"text\">\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['phoneNumber'].touched && addAddressForm?.controls['phoneNumber'].errors?.required\">\r\n            {{language['please_enter_your_phone_number']}}\r\n          </div>\r\n          <div *ngIf=\"validationErrors['phoneNumber']\">\r\n            {{ validationErrors['phoneNumber'] }}\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label>{{language['country']}}</label>\r\n          <select name=\"countryCode\" id=\"countryCode\" class=\"form-control\" formControlName=\"countryCode\"\r\n            (change)=\"updateAddressingCities($event.target.value)\">\r\n            <option value=\"\" disabled>{{language['country']}}</option>\r\n            <option *ngFor=\"let country of countries\" [value]=\"country.code\"> {{ country.name }} </option>\r\n          </select>\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['countryCode'].touched && addAddressForm?.controls['countryCode'].errors?.required\">\r\n            {{language['please_enter_your_country']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n\r\n        <div class=\"form-group\">\r\n          <label>{{language['city']}}</label>\r\n          <select name=\"cityName\" id=\"cityName\" class=\"form-control\" formControlName=\"cityName\"\r\n            (change)=\"selectCity($event.target.value)\">\r\n            <option value=\"\" disabled>{{language['city']}}</option>\r\n            <option *ngFor=\"let city of cities\" [value]=\"city.code\">{{ city.name }}</option>\r\n          </select>\r\n        </div>\r\n        <!--End Form-group-->\r\n\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['cityName'].touched && addAddressForm?.controls['cityName'].errors?.required\">\r\n            {{language['please_enter_your_city']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n\r\n        <!--End Form-group-->\r\n\r\n        <div class=\"form-group\">\r\n          <label for=\"areaCode\">\r\n            {{language['area']}}\r\n          </label>\r\n          <select class=\"form-control\" formControlName='areaCode' id=\"areaCode\">\r\n            <option value=\"\" disabled> {{language['area'] }}</option>\r\n            <option *ngFor=\"let area of areas\" [value]=\"area.code\">{{ area.name }}</option>\r\n          </select>\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"addAddressForm?.controls['areaCode'].touched && addAddressForm?.controls['areaCode'].errors?.required\">\r\n            {{language['please_enter_your_area']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <!--separateFloorApp-->\r\n        <div *ngIf=\"separateFloorApp\">\r\n          <div class=\"form-group\">\r\n            <label>{{ language[\"address-building\"] }}</label>\r\n            <input type=\"text\" name=\"building\" id=\"building\" class=\"form-control\" placeholder=\"{{ language['address-building'] }}\"\r\n              formControlName=\"building\">\r\n          </div>\r\n          <!--End Form-group-->\r\n          <div class=\"validation-text\">\r\n            <div *ngIf=\"addAddressForm?.controls['street'].touched && addAddressForm?.controls['street'].errors?.required\">\r\n              {{language['please_enter_your_address-building']}}\r\n            </div>\r\n          </div>\r\n          <!--End Validation-text-->\r\n          <div class=\"form-group\">\r\n            <label>{{ language[\"address-floor\"] }}</label>\r\n            <input type=\"text\" name=\"floor\" id=\"floor\" class=\"form-control\" placeholder=\"{{ language['address-floor'] }}\"\r\n              formControlName=\"floor\">\r\n          </div>\r\n          <!--End Form-group-->\r\n          <div class=\"validation-text\">\r\n            <div *ngIf=\"addAddressForm?.controls['street'].touched && addAddressForm?.controls['street'].errors?.required\">\r\n              {{language['please_enter_your_address-floor']}}\r\n            </div>\r\n          </div>\r\n          <!--End Validation-text-->\r\n          <div class=\"form-group\">\r\n            <label>{{ language[\"address-appartement\"] }}</label>\r\n            <input type=\"text\" name=\"appartement\" id=\"appartement\" class=\"form-control\" placeholder=\"{{ language['address-appartement'] }}\"\r\n              formControlName=\"appartement\">\r\n          </div>\r\n          <!--End Form-group-->\r\n          <div class=\"validation-text\">\r\n            <div *ngIf=\"addAddressForm?.controls['street'].touched && addAddressForm?.controls['street'].errors?.required\">\r\n              {{language['please_enter_your_address-appartement']}}\r\n            </div>\r\n          </div>\r\n          <!--End Validation-text-->\r\n          <div class=\"form-group\">\r\n            <label>{{ language[\"address-neighborhood\"] }}</label>\r\n            <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" class=\"form-control\" placeholder=\"{{ language['address-neighborhood'] }}\"\r\n              formControlName=\"neighborhood\">\r\n          </div>\r\n          <!--End Form-group-->\r\n          <div class=\"validation-text\">\r\n            <div *ngIf=\"addAddressForm?.controls['street'].touched && addAddressForm?.controls['street'].errors?.required\">\r\n              {{language['please_enter_your_address-neighborhood']}}\r\n            </div>\r\n          </div>\r\n          <!--End Validation-text-->\r\n          </div>\r\n          <!--separateFloorApp-->\r\n        <div class=\"form-group\">\r\n          <label>{{language['address']}}</label>\r\n          <input type=\"text\" name=\"street\" id=\"street\" class=\"form-control\" placeholder=\"{{language['ProfilecheckoutAddress']}}\"\r\n            formControlName=\"street\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"validation-text\">\r\n          <div *ngIf=\"addAddressForm?.controls['street'].touched && addAddressForm?.controls['street'].errors?.required\">\r\n            {{language['please_enter_your_ProfilecheckoutAddress']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <div class=\"form-group justify-content-end\">\r\n          <input type=\"submit\" value=\"{{language['add_address']}}\" class=\"custom-btn\"\r\n            [disabled]=\"!addAddressForm?.valid\">\r\n        </div>\r\n       \r\n        <!--End Form-group-->\r\n      </form>\r\n    </div>\r\n    <!--End box-item=content-->\r\n  </div>\r\n  <!--End box-item-->\r\n</div>\r\n<!--End dashboard-content-->\r\n", styles: ["h3{color:red}.address-book{position:relative;padding:10px;background-color:#f5f5f5;margin-bottom:15px;border-radius:10px}.address-book .address-item{margin-bottom:10px;overflow:hidden;text-transform:capitalize;display:flex;justify-content:space-between}.address-book .address-item span:first-child{font-weight:bold}.address-book .address-item span:last-child{float:right}[dir=rtl] .address-book .address-item span:last-child{float:left}.btn{background-color:#09f;margin:0 5px;color:#fff;text-transform:capitalize;font-size:14px;border-radius:2px;padding:3px 10px;box-shadow:none;border:0;transition:all .2s ease-in-out}.btn:hover{background-color:#09f}.btn.btn-delete{background-color:#bd2130}.no-address{padding:30px;text-align:center;text-transform:capitalize;font-size:24px}.phone-country-selector{min-width:120px}.phone-country-selector ::ng-deep .ng-placeholder{font-size:12px}.phone-country-selector .ng-touched.ng-invalid:not(form){border:1px solid red}.phoneNumber{display:flex;align-items:center;justify-content:flex-start}.phoneNumber ::ng-deep .ng-select.ng-select-single .ng-select-container{border:1px solid #acacac;height:50px;border-radius:20px;box-shadow:none}#phoneNumberInput{width:100%}@media (min-width: 576px){.phoneNumber{width:70%}}.profile-page-content .box-item .box-item-content .inline-form .form-group .form-control,.profile-page-content .box-item .box-item-content .inline-form .form-group label{width:100%!important}\n"], components: [{ type: i5$1.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i5$1.ɵh, selector: "[ng-label-tmp]" }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i5$1.ɵf, selector: "[ng-option-tmp]" }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AddressBookBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-address-book',
                    templateUrl: './address-book.base-component.html',
                    styleUrls: ['./address-book.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$1.FormBuilder }, { type: AddressingService }, { type: LanguageService }, { type: i3$1.ToastrService }, { type: CheckoutService }, { type: ConfService }]; } });

class DashboardBaseComponent {
    constructor(formBuilder, personalInfoService, languageService, changePasswordService, toastr, checkoutService, confService, loginService, router, authService) {
        this.formBuilder = formBuilder;
        this.personalInfoService = personalInfoService;
        this.languageService = languageService;
        this.changePasswordService = changePasswordService;
        this.toastr = toastr;
        this.checkoutService = checkoutService;
        this.confService = confService;
        this.loginService = loginService;
        this.router = router;
        this.authService = authService;
        this.user_fname = localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName');
        this.user_lname = localStorage.getItem('user_lastName') ? localStorage.getItem('user_lastName') : sessionStorage.getItem('user_lastName');
        this.user_email = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email');
        this.language = {};
        this.regExpForMobileNumbers = '^01[0125][0-9]{8}$';
        this.regExpForOnlyLetters = '^[a-zA-Z]*$';
        this.dataSentSuccessfully = false;
        this.personIsHere = false;
        this.isVerified = false;
        this.countries = [];
        this.verifyMobileRequired$ = this.confService.verifyMobileRequired;
        this.imgChanged = false;
        this.errors = [];
        this.data = this.router.getCurrentNavigation().extras.state;
        if (this.data && this.data.errors && this.data.errors.length > 0) {
            this.data.errors.forEach(element => {
                this.toastr.error(element);
                this.errors.push(element);
            });
        }
    }
    ngOnInit() {
        this.personalInfoService.getUser().subscribe((res) => {
            this.person = res;
            if (res['verified']) {
                this.isVerified = true;
            }
            if (res['image']) {
                this.isImageSaved = true;
                this.cardImageBase64 = environment.imageUrl + this.person.image;
                this.authService.updatedProfilePic.next(environment.imageUrl + this.person.image);
            }
            this.verifyMobileRequired$.subscribe(verifyMobileRequired => {
                this.verifyMobileRequired = verifyMobileRequired;
                this.dataBackFromVerify = (this.data && this.data != null && this.data.data && this.data.data != null && this.verifyMobileRequired == true) ? true : false;
                this.statusBackFromVerify = (this.data && this.data != null && this.data.data && this.data.data != null && this.verifyMobileRequired == true && this.data.info && this.data.info != null && this.data.info.status && this.data.info.status == 'verified') ? true : false;
                this.personalForm.controls['image'].setValue((this.dataBackFromVerify && this.data.data.image) ? this.data.data.image : this.person.image);
                this.personalForm.controls['firstName'].setValue((this.dataBackFromVerify && this.data.data.firstName) ? this.data.data.firstName : this.person.firstName);
                this.personalForm.controls['lastName'].setValue((this.dataBackFromVerify && this.data.data.lastName) ? this.data.data.lastName : this.person.lastName);
                this.personalForm.controls['email'].setValue((this.dataBackFromVerify && this.data.data.email) ? this.data.data.email : this.person.email);
                if (this.person.birthday) {
                    this.personalForm.controls['birthday'].setValue((this.dataBackFromVerify && this.data.data.birthday) ? this.data.data.birthday.split('T')[0] : this.person.birthday.split('T')[0]);
                }
                this.personalForm.controls['gender'].setValue((this.dataBackFromVerify && this.data.data.gender) ? this.data.data.gender : this.person.gender);
                const phoneNumber = this.person.phoneNumber.split('-');
                if (phoneNumber.length >= 2) {
                    this.personalForm.controls['phoneKey'].setValue(phoneNumber[0]);
                    this.personalForm.controls['phoneNumber'].setValue((this.dataBackFromVerify && this.data.data.phoneNumber) ? this.data.data.phoneNumber : phoneNumber[1]);
                }
                else {
                    this.personalForm.controls['phoneNumber'].setValue((this.dataBackFromVerify && this.data.data.phoneNumber) ? this.data.data.phoneNumber : this.person.phoneNumber);
                }
                // this.personalForm.controls['phoneNumber'].setValue((this.dataBackFromVerify && this.data.data.phoneNumber ) ? this.data.data.phoneNumber : this.person.phoneNumber);
                this.personalForm.controls['subscribedToNewsletter'].setValue((this.dataBackFromVerify && this.data.data.subscribedToNewsletter) ? this.data.data.subscribedToNewsletter : this.person.subscribedToNewsletter);
                this.personIsHere = true;
            });
            // this.personalForm.controls['image'].setValue(this.person.image);
            // this.personalForm.controls['firstName'].setValue(this.person.firstName);
            // this.personalForm.controls['lastName'].setValue(this.person.lastName);
            // this.personalForm.controls['email'].setValue(this.person.email);
            // if (this.person.birthday) {
            //   this.personalForm.controls['birthday'].setValue(this.person.birthday.split('T')[0]);
            // }
            // this.personalForm.controls['gender'].setValue(this.person.gender);
            // let phoneNumber =  this.person.phoneNumber.split("-");
            // if(phoneNumber.length >= 2){
            //   this.personalForm.controls['phoneKey'].setValue(phoneNumber[0]);
            //   this.personalForm.controls['phoneNumber'].setValue(phoneNumber[1]);
            // }else{
            //   this.personalForm.controls['phoneNumber'].setValue(this.person.phoneNumber);
            // }
            // this.personalForm.controls['subscribedToNewsletter'].setValue(this.person.subscribedToNewsletter);
            // this.personIsHere = true;
        });
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        // Initializing personal form
        this.personalForm = this.formBuilder.group({
            image: [
                ''
            ],
            firstName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.pattern(this.regExpForOnlyLetters)
                ]
            ],
            lastName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.pattern(this.regExpForOnlyLetters)
                ]
            ],
            email: ['', [Validators.email, Validators.required]],
            birthday: [null, []],
            gender: ['u', [Validators.required]],
            phoneKey: [null, [Validators.required]],
            phoneNumber: [
                '',
                [Validators.required, Validators.minLength(7), Validators.maxLength(14)]
            ],
            subscribedToNewsletter: [false, []]
        });
        // Initializing change password form
        this.chnagePasswordForm = this.formBuilder.group({
            oldPassword: ['', [Validators.required, Validators.minLength(6)]],
            newPassword: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
        });
        this.checkoutService.getCountriesCitiesProvinces().pipe(map$1(data => data['response'])).subscribe((data) => {
            this.countries = data;
            this.personalForm.get('phoneKey').setValue(data[0].phoneKey);
        });
    }
    fileChangeEvent(fileInput) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.cardImageBase64 = e.target.result;
                this.imgChanged = true;
                this.isImageSaved = true;
                this.personalForm.controls['image'].setValue(this.cardImageBase64);
            };
            reader.readAsDataURL(fileInput.target.files[0]);
        }
    }
    verifyOTP(newCustomer) {
        const currentPhoneNumber = this.personalForm.value['phoneNumber'];
        const navigationExtras = {
            state: {
                info: { from: 'dashboard', to: 'verify-phone', 'status': 'notVerified', 'phoneNumber': currentPhoneNumber },
                data: newCustomer
            }
        };
        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'verify-phone'], navigationExtras);
    }
    changePhoneNumber() {
        this.statusBackFromVerify = false;
    }
    onSubmit() {
        this.changeAddressLoading = true;
        const body = {
            email: this.personalForm.get('email').value,
            image: this.personalForm.get('image').value,
            firstName: this.personalForm.get('firstName').value,
            lastName: this.personalForm.get('lastName').value,
            birthday: this.personalForm.get('birthday').value,
            gender: this.personalForm.get('gender').value,
            phoneNumber: this.personalForm.value['phoneKey'] ?
                this.personalForm.value['phoneKey'] + '-' + this.personalForm.value['phoneNumber']
                : this.personalForm.value['phoneNumber'],
            subscribedToNewsletter: this.personalForm.get('subscribedToNewsletter').value,
        };
        if ((this.verifyMobileRequired == true && this.statusBackFromVerify == false)) {
            const customerId = localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : sessionStorage.getItem('customer_id');
            const currentPhoneNumber = this.personalForm.value['phoneNumber'];
            this.loginService.getphoneNumberOTP(currentPhoneNumber, customerId).subscribe({
                next: data => {
                    if (data && data.success && data.success == 'sms_sent') {
                        this.verifyOTP(body);
                        return;
                    }
                    if (data && data.success && data.success == 'already_verified') {
                        this.statusBackFromVerify = true;
                        this.onSubmit();
                        return;
                    }
                    if (data && data.success && data.success == 'already_verified') {
                        this.statusBackFromVerify = true;
                        this.onSubmit();
                        return;
                    }
                    (!data.success && data.message) ? this.toastr.error(data.message) : '';
                },
                error: error => {
                    (error && error.error && error.error.message) ? this.toastr.error(error.error.message) : '';
                }
            });
            return;
        }
        this.personalInfoService.updateUserInfo(body).subscribe(() => {
            this.changeAddressLoading = false;
            this.dataSentSuccessfully = true;
            this.toastr.success(this.language['userDataUpdatedSuccessfully']);
            this.authService.updatedProfilePic.next(this.personalForm.controls['image'].value);
            localStorage.setItem('user_firstName', body['firstName']);
            localStorage.setItem('user_image', environment.imageUrl + this.personalForm.controls['image'].value);
            localStorage.setItem('user_lastName', body['lastName']);
            localStorage.setItem('user_phone', body['phoneNumber']);
            localStorage.setItem('user_email', body['email']);
            this.imgChanged = false;
        }, err => {
            this.changeAddressLoading = false;
            const msg = err['error'] ? err['error']['message'] : this.language['sorrySomethingWentWrong'];
            this.toastr.error(this.language['sorrySomethingWentWrong']);
        });
    }
    changePasswordForm() {
        this.changePasswordLoading = true;
        this.changePasswordService.changePassword(this.chnagePasswordForm.value).subscribe((res) => {
            this.changePasswordLoading = false;
            if (res.status === 'success') {
                this.makenewPasswordLikeConfirmPassword = false;
                this.responseText = res.response;
                this.toastr.success(res.response);
                this.chnagePasswordForm.reset();
            }
            else {
                this.toastr.error(res.response);
            }
        }, () => {
            this.changePasswordLoading = false;
            this.toastr.error(this.language['somethingWentWrong']);
        });
    }
    verifyMail() {
        this.verifyMailLoading = true;
        this.personalInfoService.verifyMail(this.user_email).subscribe((res) => {
            this.verifyMailLoading = false;
            if (res.code === 200) {
                this.toastr.success(res.message);
            }
        }, (err) => {
            this.verifyMailLoading = false;
            this.toastr.error(err.error.message);
        });
    }
    numberOnly(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        return charCode > 31 && (charCode < 48 || charCode > 57) ? false : true;
    }
}
DashboardBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DashboardBaseComponent, deps: [{ token: i1$1.FormBuilder }, { token: PersonalInfoService }, { token: LanguageService }, { token: ChangePasswordService }, { token: i3$1.ToastrService }, { token: CheckoutService }, { token: ConfService }, { token: LoginService }, { token: i2.Router }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Component });
DashboardBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: DashboardBaseComponent, selector: "app-base-dashboard", ngImport: i0, template: "<div class=\"dashboard-content\">\r\n  <div class=\"title\">\r\n    <h3 id=\"h3--custom\">\r\n      {{language['setting']}}<br>\r\n      <small>{{language['manage_your_personal_information_and_preferences']}}</small>\r\n    </h3>\r\n  </div>\r\n  <!--End Title-->\r\n  <div class=\"box-item\" *ngIf=\"!isVerified\">\r\n    <div class=\"box-item-head\">\r\n      {{language['verify_your_email']}}\r\n    </div>\r\n    <div class=\"box-item-content verfy-mail\">\r\n      <b>{{ user_email }}</b>\r\n      <button (click)=\"verifyMail()\" [disabled]=\"verifyMailLoading\"\r\n        class=\"custom-btn\">{{language['verify_your_email']}}</button>\r\n    </div>\r\n    <!--End box-item=content-->\r\n  </div>\r\n  <!--End box-item-->\r\n\r\n  <div class=\"box-item\">\r\n    <div class=\"box-item-head\">\r\n      {{language['personal_info']}}\r\n    </div>\r\n    <div class=\"box-item-content\">\r\n      <form [formGroup]=\"personalForm\" class=\"inline-form\">\r\n        <div class=\"form-group grid\">\r\n          <label for=\"firstName\">{{language['image']}}: </label>\r\n          <input type=\"file\" hidden #profile_input (change)=\"fileChangeEvent($event)\">\r\n          <div class=\"profile_pic\" (click)=\"profile_input.click()\">\r\n            <ng-container *ngIf=\"isImageSaved; else elseTemplate\">\r\n              <img [lazyLoad]=\"cardImageBase64\" [alt]=\"person.user.username\" [errorImage]=\"defaultImage\" />\r\n              <i class=\"fa fa-plus\"></i>\r\n            </ng-container>\r\n            <ng-template #elseTemplate>\r\n              <i class=\"fa fa-user\"></i>\r\n              <i class=\"fa fa-plus\"></i>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label for=\"firstName\">{{language['firstName']}}: </label>\r\n          <input class=\"form-control\" formControlName=\"firstName\" id=\"firstName\" type=\"text\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <!-- div to show error -->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"personalForm.controls['firstName'].touched && personalForm.controls['firstName'].errors?.required\">\r\n            {{language['Please_enter_your_first_name']}}\r\n          </div>\r\n          <div\r\n            *ngIf=\"personalForm.controls['firstName'].touched && personalForm.controls['firstName'].errors?.minlength\">\r\n            {{language['Please_make_your_name_not_less_than_3_letters']}}\r\n          </div>\r\n          <div *ngIf=\"personalForm.controls['firstName'].touched && personalForm.controls['firstName'].errors?.pattern\">\r\n            {{language['Please_make_your_name_doesnt_contain_numbers_or_symbols']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <div class=\"form-group\">\r\n          <label for=\"lastName\">{{language['lastName']}} :</label>\r\n          <input class=\"form-control\" formControlName=\"lastName\" id=\"lastName\" type=\"text\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <!-- div to show error -->\r\n        <div class=\"validation-text\">\r\n          <div *ngIf=\" personalForm.controls['lastName'].touched && personalForm.controls['lastName'].errors?.required\">\r\n            {{language['please_enter_your_last_name']}}\r\n          </div>\r\n          <div *ngIf=\"personalForm.controls['lastName'].touched && personalForm.controls['lastName'].errors?.minlength\">\r\n            {{language['Please_make_your_name_not_less_than_3_letters']}}\r\n          </div>\r\n          <div *ngIf=\"personalForm.controls['lastName'].touched && personalForm.controls['lastName'].errors?.pattern\">\r\n            {{language['Please_make_your_name_doesnt_contain_numbers_or_symbols']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <div class=\"form-group\">\r\n          <label for=\"email\">{{language['email']}} :</label>\r\n          <input class=\"form-control\" formControlName=\"email\" id=\"email\" type=\"email\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <!-- div to show error -->\r\n        <div class=\"validation-text\">\r\n          <div *ngIf=\"personalForm.controls['email'].touched && personalForm.controls['email'].errors?.required\">Please\r\n            {{language['enter_your_email']}}\r\n          </div>\r\n          <div *ngIf=\"personalForm.controls['email'].touched && personalForm.controls['email'].errors?.email\">Please\r\n            {{language['enter_your_email']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <div class=\"form-group\">\r\n          <label for=\"birthday\">{{language['birthday']}} :</label>\r\n          <input class=\"form-control\" formControlName=\"birthday\" id=\"birthday\" type=\"date\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"form-group\">\r\n          <label for=\"gender\">{{language['gender']}} :</label>\r\n          <div class=\"form-control\">\r\n            <select class=\"form-select\" formControlName=\"gender\" id=\"gender\">\r\n              <option disabled selected=\"selected\" value=\"null\">{{language['select_your_gender']}}</option>\r\n              <option value=\"u\">{{language['preferNotToSay']}}</option>\r\n              <option value=\"m\">{{language['male']}}</option>\r\n              <option value=\"f\">{{language['female']}}</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"form-group\">\r\n          <label for=\"phoneNumber\">{{language['phone_number']}} :</label>\r\n          <div class=\"phoneNumber\">\r\n            <div class=\"phone-country-selector\">\r\n              <ng-select  [selectOnTab]=\"true\" [items]=\"countries\" formControlName=\"phoneKey\" bindValue=\"phoneKey\"\r\n                bindLabel=\"code\" placeholder=\"Code\" class=\"w-100 my-custom-ng-select\" [clearable]=\"false\">\r\n                <ng-template ng-label-tmp let-item=\"item\">\r\n                  <ng-container *ngIf=\"item.phoneKey\">\r\n                    <img class='flag'[lazyLoad]=\"\r\n                  'https://flagcdn.com/h20/'+ item.code.toLowerCase() +'.png'\r\n                    \" />\r\n                    {{ item.phoneKey }}\r\n                  </ng-container>\r\n                </ng-template>\r\n\r\n                <ng-template ng-option-tmp let-item=\"item\">\r\n                  <img class='flag'[lazyLoad]=\"\r\n                'https://flagcdn.com/h20/'+ item.code.toLowerCase() +'.png'\r\n                  \" />\r\n                  {{ item.code }}\r\n                </ng-template>\r\n              </ng-select>\r\n            </div>\r\n            <input (keyup)=\"changePhoneNumber()\" (keypress)=\"numberOnly($event)\" class=\"form-control\"\r\n              formControlName=\"phoneNumber\" id=\"phoneNumber\" type=\"text\">\r\n          </div>\r\n        </div>\r\n        <!--End Form-group-->\r\n        <!-- div to show error -->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"personalForm.controls['phoneNumber'].touched && personalForm.controls['phoneNumber'].errors?.required\">\r\n            {{language['please_enter_your_phone_number']}}\r\n          </div>\r\n          <!-- <div\r\n            *ngIf=\"personalForm.controls['phoneNumber'].touched && personalForm.controls['phoneNumber'].errors?.pattern\">\r\n            {{language['Not_validEGPhoneNumber']}}\r\n          </div> -->\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <div class=\"form-group custom-checkbox\">\r\n          <label>\r\n            {{language['Subscribe_to_newsletter']}}\r\n            <input [value]=\"false\" class=\"custom-checkbox-slider\" formControlName=\"subscribedToNewsletter\"\r\n              type=\"checkbox\">\r\n            <span>\r\n              <i class=\"fa fa-check\"></i>\r\n            </span>\r\n          </label>\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"form-group justify-content-end\">\r\n          <button (click)=\"onSubmit()\" [disabled]=\"personalForm.invalid || changeAddressLoading\" class=\"custom-btn\"\r\n            type=\"submit\">{{language['save_changes']}}</button>\r\n        </div>\r\n        <!--End Form-group-->\r\n      </form>\r\n      <p *ngIf=\"dataSentSuccessfully\">\r\n        {{ requestResponse }}\r\n      </p>\r\n    </div>\r\n    <!--End box-item=content-->\r\n  </div>\r\n  <!--End Box-item-->\r\n\r\n  <div class=\"box-item\">\r\n    <div class=\"box-item-head\">\r\n      {{language['change_password']}}\r\n    </div>\r\n    <div class=\"box-item-content\">\r\n      <form class=\"inline-form\" [formGroup]=\"chnagePasswordForm\">\r\n        <div class=\"form-group has-icon\">\r\n          <label for=\"oldPassword\">{{language['current_password']}}:</label>\r\n          <input class=\"form-control\" formControlName=\"oldPassword\" id=\"oldPassword\" type=\"password\">\r\n          <span appChangeVisibility>\r\n            <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\r\n          </span>\r\n        </div>\r\n        <!--End Form-group-->\r\n        <!-- div to show error -->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"chnagePasswordForm.controls['oldPassword'].touched  && chnagePasswordForm.controls['oldPassword'].errors?.required\"\r\n            class=\"error\">\r\n            {{language['please_write_your_password']}}\r\n          </div>\r\n          <div\r\n            *ngIf=\"chnagePasswordForm.controls['oldPassword'].touched  && chnagePasswordForm.controls['oldPassword'].errors?.minlength\"\r\n            class=\"error\">\r\n            {{language['please_make_sure_your_password_is_not_less_than_6_characters']}}\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <!-- Div to show errors -->\r\n        <div class=\"form-group has-icon\">\r\n          <label for=\"newPassword\">{{language['new_password']}} :</label>\r\n          <input class=\"form-control\" formControlName=\"newPassword\" id=\"newPassword\" type=\"password\">\r\n          <span appChangeVisibility>\r\n            <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\r\n          </span>\r\n        </div>\r\n        <!--End Form-group-->\r\n        <!-- div to show error -->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"chnagePasswordForm.controls['newPassword'].touched  && chnagePasswordForm.controls['newPassword'].errors?.required\"\r\n            class=\"error\">\r\n            {{language['please_write_your_password']}} :\r\n          </div>\r\n          <div\r\n            *ngIf=\"chnagePasswordForm.controls['newPassword'].touched  && chnagePasswordForm.controls['newPassword'].errors?.minlength\"\r\n            class=\"error\">\r\n            {{language['please_make_sure_your_password_is_not_less_than_6_characters']}} :\r\n          </div>\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <div class=\"form-group has-icon\">\r\n          <label for=\"confirmPassword\">{{language['confirmation']}} :</label>\r\n          <input class=\"form-control\" formControlName=\"confirmPassword\" id=\"confirmPassword\" type=\"password\">\r\n          <span appChangeVisibility>\r\n            <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\r\n          </span>\r\n        </div>\r\n        <!--End form-group-->\r\n        <!-- Div to show errors -->\r\n        <div class=\"validation-text\">\r\n          <div\r\n            *ngIf=\"chnagePasswordForm.controls['confirmPassword'].touched  && chnagePasswordForm.controls['confirmPassword'].errors?.required\"\r\n            class=\"error\">\r\n            {{language['please_write_your_password']}}\r\n          </div>\r\n          <div class=\"error\"\r\n            *ngIf=\"chnagePasswordForm.controls['confirmPassword'].touched  && chnagePasswordForm.controls['confirmPassword'].errors?.minlength\">\r\n            {{language['please_make_sure_your_password_is_not_less_than_6_characters']}}\r\n          </div>\r\n\r\n          <div class=\"error\"\r\n            *ngIf=\"chnagePasswordForm.controls['confirmPassword'].dirty && (chnagePasswordForm.get('newPassword').value !== chnagePasswordForm.get('confirmPassword').value)\">\r\n            {{language['please_make_sure_that_your_new_password_like_your_confirm_password']}}\r\n          </div>\r\n\r\n        </div>\r\n        <!--End validation-text-->\r\n\r\n        <div class=\"form-group justify-content-end\">\r\n          <button (click)=\"changePasswordForm()\"\r\n            [disabled]=\"chnagePasswordForm.invalid || (chnagePasswordForm.get('newPassword').value !== chnagePasswordForm.get('confirmPassword').value) || changePasswordLoading\"\r\n            class=\"custom-btn\" role=\"button\" type=\"submit\">{{language['save_changes']}}</button>\r\n        </div>\r\n        <!--End Form-group-->\r\n      </form>\r\n    </div>\r\n    <!--End box-item=content-->\r\n  </div>\r\n  <!--End box-item-->\r\n</div>", styles: [":host .dashboard-content ::ng-deep .grid{display:grid;text-align:center}:host .dashboard-content ::ng-deep .grid .profile_pic{position:relative;display:inline-block;vertical-align:middle;width:100px;overflow:hidden;height:100px;margin:auto;text-align:center;background-color:#fff;border:1px solid var(--main-color, orange);color:var(--main-color, orange);border-radius:5px}:host .dashboard-content ::ng-deep .grid .profile_pic img{width:100%;height:100%}:host .dashboard-content ::ng-deep .grid .profile_pic:hover{background-color:#3a3a3ab3;cursor:pointer}:host .dashboard-content ::ng-deep .grid .profile_pic:hover i.fa-plus{display:block}:host .dashboard-content ::ng-deep .grid .profile_pic i.fa-user{font-size:70px;position:relative;top:12px}:host .dashboard-content ::ng-deep .grid .profile_pic i.fa-plus{display:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#fff;font-size:22px}:host .dashboard-content ::ng-deep .phoneNumber{width:70%;display:flex}:host .dashboard-content ::ng-deep .phoneNumber .form-control{width:100%!important;margin-left:2%}:host .dashboard-content ::ng-deep .phone-country-selector{height:50px}:host .dashboard-content ::ng-deep .phone-country-selector .ng-select{height:100%}:host .dashboard-content ::ng-deep .phone-country-selector .ng-select .ng-select-container{border-radius:20px;height:100%}:host .dashboard-content ::ng-deep .verfy-mail{overflow:hidden;display:flex;flex-direction:row;justify-content:space-between}@media (max-width: 991px){:host .dashboard-content ::ng-deep .verfy-mail{flex-direction:column}}[dir=rtl] :host .dashboard-content ::ng-deep .verfy-mail{display:flex;flex-direction:row-reverse;justify-content:space-between}@media (max-width: 991px){[dir=rtl] :host .dashboard-content ::ng-deep .verfy-mail{flex-direction:column}}:host .dashboard-content ::ng-deep .verfy-mail .custom-btn{float:right}[dir=rtl] :host .dashboard-content ::ng-deep .verfy-mail .custom-btn{float:left}:host .dashboard-content ::ng-deep input[type=date]::-webkit-inner-spin-button,:host .dashboard-content ::ng-deep input[type=date]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}:host .dashboard-content ::ng-deep [type=date]{-moz-appearance:textfield}:host .form-select{width:100%;height:100%;border:none}\n"], components: [{ type: i5$1.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5$1.ɵh, selector: "[ng-label-tmp]" }, { type: i5$1.ɵf, selector: "[ng-option-tmp]" }, { type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: ChangeVisibilityDirective, selector: "[appChangeVisibility]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DashboardBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-dashboard',
                    templateUrl: './dashboard.base-component.html',
                    styleUrls: ['./dashboard.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$1.FormBuilder }, { type: PersonalInfoService }, { type: LanguageService }, { type: ChangePasswordService }, { type: i3$1.ToastrService }, { type: CheckoutService }, { type: ConfService }, { type: LoginService }, { type: i2.Router }, { type: AuthService }]; } });

class EditAddressBaseComponent {
    constructor(activatedRoute, formBuilder, addressingService, languageService, toastr, checkoutService) {
        this.activatedRoute = activatedRoute;
        this.formBuilder = formBuilder;
        this.addressingService = addressingService;
        this.languageService = languageService;
        this.toastr = toastr;
        this.checkoutService = checkoutService;
        this.countries = [];
        this.cities = [];
        this.areas = [];
        this.language = {};
        this.validationErrors = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        // build the form
        this.editAddressForm = this.formBuilder.group({
            firstName: ['', [
                    Validators.required,
                    Validators.minLength(2),
                ]],
            lastName: ['', [
                    Validators.required,
                    Validators.minLength(2),
                ]],
            phoneKey: [null],
            phoneNumber: [''],
            street: ['', [
                    Validators.required,
                ]],
            countryCode: ['', [
                    Validators.required,
                ]],
            cityName: ['', [
                    Validators.required,
                ]],
            areaCode: ['', [
                    Validators.required,
                ]],
        });
        this.checkoutService.getCountriesCitiesProvinces().pipe(map$1(data => data['response'])).subscribe((data) => {
            this.countries = data;
        });
        // when there are a change of value display the errors
        this.editAddressForm.valueChanges.subscribe(() => {
            const keys = Object.keys(this.editAddressForm.controls);
            this.errors = [];
            for (const key of keys) {
                const control = this.editAddressForm.controls[key];
                if (control.invalid && control.dirty) {
                    if (!!control.errors.minlength) {
                        this.errors.push(`${key
                            .replace(/([A-Z])/g, ' $1')
                            .toLowerCase()} minimum length is ${control.errors.minlength.requiredLength}
              `);
                    }
                    else if (!!control.errors.required) {
                        this.errors.push(`${key.replace(/([A-Z])/g, ' $1').toLowerCase()} is required`);
                    }
                    else {
                        this.errors.push(`invalid ${key.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
                    }
                }
            }
        });
        // load address data & countries options
        this.activatedRoute.params.subscribe(params => {
            this.addressId = +params['id'];
            this.addressingService.getCountries().subscribe((countries) => {
                this.countries = countries;
                if (countries.length === 0) {
                    return;
                }
                this.addressingService.getAddresses().subscribe(addresses => {
                    if (addresses.length === 0) {
                        return;
                    }
                    setTimeout(() => {
                        this.address = addresses.find(address => {
                            return address.ID === this.addressId;
                        });
                        if (!this.address) {
                            return;
                        }
                        this.editAddressForm.controls['countryCode'].setValue(this.address.CountryCode);
                        this.updateAddressingCities(this.address.CountryCode);
                        if (this.address.CityInfo && this.address.CityInfo.code) {
                            this.selectCity(this.address.CityInfo.code);
                        }
                        this.editAddressForm.controls['firstName'].setValue(this.address.FirstName);
                        this.editAddressForm.controls['lastName'].setValue(this.address.LastName);
                        this.editAddressForm.controls['street'].setValue(this.address.Street);
                        this.editAddressForm.controls['phoneKey'].setValue(this.address['PhoneKey']);
                        const phoneKeyExp = new RegExp(this.address['PhoneKey'] + '(.+)');
                        let phoneNumber = this.address['PhoneNumber'].split(phoneKeyExp)[1];
                        phoneNumber = phoneNumber.indexOf('-') > -1 ? phoneNumber.split('-')[1] : phoneNumber;
                        this.editAddressForm.controls['phoneNumber'].setValue(phoneNumber);
                        setTimeout(() => {
                            this.editAddressForm.controls['cityName'].setValue(this.address.CityName);
                            this.editAddressForm.controls['areaCode'].setValue(this.address.AreaInfo.code);
                        }, 0);
                    });
                });
            });
        });
    }
    updateAddressingCities(city) {
        this.addressingService.getCitiesFromApi(city).pipe(map$1(data => data['response'])).subscribe((data) => {
            this.cities = data;
        });
    }
    selectCity(cityid) {
        this.addressingService.getAreasFromApi(cityid).pipe(map$1(data => data['response'])).subscribe(data => {
            this.areas = data;
        });
    }
    // selectCity(cityCode: string) {
    //   if (cityCode === '') {
    //     return this.areas.length = 0;
    //   }
    //   this.getCityAreas(cityCode);
    // }
    // getCityAreas(cityCode: string) {
    //   const selectedCity = this.cities.find(city => city.code === cityCode);
    //   this.areas = selectedCity['areas'];
    // }
    editAddress() {
        const edittedAddress = {
            areaCode: this.editAddressForm.value['areaCode'],
            cityName: this.editAddressForm.value['cityName'],
            countryCode: this.editAddressForm.value['countryCode'],
            firstName: this.editAddressForm.value['firstName'],
            lastName: this.editAddressForm.value['lastName'],
            phoneNumber: this.editAddressForm.value['phoneKey'] + '-' + this.editAddressForm.value['phoneNumber'],
            street: this.editAddressForm.value['street'],
        };
        this.addressingService.editAddress(this.addressId, edittedAddress).subscribe((res) => {
            this.toastr.success(res.response, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
        }, (err) => {
            if (err.error) {
                this.validationErrors = err.error.errors;
            }
            let toastrMsg = this.language['sorrySomethingWentWrong'];
            if (err.error.message) {
                toastrMsg = err.error.message;
            }
            this.toastr.error(`${toastrMsg}`, `${this.language['error']}!`, { enableHtml: true, closeButton: true });
        });
    }
    numberOnly(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        return charCode > 31 && (charCode < 48 || charCode > 57) ? false : true;
    }
}
EditAddressBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: EditAddressBaseComponent, deps: [{ token: i2.ActivatedRoute }, { token: i1$1.FormBuilder }, { token: AddressingService }, { token: LanguageService }, { token: i3$1.ToastrService }, { token: CheckoutService }], target: i0.ɵɵFactoryTarget.Component });
EditAddressBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: EditAddressBaseComponent, selector: "app-base-edit-address", ngImport: i0, template: "<div class=\"dashboard-content\">\r\n  <div class=\"box-item\">\r\n    <div class=\"box-item-head\">\r\n      {{language['editAddress']}}\r\n    </div>\r\n    <div class=\"box-item-content\">\r\n      <form class=\"inline-form\" [formGroup]=\"editAddressForm\" (ngSubmit)=\"editAddress()\">\r\n        <div class=\"form-group\">\r\n          <label>{{language['firstName']}}</label>\r\n          <input type=\"text\" name=\"firstName\" id=\"firstName\" class=\"form-control\"\r\n            placeholder=\"{{language['firstName']}}\" formControlName=\"firstName\">\r\n        </div>\r\n        <!--End Form-group-->\r\n        <div class=\"form-group\">\r\n          <label>{{language['lastName']}}</label>\r\n          <input type=\"text\" name=\"lastName\" id=\"lastName\" class=\"form-control\" placeholder=\"{{language['lastName']}}\"\r\n            formControlName=\"lastName\">\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>{{language['phone_number']}}</label>\r\n\r\n          <div class=\"phoneNumber\">\r\n            <div class=\"phone-country-selector\">\r\n              <ng-select [selectOnTab]=\"true\" [items]=\"countries\" formControlName=\"phoneKey\" bindValue=\"phoneKey\"\r\n                bindLabel=\"code\" placeholder=\"Select country\" class=\"w-100\" [clearable]=\"false\">\r\n                <ng-template ng-label-tmp let-item=\"item\">\r\n                  <ng-container *ngIf=\"item.phoneKey\">\r\n                    <img [lazyLoad]=\"'https://flagcdn.com/h20/'+ item.code.toLowerCase() +'.png'\" />\r\n                    {{item.phoneKey}}\r\n                  </ng-container>\r\n                </ng-template>\r\n                <ng-template ng-option-tmp let-item=\"item\">\r\n                  <img [lazyLoad]=\"'https://flagcdn.com/h20/'+ item.code.toLowerCase() +'.png'\" />\r\n                  {{item.code}}\r\n                </ng-template>\r\n              </ng-select>\r\n            </div>\r\n            <input (keypress)=\"numberOnly($event)\" class=\"form-control mx-1\" placeholder=\"{{language['phone_number']}}\"\r\n              formControlName=\"phoneNumber\" id=\"phoneNumberInput\" type=\"text\">\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"validation-text\">\r\n          <!-- Only Backend Validations for phone number -->\r\n          <div\r\n            *ngIf=\"editAddressForm.controls['phoneNumber'].touched && (validationErrors['phoneNumber'] || validationErrors['phoneKey'])\">\r\n            {{ validationErrors['phoneNumber'] }}\r\n            {{validationErrors['phoneKey']}}\r\n          </div>\r\n\r\n        </div>\r\n        <!--End Validation-text-->\r\n        <div class=\"form-group\">\r\n          <label>{{language['street']}}</label>\r\n          <input type=\"text\" name=\"street\" id=\"street\" class=\"form-control\" placeholder=\"{{language['street']}}\"\r\n            formControlName=\"street\">\r\n        </div>\r\n        <!--End Form-group-->\r\n\r\n        <div class=\"form-group\">\r\n          <label>{{language['country']}}</label>\r\n          <select name=\"countryCode\" id=\"countryCode\" class=\"form-control\" formControlName=\"countryCode\"\r\n            (change)=\"updateAddressingCities($event.target.value)\">\r\n            <option value=\"\">{{language['country']}}</option>\r\n            <option *ngFor=\"let country of countries\" [value]=\"country.code\">{{country.name}}</option>\r\n          </select>\r\n        </div>\r\n        <!--End Form-group-->\r\n\r\n        <div class=\"form-group\">\r\n          <label>{{language['city']}}</label>\r\n          <select name=\"cityName\" id=\"cityName\" class=\"form-control\" formControlName=\"cityName\"\r\n            (change)=\"selectCity($event.target.value)\">\r\n            <option value=\"\">{{language['city']}}</option>\r\n            <option *ngFor=\"let city of cities\" [value]=\"city.code\">{{city.name}}</option>\r\n          </select>\r\n        </div>\r\n        <!--End Form-group-->\r\n\r\n        <div class=\"form-group\">\r\n          <label>{{language['area']}}</label>\r\n          <select name=\"areaName\" id=\"areaName\" class=\"form-control\" formControlName=\"areaCode\">\r\n            <option value=\"\">{{language['area']}}</option>\r\n            <option *ngFor=\"let area of areas\" [value]=\"area.code\">{{area.name}}</option>\r\n          </select>\r\n        </div>\r\n        <!--End Form-group-->\r\n\r\n        <div class=\"form-group justify-content-end\">\r\n          <input type=\"submit\" value=\"{{language['editAddress']}}\" class=\"custom-btn\"\r\n            [disabled]=\"!editAddressForm.valid\">\r\n        </div>\r\n        <!--End Form-group-->\r\n      </form>\r\n      <div class=\"errors\">\r\n        <div *ngFor=\"let error of errors\" class=\"alert alert-danger\">{{error}}</div>\r\n      </div>\r\n    </div>\r\n    <!--End box-item=content-->\r\n  </div>\r\n  <!--End box-item-->\r\n</div>\r\n<!--End dashboard-content-->\r\n\r\n\r\n<!--\r\n<div class=\"container\">\r\n<div class=\"row\">\r\n  <div class=\"col-xs-12 col-sm-8 col-md-6 col-sm-offset-2 col-md-offset-3\">\r\n    <form [formGroup]=\"editAddressForm\" (ngSubmit)=\"editAddress()\">\r\n      <h2>edit address</h2>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 col-sm-6 col-md-6\">\r\n          <div class=\"form-group\">\r\n            <input type=\"text\" name=\"firstName\" id=\"firstName\" class=\"form-control input-lg\"\r\n                   placeholder=\"First Name\" formControlName=\"firstName\">\r\n          </div>\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-6 col-md-6\">\r\n          <div class=\"form-group\">\r\n            <input type=\"text\" name=\"lastName\" id=\"lastName\" class=\"form-control input-lg\" placeholder=\"Last Name\"\r\n                   formControlName=\"lastName\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">-->\r\n<!--<input type=\"text\" name=\"company\" id=\"company\" class=\"form-control input-lg\" placeholder=\"company\" formControlName=\"company\">-->\r\n<!--</div>-->\r\n\r\n<!-- <div class=\"form-group\">\r\n        <input type=\"text\" name=\"street\" id=\"street\" class=\"form-control input-lg\" placeholder=\"Street\"\r\n               formControlName=\"street\">\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <input type=\"text\" name=\"phoneNumber\" id=\"phoneNumber\" class=\"form-control input-lg\"\r\n               placeholder=\"phone number\"\r\n               formControlName=\"phoneNumber\">\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 col-sm-6 col-md-6\">\r\n          <div class=\"form-group\">\r\n            <select name=\"countryCode\" id=\"countryCode\" class=\"form-control input-lg\" formControlName=\"countryCode\"\r\n                    (change)=\"updateAddressingCities($event.target.value)\">\r\n              <option value=\"\">country</option>\r\n              <option *ngFor=\"let country of countries\">{{country.code}}</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-6 col-md-6\">\r\n          <div class=\"form-group\">\r\n            <select name=\"cityName\" id=\"cityName\" class=\"form-control input-lg\" formControlName=\"cityName\">\r\n              <option value=\"\">city</option>\r\n              <option *ngFor=\"let city of cities\">{{city.name}}</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <input type=\"submit\" value=\"edit address\" class=\"btn btn-primary btn-block btn-lg\"\r\n             [disabled]=\"!editAddressForm.valid\">\r\n    </form>\r\n  </div>\r\n</div>\r\n<div class=\"row errors\">\r\n  <div *ngFor=\"let error of errors\" class=\"alert alert-danger\">{{error}}</div>\r\n</div>\r\n</div> -->\r\n", styles: [".phone-country-selector ::ng-deep .ng-placeholder{font-size:12px}.phone-country-selector ::ng-deep .ng-select.ng-select-focused.ng-touched.ng-dirty.ng-invalid>.ng-select-container{border:1px solid red}.phone-country-selector .ng-touched.ng-dirty.ng-invalid:not(form){border:1px solid red}.phoneNumber{width:70%;display:flex;align-items:center;justify-content:flex-start}.phoneNumber ::ng-deep .ng-select.ng-select-single .ng-select-container{border:1px solid #acacac;height:50px;border-radius:20px;box-shadow:none}#phoneNumberInput{width:auto}\n"], components: [{ type: i5$1.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }], directives: [{ type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i5$1.ɵh, selector: "[ng-label-tmp]" }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i5$1.ɵf, selector: "[ng-option-tmp]" }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: EditAddressBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-edit-address',
                    templateUrl: './edit-address.base-component.html',
                    styleUrls: ['./edit-address.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: i1$1.FormBuilder }, { type: AddressingService }, { type: LanguageService }, { type: i3$1.ToastrService }, { type: CheckoutService }]; } });

class OrderHistoryBaseComponent {
    constructor(orderHistoryService, languageService, cartService, activatedRoute, router, toastrService) {
        this.orderHistoryService = orderHistoryService;
        this.languageService = languageService;
        this.cartService = cartService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.toastrService = toastrService;
        this.orders = [];
        this.requestData = '';
        this.language = {};
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.cancelMsg = '';
        this.status = [];
        this.allStatus = [];
    }
    ngOnInit() {
        this.imgUrl = environment.imageUrl;
        this.activatedRoute.queryParams.subscribe((params) => {
            if (!params['page']) {
                this.currentPage = 1;
            }
            else {
                this.currentPage = +params['page'];
            }
            this.loadOrders(this.currentPage);
        });
        this.languageSubscription = this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            this.defaultImage = environment.defaultImage;
        });
    }
    loadOrders(page) {
        this.ordersSubscription = this.orderHistoryService.getOrders(page).subscribe((response) => {
            this.pagesCount = response.pagesCount;
            this.orders = response.items;
            this.allStatus = [...response.shippingStates];
            this.status = this.allStatus.filter(st => st.code !== 'undelivered' && st.code !== 'cancelled');
            this.loaded = true;
            // this.orders = this.orders.filter(order => order.checkoutState === 'completed');
        });
    }
    pageChanged(e) {
        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'profile', 'order-history'], { queryParams: { page: e.page }, queryParamsHandling: 'merge' });
    }
    // reorder(order) {
    //   const orderItems: { variantCode: string, qty: number }[] = [];
    //   order.items.forEach(item => {
    //     orderItems.push({ variantCode: item.variant.code, qty: +item.quantity });
    //   });
    //   this.cartService.addToCart(orderItems, null, null);
    // }
    openModal(id, orderDetialsModal, index) {
        this.orderID = id;
        this.order = null;
        this.currentStatus = this.allStatus.find(st => st.code == this.orders[index]['shippingState']).name;
        this.orderSubscription = this.orderHistoryService.getOrder(id).subscribe((order) => {
            this.order = order;
            if (this.orders[index] && this.orders[index]['cancellation'] && this.orders[index]['cancellation'].state) {
                this.cancelMsg = this.orders[index]['cancellation'].state;
            }
        });
        orderDetialsModal.show();
    }
    ngOnDestroy() {
        if (this.languageSubscription) {
            this.languageSubscription.unsubscribe();
        }
        if (this.ordersSubscription) {
            this.ordersSubscription.unsubscribe();
        }
        if (this.orderSubscription) {
            this.orderSubscription.unsubscribe();
        }
    }
    currentStatusIndex(statusCode) {
        this.stIndex = statusCode == 'undelivered' ? this.status.length - 1 :
            statusCode == 'cancelled' ? -1 :
                this.status.indexOf(this.status.find(st => st.code == statusCode));
        return this.stIndex;
    }
    notCompleted(statusCode) {
        if (statusCode == 'undelivered' || statusCode == 'cancelled') {
            return true;
        }
        else {
            return false;
        }
    }
    getNameByCode(code) {
        return this.allStatus.find(st => st.code === code).name;
    }
    CancelRequests() {
        let body = {
            "note": this.requestData
        };
        if (this.order.cancellation && this.order.cancellation.state) {
            let word = this.order.cancellation.state;
        }
        this.orderHistoryService.onCancelRequests(body, this.orderID)
            .subscribe(response => {
            this.loadOrders(this.currentPage);
            this.toastrService.success(response.message, response.status);
            this.cancellationModal.hide();
        }, error => {
            this.toastrService.error(error.message, error.status);
        });
    }
}
OrderHistoryBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderHistoryBaseComponent, deps: [{ token: OrderHistoryService }, { token: LanguageService }, { token: CartService }, { token: i2.ActivatedRoute }, { token: i2.Router }, { token: i3$1.ToastrService }], target: i0.ɵɵFactoryTarget.Component });
OrderHistoryBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: OrderHistoryBaseComponent, selector: "app-base-order-history", viewQueries: [{ propertyName: "cancellationModal", first: true, predicate: ["cancellationModal"], descendants: true }], ngImport: i0, template: "<div class=\"dashboard-content\">\r\n  <div class=\"title\">\r\n    <h3 id=\"h3--custom\">\r\n      {{language['orders']}}\r\n    </h3>\r\n  </div>\r\n  <!--End Title-->\r\n\r\n  <!--start order tracking-->\r\n  <div *ngFor=\"let or of orders; let k=index;\" class=\"order--tracking\">\r\n\r\n    <!--start order detials-->\r\n    <div class=\"order--details\">\r\n      <div class=\"\">\r\n        <p class=\"order--id text-capitalize\">{{language['order_number']}} :{{or.number}}</p>\r\n        <p class=\"order--history text-capitalize\">\r\n          <strong>{{language['order-placed-on']}}:</strong>\r\n          {{or.checkoutCompletedAt}}\r\n        </p>\r\n        <!-- <p class=\"order--numbers text-capitalize\">\r\n          <strong>{{order.items?.length}}</strong> items\r\n        </p> -->\r\n      </div>\r\n      <div>\r\n        <p class=\"order--total text-capitalize\">\r\n          {{language['total']}}\r\n          <span>{{ (or.total) / 100 | currency: currencyCode}}</span>\r\n        </p>\r\n        <!-- <p class=\"payment--method text-capitalize\"><strong> payment : </strong>\r\n          {{order.payments[0].method  | translate: 'name'}}\r\n        </p> -->\r\n        <div class=\"cancellation--order--buttons\" *ngIf=\"or&&or.cancellation&&or.cancellation.enabled\">\r\n          <div>\r\n            <!-- [disabled]=\"!or.cancellation.enabled\" -->\r\n            <button  [disabled]=\"!(or.cancellation.enabled && (or.cancellation.state == 'Request Cancellation' || or.cancellation.state =='\u0637\u0644\u0628 \u0625\u0644\u063A\u0627\u0621' || or.cancellation.state =='Request Return' || or.cancellation.state =='\u0637\u0644\u0628 \u0627\u0633\u062A\u0631\u062C\u0627\u0639' ))\" class=\"font-weight-bold border-0\" (click)=\"openModal(or.id, cancellationModal,k)\">\r\n              {{or.cancellation.state || 'Request Cnacellation ' }}\r\n            </button>\r\n            <!-- <span *ngIf=\"or.cancellation && or.cancellation.state && !or.cancellation.enabled\">\r\n              {{or.cancellation.state }}\r\n            </span> -->\r\n          </div>\r\n          <!-- <ng-template #return>\r\n            <a class=\"font-weight-bold\">\r\n              Return\r\n            </a>\r\n          </ng-template> -->\r\n\r\n          <!--end buttons section-->\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!--end order details-->\r\n\r\n    <!--start order state-->\r\n    <div class=\"d-flex\">\r\n      <div class=\"order\" *ngFor=\"let st of status ; let i=index; let last=last;\"\r\n        [class.order-in-progress]=\"i==currentStatusIndex(or.shippingState) &&!notCompleted(or.shippingState)\"\r\n        [class.order-complete]=\"(i<currentStatusIndex(or.shippingState))|| or.shippingState==='delivered'\"\r\n        [class.order-canceled]=\"notCompleted(or.shippingState)&& last\">\r\n        <div class=\"order--state start--state\">\r\n          <span class=\"font-weight-bold\">{{i+1}}</span>\r\n        </div>\r\n        <div class=\"order--state end--state\">\r\n          <span>\r\n            <i class=\"fa fa-check\"></i>\r\n          </span>\r\n        </div>\r\n        <div class=\"pt-3 text-capitalize state--word\">\r\n          {{notCompleted(or.shippingState) &&last? getNameByCode(or.shippingState):st.name}}\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n    <!--end order state-->\r\n\r\n    <!--start buttons section-->\r\n    <div class=\"order--buttons\">\r\n      <div class=\"\">\r\n        <button (click)=\"openModal(or.id, orderDetailsModal,k)\">\r\n          {{language['viewDetails']}}\r\n        </button>\r\n        <!-- <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'download-invoice', order.id]\"\r\n          class=\"ml-md-4 mr-2 mr-md-3 mb-3 mb-md-0\" target=\"_blank\">Print Invoice</a> -->\r\n      </div>\r\n      <!-- <div>\r\n        <button class=\"mr-4\">Track order</button>\r\n      </div> -->\r\n      <!--end buttons section-->\r\n    </div>\r\n    <!--end buttons section-->\r\n\r\n  </div>\r\n  <!--end order tracking-->\r\n  <div *ngIf=\"orders.length === 0 && loaded\">\r\n    {{language['thereAreNoOrdersYet']}}\r\n  </div>\r\n  <div class=\"loading-animation\" *ngIf=\"!loaded\">\r\n    <div class=\"lds-ripple\">\r\n      <div></div>\r\n      <div></div>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"error\">{{error}}</div>\r\n\r\n  <div class=\"pagination-container site-navigation \" *ngIf=\"pagesCount > 1\">\r\n    <pagination (pageChanged)=\"pageChanged($event)\" [(ngModel)]=\"currentPage\" [itemsPerPage]=\"1\" [maxSize]=\"4\"\r\n      [totalItems]=\"pagesCount\"></pagination>\r\n  </div>\r\n</div>\r\n<!--End Dashboard-content-->\r\n\r\n<div class=\"modal fade default-modal\" bsModal #orderDetailsModal=\"bs-modal\" tabindex=\"-1\" role=\"dialog\"\r\n  aria-labelledby=\"dialog-static-name\">\r\n  <div class=\"modal-dialog modal-lg modal-dialog-centered\" *ngIf=\"order\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h4 id=\"dialog-static-name\" class=\"modal-title\">\r\n          <span>{{language['order_number']}} :</span>\r\n          <span> {{order.number}}</span>\r\n        </h4>\r\n        <span class=\"status\">\r\n          {{language['status']}} : {{currentStatus}}\r\n        </span>\r\n        <!-- <button class=\"custom-btn d-block\" (click)='reorder(order)'>\r\n          {{language['reOrder']}}\r\n        </button> -->\r\n        <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"orderDetailsModal.hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n      </div>\r\n      <!--End Modal-header-->\r\n      <div class=\"modal-body\">\r\n        <div class=\"row m-0\">\r\n          <div class=\"col-md-6 order__col\">\r\n            <div class=\"order-items\">\r\n              <div class=\"order-item\" *ngFor=\"let item of order.items; let i = index;\">\r\n                <span class=\"order-item-number\">\r\n                  {{i + 1}}\r\n                </span>\r\n                <div class=\"order-item-img\">\r\n                  <img class=\"img-fluid\" #thisImage\r\n                    [lazyLoad]=\"imgUrl + item.variant.product.thumbnailImage.path\"\r\n                    [alt]=\"item.variant.product | translate : 'name'\" (error)=\"thisImage.src = defaultImage\">\r\n                </div>\r\n                <!--End Order-item-img-->\r\n                <div class=\"order-item-info\">\r\n                  <!-- <span class=\"item-id\">\r\n                    <span>ID </span>\r\n                    <span>{{item.id}}</span>\r\n                  </span> -->\r\n                  <h4 class=\"order-item-name\">\r\n                    <span>{{item.variant.product | translate : 'name'}} </span> <br>\r\n                    <!-- ({{ item.variant | translate : 'name' }}) -->\r\n                  </h4>\r\n                  <span class=\"item-quantity\">\r\n                    <strong>{{language['quantity']}}: </strong>\r\n                    <span>{{item.quantity}}</span>\r\n                  </span>\r\n                  <span class=\"item-price\">\r\n                    <strong>{{language['price']}}: </strong>\r\n                    <span>{{ (item.unitPrice) / 100 | currency: currencyCode}}</span>\r\n                  </span>\r\n                </div>\r\n                <!--End Order-item-info-->\r\n                <div class=\"order-item-total\">\r\n                  <span>{{language['total']}}: </span>\r\n                  <span>{{ (item.total) / 100 | currency: currencyCode}}</span>\r\n                </div>\r\n              </div>\r\n              <!--End Order-item-->\r\n\r\n            </div>\r\n            <!--End order-items-->\r\n          </div>\r\n          <!--End Col--->\r\n          <div class=\"col-md-6\">\r\n            <ul class=\"order-info\">\r\n              <li>\r\n                <span>{{ language['shippingAddress']}}</span>\r\n                <span>{{ order.shippingAddress?.areaInfo?.name }} , {{order.shippingAddress?.cityInfo?.name}}</span>\r\n              </li>\r\n              <li>\r\n                <span>{{ language['shipping'] }}</span>\r\n                <span>\r\n                  {{ order.shipments[0].method.name}}\r\n                </span>\r\n              </li>\r\n              <li>\r\n                <span>{{language['payment_type']}}</span>\r\n                <span>{{ order.payments[0].method.name}}</span>\r\n              </li>\r\n              <li *ngIf=\"order.promotionCode\">\r\n                <span>promotion code</span>\r\n                <span>summer-free-50</span>\r\n              </li>\r\n              <li class=\"p-0\">\r\n                <ul class=\"order-total-info\">\r\n                  <li>\r\n                    <span>{{language['subtotal']}}</span>\r\n                    <span>{{ (order.itemsTotal) / 100 | currency: currencyCode }}</span>\r\n                  </li>\r\n                  <li>\r\n                    <span>{{language['shipping']}}</span>\r\n                    <span>{{ (order.adjustmentsTotal) / 100 | currency: currencyCode }}</span>\r\n                  </li>\r\n                  <li>\r\n                    <span>{{language['summaryPromotions'] }}</span>\r\n                    <span>{{ (order.promotionTotal) / 100 | currency: currencyCode }}</span>\r\n                  </li>\r\n                </ul>\r\n              </li>\r\n              <li class=\"total-order\">\r\n                <span>{{language['totalPrice']}}</span>\r\n                <span>{{ (order.total) / 100 | currency: currencyCode}}</span>\r\n              </li>\r\n            </ul>\r\n            <!--End Irder-info-->\r\n          </div>\r\n          <!--End Col-->\r\n        </div>\r\n        <!--End Row-->\r\n      </div>\r\n      <!--End Modal-body-->\r\n    </div>\r\n    <!--End modal-content-->\r\n  </div>\r\n  <!--End Modal-dialog-->\r\n</div>\r\n<!--End Modal-->\r\n<!--Start Cnacellation Modal-->\r\n<div class=\"modal fade default-modal cancellation-modal\" bsModal #cancellationModal=\"bs-modal\" tabindex=\"-1\" role=\"dialog\"\r\n  aria-labelledby=\"dialog-static-name\">\r\n  <div class=\"modal-dialog modal-dialog-centered\" *ngIf=\"order\">\r\n    <div class=\"modal-content p-5\">\r\n      <div class=\"modal-header\">\r\n        <!-- <h4 id=\"dialog-static-name\" class=\"modal-title\">\r\n          <span>{{language['order_number']}} :</span>\r\n          <span> {{order.number}}</span>\r\n        </h4> -->\r\n        <!-- <span class=\"status\">\r\n          {{language['status']}} : {{currentStatus}}\r\n        </span> -->\r\n        <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"cancellationModal.hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n      </div>\r\n      <!--End Modal-header-->\r\n      <div class=\"modal-body\">\r\n        <div>\r\n        <p  *ngIf=\"cancelMsg == 'Request Cancellation' || cancelMsg == '\u0637\u0644\u0628 \u0625\u0644\u063A\u0627\u0621'\" class=\"text-center\">\r\n        {{language['cancelOrderRequestMsg'] || 'Are you Sure you want to Cancel this Order including ALL Items?'}}\r\n      </p>\r\n      <p  *ngIf=\"cancelMsg == 'Request Return' || cancelMsg == '\u0637\u0644\u0628 \u0627\u0633\u062A\u0631\u062C\u0627\u0639'\" class=\"text-center\">\r\n        {{language['returnOrderRequestMsg'] || 'Are you Sure you want to Return this Order including ALL Items?'}}\r\n      </p>\r\n    </div>\r\n    <div>\r\n      <form>\r\n        <div class=\"form-group\">\r\n          <label for=\"exampleFormControlTextarea1\">Reason(Optional)</label>\r\n          <textarea class=\"form-control\" id=\"exampleFormControlTextarea1\" name=\"requestData\" [(ngModel)]=\"requestData\" rows=\"3\" placeholder=\"your feedback\"></textarea>   \r\n        </div>\r\n        <!-- <button type=\"submit\" class=\"btn btn-primary\">Submit</button> -->\r\n      </form>\r\n    </div>\r\n        <!--End Row-->\r\n      </div>\r\n      <!--End Modal-body-->\r\n      <div class=\"modal-footer\">\r\n        <ng-container>\r\n          <button type=\"button\" class=\"btn btn-secondary btn-lg m-auto\" (click)=\"CancelRequests()\">Confirm</button>\r\n          <!-- <button  type=\"button\" class=\"btn btn-default m-auto\">confirm</button> -->\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <!--End modal-content-->\r\n  </div>\r\n  <!--End Modal-dialog-->\r\n</div>\r\n<!--End Cnacellation Modal-->\r\n", styles: ["::ng-deep .default-modal .modal-dialog{max-width:500px;margin:17.5px auto}::ng-deep .default-modal .modal-dialog.modal-lg{max-width:900px}::ng-deep .default-modal .modal-content{height:inherit;border-radius:10px}::ng-deep .default-modal .modal-header{display:flex;align-items:center;padding:8px 30px}::ng-deep .default-modal .modal-header span.status{color:#09f;font-size:20px;text-transform:capitalize;margin-right:15px}[dir=rtl] ::ng-deep .default-modal .modal-header span.status{margin-right:0;margin-left:15px}@media (max-width: 768px){::ng-deep .default-modal .modal-header span.status{font-size:16px}}::ng-deep .default-modal .modal-header .modal-title{text-transform:capitalize;font-size:20px;font-weight:bold}@media (max-width: 768px){::ng-deep .default-modal .modal-header .modal-title{font-size:16px}}::ng-deep .default-modal .modal-header .close{cursor:pointer;padding:0;width:40px;height:40px;font-size:25px;background-color:#000;font-weight:bold;position:absolute;border-radius:50%;top:-2px;right:0;opacity:1;text-shadow:none;transition:all .3s ease-in-out;color:#fff;display:flex;align-items:center;justify-content:center}::ng-deep .default-modal .modal-header .close span{margin-bottom:5px}[dir=rtl] ::ng-deep .default-modal .modal-header .close{right:auto;left:0;margin-left:-1rem!important}@media (max-width: 768px){::ng-deep .default-modal .modal-header .close{height:30px;width:30px;line-height:20px;right:12px;top:12px}}::ng-deep .default-modal .modal-header .close:not(:disabled):not(.disabled):hover,::ng-deep .default-modal .modal-header .close:not(:disabled):not(.disabled):focus{opacity:1}::ng-deep .default-modal .modal-body{max-height:600px;padding:0}@media all and (max-width: 991.98px){::ng-deep .default-modal .modal-dialog.modal-lg{width:95%}::ng-deep .default-modal .modal-dialog .modal-body{max-height:60%}}@media all and (max-width: 567.98px){::ng-deep .default-modal .modal-header{display:block;text-align:center}::ng-deep .default-modal .modal-header .custom-btn{margin:5px auto}}:host .order-items{max-height:450px;padding:0 10px;overflow-y:auto}@media all and (max-width: 768px){:host .order-items{max-height:300px}}:host .custom-btn{padding:0;height:40px;width:120px;margin-top:0}@media (max-width: 580px){:host .custom-btn{margin:10px auto 0;width:100px}}@media (min-width: 580px) and (max-width: 768px){:host .custom-btn{margin-right:10px}}:host .default-modal .modal-content{height:auto!important}:host .order-item{display:flex;flex-wrap:wrap;align-items:center;padding:5px;border-bottom:1px solid #cccfd6}:host .order-item:last-child{border-bottom:0}:host .order-item .order-item-number{font-weight:bold}:host .order-item .order-item-img{width:70px;border:3px solid #000;padding:5px;border-radius:5px;margin:0 10px}:host .order-item .order-item-img img{width:100%}:host .order-item .item-id{font-weight:600}:host .order-item .order-item-info{margin-right:10px;text-transform:capitalize}:host .order-item .order-item-info .order-item-name{font-size:16px;margin-bottom:0}:host .order-item .order-item-info .item-price{display:block}:host .order-item .order-item-total{font-weight:bold;margin-left:auto;text-transform:capitalize}[dir=rtl] :host .order-item .order-item-total{margin-left:0;margin-right:auto}:host .order-item .order-item-total span:last-child{font-weight:bold;margin:0 5px}@media (max-width: 768px){:host .order-item .order-item-total{margin:inherit;text-align:center;width:100%;padding-top:10px}}:host .order__col{border-right:1px solid #b3b7ba;padding:0}[dir=rtl] :host .order__col{border-right:none;border-left:1px solid #b3b7ba}@media (max-width: 768px){:host .order__col{border-bottom:1px solid #b3b7ba}}:host .order-info{padding:0 10px;margin-bottom:0;border-radius:0 0 10px}:host .order-info li{display:flex;justify-content:space-between;padding-top:14px;font-size:18px;text-transform:capitalize}:host .order-info li span:first-child{font-weight:bold}:host .order-info li span:last-child{font-size:16px}@media (max-width: 768px){:host .order-info li{padding:10px 0;font-size:16px}}:host .order-info .order-total-info{width:100%;border-bottom:1px solid #b3b7ba;padding:0}:host .order-info .order-total-info li:last-child{padding-bottom:14px}:host .order-info .total-order{padding-bottom:14px}:host .order-info .total-order span{font-weight:bold}:host .order-info .total-order span:nth-of-type(2){color:#2aa524;font-size:18px}@media (max-width: 768px){:host .order-info .total-order{padding-bottom:10px}}:host .order-info .border-bottom-i{border-bottom:1px solid #b3b7ba}@media (max-width: 768px){:host .order-info{border-radius:0 0 10px 10px}}:host .dashboard-content{padding-bottom:30px}:host .order--details{border-bottom:1px solid #dee2e6;display:flex;justify-content:space-between;padding:0 15px 15px;margin-bottom:15px}:host .order--details p{line-height:1.7}:host .order--details p:first-child{font-weight:700}:host .order--details .order--total span{color:#2aa524;font-weight:normal;font-weight:bold;font-size:18px}@media (max-width: 768px){:host .order--details{flex-direction:column}:host .order--details>div{text-align:center}}:host .order--tracking{padding:15px 0;margin-bottom:20px;border:1px solid #dee2e6;overflow:hidden;background-color:#fff;border-radius:10px;color:#000}:host .order--state{width:45px;height:45px;border-radius:50%;background-color:#d7d7d7;display:flex;justify-content:center;align-items:center;color:gray;position:relative}@media (max-width: 420px){:host .order--state{height:30px;width:30px;font-size:14px}}@media (min-width: 421px) and (max-width: 768px){:host .order--state{height:35px;width:35px}}:host .order{flex-basis:20%;position:relative;z-index:1;display:flex;flex-direction:column;align-items:center}:host .order:after{content:\" \";height:20px;background-color:#f5f5f5;width:100%;position:absolute;top:15px;z-index:-1;left:36%}[dir=rtl] :host .order:after{right:36%;left:auto}@media (max-width: 768px){:host .order:after{height:12px;top:13px}}:host .order:last-child:after{content:\" \";background-color:#fff}@media (max-width: 420px){:host .order .state--word{font-size:11px}}@media (min-width: 421px) and (max-width: 768px){:host .order .state--word{font-size:13px}}:host .order-in-progress .order--state{background-color:#09f;color:#fff}:host .order-canceled .order--state{background-color:#d23632;color:#fff}:host .end--state{display:none}:host .order-complete .start--state{display:none}:host .order-complete .end--state{background-color:#fff;color:green;border:1px solid green;display:flex}:host .order--buttons{margin-top:15px;display:flex;justify-content:center}:host .order--buttons button{padding:8px 20px;cursor:pointer;border:1px solid #000;background:transparent;text-transform:capitalize;color:#000;transition:all .3s ease-in-out;border-radius:20px;font-size:16px;display:flex;align-items:center;justify-content:center}:host .order--buttons button:hover{border:1px solid #0099ff;background-color:#09f;color:#fff}@media (max-width: 768px){:host .order--buttons button{font-size:14px;padding:6px 18px}}:host .order--buttons a{display:inline-block;width:120px;height:40px;line-height:40px;border:1px solid var(--main-color, orange);border-radius:20px;text-transform:capitalize;color:var(--main-color, orange);text-align:center;font-size:16px}:host .order--buttons a:hover,:host .order--buttons a:active{border:1px solid #0099ff;background-color:#09f;color:#fff!important}@media (max-width: 768px){:host .order--buttons a{width:100px;font-size:14px;height:35px;line-height:35px}}.loading-animation .lds-ripple{display:inline-block;position:relative;width:45px;height:45px}.loading-animation .lds-ripple div{position:absolute;border:4px solid var(--main-color, orange);opacity:1;border-radius:50%;animation:lds-ripple 1s cubic-bezier(0,.2,.8,1) infinite}.loading-animation .lds-ripple div:nth-child(2){animation-delay:-.5s}@keyframes lds-ripple{0%{top:28px;left:28px;width:0;height:0;opacity:1}to{top:-1px;left:-1px;width:58px;height:58px;opacity:0}}.cancellation-modal .modal-content{border-radius:5px}.cancellation-modal textarea#exampleFormControlTextarea1{border-radius:unset!important}.cancellation-modal button.btn.btn-secondary.btn-lg.m-auto{padding:1rem 4rem;border-radius:.7rem}.cancellation-modal .modal-header{border-bottom:unset}.cancellation-modal .modal-header .close{background-color:unset;position:absolute;border-radius:unset;top:10px;right:11px;color:#bfbcbc}.cancellation-modal .modal-footer{border-top:unset}.cancellation--order--buttons .font-weight-bold{border:1px solid #d7d7d7}@media (max-width: 991.98px){.cancellation-modal .modal-dialog.modal-dialog-centered{width:95%}}\n"], components: [{ type: i4$1.PaginationComponent, selector: "pagination", inputs: ["align", "boundaryLinks", "directionLinks", "rotate", "pageBtnClass", "disabled", "itemsPerPage", "totalItems", "maxSize", "firstText", "previousText", "nextText", "lastText", "customPageTemplate", "customNextTemplate", "customPreviousTemplate", "customFirstTemplate", "customLastTemplate"], outputs: ["numPages", "pageChanged"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.ModalDirective, selector: "[bsModal]", inputs: ["config", "closeInterceptor"], outputs: ["onShow", "onShown", "onHide", "onHidden"], exportAs: ["bs-modal"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }], pipes: { "currency": i6.CurrencyPipe, "translate": TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderHistoryBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-order-history',
                    templateUrl: './order-history.base-component.html',
                    styleUrls: ['./order-history.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: OrderHistoryService }, { type: LanguageService }, { type: CartService }, { type: i2.ActivatedRoute }, { type: i2.Router }, { type: i3$1.ToastrService }]; }, propDecorators: { cancellationModal: [{
                type: ViewChild,
                args: ['cancellationModal']
            }] } });

class WishListBaseComponent {
    constructor(wishlistService, cartService, http, languageService, quickViewService, breadcrumbService) {
        this.wishlistService = wishlistService;
        this.cartService = cartService;
        this.http = http;
        this.languageService = languageService;
        this.quickViewService = quickViewService;
        this.breadcrumbService = breadcrumbService;
        this.modal = false;
        this.language = {};
        this.quantity = 1;
        this.options = {};
        this.price = 0;
        this.cartId = +localStorage.getItem('cartId');
        this.defaultImage = environment.defaultImage;
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.wishlistService.getWishList().subscribe(wishList => {
            this.wishlist = wishList;
        });
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.handleBreadcrumb();
    }
    handleBreadcrumb() {
        const breadCrumbArr = [
            {
                name: 'wishList',
                url: {
                    path: ['wish-list'],
                    params: [],
                },
            },
        ];
        this.breadcrumbService.setCustom(breadCrumbArr);
    }
    removeFromWishlist(code) {
        this.wishlistService.toggleWishList(code);
    }
    clearWishList() {
        this.wishlistService.clearWishList();
    }
    openQuickView(product) {
        this.quickViewService.open(product);
    }
    ngOnDestroy() {
        this.quickViewService.close();
    }
}
WishListBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListBaseComponent, deps: [{ token: WishListService }, { token: CartService }, { token: i1.HttpClient }, { token: LanguageService }, { token: QuickViewService }, { token: BreadcrumbService }], target: i0.ɵɵFactoryTarget.Component });
WishListBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: WishListBaseComponent, selector: "app-base-wish-list", ngImport: i0, template: "<section class=\"wishList-page\">\r\n  <div class=\"wishListBody\" *ngIf=\"wishlist\">\r\n    <!-- Title -->\r\n    <div class=\"wishList-header\">\r\n      <div class=\"container\">\r\n        <div class=\"d-flex justify-content-between\">\r\n          <div class=\"\">\r\n            <p class=\"header-title\"> {{language['wishList']}}</p>\r\n          </div><!--End Col-->\r\n          <div class=\"\">\r\n            <div class=\"header-buttons\" *ngIf=\"wishlist.length > 0;\">\r\n              <button class=\"custom-btn\" (click)=\"clearWishList()\">{{language['remove']}}</button>\r\n            </div>\r\n          </div><!--End Col-->\r\n        </div><!--End Row-->\r\n      </div><!--End Container-->\r\n    </div><!--End wishlist-header-->\r\n    <div class=\"wishlist-content\" *ngIf=\"wishlist.length > 0 ; else showmessage\">\r\n      <div class=\"container\">\r\n        <div class=\"product-wishlist\" *ngFor=\"let fav of wishlist\">\r\n          <div class=\"product-head\">\r\n            <div class=\"product-img\" appImage=\"\" [product]=\"fav\">\r\n              <!--<img [src]=\"imageUrl + fav.images[0]?.path\" class=\"img-fluid \">-->\r\n            </div><!--End product-img-->\r\n          </div><!--End Product-head-->\r\n          <div class=\"product-content\">\r\n            <div class=\"product-name\">\r\n              <a [routerLink]=\"['/',language['LANGUAGE_CODE'],'collection', 'product', fav | translate: 'slug']\">{{ fav.name }}</a>\r\n            </div><!--End product-name-->\r\n            <div class=\"product-price\" *ngIf=\"wishlist.hidePrice\">\r\n                  <span class=\"current-price\">\r\n                    {{ fav.variants[0].prices[0].price/100 }} {{currencyCode}}\r\n                  </span>\r\n              <span class=\"original-price\" *ngIf=\"fav.variants[0].prices[0].original_price > fav.variants[0].prices[0].price\">\r\n                    {{fav.variants[0].prices[0].original_price/100 | number }} {{currencyCode}}\r\n                  </span>\r\n            </div><!--End Product-price-->\r\n            <div class=\"product-status\">\r\n              <span *ngIf=\"\r\n              fav.variants[0].tracked === false ||\r\n              fav.variants[0].stock > 0\" class=\"text-success\">In Stock</span>\r\n              <span *ngIf=\"\r\n              fav.variants[0].tracked &&\r\n              fav.variants[0].stock == 0\" class=\"text-danger\">{{language['outOfStock']}}</span>\r\n            </div><!-- End product-status -->\r\n            <div class=\"product-actions\">\r\n              <button (click)=\"openQuickView(fav)\" class=\"custom-btn reversed d-none\">\r\n                <span class=\"\"> {{language['quickView'] | uppercase}}</span>\r\n              </button>\r\n              <button *ngIf=\"wishlist.hidePrice\" [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product',  fav | translate: 'slug']\"\r\n                      class=\"d-inline custom-btn reversed\">\r\n                {{language['addToCart'] | uppercase}}\r\n                <i class=\"fa fa-shopping-cart\"></i>\r\n              </button>\r\n            </div><!--End Product-action-->\r\n            <div class=\"product-remove\">\r\n              <button class=\"btn-remove\" (click)=\"removeFromWishlist(fav.code)\">\r\n                <!--<i class=\"fa fa-times\"></i>-->\r\n                <span  aria-hidden=\"true\">Remove</span>\r\n              </button>\r\n            </div><!--End product-remove-->\r\n          </div><!--End Product-content-->\r\n        </div><!--End product-wishlist-->\r\n      </div><!--End Container-->\r\n    </div><!--End Wishlist-content-->\r\n    <ng-template  #showmessage>\r\n      <div class=\"empty-wishlist\">\r\n        <div class=\"container\">\r\n          <div class=\"empty-item\">\r\n            <i class=\"fa fa-heart-o\"></i>\r\n            <span class=\"help-text\">{{language['emptyWishList']}}</span>\r\n          </div>\r\n          <div class=\"text-center\">\r\n            <a class=\"custom-btn reversed\" routerLink=\"/collection\">{{language['continueShopping']}}</a>\r\n          </div>\r\n        </div><!--End Container-->\r\n      </div><!--End -empty-wishlist-->\r\n    </ng-template>\r\n  </div><!--End wishListBody-->\r\n\r\n</section><!--End section-settings-->\r\n", styles: [":host .wishListBody{background-color:#fff;min-height:calc(100vh - 200px)}:host .wishListBody .wishList-header{background-color:#09f;font-size:18px;color:#fff;padding:15px 0;overflow:hidden;width:100%}[dir=rtl] :host .wishListBody .wishList-header{text-align:right}:host .wishListBody .wishList-header .header-title{position:relative;display:inline-block;font-weight:bold;margin:0;text-transform:uppercase}:host .wishListBody .wishList-header .header-title:before{position:absolute;content:\"\";right:0;bottom:-5px;width:50%;height:2px;background:var(--main-color, orange)}[dir=rtl] :host .wishListBody .wishList-header .header-title:before{right:auto;left:0}:host .wishListBody .wishList-header .header-buttons{text-align:right}[dir=rtl] :host .wishListBody .wishList-header .header-buttons{text-align:left}:host .wishListBody .wishList-header .header-buttons .custom-btn{background-color:transparent;color:#fff;border:0}:host .wishListBody .wishList-header .header-buttons .custom-btn.reversed{background-color:#fff!important;color:var(--main-color, orange)!important}:host .wishListBody .wishList-header .header-buttons .custom-btn.reversed:hover{background-color:#333!important}:host .wishListBody .wishList-header .header-buttons .custom-btn:hover{color:var(--main-color, orange)}:host .wishListBody .wishlist-content{padding:50px 0;background-color:#fff}:host .wishListBody .wishlist-content .product-wishlist{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;position:relative;background-color:#fff;border:1px solid #ced4da;border-radius:10px;margin-bottom:20px;overflow:hidden;transition:all .3s ease-in-out;padding-left:15px}:host .wishListBody .wishlist-content .product-wishlist:hover{border-color:var(--main-color, orange)}:host .wishListBody .wishlist-content .product-wishlist:hover .product-head:before{background-color:#fbc90012}:host .wishListBody .wishlist-content .product-wishlist .product-head{position:relative;width:20%;padding:10px;background-color:#fff;text-align:center;margin:15px 0;border-radius:15px}:host .wishListBody .wishlist-content .product-wishlist .product-head:before{content:none;position:absolute;top:0;left:0;width:100%;height:100%;background-color:#00000005;transition:all .3s ease-in-out;border-radius:15px}:host .wishListBody .wishlist-content .product-wishlist .product-head .product-img{min-height:150px;width:140px;margin:auto;background-color:transparent}:host .wishListBody .wishlist-content .product-wishlist .product-content{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-around;position:relative;width:80%;min-height:140px;padding-left:20px}[dir=rtl] :host .wishListBody .wishlist-content .product-wishlist .product-content{padding-left:0;padding-right:20px}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-name,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price:after{flex-basis:40%;max-width:40%;position:relative;align-self:flex-start;word-break:break-all}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-name:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price:after{content:\"\";position:absolute;width:1px;height:75vh;background-color:#ced4da;right:0;top:-31vh}[dir=rtl] :host .wishListBody .wishlist-content .product-wishlist .product-content .product-name:after,[dir=rtl] :host .wishListBody .wishlist-content .product-wishlist .product-content .product-status:after,[dir=rtl] :host .wishListBody .wishlist-content .product-wishlist .product-content .product-price:after{left:0;right:auto}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-name a,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status:after a,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price:after a{text-transform:capitalize;font-size:18px;color:#333;font-weight:bold}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price{flex-basis:15%;max-width:15%;position:relative;text-align:center}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price .current-price{font-weight:700;font-size:16px;color:#09f;text-transform:uppercase;margin:0 3px;display:block}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price .original-price{text-decoration:line-through;font-size:16px;margin-top:10px;display:block}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status{flex-basis:15%;position:relative;text-align:center;text-transform:capitalize}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-actions{flex-basis:30%;max-width:30%;text-align:center}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-actions .custom-btn{color:#fff}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-remove{width:38%;text-align:right;position:absolute;bottom:0px;left:0px}[dir=rtl] :host .wishListBody .wishlist-content .product-wishlist .product-content .product-remove{left:auto;right:0;text-align:left}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-remove .btn-remove{text-align:center;padding:0;border:none;background-color:transparent;color:#333;font-size:14px;cursor:pointer;transition:all .3s ease-in-out}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-remove .btn-remove:hover{color:var(--main-color, orange)}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-remove .btn-remove span{border-left:1px solid #ccc;padding-left:10px}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-actions .custom-btn span{color:#fff}@media all and (max-width: 991.98px){:host .wishListBody .product-name,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status:after{margin-bottom:30px}:host .wishListBody .custom-btn{padding:5px 10px;font-size:1.4rem}}@media all and (max-width: 767.98px){:host .wishListBody .wishlist-content .product-wishlist{display:block;padding-left:0}:host .wishListBody .wishlist-content .product-wishlist .product-head{margin:auto;width:100%}:host .wishListBody .wishlist-content .product-wishlist .product-content{display:block;width:100%;text-align:center;position:static;padding-left:0}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-name:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status:after{content:none}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-name,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status:after,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price{max-width:100%;flex-basis:auto}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-price,:host .wishListBody .wishlist-content .product-wishlist .product-content .product-actions{margin-bottom:20px}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-status{margin-bottom:20px}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-actions{max-width:unset}:host .wishListBody .wishlist-content .product-wishlist .product-content .product-remove{position:absolute;top:auto;left:auto;bottom:23px;right:10px}}:host .empty-wishlist{padding:30px 0}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: ImageDirective, selector: "[appImage]", inputs: ["product", "hover"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i2.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "translate": TranslatePipe, "number": i6.DecimalPipe, "uppercase": i6.UpperCasePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-wish-list',
                    templateUrl: './wish-list.base-component.html',
                    styleUrls: ['./wish-list.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: WishListService }, { type: CartService }, { type: i1.HttpClient }, { type: LanguageService }, { type: QuickViewService }, { type: BreadcrumbService }]; } });

class LoginBaseComponent {
    constructor(toastr, formBuilder, loginService, languageService, authService, confService, activatedRoute, router) {
        this.toastr = toastr;
        this.formBuilder = formBuilder;
        this.loginService = loginService;
        this.languageService = languageService;
        this.authService = authService;
        this.confService = confService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.errors = [];
        this.language = {};
        this.loading = false;
        this.logByPhone = false;
    }
    ngOnInit() {
        this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
        this.store$ = this.confService.store$;
        this.currentLang = this.languageService.lastLocale;
        this.languageService.localeChange.subscribe(() => {
            this.currentLang = this.languageService.lastLocale;
        });
        this.logo$ = this.confService.logo$;
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        this.store$.subscribe(res => {
            this.logByPhone = res.isMobileEssential;
        });
        this.confService.getConf().subscribe(conf => {
            this.allow_registration = conf['allow_registration'];
        });
        this.signInForm = this.formBuilder.group({
            email: ['', [Validators.required, this.logByPhone ? Validators.minLength(6) : Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            rememberMe: [true]
        });
        this.signInForm.valueChanges.subscribe(() => {
            const keys = Object.keys(this.signInForm.controls);
            this.errors = [];
            for (const key of keys) {
                const control = this.signInForm.controls[key];
                if (control.invalid &&
                    (control.dirty || key === 'passwordConfirmation')) {
                    if (!!control.errors.minlength) {
                        this.errors.push(`${this.language[key]} ${this.language['minimumLength']} ${control.errors.minlength.requiredLength}`);
                    }
                    else if (!!control.errors.doesNotMath) {
                        this.errors.push(control.errors.doesNotMath);
                    }
                    else if (!!control.errors.required) {
                        this.errors.push(`${this.language[key]}: ${this.language['required']}`);
                    }
                    else {
                        this.errors.push(`${this.language[key]}: ${this.language['invalid']}`);
                    }
                }
            }
        });
    }
    signIn() {
        this.errors = [];
        this.loading = true;
        const email = this.signInForm.value.email;
        const password = this.signInForm.value.password;
        const rememberMe = this.signInForm.value.rememberMe;
        const storage = rememberMe ? localStorage : sessionStorage;
        this.loginService.login(email, password).pipe().subscribe((data) => {
            console.log(data);
            this.loading = false;
            storage.setItem('user_id', data.shopUserId.toString());
            storage.setItem('customer_id', data.customerId.toString());
            storage.setItem('user_firstName', data.firstName);
            storage.setItem('user_lastName', data.lastName);
            storage.setItem('user_email', data.email);
            storage.setItem('jwt_token', data.token);
            localStorage.setItem('user_phone', data.phoneNumber);
            this.loginService.loggedIn(this.returnUrl);
        }, error => {
            this.loading = false;
            if (error && error.error && error.error.message) {
                this.errors.push(error.error.message);
            }
        });
    }
    signInWithGoogle() {
        this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then((res) => {
            this.loginService.socialLogin(res);
        }).catch(err => {
        });
    }
    signInWithFB() {
        this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then((res) => {
            this.loginService.socialLogin(res);
        }).catch(err => {
        });
    }
}
LoginBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginBaseComponent, deps: [{ token: i3$1.ToastrService }, { token: i1$1.FormBuilder }, { token: LoginService }, { token: LanguageService }, { token: i2$1.SocialAuthService }, { token: ConfService }, { token: i2.ActivatedRoute }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
LoginBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: LoginBaseComponent, selector: "app-base-login", ngImport: i0, template: "<section class=\"page-container\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row no-gutters\">\r\n      <!-- Store logo-->\r\n      <div class=\"col-lg-6 col-md-5\">\r\n        <div class=\"image-container\">\r\n          <img *ngIf=\"logo$ as logo\" [lazyLoad]=\"logo |async\" alt=\"logo\" [errorImage]=\"defaultImage\">\r\n        </div>\r\n        <!--End image-container-->\r\n      </div>\r\n      <!--End col-->\r\n      <!--Form login -->\r\n\r\n      <div class=\"col-lg-6 col-md-7 d-flex justify-content-center align-items-center\">\r\n        <div class=\"accounts-form col-9\">\r\n          <div class=\"accounts-form-head\">\r\n            <ng-container *ngIf=\"store$ | async as store\">\r\n              <a *ngIf=\"!store['mustLogged']\" routerLink=\"/{{language['LANGUAGE_CODE']}}\" class=\"backToWebsite\">\r\n                <i [ngClass]=\"language['DIR'] === 'rtl'? 'fa fa-angle-right' : 'fa fa-angle-left'\"></i>\r\n                {{language['backToWebsite']}}\r\n              </a>\r\n            </ng-container>\r\n          </div>\r\n          <!--End accounts-form-head-->\r\n          <div class=\"accounts-form-content \">\r\n            <div class=\"form-container\">\r\n              <h3 class=\"account-title h3--custom\">{{language['login']}}</h3>\r\n              <div class=\"validation-text\" *ngIf=\"errors.length\">\r\n                <div *ngFor=\"let error of errors\">{{error}}</div>\r\n              </div>\r\n              <form [formGroup]=\"signInForm\" (ngSubmit)=\"signIn()\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"email\" [innerHTML]=\"logByPhone ? language['phone_number'] + ' *': language['email'] + ' *'\"></label>\r\n                  <input type=\"text\" name=\"email\" id=\"email\" class=\"form-control input-lg\"\r\n                    required>\r\n                  <div class=\"invalid-feedback\">{{language['youMissedThisOne']}}</div>\r\n                </div>\r\n                <!--End form-group-->\r\n\r\n                <div class=\"form-group\">\r\n                  <label for=\"password\">{{language['password']}} *</label>\r\n                  <input type=\"password\" name=\"   password\" id=\"password\" class=\"form-control input-lg\"\r\n                    formControlName=\"password\" required>\r\n                  <div class=\"invalid-feedback\">{{language['youMissedThisOne']}}</div>\r\n                </div>\r\n                <!--End form-group-->\r\n\r\n                <div class=\"form-group d-flex align-items-center justify-content-between\">\r\n                  <div class=\"custom-checkbox\">\r\n                    <input id=\"rememberMe\" type=\"checkbox\" formControlName=\"rememberMe\"\r\n                      [attr.aria-checked]=\"signInForm.controls.rememberMe.value\">\r\n                    <label for=\"rememberMe\" class=\"label\">{{language['rememberMe']}}</label>\r\n                  </div>\r\n                  <!--End custom-checkbox-->\r\n                  <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'accounts', 'forget-password']\"\r\n                    class=\"forget-password btn btn-link p-0 m-0\">{{language['forgetYourPassword']}}</a>\r\n                </div>\r\n                <!--End form-group-->\r\n                <div class=\"form-group\">\r\n                  <button type=\"submit\" class=\"main-btn\"\r\n                    [disabled]='!signInForm.valid ||loading'>{{language['login']}}</button>\r\n                </div>\r\n                <!--End form-group-->\r\n\r\n                <!-- Social login -->\r\n                <ng-container *ngIf=\"store$ | async as store\">\r\n                  <hr *ngIf=\"!(store.googleOauth && store.appId)\">\r\n                  <div class=\"social-login-section text-center\" *ngIf=\"!!store.googleOauth || !!store.appId\">\r\n                    <div *ngIf=\"!!store.googleOauth && !!store.appId\"\r\n                      class=\"or-section d-flex justify-content-between align-items-center\">\r\n                      <hr>\r\n                      <span>{{language['Or']}}</span>\r\n                      <hr>\r\n                    </div>\r\n                    <div class=\"social-btns d-flex align-items-center justify-content-between\">\r\n                      <button class=\"social facebook\" type=\"button\" (click)=\"signInWithFB()\" *ngIf=\"!!store.appId\">\r\n                        <i class=\"fa fa-facebook-square\"></i>\r\n                        {{language['facebook']}}\r\n                      </button>\r\n                      <button class=\"social google\" type=\"button\" (click)=\"signInWithGoogle()\"\r\n                        *ngIf=\"!!store.googleOauth\">\r\n                        <i class=\"fa fa-google\"></i>\r\n                        {{language['google']}}</button>\r\n                    </div>\r\n                    <hr>\r\n                  </div>\r\n                  <!--End social-login-section-->\r\n                  <ng-content select=\".facebook--google\"></ng-content>\r\n                </ng-container>\r\n\r\n\r\n                <!-- Don't have account -->\r\n                <div class=\"not-member\" *ngIf=\"allow_registration === 1\">\r\n                  <p>{{language['dontHaveAccount']}} <a routerLink=\"/{{language['LANGUAGE_CODE']}}/accounts/sign-up\"\r\n                      class=\"btn-link\">{{language['register']}}</a></p>\r\n                </div>\r\n                <ng-content></ng-content>\r\n              </form>\r\n            </div>\r\n            <!--End form-container-->\r\n          </div>\r\n          <!--End accounts-form-content-->\r\n        </div>\r\n        <!--End accounts-form-->\r\n      </div>\r\n      <!--End col-->\r\n    </div>\r\n    <!--End row-->\r\n  </div>\r\n  <!--End container-fluid-->\r\n</section>\r\n<!--End page-container-->\r\n", styles: ["@charset \"UTF-8\";:host .page-container .container-fluid{padding:0}:host .page-container .container-fluid>.row{min-height:100vh}:host .page-container .account-title{color:var(--h3-color, #000);font-size:var(--h3-font-size, 28px);text-transform:capitalize;font-weight:600;margin-bottom:10px}:host .page-container .image-container{background:#0d0d0d;min-height:100%;display:flex;align-items:center;justify-content:center;padding:20px}:host .page-container .image-container img{max-width:300px}:host .page-container .accounts-form{padding:10px}:host .page-container .accounts-form .accounts-form-head .backToWebsite{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 16px)}:host .page-container .accounts-form .accounts-form-content{position:absolute;width:400px;transform:translate(-50%,-50%);top:50%;left:50%}@media all and (max-width: 767.98px){:host .page-container .accounts-form .accounts-form-content{position:static;transform:none;width:auto;max-width:400px;margin:30px auto 0}}:host .page-container .accounts-form .form-container .form-control{border-radius:0}:host .page-container .accounts-form .form-container .forget-password{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 1.4rem)}:host .page-container .with-cursor{cursor:pointer}:host .custom-checkbox{position:relative}:host .custom-checkbox input[type=checkbox]{width:0;height:0;opacity:0;position:absolute}:host .custom-checkbox input[type=checkbox]~.label{position:relative;padding-left:25px;text-transform:capitalize;cursor:pointer}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label{padding-left:0;padding-right:25px}:host .custom-checkbox input[type=checkbox]~.label:after{position:absolute;content:\"\";top:4px;left:0;font-family:\"fontAwesome\";width:17px;height:17px;line-height:14px;text-align:center;border-radius:2px;border:2px solid #d3cac5;color:#000;font-size:14px}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label:after{left:auto;right:0}:host .custom-checkbox input[type=checkbox]:checked~.label:after{content:\"\\f00c\";border-color:var(--main-color, var(--main-color, orange));background-color:var(--main-color, var(--main-color, orange))}:host .custom-checkbox input[type=checkbox]:focus~.label:after{border-color:var(--main-color, var(--main-color, orange))}:host .social-btns{margin-bottom:10px}:host .main-btn{background:transparent;border:1px solid var(--main-color, orange);color:#444;font-weight:600;transition:all .4s ease;min-width:100px;padding:5px 0;margin:0 auto;text-align:center;display:block}:host .main-btn:enabled:hover{background:var(--main-color, orange);color:#fff!important;cursor:pointer}:host .main-btn:disabled{cursor:not-allowed;background:#999;color:#fff;border-color:#999}:host .or-section hr{width:40%;border-top:1px solid #ced4da}:host hr{border-top:1px solid #ced4da}:host button.social{background:transparent;border:2px solid;border-radius:0;width:110px;height:35px;display:flex;align-items:center;justify-content:center}:host button.social.facebook{border-color:#29487d;transition:all .4s ease;cursor:pointer}:host button.social.facebook i{color:#29487d;margin:0 5px}:host button.social.google{border-color:#dd5347;transition:all .4s ease;cursor:pointer}:host button.social.google i{color:#dd5347;margin:0 5px}:host button.social.facebook:hover{background:#29487d;color:#fff}:host button.social.facebook:hover i{color:#fff}:host button.social.google:hover{background:#dd5347;color:#fff}:host button.social.google:hover i{color:#fff}:host .form-control{box-shadow:none}:host .form-control.ng-invalid.ng-touched{border-color:#bd2130}:host .validation-text{font-size:14px;color:#bd2130;position:relative;top:-10px;margin-top:15px}:host .validation-text span{display:block}:host .not-member{display:flex;justify-content:center;align-items:center;margin-top:10px}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i1$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-login',
                    templateUrl: './login.base-component.html',
                    styleUrls: ['./login.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i3$1.ToastrService }, { type: i1$1.FormBuilder }, { type: LoginService }, { type: LanguageService }, { type: i2$1.SocialAuthService }, { type: ConfService }, { type: i2.ActivatedRoute }, { type: i2.Router }]; } });

class SideMenuBaseComponent {
    constructor(languageService, router, activatedRoute, wishListService, taxonService, compareService, cartService, confService, staticPagesService, loginService, navigationMenu) {
        this.languageService = languageService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.wishListService = wishListService;
        this.taxonService = taxonService;
        this.compareService = compareService;
        this.cartService = cartService;
        this.confService = confService;
        this.staticPagesService = staticPagesService;
        this.loginService = loginService;
        this.navigationMenu = navigationMenu;
        this.taxons = [];
        this.language = {};
        this.redirectUrls = [];
        this.queryParams = {};
        this.openLanguageList = false;
        this.conf$ = this.confService.getConf();
        this.logo$ = this.confService.logo$;
        this.store$ = this.confService.store$;
        this.imageUrl = environment.imageUrl;
        this.logged$ = this.loginService.logged;
        this.compareFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.COMPARE));
        this.wishListFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.WISH_LIST));
        // this.menus = this.navigationMenu.menus.getValue();
    }
    ngOnInit() {
        this.navigationMenu.getNavigationMenuHeader().subscribe(data => {
            this.menus = data;
            this.switchDynamicMenuStaticPages();
        });
        this.conf$.subscribe(conf => {
            /* //stop-auto-detect//
            this.confService.store$.subscribe(
                (store) => {
                    
                    this.multipleBranchsFeature = store['mutipleBranch'] && !store['allowGeofence'];
                    
                }
            );
            */
            this.multipleBranchsFeature = conf['multiple_locations'];
        });
        this.userName = this.getUserName();
        this.cartCounter = this.cartService.getCartCounter();
        this.selectedTaxon = this.taxons[0];
        this.wishListCounter = this.wishListService.getWishListCounter();
        this.compareCounter = this.compareService.getCompareCounter();
        this.languageSub = this.languageService.getAvailableLocales().subscribe(availableLanguages => {
            this.availableLanguages = availableLanguages;
            this.languageService.getLanguage().subscribe(language => {
                this.language = language;
                this.readUrl();
            });
            this.readUrl();
            this.routerSub = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
                this.readUrl();
            });
        });
        this.activatedRoute.queryParams.subscribe(params => {
            this.queryParams = params;
        });
        // this.switchDynamicMenuStaticPages();
    }
    refresh() {
        window.location.reload();
    }
    switchDynamicMenuStaticPages() {
        if (!this.menus) {
            this.renderTaxonsFromApi();
            this.renderStaticPages();
            this.hasOwnNavigationMenu = false;
        }
        if (this.menus && this.menus.length > 0) {
            this.generteUrls(this.menus);
            this.renderTaxonsFromApi();
            this.hasOwnNavigationMenu = true;
        }
    }
    renderTaxonsFromApi() {
        this.taxonService.getTaxons().subscribe(taxons => {
            this.taxons = taxons;
            this.selectedTaxon = this.taxons[0];
        });
    }
    renderStaticPages() {
        this.staticPagesService.getAllPages('header').subscribe(staticPages => {
            this.staticPages = staticPages;
        });
    }
    closeModal() {
        this.navigationMenu.setCloseBehaviorView(true);
        this.modal.hide();
    }
    generteUrls(array) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].url_type !== 'external_link') {
                const url = array[i].url;
                const tree = this.router.parseUrl(url);
                const params = tree.queryParams;
                const g = tree.root.children[PRIMARY_OUTLET];
                const s = g.segments;
                const router = ['/', ...s.map(segement => segement.path)];
                array[i]['parsedUrl'] = { router: router, params: params };
                this.generteUrls(array[i].children);
            }
        }
        return array;
    }
    readUrl() {
        for (const language of this.availableLanguages) {
            this.redirectUrls[language.code] = this.router.url.replace(this.language['LANGUAGE_CODE'], language.code)
                .split('?')[0];
        }
    }
    logout() {
        this.loginService.logOut();
        this.modal.hide();
    }
    getUserName() {
        return this.logged$.pipe(map(() => {
            return localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName');
        }));
    }
    ngAfterViewInit() {
        this.closeModalSub = this.navigationMenu.getCloseBehaviorView().subscribe(x => {
            if (x) {
                this.modal.hide();
            }
        });
    }
    removeOverFlow() {
        const root = document.getElementsByTagName('html')[0];
        root.classList.remove('overflow');
    }
    ngOnDestroy() {
        if (this.routerSub || this.languageSub || this.closeModalSub) {
            this.routerSub.unsubscribe();
            this.languageSub.unsubscribe();
            this.closeModalSub.unsubscribe();
        }
    }
}
SideMenuBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SideMenuBaseComponent, deps: [{ token: LanguageService }, { token: i2.Router }, { token: i2.ActivatedRoute }, { token: WishListService }, { token: TaxonService }, { token: CompareService }, { token: CartService }, { token: ConfService }, { token: StaticPagesService }, { token: LoginService }, { token: DynamicNavigationMenu }], target: i0.ɵɵFactoryTarget.Component });
SideMenuBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: SideMenuBaseComponent, selector: "ng-component", inputs: { modal: "modal" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SideMenuBaseComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: WishListService }, { type: TaxonService }, { type: CompareService }, { type: CartService }, { type: ConfService }, { type: StaticPagesService }, { type: LoginService }, { type: DynamicNavigationMenu }]; }, propDecorators: { modal: [{
                type: Input
            }] } });

class SearchBaseComponent {
    constructor(languageService, _router, taxonService, collectionService) {
        this.languageService = languageService;
        this._router = _router;
        this.taxonService = taxonService;
        this.collectionService = collectionService;
        this.searchFired$ = new EventEmitter();
        this.taxons = [];
        this.term = '';
        this.autoCompleteList = false;
        this.completeToThose = [];
        this.language = {};
        this.currentUrl = '';
        this.redirectUrl = '';
        this.products = [];
        this.page = 1;
        this.showNoAvaliableStatus = false;
        this.autoComplete = false;
        this.showAllProducts = false;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            this.readUrl();
        });
        this.readUrl();
        this._router.events.subscribe(() => {
            this.readUrl();
        });
        this.taxonService.getTaxons().subscribe(taxons => {
            this.taxons = taxons;
        });
    }
    readUrl() {
        const theOtherLanguage = this.language['LANGUAGE_CODE'] === 'en_US' ? 'ar_EG' : 'en_US';
        this.redirectUrl = this._router.url.replace(this.language['LANGUAGE_CODE'], theOtherLanguage);
        this.currentUrl = this._router.url.split('/').filter(url => url !== '')[1];
    }
    changed(term) {
        this.term = term;
        if (term.length > 2) {
            const params = this.selectedTaxon ? { q: term, limit: 4, taxons: [this.selectedTaxon] } : { q: term, limit: 4 };
            this.collectionService.getCollectionForAutocomplete(params).subscribe((data) => {
                this.autoComplete = true;
                this.completeToThose = data;
                if (this.completeToThose.length === 0) {
                    this.showNoAvaliableStatus = true;
                    this.showAllProducts = false;
                }
                else if (this.completeToThose.length < 2) {
                    this.showAllProducts = false;
                    this.showNoAvaliableStatus = false;
                }
                else if (this.completeToThose.length > 3) {
                    this.showAllProducts = true;
                    this.showNoAvaliableStatus = false;
                }
                else {
                    this.showNoAvaliableStatus = false;
                }
            });
        }
        else {
            this.autoComplete = false;
        }
    }
    serchResult(e) {
        if (e.trim().length > 0) {
            this.searchFired$.emit();
            const queryParams = { q: e, page: 1 };
            console.log(queryParams);
            if (this.selectedTaxon && this.selectedTaxon !== undefined && this.selectedTaxon !== 'undefined') {
                queryParams['taxons'] = [this.selectedTaxon];
            }
            this._router.navigate(['/', this.language['LANGUAGE_CODE'], 'collection'], { queryParams: queryParams });
        }
    }
    focusOutFunction() {
        setTimeout(() => {
            this.autoComplete = false;
        }, 250);
    }
}
SearchBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SearchBaseComponent, deps: [{ token: LanguageService }, { token: i2.Router }, { token: TaxonService }, { token: CollectionService }], target: i0.ɵɵFactoryTarget.Component });
SearchBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: SearchBaseComponent, selector: "ng-component", outputs: { searchFired$: "searchFired$" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SearchBaseComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i2.Router }, { type: TaxonService }, { type: CollectionService }]; }, propDecorators: { searchFired$: [{
                type: Output
            }] } });

class SubCategorySliderComponent {
    constructor(languageService, shopService, route, router, taxonService, confService) {
        this.languageService = languageService;
        this.shopService = shopService;
        this.route = route;
        this.router = router;
        this.taxonService = taxonService;
        this.confService = confService;
        // @Input() taxons: Taxon[];
        this.language = {};
        this.subCategorySelectedCount = 0;
        this.showSubCategory = false;
        this.imageUrl = environment.imageUrl;
        this.defaultImage = environment.defaultImage;
        this.getImage = TaxonService.getImage;
        this.storeEnableSubCategory$ = this.confService.storeEnableSubCategory;
    }
    ngOnInit() {
        this.filterSubscription = this.shopService.filter.subscribe((filter) => {
            this.filter = filter;
        });
        this.route.queryParamMap.subscribe((param) => {
            this.filteredItemsParams = param['params'];
            if (this.filteredItemsParams && this.filteredItemsParams.taxons) {
                this.getTaxons(this.filteredItemsParams.taxons);
            }
            else {
                this.resetSubCategory();
            }
        });
        let prevScrollPosition = 0;
        this.responsiveOptions = [
            {
                breakpoint: '1199px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '991px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '767px',
                numVisible: 1,
                numScroll: 1
            }
        ];
        function scrollHandler(e) {
            // At a time out of 150 by default for better browser support,
            // but do not set a time out if a snapping point has been reached.
            let atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0, timeOut = atSnappingPoint ? 0 : 150, slider = e.target.closest('.js-slider');
            clearTimeout(e.target.scrollTimeout);
            e.target.scrollTimeout = setTimeout(function () {
                const currentScrollPosition = parseInt(e.target.scrollLeft, 10);
                slider.classList.remove('slider--last', 'slider--first');
                if (currentScrollPosition > prevScrollPosition &&
                    e.target.scrollWidth - currentScrollPosition === e.target.offsetWidth) {
                    slider.classList.add('slider--last');
                }
                else if (currentScrollPosition <= prevScrollPosition &&
                    currentScrollPosition <= 0) {
                    slider.classList.add('slider--first');
                }
                prevScrollPosition = currentScrollPosition;
            }, timeOut);
        }
        function scrollHandlerAr(e) {
            // At a time out of 150 by default for better browser support,
            // but do not set a time out if a snapping point has been reached.
            let atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0, timeOut = atSnappingPoint ? 0 : 150, slider = e.target.closest('.js-slider');
            clearTimeout(e.target.scrollTimeout);
            e.target.scrollTimeout = setTimeout(function () {
                const currentScrollPosition = parseInt(e.target.scrollLeft, 10);
                slider.classList.remove('slider--last', 'slider--first');
                if (currentScrollPosition > prevScrollPosition &&
                    e.target.scrollWidth - currentScrollPosition === e.target.offsetWidth) {
                    slider.classList.add('slider--first');
                }
                else if (currentScrollPosition <= prevScrollPosition &&
                    currentScrollPosition <= 0) {
                    slider.classList.add('slider--last');
                }
                prevScrollPosition = currentScrollPosition;
            }, timeOut);
        }
        function updateSlidePosition(e, direction) {
            const firstSlideWidth = e.querySelector('.slider__slide').offsetWidth;
            if (direction === 'prev') {
                e.scrollLeft -= firstSlideWidth;
            }
            else {
                e.scrollLeft += firstSlideWidth;
            }
        }
        document
            .querySelector('.js-slider-inner')
            .addEventListener('scroll', scrollHandler);
        // document
        //     .querySelector(".js-slider-inner")
        //     .addEventListener("pointermove", (e) => {
        //         if (e.movementX > 0 && e.movementY == 0) {
        //             updateSlidePosition(
        //                 document.querySelector(".js-slider-inner"),
        //                 "prev"
        //             );
        //         } else if (e.movementX < 0 && e.movementY == 0) {
        //             updateSlidePosition(
        //                 document.querySelector(".js-slider-inner"),
        //                 "next"
        //             );
        //         }
        //     });
        if (document.querySelector('.js-slider-prev') !== null) {
            document
                .querySelector('.js-slider-prev')
                .addEventListener('click', function () {
                updateSlidePosition(this.nextElementSibling, 'prev');
            });
        }
        if (document.querySelector('.js-slider-next') !== null) {
            document
                .querySelector('.js-slider-next')
                .addEventListener('click', function () {
                updateSlidePosition(this.previousElementSibling, 'next');
            });
        }
        this.languageService
            .getLanguage()
            .subscribe((language) => (this.language = language));
    }
    updatePosition(e, direction) {
        const firstSlideWidth = e.querySelector('.slider__slide').offsetWidth;
        if (direction === 'prev') {
            e.scrollLeft -= firstSlideWidth;
        }
        else {
            e.scrollLeft += firstSlideWidth;
        }
    }
    nextBtn() {
        document
            .querySelector('.js-slider-prev')
            .addEventListener('click', function () {
            this.updatePosition(this.nextElementSibling, 'prev');
        });
    }
    getTaxons(taxonsParams) {
        this.imageUrl = environment.imageUrl;
        let subCategory = [];
        const allsubCategory = [];
        this.taxonService.getTaxons().subscribe((taxons) => {
            this.taxons = taxons;
            let parentTaxonCountSelected = 0;
            let alltaxonsParams = taxonsParams.split(',');
            if (!alltaxonsParams || alltaxonsParams.length == 0) {
                //this.shopService.changeX('taxons' , false)
                this.resetSubCategory();
            }
            this.taxons = this.taxons || [];
            this.taxons.forEach((taxon, t) => {
                for (let p = 0; p < alltaxonsParams.length; p++) {
                    let paramTaxon = alltaxonsParams[p];
                    if (taxon.code && taxon.code == paramTaxon && taxon.children) {
                        parentTaxonCountSelected += 1;
                        //taxon.children.map(obj=> ({ ...obj, active: false }))
                        subCategory.push(taxon.children);
                    }
                    if (p == alltaxonsParams.length - 1) {
                        if (taxon.children && taxon.children.length > 0) {
                            for (const element of taxon.children) {
                                element['active'] = false;
                            }
                            allsubCategory.push(taxon.children);
                        }
                    }
                    if (t == this.taxons.length - 1 && p == alltaxonsParams.length - 1) {
                        if (parentTaxonCountSelected == 1 && subCategory[0].length != 0) {
                            this.showSubCategory = true;
                            this.subCategory = subCategory[0];
                            this.mainCategory = this.getMainCategory(subCategory[0][0].parent_id);
                            this.mainCategory['active'] = true;
                            this.checkThirdLevelSelection(alltaxonsParams, this.mainCategory);
                        }
                        else if (parentTaxonCountSelected > 1) {
                            this.resetSubCategory();
                            return;
                        }
                        else {
                            let taxonsParamsChildreen = taxonsParams.split(',');
                            let taxonExistInSuCategoryCount = 0;
                            let subIndex = 0;
                            allsubCategory.forEach((sub, s) => {
                                let taxonExistInSuCategory = false;
                                sub = sub || [];
                                sub.forEach((element, e) => {
                                    taxonsParamsChildreen.forEach((code, c) => {
                                        if (element.code && element.code == code) {
                                            element.active = true;
                                            this.subCategorySelectedCount += 1;
                                            taxonExistInSuCategory = true;
                                        }
                                        if (e == sub.length - 1 &&
                                            c == taxonsParamsChildreen.length - 1) {
                                            if (taxonExistInSuCategory == true) {
                                                taxonExistInSuCategoryCount += 1;
                                                subIndex = s;
                                            }
                                        }
                                        if (s == allsubCategory.length - 1 &&
                                            e == sub.length - 1 &&
                                            c == taxonsParamsChildreen.length - 1) {
                                            if (taxonExistInSuCategoryCount == 1) {
                                                this.subCategory = allsubCategory[subIndex];
                                                this.showSubCategory = true;
                                                this.mainCategory = this.getMainCategory(allsubCategory[subIndex][0].parent_id);
                                                this.mainCategory['active'] = false;
                                                this.checkThirdLevelSelection(taxonsParamsChildreen, this.mainCategory);
                                            }
                                            else {
                                                this.resetSubCategory();
                                            }
                                        }
                                    });
                                });
                            });
                            // this.showSubCategory = false;
                            // this.subCategory = []
                        }
                    }
                }
            });
        });
    }
    checkThirdLevelSelection(taxonsParamsChildreen, mainCategory) {
        if (!taxonsParamsChildreen || taxonsParamsChildreen.length == 0) {
            return;
        }
        taxonsParamsChildreen.forEach((param) => {
            this.taxons.forEach((taxon) => {
                taxon.children = taxon.children || [];
                taxon.children.forEach((subCategory) => {
                    if (mainCategory &&
                        mainCategory.id &&
                        subCategory['parent_id'] &&
                        subCategory['code'] &&
                        subCategory['code'] == param &&
                        mainCategory.id != subCategory['parent_id']) {
                        this.resetSubCategory();
                    }
                    subCategory.children = subCategory.children || [];
                    subCategory.children.forEach((child) => {
                        if (child.code && child.code == param) {
                            this.resetSubCategory();
                        }
                    });
                });
            });
        });
    }
    selectSubCategory(category) {
        if (category.active == true) {
            category.active = false;
            this.subCategorySelectedCount -= 1;
            if (this.filteredItemsParams.taxons &&
                this.filteredItemsParams.taxons == category.code) {
                this.shopService.changeX('taxons', this.mainCategory.code);
                return;
            }
            this.shopService.changeTaxon(category.code, category.active);
            return;
        }
        if (category.active == false) {
            category.active = true;
            this.subCategorySelectedCount += 1;
            this.shopService.changeTaxon(category.code, category.active);
            return;
        }
    }
    selectMainCategory(category) {
        this.shopService.changeX('taxons', category.code);
    }
    getMainCategory(id) {
        return this.taxons.find((taxon) => taxon.id === id);
    }
    resetSubCategory() {
        this.showSubCategory = false;
        this.mainCategory = null;
        this.subCategory = [];
    }
}
SubCategorySliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SubCategorySliderComponent, deps: [{ token: LanguageService }, { token: ShopService }, { token: i2.ActivatedRoute }, { token: i2.Router }, { token: TaxonService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
SubCategorySliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: SubCategorySliderComponent, selector: "app-base-sub-category-slider", ngImport: i0, template: "\r\n<div  [ngClass]=\"{'container__hidden': (!( subCategory && subCategory.length > 0  && (storeEnableSubCategory$ | async)))}\"   class=\"container\">\r\n  <div class=\"row row-block\">\r\n<div class=\"slider slider--first js-slider\">\r\n<div class=\"slider__wrapper\">\r\n\r\n<p-carousel [value]=\"subCategory\" [numVisible]=\"3\" [numScroll]=\"3\"  [circular]=\"true\" [responsiveOptions]=\"responsiveOptions\"  style=\"padding: 11px;direction: ltr;\">\r\n  <ng-template let-product pTemplate=\"item\" >\r\n    <div (click)=\"selectSubCategory(product)\" [ngClass]=\"{'default_border': product?.active}\" class=\"slide__content p-2 m-2\">\r\n      <div *ngIf=\"product?.active\" class=\"slide__content__selected__box\">\r\n        <svg class=\"correct_sign\" xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n          <g id=\"selected\" transform=\"translate(-0.162 -0.297)\">\r\n            <g id=\"invisible_box\" data-name=\"invisible box\" transform=\"translate(0 0)\">\r\n              <rect id=\"Rectangle_5\" data-name=\"Rectangle 5\" width=\"18\" height=\"18\" transform=\"translate(0.162 0.297)\" fill=\"none\"/>\r\n            </g>\r\n            <g id=\"icons_Q2\" data-name=\"icons Q2\" transform=\"translate(1.901 3.494)\">\r\n              <path id=\"Path_3\" data-name=\"Path 3\" d=\"M8.763,20.4l-3.035-3a.8.8,0,0,1-.076-1.024A.721.721,0,0,1,6.79,16.3l2.5,2.5,8.953-8.953a.759.759,0,0,1,1.062,1.062L9.825,20.4a.721.721,0,0,1-1.062,0Z\" transform=\"translate(-5.501 -9.7)\" fill=\"#fff\"/>\r\n            </g>\r\n          </g>\r\n        </svg>\r\n        \r\n      </div>\r\n      <div class=\"slide__content__default\">\r\n        <div  class=\"slide__content__text\" >\r\n        <span>{{product | translate : 'name'}}</span>\r\n        </div>\r\n      </div>\r\n        <img  [lazyLoad]=\"getImage(product)\" [src]=\"getImage(product)\" class=\"slider__image\" />\r\n    </div>\r\n  </ng-template>\r\n</p-carousel>\r\n</div>\r\n</div>\r\n</div>", styles: [":host{display:block;margin-top:15px}:host .row-block{display:block!important}:host .label-number{margin:0 5px}:host *,:host :after,:host :before{box-sizing:border-box}:host .slider{width:100%;max-width:100%;margin:24px auto}:host .slider__wrapper{position:relative}:host .slider__inner{display:flex;overflow-x:scroll;flex-flow:row nowrap;margin-bottom:24px;grid-gap:24px;gap:24px;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;touch-action:pan-x;scrollbar-width:none}:host .slider__inner::-webkit-scrollbar{height:12px}:host .slider__inner::-webkit-scrollbar-thumb{border-radius:24px;background-color:#d3d3d3}:host .slider__inner::-webkit-scrollbar-track{background-color:transparent}:host .slider__inner::-webkit-scrollbar{display:none}:host .slider__inner .correct_sign{margin-left:15px;margin-top:10px}[dir=rtl] :host .slider__inner .correct_sign{margin-left:unset;margin-right:15px!important}:host .slider__slide{flex:1 0 80%;max-width:80%;scroll-snap-align:center}@media (min-width: 980px){:host .slider__slide{flex-basis:26%;max-width:26%}}:host .slide__content{cursor:pointer;position:relative;overflow:hidden;border:5px solid #818181;border-radius:50px;opacity:1}:host .slide__content:before{content:\"\";display:block;padding-top:56%}:host .slide__content .slide__content__selected__box{position:absolute;top:0;left:0;width:48px;height:39px;background:var(--main-color, #000) 0% 0% no-repeat padding-box;border-radius:44px 0 22px;opacity:1;z-index:99}:host .slide__content .selected-mark{position:absolute;top:15px;left:15px}:host .slide__content .slide__content__default{height:100%;width:100%;display:flex;align-items:center;position:absolute;top:0;left:0;right:0;bottom:0;background:#00000080 0% 0% no-repeat padding-box;z-index:90}:host .slide__content .slide__content__default .slide__content__text{display:block;width:100%;padding:15px 20px;color:#fff;text-align:center}:host .default_border{border-color:var(--main-color, #000)!important}:host .slide__content__selected__border{border:5px solid #000}:host .slider__image{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;object-fit:cover}:host .slider__dots{display:flex;flex-flow:row wrap;justify-content:center;grid-gap:12px;gap:12px}@media (min-width: 980px){:host .slider__dots{display:none}}:host .slider__arrow{position:absolute;top:40%;z-index:1;display:block;width:48px;height:48px;cursor:pointer;border-radius:50%;background-color:var(--secondary-color, #000);border:none}:host .slider__arrow__hidden{pointer-events:none;background-color:transparent!important;overflow:hidden!important;width:.000000002px!important;height:.0000002px!important;border:none}:host .container__hidden{height:.000001px!important;overflow:hidden!important;pointer-events:none!important}:host .slider__arrow-prev{left:-60px;top:40%}:host .slider__arrow-next{right:-60px;top:40%}\n"], components: [{ type: i5$2.Carousel, selector: "p-carousel", inputs: ["page", "numVisible", "numScroll", "responsiveOptions", "orientation", "verticalViewPortHeight", "contentClass", "indicatorsContentClass", "indicatorsContentStyle", "indicatorStyleClass", "indicatorStyle", "value", "circular", "showIndicators", "showNavigators", "autoplayInterval", "style", "styleClass"], outputs: ["onPage"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }], pipes: { "async": i6.AsyncPipe, "translate": TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SubCategorySliderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-sub-category-slider',
                    templateUrl: './sub-category-slider.base-component.html',
                    styleUrls: ['./sub-category-slider.base-component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ShopService }, { type: i2.ActivatedRoute }, { type: i2.Router }, { type: TaxonService }, { type: ConfService }]; } });

class BranchSelectorModalComponent {
    constructor(bsModalRef, contactUsService, languageService, confService) {
        this.bsModalRef = bsModalRef;
        this.contactUsService = contactUsService;
        this.languageService = languageService;
        this.confService = confService;
        this.branches$ = this.contactUsService.getContactDetails().pipe(map(data => data.branches));
        this.requiredMsg = '';
        this.language = {};
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.Ramco = (this.id == 13246) ? true : false;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
    }
    selectBranch() {
        if (!this.selectedBranchId) {
            this.requiredMsg = 'You must select branch';
            return;
        }
        localStorage.setItem('branchId', this.selectedBranchId);
        localStorage.removeItem('cartId');
        localStorage.removeItem('cart-counter');
        this.bsModalRef.hide();
    }
}
BranchSelectorModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BranchSelectorModalComponent, deps: [{ token: i5.BsModalRef }, { token: ContactUsService }, { token: LanguageService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
BranchSelectorModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: BranchSelectorModalComponent, selector: "app-branch-selector-modal", ngImport: i0, template: "<div class=\"popup\">\r\n  <div class=\"header\">\r\n    <div class=\"top\">\r\n      <!-- <svg height=\"48\" viewBox=\"-3 -3 82 82\"\r\n        width=\"48\" style=\"display: block;\">\r\n        <circle cx=\"38\" cy=\"38\" fill=\"white\" r=\"40\"></circle>\r\n        <path\r\n          d=\"M27.5 71c3.3 1 6.7 1.6 10.3 1.6C57 72.6 72.6 57 72.6 37.8 72.6 18.6 57 3 37.8 3 18.6 3 3 18.6 3 37.8c0 14.8 9.3 27.5 22.4 32.5-.3-2.7-.6-7.2 0-10.3l4-17.2s-1-2-1-5.2c0-4.8 3-8.4 6.4-8.4 3 0 4.4 2.2 4.4 5 0 3-2 7.3-3 11.4C35.6 49 38 52 41.5 52c6.2 0 11-6.6 11-16 0-8.3-6-14-14.6-14-9.8 0-15.6 7.3-15.6 15 0 3 1 6 2.6 8 .3.2.3.5.2 1l-1 3.8c0 .6-.4.8-1 .4-4.4-2-7-8.3-7-13.4 0-11 7.8-21 22.8-21 12 0 21.3 8.6 21.3 20 0 12-7.4 21.6-18 21.6-3.4 0-6.7-1.8-7.8-4L32 61.7c-.8 3-3 7-4.5 9.4z\"\r\n          fill=\"#e60023\" fill-rule=\"evenodd\"></path>\r\n      </svg> -->\r\n    </div>\r\n    <div class=\"title\"  >\r\n      <h3 *ngIf=\"!Ramco\">{{language['chooseNearistBranch']}}</h3>\r\n      <h3 *ngIf=\"Ramco\">{{ language['LANGUAGE_CODE'] === 'en_US' ? \"Please select pharmacy \" : \"\u0645\u0646 \u0641\u0636\u0644\u0643 \u0627\u062E\u062A\u0631 \u0635\u064A\u062F\u0644\u064A\u0647\" }}</h3>\r\n    </div>\r\n  </div>\r\n\r\n  <div  class=\"popup-body\"> \r\n    <div class=\"branch-selector \">\r\n      <ng-select class=\"ng-select\" autofocus [selectOnTab]=\"true\" [items]=\"branches$ | async\" bindValue=\"id\" bindLabel=\"translations.en_US.name\"\r\n        placeholder=\"{{language['branch']}}\" class=\"w-75\" [clearable]=\"false\"  [(ngModel)]=\"selectedBranchId\">\r\n      \r\n        <ng-template ng-label-tmp let-item=\"item\">\r\n              <i class=\"fa fa-map-marker\"></i>\r\n              {{\r\n                item.translations[language['LANGUAGE_CODE']].name\r\n              }}\r\n              <!-- {{item.translations.en_US.name}} -->\r\n      </ng-template>\r\n\r\n      <ng-template ng-option-tmp let-item=\"item\">\r\n        {{\r\n          item.translations[language['LANGUAGE_CODE']].name\r\n        }}\r\n    </ng-template>\r\n      \r\n      </ng-select>\r\n      <div class=\"text-danger mt-3\" *ngIf=\"requiredMsg\">{{ requiredMsg }}</div>\r\n    </div>\r\n    \r\n\r\n    <button class=\"save-btn\" (click)= \"selectBranch()\" [disabled]= '!selectedBranchId'>\r\n      {{language['shopNow']}}\r\n    </button>\r\n  </div>\r\n</div>", styles: [":host .popup{background-color:#fff;border-radius:8px;position:relative;text-align:center;margin:auto;min-height:450px;box-shadow:#00000073 0 2px 10px}:host .popup .header{padding:20px 10px 24px}:host .popup .header .top{display:block;height:45px;margin:5px auto 8px;width:45px}:host .popup .header .title{margin:0 22px 18px}:host .popup .header .title h3{color:#000;font-size:36px;font-weight:600;-webkit-font-smoothing:antialiased;letter-spacing:-1.2px}:host .popup-body{position:relative;flex:1 1 auto;padding:2rem;margin-top:20px}:host .popup-body .branch-selector{text-align:left;width:100%;display:flex;justify-content:center;margin-bottom:20px;flex-direction:column;align-items:center}:host .popup-body .save-btn{width:75%;min-height:36px;color:#fff;background:var(--main-color, #000);border:none;border-radius:4px}:host .popup-body .save-btn:disabled{cursor:not-allowed;color:#999;background:#f0f0f0}::ng-deep .modal-backdrop.show{opacity:.9}::ng-deep ng-select .ng-dropdown-panel{overflow:hidden}::ng-deep ng-select i{color:var(--main-color, #000)}::ng-deep ng-select ::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{white-space:pre-wrap!important}\n"], components: [{ type: i5$1.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5$1.ɵh, selector: "[ng-label-tmp]" }, { type: i5$1.ɵf, selector: "[ng-option-tmp]" }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BranchSelectorModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-branch-selector-modal',
                    templateUrl: './branch-selector-modal.component.html',
                    styleUrls: ['./branch-selector-modal.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i5.BsModalRef }, { type: ContactUsService }, { type: LanguageService }, { type: ConfService }]; } });

function tagManager(tagId) {
    const node1 = document.createElement('script');
    const node2 = document.createElement('script');
    const node3 = document.createElement('script');
    const noScriptNode = document.createElement('noscript');
    const noScript = `<iframe src="https://www.googletagmanager.com/ns.html?id=${JSON.parse(tagId)}"
	height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    const script1 = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script','dataLayer',${tagId});`;
    const script2 = `
	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());
	gtag('config', ${tagId});`;
    node1.async = true;
    node1.defer = true;
    node1.innerHTML = script1;
    node2.async = true;
    node2.defer = true;
    node2.innerHTML = script2;
    node3.src = 'https://www.googletagmanager.com/gtag/js?id=' + JSON.parse(tagId);
    document.head.appendChild(node1);
    document.head.appendChild(node3);
    document.head.appendChild(node2);
    noScriptNode.innerHTML = noScript;
    document.body.prepend(noScriptNode);
}
function googleAnalytics(googleAnalyticsId) {
    const node = document.createElement('script');
    node.src = 'https://www.googletagmanager.com/gtag/js?id=' + JSON.parse(googleAnalyticsId);
    const node2 = document.createElement('script');
    node2.innerHTML = `
	window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', ${googleAnalyticsId});
	`;
    node.async = true;
    node.defer = true;
    document.head.appendChild(node);
    document.head.appendChild(node2);
}
function facebookPixel(facebookPixelId) {
    const node = document.createElement('script');
    const node2 = document.createElement('noscript');
    const script = `!function (f, b, e, v, n, t, s) {
		if (f.fbq) return; n = f.fbq = function () {
			n.callMethod ?
				n.callMethod.apply(n, arguments) : n.queue.push(arguments)
		};
		if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
		n.queue = []; t = b.createElement(e); t.async = !0;
		t.src = v; s = b.getElementsByTagName(e)[0];
		s.parentNode.insertBefore(t, s)
	}(window, document, 'script',
		'https://connect.facebook.net/en_US/fbevents.js')`;
    node2.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=' + facebookPixelId + '&ev=PageView&noscript=1"/>';
    node.async = true;
    node.defer = true;
    node.innerHTML = script;
    document.head.appendChild(node);
    document.body.appendChild(node2);
    fbq('init', facebookPixelId);
    fbq('track', 'PageView');
}
function TiktokPixel(TiktokPixelId) {
    const node = document.createElement('script');
    const node2 = document.createElement('noscript');
    console.log(TiktokPixel);
    const script = `!function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};

    ttq.load(${TiktokPixelId});
    ttq.page();
  }(window, document, 'ttq');`;
    node.async = true;
    node.defer = true;
    node.innerHTML = script;
    document.head.appendChild(node);
}

var __awaiter$1 = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class AppBaseComponent {
    constructor(router, quickViewService, confService, titleService, languageService, customThemeService, meta, route, loginService, collectionService, modalService, googleTagManager, facebookPixelService, googleAnalyticsService, appInitService, changeDetector, tiktok) {
        this.router = router;
        this.quickViewService = quickViewService;
        this.confService = confService;
        this.titleService = titleService;
        this.languageService = languageService;
        this.customThemeService = customThemeService;
        this.meta = meta;
        this.route = route;
        this.loginService = loginService;
        this.collectionService = collectionService;
        this.modalService = modalService;
        this.googleTagManager = googleTagManager;
        this.facebookPixelService = facebookPixelService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.appInitService = appInitService;
        this.changeDetector = changeDetector;
        this.tiktok = tiktok;
        this.HideHeaderFooter = false;
        this.isScrolled = false;
        this.quickView = null;
        this.notAvaliableStore$ = this.confService.notAvailableStore;
        this.language = {};
        this.isUnderConstructionStore = this.confService.isUnderConstructionStoreSubject;
        this.storeIsActivated = this.confService.storeIsActivated;
        this.storeEnabledTestOrder = this.confService.storeEnabledTestOrder;
        this.storeIsMultiLocations$ = this.confService.storeIsMultiLocations;
        this.openPopupModal$ = this.confService.openPopupModal;
        this.storeIsExpired$ = this.confService.storeIsExpired;
        this.themeData = this.appInitService.themeDataLoaded;
        this.logged = this.loginService.logged.getValue();
        this.isModalShown = new BehaviorSubject(false);
        this.currentUrl = 'https://uniform-locker.com/store/web/app.php/api/';
        this.titleText = '';
        // if(localStorage.getItem('cleared')==null){
        // 	this.clearAll()
        // 	localStorage.setItem('cleared','true')
        // }
        this.confService.getConf().subscribe((res) => {
            this.logged = this.loginService.logged.getValue();
            // For location-based store
            const selectedBranchId = localStorage.getItem('branchId') || null;
            if (res['multiple_locations'] && !selectedBranchId) {
                this.openSelectBranchPopup();
                /* //stop-auto-detect//
                this.confService.store$.subscribe(
                    (store) => {

                        let allowGeofence = store.allowGeofence;
                        if(!allowGeofence){
                            this.openSelectBranchPopup();
                        }

                    }

                );
                */
            }
            else if (!res['multiple_locations']) {
                localStorage.removeItem('branchId');
            }
            // For MustLogged store
            if (this.router.url.indexOf('/accounts') < 0 && this.router.url.indexOf('/reset-password') < 0) {
                if (res['mustLogged'] && !this.logged) {
                    this.router.navigate(['/accounts/login'], { replaceUrl: true, skipLocationChange: true });
                }
            }
        });
        this.storeSubscription = this.confService.store$.subscribe((store) => {
            // set google anlytics ID & facebook pixel Id
            if (store.googleAnalyticsId && !store.googleTagManagerId) {
                googleAnalytics(JSON.stringify(store.googleAnalyticsId));
            }
            if (store.tiktokPixelId) {
                TiktokPixel(JSON.stringify(store.tiktokPixelId));
            }
            if (store.googleTagManagerId) {
                tagManager(JSON.stringify(store.googleTagManagerId));
            }
            if (store.facebookPixelId && !store.googleTagManagerId) {
                //if (!store.hasFbConversionToken) {
                facebookPixel(store.facebookPixelId);
                //	}
            }
            this.router.events.pipe(filter(event => event instanceof NavigationEnd)).pipe(map((event) => {
                if (this.store.googleTagManagerId) {
                    this.googleTagManager.pageView(event);
                }
                else {
                    if (this.store.facebookPixelId) {
                        this.facebookPixelService.pageView();
                    }
                    if (this.store.googleAnalyticsId) {
                        this.googleAnalyticsService.pageView(event);
                    }
                    if (this.store.tiktokPixelId) {
                        this.tiktok.pageView(event);
                    }
                }
                const route = this.router.url.split('/')[this.router.url.split('/').length - 1] === this.language['LANGUAGE_CODE'] ? 'home' :
                    this.router.url.split('/')[this.router.url.split('/').length - 1];
                return route.includes('?') ? route.split('?')[0].charAt(0).toUpperCase() + route.split('?')[0].substr(1) :
                    route.charAt(0).toUpperCase() + route.split('?')[0].substr(1);
            })).subscribe(event => {
                this.readUrl();
                this.setTitle(event);
                this.router.navigated = false;
                if (this.router.url.indexOf('/collection') > 0) {
                    this.collectionService.hasViewMoreBtn.subscribe(val => {
                        if (!val) {
                            window.scrollTo(0, 0);
                        }
                    });
                }
                if (this.router.url.indexOf('/product') > 0) {
                    window.scrollTo(0, 0);
                }
                if (this.router.url.indexOf('/collection') < 0) {
                    window.scrollTo(0, 0);
                }
            });
            this.store = store;
            if (store.SEOMetaDescription) {
                const keyWords = this.store.SEOMetaDescription.split(' ').toString();
                this.meta.addTags([
                    { name: 'description', content: this.store.SEOMetaDescription },
                    { name: 'keywords', content: keyWords }
                ]);
            }
        });
        const date = 1545148319779;
        const lastModified = +localStorage.getItem('last-modified');
        if (lastModified < date) {
            localStorage.clear();
            localStorage.setItem('last-modified', date.toString());
        }
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            let title = this.router.url.split('/')[this.router.url.split('/').length - 1] === this.language['LANGUAGE_CODE'] ? 'home' :
                this.router.url.split('/')[this.router.url.split('/').length - 1];
            if (this.router.url.indexOf('/reset-password') > -1) {
                title = 'Reset Password';
            }
            else if (this.router.url.indexOf('profile/edit-address/') > -1) {
                title = 'Edit Address';
            }
            else if (this.router.url.indexOf('/we-accept') > -1) {
                title = 'Payment';
            }
            this.setTitle(title.charAt(0).toUpperCase() + title.substr(1));
            this.manifestSubscription = this.confService.getSWManifest().subscribe((res) => {
                const stringManifest = JSON.stringify(res);
                const blob = new Blob([stringManifest], { type: 'application/json' });
                const manifestURL = URL.createObjectURL(blob);
                document.querySelector('#my-manifest-placeholder').setAttribute('href', manifestURL);
            });
        });
    }
    ngOnInit() {
        this.confService.checkLoggedUserToCart();
        this.quickViewService.get().subscribe(product => {
            this.quickView = product;
            if (product) {
                this.staticModal.show();
                this.isModalShown.next(true);
                this.staticModal.onHide.subscribe(() => {
                    this.isModalShown.next(false);
                    this.quickViewService.closeQuickViewVisibility();
                });
            }
        });
        if (this.staticModal) {
            this.modalSubscription = this.staticModal.onHidden.subscribe(() => {
                this.closeQuickView();
            });
        }
        this.readUrl();
        this.storeIsExpired$.pipe(take(2)).subscribe(val => {
            if (val) {
                this.titleService.setTitle('Expired store');
            }
        });
        if (window.location.href.includes('reset-password')) {
            const urlSegments = window.location.href.split('/'); // Split the URL into segments
            const emailIndex = urlSegments.indexOf('reset-password') + 1; // Get the index of 'email' parameter
            const tokenIndex = emailIndex + 1; // Get the index of 'token' parameter
            if (emailIndex < urlSegments.length && tokenIndex < urlSegments.length) {
                const email = urlSegments[emailIndex];
                const token = urlSegments[tokenIndex];
                if (email && token) {
                    this.router.navigate([`/reset-password/${email}/${token}`]);
                }
            }
        }
        if (window.location.href.includes('download')) {
            const numSegments = window.location.href.split('/')[window.location.href.split('/').length - 1];
            const downloadUrl = `ar_EG/download-invoice/${numSegments}`;
            this.router.navigate([downloadUrl]);
        }
    }
    clearAll() {
        return __awaiter$1(this, void 0, void 0, function* () {
            localStorage.clear();
            sessionStorage.clear();
            const cacheKeys = yield caches.keys();
            if ('caches' in window) {
                const cacheNames = yield caches.keys();
                yield Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
            }
        });
    }
    closeQuickView() {
        this.staticModal.hide();
        this.isModalShown.next(false);
        this.quickViewService.closeQuickViewVisibility();
    }
    readUrl() {
        const url = window.location.href.split('/');
        if (url.includes('checkout') || url.includes('accounts') || url.includes('success') || url.includes('download') || url.includes('reset-password') || url.includes('mobile/page/')) {
            this.HideHeaderFooter = true;
        }
        else {
            this.HideHeaderFooter = false;
        }
    }
    setTitle(title) {
        this.storeSubscription = this.confService.store$.subscribe((store) => {
            this.confService.getConf().subscribe((res) => {
                if (res.api_url == this.currentUrl && res.id == 1117) {
                    this.titleText = 'uniformlocker';
                }
                else {
                    this.titleText = store.name;
                }
            });
            if (title === this.language['LANGUAGE_CODE']) {
                this.titleService.setTitle(this.titleText + '| home');
            }
            else if (this.language[title] !== undefined) {
                this.titleService.setTitle(this.titleText + ' | ' + this.language[title]);
            }
            else {
                this.titleService.setTitle(this.titleText + ' | ' + (title.indexOf('?') > -1 ? title.split('?')[0] : title));
            }
        });
    }
    ngOnDestroy() {
        if (this.storeSubscription) {
            this.storeSubscription.unsubscribe();
        }
        if (this.manifestSubscription) {
            this.manifestSubscription.unsubscribe();
        }
        if (this.modalSubscription) {
            this.modalSubscription.unsubscribe();
        }
    }
    // Add host listener when scroll to add class on main tag
    onWindowScroll($event) {
        const number = window.pageYOffset;
        if (number > 0) {
            this.isScrolled = true;
        }
        else if (this.isScrolled && number === 0) {
            this.isScrolled = false;
        }
    }
    ngAfterViewChecked() {
        this.changeDetector.detectChanges();
    }
    openSelectBranchPopup() {
        this.bsModalRef = this.modalService.show(BranchSelectorModalComponent, { animated: true, ignoreBackdropClick: true, keyboard: false, class: 'branch-selector-modal' });
        this.modalService.onHide.subscribe(result => location.reload());
    }
}
AppBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppBaseComponent, deps: [{ token: i2.Router }, { token: QuickViewService }, { token: ConfService }, { token: i3.Title }, { token: LanguageService }, { token: CustomThemeService }, { token: i3.Meta }, { token: i2.ActivatedRoute }, { token: LoginService }, { token: CollectionService }, { token: i5.BsModalService }, { token: GoogleTagManagerService }, { token: FacebookPixelService }, { token: GoogleAnalyticsService }, { token: AppInitService }, { token: i0.ChangeDetectorRef }, { token: TiktokPixelService }], target: i0.ɵɵFactoryTarget.Component });
AppBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: AppBaseComponent, selector: "ng-component", host: { listeners: { "window:scroll": "onWindowScroll($event)" } }, viewQueries: [{ propertyName: "staticModal", first: true, predicate: ["staticModal"], descendants: true }], ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i2.Router }, { type: QuickViewService }, { type: ConfService }, { type: i3.Title }, { type: LanguageService }, { type: CustomThemeService }, { type: i3.Meta }, { type: i2.ActivatedRoute }, { type: LoginService }, { type: CollectionService }, { type: i5.BsModalService }, { type: GoogleTagManagerService }, { type: FacebookPixelService }, { type: GoogleAnalyticsService }, { type: AppInitService }, { type: i0.ChangeDetectorRef }, { type: TiktokPixelService }]; }, propDecorators: { staticModal: [{
                type: ViewChild,
                args: ['staticModal']
            }], onWindowScroll: [{
                type: HostListener,
                args: ['window:scroll', ['$event']]
            }] } });

class AppInterceptor {
    constructor(authService, loaderService) {
        this.authService = authService;
        this.loaderService = loaderService;
    }
    intercept(req, next) {
        this.loaderService.requestBegin();
        return this.authService.setHeaders(req, next).pipe(catchError((error) => {
            this.loaderService.requestEnded();
            return throwError(error);
        }));
    }
}
AppInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppInterceptor, deps: [{ token: AuthService }, { token: LoaderService }], target: i0.ɵɵFactoryTarget.Injectable });
AppInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AuthService }, { type: LoaderService }]; } });

class StoreNotAvailableComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
StoreNotAvailableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StoreNotAvailableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StoreNotAvailableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: StoreNotAvailableComponent, selector: "app-store-not-available", ngImport: i0, template: "<div class=\"store-not-found container d-flex align-items-center justify-content-center\">\r\n  <img alt=\"store not available\" src=\"assets/images/store-not-found.png\">\r\n</div>\r\n", styles: [".store-not-found{height:100vh}@media (max-width: 500px){.store-not-found img{width:100%}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StoreNotAvailableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-store-not-available',
                    templateUrl: './store-not-available.component.html',
                    styleUrls: ['./store-not-available.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

class StaticPageComponent {
    constructor(route, router, staticPagesService, sanitizer, translatePipe, breadcrumbService, languageService, fb, titleService, meta, toastr, contactUsService) {
        this.route = route;
        this.router = router;
        this.staticPagesService = staticPagesService;
        this.sanitizer = sanitizer;
        this.translatePipe = translatePipe;
        this.breadcrumbService = breadcrumbService;
        this.languageService = languageService;
        this.fb = fb;
        this.titleService = titleService;
        this.meta = meta;
        this.toastr = toastr;
        this.contactUsService = contactUsService;
        this.imageUrl = environment.imageUrl;
        this.language = {};
        this.regEx = '^[0-9]+$';
        languageService.getLanguage().subscribe(language => this.language = language);
    }
    ngOnInit() {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scrolling
        this.contactUsForm = this.fb.group({
            name: [null, Validators.required],
            phoneNumber: [null, Validators.compose([
                    Validators.required,
                    Validators.pattern(this.regEx),
                    Validators.min(100000000),
                    Validators.max(100000000000000)
                ])],
            email: [null, [Validators.required, Validators.email]],
            subject: ['', Validators.required],
            message: [null, Validators.required],
            notRobot: [null, Validators.requiredTrue]
        });
        this.route.params.subscribe(params => {
            const code = params.code;
            this.staticPagesService.getPage(code).subscribe((staticPage) => {
                this.breadcrumbService.setCustom([
                    {
                        name: this.translatePipe.transform(staticPage, 'name'),
                        url: {
                            path: ['page', staticPage.code],
                            params: {}
                        }
                    }
                ]);
                this.staticPage = staticPage;
                const content = this.translatePipe.transform(staticPage, 'content');
                this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(content);
                // Add Meta Tags
                if (this.meta.getTag('name="keywords"')) {
                    this.meta.updateTag({ name: 'keywords', content: this.translatePipe.transform(staticPage, 'meta_keywords') });
                }
                else {
                    this.meta.addTag({ name: 'keywords', content: this.translatePipe.transform(staticPage, 'meta_keywords') });
                }
                if (this.meta.getTag('name="description"')) {
                    this.meta.updateTag({ name: 'description', content: this.translatePipe.transform(staticPage, 'meta_description') });
                }
                else {
                    this.meta.addTag({ name: 'description', content: this.translatePipe.transform(staticPage, 'meta_description') });
                }
            }, () => {
                this.router.navigate(['/notFound'], { replaceUrl: true });
            });
        });
    }
    submitContactUs() {
        const body = {
            name: this.contactUsForm.value.name,
            phoneNumber: this.contactUsForm.value.phoneNumber,
            email: this.contactUsForm.value.email,
            subject: this.contactUsForm.value.subject,
            message: this.contactUsForm.value.message,
        };
        this.contactUsService.sendContactUs(body).subscribe((res) => {
            this.toastr.success(res.response);
            this.contactUsForm.reset();
        }, () => {
            this.toastr.error(`${this.language['sorrySomethingWentWrong']}`);
        });
    }
    ngOnDestroy() {
        this.breadcrumbService.setCustom([]);
    }
}
StaticPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StaticPageComponent, deps: [{ token: i2.ActivatedRoute }, { token: i2.Router }, { token: StaticPagesService }, { token: i3.DomSanitizer }, { token: TranslatePipe }, { token: BreadcrumbService }, { token: LanguageService }, { token: i1$1.FormBuilder }, { token: i3.Title }, { token: i3.Meta }, { token: i3$1.ToastrService }, { token: ContactUsService }], target: i0.ɵɵFactoryTarget.Component });
StaticPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: StaticPageComponent, selector: "app-static-page", providers: [TranslatePipe], ngImport: i0, template: "<div class=\"container my-5\" *ngIf=\"staticPage\">\r\n  <!--<h1>{{staticPage | translate: 'name'}}</h1>-->\r\n  <!--<img [src]=\"imageUrl + staticPage.image.path\" class=\"img-fluid\">-->\r\n  <div class=\"innerContent\" [innerHTML]=\"htmlContent\"></div>\r\n  <!--start contact us-->\r\n  <ng-template [ngIf]=\"staticPage.code == 'findus'\">\r\n    <section class=\"contact-wrapper pt-3 pt-md-5 pb-3 pb-md-5 pl-2 pl-md-0 pr-2 pr-md-0\">\r\n      <div class=\"container\">\r\n        <div [formGroup]=\"contactUsForm\" class=\"row messages bg-color mt-4\">\r\n\r\n          <!--start section tittle-->\r\n          <div class=\"col-12 mb-4 pt-4\">\r\n            <h1 class=\"text-capitalize h1--custom\">{{language['message-us']}}</h1>\r\n          </div>\r\n          <!--end section tittle-->\r\n\r\n          <!--start details section-->\r\n          <div class=\"col-12 col-md-6 inputs-section pb-3\">\r\n            <!-- start form -->\r\n            <!--first name-->\r\n            <div class=\"form-group\">\r\n              <label class=\"text-capitalize\">{{language['firstName']}}*</label>\r\n              <input class=\"form-control\" formControlName=\"name\">\r\n            </div>\r\n            <!--phone number-->\r\n            <div class=\"form-group\">\r\n              <label class=\"text-capitalize\">{{language['phone_number']}}*</label>\r\n              <input class=\"form-control remove-default\" type=\"number\" formControlName=\"phoneNumber\" autocomplete=\"true\">\r\n              <p class=\"alert alert-danger mt-4\" *ngIf=\"contactUsForm.get('phoneNumber').errors?.min || contactUsForm.get('phoneNumber').errors?.max\">Phone number must be between 9 and 14</p>\r\n            </div>\r\n            <!--email-->\r\n            <div class=\"form-group\">\r\n              <label class=\"text-capitalize\">{{language['email']}}*</label>\r\n              <input class=\"form-control\" type=\"email\" formControlName=\"email\" autocomplete=\"true\">\r\n            </div>\r\n            <!--subject-->\r\n            <div class=\"form-group\">\r\n              <label class=\"text-capitalize\">{{language['subject']}}*</label>\r\n              <select class=\"form-control\" title=\"{{language['subject']}}\" formControlName=\"subject\">\r\n                <option value=\"\">{{language['chooseSubject']}}</option>\r\n                <option>{{language['general']}}</option>\r\n                <option>{{language['feedback']}}</option>\r\n                <option>{{language['enquiry']}}</option>\r\n                <option>{{language['complaint']}}</option>\r\n              </select>\r\n            </div>\r\n            <!-- end form -->\r\n          </div>\r\n          <!--end details section-->\r\n\r\n          <!--start area section-->\r\n          <div class=\"col-12 col-md-6 txt-area\">\r\n\r\n            <!--start text-area section-->\r\n            <div class=\"form-group ml-md-3 mr-3\">\r\n              <label class=\"text-capitalize\">{{language['message-content']}}</label>\r\n              <textarea class=\"form-control\" placeholder=\"{{language['message']}}\" formControlName=\"message\"></textarea>\r\n            </div>\r\n            <!--end text-area section-->\r\n\r\n            <!--start submit section-->\r\n            <div class=\"d-flex justify-content-between mr-3 ml-3\">\r\n              <!--start checkbox-->\r\n              <div class=\"form-group submit--input mr-3\">\r\n                <label class=\"d-flex align-items-center mb-0\">\r\n                  <input type=\"checkbox\" class=\"mr-2 ml-3\" formControlName=\"notRobot\">\r\n                  <span>{{language['i-am-not-a-robot']}}</span>\r\n                </label>\r\n              </div>\r\n              <!--end checkbox-->\r\n\r\n              <!--start submit button-->\r\n              <div class=\"form-group\">\r\n                <button type=\"submit\" (click)=\"submitContactUs()\" class=\"btn btn--submit\" [disabled]=\"contactUsForm.invalid\"\r\n                [ngClass]=\"{'disabled': !contactUsForm.valid}\"\r\n                >\r\n                  {{language['send']}}\r\n                </button>\r\n              </div>\r\n              <!--end submit button-->\r\n            </div>\r\n            <!--end submit section-->\r\n          </div>\r\n          <!--start area section-->\r\n\r\n        </div>\r\n        <!--end message-us section-->\r\n      </div>\r\n      <!--end container-->\r\n    </section>\r\n  </ng-template>\r\n</div>\r\n", styles: [".innerContent{word-break:break-word}.btn--submit{background-color:#59bfb8;padding:15px 30px;font-size:15px;color:#fff;text-transform:capitalize}.disabled{cursor:not-allowed}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i1$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StaticPageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-static-page',
                    templateUrl: './static-page.component.html',
                    styleUrls: ['./static-page.component.scss'],
                    providers: [TranslatePipe]
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: i2.Router }, { type: StaticPagesService }, { type: i3.DomSanitizer }, { type: TranslatePipe }, { type: BreadcrumbService }, { type: LanguageService }, { type: i1$1.FormBuilder }, { type: i3.Title }, { type: i3.Meta }, { type: i3$1.ToastrService }, { type: ContactUsService }]; } });

class VerifyAccountComponent {
    constructor(activatedRoute, router, _updataUserInfoService, languageService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this._updataUserInfoService = _updataUserInfoService;
        this.languageService = languageService;
        this.language = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        this.activatedRoute.params.subscribe(params => {
            this.token = params['token'];
            this.email = params['email'];
            this._updataUserInfoService.verifyVerificationToken(this.email, this.token)
                .subscribe(() => {
                this.success = this.language['EmailSuccessfullyVerified'];
            }, (err) => {
                this.error = err.error.message;
            });
        });
    }
}
VerifyAccountComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VerifyAccountComponent, deps: [{ token: i2.ActivatedRoute }, { token: i2.Router }, { token: PersonalInfoService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
VerifyAccountComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: VerifyAccountComponent, selector: "app-verify-account", ngImport: i0, template: "<div class=\"msg\">\r\n  <p *ngIf=\"error\" class=\"error\">{{error}} <a routerLink=\"/collection\"><br>{{language['backToWebsite']}}</a></p>\r\n  <p *ngIf=\"success\" class=\"success\">{{success}} <a routerLink=\"/collection\"><br>{{language['backToWebsite']}}</a></p>\r\n</div>\r\n", styles: [".msg{background:transparent;position:relative;min-height:400px;display:flex;align-items:center;justify-content:center;padding:20px}.msg p{background:#fff;padding:20px 40px;border-radius:15px;box-shadow:0 2px 2px -2px;font-size:2em}.msg p a{font-weight:600;color:var(--main-color, orange)}.msg p a:hover{text-decoration:none}.msg .error{color:#dd5347}.msg .success{color:green}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VerifyAccountComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-verify-account',
                    templateUrl: './verify-account.component.html',
                    styleUrls: ['./verify-account.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: i2.Router }, { type: PersonalInfoService }, { type: LanguageService }]; } });

class WeAcceptComponent {
    constructor(activatedRoute, weAcceptService, cartService, languageService) {
        this.activatedRoute = activatedRoute;
        this.weAcceptService = weAcceptService;
        this.cartService = cartService;
        this.languageService = languageService;
        this.language = {};
        this.loading = true;
    }
    ngOnInit() {
        ;
        this.languageService.getLanguage().subscribe(lanuage => this.language = lanuage);
        ;
        this.activatedRoute.queryParams.subscribe(params => {
            this.params = params;
            this.orderId = params.merchant_order_id.indexOf('_') > -1 ? params.merchant_order_id.split('_')[0] : params.merchant_order_id;
            this.weAcceptSuccess = params.success == 'true';
            ;
            console.log(params);
            this.weAcceptService.weAccept(params).subscribe(res => {
                console.log(res);
                let data = res;
                localStorage.setItem('orderNumber', data === null || data === void 0 ? void 0 : data.orderNumber);
                this.loading = false;
                this.syliusSuccess = true;
                this.cartService.emptyCartLastStepWeAccept('', params['amount_cents'], params['currency']);
            }, err => {
                this.syliusSuccess = false;
                this.loading = false;
                console.log(err);
                if (this.weAcceptSuccess) {
                    this.cartService.checkoutCompleted();
                }
            });
        });
        ;
    }
}
WeAcceptComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WeAcceptComponent, deps: [{ token: i2.ActivatedRoute }, { token: WeAcceptService }, { token: CartService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
WeAcceptComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: WeAcceptComponent, selector: "app-we-accept", ngImport: i0, template: "<div *ngIf=\"loading; else showContent\">\r\n    <app-inner-loading></app-inner-loading>\r\n</div>\r\n<ng-template #showContent>\r\n    <h1 class=\"payment-message\">\r\n        <span>{{language['paymentStatus']}}</span>\r\n        <span *ngIf=\"syliusSuccess\" class=\"approved\"> {{language['approved']}} <img src=\"assets/checkoutSteps/ok-sign.png\"></span>\r\n        <span *ngIf=\"!syliusSuccess\" class=\"declined\"> {{language['declined']}}  <img src=\"assets/checkoutSteps/false-sign.png\"></span>\r\n    </h1>\r\n    <h3 >{{language['yourOrderNumberIs']}} {{orderId}}</h3>\r\n    <h4 >{{language['orderSuccess']}}</h4>\r\n    <h3 *ngIf=\"!syliusSuccess && weAcceptSuccess\">\r\n        An error has occured, please save the following info : <br> [ Transaction Id : {{params['id']}} - CartId : {{orderId}} ] <br> and Contact us immediately <a routerLink=\"/contact-us\">Contact us</a>\r\n    </h3>\r\n    <h4 *ngIf=\"!weAcceptSuccess\">{{language['click']}} <a [routerLink]=\"['/checkout', 'payment']\">{{language['here']}}</a> {{language['backToPayment']}} </h4>\r\n</ng-template>", styles: [".declined{color:red}.approved{color:green}img{height:60px;width:auto}h1,h3,h4{text-align:center}a{color:#00f}.payment-message{font-size:40px}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WeAcceptComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-we-accept',
                    templateUrl: './we-accept.component.html',
                    styleUrls: ['./we-accept.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: WeAcceptService }, { type: CartService }, { type: LanguageService }]; } });

class CheckoutSuccessComponent {
    constructor(confService, cartService, router, languageService, checkoutService, activeRoute, analyticsService, tagManagerService, tiktok) {
        this.confService = confService;
        this.cartService = cartService;
        this.router = router;
        this.languageService = languageService;
        this.checkoutService = checkoutService;
        this.activeRoute = activeRoute;
        this.analyticsService = analyticsService;
        this.tagManagerService = tagManagerService;
        this.tiktok = tiktok;
        this.language = {};
        this.isWeAccept = false;
        this.showInvoice = true;
        this.orderTextCheckout = '';
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                localStorage.removeItem('stepFour');
            }
        });
    }
    ngOnInit() {
        var _a;
        this.showInvoice = JSON.parse(localStorage.getItem('showInvoiceAfterBuy'));
        this.orderTextCheckout = localStorage.getItem('orderTextCheckout');
        this.activeRoute.paramMap.pipe(switchMap((params) => of(params.get('id')))).subscribe(orderId => {
            this.orderId = +orderId;
            if (this.orderId) {
                this.checkoutService.getOrder(this.orderId).subscribe(response => {
                    this.analyticsService.placeOrder(response);
                    this.tiktok.placeOrder(response);
                    // this.tagManagerService.purchaseEventEmitter(response.items, response.number, response.total, response.currencyCode);
                });
            }
        });
        this.activeRoute.queryParamMap.pipe(switchMap((params) => of(params.get('we-accept')))).subscribe(isWeAccept => {
            if (isWeAccept === 'true') {
                this.isWeAccept = true;
            }
        });
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.cartService.getOrderData().subscribe(data => {
            this.successMessage = data;
        });
        this.logo$ = this.confService.logo$;
        if (localStorage.getItem('orderNumber')) {
            this.orderNumber = localStorage.getItem('orderNumber');
        }
        else {
            this.orderNumber = (_a = this.successMessage) === null || _a === void 0 ? void 0 : _a.orderNumber;
        }
    }
    downloadInvoce() {
        localStorage.setItem('downloadInvoice', 'true');
        this.download(this.orderId);
        //  this.router.navigate([`/${this.language['LANGUAGE_CODE']}/download-invoice`, this.orderId]);
    }
    backToHomePage() {
        this.router.navigateByUrl(`/${this.language['LANGUAGE_CODE']}`);
    }
    download(orderId) {
        this.checkoutService
            .downloadInvoice(`${location.origin}/store/web/app.php/admin/import_export/invoice/${orderId}`)
            // for testing in localhost origin --> .download("https://n5.zvendo.dev/store/web/app.php/admin/import_export/invoice/1244")
            .subscribe(blob => {
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = `Invoice-${orderId}.pdf`;
            a.click();
            URL.revokeObjectURL(objectUrl);
        });
    }
}
CheckoutSuccessComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutSuccessComponent, deps: [{ token: ConfService }, { token: CartService }, { token: i2.Router }, { token: LanguageService }, { token: CheckoutService }, { token: i2.ActivatedRoute }, { token: GoogleAnalyticsService }, { token: GoogleTagManagerService }, { token: TiktokPixelService }], target: i0.ɵɵFactoryTarget.Component });
CheckoutSuccessComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CheckoutSuccessComponent, selector: "app-checkout-success", ngImport: i0, template: "<div class=\"order__placed__successfully\">\r\n  <div class=\"text-box\">\r\n    <!-- <div class=\"logo\">\r\n            <a [routerLink]=\"['/', language['LANGUAGE_CODE']]\">\r\n                <img [src]=\"logo$ | async\">\r\n            </a>\r\n        </div> -->\r\n    <h1 class=\"title\">{{language['thankYouForShoppingWithUs']}} </h1>\r\n    <p class=\"order\"> {{language['checkoutSuccess']}}</p>\r\n\r\n    <p *ngIf=\"isWeAccept\" class=\"isWeAccept\">\r\n      <span>{{language['paymentStatus']}}</span>\r\n      <span class=\"approved\"> {{language['approved']}} <img src=\"assets/checkoutSteps/ok-sign.png\"></span>\r\n    </p>\r\n    <p  class=\"order__number\">{{language['order_number']}}:\r\n      <span class=\"order_id\">{{orderNumber}}</span>\r\n    </p>\r\n    <p class=\"order\">{{orderTextCheckout}}</p>\r\n    <div class=\"order__success__btns\">\r\n      <a *ngIf=\"showInvoice\" (click)=\"downloadInvoce()\">{{language['downloadInvoice']}}</a>\r\n      <a (click)=\"backToHomePage()\"> {{ language['backToWebsite'] }}</a>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".order__placed__successfully{display:block;position:relative;height:100vh}.order__placed__successfully .text-box{background-color:#fff;position:absolute;top:50%;left:50%;width:80%;padding:50px 30px;border-radius:10px;text-align:center;transform:translate(-50%,-50%);box-shadow:0 0 10px #0000001a}.order__placed__successfully .text-box .logo{display:flex;align-items:center;justify-content:center;height:80px;margin-bottom:3rem}.order__placed__successfully .text-box .logo a{display:block}.order__placed__successfully .text-box .logo img{max-width:100%;max-height:100%}.order__placed__successfully .text-box .title{font-size:2.5rem;font-weight:700;color:#2d3546;text-transform:capitalize}.order__placed__successfully .text-box .order{font-size:3.2rem;color:#2d3546;margin-bottom:40px}.order__placed__successfully .text-box .order__number{font-size:3.2rem;font-weight:600;text-transform:capitalize;margin-bottom:5rem}.order__placed__successfully .text-box .order__number .order_id{color:#09f}.order__placed__successfully .text-box .order__success__btns{position:relative;display:flex;align-items:center;justify-content:center;margin-bottom:2rem}.order__placed__successfully .text-box .order__success__btns a{display:block;font-size:18px;font-weight:700;cursor:pointer;background:#00a651;margin:0 1rem;color:#fff;padding:7px 45px;border-radius:10px}.order__placed__successfully .text-box .order__success__btns a:hover{text-decoration:none}.order__placed__successfully .isWeAccept{font-size:20px}.order__placed__successfully .approved{color:green}.order__placed__successfully .approved img{height:auto;width:60px}@media all and (max-width: 776.98px){.order__placed__successfully .text-box{padding:30px 10px}.order__placed__successfully .text-box .title{font-size:2.9rem}.order__placed__successfully .text-box .order{font-size:2.2rem;margin-bottom:15px}.order__placed__successfully .text-box .order__number{font-size:2.2rem;margin-bottom:20px}.order__placed__successfully .text-box .order__success__btns{flex-wrap:wrap;margin-bottom:1rem}.order__placed__successfully .text-box .order__success__btns a{margin-bottom:1rem}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutSuccessComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-checkout-success',
                    templateUrl: './checkout-success.component.html',
                    styleUrls: ['./checkout-success.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: ConfService }, { type: CartService }, { type: i2.Router }, { type: LanguageService }, { type: CheckoutService }, { type: i2.ActivatedRoute }, { type: GoogleAnalyticsService }, { type: GoogleTagManagerService }, { type: TiktokPixelService }]; } });

const routerSildeStateTrigger = trigger('routerSildeState', [
    transition(':enter', [
        style({
            transform: 'translateX(-100%)',
            opacity: 0,
            transition: 'transform 1s ease-in'
        }),
        animate('300ms')
    ]),
    transition(':leave', animate('300ms', style({
        transform: 'translateX(100%)',
        opacity: 1,
        transition: 'transform 1s ease-in'
    })))
]);
const showAndHideElementAnimation = trigger('hideShowAnimator', [
    state('true', style({ opacity: 1 })),
    state('false', style({ opacity: 0 })),
    transition('0 => 1', animate('.5s')),
    transition('1 => 0', animate('.9s'))
]);

class CheckoutSpinnerComponent {
    constructor() { }
    ngOnInit() {
    }
}
CheckoutSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CheckoutSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CheckoutSpinnerComponent, selector: "app-checkout-spinner", ngImport: i0, template: "<div class=\"lds-ring\">\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n</div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutSpinnerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-checkout-spinner',
                    templateUrl: './checkout-spinner.component.html',
                    styleUrls: ['./checkout-spinner.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

class RadioButtonsComponent {
    constructor(languageService, confService, checkoutService) {
        this.languageService = languageService;
        this.confService = confService;
        this.checkoutService = checkoutService;
        this.selectMethod = new EventEmitter();
        this.storeIsActivated = this.confService.storeIsActivated;
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.storeid = this.confService.getMustLogged().subscribe((data) => {
            this.maxAllowedCodAmount = data.response.maxAllowedCodAmount / 100;
            console.log(this.maxAllowedCodAmount);
        });
        this.cart = this.checkoutService.getCart().subscribe((data) => {
            this.cartTotal = data.total / 100;
            console.log(this.cartTotal);
        });
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.methods.forEach(element => {
            if (element && element.description) {
                element.descriptions = element.description.split("\n");
            }
        });
    }
    sendSelectedMethod(method) {
        this.selectMethod.emit(method);
    }
}
RadioButtonsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RadioButtonsComponent, deps: [{ token: LanguageService }, { token: ConfService }, { token: CheckoutService }], target: i0.ɵɵFactoryTarget.Component });
RadioButtonsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: RadioButtonsComponent, selector: "app-radio-buttons", inputs: { methods: "methods", readSelectedMethod: "readSelectedMethod", methodKey: "methodKey" }, outputs: { selectMethod: "selectMethod" }, ngImport: i0, template: "<div class=\"shipping\" *ngFor=\"let method of methods; let i = index\">\r\n  <div class=\"shipping__options\">\r\n    <input\r\n    id=\"{{method.code}}\"\r\n    name=\"radio-group\"\r\n    type=\"radio\"\r\n    [value]='method.code'\r\n    (change)=\"sendSelectedMethod(method)\"\r\n    [disabled]=\"(method.type == 'we-accept' || method.type== 'upg') && !(storeIsActivated | async)\"\r\n    [checked]=\"i == 0\"\r\n    >\r\n    <label for=\"{{method.code}}\">\r\n      <span>{{ method.name }}</span>\r\n    </label>\r\n    <p *ngFor=\"let description of method.descriptions; let d = index\"  class=\"shipping__desc\">\r\n      {{description}}\r\n    </p>\r\n    \r\n    <!-- <p  *ngIf=\"method.description\"  class=\"shipping__desc\">\r\n      {{method.description}}\r\n    </p> -->\r\n    <p  *ngIf=\"method.price\"   class=\"shipping__desc\">\r\n      {{method.price / 100 | currency : currencyCode}}\r\n    </p>\r\n  </div>\r\n \r\n</div>", styles: ["@charset \"UTF-8\";:host .shipping{display:block;flex-wrap:wrap;font-size:14px;padding-left:10px;margin-bottom:15px}[dir=rtl] :host .shipping{padding-left:0;padding-right:10px}:host .shipping:last-child{margin-bottom:3rem}:host .shipping .shipping__price{margin-left:auto;padding-left:27px}[dir=rtl] :host .shipping .shipping__price{margin-right:auto;margin-left:initial;padding-left:0;padding-right:27px}:host .shipping .shipping__desc{color:#897a7a;margin-left:auto;padding-left:27px;margin-bottom:0}[dir=rtl] :host .shipping .shipping__desc{margin-right:auto;margin-left:initial;padding-left:0;padding-right:27px}:host [type=radio]:checked,:host [type=radio]:not(:checked){position:absolute;left:-9999px}[dir=rtl] :host [type=radio]:checked,[dir=rtl] :host [type=radio]:not(:checked){left:auto;right:-9999px}:host [type=radio]:checked+label,:host [type=radio]:not(:checked)+label{position:relative;padding-left:30px;margin-bottom:0;font-size:1.6rem;cursor:pointer}[dir=rtl] :host [type=radio]:checked+label,[dir=rtl] :host [type=radio]:not(:checked)+label{padding-right:30px;padding-left:0}:host [type=radio]:disabled+label{cursor:not-allowed}:host [type=radio]:checked+label:before,:host [type=radio]:not(:checked)+label:before{content:\"\";position:absolute;left:0;top:1px;width:20px;height:20px;border:1px solid #ddd;border-radius:100%;background:#fff}[dir=rtl] :host [type=radio]:checked+label:before,[dir=rtl] :host [type=radio]:not(:checked)+label:before{right:0;left:auto}:host [type=radio]:checked+label:after,:host [type=radio]:not(:checked)+label:after{content:\"\\f00c\";position:absolute;top:1px;left:0px;width:20px;height:20px;line-height:20px;text-align:center;padding-top:1px;background:#0099ff;font-family:\"FontAwesome\";color:#fff;border-radius:100%;font-size:13px}[dir=rtl] :host [type=radio]:checked+label:after,[dir=rtl] :host [type=radio]:not(:checked)+label:after{right:0px;left:auto}:host [type=radio]:not(:checked)+label:after{opacity:0;transform:scale(0)}:host [type=radio]:checked+label:after{opacity:1;transform:scale(1)}\n"], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i6.AsyncPipe, "currency": i6.CurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RadioButtonsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-radio-buttons',
                    templateUrl: './radio-buttons.component.html',
                    styleUrls: ['./radio-buttons.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ConfService }, { type: CheckoutService }]; }, propDecorators: { methods: [{
                type: Input
            }], selectMethod: [{
                type: Output
            }], readSelectedMethod: [{
                type: Input
            }], methodKey: [{
                type: Input
            }] } });

window['bank'] = '';
window['upd-bank'] = '';
class PaymentComponent {
    constructor(languageService, checkoutService, router, completeGuard, _formBuilder, domSanitizer, title, weAcceptSrevice, cartService, confService, toastr, http) {
        this.languageService = languageService;
        this.checkoutService = checkoutService;
        this.router = router;
        this.completeGuard = completeGuard;
        this._formBuilder = _formBuilder;
        this.domSanitizer = domSanitizer;
        this.title = title;
        this.weAcceptSrevice = weAcceptSrevice;
        this.cartService = cartService;
        this.confService = confService;
        this.toastr = toastr;
        this.http = http;
        this.payFortPaymentMethodForm = {};
        this.language = {};
        this.loading = true;
        this.cartItemsSummary = {};
        this.adjustments = [];
        this.showCreditCard = false;
        this.loadingSummary = true;
        this.noPaymentMethodFound = false;
        this.notWeAccept = true;
        this.notkashier = true;
        this.showKashier = false;
        this.notCOD = false;
        this.lastMethod = 1;
        this.itemUnAvaliable = false;
        this.canPlaceOrder = false;
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.showContent = this.id == 12849 ? true : false;
    }
    ngOnInit() {
        this.loadUpg();
        this.errMsg = this.checkoutService.errorMsgPayFort.getValue();
        this.storeIsActivated = this.confService.storeIsActivated;
        this.storeEnabledTestOrder = this.confService.storeEnabledTestOrder;
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.confService.getDefaultCurrency().subscribe(conf => {
            this.defaultCurrency = conf;
        });
        this.checkoutService.getCheckoutData()
            .subscribe((data) => {
            for (const item of data['items']) {
                if (!item.variant.stockCheck) {
                    this.itemUnAvaliable = true;
                }
            }
            this.orders = data;
            this.shippingAddress = data.shippingAddress;
        });
        this.checkoutService.nagivateTop();
        this.creditCard = this._formBuilder.group({
            card_number: ['4987654321098769', Validators.required],
            card_holdername: ['Test Account', Validators.required],
            card_expiry_mm: ['05', Validators.required],
            card_expiry_yy: ['21', Validators.required],
            card_cvn: ['123', Validators.required],
            subtype: ['CARD', Validators.required],
        });
        this.title.setTitle('#Checkout Payment');
        this.contact = new FormGroup({
            payment: new FormControl(null, [Validators.required])
        });
        this.checkoutService.getPaymentsMethodsFromApi().pipe(first(), map(paymentMethod => this.mapPaymentMethods(paymentMethod)), tap(paymentMethods => {
            this.loading = true;
            this.paymentMethods = paymentMethods;
            this.stopSpinner();
            if (this.paymentMethods.length >= 0) {
                this.getSelectedPayment = paymentMethods[0];
                this.sendSelectedPayment(paymentMethods[0]);
            }
        })).subscribe();
        this.logo$ = this.confService.logo$;
    }
    /**
     * @param paymentMethod payment method api response
     * @return payment Methods
     */
    mapPaymentMethods(paymentMethod) {
        if (paymentMethod['payments']) {
            return paymentMethod['payments'][0]['methods'];
        }
        else {
            return paymentMethod = [];
        }
    }
    /**
     * Represents we accept payment get the token that will be sent to display the data that will be displayed in the iframe.
     * also it will toggle the div that display the iframe for we accept based on the state
     * @returns we accept token
     */
    canAccessNextStep() {
        localStorage.setItem('stepFour', 'stepFour');
        this.cartService.emptyCartLastStep('', this.orders['total'], this.orders['currencyCode']);
    }
    canNotAccessNextStep() {
        localStorage.setItem('stepThree', 'false');
        this.completeGuard.completeStateBehavior.next(false);
    }
    backToShippingAddress() {
        this.router.navigateByUrl(`${this.language['LANGUAGE_CODE']}/checkout/mydetails`);
    }
    backToShippingMethods() {
        this.router.navigateByUrl(`${this.language['LANGUAGE_CODE']}/checkout/shipping`);
    }
    sendSelectedPayment(method) {
        this.getSelectedPayment = method;
        if (this.getSelectedPayment.type !== 'offline') {
            this.canPlaceOrder = false;
        }
        else {
            this.canPlaceOrder = true;
        }
        this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(res => {
            this.checkoutService.getFullyCheckoutData()
                .subscribe((data) => {
                for (const item of data['items']) {
                    if (!item.variant.stockCheck) {
                        this.itemUnAvaliable = true;
                    }
                }
                this.orders = data;
                this.shippingAddress = data.shippingAddress;
            });
        });
    }
    /**
     * Represents the spinner state to be false if the data loaded
     * @returns false to stop the spinner
     */
    stopSpinner() {
        if (this.paymentMethods.length > 0) {
            this.loading = false;
            this.noPaymentMethodFound = true;
        }
        else {
            this.loading = false;
            this.noPaymentMethodFound = false;
        }
    }
    /**
     * Represents we accept payment get the token that will be sent to display the data that will be displayed in the iframe.
     * also it will toggle the div that display the iframe for we accept based on the state
     * @returns we accept token
     */
    handlePayment() {
        if (this.contact.controls['payment'].value !== 'we-accept') {
            this.isSelectPaymentMethod(this.getSelectedPayment.code);
        }
    }
    isSelectPaymentMethod(evt) {
        this.checkoutService.selectPaymentMethod(evt, true).subscribe(data => {
            if (data['status'] === 204) {
                this.canAccessNextStep();
            }
            else {
                this.canNotAccessNextStep();
            }
        });
    }
    /**
     * Represents we accept payment get the token that will be sent to display the data that will be displayed in the iframe.
     * also it will toggle the div that display the iframe for we accept based on the state
     * @returns we accept token
     */
    selectPaymentMethod() {
        this.canPlaceOrder = true;
        if (this.getSelectedPayment.type !== 'offline') {
            this.notCOD = true;
        }
        if (this.getSelectedPayment.type === 'offline') {
            this.notWeAccept = true;
            this.showCreditCard = false;
            this.notCOD = false;
        }
        if (this.getSelectedPayment.type === 'we-accept') {
            this.notWeAccept = false;
            this.weAcceptSrevice
                .getOrderToken(this.getSelectedPayment.code)
                .subscribe(data => {
                if (data) {
                    window.location.href = data;
                }
                // this.iframeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
                // 	`https://accept.paymobsolutions.com/api/acceptance/iframes/${iframeId}?payment_token=` + data
                // );
                //this.showCreditCard = true;
            });
        }
        if (this.getSelectedPayment.type === 'upg') {
            this.loading = true;
            this.notWeAccept = true;
            this.showCreditCard = false;
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(response => {
                if (response['body']['configurations']) {
                    if (response['body']['configurations']['bank-type'] === 'QNB') {
                        window['upg-bank'] = 'QNB';
                        this.callLightbox(response['body']['configurations']);
                    }
                    else if (response['body']['configurations']['bank-type'] === 'MISR') {
                        window['upg-bank'] = 'MISR';
                        this.callUpg(response['body']['configurations']);
                    }
                    else if (response['body']['configurations']['bank-type'] === 'AAIB') {
                        window['upg-bank'] = 'AAIB';
                        this.callPaySky(response['body']['configurations']);
                    }
                }
            });
        }
        if (this.getSelectedPayment.type === 'payfort') {
            this.loading = true;
            this.notWeAccept = true;
            this.showCreditCard = false;
            this.payFortPaymentMethodForm = [];
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(response => {
                this.payFortPaymentMethodForm = response.body['configurations'];
                setTimeout(() => {
                    this.payFortForm.nativeElement.submit();
                }, 500);
            }, err => {
                this.loading = false;
                this.errorFromReq = true;
            });
        }
        if (this.getSelectedPayment.type === 'bank-misr') {
            this.loading = true;
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(response => {
                if (response['body']['configurations']) {
                    window['bank'] = 'bank-misr';
                    this.callMpgEg(response['body']['configurations']);
                    this.mpgsMisrData = response['body']['configurations'];
                }
            }, (error) => {
                this.toastr.error(this.language['sorrySomethingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            });
        }
        if (this.getSelectedPayment.type === 'paytabs') {
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe((response) => {
                const url = response['body']['configurations']['payment_url'];
                if (url) {
                    window.location.href = url;
                }
                else {
                    return;
                }
            });
        }
        if (this.getSelectedPayment.type === 'cashcall') {
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe((response) => {
                const url = response['body']['configurations']['returnUrl'];
                if (url) {
                    window.location.href = url;
                }
                else {
                    return;
                }
            });
        }
        if (this.getSelectedPayment.type === 'stripe') {
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe((response) => {
                const url = response['body']['configurations']['stripe_url'];
                if (url) {
                    window.location.href = url;
                }
                else {
                    return;
                }
            });
        }
        if (this.getSelectedPayment.type === 'opay') {
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe((response) => {
                const url = response['body']['configurations']['payment_url'];
                if (url) {
                    window.location.href = url;
                }
                else {
                    return;
                }
            });
        }
        if (this.getSelectedPayment.type === 'fawryPay') {
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe((response) => {
                const url = response['body']['configurations']['payment_url'];
                if (url) {
                    window.location.href = url;
                }
                else {
                    return;
                }
            });
        }
        if (this.getSelectedPayment.type === 'bank-qnb') {
            this.loading = true;
            this.notWeAccept = true;
            this.showCreditCard = false;
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(response => {
                if (response['body']['configurations']) {
                    window['bank'] = 'bank-qnb';
                    this.callMpgQNB(response['body']['configurations']);
                    this.mpgsQNBData = response['body']['configurations'];
                }
            }, (error) => {
                this.toastr.error(this.language['sorrySomethingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            });
        }
        // if (this.getSelectedPayment.type === 'bank-aaib') {
        // 	this.loading = true;
        // 	this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code).subscribe(res => {
        // 		if (res['body']['configurations']) {
        // 			window['bank'] = 'bank-aaib';
        // 			this.aaibData = res['body']['configurations'];
        // 			this.callMpgAAIB(this.aaibData);
        // 		}
        // 	}, (error) => {
        // 		this.toastr.error(
        // 			this.language['sorrySomethingWentWrong'],
        // 			`${this.language['error']}!`,
        // 			{ enableHtml: true, closeButton: true }
        // 		);
        // 	});
        // }
        /** New Aaib Bank**/
        if (this.getSelectedPayment.type === 'bank-aaib') {
            this.loading = true;
            this.checkoutService
                .selectPaymentMethod(this.getSelectedPayment.code, true).pipe(retry(6))
                .subscribe(response => {
                if (response['body']['configurations']) {
                    window['bank'] = 'bank-aaib';
                    this.aaibData = response['body']['configurations'];
                    this.AABbaseUrl = response['body']['configurations']['base_url'];
                    setTimeout(() => {
                        if (document.getElementById('aaibSubmit')) {
                            document.getElementById('aaibSubmit').click();
                        }
                    }, 500);
                }
            }, err => {
                this.loading = false;
                this.errorFromReq = true;
            });
        }
        if (this.getSelectedPayment.type === 'kashier') {
            // this.loading = true ;
            this.notkashier = false;
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe((res) => {
                this.callKashier(res['body']['configurations']);
            });
        }
        if (this.getSelectedPayment.type === 'paysky') {
            this.loading = true;
            this.notWeAccept = true;
            this.showCreditCard = false;
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(response => {
                if (response['body']['configurations']) {
                    window['upg-bank'] = 'pay-sky';
                    this.callPaySky(response['body']['configurations']);
                }
            });
        }
        if (this.getSelectedPayment.type === 'bank-cib') {
            this.loading = true;
            this.notWeAccept = true;
            this.showCreditCard = false;
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(response => {
                if (response['body']['configurations']) {
                    window['bank'] = 'bank-cib';
                    this.callCIB(response['body']['configurations']);
                    this.cibData = response['body']['configurations'];
                }
            }, (error) => {
                this.toastr.error(this.language['sorrySomethingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            });
        }
        if (this.getSelectedPayment.type === 'bank-nbe') {
            this.loading = true;
            this.notWeAccept = true;
            this.showCreditCard = false;
            this.checkoutService.selectPaymentMethod(this.getSelectedPayment.code, true).subscribe(response => {
                if (response['body']['configurations']) {
                    window['bank'] = 'nbe';
                    this.callNBE(response['body']['configurations']);
                    this.nbeData = response['body']['configurations'];
                }
            }, (error) => {
                this.toastr.error(this.language['sorrySomethingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            });
        }
    }
    callLightbox(upgConfigurations) {
        this.loadUpg();
        const orderId = '';
        const paymentMethodFromLightBox = null;
        const amount = upgConfigurations['amount'];
        const mID = +upgConfigurations['merchantId'];
        const tID = +upgConfigurations['terminalId'];
        setTimeout(() => {
            Lightbox.Checkout.configure = {
                OrderId: orderId,
                paymentMethodFromLightBox: paymentMethodFromLightBox,
                MID: mID,
                TID: tID,
                AmountTrxn: amount,
                completeCallback: (data) => {
                    this.router.navigate(['upg'], { queryParams: { upgData: JSON.stringify(data) } });
                    Lightbox.Checkout.closeLightbox();
                },
                errorCallback: (error) => {
                    this.loading = false;
                },
                cancelCallback: () => {
                    this.removeMpgs(window['upg-bank']);
                    // your code here
                }
            };
            this.loading = true;
            window.addEventListener('lightBoxEventQnb', (e) => {
                this.loading = false;
            });
            Lightbox.Checkout.showLightbox();
        }, 1000);
    }
    callUpg(upgConfigurations) {
        this.loadUpg();
        const orderId = '';
        const paymentMethodFromLightBox = null;
        const amount = upgConfigurations['amount'];
        const mID = upgConfigurations['merchantId'];
        const tID = upgConfigurations['terminalId'];
        setTimeout(() => {
            Lightbox.Checkout.configure = {
                OrderId: orderId,
                paymentMethodFromLightBox: paymentMethodFromLightBox,
                MID: mID,
                TID: tID,
                AmountTrxn: amount,
                completeCallback: (data) => {
                    this.router.navigate(['upg'], { queryParams: { upgData: JSON.stringify(data) } });
                    Lightbox.Checkout.closeLightbox();
                },
                errorCallback: (error) => {
                    this.loading = false;
                },
                cancelCallback: (x) => {
                    this.removeMpgs(window['upg-bank']);
                    this.loading = false;
                }
            };
            this.loading = true;
            window.addEventListener('lightBoxLoaded', (e) => {
                this.loading = false;
            });
            Lightbox.Checkout.showLightbox();
        }, 1000);
    }
    callPaySky(paySkyConfigurations) {
        this.loadUpg(paySkyConfigurations['live-credentials']);
        const orderId = '';
        const amount = +paySkyConfigurations['amount'];
        const mID = +paySkyConfigurations['merchantId'];
        const tID = +paySkyConfigurations['terminalId'];
        const mRN = paySkyConfigurations['order_reference'];
        setTimeout(() => {
            Lightbox.Checkout.configure = {
                OrderId: orderId,
                MID: mID,
                TID: tID,
                AmountTrxn: amount,
                MerchantReference: mRN,
                completeCallback: (data) => {
                    this.router.navigate(['upg'], { queryParams: { upgData: JSON.stringify(data) } });
                    Lightbox.Checkout.closeLightbox();
                },
                errorCallback: (error) => {
                    this.loading = false;
                },
                cancelCallback: (x) => {
                    this.removeMpgs(window['upg-bank']);
                    this.loading = false;
                    this.lastMethod = 1;
                }
            };
            this.loading = true;
            window.addEventListener('lightBoxLoaded', (e) => {
                this.loading = false;
            });
            Lightbox.Checkout.showLightbox();
        }, 1000);
    }
    callMpgEg(mpgConfigr) {
        this.loadMpgs(mpgConfigr['base_url']);
        setTimeout(() => {
            Checkout.configure({
                session: {
                    id: mpgConfigr['sessionId'],
                },
                merchant: mpgConfigr['merchantId'],
                order: {
                    amount: mpgConfigr['amount'] / 100,
                    currency: mpgConfigr['currency'],
                    description: 'Order Id: ' + mpgConfigr['orderId'],
                    id: mpgConfigr['orderId'],
                    reference: mpgConfigr['orderId']
                },
                interaction: {
                    operation: mpgConfigr['operation'],
                    merchant: {
                        name: mpgConfigr['merchantName'],
                        logo: ''
                    },
                    locale: 'en_US',
                    theme: 'default',
                    displayControl: {
                        billingAddress: 'HIDE',
                        customerEmail: 'HIDE',
                        orderSummary: 'SHOW',
                        shipping: 'HIDE'
                    }
                },
                billing: {
                    address: {
                        city: mpgConfigr['billing.address.city'],
                        country: mpgConfigr['billing.address.country'],
                        postcodeZip: mpgConfigr['billing.address.postcodeZip'],
                        street: mpgConfigr['billing.address.street']
                    }
                },
            });
            Checkout.showLightbox();
        }, 4000);
        window.addEventListener('IsCanceled', (e) => {
            this.cancelCall();
        });
        window.addEventListener('IsCompleted', (e) => {
            e['detail']['amount'] = mpgConfigr['amount'];
            this.completeCall(e['detail']);
        });
        window.addEventListener('anError', (e) => {
            this.errorCall(e['detail']);
        });
        window.addEventListener('timeout', (e) => {
            this.timeoutCall();
        });
    }
    callMpgQNB(mpgConfigr) {
        this.loadMpgs(mpgConfigr['base_url']);
        setTimeout(() => {
            Checkout.configure({
                session: {
                    id: mpgConfigr['sessionId'],
                },
                merchant: mpgConfigr['merchantId'],
                order: {
                    amount: mpgConfigr['amount'] / 100,
                    currency: mpgConfigr['currency'],
                    description: 'Order Id: ' + mpgConfigr['orderId'],
                    id: mpgConfigr['orderId'],
                },
                interaction: {
                    operation: mpgConfigr['operation'],
                    merchant: {
                        name: mpgConfigr['merchantName'],
                        logo: ''
                    },
                    locale: 'en_US',
                    theme: 'default',
                    displayControl: {
                        billingAddress: 'HIDE',
                        customerEmail: 'HIDE',
                        orderSummary: 'SHOW',
                        shipping: 'HIDE'
                    }
                },
                billing: {
                    address: {
                        city: mpgConfigr['billing.address.city'],
                        country: mpgConfigr['billing.address.country'],
                        postcodeZip: mpgConfigr['billing.address.postcodeZip'],
                        street: mpgConfigr['billing.address.street']
                    }
                }
            });
            Checkout.showLightbox();
        }, 5000);
        window.addEventListener('IsCanceled', (e) => {
            this.cancelCall();
        });
        window.addEventListener('IsCompleted', (e) => {
            e['detail']['amount'] = mpgConfigr['amount'];
            this.completeCall(e['detail']);
        });
        window.addEventListener('anError', (e) => {
            this.errorCall(e['detail']);
        });
        window.addEventListener('timeout', (e) => {
            this.timeoutCall();
        });
    }
    callMpgAAIB(mpgConfigr) {
        this.loadMpgs(mpgConfigr['base_url']);
        setTimeout(() => {
            Checkout.configure({
                session: {
                    id: mpgConfigr['sessionId'],
                },
                merchant: mpgConfigr['merchantId'],
                order: {
                    amount: mpgConfigr['amount'] / 100,
                    currency: mpgConfigr['currency'],
                    description: 'Order Id: ' + mpgConfigr['orderId'],
                    id: mpgConfigr['orderId'],
                    reference: mpgConfigr['orderId']
                },
                interaction: {
                    operation: mpgConfigr['operation'],
                    merchant: {
                        name: mpgConfigr['merchantName'],
                        logo: ''
                    },
                    locale: 'en_US',
                    theme: 'default',
                    displayControl: {
                        billingAddress: 'HIDE',
                        customerEmail: 'HIDE',
                        orderSummary: 'SHOW',
                        shipping: 'HIDE'
                    }
                },
                billing: {
                    address: {
                        city: mpgConfigr['billing.address.city'],
                        country: mpgConfigr['billing.address.country'],
                        postcodeZip: mpgConfigr['billing.address.postcodeZip'],
                        street: mpgConfigr['billing.address.street']
                    }
                },
            });
            Checkout.showLightbox();
        }, 5000);
        window.addEventListener('IsCanceled', (e) => {
            this.cancelCall();
        });
        window.addEventListener('IsCompleted', (e) => {
            e['detail']['amount'] = mpgConfigr['amount'];
            this.completeCall(e['detail']);
        });
        window.addEventListener('anError', (e) => {
            this.errorCall(e['detail']);
        });
        window.addEventListener('timeout', (e) => {
            this.timeoutCall();
        });
    }
    createElementFromHTML(htmlString) {
        var div = document.getElementById('aaibtest');
        div.innerHTML = htmlString.trim();
        // Change this to div.childNodes to support multiple top-level nodes
        return div.firstChild;
    }
    callCIB(cibConfigr) {
        this.loadMpgs(cibConfigr['base_url']);
        setTimeout(() => {
            Checkout.configure({
                session: {
                    id: cibConfigr['sessionId'],
                },
                merchant: cibConfigr['merchantId'],
                order: {
                    amount: cibConfigr['amount'] / 100,
                    currency: cibConfigr['currency'],
                    description: 'Order Id: ' + cibConfigr['orderId'],
                    id: cibConfigr['orderId'],
                },
                interaction: {
                    operation: cibConfigr['operation'],
                    merchant: {
                        name: cibConfigr['merchantName'],
                        logo: ''
                    },
                    locale: 'en_US',
                    displayControl: {
                        billingAddress: 'HIDE',
                        customerEmail: 'HIDE',
                        orderSummary: 'SHOW',
                        shipping: 'HIDE'
                    }
                },
                billing: {
                    address: {
                        city: cibConfigr['billing.address.city'],
                        country: cibConfigr['billing.address.country'],
                        postcodeZip: cibConfigr['billing.address.postcodeZip'],
                        street: cibConfigr['billing.address.street']
                    }
                }
            });
            Checkout.showLightbox();
        }, 5000);
        window.addEventListener('IsCanceled', (e) => {
            this.cancelCall();
        });
        window.addEventListener('IsCompleted', (e) => {
            e['detail']['amount'] = cibConfigr['amount'];
            this.completeCall(e['detail']);
        });
        window.addEventListener('anError', (e) => {
            this.errorCall(e['detail']);
        });
        window.addEventListener('timeout', (e) => {
            this.timeoutCall();
        });
    }
    callNBE(nbeConfigr) {
        this.loadMpgs(nbeConfigr['base_url']);
        setTimeout(() => {
            Checkout.configure({
                session: {
                    id: nbeConfigr['sessionId'],
                },
                merchant: nbeConfigr['merchantId'],
                order: {
                    amount: nbeConfigr['amount'] / 100,
                    currency: nbeConfigr['currency'],
                    description: 'Order Id: ' + nbeConfigr['orderId'],
                    id: nbeConfigr['orderId'],
                },
                interaction: {
                    operation: nbeConfigr['operation'],
                    merchant: {
                        name: nbeConfigr['merchantName'],
                        logo: ''
                    },
                    locale: 'en_US',
                    // theme: 'default',
                    displayControl: {
                        billingAddress: 'HIDE',
                        customerEmail: 'HIDE',
                        orderSummary: 'SHOW',
                        shipping: 'HIDE'
                    }
                },
                billing: {
                    address: {
                        city: nbeConfigr['billing.address.city'],
                        country: nbeConfigr['billing.address.country'],
                        postcodeZip: nbeConfigr['billing.address.postcodeZip'],
                        street: nbeConfigr['billing.address.street']
                    }
                }
            });
            Checkout.showLightbox();
        }, 5000);
        window.addEventListener('IsCanceled', (e) => {
            this.cancelCall();
        });
        window.addEventListener('IsCompleted', (e) => {
            e['detail']['amount'] = nbeConfigr['amount'];
            this.completeCall(e['detail']);
        });
        window.addEventListener('anError', (e) => {
            this.errorCall(e['detail']);
        });
        window.addEventListener('timeout', (e) => {
            this.timeoutCall();
        });
    }
    /**

*@param non
*@return non
*@author Ahmed Nader
this to load upg js file jsut in payment component
 */
    loadUpg(live_credentials) {
        const body = document.body;
        const script = document.createElement('script');
        script.id = window['upg-bank'];
        script.type = 'text/javascript';
        if (window['upg-bank'] === 'QNB') {
            script.src = './assets/scripts/upg_qnb_nosecure.js';
        }
        else if (window['upg-bank'] === 'MISR') {
            script.src = './assets/scripts/upg_Lightbox.js';
        }
        else if (window['upg-bank'] === 'pay-sky') {
            script.src = live_credentials ? './assets/scripts/paysky-live.js' : './assets/scripts/paysky-testing.js';
        }
        else if (window['upg-bank'] === 'AAIB') {
            script.src = './assets/scripts/upg_Lightbox_aaib.js';
        }
        body.appendChild(script);
        body.insertBefore(script, body.firstChild);
    }
    loadMpgs(src) {
        const body = document.body;
        const MpgsLib = document.createElement('script');
        MpgsLib.type = 'text/javascript';
        if (window['bank'] === 'egy') {
            MpgsLib.src = src;
            MpgsLib.dataset.complete = 'completeCallback';
        }
        else if (window['bank'] === 'bank-aaib') {
            MpgsLib.src = src;
            MpgsLib.dataset.complete = 'completeCallback';
        }
        else if (window['bank'] === 'bank-cib') {
            MpgsLib.src = src;
            MpgsLib.dataset.complete = 'completeCallback';
        }
        if (window['bank'] === 'bank-misr') {
            MpgsLib.src = src;
            MpgsLib.dataset.complete = 'completeCallback';
        }
        else if (window['bank'] === 'bank-qnb') {
            MpgsLib.src = src;
            MpgsLib.dataset.complete = 'completeCallback';
        }
        else if (window['bank'] === 'nbe') {
            MpgsLib.src = src;
            MpgsLib.dataset.complete = 'completeCallback';
        }
        MpgsLib.dataset.cancel = 'cancelCallback';
        MpgsLib.dataset.error = 'errorCallback';
        // MpgsLib.dataset.timeout = 'timeoutCallback';
        MpgsLib.setAttribute('id', window['bank']);
        body.appendChild(MpgsLib);
        body.insertBefore(MpgsLib, body.firstChild);
        const MpgsCallBacks = document.createElement('script');
        MpgsCallBacks.type = 'text/javascript';
        const code = `
						function cancelCallback() {
							var cancelMpgsEvent = new Event('IsCanceled');
							window.dispatchEvent(cancelMpgsEvent);
						};
						function completeCallback(x,y) {
								var completeMpgsEvent = new CustomEvent('IsCompleted',{detail:{
									resultIndicator: x ,
									sessionVersion: y
								}});
							window.dispatchEvent(completeMpgsEvent);
						};
						function errorCallback(e) {
							var errorMpgsEvent = new Event('anError',{detail:e});
							window.dispatchEvent(errorMpgsEvent);
						};
						 `;
        MpgsCallBacks.appendChild(document.createTextNode(code));
        MpgsCallBacks.setAttribute('id', window['bank']);
        body.appendChild(MpgsCallBacks);
    }
    completeCall(details) {
        const cartId = localStorage.getItem('cartId');
        this.cartService.verifyMpgsPayment(cartId, details).subscribe(res => {
            if (res['status'] === 'success') {
                this.removeMpgs(window['bank']);
                this.router.navigate(['mpgs'], { queryParams: { mpgsData: JSON.stringify(res) } });
            }
            else {
                this.loading = false;
                this.router.navigate(['mpgs'], { queryParams: { mpgsData: JSON.stringify(res) } });
                // this.toastr.error(
                //   this.language['sorrySomethingWentWrong'],
                //   `${this.language['error']}!`,
                //   { enableHtml: true, closeButton: true }
                // );
            }
        }, (err) => {
            this.removeMpgs(window['bank']);
            this.loading = false;
            this.router.navigate(['mpgs'], { queryParams: { mpgsData: JSON.stringify(err) } });
            // this.toastr.error(
            //   this.language['sorrySomethingWentWrong'],
            //   `${this.language['error']}!`,
            //   { enableHtml: true, closeButton: true }
            // );
        });
    }
    errorCall(e) {
        this.loading = false;
        this.removeMpgs(window['bank']);
        this.toastr.error(this.language['sorrySomethingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
    }
    cancelCall() {
        this.loading = false;
        this.removeMpgs(window['bank']);
    }
    timeoutCall() {
        this.loading = false;
        this.toastr.error(this.language['sorrySomethingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
    }
    log(args) {
        let str = '';
        for (let i = 0; i < arguments.length; i++) {
            if (typeof arguments[i] === 'object') {
                str += JSON.stringify(arguments[i]);
            }
            else {
                str += arguments[i];
            }
        }
    }
    callKashier(configration) {
        this.loading = true;
        const body = document.body;
        const KashierLib = document.createElement('script');
        const reduirectUrl = `${location.origin}/${this.language['LANGUAGE_CODE']}/kashier`;
        KashierLib.type = 'text/javascript';
        KashierLib.dataset.amount = configration.amount;
        KashierLib.dataset.hash = configration.hash;
        KashierLib.dataset.currency = configration.currency;
        KashierLib.dataset.orderid = configration.order;
        KashierLib.dataset.merchantid = configration.mid;
        KashierLib.dataset.merchantredirect = reduirectUrl;
        KashierLib.id = 'kashier-iFrame';
        KashierLib.src = configration.base_url;
        KashierLib.dataset.display = 'en';
        KashierLib.dataset.description = 'description';
        KashierLib.dataset.store = 'ANY';
        KashierLib.dataset.type = 'external';
        KashierLib.dataset.mode = configration.mode;
        body.appendChild(KashierLib);
        body.insertBefore(KashierLib, body.firstChild);
        const kashierStyle = document.createElement('style');
        const head = document.head || document.getElementsByTagName('head')[0];
        head.appendChild(kashierStyle);
        kashierStyle.appendChild(document.createTextNode('.el-kashier-div-button {display: none;}'));
        setTimeout(() => {
            const kashierBtn = document.getElementById('el-kashier-button');
            kashierBtn.click();
            this.stopSpinner();
        }, 5000);
        this.showKashier = true;
    }
    removeMpgs(bank) {
        const element = document.getElementById(bank);
        if (element !== null || undefined) {
            element.parentNode.removeChild(element);
        }
        this.lastMethod = 1;
        this.notCOD = false;
    }
}
PaymentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentComponent, deps: [{ token: LanguageService }, { token: CheckoutService }, { token: i2.Router }, { token: CompleteGuardCheckout }, { token: i1$1.FormBuilder }, { token: i3.DomSanitizer }, { token: i3.Title }, { token: WeAcceptService }, { token: CartService }, { token: ConfService }, { token: i3$1.ToastrService }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Component });
PaymentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: PaymentComponent, selector: "app-payment", viewQueries: [{ propertyName: "payFortForm", first: true, predicate: ["payFortForm"], descendants: true }, { propertyName: "aaibForm", first: true, predicate: ["aaibForm"], descendants: true }], ngImport: i0, template: "<div class=\"checkout-container\">\r\n  <div class=\"edit__container\" *ngIf=\"!showContent\">\r\n    <h4 class=\"title\">\r\n      {{language['stepOne']}}\r\n      <ng-container *ngIf=\"shippingAddress\">\r\n        <span>{{ shippingAddress.city}} , {{shippingAddress.areaCode}} , {{ shippingAddress.countryCode}}</span>\r\n      </ng-container>\r\n    </h4>\r\n    <a class=\"edit__link\" (click)=\"backToShippingAddress()\">{{language['edit']}}</a>\r\n  </div>\r\n  <div class=\"edit__container\" *ngIf=\"!showContent\">\r\n    <h4 class=\"title\">\r\n      {{language['stepTwo']}}\r\n    </h4>\r\n    <a class=\"edit__link\" (click)=\"backToShippingMethods()\">{{language['edit']}}</a>\r\n  </div>\r\n  \r\n  <div class=\"payment__options__container\">\r\n    <div class=\"payment__options\">\r\n      <div *ngIf=\"cartItemsSummary\" class=\"container\">\r\n      </div>\r\n      <!--End Order Summary-->\r\n      <div class=\"panel-body\" [ngStyle]=\"{'background-color': loading ? '#fff' : ''}\">\r\n        <ng-container *ngIf=\"loading\">\r\n          <app-checkout-spinner></app-checkout-spinner>\r\n        </ng-container>\r\n        <h4 *ngIf=\"!loading\" class=\"payment__method__title\">{{language['selectPaymentMethod']}}</h4>\r\n        <form [formGroup]=\"contact\">\r\n          <div class=\"payment__method__container\">\r\n            <ng-container *ngIf=\"!loading\">\r\n              <app-radio-buttons [disabled]=\"showCreditCard\" [methods]=\"paymentMethods\" id=\"radioBtnRef\" (selectMethod)=\"sendSelectedPayment($event)\" [methodKey]=\"'type'\">\r\n              </app-radio-buttons>\r\n              <ng-container *ngIf=\"!noPaymentMethodFound\">\r\n                <p class=\"no__payment__method\">{{language['no-payment']}}</p>\r\n              </ng-container>\r\n            </ng-container>\r\n          </div>\r\n          <ng-template [ngIf]=\"showCreditCard\">\r\n            <div [@hideShowAnimator]=\"showCreditCard\">\r\n              <iframe #iframe [src]=\"iframeUrl\" style=\"width: 100%; border: 0; height: 566px;\"></iframe>\r\n            </div>\r\n          </ng-template>\r\n          <div hidden>\r\n            <form ngNoForm #payFortForm [action]=\"payFortPaymentMethodForm['gateway_url']\" method=\"POST\">\r\n              <input name=\"access_code\" [value]=\"payFortPaymentMethodForm['access_code']\">\r\n              <input name=\"amount\" [value]=\"payFortPaymentMethodForm['amount']\">\r\n              <input name=\"command\" [value]=\"payFortPaymentMethodForm['command']\">\r\n              <input name=\"currency\" [value]=\"payFortPaymentMethodForm['currency']\">\r\n              <input name=\"customer_email\" [value]=\"payFortPaymentMethodForm['customer_email']\">\r\n              <input name=\"language\" [value]=\"payFortPaymentMethodForm['language']\">\r\n              <input name=\"merchant_identifier\" [value]=\"payFortPaymentMethodForm['merchant_identifier']\">\r\n              <input name=\"merchant_reference\" [value]=\"payFortPaymentMethodForm['merchant_reference']\">\r\n              <input name=\"signature\" [value]=\"payFortPaymentMethodForm['signature']\">\r\n              <button type=\"submit\">sumbit</button>\r\n            </form>\r\n          </div>\r\n        </form>\r\n        <p *ngIf=\"errMsg\" class=\"alert alert-danger mt-3\"> Failed payment please choose another payment method </p>\r\n        <p *ngIf=\"errorFromReq\" class=\"alert alert-danger mt-3\"> An error occurred please try again </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"alert alert-danger\" *ngIf=\"itemUnAvaliable\">{{language['Remove_Checkout_Items']}}</div>\r\n  <ng-container *ngIf=\"notWeAccept\">\r\n    <div class=\"submit-btn\">\r\n      <p class=\"tooltip--activated\" *ngIf=\"(!(storeIsActivated | async) && !(storeEnabledTestOrder | async)) \">\r\n        {{language['storeIsNotActivated']}}\r\n      </p>\r\n      <p class=\"min_order text-center\"\r\n      *ngIf=\"defaultCurrency && defaultCurrency['min_order_amount'] && orders && orders['total'] && defaultCurrency['min_order_amount'] > orders['total'] / 100\">\r\n      {{language['min_order']}} {{defaultCurrency.min_order_amount}} {{ defaultCurrency.code}} {{language['you_have']}}\r\n      {{defaultCurrency.min_order_amount - orders.total / 100 | number  :'1.0-2'}} {{ defaultCurrency.code}}\r\n    </p>\r\n    <button *ngIf=\"getSelectedPayment?.type !== 'offline' && !canPlaceOrder\" class=\"btn btn-continue\" (click)=\"selectPaymentMethod()\">{{language['payOnline']}}\r\n      <img src=\"assets/checkout-header/arrow1.png\" class=\"icon-arrow\" alt=\"icon-arrow\">\r\n    </button>\r\n      <button *ngIf=\"canPlaceOrder\" class=\"btn btn-continue\" (click)=\"handlePayment()\" [disabled]=\"((!(storeIsActivated | async ) && !(storeEnabledTestOrder | async) ) || notCOD) || itemUnAvaliable || (defaultCurrency && defaultCurrency['min_order_amount'] &&  orders && orders['total'] && defaultCurrency['min_order_amount'] > orders['total'] / 100) || (orders && orders['disablePurchase'])  \">\r\n        {{language['pleaseOrder']}}\r\n        <img src=\"assets/checkout-header/arrow1.png\" class=\"icon-arrow\" alt=\"icon-arrow\">\r\n      </button>\r\n    </div>\r\n  </ng-container>\r\n  <!--Form Aaib Bank-->\r\n  <div hidden>\r\n    <form ngNoForm #aaibForm action=\"{{AABbaseUrl}}\" method=\"POST\">\r\n      <input type=\"hidden\" id=\"access_key\" name=\"access_key\" value=\"{{aaibData?.access_key}}\">\r\n      <input type=\"hidden\" id=\"profile_id\" name=\"profile_id\" value=\"{{aaibData?.profile_id}}\">\r\n      <input type=\"hidden\" id=\"merchant_id\" name=\"merchant_id\" value=\"{{aaibData?.merchant_id}}\">\r\n      <input type=\"hidden\" id=\"transaction_uuid\" name=\"transaction_uuid\" value=\"{{aaibData?.transaction_uuid}}\">\r\n      <input type=\"hidden\" id=\"signed_field_names\" name=\"signed_field_names\" value=\"{{aaibData?.signed_field_names}}\">\r\n      <input type=\"hidden\" id=\"unsigned_field_names\" name=\"unsigned_field_names\"\r\n        value=\"{{aaibData?.unsigned_field_names}}\">\r\n      <input type=\"hidden\" id=\"signed_date_time\" name=\"signed_date_time\" value=\"{{aaibData?.signed_date_time}}\">\r\n      <input type=\"hidden\" id=\"locale\" name=\"locale\" value=\"{{aaibData?.locale}}\">\r\n      <input id=\"override_custom_cancel_page\" name=\"override_custom_cancel_page\"\r\n        value=\"{{aaibData?.override_custom_cancel_page}}\">\r\n      <input id=\"override_custom_receipt_page\" name=\"override_custom_receipt_page\"\r\n        value=\"{{aaibData?.override_custom_receipt_page}}\">\r\n      <input type=\"hidden\" id=\"transaction_type\" name=\"transaction_type\" value=\"{{aaibData?.transaction_type}}\">\r\n      <input type=\"hidden\" id=\"reference_number\" name=\"reference_number\" value=\"{{aaibData?.reference_number}}\">\r\n      <input type=\"hidden\" id=\"bill_to_forename\" name=\"bill_to_forename\" value=\"{{aaibData?.bill_to_forename}}\">\r\n      <input type=\"hidden\" id=\"bill_to_surname\" name=\"bill_to_surname\" value=\"{{aaibData?.bill_to_surname}}\">\r\n      <input type=\"hidden\" id=\"bill_to_email\" name=\"bill_to_email\" value=\"{{aaibData?.bill_to_email}}\">\r\n      <input type=\"hidden\" id=\"bill_to_address_line1\" name=\"bill_to_address_line1\"\r\n        value=\"{{aaibData?.bill_to_address_line1}}\">\r\n      <input type=\"hidden\" id=\"bill_to_address_city\" name=\"bill_to_address_city\"\r\n        value=\"{{aaibData?.bill_to_address_city}}\">\r\n      <input type=\"hidden\" id=\"bill_to_address_country\" name=\"bill_to_address_country\"\r\n        value=\"{{aaibData?.bill_to_address_country}}\">\r\n      <input type=\"hidden\" id=\"amount\" name=\"amount\" value=\"{{aaibData?.amount}}\">\r\n      <input type=\"hidden\" id=\"currency\" name=\"currency\" value=\"{{aaibData?.currency}}\">\r\n      <!-- <input  id=\"submit\" name=\"submit\" value=\"Submit\"> -->\r\n      <input type=\"hidden\" id=\"signature\" name=\"signature\" value=\"{{aaibData?.signature}}\">\r\n      <input #aaibSubmit type=\"hidden\" id=\"aaibSubmit\" type=\"submit\" value=\"Submit\">\r\n    </form>\r\n  </div>\r\n</div>", styles: [":host .checkout-container{position:relative;min-height:620px}:host .checkout-container .edit__container{display:flex;background:#fcfcfd;padding:15px;border-radius:10px;margin:15px 0}:host .checkout-container .edit__container .title{font-size:16px;font-weight:700;margin:0}:host .checkout-container .edit__container .edit__link{margin-left:auto;transition:all .3s ease-in-out;cursor:pointer}:host .checkout-container .edit__container .edit__link:hover{color:#09f}[dir=rtl] :host .checkout-container .edit__container .edit__link{margin-right:auto;margin-left:initial}:host .checkout-container .payment__options__container{margin-top:2px}:host .checkout-container .payment__options__container .no__payment__method{text-align:center;font-weight:bold;font-size:20px;font-weight:600}:host .checkout-container .payment__options__container .payment__options{background-color:#fff;padding:20px;min-height:350px;border-radius:10px;box-shadow:0 0 10px #0000001a}@media all and (max-width: 767.98px){:host .checkout-container .payment__options__container .payment__options{min-height:auto}}:host .checkout-container .payment__options__container .payment__options .panel-body{position:relative}:host .checkout-container .payment__options__container .payment__options .panel-body .payment__method__title{font-weight:700;font-size:18px;margin-bottom:2rem}:host iframe .col-xs-offset-2{margin-left:0!important}:host iframe .col-xs-8{width:0px!important}:host .btn-continue:disabled{cursor:not-allowed;opacity:.6}\n"], components: [{ type: CheckoutSpinnerComponent, selector: "app-checkout-spinner" }, { type: RadioButtonsComponent, selector: "app-radio-buttons", inputs: ["methods", "readSelectedMethod", "methodKey"], outputs: ["selectMethod"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }], pipes: { "async": i6.AsyncPipe, "number": i6.DecimalPipe }, animations: [showAndHideElementAnimation] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-payment',
                    templateUrl: './payment.component.html',
                    styleUrls: ['./payment.component.scss'],
                    animations: [showAndHideElementAnimation]
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CheckoutService }, { type: i2.Router }, { type: CompleteGuardCheckout }, { type: i1$1.FormBuilder }, { type: i3.DomSanitizer }, { type: i3.Title }, { type: WeAcceptService }, { type: CartService }, { type: ConfService }, { type: i3$1.ToastrService }, { type: i1.HttpClient }]; }, propDecorators: { payFortForm: [{
                type: ViewChild,
                args: ['payFortForm']
            }], aaibForm: [{
                type: ViewChild,
                args: ['aaibForm']
            }] } });

class CompleteComponent {
    constructor(languageService, router, checkoutService, cartService) {
        this.languageService = languageService;
        this.router = router;
        this.checkoutService = checkoutService;
        this.cartService = cartService;
        // @HostBinding('@routerSildeState') routeAnimation = true;
        this.isMoreThanItem = false;
        this.getImage = ProductService.getImage;
        this.orders = {};
        this.cartItemsSummary = {};
        this.adjustments = [];
        this.language = {};
        this.getNotes = '';
        this.imageUrl = `${environment.imageUrl}`;
        this.isSuccess = false;
        this.destroyed$ = new Subject();
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.checkoutService.nagivateTop();
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.checkoutService.getFullyCheckoutData().pipe(first(), takeUntil(this.destroyed$)).subscribe((data) => {
            this.fullyCheckoutData = data;
            if (data['items'].length > 4) {
                this.isMoreThanItem = true;
            }
            // lets  make defualt image if there is no image found
            this.billingAddress = data['billingAddress'];
            this.shippingAddress = data['shippingAddress'];
            this.payments = data['payments'][0];
            this.orders = data;
        });
        this.checkoutService.getNextStep(3).subscribe(() => {
            this.placeOrder();
        });
    }
    placeOrder() {
        // this.googleAnalyticService.sendEvent();
        this.cartService.emptyCartLastStep(this.getNotes);
    }
    goToCollectionPage() {
        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'collection']);
    }
}
CompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompleteComponent, deps: [{ token: LanguageService }, { token: i2.Router }, { token: CheckoutService }, { token: CartService }], target: i0.ɵɵFactoryTarget.Component });
CompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CompleteComponent, selector: "app-complete", viewQueries: [{ propertyName: "modal", first: true, predicate: ["template"], descendants: true }], ngImport: i0, template: "<div class=\"checkout-container\">\r\n\r\n  <!--Start Checkout Items-->\r\n  <div class=\"container checkout-items-container\">\r\n    <div class=\"steps-container\">\r\n      <div class=\"vertical-line\"></div>\r\n      <div class=\"vertical-line-1\"></div>\r\n      <div class=\"vertical-line-2\"></div>\r\n      <div class=\"vertical-line-3\"></div>\r\n    </div>\r\n    <div class=\"row \">\r\n      <div class=\"col-md-12 col-sm-12 col-xs-12 checkout-items\">\r\n        <div class=\"container complete-header-container\">\r\n          <span class=\"checkout-items-logo\">\r\n            <img src=\"../assets/checkoutSteps/new_step5.png\">\r\n          </span>\r\n          <h2>{{language['stepFour']}}</h2>\r\n        </div>\r\n        <div>\r\n          <div *ngIf=\"fullyCheckoutData\" class=\"table-responsive items__table\">\r\n            <div [ngClass]=\"{'scroll-table': isMoreThanItem}\" id=\"style-2\">\r\n              <div class=\"table-responsive\">\r\n\r\n                <table class=\"table \">\r\n                  <thead>\r\n                  <tr>\r\n                    <th height='70' style=\"width: 20%\">{{language['summaryItems']}}</th>\r\n                    <th height='70' style=\"width: 15%;\">{{language['quantity']}}</th>\r\n                    <th height='70' style=\"width: 15%\">\r\n                      {{language['price']}}\r\n\r\n                    </th>\r\n\r\n                    <th height='70' style=\"width: 50%\">{{language['productName']}}</th>\r\n                  </tr>\r\n                  </thead>\r\n\r\n                  <tbody *ngFor=\"let item of fullyCheckoutData.items\" class=\"scrollbar\"\r\n                         id=\"style-1\">\r\n                  <tr>\r\n                    <td style=\"width: 20%\">\r\n                      <img [lazyLoad]=\"getImage(item.variant.product)\" [errorImage]=\"defaultImage\">\r\n                      {{item.variant.product.name}}\r\n                    </td>\r\n                    <td style=\"width: 15%\">{{item.quantity}}</td>\r\n                    <td style=\"width: 15%\">\r\n                      {{ item.total / 100}} {{ fullyCheckoutData.currencyCode}}\r\n\r\n                      <p *ngIf=\"((item.unitPrice* item.quantity) - item.total) > 0\">\r\n                          <span style=\"text-decoration: line-through;color: #000;\">\r\n                            {{ item.unitPrice / 100 *\r\n                          item.quantity | number }} {{currencyCode}}\r\n                        </span>\r\n                      </p>\r\n                    </td>\r\n                    <td style=\"width: 50%\">\r\n                      <p>{{ item.variant | translate : 'name' }}</p>\r\n                      <p>{{ item.variant.product | translate : 'name' }}</p>\r\n\r\n                    </td>\r\n\r\n                  </tr>\r\n                  </tbody>\r\n                </table>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Start Order Summary -->\r\n        <div *ngIf=\"cartItemsSummary\" class=\"container\">\r\n          <div class=\"order_summary_container\">\r\n            <p *ngIf=\"cartItemsSummary.itemsQty < 2\">\r\n              <span\r\n              class=\"order_summary_items_number\">{{cartItemsSummary.itemsQty}}</span>\r\n              {{language['summaryItem']}} : <span\r\n                class=\"order_summary_container_price same-color\">{{cartItemsSummary.itemsTotal /\r\n              100 }} {{cartItemsSummary.currencyCode}}</span>\r\n            </p>\r\n            <p *ngIf=\"cartItemsSummary.itemsQty > 1\"><span\r\n              class=\"order_summary_items_number\">{{cartItemsSummary.itemsQty}}</span>\r\n              {{language['summaryItems'] }} : <span\r\n                class=\"order_summary_container_price same-color\">{{cartItemsSummary.itemsTotal /\r\n              100 }} {{cartItemsSummary.currencyCode}}</span>\r\n            </p>\r\n            <ng-container *ngIf=\"adjustments\">\r\n              <div *ngFor=\"let adjust of adjustments\" class=\"adjustments\">\r\n                <p>{{ language[adjust.type] }} :\r\n                  <span class=\"order_summary_price same-color\"> {{ adjust.amount / 100 }}\r\n                    {{cartItemsSummary.currencyCode }}</span></p>\r\n              </div>\r\n            </ng-container>\r\n            <p> {{language['summaryPromotions']}} : <span class=\"order_summary_price same-color\">\r\n                {{cartItemsSummary.promotions / 100}}\r\n              {{cartItemsSummary.currencyCode }}</span>\r\n            </p>\r\n            <!-- <p>{{language['delivery']}} : <span class=\"order_summary_price same-color\">{{cartItemsSummary.shippingAmount }}\r\n                {{cartItemsSummary.currencyCode}}</span>\r\n            </p> -->\r\n            <p>{{language['totalPrice']}} : <span *ngIf=\"fullyCheckoutData\" class=\"order_summary_price same-color\">{{\r\n              fullyCheckoutData.total / 100}} EGP</span>\r\n            </p>\r\n          </div>\r\n          <!-- <h4 class=\"order_summary_payment_method same-color\" style=\"text-align: center\">{{language['paidByCreditCard']}}</h4> -->\r\n\r\n        </div>\r\n        <!--End Order Summary-->\r\n        <hr>\r\n        <!-- Start Order Summary -->\r\n        <div class=\"container \">\r\n          <h4 style=\"padding: 20px 0\">{{language['deliverToMyAddress']}}</h4>\r\n          <div *ngIf=\"shippingAddress\" class=\"order_delivery\">\r\n            <p class=\"order_delivery_cust-name\">{{language['name']}} : {{shippingAddress.firstName }} {{\r\n              shippingAddress.lastName}}</p>\r\n            <p class=\"order_delivery_cust-phone\">{{language['formPhoneNumber']}}: {{shippingAddress.phoneNumber}}</p>\r\n            <p class=\"order_delivery_cust-details\">{{language['street']}} : {{shippingAddress.street }}</p>\r\n            <p class=\"order_delivery_cust-country\">{{language['country']}} : {{shippingAddress.countryCode}}</p>\r\n            <p class=\"order_delivery_cust-country\">{{language['city']}} : {{shippingAddress.city}}</p>\r\n          </div>\r\n        </div>\r\n        <!--End Order Summary-->\r\n        <hr>\r\n        <!--Start Billing Address-->\r\n        <div class=\"container\">\r\n          <h4 style=\"padding: 20px 0\">{{language['billingAddressTitle']}}</h4>\r\n          <div *ngIf=\"billingAddress\" class=\"order_delivery\">\r\n            <p class=\"order_delivery_cust-name\">{{language['name']}} : {{billingAddress.firstName }} {{\r\n              billingAddress.lastName}}</p>\r\n            <p class=\"order_delivery_cust-phone\">{{language['formPhoneNumber']}}: {{billingAddress.phoneNumber}} </p>\r\n            <p class=\"order_delivery_cust-details\">{{language['street']}} : {{billingAddress.street }}</p>\r\n            <p class=\"order_delivery_cust-country\">{{language['country']}} : {{billingAddress.countryCode}}</p>\r\n            <p class=\"order_delivery_cust-country\">{{language['city']}} : {{billingAddress.city}}</p>\r\n          </div>\r\n        </div>\r\n        <!--End Billing Address -->\r\n        <hr>\r\n        <!--Start Billing Address-->\r\n        <!--End Billing Address -->\r\n      </div>\r\n      <!--End Checkout Items-->\r\n\r\n    </div>\r\n  </div>\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"addNoteContainer\">\r\n        <div class=\"form-group\">\r\n          <label for=\"comment\">{{language['addNote']}}</label>\r\n          <textarea [(ngModel)]='getNotes' class=\"form-control\" id=\"comment\" rows=\"5\"></textarea>\r\n        </div>\r\n        <ng-container *ngIf=\"isSuccess\">\r\n          <div class=\"successfully__ordered\">\r\n            <h3>{{language['orderConfirmation']}}</h3>\r\n            <a (click)=\"goToCollectionPage()\">{{language['backToCollection']}}</a>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n</div>\r\n\r\n\r\n<!-- <button type=\"button\" class=\"btn btn-primary\" (click)=\"openModal(template)\">Create template modal</button>\r\n     \r\n<ng-template #template>\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title pull-left\">Modal</h4>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    This is a modal.\r\n  </div>\r\n</ng-template> -->\r\n", styles: [".checkout-container{background:#eef1f6;position:relative;padding-bottom:50px}.checkout-container .checkout-items-container{margin-top:2px}.checkout-container .checkout-items-container .items__table thead{text-transform:capitalize}.checkout-container .checkout-items-container .checkout-items{background:#fff;box-shadow:-1px 1px 9px -2px #000000bf;border-radius:15px;padding-bottom:30px;padding-left:0!important;width:95%;margin:0 auto}.checkout-container .checkout-items-container .checkout-items .complete-header-container{padding-left:0;margin-left:0;min-height:80px}[dir=rtl] .checkout-container .checkout-items-container .checkout-items .complete-header-container{padding-right:0}.checkout-container .checkout-items-container .checkout-items .checkout-items-logo{float:left;border-top-left-radius:15px;border-bottom-right-radius:15px;padding:10px 20px;font-size:40px;color:#fff;background-color:#f3d43e}[dir=rtl] .checkout-container .checkout-items-container .checkout-items .checkout-items-logo{float:right}.checkout-container .checkout-items-container .checkout-items h2{float:left;vertical-align:-webkit-baseline-middle;margin-top:25px;font-weight:600;margin-left:10px;text-transform:uppercase}[dir=rtl] .checkout-container .checkout-items-container .checkout-items h2{float:right;margin-right:20px}.checkout-container .checkout-items-container .checkout-items .scroll-table{height:563px;overflow:auto;width:100%}.checkout-container .checkout-items-container .checkout-items #style-2::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);border-radius:10px;background:#ecf0f3}.checkout-container .checkout-items-container .checkout-items #style-2::-webkit-scrollbar{width:8px;background:#ecf0f3}.checkout-container .checkout-items-container .checkout-items #style-2::-webkit-scrollbar-thumb{border-radius:10px;-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#333}.checkout-container .checkout-items-container .checkout-items .table-responsive{padding-top:30px;padding-bottom:30px}.checkout-container .checkout-items-container .checkout-items .table{border-radius:1em;width:95%;margin:0 auto;padding-right:20px;overflow:hidden}.checkout-container .checkout-items-container .checkout-items .table thead{background:#545d70;color:#fff}.checkout-container .checkout-items-container .checkout-items .table th,.checkout-container .checkout-items-container .checkout-items .table td{vertical-align:middle;text-align:left;font-size:18px;border:none!important}.checkout-container .checkout-items-container .checkout-items .table th img,.checkout-container .checkout-items-container .checkout-items .table td img{width:100px}.checkout-container .checkout-items-container .checkout-items .table th:first-child{padding-left:50px}.checkout-container .checkout-items-container .checkout-items .table td{background:#f6f7fd}.checkout-container .items-info .item-info-style{background:#e1e4e9;width:100%;padding:15px;margin:5px auto;text-align:left;border-radius:15px}.checkout-container .items-info .item-info-style .item-info-first{color:#666!important}.checkout-container .items-info .item-info-style p{font-size:18px;font-weight:bold;color:#000}.checkout-container .items-info .item-info-style p span{padding-right:25px;font-weight:bold;color:#666}.checkout-container .items-info .qty-number-one{font-size:25px;color:#000!important}.checkout-container .checkout-footer{background-color:#fff;margin-top:40px;padding:3px}.checkout-container .checkout-footer .methods{display:inline-block;width:20%;padding:20px 0}.checkout-container .checkout-footer .methods .next{padding:25px 60px;background:#46ca38;color:#fff;font-size:20px;margin:20px}.checkout-container .checkout-footer .methods a{position:relative}.checkout-container .checkout-footer .methods a .checkout-pg-number{border:3px solid #ecf0f3;background-color:#f3d43e;color:#fff;padding:5px 13px;border-radius:5px}.checkout-container .checkout-footer .methods a .checkout-pg-number:after{display:block;content:\"\";width:30%;height:2px;background:#777;position:absolute;bottom:8px;left:-40px}.order_summary_container{background-color:#545d70;padding:15px 20px;border-radius:15px;margin-bottom:20px;margin-top:20px}.order_summary_container p{color:#fff;text-transform:capitalize}.order_summary_container .order_summary_items_number{font-size:25px;color:#fff;font-weight:700}.order_summary_container .order_summary_payment_method{text-align:right;padding:5px}.order_summary_container .same-color{color:#fff}.order_delivery{background-color:#545d70;padding:15px 20px;border-radius:15px;color:#fff;margin-bottom:20px}.order_delivery .order_delivery_cust-name{font-weight:700;font-size:22px;text-transform:capitalize}.order_delivery p{text-transform:capitalize}.order_delivery .order_delivery_cust-details{font-weight:700}.col-md-12{padding-right:0}.steps-container{text-align:center}.steps-container .vertical-line{height:10px;display:inline-block;text-align:center;background-color:#f3d43e;width:40px;position:relative;margin-top:30px;margin-bottom:30px;border-radius:5px}[dir=rtl] .steps-container .vertical-line{margin-left:15px}.steps-container .vertical-line-1{height:10px;display:inline-block;text-align:center;background-color:#f48a3e;margin-left:20px;width:40px;position:relative;margin-top:30px;margin-bottom:30px;border-radius:5px}.steps-container .vertical-line-2{height:10px;display:inline-block;text-align:center;background-color:#3bb1ef;width:40px;position:relative;margin-left:20px;margin-top:30px;margin-bottom:30px;border-radius:5px}.steps-container .vertical-line-3{height:10px;display:inline-block;text-align:center;background-color:#46ca38;width:80px;position:relative;margin-left:20px;margin-top:30px;margin-bottom:30px;border-radius:5px}.addNoteContainer{padding:20px 30px;background:#fff;border-radius:15px;width:100%;margin-top:30px;box-shadow:0 4px 5px #c7b3c7}.addNoteContainer label{font-size:25px;font-weight:700}.items-table{display:block;padding-top:130px}.items-table .items-row{margin-left:0;margin-right:0}.items-table .items-info-header{background:#545d70;color:#fff;padding-left:20px}.items-table .items-info-header .items h5{padding-top:15px;padding-left:20px}.items-table .items-info-header .quantity h5{padding-top:15px}.items-table .items-info-header .price h5{padding-top:15px}.items-table .border-items-left{border-top-left-radius:15px}.items-table .border-items-right{border-top-right-radius:15px}.items-table .items-image-container .image img{width:25%}.items-table .items-quantityValue-container .quantity{line-height:7rem;font-weight:bold;margin-left:30px;font-size:20px}.items-table .items-priceValue-container .price{line-height:7rem;font-weight:bold;margin-left:30px;font-size:20px}iframe{height:600px;border:none}.successfully__ordered{text-align:center;width:50%;margin:auto;border-radius:15px;background:#333;transition:all .3s ease-in;animation:successMessage;animation-duration:1s;padding:15px}.successfully__ordered h3{color:#46ca38}.successfully__ordered a{font-size:18px;color:#fff;cursor:pointer}@media screen and (max-width: 667px){.successfully__ordered{width:100%}.successfully__ordered h3,.successfully__ordered a{font-size:18px}}@keyframes successMessage{0%{transform:translateY(-100px)}80%{transform:translateY(-10px)}to{transform:translateY(0)}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "number": i6.DecimalPipe, "translate": TranslatePipe }, animations: [
        routerSildeStateTrigger,
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CompleteComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-complete',
                    templateUrl: './complete.component.html',
                    styleUrls: ['./complete.component.scss'],
                    animations: [
                        routerSildeStateTrigger,
                    ],
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i2.Router }, { type: CheckoutService }, { type: CartService }]; }, propDecorators: { modal: [{
                type: ViewChild,
                args: ['template']
            }] } });

function phoneNumberValidator(control1, control2) {
    return (formGroup) => {
        const phoneKey = formGroup.controls[control1];
        const phoneNumber = formGroup.controls[control2];
        // Regular expression to match Arabic digits (٠١٢٣٤٥٦٧٨٩)
        const arabicDigitsPattern = /[\u0660-\u0669]/g;
        if (phoneKey.value === '002') { // Egypt
            // Replace Arabic digits with their corresponding English digits
            const normalizedPhoneNumber = phoneNumber.value.replace(arabicDigitsPattern, match => String.fromCharCode(match.charCodeAt(0) - 1584));
            // Apply the regular expression to validate the phone number
            if (!/^(01[0125][0-9]{8})$/.test(normalizedPhoneNumber)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00966') { // Saudi Arabia
            if (!/^((5|0|3|6|4|9)[0-9]{8})$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00965') { // Kwait
            if (!/^\d{4}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00974') { // Qatar
            if (!/^\d{4}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00961') { // Lebanon
            if (!/^\d{2}\s?\d{6}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00968') { // Oman
            if (!/^\d{4}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00967') { // Yemen
            if (!/^\d{1}\s?\d{6}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00970') { // Palestine
            if (!/^\d{1}\s?\d{7}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '0093') { // Afghanistan
            if (!/^\d{3}\s?\d{3}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00962') { // Jordan
            if (!/^\d{1}\s?\d{7}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00971') { // United Emirates
            if (!/^\d{2}\s?\d{3}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00218') { // Libya
            if (!/^\d{2}\s?\d{3}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00963') { // Syria
            if (!/^\d{2}\s?\d{3}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '001') { // United States
            if (!/^\d{3}\s?\d{3}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00964') { // Iraq
            if (!/^\d{2}\s?\d{3}\s?\d{4}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else if (phoneKey.value === '00973') { // bahrein
            if (!/^\d{1}\s?\d{7}$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        else {
            if (!/^((5|0|3|6|4|9)[0-9]{8,11})$/.test(phoneNumber.value)) {
                phoneNumber.setErrors({ invalidPhoneNumber: true });
            }
        }
        return null;
    };
}

class GeofenceComponent {
    constructor(cartService, confService) {
        this.cartService = cartService;
        this.confService = confService;
        this.areaCords = new EventEmitter();
        this.lat = 30.0444;
        this.lng = 31.2357;
        this.polygonCoords = [];
        this.storeSubscription = this.confService.store$.subscribe((store) => {
            this.loadScript(store.mapsApiKey ? store.mapsApiKey : store.mapsApiKeyDefault);
            //this.loadScript(store.mapsApiKey ? store.mapsApiKey : 'AIzaSyBiT3nISMJZ9Z-6ynBRj25PCW3Ld3ImHPA');
        });
    }
    /**
   * @description Bind google maps API to the head tag with dynamic key.
   * @param apiKey
   * @author Mostafa Mahmoud
   */
    loadScript(apiKey) {
        this.node = document.createElement('script');
        this.node.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        this.node.type = 'text/javascript';
        this.node.async = true;
        this.node.defer = true;
        document.getElementsByTagName('head')[0].appendChild(this.node);
        this.node.onload = () => {
            this.initMap();
        };
    }
    /**
   * @description Initialize google map with default options.
   * @author Mostafa Mahmoud
   */
    initMap() {
        this.coordinates = new google.maps.LatLng(this.lat, this.lng);
        this.marker = new google.maps.Marker({
            draggable: false,
            animation: google.maps.Animation.DROP,
        });
        this.rangeArea = new google.maps.Polygon({
            strokeColor: '#FF0000',
            strokeOpacity: 0.4,
            strokeWeight: 1,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            clickable: true
        });
        this.map = new google.maps.Map(this.gmap.nativeElement, {
            center: this.coordinates,
            zoom: 14
        });
        this.marker.setMap(this.map);
        this.rangeArea.setMap(this.map);
        // This event listener calls addMarker() when the map is clicked.
        google.maps.event.addListener(this.map, 'click', (event) => {
            this.addMarker(event.latLng);
        });
        google.maps.event.addListener(this.rangeArea, 'click', (event) => {
            this.addMarker(event.latLng);
        });
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                this.map.setCenter(pos);
                this.marker.setPosition(pos);
            });
        }
        this.polygonDrawer(this.polygonCoords);
    }
    ngOnChanges(changes) {
        if (changes['area'] !== undefined) {
            if (changes['area']['currentValue'] !== undefined) {
                this.polygonCoords = changes['area']['currentValue']['coords'];
                if (this.rangeArea) {
                    this.polygonDrawer(this.polygonCoords);
                }
            }
        }
        if (changes['defaultGeoLocation']) {
            if (changes['defaultGeoLocation']['currentValue']['isLocated']) {
                this.addMarker(changes['defaultGeoLocation']['currentValue']['location']);
            }
        }
        if (changes['pos']) {
            this.pos = changes['pos']['currentValue'];
            this.map ? this.map.setZoom(18) : '';
            this.marker ? this.marker.setPosition(this.pos) : '';
            if (this.area && this.area) {
                const areaObj = {
                    areaId: this.area['id'],
                    coords: {
                        longitude: this.marker.getPosition().toJSON()['lng'],
                        latitude: this.marker.getPosition().toJSON()['lat']
                    }
                };
                this.geoFenceValidation(areaObj);
            }
        }
    }
    /**
   * @description Add the marker at the clicked location, and add the next-available label
   * from the array of alphabetical characters.
   * @param location
   * @author Mostafa Mahmoud
   */
    addMarker(location) {
        if (this.area) {
            this.marker.setPosition(location);
            const areaObj = {
                areaId: this.area['id'],
                coords: {
                    longitude: this.marker.getPosition().toJSON()['lng'],
                    latitude: this.marker.getPosition().toJSON()['lat']
                }
            };
            if (this.allowGeofence) {
                this.geoFenceValidation(areaObj);
            }
            else {
                const clickedArea = {
                    inRange: true,
                    coords: {
                        longitude: this.marker.getPosition().toJSON()['lng'],
                        latitude: this.marker.getPosition().toJSON()['lat']
                    }
                };
                this.areaCords.emit(clickedArea);
            }
        }
    }
    /**
   * @description Drow polygon area from givien coordinates array.
   * @param coords
   * @author Mostafa Mahmoud
   */
    polygonDrawer(coords) {
        if (this.allowGeofence) {
            this.rangeArea.setOptions({ paths: coords });
            this.map.setCenter(this.pos ? this.pos : coords[0]);
        }
        else {
            this.rangeArea.setOptions({ paths: [] });
        }
    }
    /**
   * @description validate that marker inRange or not.
   * @param areaObj
   * @author Mostafa Mahmoud
   */
    geoFenceValidation(areaObj) {
        this.cartService.validateGeofence(areaObj).subscribe(response => {
            const clickedArea = {
                inRange: response['inRange'],
                coords: {
                    longitude: this.marker.getPosition().toJSON()['lng'],
                    latitude: this.marker.getPosition().toJSON()['lat']
                }
            };
            this.areaCords.emit(clickedArea);
        });
    }
    ngOnDestroy() {
        document.getElementsByTagName('head')[0].removeChild(this.node);
        if (this.storeSubscription) {
            this.storeSubscription.unsubscribe();
        }
    }
}
GeofenceComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GeofenceComponent, deps: [{ token: CartService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
GeofenceComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: GeofenceComponent, selector: "app-geofence", inputs: { area: "area", defaultGeoLocation: "defaultGeoLocation", pos: "pos", allowGeofence: "allowGeofence" }, outputs: { areaCords: "areaCords" }, viewQueries: [{ propertyName: "gmap", first: true, predicate: ["mapContainer"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #mapContainer id=\"map\"></div>\r\n", styles: ["#map{height:250px;width:100%}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: GeofenceComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-geofence',
                    templateUrl: './geofence.component.html',
                    styleUrls: ['./geofence.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: CartService }, { type: ConfService }]; }, propDecorators: { gmap: [{
                type: ViewChild,
                args: ['mapContainer']
            }], areaCords: [{
                type: Output
            }], area: [{
                type: Input
            }], defaultGeoLocation: [{
                type: Input
            }], pos: [{
                type: Input
            }], allowGeofence: [{
                type: Input
            }] } });

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function conditionalRequiredValidator(showField) {
    return (control) => {
        if (showField) {
            if (!control.value) {
                return { required: 'This field is required.' };
            }
        }
        return null;
    };
}
class AddressingComponent {
    // Add similar @ViewChild decorators for other form controls
    constructor(languageService, checkoutService, router, fb, shippingGuardCheckout, userAddressingService, confService, translatePipe, loginService, fbService, toastr) {
        this.languageService = languageService;
        this.checkoutService = checkoutService;
        this.router = router;
        this.fb = fb;
        this.shippingGuardCheckout = shippingGuardCheckout;
        this.userAddressingService = userAddressingService;
        this.confService = confService;
        this.translatePipe = translatePipe;
        this.loginService = loginService;
        this.fbService = fbService;
        this.toastr = toastr;
        this.user_fname = localStorage.getItem('user_firstName') ? localStorage.getItem('user_firstName') : sessionStorage.getItem('user_firstName');
        this.user_lname = localStorage.getItem('user_lastName') ? localStorage.getItem('user_lastName') : sessionStorage.getItem('user_lastName');
        this.user_email = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email');
        this.user_phone = localStorage.getItem('user_phone') ? localStorage.getItem('user_phone') : sessionStorage.getItem('user_phone');
        this.isUserHasAddress = false;
        this.language = {};
        this.showAnotherBilling = false;
        this.countries = [];
        this.provinces = [];
        this.provincesBilling = [];
        this.areas = [];
        this.areasBilling = [];
        this.cities = [];
        this.citiesForBilling = [];
        this.loading = false;
        this.billingLoading = false;
        this.apiValidationAddressing = {};
        this.apiValidationBilling = {};
        this.submitted = false;
        this.submittedWithBilling = false;
        this.isHasDifferentBillingAddress = false;
        this.isSelectOldAddress = false;
        this.isOldAddressChanged = false;
        this.itemUnAvaliable = false;
        this.isProvinceExist = '';
        this.isProvinceExistForBilling = '';
        this.isAreaExist = '';
        this.isAreaExistForBilling = '';
        this.pattern = /^[a-zA-Z\u0600-\u06FF]{2,}(.*)$/;
        this.email = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
        this.hideEmailField = false;
        this.USER_EMAIL = localStorage.getItem('user_email') || sessionStorage.getItem('user_email')
            ? localStorage.getItem('user_email') ||
                sessionStorage.getItem('user_email')
            : null;
        this.isLoggedIn = this.loginService.logged.getValue();
        this.isSaveAddress = false;
        this.ADDRESS_DATA = {};
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.showNeighborhoodContent = (this.id == StoresName.TamaraId) ? true : false;
        this.HideMap = (this.id == StoresName.nilestockId || this.id == StoresName.Dukes) ? false : true;
        this.showField = (this.id == StoresName.TawzeeaId) ? true : false;
        this.showContent = this.id == 12849 ? true : false;
        this.showThis = this.id == 12701 ? true : false;
        this.buildingPatten = /^([a-zA-Z0-9\u0600-\u06FF]+)$/;
        this.regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.destroyed$ = new Subject();
        this.allowConditionTerms = false;
        this.acceptTermsConditions = true;
        this.isAcceptTermsConditions = true;
        this.termsAndConditionsPage = '';
        this.separateFloorApp = false;
        this.allowGeofence = false;
        this.inRange = true;
        this.defaultGeoLocation = {
            isLocated: false,
            location: {
                lat: 0,
                lng: 0,
            },
        };
        this.addressingForm = this.fb.group({
            firstName: [this.user_fname ? this.user_fname : '', [Validators.required, Validators.pattern(this.pattern)]],
            lastName: [this.user_lname ? this.user_lname : '', [Validators.required, Validators.pattern(this.pattern)]],
            areaCode: [''],
            country: ['', [conditionalRequiredValidator(!this.showField)]],
            city: ['', [conditionalRequiredValidator(!this.showField)]],
            userEmail: [
                this.user_email,
                [Validators.required, Validators.pattern(this.regexEmail)],
            ],
            salesPerson: ['', [Validators.pattern(/^[a-zA-Z0-9\s]*$/)]],
            building: [
                '',
                [Validators.required, Validators.pattern(this.buildingPatten)],
            ],
            floor: ['', [Validators.required]],
            apartement: [
                '',
                [Validators.required, Validators.pattern(this.buildingPatten)],
            ],
            neighbourhood: [this.showNeighborhoodContent ? ' ' : '', Validators.required],
            phoneKey: ['', [Validators.required, Validators.pattern(/^(5(5|0|3|6|4|9)|05(5|0|3|6|4|9))[0-9]{7}$/)]],
            phoneNumber: [this.user_phone ? this.user_phone : '', [Validators.required, Validators.pattern(/^(5(5|0|3|6|4|9)|05(5|0|3|6|4|9))[0-9]{7}$/)]],
            shipping_notes: [''],
            street: ['', [Validators.required, Validators.minLength(5)]],
        });
        this.storeIdentitySubscription = this.confService.store$.subscribe((store) => {
            this.allowConditionTerms = store.allowConditionTerms;
            this.isAddressingEmailRequired = store.isAddressingEmailRequired;
            this.termsAndConditionsPage = store.page;
            this.allowGeofence = store.allowGeofence;
            this.separateFloorApp = store['separateFloorApp'];
            this.createAddressingForm(this.separateFloorApp);
            if (this.isAddressingEmailRequired) {
                this.addressingForm.get('userEmail').setValidators([Validators.required, Validators.pattern(this.regexEmail)]);
            }
            else {
                this.addressingForm.get('userEmail').clearValidators();
            }
            this.addressingForm.get('userEmail').updateValueAndValidity();
            this.isloggedIn(this.USER_EMAIL);
            setTimeout(() => {
                this.addressingForm.controls['city'].setValue('');
            }, 2000);
        });
    }
    get provinceTimeOutForBilling() {
        return this._provinceTimeOutForBilling;
    }
    set provinceTimeOutForBilling(value) {
        this._provinceTimeOutForBilling = value;
    }
    ngOnInit() {
        const pos = JSON.parse(localStorage.getItem('pos'));
        this.branch = this.confService.branch$;
        this.getCountries();
        if (this.isLoggedIn) {
            this.getOldAddressIfUserLoggedIn();
        }
        this.loading = true;
        this.checkoutService
            .getFullyCheckoutData()
            .pipe(first(), tap((data) => {
            for (const item of data['items']) {
                if (!item.variant.stockCheck) {
                    this.itemUnAvaliable = true;
                }
            }
            this.orders = data;
            if (data['shippingAddress'] !== undefined &&
                this.addressingForm.value !== undefined) {
                this.getCities(data['shippingAddress']['countryInfo']['id'], false);
                this.getAreas(data['shippingAddress']['cityInfo']['id'], false);
                this.checkoutService.setShippingAddressData(this.addressingForm, data);
            }
            if (data['billingAddress'] !== undefined &&
                this.billingAddress.value !== undefined) {
                this.getCitiesForBilling(data['billingAddress']['countryInfo']['id']);
                this.getCityAreasForBilling(data['billingAddress']['cityInfo']['id']);
                this.checkoutService.setBillingAddressData(this.billingAddress, data);
            }
            if (data['shippingAddress']) {
                this.defaultGeoLocation = {
                    isLocated: true,
                    location: {
                        lat: data['shippingAddress']['latitude'],
                        lng: data['shippingAddress']['longitude'],
                    },
                };
            }
            if (!data['shippingAddress'] &&
                this.pos &&
                this.pos.lat &&
                this.pos.lng) {
                this.defaultGeoLocation = {
                    isLocated: true,
                    location: pos,
                };
                this.areaCoords = {
                    latitude: this.pos['lat'],
                    longitude: this.pos['lng'],
                };
            }
            if (pos && pos.lat && pos.lng) {
                if (this.confService.branch$ &&
                    this.confService.branch$.id &&
                    this.confService.branch$.area) {
                    this.area = this.confService.branch$.area;
                    this.inRange = true;
                    this.pos = pos;
                }
            }
            this.fbService.InitiateCheckout(data['checkoutState'], data['id'], data['itemsTotal']);
            this.checkTheDifferanceAddressIfRefresh(data);
            this.stopSpinner();
        }), takeUntil(this.destroyed$))
            .subscribe();
        this.languageService
            .getLanguage()
            .pipe(first(), takeUntil(this.destroyed$))
            .subscribe((language) => this.language = language);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.addressingForm.controls['city'].setValue('');
        }, 2000);
    }
    stopSpinner() {
        this.loading = false;
        this.billingLoading = false;
        if (this.addressingForm.valid) {
            this.loading = false;
            this.billingLoading = false;
        }
        else {
            this.loading = false;
            this.billingLoading = false;
        }
    }
    createAddressingForm(separateFloorApp) {
        if (separateFloorApp) {
            let street = localStorage.getItem('street');
            this.addressingForm = this.fb.group({
                firstName: [this.user_fname ? this.user_fname : '',
                    [Validators.required, Validators.pattern(this.pattern)],
                ],
                lastName: [this.user_lname ? this.user_lname : '', [Validators.required, Validators.pattern(this.pattern)]],
                areaCode: ['', [conditionalRequiredValidator(!this.showField)]],
                country: ['', [conditionalRequiredValidator(!this.showField)]],
                city: ['', [conditionalRequiredValidator(!this.showField)]],
                salesPerson: ['', [Validators.pattern(/^[a-zA-Z0-9\s]*$/)]],
                userEmail: [
                    this.user_email,
                    [Validators.required, Validators.pattern(this.regexEmail)],
                ],
                building: [
                    '',
                    [Validators.required, Validators.pattern(this.buildingPatten)],
                ],
                floor: [''],
                apartement: [
                    '',
                    [Validators.required, Validators.pattern(this.buildingPatten)],
                ],
                neighbourhood: [this.showNeighborhoodContent ? ' ' : '', Validators.required],
                phoneKey: ['', [Validators.required]],
                phoneNumber: [this.user_phone ? this.user_phone : '',
                    [
                        Validators.required,
                    ]],
                shipping_notes: [''],
                street: [
                    street && street.length > 0 ? street : '',
                    [Validators.required, Validators.minLength(5)],
                ],
            }, {
                validator: phoneNumberValidator('phoneKey', 'phoneNumber')
            });
        }
        else {
            let street = localStorage.getItem('street');
            this.addressingForm = this.fb.group({
                firstName: [this.user_fname ? this.user_fname : '',
                    [Validators.required, Validators.pattern(this.pattern)],
                ],
                lastName: [this.user_lname ? this.user_lname : '', [Validators.required, Validators.pattern(this.pattern)]],
                areaCode: ['', [conditionalRequiredValidator(!this.showField)]],
                country: ['', [conditionalRequiredValidator(!this.showField)]],
                city: ['', [conditionalRequiredValidator(!this.showField)]],
                salesPerson: ['', [Validators.pattern(/^[a-zA-Z0-9\s]*$/)]],
                userEmail: [
                    this.user_email,
                    [Validators.required, Validators.pattern(this.regexEmail)],
                ],
                phoneKey: ['', [Validators.required]],
                phoneNumber: [
                    '',
                    [
                        Validators.required,
                    ]
                ],
                shipping_notes: [''],
                street: [
                    street && street.length > 0 ? street : '',
                    [Validators.required, Validators.minLength(5)],
                ],
            }, {
                validator: phoneNumberValidator('phoneKey', 'phoneNumber')
            });
        }
        this.billingAddress = this.fb.group({
            billingAddressFirstName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.pattern(this.pattern),
                ],
            ],
            billingAddressLastName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.pattern(this.pattern),
                ],
            ],
            billingAdderssAreaCode: ['', Validators.required],
            billingAddressCountry: ['', Validators.required],
            billingAddressCity: ['', Validators.required],
            billingAddressEmail: [
                '',
                [Validators.required, Validators.pattern(this.regexEmail)],
            ],
            billingAddressPhoneKey: ['', [Validators.required]],
            billingAddressPhoneNumber: ['', [Validators.required]],
            billingAddressStreet: ['', [Validators.required, Validators.minLength(5)]],
        });
    }
    getAreaCode(e) {
        this.area = this.areas.find((area) => area['code'] === e);
    }
    onCountryChanges() {
        this.addressingForm
            .get('country')
            .valueChanges.subscribe((selectedCity) => {
            if (selectedCity.length > 0) {
                if (this.orders['shippingAddress'] !== undefined &&
                    this.addressingForm.value !== undefined) {
                    if ((this.orders['shippingAddress']['cityInfo']['id'] !== undefined ||
                        null) &&
                        this.orders['shippingAddress']['cityInfo']['id']) {
                        this.getCities(this.orders['shippingAddress']['countryInfo']['id'], false);
                        this.getAreas(this.orders['shippingAddress']['cityInfo']['id'], false);
                    }
                    else {
                        this.selectCity(this.addressingForm.get('city').value, true);
                    }
                }
                else {
                    const countryId = this.getCountryIdByCode(this.addressingForm.get('country').value);
                    this.getCities(countryId);
                }
            }
            else {
                this.addressingForm.get('city').disable();
                this.addressingForm.get('areaCode').disable();
            }
        });
    }
    checkTheDifferanceAddressIfRefresh(checkoutData) {
        const billingAddress = Object.assign({}, checkoutData['billingAddress']);
        const shippingAddress = Object.assign({}, checkoutData['shippingAddress']);
        delete billingAddress['id'];
        delete shippingAddress['id'];
        this.showAnotherBilling =
            JSON.stringify(shippingAddress) !== JSON.stringify(billingAddress);
        if (this.showAnotherBilling) {
            this.isHasDifferentBillingAddress = true;
        }
    }
    /**
     * Represents the submit state if end user type shipping address or billing address & shipping address
     * @returns void
     */
    onSubmit() {
        console.log(this.addressingForm);
        if (this.allowConditionTerms && !this.acceptTermsConditions) {
            this.isAcceptTermsConditions = false;
            return;
        }
        if (this.isHasDifferentBillingAddress) {
            if (this.billingAddress.invalid) {
                // Scroll to the first invalid input in the billing address form
                const firstInvalidControl = this.getFirstInvalidControl(this.billingAddress);
                if (firstInvalidControl) {
                    firstInvalidControl.nativeElement.scrollIntoView({ behavior: 'smooth' });
                }
                // Display validation errors for the billing address form
                this.validateAllFormFields(this.billingAddress);
                return;
            }
            // Submit the billing address to the API
            this.sendBillingAddressToApi();
        }
        else {
            if (this.addressingForm.invalid) {
                // Scroll to the first invalid input in the addressing form
                const firstInvalidControl = this.getFirstInvalidControl(this.addressingForm);
                if (firstInvalidControl) {
                    // Calculate the offset by subtracting 30 pixels from the top of the element
                    const offset = firstInvalidControl.nativeElement.getBoundingClientRect().top - 50;
                    console.log(offset);
                    // Scroll to the top of the element with the offset
                    firstInvalidControl.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
                    // Scroll the container by the offset
                    window.scrollBy({ top: offset, left: 0, behavior: 'smooth' });
                }
                // Display validation errors for the addressing form
                this.validateAllFormFields(this.addressingForm);
                return;
            }
            // Submit the addressing form to the API
            this.sendShippingAddressingToApi();
        }
    }
    // Helper function to get the first invalid form control
    getFirstInvalidControl(formGroup) {
        for (const controlName in formGroup.controls) {
            const control = formGroup.get(controlName);
            if (control instanceof FormControl && control.invalid) {
                const elementRef = this.getElementRefByControlName(controlName);
                if (elementRef) {
                    return elementRef;
                }
            }
        }
        return null;
    }
    // Helper function to get the ElementRef for a form control by its name
    getElementRefByControlName(controlName) {
        switch (controlName) {
            case 'firstName':
                return this.firstNameInput;
            case 'lastName':
                return this.lastNameInput;
            case 'userEmail':
                return this.emailInput;
            case 'phoneNumber':
                return this.phoneInput;
            case 'street':
                return this.addressInput;
            // Add similar cases for other form controls
            default:
                return null; // Return null for unknown control names
        }
    }
    // Helper function to recursively mark all form fields as touched
    validateAllFormFields(formGroup) {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
    isloggedIn(userEmail) {
        if (userEmail) {
            this.hideEmailField = true;
            this.addressingForm.get('userEmail').setValue(userEmail);
            this.billingAddress.get('billingAddressEmail').setValue('userEmail');
        }
        else {
            this.hideEmailField = false;
        }
    }
    /**
     * Represents that the end user can't type any special charachters in any text input handle arabic & english
     * @returns void;
     */
    getUpdatedAddress(evt) {
        return evt.target.checked
            ? this.isSaveAddress = true
            : this.isSaveAddress = false;
    }
    /**
     * Represents the shippingAddressing that will be send to addressing api
     * @returns void
     */
    sendShippingAddressingToApi() {
        this.submitted = true;
        let concatAddress;
        if (this.separateFloorApp) {
            const buildingPieces = this.addressingForm.controls['building'].value.split("-");
            const resultBuilding = buildingPieces.join('');
            const apartementPieces = this.addressingForm.controls['apartement'].value.split("-");
            const resultapartement = apartementPieces.join('');
            concatAddress =
                'Building-' +
                    resultBuilding +
                    '-floor-' +
                    this.addressingForm.controls['floor'].value +
                    '-apartement-' +
                    resultapartement +
                    '-neighbourhood-' +
                    this.addressingForm.controls['neighbourhood'].value +
                    '-street-' +
                    this.addressingForm.controls['street'].value;
        }
        if (!this.areaCoords && this.allowGeofence) {
            this.inRange = false;
            return;
        }
        const ShippingAddressingData = {
            shippingAddress: {
                firstName: this.addressingForm.controls['firstName'].value,
                lastName: this.addressingForm.controls['lastName'].value,
                street: this.separateFloorApp
                    ? concatAddress
                    : this.addressingForm.controls['street'].value,
                phoneNumber: this.addressingForm.controls['phoneKey'].value +
                    '-' +
                    this.addressingForm.controls['phoneNumber'].value.replace(/\s/g, ''),
                countryCode: this.addressingForm.controls['country'].value,
                city: this.addressingForm.controls['city'].value,
                areaCode: this.addressingForm.controls['areaCode'].value,
                postcode: '11111',
                sales_person: this.addressingForm.controls['salesPerson'].value
            },
            userEmail: this.addressingForm.controls['userEmail'].value,
            shipping_notes: this.addressingForm.controls['shipping_notes'].value,
            differentBillingAddress: false,
            saveAddress: this.isSaveAddress,
        };
        if (this.areaCoords) {
            ShippingAddressingData['shippingAddress']['coords'] = {
                latitude: this.areaCoords.latitude,
                longitude: this.areaCoords.longitude,
            };
        }
        this.checkoutService
            .sendShippingAddressing(ShippingAddressingData)
            .pipe(debounceTime(500), takeUntil(this.destroyed$))
            .subscribe((data) => {
            if (this.isSaveAddress) {
                this.checkOldAddressEqualFormValues(this.addressingForm);
            }
            this.canAccessNextStep();
            localStorage.setItem('checkout_email', ShippingAddressingData.userEmail);
        }, (err) => {
            this.canNotAccessNextStep();
            if (err['error']['code'] === 407) {
                this.inRange = false;
                return;
            }
            else {
                debugger;
                localStorage.removeItem('cartId');
                this.toastr.error(err.message);
                this.router.navigate(['/']);
                setTimeout(() => {
                    location.reload();
                }, 400);
            }
        });
        // if the user select old address and modified it we need to create a new address
    }
    numberOnly(event) {
        const charCode = event.which ? event.which : event.keyCode;
        return charCode > 31 && (charCode < 48 || charCode > 57) ? false : true;
    }
    showBillingAddress(evt) {
        if (evt) {
            const target = evt.target;
            this.isHasDifferentBillingAddress = evt.target.checked;
            this.showAnotherBilling = target.checked;
        }
    }
    /**
     * get country id using country code
     * @param countryId
     */
    getCountryIdByCode(countryCode) {
        const country = this.countries.find((country) => country.code === countryCode);
        return country.id;
    }
    /**
     * get city id using city code
     * @param countryId
     */
    getCityIdByCode(cityCode, forBilling = false) {
        if (!forBilling) {
            const city = this.cities.find((city) => city.code === cityCode);
            return city.id;
        }
        else {
            const billingCity = this.citiesForBilling.find((city) => city.code === cityCode);
            return billingCity.id;
        }
    }
    /**
     * reset select values in city and area
     * when select the country we first check
     * if the countryId is null or undefined
     * @param countryCode
     */
    selectCountry(countryCode) {
        this.addressingForm.controls['city'].setValue('');
        this.addressingForm.controls['areaCode'].setValue('');
        if (countryCode === null || countryCode === undefined) {
            return (() => {
                this.cities.length = 0;
                this.areas.length = 0;
            })();
        }
        const countryId = this.getCountryIdByCode(countryCode);
        if (this.countries && countryCode) {
            this.getCities(countryId, true);
        }
    }
    selectCountryForBilling(countryCode) {
        this.billingAddress.controls['billingAddressCity'].setValue('');
        this.billingAddress.controls['billingAdderssAreaCode'].setValue('');
        if (countryCode === null || countryCode === undefined) {
            return (() => {
                this.citiesForBilling.length = 0;
                this.areasBilling.length = 0;
            })();
        }
        const countryId = this.getCountryIdByCode(countryCode);
        if (this.countries && countryCode) {
            this.getCitiesForBilling(countryId);
        }
    }
    selectCity(cityCode, firstTime = false) {
        if (cityCode === null || cityCode === undefined) {
            return this.areas.length = 0;
        }
        setTimeout(() => {
            const cityId = this.getCityIdByCode(cityCode);
            if (this.cities && cityId) {
                this.getAreas(cityId, true);
            }
        }, 1000);
    }
    selectCityForBilling(cityCode) {
        if (cityCode === null || cityCode === undefined) {
            return this.areasBilling.length = 0;
        }
        setTimeout(() => {
            const cityId = this.getCityIdByCode(cityCode, true);
            if (this.cities && cityCode) {
                this.getCityAreasForBilling(cityId);
            }
        }, 1000);
    }
    getCities(countryId, firstTime) {
        this.loading = true;
        this.checkoutService
            .getCitiesFromApi(countryId)
            .pipe(map((data) => data['response']), first())
            .subscribe((cities) => {
            if (cities.length > 0) {
                this.cities = cities;
                this.addressingForm.get('city').enable();
                if (firstTime) {
                    this.addressingForm.controls['city'].setValue(this.branch && this.branch.city && this.branch.city.code
                        ? this.branch.city.code
                        : this.cities[0]['code']);
                    this.selectCity(this.branch && this.branch.city && this.branch.city.code
                        ? this.branch.city.code
                        : this.cities[0]['code']);
                }
            }
            else {
                this.addressingForm.get('city').disable();
            }
            this.stopSpinner();
        });
        return this.cities;
    }
    getCitiesForBilling(countryId) {
        this.billingLoading = true;
        this.checkoutService
            .getCitiesFromApi(countryId)
            .pipe(map((data) => data['response']))
            .subscribe((cities) => {
            this.citiesForBilling = cities;
            this.stopSpinner();
        });
        return this.citiesForBilling;
    }
    getAreas(cityId, firstTime) {
        this.loading = true;
        this.checkoutService
            .getAreasFromApi(cityId)
            .pipe(map((data) => data['response']), first())
            .subscribe((areas) => {
            this.stopSpinner();
            if (areas) {
                this.areas = areas;
                this.addressingForm.get('areaCode').enable();
                if (!firstTime) {
                    if (this.orders['shippingAddress']) {
                        if (this.orders['shippingAddress']['areaInfo']['code']) {
                            this.area = this.areas.find((area) => area['code'] === this.orders['shippingAddress']['areaInfo']['code']);
                        }
                    }
                    else {
                        this.addressingForm.controls['areaCode'].setValue(this.areas[0]['code']);
                        this.getAreaCode(this.areas[0]['code']);
                    }
                }
                else {
                    this.addressingForm.controls['areaCode'].setValue(this.branch && this.branch.area && this.branch.area.code
                        ? this.branch.area.code
                        : this.areas[0]['code']);
                    this.getAreaCode(this.branch && this.branch.area && this.branch.area.code
                        ? this.branch.area.code
                        : this.areas[0]['code']);
                }
            }
        });
        return this.areas;
    }
    getCityAreasForBilling(cityId) {
        if (cityId !== undefined) {
            this.billingLoading = true;
            this.checkoutService
                .getAreasFromApi(cityId)
                .pipe(map((data) => data['response']))
                .subscribe((areas) => {
                this.areasBilling = areas;
                this.stopSpinner();
            });
        }
        return this.areasBilling;
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
        clearTimeout(this.clearToggleBtnTimeOut);
        clearTimeout(this.provinceTimeOut);
        clearTimeout(this.provinceTimeOutForBilling);
        if (this.storeIdentitySubscription) {
            this.storeIdentitySubscription.unsubscribe();
        }
    }
    /**
     * Represents the selected old address that select by the end user
     * @returns old address that selected by the user;
     */
    getSelectAddress(addressId) {
        return __awaiter(this, void 0, void 0, function* () {
            const selectedAdress = yield this.userOldAddressData.find((address) => {
                return address.ID == Number(addressId);
            });
            this.addressingForm.controls['city'].setValue(selectedAdress['CityName']);
            const countryId = this.getCountryIdByCode(selectedAdress['CountryCode']);
            this.getCities(countryId, false);
            this.selectCity(selectedAdress['CityName'], false);
            this.addressingForm.controls['firstName'].setValue(selectedAdress['FirstName']);
            this.addressingForm.controls['lastName'].setValue(selectedAdress['LastName']);
            this.addressingForm.controls['country'].setValue(selectedAdress['CountryCode']);
            this.addressingForm.controls['areaCode'].setValue(selectedAdress['AreaCode']);
            if (this.separateFloorApp) {
                this.addressingForm.controls['building'].setValue(selectedAdress['Street'].split('-')[1]);
                this.addressingForm.controls['floor'].setValue(selectedAdress['Street'].split('-')[3]);
                this.addressingForm.controls['apartement'].setValue(selectedAdress['Street'].split('-')[5]);
                this.addressingForm.controls['neighbourhood'].setValue(selectedAdress['Street'].split('-')[7]);
                this.addressingForm.controls['street'].setValue(selectedAdress['Street'].split('-')[9]);
            }
            else {
                this.addressingForm.controls['street'].setValue(selectedAdress['Street']);
            }
            this.addressingForm.controls['phoneKey'].setValue(selectedAdress['PhoneKey']);
            this.addressingForm.controls['phoneNumber'].setValue(this.checkoutService.getPhoneNumberWithoutKey(selectedAdress['PhoneKey'], selectedAdress['PhoneNumber']));
        });
    }
    checkOldAddressEqualFormValues(formValues) {
        let createAddressData;
        if (this.separateFloorApp) {
            const buildingPieces = formValues.controls['building'].value.split("-");
            const resultBuilding = buildingPieces.join('');
            const apartementPieces = formValues.controls['apartement'].value.split("-");
            const resultapartement = apartementPieces.join('');
            let streetAddress = 'Building-' +
                resultBuilding +
                '-floor-' +
                formValues.controls['floor'].value +
                '-apartement-' +
                resultapartement +
                '-neighbourhood-' +
                formValues.controls['neighbourhood'].value +
                '-street-' +
                formValues.controls['street'].value;
            createAddressData = {
                cityName: formValues.controls['city'].value,
                countryCode: formValues.controls['country'].value,
                areaCode: formValues.controls['areaCode'].value,
                firstName: formValues.controls['firstName'].value,
                lastName: formValues.controls['lastName'].value,
                salesPerson: formValues.controls['salesPerson'].value,
                // building: formValues.controls['building'].value,
                // floor: formValues.controls['floor'].value,
                // apartement: formValues.controls['apartement'].value,
                // neighbourhood: formValues.controls['neighbourhood'].value,
                phoneNumber: formValues.controls['phoneKey'].value +
                    '-' +
                    formValues.controls['phoneNumber'].value,
                street: streetAddress
            };
        }
        else {
            createAddressData = {
                cityName: formValues.controls['city'].value,
                countryCode: formValues.controls['country'].value,
                areaCode: formValues.controls['areaCode'].value,
                firstName: formValues.controls['firstName'].value,
                lastName: formValues.controls['lastName'].value,
                salesPerson: formValues.controls['salesPerson'].value,
                phoneNumber: formValues.controls['phoneKey'].value +
                    '-' +
                    formValues.controls['phoneNumber'].value,
                street: formValues.controls['street'].value,
            };
        }
        if (this.isShippingAddressEqualToSelectedAddress()) {
            this.userAddressingService
                .addAddress(createAddressData)
                .pipe(first())
                .subscribe((data) => {
                this.isSaveAddress = false;
            });
        }
    }
    /**
     * Represents that the end user can't write special charachter in the text field;
     * @returns void;
     */
    validateTextInputs(value, controlName, formName) {
        const lastchar = value.substr(value.length - 1);
        const regExp = '^[\u0621-\u064A\u0660-\u0669a-zA-Z ]+$';
        if (!new RegExp(regExp).test(lastchar)) {
            value = value.substr(0, value.length - 1);
            if (formName === 'billingAddress') {
                this.billingAddress.controls[`${controlName}`].setValue(value);
            }
            if (formName === 'shippingAddress') {
                this.addressingForm.controls[`${controlName}`].setValue(value);
            }
        }
    }
    /**
     * Represents that the end user can't write special charachter in the text field;
     * @returns void;
     */
    getOldAddressIfUserLoggedIn() {
        this.checkoutService
            .selectOldAddressing()
            .pipe(first())
            .subscribe((data) => {
            if (data['status'] === 'success') {
                if (data['response'] && data['response'].length > 0) {
                    this.isUserHasAddress = true;
                    this.userOldAddressData = data['response'];
                }
                if (this.userOldAddressData &&
                    this.userOldAddressData.length > 0) {
                    this.addressingForm.controls['city'].setValue(this.userOldAddressData[0]['CityName']);
                    const countryId = this.getCountryIdByCode(this.userOldAddressData[0]['CountryCode']);
                    this.getCities(countryId, false);
                    this.selectCity(this.userOldAddressData[0]['CityName'], false);
                    this.addressingForm.controls['firstName'].setValue(this.userOldAddressData[0]['FirstName']);
                    this.addressingForm.controls['lastName'].setValue(this.userOldAddressData[0]['LastName']);
                    this.addressingForm.controls['country'].setValue(this.userOldAddressData[0]['CountryCode']);
                    this.addressingForm.controls['areaCode'].setValue(this.userOldAddressData[0]['AreaCode']);
                    this.addressingForm.controls['street'].setValue(this.userOldAddressData[0]['Street']);
                    this.addressingForm.controls['phoneKey'].setValue(this.userOldAddressData[0]['PhoneKey']);
                    this.addressingForm.controls['phoneNumber'].setValue(this.checkoutService.getPhoneNumberWithoutKey(this.userOldAddressData[0]['PhoneKey'], this.userOldAddressData[0]['PhoneNumber']));
                }
            }
        });
    }
    getCountries() {
        this.checkoutService
            .getCountriesFromApi()
            .pipe(map((data) => data['response']), first())
            .subscribe((data) => {
            this.countries = data;
            if (data.length >= 1) {
                this.addressingForm.controls['country'].setValue(data[0]['code']);
                this.addressingForm.controls['phoneKey'].setValue(data[0]['phoneKey']);
                this.selectCountry(this.branch && this.branch.country && this.branch.country.code
                    ? this.branch.country.code
                    : data[0]['code']);
            }
        });
        return this.countries;
    }
    /**
     * Represents the next step page shipping when the data sent succesffuly so the end user can access shipping
     * @returns void
     */
    canAccessNextStep() {
        return (() => {
            localStorage.setItem('stepOne', 'true');
            this.shippingGuardCheckout.st.next(true);
            this.router.navigateByUrl(`${this.language['LANGUAGE_CODE']}/checkout/shipping`);
        })();
    }
    /**
     * Represents that the end user can't access the shipping page
     * @returns void
     */
    canNotAccessNextStep() {
        return (() => {
            localStorage.setItem('stepOne', 'false');
        })();
    }
    sendBillingAddressToApi() {
        this.submittedWithBilling = true;
        const billingAddressingData = {
            shippingAddress: {
                firstName: this.addressingForm.controls['firstName'].value,
                lastName: this.addressingForm.controls['lastName'].value,
                street: this.addressingForm.controls['street'].value,
                phoneNumber: this.addressingForm.controls['phoneKey'].value +
                    '-' +
                    this.addressingForm.controls['phoneNumber'].value.replace(/\s/g, ''),
                countryCode: this.addressingForm.controls['country'].value,
                areaCode: this.addressingForm.controls['areaCode'].value,
                city: this.addressingForm.controls['city'].value,
                postcode: '11111',
            },
            billingAddress: {
                firstName: this.billingAddress.controls['billingAddressFirstName'].value,
                lastName: this.billingAddress.controls['billingAddressLastName'].value,
                street: this.billingAddress.controls['billingAddressStreet'].value,
                phoneNumber: this.billingAddress.controls['billingAddressPhoneKey'].value +
                    '-' +
                    this.billingAddress.controls['billingAddressPhoneNumber'].value.replace(/\s/g, ''),
                countryCode: this.billingAddress.controls['billingAddressCountry'].value,
                areaCode: this.billingAddress.controls['billingAdderssAreaCode'].value,
                city: this.billingAddress.controls['billingAddressCity'].value,
                postcode: '11111',
            },
            userEmail: this.addressingForm.controls['userEmail'].value,
            shipping_notes: this.addressingForm.controls['shipping_notes'].value,
            differentBillingAddress: true,
            saveAddress: this.isSaveAddress,
        };
        this.checkoutService
            .sendShippingAddressing(billingAddressingData)
            .pipe(debounceTime(1000), first(), takeUntil(this.destroyed$))
            .subscribe((data) => {
            if (data['status'] === 200) {
                return (() => {
                    localStorage.setItem('stepOne', 'true');
                    this.shippingGuardCheckout.st.next(true);
                    this.router.navigateByUrl(`${this.language['LANGUAGE_CODE']}/checkout/shipping`);
                })();
            }
            else {
                localStorage.setItem('stepOne', 'false');
            }
        }, (err) => {
            if (err['error']['errors']) {
                if (err['error']['errors']['billingAddress']) {
                    this.apiValidationBilling =
                        err['error']['errors']['billingAddress'];
                }
                if (err['error']['errors']['shippingAddress']) {
                    this.apiValidationAddressing =
                        err['error']['errors']['shippingAddress'];
                }
                if (err['error']['errors']['userEmail']) {
                    this.apiValidationAddressing['userEmail'] =
                        err['error']['errors']['userEmail'];
                }
            }
        });
    }
    goToLogin() {
        const redirectUrl = `${this.language['LANGUAGE_CODE']}/checkout/mydetails`;
        localStorage.setItem('redirectUrl', `${redirectUrl}`);
        this.router.navigateByUrl(`${this.language['LANGUAGE_CODE']}/accounts/login?returnUrl=${this.router.url}`);
    }
    isShippingAddressEqualToSelectedAddress() {
        const shippingData = {
            cityName: this.addressingForm.controls['city'].value,
            countryCode: this.addressingForm.controls['country'].value,
            firstName: this.addressingForm.controls['firstName'].value,
            lastName: this.addressingForm.controls['lastName'].value,
            phoneNumber: this.addressingForm.controls['phoneKey'].value +
                this.addressingForm.controls['phoneNumber'].value,
            street: this.addressingForm.controls['street'].value,
        };
        // If number of properties is different,
        // objects are not equivalent
        if (!this.isSaveAddress) {
            return false;
        }
        if (shippingData.firstName !== this.ADDRESS_DATA['FirstName'] ||
            shippingData.lastName !== this.ADDRESS_DATA['LastName'] ||
            shippingData.cityName !== this.ADDRESS_DATA['CityName'] ||
            shippingData.countryCode !== this.ADDRESS_DATA['CountryCode'] ||
            shippingData.phoneNumber !== this.ADDRESS_DATA['PhoneNumber'] ||
            shippingData.street !== this.ADDRESS_DATA['Street']) {
            return true;
        }
        return true;
    }
    updateStreet(full_user_address) {
        this.addressingForm.controls['street'].setValue(full_user_address);
    }
    getAreaAddressString(pos) {
        const google_maps_geocoder = new google.maps.Geocoder();
        google_maps_geocoder.geocode({ location: pos }, (results, status) => {
            let full_user_address = '';
            for (const component of results[0].address_components) {
                full_user_address += component.short_name;
                full_user_address += ',';
            }
            if (full_user_address.charAt(full_user_address.length - 1) === ',') {
                full_user_address = full_user_address.substr(0, full_user_address.length - 1);
            }
            localStorage.setItem('street', full_user_address);
            localStorage.setItem('pos', JSON.stringify(pos));
            this.updateStreet(full_user_address);
        });
    }
    areaCordsValue(event) {
        this.inRange = event.inRange;
        this.areaCoords = event.coords;
        if (this.areaCoords.latitude &&
            this.areaCoords.longitude &&
            this.confService.storeIsMultiLocations.getValue()) {
            if (this.inRange) {
                let pos = {
                    lat: this.areaCoords['latitude'],
                    lng: this.areaCoords['longitude'],
                };
                this.getAreaAddressString(pos);
            }
            else {
                this.updateStreet('');
            }
        }
    }
}
AddressingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AddressingComponent, deps: [{ token: LanguageService }, { token: CheckoutService }, { token: i2.Router }, { token: i1$1.FormBuilder }, { token: ShippingGuardCheckout }, { token: AddressingService }, { token: ConfService }, { token: TranslatePipe }, { token: LoginService }, { token: FacebookPixelService }, { token: i3$1.ToastrService }], target: i0.ɵɵFactoryTarget.Component });
AddressingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: AddressingComponent, selector: "app-addressing", viewQueries: [{ propertyName: "firstNameInput", first: true, predicate: ["firstNameInput"], descendants: true }, { propertyName: "lastNameInput", first: true, predicate: ["lastNameInput"], descendants: true }, { propertyName: "emailInput", first: true, predicate: ["emailInput"], descendants: true }, { propertyName: "phoneInput", first: true, predicate: ["phoneInput"], descendants: true }, { propertyName: "addressInput", first: true, predicate: ["addressInput"], descendants: true }], ngImport: i0, template: "<!--Start Addressing -->\r\n<div class=\"checkout-container\">\r\n  <div class=\"addressing__form__container\">\r\n    <!--Start Have account message if the end user is user and want to go to login-->\r\n    <ng-container *ngIf=\"!isLoggedIn\">\r\n      <p>\r\n        {{ language[\"haveAccount\"] }}\r\n        <a class=\"signin-link\" (click)=\"goToLogin()\">{{ language[\"login\"] }}</a>\r\n        {{ language[\"now\"] }}\r\n      </p>\r\n    </ng-container>\r\n    <!--End Have account message if the end user is user and want to go to login-->\r\n    <!--Start Form for Shipping Addressing and billing Addressing-->\r\n    <div class=\"box__container\" [ngStyle]=\"{ 'background-color': loading ? '#fff' : '' }\">\r\n      <!--Start Loading for the form-->\r\n      <div class=\"spinner-holder\" *ngIf=\"loading\">\r\n        <div class=\"lds-ring\">\r\n          <div></div>\r\n          <div></div>\r\n          <div></div>\r\n          <div></div>\r\n        </div>\r\n      </div>\r\n      <!--End Loading For the form-->\r\n      <div class=\"panel-body\">\r\n        <!--Start Shipping Addressing container-->\r\n        <!--Start user has addressing so he can select from has old address-->\r\n        <div *ngIf=\"isUserHasAddress\" class=\"select-old-address\">\r\n          <div class=\"form-group\">\r\n            <select (change)=\"getSelectAddress($event.target.value)\" class=\"form-control\">\r\n              <option selected value=\"\">\r\n                {{ language[\"formSelectOldAddress\"] }}\r\n              </option>\r\n              <option *ngFor=\"let address of userOldAddressData\" [value]=\"address.ID\">\r\n                {{ address.FullName }} - {{ address.Street }} -\r\n                {{ address.CityName }} -\r\n                {{ address.CountryCode }}\r\n              </option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n        <!--End user has addressing so he can select from has old address-->\r\n        <form (submit)=\"onSubmit()\" [formGroup]=\"addressingForm\">\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-6 col-12 form-group-horzonial\">\r\n              <label for=\"firstName\" #firstNameInput>\r\n                {{ language[\"formFirstName\"] }}\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <input autocomplete=\"false\" #firstname\r\n                (input)=\"validateTextInputs(firstname.value, 'firstName', 'shippingAddress')\" class=\"form-control\"\r\n                formControlName=\"firstName\" id=\"firstName\" maxlength=\"20\" type=\"text\"\r\n                [attr.aria-invalid]=\"addressingForm.get('firstName').invalid\" />\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationAddressing.firstName &&\r\n                  addressingForm.get('firstName').hasError('required') &&\r\n                  addressingForm.get('firstName').invalid\r\n                \">\r\n                {{ apiValidationAddressing.firstName }}\r\n              </p>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  (apiValidationAddressing.firstName == null || undefined) &&\r\n                  addressingForm.get('firstName').hasError('required') &&\r\n                  (addressingForm.get('firstName').touched ||\r\n                    addressingForm.get('firstName').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  (apiValidationAddressing.firstName == null || undefined) &&\r\n                  addressingForm.get('firstName').hasError('pattern') &&\r\n                  (addressingForm.get('firstName').touched ||\r\n                    addressingForm.get('firstName').dirty)\r\n                \">\r\n                {{ language[\"value_pat\"] }}\r\n              </p>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationAddressing.firstName &&\r\n                  addressingForm.get('firstName').hasError('pattern') &&\r\n                  addressingForm.get('firstName').invalid\r\n                \">\r\n                {{ apiValidationAddressing.firstName }}\r\n              </p>\r\n            </div>\r\n            <div class=\"col-md-6 col-12 form-group-horzonial\">\r\n              <label for=\"lastName\" #lastNameInput>\r\n                {{ language[\"formLastName\"] }}\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <input #lastName (input)=\"\r\n                  validateTextInputs(\r\n                    lastName.value,\r\n                    'lastName',\r\n                    'shippingAddress'\r\n                  )\r\n                \" class=\"form-control\" formControlName=\"lastName\" id=\"lastName\" maxLength=\"20\" type=\"text\"\r\n                [attr.aria-invalid]=\"addressingForm.get('lastName').invalid\" />\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationAddressing.lastName &&\r\n                  addressingForm.get('lastName').hasError('required')\r\n                \">\r\n                {{ apiValidationAddressing.lastName }}\r\n              </p>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  (apiValidationAddressing.lastName == null || undefined) &&\r\n                  addressingForm.get('lastName').hasError('required') &&\r\n                  (addressingForm.get('lastName').touched ||\r\n                    addressingForm.get('lastName').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  (apiValidationAddressing.lastName == null || undefined) &&\r\n                  addressingForm.get('lastName').hasError('pattern')\r\n                \">\r\n                {{ language[\"value_pat\"] }}\r\n              </p>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationAddressing.lastName &&\r\n                  addressingForm.get('lastName').hasError('pattern')\r\n                \">\r\n                {{ apiValidationAddressing.lastName }}\r\n              </p>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group-horzonial\" [ngClass]=\"{ hideEmail: hideEmailField }\">\r\n            <label for=\"userEmail\" #emailInput>\r\n              {{ language[\"formEmail\"] }}\r\n              <span *ngIf=\"isAddressingEmailRequired\" class=\"required\">*</span>\r\n            </label>\r\n            <input class=\"form-control\" formControlName=\"userEmail\" id=\"userEmail\" type=\"email\"\r\n              [attr.aria-invalid]=\"addressingForm.get('userEmail').invalid\" />\r\n\r\n            <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                (apiValidationAddressing.userEmail == null || undefined) &&\r\n                addressingForm.get('userEmail').hasError('pattern') &&\r\n                addressingForm.get('userEmail').touched &&\r\n                  addressingForm.get('userEmail').dirty\r\n              \">\r\n              {{ language[\"email_pat\"] }}\r\n            </p>\r\n\r\n            <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                apiValidationAddressing.userEmail &&\r\n                addressingForm.get('userEmail').hasError('pattern')\r\n              \">\r\n              {{ apiValidationAddressing.userEmail }}\r\n            </p>\r\n\r\n            <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                (apiValidationAddressing.userEmail == null || undefined) &&\r\n                addressingForm.get('userEmail').hasError('required') &&\r\n                (addressingForm.get('userEmail').touched ||\r\n                  addressingForm.get('userEmail').dirty)\r\n              \">\r\n              {{ language[\"value_req\"] }}\r\n            </p>\r\n\r\n            <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                apiValidationAddressing.userEmail &&\r\n                addressingForm.get('userEmail').hasError('required')\r\n              \">\r\n              {{ apiValidationAddressing.userEmail }}\r\n            </p>\r\n          </div>\r\n          <div class=\"form-group-horzonial\">\r\n            <label for=\"phoneNumber\" #phoneInput>\r\n              {{ language[\"formPhoneNumber\"] }}\r\n              <span class=\"required\">*</span>\r\n            </label>\r\n\r\n            <div class=\"input-group\">\r\n              <div class=\"phone-country-selector\">\r\n                <ng-select [selectOnTab]=\"true\" [items]=\"countries\" formControlName=\"phoneKey\" bindValue=\"phoneKey\"\r\n                  bindLabel=\"code\" placeholder=\"code\" class=\"w-100\" [clearable]=\"false\">\r\n                  <ng-template ng-label-tmp let-item=\"item\">\r\n                    <ng-container *ngIf=\"item.phoneKey\">\r\n                      <img lazyLoad=\"{{'https://flagcdn.com/h20/' + item.code +'.png' |lowercase}} \" width=\"20\"/>\r\n                      {{ item.phoneKey }}\r\n                    </ng-container>\r\n                  </ng-template>\r\n\r\n                  <ng-template ng-option-tmp let-item=\"item\">\r\n                    <img lazyLoad=\"{{'https://flagcdn.com/h20/' + item.code +'.png' |lowercase}} \" width=\"20\"/>\r\n                    {{ item.code }}\r\n                  </ng-template>\r\n                </ng-select>\r\n              </div>\r\n              <!-- (keypress)=\"numberOnly($event)\" -->\r\n              <input  class=\"form-control mx-1\" formControlName=\"phoneNumber\"\r\n                id=\"phoneNumber\" type=\"text\"  [class.is-invalid]=\"addressingForm.get('phoneNumber').invalid && addressingForm.get('phoneNumber').touched\" />\r\n            </div>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\"\r\n              *ngIf=\"\r\n              (apiValidationAddressing.userEmail == null || undefined) &&\r\n              addressingForm.get('phoneNumber').hasError('required') &&\r\n              (addressingForm.get('phoneNumber').touched ||\r\n                addressingForm.get('phoneNumber').dirty)\r\n            \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n              <!-- <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n              (apiValidationAddressing.userEmail == null || undefined) &&\r\n              addressingForm.get('phoneNumber').hasError('pattern') &&\r\n              addressingForm.get('phoneNumber').touched &&\r\n                addressingForm.get('phoneNumber').dirty\r\n            \">\r\n            {{ language[\"enterValidPhoneNumber\"] }}\r\n          </p> -->\r\n          <p role=\"alert\" class=\"text-alert alert alert-danger\"  *ngIf=\"(apiValidationAddressing.userEmail == null || undefined) && addressingForm.get('phoneNumber').errors?.invalidPhoneNumber &&\r\n          addressingForm.get('phoneNumber').touched &&\r\n            addressingForm.get('phoneNumber').dirty\"> {{ language[\"enterValidPhoneNumber\"] }}</p>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"apiValidationAddressing.phoneNumber\">\r\n                {{ apiValidationAddressing.phoneNumber }}\r\n              </p>\r\n            </div>\r\n\r\n          <div class=\"form-row\">\r\n            <div class=\"col-md-4 col-12 form-group-horzonial\" *ngIf=\"!showField\">\r\n              <label for=\"shippingcountry\">\r\n                {{ language[\"formCountry\"] }}\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <select (change)=\"selectCountry($event.target.value)\" formControlName=\"country\" id=\"shippingcountry\"\r\n                class=\"form-control\" [attr.aria-invalid]=\"addressingForm.get('country').invalid\">\r\n                <option value=\"\" disabled selected>\r\n                  {{ language[\"selectCountry\"] }}\r\n                </option>\r\n                <option *ngFor=\"let country of countries\" [value]=\"country.code\">\r\n                  {{ country.name }}\r\n                </option>\r\n              </select>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  (apiValidationAddressing.countryCode == null || undefined) &&\r\n                  addressingForm.get('country').hasError('required') &&\r\n                  (addressingForm.get('country').touched ||\r\n                    addressingForm.get('country').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationAddressing.countryCode &&\r\n                  addressingForm.get('country').hasError('required')\r\n                \">\r\n                {{ apiValidationAddressing.countryCode }}\r\n              </p>\r\n            </div>\r\n            <div class=\"col-md-4 col-12 form-group-horzonial\" *ngIf=\"!showField\">\r\n              <label for=\"city\">\r\n                {{ language[\"city\"] }}\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <select class=\"form-control\" formControlName=\"city\" id=\"city\" (change)=\"selectCity($event.target.value)\"\r\n                [attr.aria-invalid]=\"addressingForm.get('city').invalid\" [attr.disabled]=\"'true'\">\r\n                <option disabled hidden>{{ language[\"city\"] }}</option>\r\n                <option *ngFor=\"let city of cities\" [value]=\"city.code\">\r\n                  {{ city | translate: \"name\" }}\r\n                </option>\r\n              </select>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  (apiValidationAddressing.city == null || undefined) &&\r\n                  addressingForm.get('city').hasError('required') &&\r\n                  (addressingForm.get('city').touched ||\r\n                    addressingForm.get('city').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationAddressing.city &&\r\n                  addressingForm.get('city').hasError('required')\r\n                \">\r\n                {{ apiValidationAddressing.city }}\r\n              </p>\r\n            </div>\r\n            <div class=\"col-md-4 col-12 form-group-horzonial\" *ngIf=\"!showField\">\r\n              <label for=\"areaCode\">\r\n                {{ language[\"area\"] }}\r\n                <span class=\"required\">*</span>\r\n\r\n              </label>\r\n              <select class=\"form-control\" formControlName=\"areaCode\" id=\"areaCode\"\r\n                (change)=\"getAreaCode($event.target.value)\" [attr.aria-invalid]=\"addressingForm.get('areaCode').invalid\"\r\n                [attr.disabled]=\"'true'\">\r\n                <option disabled hidden>{{ language[\"area\"] }}</option>\r\n                <option *ngFor=\"let area of areas\" [value]=\"area.code\">\r\n                  {{ area | translate: \"name\" }}\r\n                </option>\r\n              </select>\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  (apiValidationAddressing.areaCode == null || undefined) &&\r\n                  addressingForm.get('areaCode').hasError('required') &&\r\n                  (addressingForm.get('areaCode').touched ||\r\n                    addressingForm.get('areaCode').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationAddressing.areaCode &&\r\n                  addressingForm.get('areaCode').hasError('required')\r\n                \">\r\n                {{ apiValidationAddressing.areaCode }}\r\n              </p>\r\n            </div>\r\n            <div class=\"col-12 form-group-horzonial\" *ngIf=\"showField\">\r\n              <label for=\"areaCode\">\r\n                {{ language['LANGUAGE_CODE'] === 'en_US' ? \"Sales Person\" : \"\u0623\u0633\u0645 \u0627\u0644\u0645\u0646\u062F\u0648\u0628\" }}\r\n\r\n              </label>\r\n              <input class=\"form-control\" formControlName=\"salesPerson\" id=\"salesPerson\" type=\"text\" />\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  addressingForm.get('salesPerson').hasError('required') &&\r\n                  (addressingForm.get('salesPerson').touched ||\r\n                    addressingForm.get('salesPerson').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n            </div>\r\n        \r\n          </div>\r\n          <!--separateFloorApp -->\r\n          <div class=\"form-row\" *ngIf=\"separateFloorApp\">\r\n            <div class=\"col-12 form-group-horzonial\" [ngClass]=\"showNeighborhoodContent ? 'col-md-4' : 'col-md-2' \">\r\n              <label for=\"shippingbuilding\">\r\n                {{ language[\"address-building\"] }}\r\n\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <input class=\"form-control\" formControlName=\"building\" id=\"building\"  type=\"text\"\r\n\r\n              oninput=\"validity.valid||(value='');\"  />\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  addressingForm.get('building').hasError('required')  &&\r\n                  (addressingForm.get('building').touched ||\r\n                    addressingForm.get('building').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  addressingForm.get('building').hasError('pattern')  &&\r\n                  (addressingForm.get('building').touched ||\r\n                    addressingForm.get('building').dirty)\r\n                \">\r\n                {{  language[\"OnlyAlphabetsNumbers\"] || 'Only alphabets, numbers'  }}\r\n              </p>\r\n            </div>\r\n            <div class=\" col-12 form-group-horzonial\"  [ngClass]=\"showNeighborhoodContent ? 'col-md-4' : 'col-md-2' \">\r\n              <label for=\"floor\">\r\n                {{ language[\"address-floor\"] }}\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <input class=\"form-control\" formControlName=\"floor\" id=\"floor\" type=\"number\" min=\"0\"\r\n                oninput=\"validity.valid||(value='');\" required />\r\n                <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                addressingForm.get('floor').hasError('required')  &&\r\n                (addressingForm.get('floor').touched ||\r\n                  addressingForm.get('floor').dirty)\r\n              \">\r\n              {{ language[\"value_req\"] }}\r\n            </p>\r\n            </div>\r\n\r\n            <div class=\"col-12 form-group-horzonial\"  [ngClass]=\"showNeighborhoodContent ? 'col-md-4' : 'col-md-2' \">\r\n              <label for=\"areaCode\">\r\n                {{ language[\"address-appartement\"] }}\r\n\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <input class=\"form-control\" formControlName=\"apartement\" id=\"apartement\" type=\"text\"\r\n              oninput=\"validity.valid||(value='');\"\r\n              />\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  addressingForm.get('apartement').hasError('required')  &&\r\n                  (addressingForm.get('apartement').touched ||\r\n                    addressingForm.get('apartement').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n              addressingForm.get('apartement').hasError('pattern') &&\r\n                  (addressingForm.get('apartement').touched ||\r\n                    addressingForm.get('apartement').dirty)\r\n            \">\r\n            {{  language[\"OnlyAlphabetsNumbers\"] || 'Only alphabets, numbers'  }}\r\n          </p>\r\n            </div>\r\n            <div class=\"col-md-6 col-12 form-group-horzonial\" *ngIf=\"!showNeighborhoodContent\">\r\n              <label for=\"areaCode\">\r\n                {{ language[\"address-neighborhood\"] }}\r\n\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <input class=\"form-control\" formControlName=\"neighbourhood\" id=\"neighbourhood\" type=\"text\" />\r\n\r\n              <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  addressingForm.get('neighbourhood').hasError('required') &&\r\n                  (addressingForm.get('neighbourhood').touched ||\r\n                    addressingForm.get('neighbourhood').dirty)\r\n                \">\r\n                {{ language[\"value_req\"] }}\r\n              </p>\r\n            </div>\r\n           \r\n          </div>\r\n          <!--separateFloorApp-->\r\n\r\n          <!-- GeoFence Map component -->\r\n\r\n\r\n          <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"!inRange\">\r\n            {{ language[\"OutofRange\"] }}\r\n          </p>\r\n\r\n          <label *ngIf=\"HideMap\" style=\"display: inline-block;margin-bottom: 0.5rem;background-color: hsl(0deg 0% 96%); padding: 5px 10px ;\r\n          border: 1px  solid #ddd;font-weight: 510; font-size: 12px;\" [ngStyle]=\"{ 'color': showNeighborhoodContent ? 'red' : '', 'border-color': showNeighborhoodContent ? 'red' : '' }\" for=\"map_area\">\r\n             <img style=\"margin-left:5px;margin-right:5px\" src=\"assets/checkout-header/attention.png\" alt=\"attention\"> {{ language[\"select_map_area\"] || \"Please add your GPS pin location for more accuracy \" + \"(optional)\"}}\r\n\r\n            <!-- <span class=\"required\">*</span> -->\r\n          </label>\r\n\r\n          <app-geofence *ngIf=\"HideMap\" id=\"map_area\" [area]=\"area\" [pos]=\"pos\" [defaultGeoLocation]=\"defaultGeoLocation\" [allowGeofence]=\"allowGeofence\"\r\n            (areaCords)=\"areaCordsValue($event)\"></app-geofence>\r\n\r\n          <div class=\"form-group-horzonial\" #addressInput>\r\n            <label *ngIf=\"!separateFloorApp\" for=\"shippingStreet\">\r\n              {{ language[\"ProfilecheckoutAddress\"] }}\r\n              <span class=\"required\">*</span>\r\n            </label>\r\n            <label *ngIf=\"separateFloorApp\" for=\"shippingStreet\">\r\n              {{ language[\"address-AdditionalInfo\"] }}\r\n\r\n              <span class=\"required\">*</span>\r\n            </label>\r\n            <textarea formControlName=\"street\" id=\"shippingStreet\" class=\"form-control\" rows=\"10\"\r\n              [attr.aria-invalid]=\"addressingForm.get('street').invalid\"></textarea>\r\n\r\n            <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                (apiValidationAddressing.street == null || undefined) &&\r\n                addressingForm.get('street').hasError('required') &&\r\n                (addressingForm.get('street').touched ||\r\n                  addressingForm.get('street').dirty)\r\n              \">\r\n              {{ language[\"value_req\"] }}\r\n            </p>\r\n\r\n            <p role=\"alert\" class=\"text-alert alert alert-danger\" *ngIf=\"\r\n            (addressingForm.get('street').touched ||\r\n            addressingForm.get('street').dirty)&& (this.addressingForm.get('street').value.length<5)\r\n              \">\r\n              This value is too short. It should have 5 characters or more.\r\n            </p>\r\n          </div>\r\n          <div class=\"form-group-horzonial\">\r\n            <label for=\"shippingNotes\" *ngIf=\"!showContent\">\r\n              {{ language[\"orderNotes\"] }}\r\n            </label>\r\n            <label for=\"shippingNotes\" *ngIf=\"showContent\">\r\n              {{ (language['LANGUAGE_CODE'] === 'en_US' ? \"Notes\" : \"\u0645\u0644\u0627\u062D\u0638\u0627\u062A\") }}\r\n            </label>\r\n            <textarea type=\"text\" class=\"form-control\" id=\"shippingNotes\" rows=\"10\" formControlName=\"shipping_notes\"\r\n              [attr.aria-invalid]=\"addressingForm.get('shipping_notes').invalid\"></textarea>\r\n          </div>\r\n        </form>\r\n        <!--End Shipping Addressing Container-->\r\n        <div *ngIf=\"isLoggedIn\" class=\"row\">\r\n          <div class=\"col-12\">\r\n            <div class=\"createOrUpdateAddress\">\r\n              <div class=\"custom-control custom-checkbox\">\r\n                <input (change)=\"getUpdatedAddress($event)\" class=\"custom-control-input\" id=\"customControlAutosizing\"\r\n                  type=\"checkbox\" [disabled]=\"isSelectOldAddress\" />\r\n                <label class=\"custom-control-label\" for=\"customControlAutosizing\">{{ language[\"formSaveAddress\"]\r\n                  }}</label>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-12\">\r\n            <div class=\"createOrUpdateAddress\">\r\n              <div class=\"custom-control custom-checkbox\" *ngIf=\"allowConditionTerms\">\r\n                <input [(ngModel)]=\"acceptTermsConditions\" class=\"custom-control-input\" id=\"customControlAutosizing2\"\r\n                  type=\"checkbox\" />\r\n                <label class=\"custom-control-label\" for=\"customControlAutosizing2\">\r\n                  {{ language[\"reading_Accecpt\"] }}\r\n                  <a [routerLink]=\"[\r\n                      '/',\r\n                      language['LANGUAGE_CODE'],\r\n                      'page',\r\n                      termsAndConditionsPage\r\n                    ]\">{{ language[\"termsAndCondition\"] }}</a>\r\n                </label>\r\n              </div>\r\n              <small class=\"text-danger\" *ngIf=\"!isAcceptTermsConditions\">\r\n                {{ language[\"value_req\"] }}\r\n              </small>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"anotherBilling\" *ngIf=\"!showThis\">\r\n          <label class=\"switch\">\r\n            <input (click)=\"showBillingAddress($event)\" class=\"toggleButtont\" type=\"checkbox\" id=\"toggle\"\r\n              [checked]=\"showAnotherBilling\" />\r\n            <span class=\"knob\"></span>\r\n            <p class=\"switch-text\">\r\n              {{ language[\"formUserBillingAddress\"] }}\r\n            </p>\r\n          </label>\r\n        </div>\r\n        <!--Start Another Billind Address For User-->\r\n        <ng-template [ngIf]=\"showAnotherBilling\">\r\n          <form (submit)=\"onSubmit()\" [formGroup]=\"billingAddress\" [@hideShowAnimator]=\"showAnotherBilling\"\r\n            class=\"position-relative\">\r\n            <div class=\"spinner-holder\" *ngIf=\"billingLoading\">\r\n              <div class=\"lds-ring\">\r\n                <div></div>\r\n                <div></div>\r\n                <div></div>\r\n                <div></div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-row\">\r\n              <div class=\"form-group-horzonial col-md-6 col-12\">\r\n                <label for=\"billingFirstName\">\r\n                  {{ language[\"formFirstName\"] }}\r\n                  <span class=\"required\">*</span>\r\n                </label>\r\n                <input #firstName (input)=\"\r\n                    validateTextInputs(\r\n                      firstName.value,\r\n                      'billingAddressFirstName',\r\n                      'billingAddress'\r\n                    )\r\n                  \" class=\"form-control\" formControlName=\"billingAddressFirstName\" type=\"text\" id=\"billingFirstName\"\r\n                  [attr.aria-invalid]=\"\r\n                    billingAddress.get('billingAddressFirstName').invalid\r\n                  \" />\r\n                <p class=\"text-alert alert alert-danger alert alert-danger\" *ngIf=\"\r\n                    apiValidationBilling.firstName &&\r\n                    billingAddress.get('billingAddressFirstName').invalid\r\n                  \" role=\"alert\">\r\n                  {{ apiValidationBilling.firstName }}\r\n                </p>\r\n              </div>\r\n              <div class=\"form-group-horzonial col-md-6 col-12\">\r\n                <label for=\"billingLastName\">\r\n                  {{ language[\"formLastName\"] }}\r\n                  <span class=\"required\">*</span>\r\n                </label>\r\n                <input #lastName (input)=\"\r\n                    validateTextInputs(\r\n                      lastName.value,\r\n                      'billingAddressLastName',\r\n                      'billingAddress'\r\n                    )\r\n                  \" class=\"form-control\" formControlName=\"billingAddressLastName\" type=\"text\" id=\"billingLastName\"\r\n                  [attr.aria-invalid]=\"\r\n                    billingAddress.get('billingAddressLastName').invalid\r\n                  \" />\r\n                <p class=\"text-alert alert alert-danger alert alert-danger\" *ngIf=\"\r\n                    apiValidationBilling.lastName &&\r\n                    billingAddress.get('billingAddressLastName').invalid\r\n                  \" role=\"alert\">\r\n                  {{ apiValidationBilling.lastName }}\r\n                </p>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group-horzonial\">\r\n              <label for=\"billingPhoneNumber\">\r\n                {{ language[\"formPhoneNumber\"] }}\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <div class=\"input-group\">\r\n                <div class=\"phone-country-selector\">\r\n                  <ng-select [selectOnTab]=\"true\" [items]=\"countries\" formControlName=\"billingAddressPhoneKey\"\r\n                    bindValue=\"phoneKey\" bindLabel=\"code\" placeholder=\"Code\" class=\"w-100\" [clearable]=\"false\">\r\n                    <ng-template ng-label-tmp let-item=\"item\">\r\n                      <ng-container *ngIf=\"item.phoneKey\">\r\n                        <img lazyLoad=\"{{'https://flagcdn.com/h20/' + item.code +'.png' |lowercase}} \" />\r\n                        {{ item.phoneKey }}\r\n                      </ng-container>\r\n                    </ng-template>\r\n\r\n                    <ng-template ng-option-tmp let-item=\"item\">\r\n                      <img lazyLoad=\"{{'https://flagcdn.com/h20/' + item.code +'.png' |lowercase}} \" />\r\n                      {{ item.code }}\r\n                    </ng-template>\r\n                  </ng-select>\r\n                </div>\r\n                <!-- (keypress)=\"numberOnly($event)\" -->\r\n                <input  class=\"form-control mx-1\"\r\n                  formControlName=\"billingAddressPhoneNumber\" id=\"billingPhoneNumber\" type=\"text\"\r\n                   />\r\n              </div>\r\n\r\n              <div *ngIf=\"\r\n                  billingAddress.get('billingAddressPhoneNumber').touched ||\r\n                  billingAddress.get('billingAddressPhoneNumber').dirty\r\n                \">\r\n                <p class=\"text-alert alert alert-danger\" *ngIf=\"apiValidationBilling.phoneNumber\" role=\"alert\">\r\n                  {{ apiValidationBilling.phoneNumber }}\r\n                </p>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-row\">\r\n              <div class=\"form-group-horzonial col-md-4 col-12\">\r\n                <label for=\"billingCountry\">\r\n                  {{ language[\"formCountry\"] }}\r\n                  <span class=\"required\">*</span>\r\n                </label>\r\n                <select (change)=\"selectCountryForBilling($event.target.value)\" class=\"form-control\"\r\n                  formControlName=\"billingAddressCountry\" id=\"billingCountry\" [attr.aria-invalid]=\"\r\n                    billingAddress.get('billingAddressCountry').invalid\r\n                  \">\r\n                  <option value=\"\">{{ language[\"selectCountry\"] }}</option>\r\n                  <option *ngFor=\"let country of countries\" [value]=\"country.code\">\r\n                    {{ country.name }}\r\n                  </option>\r\n                </select>\r\n                <p class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                    apiValidationBilling.countryCode &&\r\n                    billingAddress.get('billingAddressCountry').invalid\r\n                  \" role=\"alert\">\r\n                  {{ apiValidationBilling.countryCode }}\r\n                </p>\r\n              </div>\r\n              <div class=\"col-md-4 col-12 form-group-horzonial\">\r\n                <label for=\"billingAddressCity\">\r\n                  {{ language[\"city\"] }}\r\n                  <span class=\"required\">*</span>\r\n                </label>\r\n                <select class=\"form-control\" formControlName=\"billingAddressCity\" id=\"billingAddressCity\"\r\n                  (change)=\"selectCityForBilling($event.target.value)\" [attr.aria-invalid]=\"\r\n                    billingAddress.get('billingAddressCity').invalid\r\n                  \">\r\n                  <option value=\"\">{{ language[\"city\"] }}</option>\r\n                  <option *ngFor=\"let city of citiesForBilling\" [value]=\"city.code\">\r\n                    {{ city | translate: \"name\" }}\r\n                  </option>\r\n                </select>\r\n                <p class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                    apiValidationBilling.city &&\r\n                    billingAddress.get('billingAddressCity').invalid\r\n                  \" role=\"alert\">\r\n                  {{ apiValidationBilling.city }}\r\n                </p>\r\n              </div>\r\n              <div class=\"col-md-4 col-12 form-group-horzonial\">\r\n                <label for=\"billingAdderssAreaCode\">\r\n                  {{ language[\"area\"] }}\r\n                  <span class=\"required\">*</span>\r\n                </label>\r\n                <select class=\"form-control\" formControlName=\"billingAdderssAreaCode\" id=\"billingAdderssAreaCode\"\r\n                  [attr.aria-invalid]=\"\r\n                    billingAddress.get('billingAdderssAreaCode').invalid\r\n                  \">\r\n                  <option value=\"\">{{ language[\"area\"] }}</option>\r\n                  <option *ngFor=\"let area of areasBilling\" [value]=\"area.code\">\r\n                    {{ area | translate: \"name\" }}\r\n                  </option>\r\n                </select>\r\n                <p class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                    apiValidationBilling.areaCode &&\r\n                    billingAddress.get('billingAdderssAreaCode').invalid\r\n                  \">\r\n                  {{ apiValidationBilling.areaCode }}\r\n                </p>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group-horzonial\">\r\n              <label for=\"billingStreetAddress\">\r\n                {{ language[\"address\"] }}\r\n                <span class=\"required\">*</span>\r\n              </label>\r\n              <textarea formControlName=\"billingAddressStreet\" class=\"form-control\" rows=\"10\" id=\"billingStreetAddress\"\r\n                [attr.aria-invalid]=\"\r\n                  billingAddress.get('billingAddressStreet').invalid\r\n                \"></textarea>\r\n              <p class=\"text-alert alert alert-danger\" *ngIf=\"\r\n                  apiValidationBilling.street &&\r\n                  billingAddress.get('billingAddressStreet').invalid\r\n                \" role=\"alert\">\r\n                {{ apiValidationBilling.street }}\r\n              </p>\r\n            </div>\r\n          </form>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"alert alert-danger\" *ngIf=\"itemUnAvaliable\">{{language['Remove_Checkout_Items']}}</div>\r\n  <div class=\"submit-btn\">\r\n    <button  class=\"btn btn-continue\" (click)=\"onSubmit()\">\r\n      {{ language[\"continue\"] }}\r\n      <img src=\"assets/checkout-header/arrow1.png\" class=\"icon-arrow\" />\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [":host select,:host option{cursor:pointer}:host .checkout-container{position:relative}:host .checkout-container .addressing__form__container>p{margin-bottom:1rem}:host .signin-link{color:#00a651;padding:0 5px;text-decoration:underline}:host .signin-link:hover{cursor:pointer}:host .box__container{background:#fff;box-shadow:0 0 10px #0000001a;border-radius:10px;min-height:670px}:host .box__container .panel-body{padding:20px}:host .box__container .panel-body .hideEmail{display:none!important}:host .box__container .panel-body .form-control{background-color:#fff;height:4rem;border:1px solid #c6d0e5;border-radius:5px;transition:.3s linear;font-size:14px;outline:none;box-shadow:none}:host .box__container .panel-body .form-control:focus{border:1px solid var(--main-color, var(--main-color, orange))}:host .box__container .panel-body textarea.form-control{height:120px;padding:10px}:host .box__container .panel-body .form-group-horzonial{margin-bottom:12px}:host .box__container .panel-body .form-group-horzonial .required{color:red;font-weight:700}:host .box__container .panel-body label{font-size:14px;font-weight:600}:host .switch{position:relative;height:25px;cursor:pointer}:host .switch input[type=checkbox]{display:none}:host .switch input:checked+.knob{animation:colorChange .2s linear forwards}:host .switch input:checked+.knob:before{animation:turnON .2s linear forwards}:host .switch .switch-text{margin-left:65px;font-weight:bold;position:relative;top:3px}[dir=rtl] :host .switch .switch-text{margin-left:0;margin-right:65px}:host .knob{position:absolute;top:0;left:0;right:0;bottom:0;background-color:#ccc;border-radius:26px;width:53px}:host .knob:before{position:absolute;background-color:#fff;content:\"\";left:2px;top:2.5px;width:20px;height:20px;border-radius:50%}:host .createOrUpdateAddress{float:left;margin:10px 0}[dir=rtl] :host .createOrUpdateAddress{float:right}:host .custom-checkbox .custom-control-label{padding-left:10px}[dir=rtl] :host .custom-checkbox .custom-control-label{padding-left:0;padding-right:20px}:host .custom-checkbox .custom-control-label:before{width:1.5rem;height:1.5rem}[dir=rtl] :host .custom-checkbox .custom-control-label:before{right:0}:host .custom-checkbox .custom-control-label:after{width:1.5rem;height:1.5rem}[dir=rtl] :host .custom-checkbox .custom-control-label:after{right:0}:host .custom-checkbox .custom-control-label a{font-size:14px}:host .anotherBilling{margin-bottom:12px}:host .spinner-holder{position:absolute;background:transparent;height:100%;width:100%;z-index:6666;top:0;bottom:0;margin:auto 0}:host .phone-country-selector{max-width:30%;min-width:10%}:host .phone-country-selector ::ng-deep .ng-placeholder{font-size:12px}:host .phone-country-selector ::ng-deep .ng-select.ng-select-focused.ng-touched.ng-invalid>.ng-select-container{border:1px solid red}:host .phone-country-selector .ng-touched.ng-invalid:not(form){border:1px solid red}:host .w-74{width:74%!important}@keyframes colorChange{0%{background-color:#ccc}50%{background-color:#09f}to{background-color:#09f}}@keyframes turnON{0%{transform:translate(0)}to{transform:translate(29.26px)}}::ng-deep .ng-select.ng-select-single .ng-select-container{height:4rem}.form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}\n"], components: [{ type: i5$1.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { type: GeofenceComponent, selector: "app-geofence", inputs: ["area", "defaultGeoLocation", "pos", "allowGeofence"], outputs: ["areaCords"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i1$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5$1.ɵh, selector: "[ng-label-tmp]" }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i5$1.ɵf, selector: "[ng-option-tmp]" }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i1$1.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i1$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "lowercase": i6.LowerCasePipe, "translate": TranslatePipe }, animations: [routerSildeStateTrigger, showAndHideElementAnimation] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AddressingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-addressing',
                    templateUrl: './addressing.component.html',
                    styleUrls: ['./addressing.component.scss'],
                    animations: [routerSildeStateTrigger, showAndHideElementAnimation],
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CheckoutService }, { type: i2.Router }, { type: i1$1.FormBuilder }, { type: ShippingGuardCheckout }, { type: AddressingService }, { type: ConfService }, { type: TranslatePipe }, { type: LoginService }, { type: FacebookPixelService }, { type: i3$1.ToastrService }]; }, propDecorators: { firstNameInput: [{
                type: ViewChild,
                args: ['firstNameInput', { static: false }]
            }], lastNameInput: [{
                type: ViewChild,
                args: ['lastNameInput', { static: false }]
            }], emailInput: [{
                type: ViewChild,
                args: ['emailInput', { static: false }]
            }], phoneInput: [{
                type: ViewChild,
                args: ['phoneInput', { static: false }]
            }], addressInput: [{
                type: ViewChild,
                args: ['addressInput', { static: false }]
            }] } });

function routerTransition() {
    return trigger('routerAnimation', [
        // LEFT TO RIGHT AKA RESET
        transition('* => 0', [
            // Initial state of new route
            query(':enter', style({
                position: 'fixed',
                width: '100%',
                zIndex: '1000',
                transform: 'translateX(-100%)'
            }), { optional: true }),
            // move page off screen right on leave
            query(':leave', animate('500ms ease', style({
                position: 'fixed',
                width: '100%',
                zIndex: '1000',
                opacity: 0,
                transform: 'translateX(100%)',
            })), { optional: true }),
            // move page in screen from left to right
            query(':enter', animate('500ms ease', style({
                opacity: 1,
                transform: 'translateX(0%)'
            })), { optional: true }),
        ]),
        // LEFT TO RIGHT AKA PREVIOUS
        transition('* => 1', [
            // Initial state of new route
            query(':enter', style({
                position: 'fixed',
                width: '100%',
                transform: 'translateX(-100%)'
            }), { optional: true }),
            // move page off screen right on leave
            query(':leave', animate('500ms ease', style({
                position: 'fixed',
                width: '100%',
                transform: 'translateX(100%)',
            })), { optional: true }),
            // move page in screen from left to right
            query(':enter', animate('500ms ease', style({
                opacity: 1,
                transform: 'translateX(0%)'
            })), { optional: true }),
        ]),
        // RIGHT TO LEFT AKA NEXT
        transition('* => 2', [
            // Initial state of new route
            query(':enter', style({
                position: 'fixed',
                width: '100%',
                transform: 'translateX(100%)'
            }), { optional: true }),
            // move page off screen right on leave
            query(':leave', animate('500ms ease', style({
                position: 'fixed',
                width: '100%',
                transform: 'translateX(-100%)',
            })), { optional: true }),
            // move page in screen from left to right
            query(':enter', animate('500ms ease', style({
                opacity: 1,
                transform: 'translateX(0%)'
            })), { optional: true }),
        ])
    ]);
}

class NavigationService {
    constructor(router) {
        this.router = router;
        this.router
            .events
            .subscribe((event) => {
            if (event instanceof ActivationEnd) {
                const snapshot = event.snapshot;
                if (snapshot.data.num) {
                    this.lastValue = this.newValue;
                    this.newValue = snapshot.data.num;
                    this.animationValue = this.getAnimationNumber(this.lastValue, this.newValue);
                }
            }
        });
    }
    getAnimationNumber(lastValue, newValue) {
        let result = 0;
        if (lastValue && newValue) {
            result = 2;
            if (lastValue) {
                if (newValue > lastValue) {
                    result = 2;
                }
                else {
                    result = 1;
                }
            }
            else {
                result = 1;
            }
        }
        return result;
    }
}
NavigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NavigationService, deps: [{ token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
NavigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NavigationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i2.Router }]; } });

class SummaryComponent {
    constructor(checkoutService, languageService, breakpointObserver, confService) {
        this.checkoutService = checkoutService;
        this.languageService = languageService;
        this.breakpointObserver = breakpointObserver;
        this.confService = confService;
        this.isMoreThanItem = false;
        this.language = {};
        this.checkoutItemSummary = {};
        this.getImage = ProductService.getImage;
        this.adjustments = [];
        this.showCloseBtn = false;
        this.unitPriceTotal = 0;
        this.itmesAdjustmentsTotal = 0;
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.showContent = (this.id == 12849 || this.id == 12839) ? true : false;
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.checkoutService.getFullyCheckoutData()
            .subscribe((data) => {
            this.orderSummary = data;
            console.log(data);
            if (data.items.length > 4) {
                this.isMoreThanItem = true;
            }
            this.checkoutService.getItemsAdjustment(this.orderSummary, this.adjustments);
            this.checkoutService.getOrderSummary(this.orderSummary, this.checkoutItemSummary);
            this.unitPriceTotal = 0;
            this.itmesAdjustmentsTotal = 0;
            for (const item of this.orderSummary.items) {
                this.unitPriceTotal += item.unitPrice * item.quantity;
                let unitAdjustmentsTotal = 0; //per itme
                for (const unit of item.units) {
                    unitAdjustmentsTotal += Math.abs(unit.adjustmentsTotal);
                }
                this.itmesAdjustmentsTotal += unitAdjustmentsTotal; //you can think of it as the total promotion price of all itmes
            }
        });
        this.breakpointObserver
            .observe(['(max-width: 661px)'])
            .subscribe((state) => {
            if (state.matches) {
                this.hideSummary = false;
                this.showCloseBtn = true;
            }
            else {
                this.hideSummary = true;
            }
        });
    }
    showSummary() {
        this.hideSummary = !this.hideSummary;
    }
    closeSummary() {
        this.hideSummary = false;
    }
}
SummaryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SummaryComponent, deps: [{ token: CheckoutService }, { token: LanguageService }, { token: i4.BreakpointObserver }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
SummaryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: SummaryComponent, selector: "app-summary", ngImport: i0, template: "<div>\r\n  <ng-container>\r\n    <div class=\"order__summery__sub\">\r\n      <span class=\"order__summery__title\">{{language['orderSummary']}}</span>\r\n      <a class=\"show__summary\" *ngIf=\"!hideSummary\" (click)=\"hideSummary = !this.hideSummary\">\r\n        {{language['show']}}\r\n        <img src=\"assets/checkout-header/arrow-up.png\">\r\n      </a>\r\n      <div class=\"order__items__number\">\r\n        <span *ngIf=\"checkoutItemSummary.itemsQty < 2 && hideSummary\"><span\r\n            class=\"item__number__bold\">{{checkoutItemSummary.itemsQty}}</span>\r\n          {{language['summaryItem']}}\r\n        </span>\r\n        <span *ngIf=\"checkoutItemSummary.itemsQty >= 2 && hideSummary\"><span\r\n            class=\"item__number__bold\">{{checkoutItemSummary.itemsQty}}</span>\r\n          {{language['summaryItems']}}\r\n        </span>\r\n        <span class=\"item__number__bold\" *ngIf=\"!hideSummary\">\r\n          {{checkoutItemSummary.total / 100 | number}} {{currencyCode}}\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container>\r\n    <div class=\"summary__wrapper\" *ngIf=\"hideSummary\" @enterLeave>\r\n      <ng-container *ngIf=\"showCloseBtn\">\r\n        <div class=\"order__summery__sub__modal \">\r\n          <div class=\"order__summery__title\">\r\n            <p>{{language['orderSummary']}}</p>\r\n          </div>\r\n          <div class=\"order__items__number\">\r\n            <p *ngIf=\"checkoutItemSummary.itemsQty < 2\"><span\r\n                class=\"item__number__bold\">{{checkoutItemSummary.itemsQty}}</span>\r\n              {{language['summaryItem']}} </p>\r\n            <p *ngIf=\"checkoutItemSummary.itemsQty >= 2\"><span\r\n                class=\"item__number__bold\">{{checkoutItemSummary.itemsQty}}</span>\r\n              {{language['summaryItems']}} </p>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n      <div class=\"container__items\">\r\n        <div [ngClass]=\"{'order__items__container': isMoreThanItem}\" id=\"style-2\">\r\n          <div class=\"single__item\" *ngFor=\"let item of orderSummary?.items; index as i\">\r\n            <div class=\"number__of__items\">\r\n              <div class=\"numbers\">\r\n                {{i + 1}}\r\n              </div>\r\n            </div>\r\n            <div class=\"single__item--img\">\r\n              <img [src]=\"getImage(item.variant.product)\">\r\n            </div>\r\n            <div class=\"item__info__container\">\r\n              <p class=\"item__description text\" [title]=\"item.variant.product | translate : 'name' \">\r\n                {{ item.variant.product | translate : 'name' }}\r\n                <span *ngIf=\"item.quantity >= 2\">\r\n                  X{{item.quantity}}\r\n                </span>\r\n              </p>\r\n              <span class=\"px-4\" *ngFor=\"let variant of item?.variant?.optionValues\">{{variant.code}}</span>\r\n              \r\n            </div>\r\n            <div class=\"item__price__container\">\r\n              <p class=\"price\">\r\n                {{ item.unitPrice / 100 * item.quantity | number}} {{currencyCode}}\r\n              </p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <ng-container *ngIf=\"orderSummary\">\r\n        <div class=\"checkout__summary\">\r\n          <div *ngIf=\"checkoutItemSummary\" class=\"addressing\">\r\n            <div class=\"items__number__container\">\r\n              <div class=\"leftSide\">\r\n                <span> {{language['subtotal']}}</span>\r\n              </div>\r\n              <div *ngIf=\"unitPriceTotal\" class=\"itemBeforeAdjust\">\r\n                {{unitPriceTotal / 100 | currency: currencyCode}}\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"items__number__container\">\r\n              <div class=\"leftSide\">\r\n                {{language['summaryPromotions'] }}\r\n              </div>\r\n              <div class=\"itemBeforeAdjust\">\r\n                {{itmesAdjustmentsTotal / 100 | currency: currencyCode}}\r\n              </div>\r\n            </div>\r\n            <ng-container *ngIf=\"orderSummary?.adjustments.length > 0 && !showContent\">\r\n              <div *ngFor=\"let adjust of orderSummary?.adjustments\" class=\"items__number__container\" >\r\n                <div class=\"leftSide\">\r\n                  <!-- {{language[adjust.type]}} -->\r\n                  {{ adjust.type == \"COD Fees\" ? language.cashOnDelivery : language[adjust.type] }}\r\n                </div>\r\n                <div class=\"itemBeforeAdjust\">\r\n                  {{ adjust.amount / 100 | number }} {{currencyCode}}\r\n                </div>\r\n              </div>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"orderSummary?.checkoutState === 'cart'\">\r\n              <div class=\"items__number__container\"  *ngIf=\"!showContent\">\r\n                <div class=\"leftSide\">\r\n                  <span>{{language['shipping']}}</span>\r\n                </div>\r\n                <div class=\"itemBeforeAdjust\">\r\n                  {{language['calculateShippingCheckout']}}\r\n                </div>\r\n              </div>\r\n            </ng-container>\r\n\r\n            <div class=\"items__number__container total__price\">\r\n              <div class=\"leftSide \">\r\n                <span> {{language['totalPrice']}} </span>\r\n              </div>\r\n              <div class=\"itemBeforeAdjust\">\r\n                {{checkoutItemSummary.total / 100 | number}} {{currencyCode }}\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <ng-container *ngIf=\"showCloseBtn\">\r\n            <div class=\"close__summary\">\r\n              <a (click)=\"closeSummary()\">\r\n                {{language['close']}}\r\n                <img src=\"assets/checkout-header/arrow.png\">\r\n              </a>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </ng-container>\r\n</div>", styles: [":host .order__summery__sub{display:flex;margin-bottom:15px;background:#fcfcfd;border-radius:10px;padding:15px}:host .order__summery__sub .order__summery__title{font-weight:700;flex-grow:1}:host .order__summery__sub .order__items__number{margin-left:auto;display:flex;justify-content:flex-end;flex-grow:1}:host .order__summery__sub .order__items__number .item__number__bold{font-weight:700}[dir=rtl] :host .order__summery__sub .order__items__number{margin-right:auto;margin-left:initial}:host .order__summery__sub .show__summary{color:#09f}:host .order__summery__sub .show__summary img{width:12px}:host .order__summery__sub__modal{margin-top:0!important;padding:15px;background:#f2f5f7;display:flex}:host .order__summery__sub__modal .order__summery__title{font-weight:700;font-size:18px;flex-grow:1}:host .order__summery__sub__modal .order__items__number{margin-left:auto;display:flex;justify-content:flex-end;flex-grow:1}:host .order__summery__sub__modal .order__items__number .item__number__bold{font-weight:700}[dir=rtl] :host .order__summery__sub__modal .order__items__number{margin-right:auto;margin-left:initial}:host .summary__wrapper .close__summary{width:100%;position:relative;text-align:center;margin:auto;bottom:0}:host .summary__wrapper .close__summary a{font-size:20px;color:#09f;text-transform:capitalize}:host .summary__wrapper .close__summary a img{width:15px;position:relative}:host .summary__wrapper .container__items{margin-bottom:1rem;border-bottom:1px solid #b7b7b7;padding-bottom:1rem}:host .summary__wrapper .order__items__container{height:400px;overflow-y:scroll;padding:0 10px}:host .summary__wrapper .single__item{display:flex;align-items:center;flex-wrap:wrap;padding:10px 0;border-bottom:1px solid #c6d0e5}:host .summary__wrapper .single__item:last-child{border-bottom:none}:host .summary__wrapper .single__item .number__of__items{flex-wrap:wrap;align-self:center}:host .summary__wrapper .single__item .number__of__items .numbers{font-weight:700}:host .summary__wrapper .single__item .single__item--img{display:inline-flex;align-items:center;justify-content:center;width:70px;height:70px;border-radius:10px;overflow:hidden;margin:0 10px}:host .summary__wrapper .single__item .single__item--img img{max-width:100%;max-height:100%}:host .summary__wrapper .single__item .item__info__container{padding-left:0;flex-wrap:wrap;align-self:center}:host .summary__wrapper .single__item .item__info__container .text{text-overflow:ellipsis;white-space:nowrap;margin-bottom:0;overflow:hidden;width:100%;font-size:1.6rem;color:#000;font-weight:600}:host .summary__wrapper .single__item .item__info__container .text span{font-weight:700;margin:0 5px}:host .summary__wrapper .single__item .item__price__container{font-size:1.4rem;font-weight:700;margin-left:auto}[dir=rtl] :host .summary__wrapper .single__item .item__price__container{margin-left:0;margin-right:auto}:host .summary__wrapper .single__item .item__price__container .price{margin-bottom:0}:host .summary__wrapper .checkout__summary{padding:0 1rem}:host .summary__wrapper .checkout__summary .items__number__container{display:flex;align-items:center;justify-content:space-between;color:#2d3546;font-size:1.8rem;font-weight:600;padding-bottom:5px}:host .summary__wrapper .checkout__summary .items__number__container :last-child:not(.total__price){padding-bottom:1rem}:host .summary__wrapper .checkout__summary .items__number__container .leftSide{text-transform:capitalize}:host .summary__wrapper .checkout__summary .items__number__container.total__price{font-weight:700;border-top:1px solid #b7b7b7;padding-top:1rem}:host .summary__wrapper .checkout__summary .items-number{font-size:20px;color:#000;background:#fff;padding:0 15px;border-radius:15px;font-weight:500}:host .summary__wrapper .checkout__summary .items-number-price{font-size:24px}:host .promotion__code__container{margin:15px;display:flex}:host .promotion__code__container .promotion__title{font-weight:700}@media screen and (max-width: 661px){:host .summary__wrapper{width:100%;position:fixed;height:100%;background:#fff;z-index:5;left:auto;right:0;bottom:0;overflow-y:auto}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "number": i6.DecimalPipe, "translate": TranslatePipe, "currency": i6.CurrencyPipe }, animations: [
        // DEFAULT STATES
        trigger('enterLeave', [
            // :ENTER TRANSITION
            // Transition Styles
            transition('void => *', [
                // 'From' styles
                style({
                    opacity: 0.2,
                    transform: 'translateY(-100vw)',
                    transition: 'all 1s ease-in'
                }),
                animate('500ms ease-in', 
                // 'To' styles
                // 1 - Comment this to remove the item's grow...
                style({
                    opacity: 1,
                    transform: 'scale(1.2)',
                    transition: 'all 1s ease-in'
                }))
            ]),
        ])
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SummaryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-summary',
                    templateUrl: './summary.component.html',
                    styleUrls: ['./summary.component.scss'],
                    animations: [
                        // DEFAULT STATES
                        trigger('enterLeave', [
                            // :ENTER TRANSITION
                            // Transition Styles
                            transition('void => *', [
                                // 'From' styles
                                style({
                                    opacity: 0.2,
                                    transform: 'translateY(-100vw)',
                                    transition: 'all 1s ease-in'
                                }),
                                animate('500ms ease-in', 
                                // 'To' styles
                                // 1 - Comment this to remove the item's grow...
                                style({
                                    opacity: 1,
                                    transform: 'scale(1.2)',
                                    transition: 'all 1s ease-in'
                                }))
                            ]),
                        ])
                    ]
                }]
        }], ctorParameters: function () { return [{ type: CheckoutService }, { type: LanguageService }, { type: i4.BreakpointObserver }, { type: ConfService }]; } });

class CheckoutComponent {
    constructor(languageService, location, _router, checkoutService, shippingGuard, paymentGuard, completeGuard, confService, breakpointObserver, navigationService) {
        this.languageService = languageService;
        this.location = location;
        this._router = _router;
        this.checkoutService = checkoutService;
        this.shippingGuard = shippingGuard;
        this.paymentGuard = paymentGuard;
        this.completeGuard = completeGuard;
        this.confService = confService;
        this.breakpointObserver = breakpointObserver;
        this.navigationService = navigationService;
        this.language = {};
        this.inLastStep = false;
        this.active = 0;
        this.current = 0;
        this.userId = JSON.parse(localStorage.getItem('user_id') ? localStorage.getItem('user_id') : sessionStorage.getItem('user_id'));
        this.cartCounter = JSON.parse(localStorage.getItem('cart-counter'));
        this.hideNextButton = false;
        this.shippingMethodColor = '#ccc';
        this.shippingMethodBorder = '2px solid #ccc';
        this.shippingMethodBg = '#fff';
        this.paymentColor = '#ccc';
        this.paymentBorder = '2px solid #ccc';
        this.paymentBg = '#fff';
        this.doneShippingAddress = false;
        this.doneShippingMethod = false;
        this.hideShippingAddress = true;
        this.hideShippingMethod = true;
        this.hidePayment = true;
        this.branch$ = this.confService.branch;
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.showContent = this.id == 12849 ? true : false;
    }
    ngOnInit() {
        this.logo$ = this.confService.logo$;
        this.checkoutService.hideNextButtonSubject
            .subscribe(state => {
            this.hideNextButton = state;
        });
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.readUrl();
        this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.readUrl();
            this.readUrlSmallScreen();
        });
        this.checkoutService.getCheckoutData().subscribe(data => {
            if (data['checkoutState'] === 'cart') {
                this.active = 0;
                this.myDetailsColor = '#0099ff';
                this.myDetailsSuccess = '#0099ff';
                this.myDetailsBg = '#fff';
                this.myDetailsBorder = '2px solid #0099ff';
            }
            else if (data['checkoutState'] === 'addressed') {
                this.active = 1;
            }
            else if (data['checkoutState'] === 'shipping_selected') {
                this.active = 2;
            }
            else if (data['checkoutState'] === 'payment_selected') {
                this.active = 3;
            }
            else {
                this.active = 0;
                this.confirmColor = '';
                this.paymentColor = '';
                this.shippingColor = '';
            }
            this.branch$.subscribe(branch => {
                this.currentBranch = branch;
            });
        });
        this.breakpointObserver
            .observe(['(max-width: 661px)'])
            .subscribe((state) => {
            if (state.matches) {
                this.isSmallScreen = false;
                if (window.location.pathname.indexOf('mydetails') !== -1) {
                    this.doneShippingAddress = true;
                    this.doneShippingMethod = false;
                    this.hideShippingAddress = true;
                    this.hideShippingMethod = false;
                    this.hidePayment = false;
                }
            }
            else {
                this.isSmallScreen = true;
            }
        });
    }
    readUrlSmallScreen() {
        this.breakpointObserver
            .observe(['(max-width: 661px)'])
            .subscribe((state) => {
            if (state.matches) {
                if (window.location.pathname.indexOf('mydetails') !== -1) {
                    this.doneShippingAddress = true;
                    this.doneShippingMethod = false;
                    this.hideShippingAddress = true;
                    this.hideShippingMethod = false;
                    this.hidePayment = false;
                }
                else if (window.location.pathname.indexOf('shipping') !== -1) {
                    this.doneShippingAddress = false;
                    this.doneShippingMethod = true;
                    this.hideShippingMethod = true;
                    this.hideShippingAddress = false;
                    this.hidePayment = false;
                }
                else if (window.location.pathname.indexOf('payment') !== -1) {
                    this.hideShippingAddress = false;
                    this.doneShippingMethod = false;
                    this.hideShippingAddress = false;
                    this.hideShippingMethod = false;
                    this.hidePayment = true;
                }
            }
        });
    }
    readUrl() {
        if (window.location.pathname.indexOf('mydetails') !== -1) {
            this.current = 0;
            this.myDetailsColor = '#0099ff';
            this.myDetailsBorder = '2px solid #0099ff';
            this.myDetailsSuccess = '#0099ff';
            this.myDetailsBg = '#fff';
            this.shippingMethodColor = '#ccc';
            this.shippingMethodBorder = '2px solid #ccc';
            this.shippingMethodBg = '#fff';
            this.shippingMethodSuccess = '#ccc';
            this.paymentColor = '#ccc';
            this.paymentBorder = '2px solid #ccc';
            this.paymentBg = '#fff';
            this.paymentSuccess = '#ccc';
            this.inLastStep = false;
            this.hideNextButton = true;
        }
        else if (window.location.pathname.indexOf('shipping') !== -1) {
            this.current = 1;
            this.myDetailsColor = '#fff';
            this.myDetailsBorder = '2px solid #00a651';
            this.myDetailsSuccess = '#00a651';
            this.myDetailsBg = '#00a651';
            this.shippingMethodColor = '#0099ff';
            this.shippingMethodBorder = '2px solid #0099ff';
            this.shippingMethodBg = '#fff';
            this.shippingMethodSuccess = '#0099ff';
            this.paymentColor = '#ccc';
            this.paymentBorder = '2px solid #ccc';
            this.paymentBg = '#fff';
            this.paymentSuccess = '#ccc';
            this.inLastStep = false;
            this.hideNextButton = true;
        }
        else if (window.location.pathname.indexOf('payment') !== -1) {
            this.current = 2;
            this.myDetailsColor = '#fff';
            this.myDetailsBorder = '2px solid #00a651';
            this.myDetailsSuccess = '#00a651';
            this.myDetailsBg = '#00a651';
            this.shippingMethodColor = '#fff';
            this.shippingMethodBorder = '2px solid #00a651';
            this.shippingMethodBg = '#00a651';
            this.shippingMethodSuccess = '#00a651';
            this.paymentColor = '#0099ff';
            this.paymentBorder = '2px solid #0099ff';
            this.paymentBg = '#fff';
            this.paymentSuccess = '#0099ff';
            this.hideNextButton = false;
            this.inLastStep = true;
        }
        else {
            this.current = 3;
            this.confirmColor = '#46ca38';
        }
        this.readUrlSmallScreen();
    }
    goBack() {
        return this.location.back();
    }
    login(langCode) {
        this._router.navigateByUrl(`/${langCode}/accounts/login'`);
    }
    handleCheckoutSteps() {
        this.checkoutService.nextStep.next(this.current);
    }
    canAccessShippingPage(langCode) {
        this.shippingGuard.st.next(true);
        return this._router.navigateByUrl(`/${langCode}/checkout/shipping`);
    }
    canAccessPaymentPage(langCode) {
        this.paymentGuard.paymentStateBehavior.next(true);
        return this._router.navigateByUrl(`/${langCode}/checkout/payment`);
    }
    canAccessConfirmPage(langCode) {
        this.completeGuard.completeStateBehavior.next(true);
        return this._router.navigateByUrl(`/${langCode}/checkout/complete`);
    }
    getRouteAnimation(outlet) {
        return this.navigationService.animationValue;
    }
}
CheckoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutComponent, deps: [{ token: LanguageService }, { token: i6.Location }, { token: i2.Router }, { token: CheckoutService }, { token: ShippingGuardCheckout }, { token: PaymentGuardCheckout }, { token: CompleteGuardCheckout }, { token: ConfService }, { token: i4.BreakpointObserver }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Component });
CheckoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CheckoutComponent, selector: "app-checkout", ngImport: i0, template: "<div class=\"checkout-container\">\r\n  <!--Checkout Header -->\r\n  <header class=\"checkout-header\">\r\n    <div class=\"container\">\r\n      <div class=\"flex__container\">\r\n        <div class=\"cart__btn\">\r\n          <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'cart']\">\r\n            <img class=\"icon-arrow\" src=\"./assets/checkout-header/arrow1.png\" alt=\"icon-arrow\">\r\n            {{language['cart']}}\r\n          </a>\r\n        </div>\r\n        <div class=\"shop_logo\">\r\n          <a routerLink=\"\">\r\n            <img *ngIf=\"logo$ | async as logo\" [lazyLoad]=\"logo\" alt=\"logo\">\r\n          </a>\r\n        </div>\r\n        <ng-container *ngIf=\"currentBranch && currentBranch.phone\" >\r\n          <div  class=\"checkout__header__staticPages\">\r\n            <a [href]=\"'tel:' + currentBranch.phone\">\r\n              <img src=\"./assets/checkout-header/call.png\" alt=\"icon\">\r\n              <p class=\"phone__number link\">\r\n                {{currentBranch.phone }}\r\n              </p>\r\n            </a>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n  </header>\r\n  <!--End Checkout Header-->\r\n</div>\r\n<div class=\"inner-outlet\" *ngIf=\"cartCounter > 0; else noPinCgotoCollection\">\r\n  <div class=\"checkout__inner__container\">\r\n    <div class=\"container\">\r\n      <ng-template [ngIf]=\"!isSmallScreen && inLastStep\">\r\n        <app-summary></app-summary>\r\n      </ng-template>\r\n      <div class=\"row justify-content-center\">\r\n        <div [ngClass]='inLastStep ? \"col-lg-7\" : \"col-lg-10\"'>\r\n          <div class=\"current__step\">\r\n            <div class=\" methods\">\r\n              <button [ngStyle]=\"{'color': myDetailsSuccess}\">\r\n                <span class=\"checkout-pg-number\"\r\n                  [ngStyle]=\"{ 'border' : myDetailsBorder, 'background-color': myDetailsBg, 'color': myDetailsColor}\">1</span>\r\n                <span *ngIf=\"hideShippingAddress && !showContent\" class=\"method__title\">{{language['stepOne']}} </span>\r\n                <span *ngIf=\"hideShippingAddress && showContent\" class=\"method__title\">{{(language['LANGUAGE_CODE'] === 'en_US' ? \"Registration Form\" : \"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\")}}  </span>\r\n              </button>\r\n            </div>\r\n            <div class=\" methods \" [ngClass]=\"{ 'push__left': doneShippingAddress}\">\r\n              <button [disabled]=\"active < 1\" [ngStyle]=\"{'color': shippingMethodSuccess}\">\r\n                <span class=\"checkout-pg-number\"\r\n                  [ngStyle]=\"{'color': shippingMethodColor, 'border' : shippingMethodBorder, 'background-color': shippingMethodBg}\">2</span>\r\n                <span *ngIf=\"hideShippingMethod && !showContent\" class=\"method__title\">{{language['stepTwo']}} </span>\r\n                <span *ngIf=\"hideShippingMethod && showContent\" class=\"method__title\">{{(language['LANGUAGE_CODE'] === 'en_US' ? \"Terms & Conditions\" : \"\u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0627\u0644\u0623\u062D\u0643\u0627\u0645\")}}  </span>\r\n              </button>\r\n            </div>\r\n            <div class=\" methods\" [ngClass]=\"{ 'push__left': doneShippingMethod}\">\r\n              <button [disabled]=\"active < 2\" [ngStyle]=\"{'color': paymentSuccess}\">\r\n                <span class=\"checkout-pg-number\"\r\n                  [ngStyle]=\"{'color': paymentColor, 'border' : paymentBorder, 'background-color': paymentBg}\">3</span>\r\n                <span *ngIf=\"hidePayment\" class=\"method__title\">{{language['stepThree']}}</span>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div [@routerAnimation]=\"getRouteAnimation(router)\">\r\n            <router-outlet #router=\"outlet\"></router-outlet>\r\n          </div>\r\n        </div>\r\n        <ng-template [ngIf]=\"isSmallScreen && inLastStep\">\r\n          <div class=\"col-lg-4\">\r\n            <app-summary></app-summary>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-template #noPinCgotoCollection>\r\n  <div class=\"container noPinCgotoCollection\">\r\n    <div class=\"no__items\">\r\n      <p>{{language['your_shopping_bag_empty']}},\r\n      </p>\r\n      <a class=\"continue__shopping__link\"\r\n        [routerLink]=\"['/' , language['LANGUAGE_CODE'], 'collection']\">{{language['continueShopping']}}</a>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [":host .inner-outlet{overflow:hidden;min-height:90vh;background-color:#f2f5f7}:host .checkout-container{position:relative}:host .checkout-container .checkout-header{display:flex;align-items:center;background-color:#fff;height:90px;box-shadow:0 0 15px #00000026}:host .checkout-container .checkout-header .flex__container{display:flex;align-items:center;justify-content:space-between}:host .checkout-container .checkout-header .flex__container .cart__btn a{position:relative;font-size:1.8rem;text-transform:capitalize}:host .checkout-container .checkout-header .flex__container .cart__btn a .icon-arrow{position:relative;top:-2px;left:7px;padding-left:1.4rem;filter:invert(1);transform:rotate(180deg);width:25px;transition:all .3s ease-in-out}[dir=rtl] :host .checkout-container .checkout-header .flex__container .cart__btn a .icon-arrow{transform:rotate(0);left:auto;right:7px}:host .checkout-container .checkout-header .flex__container .cart__btn a:hover{cursor:pointer;text-decoration:none}[dir=rtl] :host .checkout-container .checkout-header .flex__container .cart__btn a:hover .icon-arrow{left:auto;right:0}:host .checkout-container .checkout-header .flex__container .cart__btn a:hover .icon-arrow{left:0}:host .checkout-container .checkout-header .flex__container .shop_logo{display:block;height:70px;min-width:70px;max-width:200px;border-radius:1rem}:host .checkout-container .checkout-header .flex__container .shop_logo a{display:flex;align-items:center;justify-content:center;height:70px;min-width:70px;padding:1rem}:host .checkout-container .checkout-header .flex__container .shop_logo a:hover{text-decoration:none}:host .checkout-container .checkout-header .flex__container .shop_logo a img{max-width:100%;max-height:100%}:host .checkout-container .checkout-header .flex__container .checkout__header__staticPages{text-align:center}:host .checkout-container .checkout-header .flex__container .checkout__header__staticPages img{margin-bottom:1rem}:host .checkout-container .checkout-header .flex__container .checkout__header__staticPages .phone__number{margin:0;font-weight:600}@media all and (max-width: 576.98px){:host .checkout-container .checkout-header .flex__container .cart__btn a{font-size:1.4rem}:host .checkout-container .checkout-header .flex__container .shop_logo{max-width:170px}:host .checkout-container .checkout-header .flex__container .shop_logo a{padding:.5rem}}@media all and (max-width: 420px){:host .checkout-container .checkout-header .flex__container .checkout__header__staticPages{display:none}}:host .checkout-container .checkout-items-container{margin-top:20px;padding-bottom:50px}:host .checkout-container .checkout-items-container .checkout-items{background:#fff;box-shadow:-1px 1px 9px -2px #000000bf;border-radius:15px;padding-left:0!important}:host .checkout-container .checkout-items-container .checkout-items .promotion{width:95%;margin:auto;padding:30px 0;font-size:18px;vertical-align:bottom}:host .checkout-container .checkout-items-container .checkout-items .promotion .form-group label{font-weight:bold}:host .checkout-container .checkout-items-container .checkout-items .promotion .form-group input{background:#e1e4e9;height:50px}:host .checkout__inner__container{padding:30px 0}:host .checkout__inner__container .current__step{margin:0 0 20px;display:flex;justify-content:space-around}:host .checkout__inner__container .current__step .methods{transition:all .5s ease-in-out;padding:0;position:relative}:host .checkout__inner__container .current__step .methods button{text-decoration:none;background:transparent;border:none;box-shadow:none;font-weight:bold}:host .checkout__inner__container .current__step .methods button .method__title{padding-left:10px;position:relative;text-transform:capitalize!important}[dir=rtl] :host .checkout__inner__container .current__step .methods button .method__title{padding-right:10px;padding-left:0}@media (max-width: 400px){:host .checkout__inner__container .current__step .methods button .method__title{padding-left:5px;font-size:12px}[dir=rtl] :host .checkout__inner__container .current__step .methods button .method__title{padding-right:5px;padding-left:0}}:host .checkout__inner__container .current__step .methods button:focus{outline:0}:host .checkout__inner__container .current__step .methods button:hover{cursor:pointer}:host .checkout__inner__container .current__step .methods .checkout-pg-number{display:inline-flex;width:4rem;height:3rem;align-items:center;justify-content:center;color:#fff;border-radius:10px}:host .checkout__inner__container .current__step .methods .checkout-pg-number:disabled{background:#c5c8ca}.noPinCgotoCollection{min-height:750px;position:relative}.noPinCgotoCollection .no__items{padding:70px 0;position:absolute;top:40%;left:50%;width:95%;transform:translate(-50%,-50%);text-align:center;font-size:20px;border:1px solid #000;border-radius:15px;font-weight:700;background-color:#fff}.noPinCgotoCollection .no__items .continue__shopping__link{background:#f8f8f8;border-radius:15px;padding:10px 25px;margin:10px;text-transform:capitalize;opacity:.9}.noPinCgotoCollection .no__items .continue__shopping__link:hover{opacity:1;text-decoration:none}\n"], components: [{ type: SummaryComponent, selector: "app-summary" }], directives: [{ type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i2.RouterOutlet, selector: "router-outlet", outputs: ["activate", "deactivate"], exportAs: ["outlet"] }], pipes: { "async": i6.AsyncPipe }, animations: [
        routerTransition(),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-checkout',
                    templateUrl: './checkout.component.html',
                    styleUrls: ['./checkout.component.scss'],
                    animations: [
                        routerTransition(),
                    ]
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i6.Location }, { type: i2.Router }, { type: CheckoutService }, { type: ShippingGuardCheckout }, { type: PaymentGuardCheckout }, { type: CompleteGuardCheckout }, { type: ConfService }, { type: i4.BreakpointObserver }, { type: NavigationService }]; } });

class CartItemsSummary {
}

class TimeSlotObject {
    constructor(timeSlot) {
        this.date = timeSlot.day;
        this.hour = timeSlot.hour;
        this.dayname = timeSlot.dayname;
    }
    getSelectedDate() {
        const convertedDate = this.date.replace(new RegExp('-', 'g'), '/');
        return convertedDate;
    }
    getSelectedHour() {
        return this.hour;
    }
    getSelectedDayName() {
        return this.dayname;
    }
}

class ShippingComponent {
    constructor(checkoutService, languageService, router, paymentGuardCheckout, confService, localeService, formBuilder, toastr, translatePipe, fbService) {
        this.checkoutService = checkoutService;
        this.languageService = languageService;
        this.router = router;
        this.paymentGuardCheckout = paymentGuardCheckout;
        this.confService = confService;
        this.localeService = localeService;
        this.formBuilder = formBuilder;
        this.toastr = toastr;
        this.translatePipe = translatePipe;
        this.fbService = fbService;
        this.language = {};
        this.adjustments = [];
        this.selectedTimeByUser = '';
        this.datePickerValue = '';
        this.selectedDayName = '';
        this.startTime = 0;
        this.endTime = 0;
        this.api_days = [];
        this.avaliableTime = [];
        this.disabledDays = [];
        this.loading = true;
        this.noShippingMethod = true;
        this.selectedDateStatus = false;
        this.selectedTimeStatus = false;
        this.submitted = false;
        this.hasTimeSlots = false;
        this.HaveNotEnabledDays = false;
        this.itemUnAvaliable = false;
        this.cartItemsSummary = new CartItemsSummary();
        this.$destroyCheckoutDataSubject = new Subject();
        this.$destroyShippingMethods = new Subject();
        this.destroySelectShipping = new Subject();
        this.selectMethodErr = false;
        this.serviceUnvailableMsg = '';
        this.storeLimitMsg = null;
        this.id = 0;
        this.storeid = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.showContent = this.id == 12849 ? true : false;
        this.bsConfig = Object.assign({}, { containerClass: 'theme-blue', dateInputFormat: 'MM/DD/YYYY' });
    }
    ngOnInit() {
        this.timeSlotForm = this.formBuilder.group({
            date: ['', Validators.required],
            timeSlot: ['', Validators.required],
        });
        this.confService.getFeatures().subscribe(data => {
            if (data.login.original.response.response.features.TIME_SLOTS) {
                this.features = data.login.original.response.response.features.TIME_SLOTS;
                this.getDeliveryDate();
            }
        });
        this.checkoutService.nagivateTop();
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
        this.checkoutService
            .getFullyCheckoutData()
            .pipe(first(), takeUntil(this.$destroyCheckoutDataSubject), tap((response) => {
            this.fbService.InitiateCheckout(response['checkoutState'], response['id'], response['itemsTotal']);
            for (const item of response['items']) {
                if (!item.variant.stockCheck) {
                    this.itemUnAvaliable = true;
                }
            }
            this.orders = response;
            if (response['checkoutState'] === 'shipping_skipped') { // Shipping Skipped;
                this.selectShippingSuccess();
                return;
            }
            this.shippingAddress = this.orders.shippingAddress;
            // if (response['shipments'].length > 0) {
            //   this.selectedShippingMethod = response['shipments'][0]['method']
            // }
            if (this.hasTimeSlots) {
                this.getSelectedTimeSlots();
            }
            this.checkoutService
                .getShippingMethods()
                .pipe(first(), map(x => this.mapShippingMethod(x)), tap((shippingMethodApi) => {
                this.loading = true;
                this.shippingMethods = shippingMethodApi;
                if (shippingMethodApi.length > 0) {
                    this.selectedShippingMethod = shippingMethodApi[0]; // set the default shipping method by the first one
                }
                this.stopSpinner();
            }), takeUntil(this.$destroyShippingMethods)).subscribe(null, (err => {
                this.loading = false;
                this.selectMethodErr = true;
                this.toastr.error(this.language['somthingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
                if (err.status === 503) {
                    this.serviceUnvailableMsg = err.error.message;
                }
            }));
        })).subscribe();
    }
    get f() { return this.timeSlotForm.controls; }
    submitPayment() {
        this.submitted = true;
        if (this.timeSlotForm.invalid && this.features === 1) {
            return;
        }
        this.getSelectedShippment(this.selectedShippingMethod.code);
        if (this.hasTimeSlots) {
            const selectedTimeByUser = this.timeSlotForm.controls['timeSlot'].value;
            const selectedDayName = this.selectedDayName || this.orders['delivery_time_slot']['dayname'];
            const datePickerValue = this.timeSlotsDate.nativeElement.value;
            const changeDateFormat = this.changeDateFormat(datePickerValue.toString());
            this.checkoutService
                .sendTimeSlotsToApi(this.orders['id'], changeDateFormat, selectedTimeByUser, selectedDayName)
                .subscribe();
        }
    }
    submitPaymentDemo() {
        this.submitted = true;
        if (this.hasTimeSlots === true) {
            if (!this.features || this.features == 0) {
                this.getSelectedShippment(this.selectedShippingMethod.code);
            }
            else {
                if (this.timeSlotForm.invalid) {
                    return;
                }
                const selectedTimeByUser = this.timeSlotForm.controls['timeSlot'].value;
                const selectedDayName = this.selectedDayName || this.orders['delivery_time_slot']['dayname'];
                const datePickerValue = this.timeSlotsDate.nativeElement.value;
                const changeDateFormat = this.changeDateFormat(datePickerValue.toString());
                this.checkoutService
                    .sendTimeSlotsToApi(this.orders['id'], changeDateFormat, selectedTimeByUser, selectedDayName)
                    .subscribe();
                this.getSelectedShippment(this.selectedShippingMethod.code);
            }
        }
        else {
            this.getSelectedShippment(this.selectedShippingMethod.code);
        }
    }
    /**
   * @Todo
   * 1- first take the selected date that have slashes;
   * 2- second change the slashes to be - and return it;
   * @param selectedDate the date that selected
   */
    changeDateFormat(selectedDate) {
        return selectedDate.replace(new RegExp('/', 'g'), '-');
    }
    /**
   * Represent the state of the spinner.
   * @return false;
   */
    onLoad() {
        return this.loading = false;
    }
    /**
   * Represent the state of the spinner.
   * @param shipmentCode string;
   * @return false;
   */
    getSelectedShippment(shipmentCode) {
        const shippmentMethod = {
            'shipments': [
                {
                    'method': shipmentCode
                }
            ]
        };
        this.checkoutService
            .selectShippingMethod(shippmentMethod).pipe(debounceTime(1000), tap((data) => {
            if (data['status'] === 204) {
                this.selectShippingSuccess();
            }
        }, error => {
            if (error) {
                this.accessPaymentFalied();
                this.storeLimitMsg = this.translatePipe.transform(error.error, 'message') || 'This Store Exceeded Order Limit';
            }
        }), takeUntil(this.destroySelectShipping)).subscribe(null, (err => {
            this.loading = false;
            this.selectMethodErr = true;
            this.toastr.error(this.language['somthingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
            if (err.status === 503) {
                this.serviceUnvailableMsg = err.error.message;
            }
        }));
    }
    ngOnDestroy() {
        this.destroySelectShipping.next();
        this.destroySelectShipping.complete();
        this.$destroyCheckoutDataSubject.next();
        this.$destroyShippingMethods.next();
        this.$destroyCheckoutDataSubject.complete();
        this.$destroyShippingMethods.complete();
    }
    /**
   * Stop the spinner If the shipping methods represents successfully
   * @return void
   */
    stopSpinner() {
        if (this.shippingMethods.length > 0) {
            this.loading = false;
        }
        else {
            this.loading = false;
            this.noShippingMethod = false;
        }
    }
    /**
   * used by @function mapShippingMethod() to map the shipping methods
   * @param shippingMethodsApi shipping method api response
   * @return Shipping Methods
   */
    mapShippingMethod(shippingMethodsApi) {
        if (shippingMethodsApi['shipments']) {
            return shippingMethodsApi['shipments'][0]['methods'];
        }
        else {
            return shippingMethodsApi = [];
        }
    }
    /**
   * If Selected Shipping Success Go To Payment .
   */
    selectShippingSuccess() {
        this.accessPaymentSuccess();
        this.goToPayment();
    }
    /**
   * Nagivate To Payment .
   */
    goToPayment() {
        this.router.navigateByUrl(`${this.language['LANGUAGE_CODE']}/checkout/payment`);
    }
    /**
   * Set status of payment true in localstorage.
   * Set behaviour of payment true
   */
    accessPaymentSuccess() {
        localStorage.setItem('stepTwo', 'true');
        this.paymentGuardCheckout.paymentStateBehavior.next(true);
    }
    /**
   * Set status of payment fakse in localstorage.
   * Set behaviour of payment false
   */
    accessPaymentFalied() {
        localStorage.setItem('stepTwo', 'false');
        this.paymentGuardCheckout.paymentStateBehavior.next(false);
    }
    backToShippingAddress() {
        this.router.navigateByUrl(`${this.language['LANGUAGE_CODE']}/checkout/mydetails`);
    }
    getSelectedShippingMethod(shippingMethod) {
        this.selectedShippingMethod = shippingMethod;
    }
    getTimesEvent(e) {
        if (e.target.value !== null) {
            this.selectedTimeStatus = true;
            this.timeSlotForm.controls['timeSlot'].setValue(e.target.value);
        }
    }
    getDeliveryDate() {
        if (!this.features || this.features == 0) {
            this.hasTimeSlots = false;
            return;
        }
        else {
            this.checkoutService.getTimeSlotsFromApi()
                .subscribe(data => {
                if (data['status'] !== 'failure') {
                    this.days = data;
                    if (this.features == 1 && (data['response'] && data['response']['enabledDays'].length !== 0 || null || undefined)) {
                        this.hasTimeSlots = true;
                        this.setDatePickerMinDate(this.days.response.deliveryStartDate);
                        this.disabledDays = this.getAvaliableDeliveryDates(this.days.response.enabledDays);
                    }
                    else {
                        this.hasTimeSlots = false;
                    }
                }
            });
        }
    }
    setDatePickerMinDate(exec_time) {
        const execDate = new Date(exec_time.day);
        this.minDate = execDate;
        this.minHour = exec_time.time;
        // this.minDate = new Date();
        // this.minDate.setDate(this.minDate.getDate() + Number(exec_time));
    }
    getAvaliableDeliveryDates(api_days) {
        const disabledDays = [];
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        for (let i = 0; i < days.length; i++) {
            const value = days[i];
            if (api_days.indexOf(value) === -1) {
                disabledDays.push(i);
            }
        }
        return disabledDays;
    }
    getSelectedTimeSlots() {
        this.selectedTimeSlot = new TimeSlotObject(this.orders['delivery_time_slot']);
        if (this.selectedTimeSlot.getSelectedDate() !== 'null') {
            this.timeSlotForm.controls['date'].setValue(this.selectedTimeSlot.getSelectedDate());
        }
        if (this.selectedTimeSlot.getSelectedDayName() !== 'null') {
            this.avaliableTime = this.getAvaliablesHoursForSpecificDate(this.selectedTimeSlot.getSelectedDayName());
            this.timeSlotForm.controls['timeSlot'].setValue(this.orders['delivery_time_slot']['hour']);
        }
    }
    getAvaliablesHoursForSpecificDate(selectedDay) {
        const daysOfWeek = {
            Sun: 'Sunday',
            Mon: 'Monday',
            Tue: 'Tuesday',
            Wed: 'Wednesday',
            Thu: 'Thursday',
            Fri: 'Friday',
            Sat: 'Saturday',
        };
        const avaliableDays = this.days.response.days;
        if (avaliableDays) {
            const avalibleHours = avaliableDays.find(x => x.day == daysOfWeek[selectedDay]);
            const minDay = this.minDate.toString().substr(0, 3);
            if (selectedDay === minDay) {
                avalibleHours.duration = avalibleHours.duration.filter(period => period.to >= this.minHour);
            }
            return avalibleHours.duration;
        }
    }
    getSelectedDeliveryDate(evt) {
        if (evt !== null) {
            this.selectedDateStatus = true;
            const selectedDay = evt.toString().substring(0, 3);
            this.selectedDayName = selectedDay;
            this.avaliableTime = this.getAvaliablesHoursForSpecificDate(selectedDay);
        }
    }
}
ShippingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShippingComponent, deps: [{ token: CheckoutService }, { token: LanguageService }, { token: i2.Router }, { token: PaymentGuardCheckout }, { token: ConfService }, { token: i6$2.BsLocaleService }, { token: i1$1.FormBuilder }, { token: i3$1.ToastrService }, { token: TranslatePipe }, { token: FacebookPixelService }], target: i0.ɵɵFactoryTarget.Component });
ShippingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ShippingComponent, selector: "app-shipping", viewQueries: [{ propertyName: "timeSlotsDate", first: true, predicate: ["date"], descendants: true }, { propertyName: "timeSlotsAvaliableHours", first: true, predicate: ["avaliableHoursId"], descendants: true }], ngImport: i0, template: "<section class=\"shipping-container\">\r\n  <div *ngIf=\"!showContent\" class=\"edit__container\">\r\n    <h1 class=\"title\">{{language['stepOne']}} - <span *ngIf=\"shippingAddress\">{{ shippingAddress.city}}\r\n        <ng-container *ngIf=\"shippingAddress.areaCode\">, {{shippingAddress.areaCode}}</ng-container> , {{\r\n        shippingAddress.countryCode}}\r\n      </span></h1>\r\n    <div class=\"edit__link\">\r\n      <a (click)=\"backToShippingAddress()\">{{language['edit']}}</a>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"showContent\" class=\"edit__container\">\r\n    <h1 class=\"title\">{{(language['LANGUAGE_CODE'] === 'en_US' ? \"Registration Form is Done\" : \"\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\")}} </h1>\r\n  </div>\r\n  <div class=\"shipping__methods__container\" [ngStyle]=\"{'background-color': loading ? '#fff' : ''}\">\r\n\r\n    <!-- Checkout Spinner -->\r\n    <ng-template [ngIf]=\"loading\">\r\n      <app-checkout-spinner></app-checkout-spinner>\r\n    </ng-template>\r\n    <!--End Checkout Spinner-->\r\n\r\n    <div class=\"form-group shipping-methods-radio\">\r\n      <ng-container *ngIf=\"!loading\">\r\n        <h3 class=\"shipping__method__title\" *ngIf=\"noShippingMethod && !showContent\">{{language['selectShippingMethod']}} </h3>\r\n        <h3 class=\"shipping__method__title\" *ngIf=\"noShippingMethod && showContent\">{{(language['LANGUAGE_CODE'] === 'en_US' ? \"Cancelation Policy\" : \"\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u0625\u0644\u063A\u0627\u0621\")}}  </h3>\r\n        <app-radio-buttons [methods]=\"shippingMethods\" (selectMethod)=\"getSelectedShippingMethod($event)\"\r\n          [readSelectedMethod]=\"selectedShippingMethod?.code\" [methodKey]=\"'code'\">\r\n        </app-radio-buttons>\r\n        <div *ngIf=\"!noShippingMethod\">\r\n          <div class=\"no__shipping__found\">\r\n            <p>{{language['no-shipping']}}</p>\r\n          </div>\r\n        </div>\r\n\r\n        <ng-container *ngIf=\"hasTimeSlots\">\r\n          <h3 class=\"shipping__method__title\">{{language['dilveryTime']}}</h3>\r\n          <form [formGroup]=\"timeSlotForm\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <div class=\"form-group datepickerContainer has-icon\">\r\n                  <input #date formControlName=\"date\" [bsConfig]=\"bsConfig\" [daysDisabled]=\"disabledDays\"\r\n                    [minDate]=\"minDate\" (bsValueChange)=\"getSelectedDeliveryDate($event)\"\r\n                    [placeholder]=\"language['dilveryDate']\" bsDatepicker class=\"form-control\" placement=\"top\" readonly>\r\n                  <i class=\"fa fa-calendar\"></i>\r\n                </div>\r\n                <div *ngIf=\"timeSlotForm.get('date').errors && submitted\" class=\"help-block\">\r\n                  <div>\r\n                    <p>This field is required</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <ng-container *ngIf=\"avaliableTime?.length > 0\">\r\n                  <div class=\"form-group\">\r\n                    <select class=\"form-control\" formControlName=\"timeSlot\" (change)=\"getTimesEvent($event)\"\r\n                      #timeSlotsAvaliableHours>\r\n                      <option disabled value=\"\">Please Select Delivery Time</option>\r\n                      <option *ngFor=\"let time of avaliableTime\" value=\"{{time.from}}-{{time.to}}\">\r\n                        {{time.from}}-{{time.to}}</option>\r\n                    </select>\r\n                  </div>\r\n                  <div *ngIf=\"timeSlotForm.get('timeSlot').errors && submitted\" class=\"help-block\">\r\n                    <p>This field is required</p>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"HaveNotEnabledDays\">\r\n          <div class=\"help-block\">\r\n            <p>{{language['HaveNotEnabledDays']}}</p>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"selectMethodErr\">\r\n          <div class=\"no__shipping__found\">\r\n            <p *ngIf=\"!serviceUnvailableMsg\">{{language['somthingWentWrong']}}</p>\r\n            <p>{{serviceUnvailableMsg}}</p>\r\n          </div>\r\n        </ng-container>\r\n\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"alert alert-danger\" *ngIf=\"itemUnAvaliable\">{{language['Remove_Checkout_Items']}}</div>\r\n\r\n  <div class=\"alert alert-danger\" *ngIf=\"storeLimitMsg\">{{storeLimitMsg}}</div>\r\n  <div class=\"submit-btn\">\r\n    <button class=\"btn btn-continue\" (click)=\"submitPaymentDemo()\" [disabled]=\"selectMethodErr || itemUnAvaliable\">\r\n      {{language['continue']}}\r\n      <img src=\"assets/checkout-header/arrow1.png\" class=\"icon-arrow\">\r\n    </button>\r\n  </div>\r\n</section>\r\n", styles: [":host .shipping-container{min-height:620px}:host .shipping-container .edit__container{display:flex;background:#fcfcfd;padding:15px;border-radius:10px;margin:15px 0}:host .shipping-container .edit__container .title{font-size:16px;font-weight:700;margin:0}:host .shipping-container .edit__container .edit__link{margin-left:auto;transition:all .3s ease-in-out;cursor:pointer}:host .shipping-container .edit__container .edit__link:hover{text-decoration:underline}[dir=rtl] :host .shipping-container .edit__container .edit__link{margin-right:auto;margin-left:initial}:host .shipping-container .shipping__methods__container{background-color:#fff;padding:25px;min-height:350px;border-radius:10px;box-shadow:0 0 10px #0000001a}:host .shipping-container .shipping__methods__container .shipping__method__title{font-weight:700;font-size:18px;margin-bottom:2rem}:host .shipping-container .shipping__methods__container .form-group .form-control,:host .shipping-container .shipping__methods__container .form-group select{background-color:#fff;height:4rem;border:1px solid #c6d0e5;border-radius:5px;transition:.3s linear;font-size:14px;outline:none;box-shadow:none;cursor:pointer}:host .shipping-container .shipping__methods__container .form-group .form-control:focus,:host .shipping-container .shipping__methods__container .form-group select:focus{border:1px solid var(--main-color, var(--main-color, orange))}:host .shipping-container .shipping__methods__container .form-group.has-icon .fa{position:absolute;top:50%;right:15px;transform:translateY(-50%);font-size:18px;pointer-events:none}[dir=rtl] :host .shipping-container .shipping__methods__container .form-group.has-icon .fa{right:auto;left:15px}:host .shipping-container .help-block{color:red}:host .no__shipping__found{margin:45px 0;text-align:center}:host .no__shipping__found p{font-size:20px;font-weight:600}\n"], components: [{ type: CheckoutSpinnerComponent, selector: "app-checkout-spinner" }, { type: RadioButtonsComponent, selector: "app-radio-buttons", inputs: ["methods", "readSelectedMethod", "methodKey"], outputs: ["selectMethod"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6$2.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i6$2.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isDisabled", "isOpen", "bsValue", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts", "bsConfig"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ShippingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-shipping',
                    templateUrl: './shipping.component.html',
                    styleUrls: ['./shipping.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: CheckoutService }, { type: LanguageService }, { type: i2.Router }, { type: PaymentGuardCheckout }, { type: ConfService }, { type: i6$2.BsLocaleService }, { type: i1$1.FormBuilder }, { type: i3$1.ToastrService }, { type: TranslatePipe }, { type: FacebookPixelService }]; }, propDecorators: { timeSlotsDate: [{
                type: ViewChild,
                args: ['date']
            }], timeSlotsAvaliableHours: [{
                type: ViewChild,
                args: ['avaliableHoursId']
            }] } });

class OrderInvoiceComponent {
    constructor(confService, activeRoute, checkoutService, languageService, loaderService, router) {
        this.confService = confService;
        this.activeRoute = activeRoute;
        this.checkoutService = checkoutService;
        this.languageService = languageService;
        this.loaderService = loaderService;
        this.router = router;
        this.orderInfo = {};
        this.orderSummary = {};
        this.adjustments = [];
        this.getImage = ProductService.getImage;
        this.language = {};
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                localStorage.removeItem('downloadInvoice');
            }
        });
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(langauge => this.language = langauge);
        this.logo$ = this.confService.logo$;
        this.activeRoute.paramMap.pipe(switchMap((params) => of(params.get('id')))).subscribe(orderId => {
            this.orderId = +orderId;
            if (this.orderId) {
                this.checkoutService.getOrder(this.orderId)
                    .subscribe(data => {
                    if (data) {
                        this.mapResponseOfOrders(data);
                    }
                    this.orderSummary = {};
                    this.checkoutService.getOrderSummary(data, this.orderSummary);
                    this.checkoutService.getItemsAdjustment(data, this.adjustments);
                });
            }
        });
        this.store$ = this.confService.getConf().pipe(map(storename => storename['name']));
        this.store = this.confService.store$;
    }
    mapResponseOfOrders(data) {
        this.orderInfo['customer'] = data['billingAddress'];
        this.orderInfo['payment'] = data['payments'][0]['method'];
        this.orderInfo['shipment'] = data['shipments'][0]['method'];
        this.orderInfo['shipTo'] = data['shippingAddress']['street'];
        this.orderInfo['city'] = data['shippingAddress']['cityInfo'];
        this.orderInfo['area'] = data['shippingAddress']['areaInfo'];
        this.orderInfo['print_data'] = Date.now();
        this.orderInfo['items'] = data['items'];
        this.orderInfo['ordernumber'] = data['number'];
        this.orderInfo['branch'] = data['branch'] || null;
        return this.orderInfo;
    }
    ngAfterViewInit() {
        this.loaderService.loading().subscribe(data => {
            if (!data) {
                this.print();
            }
        });
    }
    print() {
        window.print();
    }
}
OrderInvoiceComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderInvoiceComponent, deps: [{ token: ConfService }, { token: i2.ActivatedRoute }, { token: CheckoutService }, { token: LanguageService }, { token: LoaderService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
OrderInvoiceComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: OrderInvoiceComponent, selector: "app-order-invoice", ngImport: i0, template: "<div class=\"container \">\r\n  <div class=\"invoice__container\">\r\n    <header>\r\n      <div class=\"logo\">\r\n        <a [routerLink]=\"['/', language['LANGUAGE_CODE']]\">\r\n          <img [lazyLoad]=\"logo$ | async\">\r\n        </a>\r\n      </div>\r\n      <h1>{{ language['Invoice'] }}</h1>\r\n      <ng-container *ngIf=\"orderInfo.customer\">\r\n        <div class=\"order__container\">\r\n          <div class=\"order__number__container\">\r\n            <span class=\"order__number__title\">{{ language['order_number'] }} : </span>\r\n            <span class=\"order__number\">{{ orderInfo.ordernumber }}</span>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4 col-12 col-sm-4\">\r\n              <div class=\"customer__info col__info\">\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['storeName']}} : </span> {{store$ |\r\n                  async}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['customer']}} : </span>\r\n                  {{orderInfo.customer.firstName}}\r\n                  {{orderInfo.customer.lastName}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['address']}} : </span>\r\n                  {{orderInfo.shipTo}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['phone_number']}} : </span> {{\r\n                  orderInfo.customer.phoneNumber}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['formCountry']}} : </span>\r\n                  {{orderInfo.customer.countryName}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['city']}} : </span> {{orderInfo.city | translate: 'name'}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['area']}} : </span> {{orderInfo.area | translate: 'name'}}</div>\r\n                <div class=\"customer__info__item\" *ngIf=\"orderInfo.branch\"><span class=\"title\">{{language['branch']}} : </span> {{orderInfo.branch | translate: 'name'}}</div>\r\n\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-4 col-12 col-sm-4\">\r\n              <div class=\"order__info col__info\">\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['payment_type']}} : </span>\r\n                  {{orderInfo.payment | translate : 'name'}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['shipment_type']}} :</span>\r\n                  {{orderInfo.shipment | translate: 'name'}}\r\n                </div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['bill_to'] || 'Bill To'}} : </span>\r\n                  {{orderInfo.customer.street}} </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-4 col-12 col-sm-4\">\r\n              <div class=\"order__date col__info\">\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['printing_date']}} </span>\r\n                  {{orderInfo.print_data | date:'medium'}}</div>\r\n                <div class=\"customer__info__item\"><span class=\"title\">{{language['order_date']}} : </span>\r\n                  {{orderInfo.customer.createdAt | date:'medium'}}</div>\r\n                  <div *ngIf=\" store | async as store\"  class=\"customer__info__item\"><span *ngIf=\"store.commercialRegistration\" class=\"title\">{{language['commercialRegistration'] || 'Commercial Registration'}}  : </span>\r\n                    <span *ngIf=\"store.commercialRegistration\">{{store.commercialRegistration}}</span> \r\n                   </div>\r\n                   <div *ngIf=\" store | async as store\" class=\"customer__info__item\"><span *ngIf=\"store.taxId\"  class=\"title\">{{language['taxId'] || 'Tax ID'}} : </span>\r\n                     <span *ngIf=\"store.taxId\">{{store.taxId}}</span>\r\n                   </div>   \r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </header>\r\n\r\n    <main>\r\n      <div class=\"table-responsive\">\r\n        <table class=\"table table-striped\">\r\n          <thead class=\"thead-dark\">\r\n            <tr>\r\n              <th>#</th>\r\n              <th class=\"desc\">{{language['productName']}}</th>\r\n              <th class=\"desc\">{{language['productOptions']}}</th>\r\n              <th>{{language['price']}}</th>\r\n              <th>{{language['quantity']}}</th>\r\n              <th>{{language['total']}}</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr *ngFor=\"let item of orderInfo.items\">\r\n              <td><a [routerLink]=\"['/', language['LANGUAGE_CODE']]\"></a><img height=\"120\" [src]=\"getImage(item.variant.product)\"></td>\r\n              <td class=\" total\">\r\n                <p> {{item.variant.product | translate : 'name'}}</p>\r\n                <!-- <p>{{ item.variant | translate : 'name' }}</p> -->\r\n              </td>\r\n              <td class=\"total\">\r\n                  <span *ngIf=\"item.variant?.optionValues?.length > 0\">\r\n                    <p *ngFor=\"let unit of item.variant.optionValues\" class=\"short-desc m-b-0\">\r\n                      {{ unit | translate: 'name' }}\r\n                    </p>\r\n                  </span>\r\n                  <span  *ngIf=\"item['type']\">\r\n                    <p *ngFor=\"let unit of item.units\" class=\"short-desc m-b-0\">\r\n                      {{unit['subVariant'] | translate: 'name'}}\r\n                    </p>\r\n                  </span>\r\n             \r\n              </td>\r\n              <td class=\"total\">\r\n                {{ item.unitPrice / 100 | number}} {{currencyCode}}\r\n              </td>\r\n              <td class=\"qty\">{{item.quantity}}</td>\r\n              <td class=\"total\">\r\n                {{ item.total / 100 | number}} {{currencyCode}}\r\n                <p *ngIf=\"((item.unitPrice* item.quantity) - item.total) > 0\">\r\n                  <span style=\"text-decoration: line-through;color: #000;\">\r\n                    {{ item.unitPrice / 100 * item.quantity | number}} {{currencyCode}}\r\n                  </span>\r\n                </p>\r\n              </td>\r\n            </tr>\r\n            <tr *ngFor=\"let adjust of adjustments\">\r\n              <td colspan=\"5\" class=\"total\">{{adjust.type }}</td>\r\n              <td class=\"total\">\r\n                {{adjust.amount / 100 | number}} {{currencyCode}}<br>\r\n              </td>\r\n            </tr>\r\n            <tr *ngIf=\"orderSummary.promotions\">\r\n              <td colspan=\"5\" class=\"total\">{{language['summaryPromotions']}}</td>\r\n              <td class=\"total\">{{orderSummary.promotions / 100 | number}} {{currencyCode}}</td>\r\n            </tr>\r\n            <tr>\r\n              <td colspan=\"5\" class=\"total\">{{language['subtotal']}}</td>\r\n              <td class=\"total\" *ngIf=\"orderSummary.itemsTotal\">{{orderSummary.itemsTotal / 100 | number}}\r\n                {{currencyCode}}</td>\r\n            </tr>\r\n            <tr>\r\n              <td colspan=\"5\" class=\"grand total\">{{language['total'] }}</td>\r\n              <td class=\"grand total \" *ngIf=\"orderSummary.total\">{{orderSummary.total /100 | number}}\r\n                {{currencyCode}}</td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n      </div>\r\n    </main>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"backBtnContainer\">\r\n  <a class=\"backBtn\" [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection']\">{{language['continueShopping']}}</a>\r\n</div>\r\n", styles: [".invoice__container{padding:30px 0;min-height:700px}.invoice__container .logo{background-color:var(--header-bg-color, #fff);padding:1rem;border-radius:1rem;max-width:220px}.invoice__container .logo a{display:flex;align-items:center;justify-content:center;height:70px}.invoice__container .logo a img{max-width:100%;max-height:100%}.invoice__container .order__container{margin:30px 0}.invoice__container .order__container .order__number__container .order__number__title{font-weight:700;text-transform:capitalize}.invoice__container .order__container .order__number__container .order__number{color:#09f}.invoice__container .order__container .col__info .customer__info__item .title{font-weight:700;text-transform:capitalize}.invoice__container .table{background:#fff;margin:3rem 0}.invoice__container .table th{text-transform:capitalize}.invoice__container .table td{vertical-align:middle;text-transform:capitalize}.invoice__container .table td img{max-width:100%;height:80px}.invoice__container .table .total{text-transform:capitalize;font-weight:700}.backBtnContainer{text-align:center;margin:20px auto}.backBtnContainer .backBtn{color:#000;box-shadow:0;padding:5px 40px;text-transform:capitalize;font-size:20px;box-shadow:none;border-radius:50px;background:transparent;border:1px solid #000}.m-b-0{margin-bottom:0!important}\n"], directives: [{ type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i6.AsyncPipe, "translate": TranslatePipe, "date": i6.DatePipe, "number": i6.DecimalPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderInvoiceComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-order-invoice',
                    templateUrl: './order-invoice.component.html',
                    styleUrls: ['./order-invoice.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: ConfService }, { type: i2.ActivatedRoute }, { type: CheckoutService }, { type: LanguageService }, { type: LoaderService }, { type: i2.Router }]; } });

class CheckoutOrderSuccessGuard {
    constructor(router) {
        this.router = router;
        this.stepFour = JSON.parse(localStorage.getItem('stepFour'));
    }
    canActivate() {
        if (this.stepFour === true) {
            return true;
        }
        else {
            this.router.navigate(['']);
            return false;
        }
    }
}
CheckoutOrderSuccessGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutOrderSuccessGuard, deps: [{ token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
CheckoutOrderSuccessGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutOrderSuccessGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutOrderSuccessGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }]; } });

class FeatureProductBaseComponent {
    constructor(languageService, wishListService, compareService, quickViewService, confService, productService, collectionService, cartService) {
        this.languageService = languageService;
        this.wishListService = wishListService;
        this.compareService = compareService;
        this.quickViewService = quickViewService;
        this.confService = confService;
        this.productService = productService;
        this.collectionService = collectionService;
        this.cartService = cartService;
        this.defaultImage = environment.defaultImage;
        this.language = {};
        this.modal = false;
        this.fav = Observable.create(false);
        this.compare = Observable.create(false);
        this.imageUrl = environment.imageUrl;
        this.wishListFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.WISH_LIST));
        this.compareFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.COMPARE));
        this.imgIsLoaded = false;
        this.imgSrc = '';
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.fav = this.wishListService.inWishList(this.product.code);
        this.compare = this.compareService.inCompare(this.product.code);
        this.languageService.getLanguage().subscribe(language => this.language = language);
        // this.productService.SortVariants(this.product);
        this.collectionService.filterOptions(this.product); // get options from variants
        this.getProductImg();
        const variant = this.product.variants[0];
        this.manageVariant(variant);
    }
    getProductImg() {
        this.imgSrc = ProductService.getImage(this.product);
    }
    toggleWishList() {
        this.wishListService.toggleWishList(this.product.code);
    }
    toggleCompare() {
        this.compareService.toggleCompare(this.product.code);
    }
    openQuickView() {
        if (this.product.options.length === 0) {
            const variant = this.product.variants[0];
            this.cartService.addToCart(variant, 1, this.product);
            return;
        }
        this.quickViewService.open(this.product);
    }
    ngOnDestroy() {
        this.quickViewService.close();
    }
    manageVariant(variant) {
        if (variant.tracked === false) {
            // variant isn't tracked
            this.canAddToCart = true;
            return;
        }
        if (variant['stock'] <= 0) {
            // variant doesn't have stock
            this.canAddToCart = false;
            return;
        }
    }
}
FeatureProductBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FeatureProductBaseComponent, deps: [{ token: LanguageService }, { token: WishListService }, { token: CompareService }, { token: QuickViewService }, { token: ConfService }, { token: ProductService }, { token: CollectionService }, { token: CartService }], target: i0.ɵɵFactoryTarget.Component });
FeatureProductBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: FeatureProductBaseComponent, selector: "ng-component", inputs: { product: "product", featured: "featured" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FeatureProductBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: WishListService }, { type: CompareService }, { type: QuickViewService }, { type: ConfService }, { type: ProductService }, { type: CollectionService }, { type: CartService }]; }, propDecorators: { product: [{
                type: Input
            }], featured: [{
                type: Input
            }] } });

class CheckoutOrderInvoiceGuard {
    constructor(router) {
        this.router = router;
        this.downloadInovice = JSON.parse(localStorage.getItem('downloadInvoice'));
    }
    canActivate() {
        if (this.downloadInovice === true) {
            return true;
        }
        else {
            this.router.navigate(['']);
            return false;
        }
    }
}
CheckoutOrderInvoiceGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutOrderInvoiceGuard, deps: [{ token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
CheckoutOrderInvoiceGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutOrderInvoiceGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CheckoutOrderInvoiceGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }]; } });

class LanguageBaseComponent {
    constructor(router, languageService) {
        this.router = router;
        this.languageService = languageService;
        const language = localStorage.getItem('language');
        if (!language) {
            localStorage.setItem('language', this.languageService.defaultLocale);
            this.router.navigate([this.languageService.defaultLocale], { replaceUrl: true });
        }
        this.languageService.is_available(language).subscribe(data => {
            if (data) {
                const pathWithQueryParam = this.router.url.indexOf('/?') > -1 ? '?' + this.router.url.split('?')[1] : '';
                this.router.navigateByUrl(language + pathWithQueryParam, { replaceUrl: true });
            }
            else {
                localStorage.setItem('language', this.languageService.defaultLocale);
                this.router.navigate([this.languageService.defaultLocale], { replaceUrl: true });
            }
        });
    }
}
LanguageBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LanguageBaseComponent, deps: [{ token: i2.Router }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
LanguageBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: LanguageBaseComponent, selector: "app-base-language", ngImport: i0, template: "<!-- Loading -->\r\n<app-inner-loading></app-inner-loading>", styles: ["<!-- Loading -->\r\n<app-inner-loading></app-inner-loading>"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LanguageBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-language',
                    templateUrl: './language.base-component.html',
                    styleUrls: ['./language.base-component.html']
                }]
        }], ctorParameters: function () { return [{ type: i2.Router }, { type: LanguageService }]; } });

class HeaderItemBaseComponent {
    constructor(languageService, breakpointObserver, dynamicNavigationMenu, activatedRoute, router) {
        this.languageService = languageService;
        this.breakpointObserver = breakpointObserver;
        this.dynamicNavigationMenu = dynamicNavigationMenu;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.hideme = [];
        this.language = {};
        this.closeModal = new EventEmitter();
        this.parent = false;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
            this.readUrl();
        });
        if (this.navItems) {
            this.index = this.navItems.indexOf(this.navItems.find(navItem => this.router.url.includes(navItem.url)));
        }
        this.resonsiveSub = this.breakpointObserver
            .observe(['(max-width: 767.98px)'])
            .subscribe((state) => {
            if (state.matches) {
                this.smallScreen = true;
            }
            else {
                this.smallScreen = false;
            }
        });
        this.queryParamsSub = this.activatedRoute.queryParams.subscribe(params => {
            this.index = this.isEmpty(params) ? -1 : this.index;
        });
    }
    ngAfterViewInit() {
        this.getListOfLinksContainer('.menu__item__withoutParams');
    }
    getListOfLinksContainer(el) {
        const container = document.querySelectorAll(el);
        for (let i = 0; i < container.length; i++) {
            container[i].style.borderBottom = '1px solid #f1f1f1';
        }
        return container;
    }
    ngOnDestroy() {
        if (this.resonsiveSub) {
            this.resonsiveSub.unsubscribe();
        }
        if (this.queryParamsSub) {
            this.queryParamsSub.unsubscribe();
        }
    }
    close() {
        this.closeModal.emit();
        this.dynamicNavigationMenu.setCloseBehaviorView(true);
    }
    showMenu(i, e) {
        e.stopPropagation();
        this.hideme[i] = !this.hideme[i];
    }
    setIndex(index) {
        this.index = index;
    }
    isEmpty(obj) {
        for (const prop in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    }
    readUrl() {
        const theOtherLanguage = this.language['LANGUAGE_CODE'] === 'en_US' ? 'ar_EG' : 'en_US';
    }
}
HeaderItemBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HeaderItemBaseComponent, deps: [{ token: LanguageService }, { token: i4.BreakpointObserver }, { token: DynamicNavigationMenu }, { token: i2.ActivatedRoute }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
HeaderItemBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: HeaderItemBaseComponent, selector: "app-base-header-item", inputs: { navItems: "navItems", parent: "parent" }, outputs: { closeModal: "closeModal" }, ngImport: i0, template: "<ng-template [ngIf]='!smallScreen'>\r\n  <ul class=\"sidenav__list\" id=\"sideNavScroll\">\r\n    <ng-template ngFor let-menu [ngForOf]=\"navItems\" let-i=\"index\">\r\n      <li class=\"sidenav__link__parent\" (mouseover)='menu.selected = true' (mouseleave)='menu.selected = false'>\r\n\r\n        <!-- if static page -->\r\n        <div class=\"menu__item__withParams d-flex justify-content-between align-items-center\"\r\n          *ngIf=\" menu.url_type == 'static_page'\">\r\n          <a [class.active]='index==i' (click)=\"setIndex(i)\"\r\n            [target]=\"menu['target'] === '_blank' ? '_blank' : '_self'\"\r\n            [routerLink]=\"['/', language['LANGUAGE_CODE'] , 'page' , menu.url.slice(6)]\"\r\n            *ngIf=\"menu.url_type == 'static_page'\" class=\"menu__item__link\">\r\n            {{menu | translate: 'name' }}\r\n          </a>\r\n          <i class=\"fa fa-plus\" *ngIf=\"menu.children.length > 0 && !parent && !menu.selected\" aria-hidden=\"true\"></i>\r\n          <i class=\"fa fa-minus\" *ngIf=\"menu.children.length > 0 && !parent && menu.selected\" aria-hidden=\"true\"></i>\r\n        </div>\r\n\r\n        <!-- if taxon -->\r\n        <div class=\"menu__item__withParams d-flex justify-content-between align-items-center\"\r\n        *ngIf=\" menu.url_type == 'taxon'\">\r\n        <a [class.active]='index==i' (click)=\"setIndex(i)\" [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection']\"\r\n          [target]=\"menu['target'] === '_blank' ? '_blank' : '_self'\"\r\n          [queryParams]=\"!isEmpty(menu.parsedUrl?.params)?menu.parsedUrl?.params:{taxons:menu.url.slice(19)}\"\r\n          *ngIf=\"menu.url_type == 'taxon'\" class=\"menu__item__link\">\r\n          {{menu | translate: 'name' }}\r\n        </a>\r\n        <i class=\"fa fa-plus\" *ngIf=\"menu.children.length > 0 && !parent && !menu.selected\" aria-hidden=\"true\"></i>\r\n        <i class=\"fa fa-minus\" *ngIf=\"menu.children.length > 0 && !parent && menu.selected\" aria-hidden=\"true\"></i>\r\n        </div>\r\n\r\n        <!-- if extrnal link -->\r\n        <div class=\"menu__item__withParams d-flex justify-content-between align-items-center\"\r\n          *ngIf=\"menu.url_type === 'external_link'\">\r\n          <a [href]=\"menu.url\" class=\"menu__item__link\" [target]=\"menu['target'] === '_blank' ? '_blank' : '_self'\">{{ menu | translate: 'name' }}</a>\r\n          <i class=\"fa fa-plus\" *ngIf=\"menu.children.length > 0  && !parent && !menu.selected\" aria-hidden=\"true\"></i>\r\n          <i class=\"fa fa-minus\" *ngIf=\"menu.children.length > 0  && !parent && menu.selected\" aria-hidden=\"true\"></i>\r\n        </div>\r\n        <app-base-header-item *ngIf=\"menu.children\" [navItems]=\"menu.children\" [hidden]=\"!menu.selected\" id=\"custom__nav--children\">\r\n        </app-base-header-item>\r\n      </li>\r\n    </ng-template>\r\n  </ul>\r\n\r\n</ng-template>\r\n\r\n<ng-template [ngIf]='smallScreen'>\r\n  <ul class=\"sidenav__list\" id=\"sideNavScroll\">\r\n    <ng-template ngFor let-menu [ngForOf]=\"navItems\" let-i=\"index\">\r\n      <li class=\"sidenav__link__parent\">\r\n\r\n        <!-- if taxon -->\r\n        <div class=\"menu__item__withParams d-flex justify-content-between align-items-center\"\r\n          *ngIf=\" menu.url_type == 'taxon'\">\r\n          <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection']\" [queryParams]=\"!isEmpty(menu.parsedUrl?.params)?menu.parsedUrl?.params:{taxons:menu.url.slice(19)}\" (click)=\"close()\"\r\n            *ngIf=\"menu.url_type == 'taxon'\" class=\"menu__item__link\">\r\n            {{menu | translate: 'name' }}\r\n          </a>\r\n          <i class=\"fa fa-plus toggle_submenu\" (click)=\"showMenu(i,$event)\" *ngIf=\"menu.children.length > 0 && !hideme[i]\"\r\n            aria-hidden=\"true\"></i>\r\n          <i class=\"fa fa-minus toggle_submenu\" (click)=\"showMenu(i,$event)\" *ngIf=\"menu.children.length > 0   && hideme[i]\"\r\n            aria-hidden=\"true\"></i>\r\n        </div>\r\n\r\n         <!-- if static page -->\r\n        <div class=\"menu__item__withParams d-flex justify-content-between align-items-center\"\r\n          *ngIf=\" menu.url_type == 'static_page'\">\r\n          <a [routerLink]=\"['/', language['LANGUAGE_CODE'] , 'page' , menu.url.slice(6)]\" (click)=\"close()\"\r\n            *ngIf=\"menu.url_type == 'static_page'\" class=\"menu__item__link\">\r\n            {{menu | translate: 'name' }}\r\n          </a>\r\n          <i class=\"fa fa-plus toggle_submenu\" (click)=\"showMenu(i,$event)\" *ngIf=\"menu.children.length > 0 && !hideme[i]\"\r\n            aria-hidden=\"true\"></i>\r\n          <i class=\"fa fa-minus toggle_submenu\" (click)=\"showMenu(i,$event)\" *ngIf=\"menu.children.length > 0   && hideme[i]\"\r\n            aria-hidden=\"true\"></i>\r\n        </div>\r\n\r\n        <!-- if extrnal link -->\r\n        <div class=\"menu__item__withoutParams d-flex justify-content-between align-items-center\"\r\n          *ngIf=\"menu.url_type === 'external_link'\">\r\n\r\n          <a [href]=\"menu.url\" class=\"menu__item__link\" [target]=\"menu['target'] === '_blank' ? '_blank' : '_self'\" (click)=\"close()\">{{\r\n            menu\r\n            |\r\n            translate: 'name' }}</a>\r\n          <i class=\"fa fa-plus toggle_submenu\" (click)=\"showMenu(i,$event)\" *ngIf=\"menu.children.length > 0  && !hideme[i]\"\r\n            aria-hidden=\"true\"></i>\r\n\r\n          <i class=\"fa fa-minus toggle_submenu\" (click)=\"showMenu(i,$event)\" *ngIf=\"menu.children.length > 0  && hideme[i]\"\r\n            aria-hidden=\"true\"></i>\r\n        </div>\r\n        <app-base-header-item *ngIf=\"menu.children\" [navItems]=\"menu.children\" [hidden]=\"!hideme[i]\"\r\n        (closeModal)=\"close()\"\r\n        id=\"custom__nav--children\"\r\n        >\r\n        </app-base-header-item>\r\n      </li>\r\n    </ng-template>\r\n  </ul>\r\n\r\n</ng-template>\r\n", styles: ["@media screen and (max-width: 767.98px){:host ::ng-deep .menu__item__withParams{border-bottom:1px solid #f1f1f1}:host .sidenav__list{list-style:none;position:relative;margin:0;padding:0}:host .sidenav__list .menu__item__link{text-decoration:none;font-weight:400;font-size:16px;line-height:32px;padding:5px 0;float:left;flex-basis:50%;color:var(--header-link-color, var(--main-color, orange))}:host .sidenav__list .menu__item__link:active{color:red!important}[dir=rtl] :host .sidenav__list .menu__item__link{float:right;left:unset}:host .sidenav__list i{color:var(--main-color, orange);flex-basis:50%;text-align:right}[dir=rtl] :host .sidenav__list i{text-align:left}:host .sidenav__list .sidenav__link__parent{position:relative;text-transform:capitalize;margin:0;padding:0 0 0 10px;transition:all .3s ease-in-out;color:var(--header-link-color);display:block;width:100%}[dir=rtl] :host .sidenav__list .sidenav__link__parent{padding:0 10px 0 0}:host .sidenav__list .sidenav__link__parent:last-child{border-bottom:none;border-top:none}:host .sidenav__list .sidenav__link__parent i{padding-right:25px;color:var(--main-color, orange)}[dir=rtl] :host .sidenav__list .sidenav__link__parent i{padding-left:25px;padding-right:unset}:host .sidenav__list .sidenav__link__parent:hover ::ng-deep>app-base-header-item>ul li{display:block;width:100%}:host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul{position:relative;width:100%;background:#fff;transition:all .5s ease-in;z-index:9999}:host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul li{display:block;width:100%}:host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul a{line-height:20px;padding:5px}}@media screen and (min-width: 768px){:host .sidenav__list{list-style:none;position:relative;float:left;margin:0;padding:0}[dir=rtl] :host .sidenav__list{float:right}:host .sidenav__list .menu__item__link{text-decoration:none;font-weight:400;font-size:16px;line-height:32px;padding:10px 15px;float:left;color:var(--header-link-color, var(--main-color, orange))}[dir=rtl] :host .sidenav__list .menu__item__link{float:right}:host .sidenav__list i{color:var(--header-link-color, var(--main-color, orange))}:host .sidenav__list .sidenav__link__parent{position:relative;text-transform:capitalize;float:left;margin:0;padding:0 10px;transition:all .3s ease-in-out;color:var(--header-link-color, var(--main-color, orange))}[dir=rtl] :host .sidenav__list .sidenav__link__parent{float:right}:host .sidenav__list .sidenav__link__parent i{padding-right:10px;color:var(var(--main-color, orange), #f1f1f1)}:host .sidenav__list .sidenav__link__parent a{color:var(--main-color, #f1f1f1)}:host .sidenav__list .sidenav__link__parent:hover{background:var(--main-color, orange);transform:translateY(-2)}:host .sidenav__list .sidenav__link__parent:hover .menu__item__link:first-child{color:#09f!important}:host .sidenav__list .sidenav__link__parent:hover ::ng-deep>app-base-header-item>ul{opacity:1;visibility:visible}:host .sidenav__list .sidenav__link__parent:hover i{color:var(--main-second-color, #ffffff)}:host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul{opacity:0;visibility:hidden;position:absolute;top:100%;left:0;background:var(--header-bg-color);transition:all .5s ease-in;padding:0;z-index:99999;box-shadow:0 1px 9px -2px #000000bf}[dir=rtl] :host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul{right:0;left:unset}:host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul li{float:none;width:20rem}:host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul a{line-height:18px;padding:10px}:host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul ul{top:0;left:100%}[dir=rtl] :host .sidenav__list .sidenav__link__parent ::ng-deep>app-base-header-item>ul ul{right:100%;left:unset}}.active{font-weight:700!important}\n"], components: [{ type: HeaderItemBaseComponent, selector: "app-base-header-item", inputs: ["navItems", "parent"], outputs: ["closeModal"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "translate": TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HeaderItemBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-header-item',
                    templateUrl: './header-item.base-component.html',
                    styleUrls: ['./header-item.base-component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i4.BreakpointObserver }, { type: DynamicNavigationMenu }, { type: i2.ActivatedRoute }, { type: i2.Router }]; }, propDecorators: { closeModal: [{
                type: Output
            }], navItems: [{
                type: Input
            }], parent: [{
                type: Input
            }] } });

class StoreNotPublishedComponent {
    constructor(confService, formBuilder) {
        this.confService = confService;
        this.formBuilder = formBuilder;
        this.submitted = false;
        this.loading = false;
        this.isValid = false;
        this.isNotValid = false;
        this.currentDate = new Date();
        this.imageUrl = environment.imageUrl;
        this.show = false;
    }
    ngOnInit() {
        this.confService.isUnderConstructionStoreSubject.subscribe(res => {
            this.comingSoonData = res;
            this.imageUrl = environment.imageUrl;
        });
        this.storePasswordForm = this.formBuilder.group({
            'password': ['', [Validators.required, Validators.min(1)]]
        });
    }
    showStorePassword() {
        this.show = !this.show;
    }
    get formControls() {
        return this.storePasswordForm.controls;
    }
    checkStoreState() {
        this.loading = true;
        this.submitted = true;
        const password = this.storePasswordForm.controls['password'].value;
        this.confService.validateStorePassword(password)
            .subscribe(data => {
            this.message = data['body']['response'];
            if (this.storePasswordForm.invalid) {
                this.loading = false;
                return;
            }
            if (data['body']['status'] === 'success') {
                this.loading = false;
                this.isNotValid = false;
                this.isValid = true;
                this.setSessionForOwner();
            }
            if (data['body']['status'] === 'failure') {
                this.loading = false;
                this.isValid = false;
                this.isNotValid = true;
                this.message = data['body']['response'];
            }
        });
    }
    setSessionForOwner() {
        this.sessionTimer = setTimeout(() => {
            this.confService.isUnderConstructionStoreSubject.next(false);
            sessionStorage.setItem('isValid', 'true');
        }, 1000);
    }
    ngOnDestroy() {
        clearTimeout(this.sessionTimer);
    }
    check_age() {
        const birthDate = new Date(this.birthDate);
        let age = this.currentDate.getFullYear() - birthDate.getFullYear();
        const monthsDif = this.currentDate.getMonth() - birthDate.getMonth();
        if (monthsDif < 0 || (monthsDif === 0 && this.currentDate.getDate() < birthDate.getDate())) {
            age--;
        }
        this.loading = true;
        this.submitted = true;
        // Check Age.
        setTimeout(() => {
            if (age >= +this.comingSoonData['value']) {
                this.loading = false;
                this.isValid = true;
                this.message = 'Successfully';
                this.setSessionForOwner();
            }
            else {
                this.loading = false;
                this.isValid = false;
                this.message = 'You must be ' + this.comingSoonData['value'] + ' or older !';
            }
        }, 500);
    }
}
StoreNotPublishedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StoreNotPublishedComponent, deps: [{ token: ConfService }, { token: i1$1.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
StoreNotPublishedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: StoreNotPublishedComponent, selector: "app-store-not-published", ngImport: i0, template: "<div class=\"store-not-published container\">\r\n    <div class=\"store__not__published__content\">\r\n        <img alt=\"store not available\" [lazyLoad]=\"imageUrl + comingSoonData['image']\" #def_img (error)=\"def_img.src = 'assets/images/built-on-zvendo.png'\">\r\n        <div [ngSwitch]=\"comingSoonData['type']\">\r\n            <div *ngSwitchCase=\"'password'\">\r\n                <p class=\"store__password\">Please enter the password if you have to see the store</p>\r\n                <form class=\"publish-form\" (ngSubmit)=\"checkStoreState()\" [formGroup]=\"storePasswordForm\">\r\n                    <div class=\"publish-form__group\">\r\n                        <input [type]=\"show ? 'text' : 'password'\" class=\"publish-form__input\" formControlName='password' placeholder=\"Password\">\r\n                        <span class=\"publish-form__icon \" [ngClass]=\"show ?'fa fa-eye':'fa fa-eye-slash'\" (click)=\"showStorePassword()\"></span>\r\n                        <button class=\"publish-form__btn\" type=\"submit\" [disabled]=\"!storePasswordForm.valid\">Go</button>\r\n                    </div>\r\n                    <ng-container *ngIf=\"message && !loading && isNotValid\">\r\n                        <div class=\"publish-form__errors\">\r\n                            <p class=\"publish-form__errorsText\">{{message}}</p>\r\n                        </div>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"message && !loading && isValid\">\r\n                        <div class=\"publish-form__validStore\">\r\n                            <p class=\"publish-form__validStoreMessage\">{{message}}</p>\r\n                        </div>\r\n                    </ng-container>\r\n                    <div class=\"publish-form__loaderContainer\"></div>\r\n                    <ng-template [ngIf]='loading'>\r\n                        <div class=\"lds-ring\">\r\n                            <div></div>\r\n                            <div></div>\r\n                            <div></div>\r\n                            <div></div>\r\n                        </div>\r\n                    </ng-template>\r\n                </form>\r\n            </div>\r\n            <div *ngSwitchCase=\"'age'\" class=\"check_age\">\r\n                <p class=\"store__password\">Please enter your Birth date if you have to see the store</p>\r\n                <div class=\"publish-form\">\r\n                    <div class=\"publish-form__group\">\r\n                        <input [(ngModel)]='birthDate' #dp=\"bsDatepicker\" placement=\"top\" [placeholder]=\"'Birth Date'\" bsDatepicker [maxDate]=\"currentDate\" class=\"publish-form__input\">\r\n                        <span class=\"publish-form__icon fa fa-calendar\" (click)=\"dp.toggle()\"></span>\r\n                        <button class=\"publish-form__btn\" (click)=\"check_age()\" [disabled]=\"!birthDate\">Go</button>\r\n                    </div>\r\n                </div>\r\n\r\n                <ng-container *ngIf=\"message && !loading && !isValid\">\r\n                    <div class=\"publish-form__errors\">\r\n                        <p class=\"publish-form__errorsText\">{{message}}</p>\r\n                    </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"message && !loading && isValid\">\r\n                    <div class=\"publish-form__validStore\">\r\n                        <p class=\"publish-form__validStoreMessage\">{{message}}</p>\r\n                    </div>\r\n                </ng-container>\r\n                <div class=\"publish-form__loaderContainer\"></div>\r\n                <ng-template [ngIf]='loading'>\r\n                    <div class=\"lds-ring\">\r\n                        <div></div>\r\n                        <div></div>\r\n                        <div></div>\r\n                        <div></div>\r\n                    </div>\r\n                </ng-template>\r\n\r\n\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"comingSoonData['image'] == null || undefined\" class=\"store-not-published__logoContainer\">\r\n        <div class=\"store-not-published__logoWrapper\">\r\n            <img class=\"store-not-published__logo\" src=\"assets/images/zvendo-logo.png\">\r\n        </div>\r\n    </div>\r\n</div>", styles: [":host .store-not-published{position:relative;display:flex;justify-content:center;align-items:center;flex-direction:column;height:100vh}:host .store-not-published .store__not__published__content{width:50%;text-align:center}@media (max-width: 767px){:host .store-not-published .store__not__published__content{max-width:500px;width:100%}}:host .store-not-published .store__not__published__content .store__not__published__text{margin-top:15px 0px 0px 0px;font-weight:700}:host .store-not-published .store__not__published__content .store__password{color:var(--body-link-color, #292929)}:host .store-not-published .store__not__published__content img{max-width:100%;height:auto;padding-bottom:15px}:host .store-not-published__logoContainer{margin-top:60px}:host .store-not-published__logoWrapper{margin:auto;text-align:center}:host .publish-form{width:80%;margin:20px auto auto}:host .publish-form__group{position:relative;border-radius:10px;background:#FFF;box-shadow:0 2px 5px #0003;overflow:hidden}:host .publish-form__input{padding:10px 15px;border:none;width:100%}:host .publish-form__icon{position:absolute;top:11px;right:90px;color:var(--main-color, orange);cursor:pointer;font-size:20px}[dir=rtl] :host .publish-form__icon{right:unset;left:90px}:host .publish-form__btn{position:absolute;top:0;right:0;background:var(--main-color, orange);border:none;border-radius:10px;color:#fff;font-weight:bold;width:70px;height:44px;font-size:25px;transition:all .3s ease-in-out}[dir=rtl] :host .publish-form__btn{right:unset;left:0}:host .publish-form__btn:disabled{opacity:.5;cursor:not-allowed}:host .publish-form__btn:hover{background:var(--main-color, orange)}:host .publish-form__btn:focus{outline:none;box-shadow:unset}:host .publish-form__errors{margin:20px 0;background-color:#eb2e2e;box-shadow:0 2px 5px #0003;border-radius:15px}:host .publish-form__errorsText{font-weight:600;padding:7px;color:#fff;font-size:20px}:host .publish-form__loaderContainer{margin:auto;text-align:center}:host .publish-form__validStore{margin:20px 0;background-color:#08bd45;box-shadow:0 2px 5px #0003;border-radius:15px}:host .publish-form__validStoreMessage{font-weight:600;padding:7px;color:#fff;font-size:20px}@media (max-width: 500px){:host .store-published-published img{width:100%;height:auto!important}:host .store-not-published{position:relative;height:100%;padding-top:70px}}::ng-deep .bs-datepicker-head{background-color:var(--main-color, orange)!important}::ng-deep .bs-datepicker-body table td span.selected,::ng-deep .bs-datepicker-body table td.selected span,::ng-deep .bs-datepicker-body table td span[class*=select-]:after,::ng-deep .bs-datepicker-body table td[class*=select-] span:after{background-color:var(--main-color, orange)!important}\n"], directives: [{ type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i6.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i6.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6$2.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i6$2.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isDisabled", "isOpen", "bsValue", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts", "bsConfig"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StoreNotPublishedComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-store-not-published',
                    templateUrl: './store-not-published.component.html',
                    styleUrls: ['./store-not-published.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: ConfService }, { type: i1$1.FormBuilder }]; } });

class WishListGuard {
    constructor(loginService, router) {
        this.loginService = loginService;
        this.router = router;
    }
    canActivate(route, state) {
        const language = state.url.split('/').filter(data => data !== '')[0];
        if (this.loginService.isLoggedIn()) {
            return true;
        }
        this.router.navigate(['/', language, 'accounts', 'login'], { queryParams: { returnUrl: state.url } });
    }
}
WishListGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListGuard, deps: [{ token: LoginService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
WishListGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: WishListGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LoginService }, { type: i2.Router }]; } });

class PageNotFoundComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
PageNotFoundComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PageNotFoundComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PageNotFoundComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: PageNotFoundComponent, selector: "app-store-not-found", ngImport: i0, template: "<div class=\"store-not-found container d-flex align-items-center justify-content-center\">\r\n  <img alt=\"store not available\" src=\"assets/images/page-not-found.png\">\r\n</div>\r\n", styles: [".store-not-found{height:100vh}@media (max-width: 500px){.store-not-found img{width:100%}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PageNotFoundComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-store-not-found',
                    templateUrl: './page-not-found.component.html',
                    styleUrls: ['./page-not-found.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

class HeaderTaxonBaseComponent {
    constructor() {
        this.closeModal = new EventEmitter();
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
    }
    ngOnDestroy() {
    }
    close() {
    }
}
HeaderTaxonBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HeaderTaxonBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HeaderTaxonBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: HeaderTaxonBaseComponent, selector: "app-base-header-taxon", inputs: { taxons: "taxons", modal: "modal" }, outputs: { closeModal: "closeModal" }, ngImport: i0, template: "<li class=\"dropdown\" *ngFor=\"let taxon of taxons\"   \r\n  [value]=\"taxon.code\">\r\n\r\n  <div class=\"nav-item\" *ngIf=\"!taxon.children\">\r\n    <a class=\"dropdown-item\"  routerLink=\"/collection\" [queryParams]=\"{taxons: taxon.code}\" (click)=\"modal.hide()\">\r\n      {{ taxon | translate: 'name' }}\r\n    </a>\r\n    <!-- <span class=\"sub-icon\">\r\n      <i (click)=\"taxon.selected = !taxon.selected; $event.stopPropagation()\" *ngIf=\"taxon.children && !taxon.selected\" class='fa fa-plus' aria-hidden='true'></i>\r\n      <i (click)=\"taxon.selected = !taxon.selected; $event.stopPropagation()\" *ngIf=\"taxon.children && taxon.selected\" class='fa fa-minus' aria-hidden='true'></i>\r\n    </span> -->\r\n  </div><!--End nav-item-->\r\n  <div class=\"nav-item\" *ngIf=\"taxon.children\" [ngClass]=\"{'mainActive': taxon.selected}\">\r\n    <a class=\"dropdown-item\"  routerLink=\"/collection\" [queryParams]=\"{taxons: taxon.code}\" (click)=\"modal.hide()\">\r\n      {{taxon | translate: 'name'}}\r\n    </a>\r\n    <span class=\"sub-icon\">\r\n      <i (click)=\"taxon.selected = !taxon.selected; $event.stopPropagation()\" *ngIf=\"taxon.children && !taxon.selected\" class='fa fa-plus' aria-hidden='true'></i>\r\n      <i (click)=\"taxon.selected = !taxon.selected; $event.stopPropagation()\" *ngIf=\"taxon.children && taxon.selected\" class='fa fa-minus' aria-hidden='true'></i>\r\n    </span>\r\n  </div><!--End nav-item-->\r\n  \r\n  <ul class=\"dropdown-menu children\" *ngIf=\"taxon.children && taxon.selected\">\r\n    <app-base-header-taxon [taxons]=\"taxon.children\" [modal]=\"modal\"></app-base-header-taxon>\r\n  </ul>\r\n</li>", styles: [":host .nav-item{display:flex;align-items:center;justify-content:space-between;background-color:#000;color:#fff;border-bottom:1px solid #e6e6e6}:host .nav-item a{display:block;color:#fff;font-weight:bold;text-transform:uppercase;font-size:18px;flex-basis:95%;padding:1rem;padding-block-start:1rem}:host .nav-item .sub-icon{flex-basis:5%;text-align:center}:host .nav-item .sub-icon i{font-size:16px;text-align:center;transition:all .3s ease-in-out}:host .nav-item .sub-icon i:hover,:host .nav-item .sub-icon i:focus{color:var(--main-color, orange)}\n"], components: [{ type: HeaderTaxonBaseComponent, selector: "app-base-header-taxon", inputs: ["taxons", "modal"], outputs: ["closeModal"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HeaderTaxonBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-header-taxon',
                    templateUrl: './header-taxon.base-component.html',
                    styleUrls: ['./header-taxon.base-component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { closeModal: [{
                type: Output
            }], taxons: [{
                type: Input
            }], modal: [{
                type: Input
            }] } });

class StoreNotActivatedComponent {
    constructor() { }
    ngOnInit() { }
}
StoreNotActivatedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StoreNotActivatedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StoreNotActivatedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: StoreNotActivatedComponent, selector: "app-store-not-activated", ngImport: i0, template: "<p class=\"store-activation\">\r\n  <ng-content></ng-content>\r\n</p>\r\n", styles: [".store-activation{text-align:center;padding:10px;color:#721c24;background-color:#f8d7da}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: StoreNotActivatedComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-store-not-activated',
                    templateUrl: './store-not-activated.component.html',
                    styleUrls: ['./store-not-activated.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

class UpgCallbackComponent {
    constructor(languageService, cartService, checkoutService, route) {
        this.languageService = languageService;
        this.cartService = cartService;
        this.checkoutService = checkoutService;
        this.route = route;
        this.loading = true;
        this.language = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(lanuage => this.language = lanuage);
        const upgData = JSON.parse(this.route.snapshot.queryParams['upgData']);
        this.orderId = upgData.orderId;
        this.checkoutService.upgSuccess(upgData).subscribe(res => {
            this.loading = false;
            this.syliusSuccess = true;
            this.cartService.emptyCartLastStepWeAccept('', upgData['amount'], upgData['currency']);
        }, err => {
            this.syliusSuccess = false;
            this.loading = false;
            this.cartService.checkoutCompleted();
        });
    }
}
UpgCallbackComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: UpgCallbackComponent, deps: [{ token: LanguageService }, { token: CartService }, { token: CheckoutService }, { token: i2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
UpgCallbackComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: UpgCallbackComponent, selector: "app-upg-callback", ngImport: i0, template: "\r\n<div *ngIf=\"loading; else showContent\">\r\n    <app-inner-loading></app-inner-loading>\r\n</div>\r\n<ng-template #showContent>\r\n    <h1 class=\"payment-message\" >\r\n        <span>{{language['paymentStatus']}}</span>\r\n        <span *ngIf=\"syliusSuccess\" class=\"approved\"> {{language['approved']}} <img src=\"assets/checkoutSteps/ok-sign.png\"></span>\r\n        <span *ngIf=\"!syliusSuccess\" class=\"declined\"> {{language['declined']}}  <img src=\"assets/checkoutSteps/false-sign.png\"></span>\r\n      </h1>\r\n      <h3 *ngIf=\"syliusSuccess\">{{language['yourOrderNumberIs']}} {{orderId}}</h3>\r\n      <h4 *ngIf=\"syliusSuccess\">{{language['orderSuccess']}}</h4>\r\n      <h3 *ngIf=\"!syliusSuccess\">\r\n        An error has occured, please \r\n        <!-- save the following info : <br> [ Transaction Id : dd - CartId : {{orderId}} ] <br> and  -->\r\n        contact us immediately <a routerLink=\"/contact-us\">Contact us</a>   \r\n      </h3>\r\n      <!-- <h4 *ngIf=\"!syliusSuccess\">click <a [routerLink]=\"['/checkout', 'payment']\">here</a> to go back to payment</h4> -->\r\n</ng-template>\r\n\r\n", styles: [".declined{color:red}.approved{color:green}img{height:60px;width:auto}h1,h3,h4{text-align:center}a{color:#00f}.payment-message{font-size:40px}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: UpgCallbackComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-upg-callback',
                    templateUrl: './upg-callback.component.html',
                    styleUrls: ['./upg-callback.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CartService }, { type: CheckoutService }, { type: i2.ActivatedRoute }]; } });

class PayfortComponent {
    constructor(cartService, checkoutService, languageService, route, router) {
        this.cartService = cartService;
        this.checkoutService = checkoutService;
        this.languageService = languageService;
        this.route = route;
        this.router = router;
        this.loading = false;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(lanuage => this.language = lanuage);
        this.route.queryParams.subscribe(params => {
            this.payFortData = params;
        });
        this.payFortResponseMsg = this.payFortData['response_message'];
        if (this.payFortResponseMsg === 'Success') {
            this.checkoutService.payFortMethod(this.payFortData).subscribe(response => {
                if (response['status'] === 'success') {
                    this.loading = false;
                    this.cartService.emptyCartLastStepPayFort('', this.payFortData['amount'], this.payFortData['currency']);
                }
            }, err => {
                this.payFortTransId = this.payFortData['fort_id'];
                this.orderId = +localStorage.getItem('cartId');
                this.loading = false;
                this.errorFromPayfort = true;
                this.cartService.checkoutCompleted();
            });
        }
        else {
            this.checkoutService.errorMsgPayFort.next(true);
            this.router.navigateByUrl('checkout/payment');
        }
    }
}
PayfortComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PayfortComponent, deps: [{ token: CartService }, { token: CheckoutService }, { token: LanguageService }, { token: i2.ActivatedRoute }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
PayfortComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: PayfortComponent, selector: "app-payfort", ngImport: i0, template: "<div class=\"container\">\r\n  <div *ngIf=\"loading; else showError\">\r\n    <app-inner-loading></app-inner-loading>\r\n  </div>\r\n  <ng-template #showError>\r\n    <div *ngIf=\"errorFromPayfort\">\r\n      An error has occured, please save the following info Transaction ID : {{ payFortTransId }} - Cart ID \r\n      {{ orderId }} and Contact us immediately <a routerLink=\"/contact-us\">Contact us</a>\r\n    </div>\r\n  </ng-template>\r\n</div>", styles: [""], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PayfortComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-payfort',
                    templateUrl: './payfort.component.html',
                    styleUrls: ['./payfort.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: CartService }, { type: CheckoutService }, { type: LanguageService }, { type: i2.ActivatedRoute }, { type: i2.Router }]; } });

class PaginationBaseComponent {
    constructor(languageService, shopService, router, activatedRoute) {
        this.languageService = languageService;
        this.shopService = shopService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.language = {};
        this.defaultLimit = this.shopService.defaultLimit;
        this.page = 1;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
        this.productsCount$ = this.shopService.productsCount;
        this.productsCount$.subscribe(data => {
            this.productsCount = data;
        });
        this.activatedRoute.queryParams.subscribe((params) => {
            if (!params['page']) {
                this.page = 1;
            }
            else {
                this.page = Number(params['page']);
            }
            if (params['limit']) {
                this.defaultLimit = Number(params['limit']);
            }
        });
    }
    pageChanged(e) {
        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'collection'], { queryParams: { page: e.page }, queryParamsHandling: 'merge' });
    }
}
PaginationBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaginationBaseComponent, deps: [{ token: LanguageService }, { token: ShopService }, { token: i2.Router }, { token: i2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
PaginationBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: PaginationBaseComponent, selector: "app-base-pagination", ngImport: i0, template: "<pagination \r\n    [totalItems]=\"productsCount\" \r\n    [itemsPerPage]=\"defaultLimit\" \r\n    [maxSize]=\"6\" \r\n    [boundaryLinks]=\"false\"\r\n    (pageChanged)=\"pageChanged($event)\" \r\n    [(ngModel)]=\"page\">\r\n</pagination>", styles: [""], components: [{ type: i4$1.PaginationComponent, selector: "pagination", inputs: ["align", "boundaryLinks", "directionLinks", "rotate", "pageBtnClass", "disabled", "itemsPerPage", "totalItems", "maxSize", "firstText", "previousText", "nextText", "lastText", "customPageTemplate", "customNextTemplate", "customPreviousTemplate", "customFirstTemplate", "customLastTemplate"], outputs: ["numPages", "pageChanged"] }], directives: [{ type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaginationBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-pagination',
                    templateUrl: './pagination.base-component.html',
                    styleUrls: ['./pagination.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ShopService }, { type: i2.Router }, { type: i2.ActivatedRoute }]; } });

class CurrenciesbaseComponent {
    constructor(_customTheme, confService) {
        this._customTheme = _customTheme;
        this.confService = confService;
        this.openCurrenciesList = false;
        this.current = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        if (this.current == null || this.current == undefined) {
            this.current = "EGP";
        }
        this._customTheme.getCustomTheme()
            .pipe(take(1))
            .subscribe(payload => {
            let obj = payload.response.theme;
            const keys = Object.keys(obj);
            const secondLastKey = keys[keys.length - 2];
            this.showCurrencySelector = obj[secondLastKey];
            console.log(this.showCurrencySelector);
            if (this.showCurrencySelector == false) {
                this.confService.getDefaultCurrency().subscribe(curr => {
                    this.defaultCurr = curr.code;
                    localStorage.setItem('currentCurrency', this.defaultCurr);
                });
            }
        });
        console.log(this.showCurrencySelector);
    }
    changeCurrency(event) {
        this.current = event;
        localStorage.removeItem('currentCurrency');
        localStorage.setItem('currentCurrency', this.current);
        location.reload();
    }
}
CurrenciesbaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CurrenciesbaseComponent, deps: [{ token: CustomThemeService }, { token: ConfService }], target: i0.ɵɵFactoryTarget.Component });
CurrenciesbaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CurrenciesbaseComponent, selector: "app-currencies-base", inputs: { currencies: "currencies" }, ngImport: i0, template: "<div class=\"currencies\" *ngIf=\"currencies?.length >1 && showCurrencySelector\">\r\n  <i class=\"fa fa-money\"></i>\r\n  <select [(ngModel)]=\"current\" (change)=\"changeCurrency($event.target.value)\" class=\"currencies-select\">\r\n    <option *ngFor=\"let availableCurencies of currencies;\" [value]=\"availableCurencies?.code\">\r\n      {{availableCurencies?.code}}\r\n    </option>\r\n  </select>\r\n</div>\r\n<!--End currencies-->", styles: [":host .currencies{margin-left:10px}[dir=rtl] :host .currencies{margin-left:unset;margin-right:10px}:host .currencies i{color:#fff;margin-right:3px}[dir=rtl] :host .currencies i{margin-right:unset;margin-left:3px}:host .currencies .currencies-select{background-color:transparent;color:#fff;border:none}:host .currencies .currencies-select option{color:#000}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CurrenciesbaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-currencies-base',
                    templateUrl: './currencies.base-component.html',
                    styleUrls: ['./currencies.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: CustomThemeService }, { type: ConfService }]; }, propDecorators: { currencies: [{
                type: Input
            }] } });

class CurrenciesSideMenuComponent {
    constructor(_customTheme) {
        this._customTheme = _customTheme;
        this.showCurrencySelector = true;
        this.openCurrenciesList = false;
        // set deful currency
        this.current = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        /**
    *@description  get the current currency from localstorge to check it to make sure it's have a data
    to change the current currency for the new currnecy from localstorage
    * @author Ahmed Nader
    *
    */
        const currentCurrency = localStorage.getItem('currentCurrency');
        if (currentCurrency != null || undefined) {
            this.current = currentCurrency;
        }
        /**
  *@description check currency selector status
  *
  * @author Ahmed Amr
  */
        this._customTheme.currencySelectorSubject
            .pipe(take(1))
            .subscribe(payload => {
            this.showCurrencySelector = payload;
        });
    }
    /**
     * @param c
     * @typeparam Currency
    *@description  get the current currency from localstorge and pass it to defultCurr variable
    then check it to make sure the user select a new currency from dropdown menu,
    then reload the page to refrech all api's requestes to change curreny in the header
    * @author Ahmed Nader
    *
    */
    changeCurrency(event) {
        for (let i = 0; i < this.currencies.length; i++) {
            if (this.currencies[i].code === event) {
                this.current = this.currencies[i].code;
            }
        }
        const currentCurrency = localStorage.getItem('currentCurrency');
        if (event != currentCurrency) {
            this.current = event;
            localStorage.setItem('currentCurrency', this.current);
            localStorage.setItem(window.location.hostname + '_' + 'isFirstTime', '1');
            location.reload();
        }
    }
}
CurrenciesSideMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CurrenciesSideMenuComponent, deps: [{ token: CustomThemeService }], target: i0.ɵɵFactoryTarget.Component });
CurrenciesSideMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CurrenciesSideMenuComponent, selector: "app-currencies-side-menu", inputs: { currencies: "currencies" }, ngImport: i0, template: "<div class=\"currencies\" *ngIf=\"currencies?.length >1 && showCurrencySelector\">\r\n  <i class=\"fa fa-money\"></i>\r\n    <select [(ngModel)]=\"current\" (change)=\"changeCurrency($event.target.value)\" class=\"currencies-select\">\r\n        <option  [value]=\"availableCurencies?.code\" *ngFor=\"let availableCurencies of currencies\">\r\n        {{availableCurencies?.code}}\r\n          </option>\r\n    </select>\r\n</div><!--End currencies-->\r\n  ", styles: [":host .currencies{margin:0;padding:1rem;background-color:#fff}:host .currencies i{width:40px;height:40px;line-height:40px;text-align:center;background-color:var(--main-color, red);color:#000;border-radius:50%;font-size:20px;margin-right:10px}[dir=rtl] :host .currencies i{margin-right:unset;margin-left:10px}:host .currencies .currencies-select{background-color:transparent;color:#1a1a1a;border:none}:host .currencies .currencies-select option{color:#000}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CurrenciesSideMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-currencies-side-menu',
                    templateUrl: './currencies-side-menu.component.html',
                    styleUrls: ['./currencies-side-menu.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: CustomThemeService }]; }, propDecorators: { currencies: [{
                type: Input
            }] } });

class FixedHeaderDirective {
    constructor() {
        this.isScrolled = false;
    }
    onScroll() {
        if (window.pageYOffset > this.offset) {
            this.isScrolled = true;
        }
        else {
            this.isScrolled = false;
        }
    }
}
FixedHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FixedHeaderDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FixedHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: FixedHeaderDirective, selector: "[appFixedHeader]", inputs: { offset: "offset" }, host: { listeners: { "window:scroll": "onScroll()" }, properties: { "class.scrolled": "this.isScrolled" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FixedHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appFixedHeader]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { offset: [{
                type: Input
            }], isScrolled: [{
                type: HostBinding,
                args: ['class.scrolled']
            }], onScroll: [{
                type: HostListener,
                args: ['window:scroll', []]
            }] } });

class KashierCallBacksComponent {
    constructor(activatedRoute, checkoutService, languageService, cartService) {
        this.activatedRoute = activatedRoute;
        this.checkoutService = checkoutService;
        this.languageService = languageService;
        this.cartService = cartService;
        this.language = {};
        this.loading = true;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(lanuage => this.language = lanuage);
        this.activatedRoute.queryParams.subscribe(params => {
            this.params = params;
            if (this.params['paymentStatus'] === 'SUCCESS') {
                this.kashierSuccess = true;
            }
            else {
                this.kashierSuccess = false;
            }
            this.checkoutService.kashierChecker(this.params)
                .subscribe((res) => {
                this.loading = false;
                if (res['code'] == 200) {
                    this.syliusSuccess = true;
                    this.orderId = res['order_number'];
                    this.cartService.emptyCartLastStepKashier('', params['amount_cents'], params['currency'], this.orderId);
                }
                else {
                    this.syliusSuccess = false;
                    this.orderId = localStorage.getItem('cartId');
                    this.cartService.checkoutCompleted();
                }
            }, (err) => {
                if (this.kashierSuccess) {
                    this.orderId = localStorage.getItem('cartId');
                    this.cartService.checkoutCompleted();
                }
                this.loading = false;
                this.syliusSuccess = false;
            });
        });
        // "paymentStatus=SUCCESS&
        // cardDataToken=
        // &maskedCard=511111******1118
        // &merchantOrderId=647_1579083094
        // &orderId=bff3de96-f531-4111-9dc0-d6389091c8ed&
        // cardBrand=&orderReference=TEST-ORD-12996&
        // transactionId=TX-69914446&amount=177.2&currency=EGP
        // &signature=5a428b76c0ca2c2e16f5e4fe01c97435ebcc25f976dfa1edff335c8d39158aee&
        // mode=test"
    }
}
KashierCallBacksComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: KashierCallBacksComponent, deps: [{ token: i2.ActivatedRoute }, { token: CheckoutService }, { token: LanguageService }, { token: CartService }], target: i0.ɵɵFactoryTarget.Component });
KashierCallBacksComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: KashierCallBacksComponent, selector: "kashierCallBacks", ngImport: i0, template: "<div *ngIf=\"loading; else showContent\">\r\n    <app-inner-loading></app-inner-loading>\r\n</div>\r\n<ng-template #showContent>\r\n    <h1 class=\"payment-message\">\r\n        <span>{{language['paymentStatus']}}</span>\r\n        <span *ngIf=\"syliusSuccess\" class=\"approved\"> {{language['approved']}} <img src=\"assets/checkoutSteps/ok-sign.png\"></span>\r\n        <span *ngIf=\"!syliusSuccess\" class=\"declined\"> {{language['declined']}}  <img src=\"assets/checkoutSteps/false-sign.png\"></span>\r\n    </h1>\r\n    <h3>{{language['yourOrderNumberIs']}} {{orderId}}</h3>\r\n    <h4 >{{language['orderSuccess']}}</h4>\r\n    <h3 *ngIf=\"!syliusSuccess && kashierSuccess\">\r\n        An error has occured, please save the following info : <br> [ Transaction Id : {{params['transactionId']}} - Cart Id : {{orderId}} ] <br> and Contact us immediately <a routerLink=\"/contact-us\">Contact us</a>\r\n    </h3>\r\n    <h4 *ngIf=\"!kashierSuccess\"> {{language['click']}} <a [routerLink]=\"['/checkout', 'payment']\">{{language['here']}}</a> {{language['backToPayment']}}</h4>\r\n</ng-template>", styles: [".declined{color:red}.approved{color:green}img{height:60px;width:auto}h1,h3,h4{text-align:center}a{color:#00f}.payment-message{font-size:40px}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: KashierCallBacksComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'kashierCallBacks',
                    templateUrl: './kashierCallBacks.component.html',
                    styleUrls: ['./kashierCallBacks.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: CheckoutService }, { type: LanguageService }, { type: CartService }]; } });

class MpgsCallbackComponent {
    constructor(languageService, cartService, checkoutService, route) {
        this.languageService = languageService;
        this.cartService = cartService;
        this.checkoutService = checkoutService;
        this.route = route;
        this.loading = true;
        this.language = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(lanuage => this.language = lanuage);
        const mpgsData = JSON.parse(this.route.snapshot.queryParams['mpgsData']);
        this.orderId = mpgsData.orderNumber || localStorage.getItem('cartId');
        if (mpgsData.code === 200) {
            this.loading = false;
            this.syliusSuccess = true;
            this.cartService.emptyCartLastStepOnlinePayment('', (mpgsData['amount'] / 100), mpgsData['currency'], mpgsData['orderNumber']);
        }
        else {
            this.syliusSuccess = false;
            this.loading = false;
            this.cartService.checkoutCompleted();
        }
    }
}
MpgsCallbackComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MpgsCallbackComponent, deps: [{ token: LanguageService }, { token: CartService }, { token: CheckoutService }, { token: i2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
MpgsCallbackComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: MpgsCallbackComponent, selector: "app-mpgs-callback", ngImport: i0, template: "\r\n<div *ngIf=\"loading; else showContent\">\r\n    <app-inner-loading></app-inner-loading>\r\n</div>\r\n<ng-template #showContent>\r\n    <h1 class=\"payment-message\" >\r\n        <span>{{language['paymentStatus']}}</span>\r\n        <span *ngIf=\"syliusSuccess\" class=\"approved\"> {{language['approved']}} <img src=\"assets/checkoutSteps/ok-sign.png\"></span>\r\n        <span *ngIf=\"!syliusSuccess\" class=\"declined\"> {{language['declined']}}  <img src=\"assets/checkoutSteps/false-sign.png\"></span>\r\n      </h1>\r\n      <h3 >{{language['yourOrderNumberIs']}} {{orderId}}</h3>\r\n      <h4>{{language['orderSuccess']}}</h4>\r\n      <h3 *ngIf=\"!syliusSuccess\">\r\n        An error has occured, please \r\n        save the following info : <br> [ CartId : {{orderId}} ] <br> and \r\n        contact us immediately <a routerLink=\"/contact-us\">Contact us</a>   \r\n      </h3>\r\n      <!-- <h4 *ngIf=\"!syliusSuccess\">click <a [routerLink]=\"['/checkout', 'payment']\">here</a> to go back to payment</h4> -->\r\n</ng-template>\r\n\r\n", styles: [".declined{color:red}.approved{color:green}img{height:60px;width:auto}h1,h3,h4{text-align:center}a{color:#00f}.payment-message{font-size:40px}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MpgsCallbackComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-mpgs-callback',
                    templateUrl: './mpgs-callback.component.html',
                    styleUrls: ['./mpgs-callback.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CartService }, { type: CheckoutService }, { type: i2.ActivatedRoute }]; } });

class BranchSelectorComponent {
    constructor(_customTheme, contactUsService, languageService) {
        this._customTheme = _customTheme;
        this.contactUsService = contactUsService;
        this.languageService = languageService;
        this.selectedBranchId = localStorage.getItem('branchId') || null;
        this.currentLanguage = localStorage.getItem('language') || 'en_US';
        this.language = {};
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe((language) => {
            this.language = language;
            console.log('language ', language);
        });
        this.branches$ = this.contactUsService
            .getContactDetails()
            .pipe(map((data) => data.branches));
        this.getCurrentBranchName();
    }
    // select branch id
    changeBranch(id) {
        if (id) {
            localStorage.setItem('branchId', id);
            localStorage.removeItem('cartId');
            localStorage.removeItem('cart-counter');
            this.getCurrentBranchName();
            location.reload();
        }
    }
    getCurrentBranchName() {
        this.branches$.subscribe((branches) => {
            if (this.selectedBranchId && branches) {
                this.currentBranchName = branches.filter((branch) => branch.id == this.selectedBranchId)[0].translations[this.currentLanguage].name;
            }
            else {
                this.currentBranchName = branches.length != 0 && branches[0].translations[this.currentLanguage].name;
            }
        });
    }
    onSearch($event) {
        if ($event.term == '') {
            this.getCurrentBranchName();
        }
        else {
            this.currentBranchName = '';
        }
    }
}
BranchSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BranchSelectorComponent, deps: [{ token: CustomThemeService }, { token: ContactUsService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
BranchSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: BranchSelectorComponent, selector: "app-branch-selector", inputs: { mutlipleBranchesFeature: "mutlipleBranchesFeature" }, ngImport: i0, template: "<ng-container *ngIf=\"branches$ | async as branches\">\r\n  <div class=\"branches-container\" *ngIf=\"branches.length && mutlipleBranchesFeature\">\r\n    <em class=\"fa fa-map-marker\"></em>\r\n    <ng-select\r\n          (blur)=\"getCurrentBranchName()\"\r\n           (search)=\"onSearch($event)\"\r\n          (change)=\"changeBranch(selectedBranchId)\"\r\n           [items]=\"branches\"\r\n           bindValue=\"id\"\r\n           [placeholder]=\"currentBranchName\"\r\n           [(ngModel)]=\"selectedBranchId\">\r\n           <ng-template ng-option-tmp let-item=\"item\">\r\n            {{\r\n              item.translations[currentLanguage].name\r\n            }}\r\n        </ng-template>\r\n</ng-select>\r\n  </div>\r\n</ng-container>\r\n", styles: [":host .branches-container{margin-inline:8px;display:flex;width:35vw;align-items:center;justify-items:center;color:var(--header-link-color, #fff)}@media (max-width: 768px){:host .branches-container{width:100%}}:host .branches-container em{padding-inline:8px}:host .branches-container ng-select{width:100%;display:grid}:host .branches-container ng-select ::ng-deep .ng-select-container{color:var(--header-link-color, Black)}:host .branches-container ng-select ::ng-deep .ng-select-container .ng-value-container{padding-top:0}:host .branches-container ng-select ::ng-deep .ng-select-container .ng-value-container .ng-placeholder{color:var(--header-link-color);display:block}:host .branches-container ng-select ::ng-deep .ng-select-container input{color:var(--header-link-color, Black)}:host .branches-container ng-select ::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{white-space:pre-wrap!important}\n"], components: [{ type: i5$1.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5$1.ɵf, selector: "[ng-option-tmp]" }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: BranchSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-branch-selector',
                    templateUrl: './branch-selector.component.html',
                    styleUrls: ['./branch-selector.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: CustomThemeService }, { type: ContactUsService }, { type: LanguageService }]; }, propDecorators: { mutlipleBranchesFeature: [{
                type: Input
            }] } });

class PaytabsComponent {
    constructor(router, activatedRoute, languageService, cartService, checkoutService, toastr, http) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.languageService = languageService;
        this.cartService = cartService;
        this.checkoutService = checkoutService;
        this.toastr = toastr;
        this.http = http;
        this.loading = true;
        this.language = {};
        this.handlePaymentCallback = false;
        this.paymentType = this.activatedRoute.snapshot.paramMap.get('paymentType');
        this.paymentCallbackId = this.activatedRoute.snapshot.paramMap.get('paymentCallbackId');
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe((lang) => {
            // 
            this.language = lang;
        });
        if (this.paymentType != null && this.paymentCallbackId != null) {
            if (this.paymentType == 'stripe' || this.paymentType == 'opay' || this.paymentType == 'fawryPay' || this.paymentType == 'payfort' || this.paymentType == 'paytabs') {
                this.handlePaymentCallback = true;
                this.cartService.checkOrderCompleted(this.paymentCallbackId)
                    .subscribe(data => {
                    const cartId = data['id'];
                    const cartIdStorage = localStorage.getItem('cartId');
                    if (cartId != cartIdStorage) {
                        this.router.navigate(['']);
                        return;
                    }
                    if (data['checkoutState'] != 'completed') {
                        this.router.navigate([this.language['LANGUAGE_CODE'], 'paymentCallback'], { queryParams: { 'success': '2', 'order_id': cartId } });
                        return;
                    }
                    if (data['checkoutState'] && data['checkoutState'] == 'completed' && cartId == cartIdStorage) {
                        const paymentData = {
                            orderNumber: data['number'],
                            total: data['total'],
                            currency: data['currencyCode'],
                            status: 'success'
                        };
                        this.cartService.emptyCartLastStepStripePayment(paymentData, cartId);
                    }
                });
            }
            else {
                this.router.navigate(['']);
            }
        }
        if (this.paymentType == null && this.paymentCallbackId == null) {
            this.handlePaymentCallback = false;
            this.activatedRoute.queryParams.subscribe((data) => {
                this.handelPayTabs(data);
            });
        }
    }
    handelPayTabs(par) {
        if (par['success'] == '1') {
            this.syliusSuccess = true;
            this.orderId = par['order-number'];
            this.loading = false;
            this.paytabsErr = false;
            this.invoice_id = false;
            this.cartService.checkoutCompleted();
        }
        else if (par['success'] == '0') {
            this.syliusSuccess = false;
            this.loading = false;
            this.paytabsErr = false;
            this.invoice_id = false;
            this.orderId = par['order_id'];
        }
        else if (par['success'] == '2') {
            this.syliusSuccess = false;
            this.loading = false;
            this.paytabsErr = true;
            this.orderId = par['order_id'];
            if (par['invoice_id']) {
                this.transactionId = par['invoice_id'];
                this.invoice_id = true;
            }
            else if (par['transaction_id']) {
                this.transactionId = par['transaction_id'];
                this.invoice_id = true;
            }
            else {
                this.invoice_id = false;
            }
            this.cartService.checkoutCompleted();
        }
    }
    goPayment() {
        this.router.navigateByUrl(`/${localStorage.getItem('language')}/checkout/payment`);
    }
}
PaytabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaytabsComponent, deps: [{ token: i2.Router }, { token: i2.ActivatedRoute }, { token: LanguageService }, { token: CartService }, { token: CheckoutService }, { token: i3$1.ToastrService }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Component });
PaytabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: PaytabsComponent, selector: "app-paytabs", ngImport: i0, template: "<div  *ngIf=\"handlePaymentCallback != true\" class=\"paytabsContainer\">\r\n    <div *ngIf=\"loading; else showContent\">\r\n        <app-inner-loading></app-inner-loading>\r\n    </div>\r\n    <ng-template #showContent>\r\n        <h1 class=\"payment-message\">\r\n            <span>{{language['paymentStatus']}}</span>\r\n            <span *ngIf=\"syliusSuccess\" class=\"approved\"> {{language['approved']}} <img src=\"assets/checkoutSteps/ok-sign.png\"></span>\r\n            <span *ngIf=\"!syliusSuccess\" class=\"declined\"> {{language['declined']}}  <img src=\"assets/checkoutSteps/false-sign.png\"></span>\r\n        </h1>\r\n        <h3 >{{language['yourOrderNumberIs']}} {{orderId}}</h3>\r\n        <h4 >{{language['orderSuccess']}}</h4>\r\n        <h3 *ngIf=\"!syliusSuccess && paytabsErr && !invoice_id\">\r\n            An error has occured, please save the following info : <br> [ CartId : {{orderId}} ] <br> and Contact us immediately <a routerLink=\"/contact-us\">Contact us</a>\r\n        </h3>\r\n        <h3 *ngIf=\"!syliusSuccess && paytabsErr && invoice_id\">\r\n            An error has occured, please save the following info : <br> [ Transaction Id : {{transactionId}} - CartId : {{orderId}} ] <br> and Contact us immediately <a routerLink=\"/contact-us\">Contact us</a>\r\n        </h3>\r\n        <h4 *ngIf=\"!syliusSuccess && !paytabsErr\">click <a (click)=\"goPayment()\">here</a> to go back to payment</h4>\r\n    </ng-template>\r\n</div>\r\n\r\n\r\n<div  *ngIf=\"handlePaymentCallback == true\">\r\n    \r\n\r\n    <app-inner-loading></app-inner-loading>\r\n\r\n</div>", styles: [".declined{color:red}.approved{color:green}img{height:60px;width:auto}h1,h3,h4{text-align:center}a{color:#00f!important;text-decoration:underline!important}.payment-message{font-size:40px}.paytabsContainer{padding-top:10%}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaytabsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-paytabs',
                    templateUrl: './paytabs.component.html',
                    styleUrls: ['./paytabs.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i2.Router }, { type: i2.ActivatedRoute }, { type: LanguageService }, { type: CartService }, { type: CheckoutService }, { type: i3$1.ToastrService }, { type: i1.HttpClient }]; } });

class ProductAddonsBaseComponent {
    constructor(route, languageService, productDetailsService, cartService, wishlistService, compareService, breadcrumbService, translatePipe, loginService, formBuilder, modalService, location, toastr, titleService, meta, confService, router, googleAnalyticsService, langaugeService, checkoutService) {
        this.route = route;
        this.languageService = languageService;
        this.productDetailsService = productDetailsService;
        this.cartService = cartService;
        this.wishlistService = wishlistService;
        this.compareService = compareService;
        this.breadcrumbService = breadcrumbService;
        this.translatePipe = translatePipe;
        this.loginService = loginService;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.location = location;
        this.toastr = toastr;
        this.titleService = titleService;
        this.meta = meta;
        this.confService = confService;
        this.router = router;
        this.googleAnalyticsService = googleAnalyticsService;
        this.langaugeService = langaugeService;
        this.checkoutService = checkoutService;
        this.defaultPrice = false;
        this.choices = [];
        this.showAddtoCartOrPlaceHolder = true;
        this.storeid = this.confService.storeId.subscribe((data) => {
            if (StoresName.OdaId == data) {
                this.showAddtoCartOrPlaceHolder = false;
            }
        });
        this.isDisabled = true;
        this.addonsLength = 0;
        this.carouselOptions = {
            margin: 10,
            items: 1,
            autoplayHoverPause: true,
            dots: false,
            nav: true,
            navSpeed: 1000,
            autoplaySpeed: 2000,
            slideTransition: 'linear'
        };
        this.bestsellersOption = {
            items: 4,
            responsive: {
                0: {
                    stagePadding: 20,
                    items: 1,
                    nav: false,
                    dots: true
                },
                576: {
                    stagePadding: 25,
                    items: 2,
                    nav: false,
                    dots: true
                },
                768: {
                    items: 3,
                    nav: false,
                    dots: true
                },
                992: {
                    items: 4,
                    nav: false,
                    dots: true
                }
            }
        };
        this.SamirCustomOption = {
            margin: 25,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                576: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 20,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    dots: true,
                    nav: false,
                },
                992: {
                    items: 4,
                    dots: true,
                    nav: false,
                },
                1024: {
                    items: 4,
                    dots: true,
                    nav: false
                },
                1100: {
                    items: 4,
                    dots: false,
                    nav: true
                }
            }
        };
        this.thumbnialOptions = {
            items: 5,
            margin: 5,
            navSpeed: 300,
            autoplaySpeed: 1000,
            responsive: {
                0: {
                    items: 3
                },
                576: {
                    items: 4
                },
                768: {
                    items: 3
                },
                991: {
                    items: 4
                },
                1199: {
                    items: 5
                }
            }
        };
        this.OwlCustom_3 = {
            margin: 30,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                576: {
                    stagePadding: 0,
                    items: 2,
                    dost: true,
                    nav: false,
                    margin: 15,
                },
                768: {
                    stagePadding: 0,
                    items: 3,
                    margin: 15,
                    dots: true,
                    nav: true,
                },
                992: {
                    items: 3,
                    dots: true,
                    nav: true,
                },
                1024: {
                    items: 3,
                    dots: true,
                    nav: true
                },
                1100: {
                    items: 3,
                    dots: true,
                    nav: true
                }
            }
        };
        this.language = {};
        this.selectedOption = {};
        this.quantity = 1;
        this.options = {};
        this.price = 0;
        this.variantExists = false;
        this.cartId = +localStorage.getItem('cartId');
        this.fav = Observable.create(false);
        this.compare = Observable.create(false);
        this.imageUrl = environment.imageUrl;
        this.defaultImage = environment.defaultImage;
        this.maxRate = 5;
        this.rate = 5;
        this.rating = 0;
        this.email = localStorage.getItem('user_email') ? localStorage.getItem('user_email') : sessionStorage.getItem('user_email');
        this.wishListFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.WISH_LIST));
        this.compareFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.COMPARE));
        this.reviewsFeature$ = this.confService.getFeatures().pipe(map(data => data.login.original.response.response.features.REVIEWS));
        this.lastPrice = [];
        this.lastindex = [];
        this.childreenBreadcrumbs = [];
        this.notFound = false;
        this.imgIsLoaded = false;
        this.showDetails = true;
        this.toggleHeight = false;
        this.increment = 0;
        this.highImage = '';
        this.mediumImage = '';
        this.lowImage = '';
        this.totalMalePrice = 0;
        this.currencyCode = localStorage.getItem('currentCurrency');
        this.id = 0;
        this.store = this.confService.storeId.subscribe((data) => {
            this.id = data;
        });
        this.prego = (this.id == 12705) ? true : false;
        this.kfc = (this.id == 12770) ? true : false;
    }
    get sellingPoints() {
        return this.formAddons.get('options');
    }
    ngOnInit() {
        this.logged$ = this.loginService.logged;
        this.reviewForm = this.formBuilder.group({
            title: ['', Validators.required],
            comment: ['', Validators.required],
            email: [this.email, [Validators.required, Validators.email]],
        });
        this.route.queryParams.subscribe((queryParams) => {
            this.defaultVariantCode = queryParams.variantCode;
        });
        this.route.params.subscribe(params => {
            this.slug = params['code'];
            if (this.productInput === undefined) {
                this.productSubscription = this.productDetailsService.getProduct(this.slug, this.defaultVariantCode).subscribe(product => {
                    this.product = product;
                    this.googleAnalyticsService.addToCart(product.id, product.name, product.addons[0].prices[0].price, product.main_taxon, 1);
                    for (const taxon in product['mainTaxon']) {
                        if (product['mainTaxon'].images) {
                            for (const i in product['mainTaxon'].images) {
                                if (product['mainTaxon'].images[i]['type'] === 'collection_page_banner') {
                                    this.breadcrumbService.setBackground(environment.imageUrl + product['mainTaxon'].images[i]['path']);
                                    break;
                                }
                                else {
                                    this.breadcrumbService.setBackground('');
                                }
                            }
                        }
                    }
                    this.actualCode = product.code;
                    this.Addons = product['addons'];
                    /* Check Product Have Addons */
                    this.isCombinationCheck(product);
                    this.AddonsChecker(product);
                    /* Check Product Price isCombination or not */
                    // Set title by the product name
                    this.storeSubscription = this.confService.store$.subscribe((store) => {
                        this.myStore = store;
                        this.titleService.setTitle(this.myStore.name + ' | ' + this.translatePipe.transform(this.product, 'name'));
                    });
                    // Add Meta Tags
                    if (this.meta.getTag('name="keywords"')) {
                        this.meta.updateTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
                    }
                    else {
                        this.meta.addTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
                    }
                    if (this.meta.getTag('name="description"')) {
                        this.meta.updateTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
                    }
                    else {
                        this.meta.addTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
                    }
                    if (this.product.options && this.product['options'].length > 0) {
                        for (const option of this.product['options']) {
                            this.options[option.code] = '';
                        }
                    }
                    this.autoSelect();
                    this.handleBreadcrumb();
                    this.manageVariant();
                    this.rate = product.rating;
                    this.fav = this.wishlistService.inWishList(product.code);
                    this.compare = this.compareService.inCompare(product.code);
                    if (product.images.length > 0) {
                        this.src = `${environment.imageUrl}c/${product.images[0].path}`;
                    }
                    else {
                        this.src = this.defaultImage;
                    }
                    this.getReview();
                }, err => {
                    this.notFound = true;
                    this.toastr.error(this.language['sorrySomethingWentWrong'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
                });
            }
            else {
                // if (this.productSubscription) { this.productSubscription.unsubscribe(); }
                this.product = this.productInput;
                this.manageProduct(this.productInput);
            }
        });
        this.languageService.getLanguage().subscribe(language => {
            this.imageUrl = environment.imageUrl;
            this.language = language;
        });
    }
    openModal(template_) {
        this.modalRef = this.modalService.show(template_);
    }
    quantityChanged() {
        this.quantity = +this.quantity > this.max ? this.max : +this.quantity;
    }
    quantityChange(event) {
        this.quantity = +this.quantity > this.max ? this.max : +this.quantity;
        if (event.target['attributes'].target.nodeValue === 'quantityUp') {
            return ++this.quantity;
        }
        else if (this.quantity > 1) {
            return --this.quantity;
        }
    }
    slideThumbnail(clickedArrow) {
        const wrapper = this.thumbnailWrapper.nativeElement;
        if (clickedArrow.target['classList'].contains('arrow-down')) {
            this.increment >= wrapper.children.length / 2 ?
                this.increment = wrapper.children.length / 2 :
                this.increment++;
            wrapper.style.transform = `translateY(-${this.increment * 100}px)`;
        }
        else {
            this.increment < 0 ?
                this.increment = 0 :
                this.increment--;
            wrapper.style.transform = `translateY(-${this.increment * 100}px)`;
        }
    }
    optionChanged(code, value) {
        this.selectedOption[code] = value;
        this.manageVariant();
        const selectedVariantCode = this.selectedVariant ? this.selectedVariant.code : '';
        if (!this.productInput) {
            this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'collection', 'product', this.translatePipe.transform(this.product, 'slug')], { queryParams: { 'variantCode': selectedVariantCode } });
        }
    }
    manageVariant() {
        if (this.product === undefined) {
            return;
        }
        // get The selected Variant Code to search on the cart items if it exist we will do some operations
        const variant = this.cartService.getVariant(this.product, this.selectedOption);
        if (variant === undefined) {
            if (this.prego || this.kfc) {
                this.canAddToCart = true;
                this.disableQuantity = false;
                this.variantUndefined = false;
                return;
            }
            else {
                // variant doesn't exists
                this.canAddToCart = false;
                this.disableQuantity = true;
                this.variantUndefined = true;
                return;
            }
        }
        this.selectedVariant = variant;
        if (variant.tracked === false) {
            // variant isn't tracked
            this.canAddToCart = true;
            this.disableQuantity = false;
            this.max = Infinity;
            this.variantUndefined = false;
            return;
        }
        this.max = variant['stock'];
        if (variant['stock'] <= 0) {
            // variant doesn't have stock
            this.canAddToCart = false;
            this.disableQuantity = true;
            this.variantUndefined = false;
            return;
        }
        this.canAddToCart = true;
        this.variantUndefined = false;
        this.disableQuantity = false;
    }
    addToCart() {
        var _a;
        if (!this.validatorCheck()) {
            return;
        }
        const ids = [];
        this.choices.forEach(element => {
            element.forEach(e => {
                if (e !== []) {
                    ids.push(e.id);
                }
            });
        });
        if (ids.length == 1) {
        }
        else if (((_a = this.choices[this.choices.length - 1][0]) === null || _a === void 0 ? void 0 : _a.addonsName) == "optionRequired") {
            ids.pop();
        }
        console.log(ids);
        console.log(this.choices);
        if (ids.length == 0) {
        }
        // this.generatArrays(this.addonsLength);
        this.cartService.addToCartAddOns(ids, this.quantity, this.product);
        // this.AddonsSetup(this.Addons);
        if (!this.product.isCombination) {
            this.totalMalePrice -= this.product.combinationPrice.price;
        }
        this.isCombinationCheck(this.product);
    }
    handleEasyZoom() {
        const $easyzoom = $('.easyzoom').easyZoom();
        const api1 = $easyzoom
            .filter('.easyzoom--with-thumbnails')
            .data('easyZoom');
        $('.thumbnails').on('click', 'a', function (e) {
            const $thisTumb = $(this);
            e.preventDefault();
            // Use EasyZoom's `swap` method
            api1.swap($thisTumb.data('standard'), $thisTumb.attr('href'));
            api1.swap($thisTumb.attr('href'), $thisTumb.attr('src'));
        });
    }
    toggleEasyZoom() {
        if (this.isDisabled) {
            $('.easyzoom').css('pointer-events', 'all');
        }
        else {
            $('.easyzoom').css('pointer-events', 'none');
        }
        this.isDisabled = !this.isDisabled;
    }
    ngOnDestroy() {
        this.breadcrumbService.setCustom([]);
        if (this.storeSubscription) {
            this.storeSubscription.unsubscribe();
        }
    }
    rateChange(rate) {
        this.rating = rate;
    }
    submitReview() {
        const review = Object.assign({}, this.reviewForm.value);
        review.rating = this.rating;
        review.author = {};
        review.author.email = review.email;
        delete review.email;
        this.productDetailsService.addReview(review, this.actualCode)
            .subscribe(() => {
            this.toastr.success(`${this.language['reviewAddedSuccessfully']}`, `${this.language['success']}!`, { enableHtml: true, closeButton: true });
            this.reviewForm.reset();
        }, (err) => {
            this.toastr.error(err.error.message, `${this.language['error']}!`, { enableHtml: true, closeButton: true });
        });
    }
    changeCarouselOptions(options = {}, extras = {}) {
        if (extras['responsive']) {
            options['responsive'] = extras['responsive'];
        }
        return Object.assign(Object.assign(Object.assign({}, this.carouselOptions), options), { rtl: this.language['DIR'] === 'rtl' });
    }
    goBack() {
        this.location.back();
    }
    getReview() {
        this.reviews$ = this.productDetailsService.getProductReview(this.actualCode);
    }
    handleBreadcrumb() {
        const taxonParams = this.getTaxonParams();
        const taxonName = this.getTaxonName();
        this.getTaxonChildName();
        const breadCrumbArr = [
            {
                name: taxonName,
                url: {
                    path: ['collection'],
                    params: { taxons: taxonParams }
                }
            },
            {
                name: this.translatePipe.transform(this.product, 'name'),
                url: {
                    path: ['collection', 'product', this.translatePipe.transform(this.product, 'slug')],
                    params: {}
                }
            }
        ];
        // append children breadcrumbs of it exists
        if (this.childreenBreadcrumbs.length) {
            this.childreenBreadcrumbs.reverse().forEach(child => {
                breadCrumbArr.splice(1, 0, {
                    name: this.translatePipe.transform(child, 'name'),
                    url: {
                        path: ['collection'],
                        params: { taxons: child.code }
                    }
                });
            });
        }
        this.breadcrumbService.setCustom(breadCrumbArr);
    }
    getTaxonName() {
        let taxonName = null;
        if (this.product['productTaxons'].length) {
            taxonName = this.product['productTaxons'][0].translations[this.language['LANGUAGE_CODE']] ?
                this.product['productTaxons'][0].translations[this.language['LANGUAGE_CODE']].name :
                this.product['productTaxons'][0].translations[this.languageService.defaultLocale].name;
        }
        return !this.product.mainTaxon.translations ? taxonName : this.translatePipe.transform(this.product.mainTaxon, 'name');
    }
    getTaxonChildName() {
        let childreen = this.product.mainTaxon.children;
        if (childreen) {
            if (!this.containsObject(childreen, this.childreenBreadcrumbs)) {
                this.childreenBreadcrumbs.push(childreen);
            }
            childreen = childreen['children'];
            if (!this.containsObject(childreen, this.childreenBreadcrumbs)) {
                this.childreenBreadcrumbs.push(childreen);
            }
        }
    }
    getTaxonParams() {
        return this.product.mainTaxon.code === undefined ?
            this.product['productTaxons'][0].code :
            this.product.mainTaxon.code;
    }
    autoSelect() {
        if (!this.product.options) {
            return;
        }
        for (const option of this.product.options) {
            // if (option.option_values.length === 1) {
            this.options[option.code] = option.option_values[0].code;
            this.optionChanged(option.code, option.option_values[0].code);
            // }
        }
    }
    //
    manageProduct(product) {
        this.product = product;
        // Add Meta Tags
        if (this.meta.getTag('name="keywords"')) {
            this.meta.updateTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
        }
        else {
            this.meta.addTag({ name: 'keywords', content: this.translatePipe.transform(this.product, 'meta_keywords') });
        }
        if (this.meta.getTag('name="description"')) {
            this.meta.updateTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
        }
        else {
            this.meta.addTag({ name: 'description', content: this.translatePipe.transform(this.product, 'meta_description') });
        }
        if (this.product.options && this.product['options'].length > 0) {
            for (const option of this.product['options']) {
                this.options[option.code] = '';
            }
        }
        this.autoSelect();
        this.manageVariant();
        this.rate = product.rating;
        this.fav = this.wishlistService.inWishList(product.code);
        this.compare = this.compareService.inCompare(product.code);
        if (product.images.length > 0) {
            this.src = `${environment.imageUrl}${product.images[0].path}`;
        }
        else {
            this.src = this.defaultImage;
        }
        this.variant = this.product['variants'][0];
        this.prices = this.product['variants'][0].prices[0];
        this.price = this.prices.original_price > this.prices.price ? this.prices.price : this.prices.original_price;
        // set empty array to hold the chose options
        this.simple = this.product.options && product.options.length === 0;
        let maxSet = false;
        const existsInCart = this.simple && product.variants[0] ? this.cartService.checkIfVariantInCart(product.variants[0]) : false;
        if (existsInCart) {
            this.max = product.variants[0].tracked ? product.variants[0].stock - existsInCart[1] : undefined;
            this.variantExists = true;
            maxSet = true;
            this.quantity = 1;
        }
        if (this.simple && !maxSet) {
            this.max = product.variants[0].tracked ? product.variants[0].stock : undefined;
            this.variantExists = true;
            this.quantity = 1;
        }
    }
    containsObject(obj, list) {
        let i;
        for (i = 0; i < list.length; i++) {
            if (list[i].code === obj.code) {
                return true;
            }
        }
        return false;
    }
    toggleShow() {
        this.showDetails = !this.showDetails;
    }
    toggleDescriptionHeight() {
        this.toggleHeight = !this.toggleHeight;
    }
    toggleShowElement(element) {
        if (element.style.display === 'block') {
            element.classList.remove('sliceDown');
            setTimeout(() => {
                element.style.display = 'none';
            }, 300);
        }
        else {
            element.style.display = 'block';
            setTimeout(() => {
                element.classList.add('sliceDown');
            }, 50);
        }
    }
    toggleProperties() {
        document.getElementById('element_attribute').classList.toggle('showproperties');
        document.getElementById('attribute_icon').classList.toggle('fa-minus');
    }
    isCombinationCheck(product) {
        if (!product.isCombination) {
            this.totalMalePrice += product.combinationPrice.price;
        }
    }
    AddonsChecker(product) {
        if (product['addons']) {
            this.addonsUndfined = false;
            /* If this product have addons we need setup addons dynamic forms*/
            this.AddonsSetup(this.Addons);
        }
        else {
            this.addonsUndfined = true;
        }
    }
    AddonsSetup(addons) {
        /** Initializ the addonsforms<formgroup> to new formgroup from form builder*/
        this.AddonsForm = this.formBuilder.group({});
        this.generatArrays(addons.length);
        this.addonsLength = addons.length;
        /** loop in product addons  */
        for (let [a, add] of addons.entries()) {
            let requireCheck = false;
            let addIndexDefult = -1;
            let varIndexDefult = -1;
            /** add new control in addons form with addons name
             * and set control value
             * is new form array from formbuilder */
            this.AddonsForm.addControl(add.name, this.formBuilder.array([]));
            /** push empty array in the choices array to collect  what the customer choices
             * the choices array length equle the addons length if addons.length = 3
             * the choices array will be [[for first addons choices ... and so on],[],[]]
             *
             */
            /** ctl variable to get the addons form controls as array
             *
             */
            const ctl = this.AddonsForm.get(add.name);
            /** loops in addonst variants */
            for (let [v, varian] of add.variant.entries()) {
                /**
                 * check the addons is required or optiona
                 * if optional = false & multipleSelect = false < the type of input in html will be radio btn
                 * if optional = false & multipleSelect = true < the type of input in html will be checkbox
                 *
                 */
                varian = Object.assign(varian, {
                    checked: add && add.optional === false && requireCheck === false || varian && varian['checked'] && varian['checked'] === true ? true : false
                });
                if (varian['checked'] === true) {
                    this.defaultPrice = true;
                    requireCheck = true;
                    // this.totalMalePrice += varian['price']
                    // this.lastPrice.push(varian['price'])
                    varIndexDefult = v;
                    addIndexDefult = a;
                }
                if (!add.optional && !add.multipleSelect || !add.optional && add.multipleSelect) {
                    /** here we detect the type of html input base on the multipleSelect if it = true
                     * the input will be checkbox else radio btn
                     * and assign new property at the every addons variants object in run time it's called
                     * checked with boolean type (inital value false )
                     *
                     * */
                    varian = Object.assign(varian, {
                        required: true,
                    });
                }
                if (add.multipleSelect) {
                    add = Object.assign(add, {
                        type: 'checkbox',
                    });
                    if (!add.optional && add['maximumChecks'] && add['minimumChecks'] && toNumber(add['maximumChecks']) >= add['minimumChecks']) {
                        add = Object.assign(add, {
                            requiredSelected: 0,
                            requiredSelectedAlert: false
                        });
                    }
                    if (add.optional && add['maximumChecks'] && toNumber(add['maximumChecks']) > 0) {
                        add = Object.assign(add, {
                            requiredSelected: 0
                        });
                    }
                }
                else {
                    add = Object.assign(add, {
                        type: 'radio',
                    });
                }
                /** then will push new control ton the ctl variable ,
                 * the checked value become the controler value (true / false )
                 * to allow track the control  is check or uncheck
                 *  */
                ctl.push(this.formBuilder.control(varian['checked']));
                if (v == add.variant.length - 1) {
                    if (addIndexDefult != -1 && varIndexDefult != -1) {
                        this.collectChooes(addons[addIndexDefult].variant[varIndexDefult], true, addIndexDefult, addons[addIndexDefult].name, varIndexDefult, add.optional, add.multipleSelect);
                    }
                }
            }
            /** after generate dynamic addons form
       * to make sure at least one is checked
       * we add the custom validation requireCheckboxesToBeCheckedValidator
       */
            // if ((!add.optional && !add.multipleSelect) || (!add.optional && add.multipleSelect)) {
            // 	this.AddonsForm
            // 		.get(add.name)
            // 		.setValidators(requireCheckboxesToBeCheckedValidator());
            // }
        }
    }
    collectChooes(val, checked, index, addName, ctrIndex, optional, mul) {
        var _a;
        // const ctrIndexString = ctrIndex.toString();
        // const f = this.AddonsForm.controls[addName].get(ctrIndexString);
        if (mul) {
            if (checked) {
                val['checked'] = true;
                this.Addons[index]['requiredSelected'] += 1;
            }
            else {
                val['checked'] = false;
                this.Addons[index]['requiredSelected'] -= 1;
            }
            if (this.Addons[index]['requiredSelected'] == this.Addons[index]['minimumChecks']) {
                this.Addons[index]['requiredSelectedAlert'] = false;
            }
        }
        if (checked) {
            if (!optional && !mul) {
                this.choices[index].length = 0;
            }
            if (this.choices[index].length >= this.Addons[index].maximumChecks) {
                ((_a = this.AddonsForm) === null || _a === void 0 ? void 0 : _a.get(ctrIndex).value) == false;
            }
            else {
                val.addonsName = addName;
                this.choices[index].push(val);
                this.checkCombinationPrice(val, 'add', mul, index);
            }
            if (this.defaultPrice !== true) {
                // f.patchValue(true);
            }
            this.defaultPrice = false;
        }
        else {
            // f.patchValue(false);
            this.choices[index] = this.choices[index].filter((itm) => {
                return itm !== val;
            });
            this.checkCombinationPrice(val, 'subtract', mul, index);
        }
    }
    checkCombinationPrice(val, operation, mul, index) {
        if (mul && operation === 'add') {
            this.totalMalePrice += val['price'];
        }
        else if (!mul && operation === 'add') {
            if (this.lastPrice[index] !== 0) {
                this.totalMalePrice -= this.lastPrice[index];
                this.totalMalePrice += val['price'];
            }
            else {
                this.totalMalePrice += val['price'];
            }
            this.lastPrice[index] = val['price'];
        }
        else if (mul && operation === 'subtract') {
            this.totalMalePrice -= val['price'];
        }
        else if (!mul && operation === 'subtract') {
            if (this.lastPrice[index] !== 0) {
                this.totalMalePrice -= val['price'];
                this.lastPrice[index] = 0;
            }
            else {
                this.totalMalePrice -= val['price'];
            }
        }
    }
    validatorCheck() {
        let validate_value = true;
        for (let index = 0; index < this.Addons.length; index++) {
            if (!this.Addons[index].optional && this.Addons[index].multipleSelect) {
                //requiredSelectedAlert
                if (!(toNumber(this.Addons[index]['requiredSelected']) && toNumber(this.Addons[index]['maximumChecks']) && toNumber(this.Addons[index]['minimumChecks']) && this.Addons[index]['requiredSelected'] <= toNumber(this.Addons[index]['maximumChecks']) && toNumber(this.Addons[index]['requiredSelected']) >= toNumber(this.Addons[index]['minimumChecks']))) {
                    this.Addons[index]['requiredSelectedAlert'] = true;
                    if (validate_value == true) {
                        validate_value = false;
                        //  validate_value;
                    }
                }
            }
        }
        return validate_value;
    }
    validateRequiredOptionsCheck(add) {
        let optionalRequired = 0;
        if (toNumber(add['minimumChecks']) > 0) {
            if (toNumber(add['minimumChecks']) > toNumber(add['requiredSelected'])) {
                optionalRequired = toNumber(add['minimumChecks']) - toNumber(add['requiredSelected']);
            }
        }
        return optionalRequired;
    }
    generatArrays(length) {
        this.choices.length = 0;
        for (let index = 0; index < length; index++) {
            this.choices.push([]);
            this.lastPrice.push(0);
        }
    }
    downloadCatalogue() {
        localStorage.setItem('downloadCatalogue', 'true');
        this.download();
    }
    download() {
        this.checkoutService.downloadInvoice(this.product['catalogPDF'])
            .subscribe(blob => {
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = `${this.product['name']}catalog.pdf`;
            a.click();
            URL.revokeObjectURL(objectUrl);
        });
    }
}
ProductAddonsBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductAddonsBaseComponent, deps: [{ token: i2.ActivatedRoute }, { token: LanguageService }, { token: ProductService }, { token: CartService }, { token: WishListService }, { token: CompareService }, { token: BreadcrumbService }, { token: TranslatePipe }, { token: LoginService }, { token: i1$1.FormBuilder }, { token: i5.BsModalService }, { token: i6.Location }, { token: i3$1.ToastrService }, { token: i3.Title }, { token: i3.Meta }, { token: ConfService }, { token: i2.Router }, { token: GoogleAnalyticsService }, { token: LanguageService }, { token: CheckoutService }], target: i0.ɵɵFactoryTarget.Component });
ProductAddonsBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: ProductAddonsBaseComponent, selector: "app-product-addons-base", inputs: { productInput: "productInput" }, viewQueries: [{ propertyName: "thisImage", first: true, predicate: ["thisImage"], descendants: true }, { propertyName: "thumbnailWrapper", first: true, predicate: ["thumbnailWrapper"], descendants: true }], ngImport: i0, template: "<!--loading-->\r\n<div *ngIf=\"!Addons && !notFound\">\r\n  <app-inner-loading></app-inner-loading>\r\n</div>\r\n<!--End collection__spinner-->\r\n<div class=\"container\" *ngIf=\"notFound\">\r\n  <div class=\"empty-div\">\r\n    <p>\r\n      {{language['sorrySomethingWentWrong']}}\r\n    </p>\r\n  </div>\r\n  <div class=\"text-center\">\r\n    <button routerLink=\"/collection\" class=\"custom-btn\">{{language['backToCollection']}}</button>\r\n  </div>\r\n</div>\r\n<!--style product details-->\r\n<section class=\"singleProduct\" *ngIf=\"Addons\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <!--start image gallery-->\r\n      <div class=\"col-lg-5\">\r\n          <div class=\"gallery\">\r\n              <carousel *ngIf=\"(Addons[0].images?.length > 0) ; \" [interval]=\"false\">\r\n                  <slide *ngFor=\"let image of Addons[0].images\" class=\"main-image-product\">\r\n                      <div class=\"easyzoom easyzoom--overlay easyzoom--with-thumbnails is-ready\" style=\"width:100%\">\r\n                          <a [href]=\"imageUrl + image.path\" class=\"image-wrapper\">\r\n                              <img #thisImage (error)=\"thisImage.src = defaultImage\" [alt]=\"product.name\" [src]=\"imageUrl + image.path\" alt=\"first slide\" class=\"animate-fade\" (load)=\"handleEasyZoom(); imgIsLoaded = true\" [hidden]=\"imgIsLoaded == false\" />\r\n                          </a>\r\n                      </div>\r\n                  </slide>\r\n              </carousel>\r\n              <ng-template #displayImage>\r\n                  <div class=\"easyzoom--with-thumbnails\">\r\n                      <img [alt]=\"product.name\" [lazyLoad]=\"defaultImage\" alt=\"first slide\" class=\"img-fluid\" style=\"width: 100%\">\r\n                  </div>\r\n              </ng-template>\r\n              <owl-carousel [options]=\"changeCarouselOptions(thumbnialOptions)\" [carouselClasses]=\"['owl-theme', 'owl-flex']\">\r\n                  <div class=\"imgSlide thumbnails\" *ngFor=\"let image of Addons[0].images\">\r\n                      <a [href]=\"imageUrl + image.path\">\r\n                          <img [lazyLoad]=\"imageUrl + image.path\" alt=\"first slide\" #thisImage (error)=\"thisImage.src = defaultImage\">\r\n                      </a>\r\n                  </div>\r\n              </owl-carousel>\r\n          </div>\r\n      </div><!--End COl-->\r\n      <!--start product info-->\r\n      <div class=\"col-lg-7\">\r\n        <div class=\"product-details-content\">\r\n          <h4 class=\"title\" id=\"dialog-child-name\">\r\n            <a class=\"product-title\"\r\n              [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product | translate: 'slug']\">\r\n              {{product | translate : 'name'}}\r\n            </a>\r\n          </h4>\r\n          \r\n          <div class=\"product-rating\" *ngIf=\"reviewsFeature$ | async\">\r\n            <h4 class=\"title\">{{language['rating']}}</h4>\r\n            <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\">\r\n            </rating>\r\n          </div>\r\n          <!--End Product Rating-->\r\n          <!--stock-->\r\n\r\n          <div class=\"form-group\">\r\n            <label>{{language['total']}}: <span dir=\"ltr\">{{ totalMalePrice / 100 | number}} {{currencyCode}}</span>\r\n            </label>\r\n          </div>\r\n          <hr>\r\n          <!--End Product-description-->\r\n          <hr *ngIf=\"product.translations[language['LANGUAGE_CODE']]?.short_description\">\r\n\r\n          <form [formGroup]=\"AddonsForm\" #ngForm=\"ngForm\">\r\n            <ng-container *ngFor=\"let add of Addons ; let v = index\">\r\n              <div class=\"form-check\" *ngIf=\"!(add.variant.length === 1 && !add.optional)\">\r\n                <div class=\"product-name\">\r\n                  <h2 [ngClass]=\"{'title-alret': add && add.requiredSelectedAlert  }\"  class=\"title\">\r\n                    {{add | translate: 'name'}}\r\n                    <span class=\"title-validate\" *ngIf=\"!add?.optional\">({{language['required'] ||   'Required' }}\r\n                      <label *ngIf=\"!add?.optional && add?.multipleSelect  && add.minimumChecks && add.minimumChecks > 0 \">\r\n                        {{language['Choose'] ||   'Choose' }}  {{add.minimumChecks}}\r\n                      </label>\r\n                      <label *ngIf=\"!add?.optional && add?.multipleSelect  && add.maximumChecks && add.maximumChecks > 0 \">\r\n                       -   {{language['max'] ||   'Max' }}  {{add.maximumChecks}}\r\n                      </label>\r\n                    )\r\n                    </span>\r\n                    <span class=\"title-validate\" *ngIf=\"add?.optional\">({{language['optional'] ||   'Optional' }}\r\n                      <label *ngIf=\"add?.optional && add?.multipleSelect  && add.maximumChecks && add.maximumChecks > 0 \">\r\n                        -   {{language['max'] ||   'Max' }} {{add.maximumChecks}}\r\n                       </label>\r\n                      )\r\n                    </span>\r\n                  </h2>\r\n                </div>\r\n                <div *ngFor=\"let a of AddonsForm?.get(add?.name)['controls']; let i = index\">\r\n                  <div [formArrayName]=\"add?.name\">\r\n                    <div [ngClass]=\"{'disabled-click': add && add.multipleSelect && add.requiredSelected && add.maximumChecks  && add.maximumChecks > 0 && add.requiredSelected == add.maximumChecks && !(add?.variant[i]['checked']) }\" [ngSwitch]=\"add['type']\">\r\n                      <input class=\"input-addons\" *ngSwitchCase=\"'radio'\" [formControlName]=\"a[i]\"\r\n                        (change)=\"collectChooes(add?.variant[i] ,$event.target.checked ,v , add?.name , a[i] ,add?.optional, add?.multipleSelect)\"\r\n                        [value]=\"add?.variant[i]['checked']\" [name]=\"add?.name\" [id]=\"add?.variant[i].code\"\r\n                        [type]=\"add['type']\" [checked]=\"add?.variant[i]['checked']\">\r\n\r\n                      <input  class=\"input-addons\" *ngSwitchCase=\"'checkbox'\" [formControlName]=\"a[i]\"\r\n                        (change)=\"collectChooes(add?.variant[i], $event.target.checked, v, add?.name, a[i], add?.optional, add?.multipleSelect )\"\r\n                        [value]=\"add?.variant[i]['checked']\" [name]=\"add?.name\" [id]=\"add?.variant[i].code\"\r\n                        [type]=\"add['type']\" [checked]=\"add?.variant[i]['checked']\">\r\n                      <label [for]=\"add?.variant[i].code\">\r\n                        {{add?.variant[i].name}} <span dir=\"ltr\" *ngIf=\"add?.variant[i]['price'] > 0\">\r\n                          (+{{add?.variant[i]['price']\r\n                          / 100}} {{currencyCode}})</span>\r\n                      </label>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <!-- <div class=\"invalid-feedback\"\r\n                  *ngIf=\"AddonsForm?.controls[add?.name].hasError('requireOneCheckboxToBeChecked')\">\r\n                  At least one checkbox is required to check</div> -->\r\n              </div>\r\n            </ng-container>\r\n             \r\n            <div *ngIf=\"!this.myStore.isContactUsInsteadAddCart; else elseBlock\">\r\n              <button class=\"custom-btn\" [ngClass]=\"{'no-items-remaining':max==0}\" (click)=\"addToCart()\" *ngIf=\"!product.hidePrice\"\r\n              [disabled]=\"!canAddToCart || cartService.addedToCart.getValue() == false || max==0\" role=\"button\"\r\n              aria-label=\"add to cart\">\r\n              {{\r\n              max==0?language['noItemsRemaining']:\r\n              variantUndefined ? language['unavailbleItem'] :\r\n              (canAddToCart ? (cartService.addedToCart.getValue() !== false ? language['addToCart'] : language['wait'] )\r\n              : language['outOfStock'])\r\n              }}\r\n            </button>\r\n\r\n            </div>\r\n            <ng-template #elseBlock>\r\n\r\n              <button class=\"custom-btn\" (click)=\"SwtichToContactUs()\" *ngIf=\"product.hidePrice\"\r\n            \r\n              aria-label=\"contactUS\">\r\n              {{\r\n          language['contactUs']\r\n              }}\r\n            </button>\r\n</ng-template>\r\n          </form>\r\n          <div class=\"product-action mt-3\">\r\n            <button class=\"custom-btn\" (click)=\"downloadCatalogue()\"\r\n            [disabled]=\"!product['catalogPDF'] || product['catalogPDF'] == Null\" role=\"button\">\r\n            Download product catalogue\r\n          </button>\r\n          </div>\r\n\r\n        </div>\r\n        <!--End product-details-content-->\r\n      </div>\r\n      <!--End Col-->\r\n    </div>\r\n    <!--End Row-->\r\n    <!--start tabs of products-->\r\n    <div class=\"singleProduct-tabs\">\r\n      <tabset>\r\n        <tab class=\"description\" [heading]=\"language['description']\" *ngIf=\"product | translate: 'description'\"\r\n          [innerHTML]=\"product | translate: 'description' | noSanitizeHtml\">\r\n        </tab>\r\n        <tab [heading]=\"language['specifications']\" *ngIf=\"product.attributes?.length\">\r\n          <table id=\"attributes-table\" class=\"table table-hover\">\r\n            <tr *ngFor=\"let attribute of product.attributes\">\r\n              <td>{{attribute | translate: 'name'}}</td>\r\n              <td>\r\n                <span *ngFor=\"let value of attribute.values; let last = last;\">\r\n                  {{value | translate: 'name'}}<ng-container *ngIf=\"!last\">, </ng-container>\r\n                </span>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </tab>\r\n        <tab [heading]=\"language['reviews']\" *ngIf=\"reviewsFeature$ | async\">\r\n          <div class=\"product-reviews\">\r\n            <div class=\"review-item\" *ngFor=\"let review of reviews$ | async\">\r\n              <div class=\"review-item-img\">\r\n                <img src=\"../../../assets/images/avatar.jpg\" alt=\"user img\">\r\n              </div>\r\n              <!--End Review-item-img-->\r\n              <div class=\"review-item-content\">\r\n                <h2 class=\"user-name\">\r\n                  {{review.author?.firstName}} {{review.author?.lastName}}\r\n                </h2>\r\n                <span class=\"review-date\">\r\n                  {{review.createdAt | date: 'yyyy-MM-dd hh:mm'}}\r\n                </span>\r\n                <div class=\"review-rate\">\r\n                  <rating [(ngModel)]=\"review.rating\" [max]=\"maxRate\" [readonly]=\"true\"></rating>\r\n                </div>\r\n                <div class=\"review-comment\">\r\n                  <h3 class=\"comment-title\">{{review.title}}</h3>\r\n                  <p>\r\n                    {{review.comment}}\r\n                  </p>\r\n                </div>\r\n              </div>\r\n              <!--End review-item-content-->\r\n            </div>\r\n            <!--End review-item-->\r\n          </div>\r\n          <!--End Product-reviews-->\r\n          <div class=\"review-form\">\r\n            <h3 class=\"title\">\r\n              {{language['add']}} {{language['rating']}}\r\n            </h3>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-9\">\r\n                <form [formGroup]=\"reviewForm\" (submit)=\"submitReview()\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <div class=\"form-group\">\r\n                        <input class=\"form-control\" placeholder=\"{{language['reviewTitle']}}*\" formControlName=\"title\">\r\n                      </div>\r\n                      <!--End form-group-->\r\n                    </div>\r\n                    <!--End col-->\r\n                    <div class=\"col-md-6\" [ngClass]=\"{'d-none': logged$ | async}\">\r\n                      <div class=\"form-group\">\r\n                        <input type=\"email\" class=\"form-control\" placeholder=\"{{language['email']}}*\"\r\n                          formControlName=\"email\">\r\n                      </div>\r\n                      <!--End form-group-->\r\n                    </div>\r\n                    <!--End col-->\r\n                    <div class=\"col-md-6 align-self-center\">\r\n                      <div class=\"form-group\">\r\n                        <span class=\"rate-label\"> {{language['rating']}}</span>\r\n                        <div class=\"rating\">\r\n                          <rating [max]=\"maxRate\" (onLeave)=\"rateChange($event)\"></rating>\r\n                        </div>\r\n                      </div>\r\n                      <!--End form-group-->\r\n                    </div>\r\n                    <!--End col-->\r\n                    <div class=\"col-md-12\">\r\n                      <div class=\"form-group\">\r\n                        <textarea class=\"form-control\" placeholder=\"{{language['addYourcomment']}}*\"\r\n                          formControlName=\"comment\"></textarea>\r\n                      </div>\r\n                      <!--End form-group-->\r\n                    </div>\r\n                    <!--End col-->\r\n                    <div class=\"col-md-12\">\r\n                      <div class=\"form-group\">\r\n                        <button class=\"custom-btn add-review-btn\" type=\"submit\" [disabled]=\"reviewForm.invalid\">\r\n                          {{language['submit']}}\r\n                        </button>\r\n                      </div>\r\n                      <!--End Form-group-->\r\n                    </div>\r\n                    <!--End col-->\r\n                  </div>\r\n                  <!--End Row-->\r\n                </form>\r\n              </div>\r\n              <!--End col-->\r\n              <div class=\"col-md-3 align-self-center\">\r\n                <div class=\"rate-container\">\r\n                  <div class=\"circle\">{{rate | number: '1.1-1'}}</div>\r\n                  <div class=\"stars-wrapper\">\r\n                    <rating [(ngModel)]=\"rate\" [max]=\"maxRate\" [readonly]=\"true\"></rating>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!--Ebd col-->\r\n            </div>\r\n            <!--End row-->\r\n          </div>\r\n          <!--End Review-form-->\r\n        </tab>\r\n      </tabset>\r\n    </div>\r\n    <!--End Single-product-tabs-->\r\n    <!--END tabs of products-->\r\n  </div>\r\n  <!--End Container-->\r\n  <!-- *ngIf=\"associations?.associated_products.length > 0\" -->\r\n\r\n</section>\r\n", styles: ["::ng-deep .main-image-product .item{background:#fff;text-align:center}::ng-deep .main-image-product .item a{width:400px;height:400px;display:inline-block}::ng-deep .gallery .carousel-control-prev-icon{background-color:var(--main-color, orange)}::ng-deep .gallery .carousel-control-next-icon{background-color:var(--main-color, orange)}::ng-deep .main-image-product .item a{width:100%;height:100%}::ng-deep .img-fluid{max-width:100%;height:100%}@media (max-width: 767px){::ng-deep .easyzoom{pointer-events:none}}label.price{margin-left:100px!important;float:right}.input-addons{margin-left:5px;margin-right:5px}.title-validate{font-size:15px}:host .disabled-click{pointer-events:none!important}:host .title{color:var(--body-link-color-, var(-h2-color, #000))}:host .title-alret{color:red!important}:host .singleProduct{background-color:var(--body-bg-color, #fff)}:host .singleProduct .gallery{margin-bottom:4rem}:host .singleProduct .gallery .main-image-product{margin:auto;height:400px}:host .singleProduct .gallery ::ng-deep .carousel{position:relative;box-shadow:10px 10px 10px -7px #e1e1e1;margin-bottom:5rem}:host .singleProduct .gallery ::ng-deep .carousel .carousel-indicators{display:none}:host .singleProduct .gallery ::ng-deep .carousel .carousel-control-prev,:host .singleProduct .gallery ::ng-deep .carousel .carousel-control-next{display:none}:host .singleProduct .gallery ::ng-deep .gallery-thumbnails .owl-theme .owl-nav{display:none}:host .singleProduct .gallery ::ng-deep .gallery-thumbnails .imgSlide.thumbnails{border-radius:0;border:2px solid #f2f2f2;margin:0 5px;width:95px;height:95px}:host .singleProduct .gallery ::ng-deep .gallery-thumbnails .imgSlide.thumbnails:focus,:host .singleProduct .gallery ::ng-deep .gallery-thumbnails .imgSlide.thumbnails:active,:host .singleProduct .gallery ::ng-deep .gallery-thumbnails .imgSlide.thumbnails:focus-within{border-color:var(--main-color, orange)}:host .singleProduct .gallery ::ng-deep .gallery-thumbnails .imgSlide.thumbnails a{display:flex;align-items:center;justify-content:center;height:90px}:host .singleProduct .gallery ::ng-deep .gallery-thumbnails .imgSlide.thumbnails img{width:auto;height:100%}:host .singleProduct .gallery ::ng-deep .easyzoom-flyout img{max-width:unset!important}:host .singleProduct .gallery ::ng-deep .loading-image-wrapper{display:flex;align-items:center;justify-content:center;height:400px}:host .singleProduct .gallery ::ng-deep .loading-image-wrapper img{max-height:100%}:host .singleProduct .gallery ::ng-deep .loading-image-wrapper .loading-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host .singleProduct .gallery .gallery--img{width:100%}:host .singleProduct .gallery .animate-fade{position:relative;-webkit-animation-name:animatefade;-webkit-animation-duration:1s;animation-name:animatefade;animation-duration:1s}@keyframes animatefade{0%{opacity:0}to{opacity:1}}:host .singleProduct .product-details-content{padding:2rem}:host .singleProduct .product-details-content .product-title{font-size:3rem;color:var(--body-link-color, #000);display:block;padding-bottom:1rem;font-weight:600;text-transform:capitalize}:host .singleProduct .product-details-content .Product-price{color:#f44336;font-size:1.8rem;font-weight:bold;margin-bottom:2rem}:host .singleProduct .product-details-content .Product-price .current-price{color:var(--main-color, orange);font-weight:700;font-size:2.4rem}:host .singleProduct .product-details-content .Product-price .original-price{color:#6c757d;font-size:1.8rem;font-weight:400;text-decoration:line-through;display:inline-block}:host .singleProduct .product-details-content .product-rating{margin:1rem 0}:host .singleProduct .product-details-content .Product-availability{margin-bottom:10px}:host .singleProduct .product-details-content .Product-availability span{font-weight:700;color:#4caf50;font-size:1.6rem}:host .singleProduct .product-details-content .Product-availability span.outofstock{color:#f44336}:host .singleProduct .product-details-content .product-actions{display:flex;align-items:flex-start;margin:2rem 0}:host .singleProduct .product-details-content .product-actions .input-number{margin-inline-end:1rem}:host .singleProduct .product-details-content .product-actions .action-btns{display:flex;align-items:flex-start}:host .singleProduct .product-details-content .product-actions .action-btns .custom-btn{min-width:165px;padding:10.5px 20px;text-transform:uppercase;color:#fff;background-color:#000;border-color:#000;margin-inline-end:1rem}:host .singleProduct .product-details-content .product-actions .action-btns .custom-btn:hover{background-color:var(--main-color, orange);border:1px solid var(--main-color, orange)}:host .singleProduct .product-details-content .product-actions .action-btns .icon-btn{max-width:45px;min-width:45px;height:45px;line-height:45px;background-color:transparent;color:var(--body-link-color, #000);border:1px solid var(--body-link-color, #000);border-radius:0;margin:auto;margin-inline-end:1rem;transition:all .3s ease-in-out}:host .singleProduct .product-details-content .product-actions .action-btns .icon-btn:hover,:host .singleProduct .product-details-content .product-actions .action-btns .icon-btn.active{background-color:var(--main-color, orange);color:#fff;border-color:#fff}:host .singleProduct .product-details-content .product-actions .action-btns .icon-btn.wishlist-btn.active{animation:heartbeat 1s 1;background-color:red}:host .singleProduct .product-details-content .product-actions .action-btns .icon-btn.wishlist-btn:hover{background-color:red}:host .singleProduct .product-details-content .product-options{padding:0}:host .singleProduct .product-details-content .product-options .form-group{display:flex;align-items:center;margin-bottom:2rem}:host .singleProduct .product-details-content .product-options .form-group label{width:30%;font-weight:bold}:host .singleProduct .product-details-content .product-options .form-group .form-control,:host .singleProduct .product-details-content .product-options .form-group .product-price{width:65%;border-radius:.5rem}:host .singleProduct .product-details-content .product-options .check-radio-item{margin-bottom:1rem;margin-inline-end:1rem}:host .singleProduct .product-details-content .product-options .check-radio-item:last-child{margin-inline-end:0}:host .singleProduct .product-details-content .product-options .check-radio-item.inline{display:inline-block;vertical-align:middle}:host .singleProduct .product-details-content .product-options .check-radio-item.with-img input[type=radio]+label,:host .singleProduct .product-details-content .product-options .check-radio-item.with-img input[type=checkbox]+label{border-radius:3px;padding:0;width:50px;height:50px;border:1px solid transparent;transition:all .3s ease-in-out}:host .singleProduct .product-details-content .product-options .check-radio-item.with-img input[type=radio]+label img,:host .singleProduct .product-details-content .product-options .check-radio-item.with-img input[type=checkbox]+label img{max-width:100%;max-height:100%}:host .singleProduct .product-details-content .product-options .check-radio-item.with-img input[type=radio]:checked+label,:host .singleProduct .product-details-content .product-options .check-radio-item.with-img input[type=checkbox]:checked+label{border:1px solid var(--main-color, orange)}:host .singleProduct .product-details-content .product-options .check-radio-item input[type=radio],:host .singleProduct .product-details-content .product-options .check-radio-item input[type=checkbox]{position:absolute;width:0;height:0;opacity:0}:host .singleProduct .product-details-content .product-options .check-radio-item input[type=radio]+label,:host .singleProduct .product-details-content .product-options .check-radio-item input[type=checkbox]+label{position:relative;width:auto;padding:5px 20px;border:1px solid var(--main-color, orange);border-radius:3rem;background-color:#fff;color:#09f;font-size:1.4rem;line-height:2.5rem;text-transform:capitalize;cursor:pointer;margin-bottom:0}:host .singleProduct .product-details-content .product-options .check-radio-item input[type=radio]+label.tooltip,:host .singleProduct .product-details-content .product-options .check-radio-item input[type=checkbox]+label.tooltip{opacity:1}:host .singleProduct .product-details-content .product-options .check-radio-item input[type=radio]:checked+label,:host .singleProduct .product-details-content .product-options .check-radio-item input[type=checkbox]:checked+label{color:#fff;background-color:var(--main-color, orange);border-color:var(--main-color, orange)}:host .singleProduct .product-details-content .product-options .tooltip{position:relative;display:inline-block;border-bottom:1px dotted #000}:host .singleProduct .product-details-content .product-options .tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;top:-50%;left:50%;transform:translate(-50%,-50%);z-index:1070}:host .singleProduct .product-details-content .product-options .tooltip .tooltiptext:after{content:\" \";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:#000 transparent transparent transparent}:host .singleProduct .product-details-content .product-options .tooltip:hover .tooltiptext{visibility:visible}:host .singleProduct .product-details-content .product-description{margin-bottom:3rem}:host .singleProduct .product-details-content .product-description .product-code span{font-size:1.6rem;font-weight:700;text-transform:uppercase}:host .singleProduct .product-details-content .product-description .product-short-desc{font-size:18px;color:var(--body-link-color, #505050)}:host .singleProduct .product-details-content .product-share{display:flex;align-items:center}:host .singleProduct .product-details-content .product-share>span{font-size:1.8rem;font-weight:600;text-transform:capitalize;margin-inline-end:25px}:host .singleProduct .product-details-content .product-share ul.social-list li a{color:var(--body-link-color, #9E9E9E);margin:0 1.5rem}:host .singleProduct .product-details-content .product-share ul.social-list li a:hover{color:var(--main-color, orange)}:host .singleProduct .singleProduct-tabs{margin-bottom:8rem}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs{border-bottom:0;padding:0}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-item{margin-bottom:-2px}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-link{padding:15px;font-size:16px;font-weight:600;color:var(--body-link-color, #6c6c6c);border:2px solid transparent}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-link.active{color:var(--main-color, orange);border-color:#ececec #ececec #fff}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-link.active:hover{border-color:#ececec #ececec #fff}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-link:hover{border-color:transparent transparent #ececec}:host .singleProduct .singleProduct-tabs ::ng-deep .tab-content{padding:3rem;border:2px solid #ececec;border-radius:.25rem}:host .singleProduct .singleProduct-tabs ::ng-deep .tab-content .description{font-size:16px;color:var(--body-link-color, #70797b);font-weight:600;line-height:1.6;margin-bottom:3rem}@media all and (max-width: 567.98px){:host .singleProduct .singleProduct-tabs ::ng-deep .tab-content{padding:1.5rem}}:host .singleProduct .singleProduct-tabs .product-reviews{width:90%;margin-bottom:3rem}:host .singleProduct .singleProduct-tabs .product-reviews .review-item{margin-bottom:3rem}:host .singleProduct .singleProduct-tabs .product-reviews .review-item:last-child{margin-bottom:0}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-img{float:left;width:80px;height:80px;border-radius:100%;overflow:hidden}[dir=rtl] :host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-img{float:right}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content{padding-inline-start:100px}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content .user-name{font-size:1.8rem;text-transform:capitalize;color:var(--body-link-color, #111);font-weight:600}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content .review-date{display:block;color:var(--body-link-color, #b7b7b7);font-size:12px;margin-bottom:5px;font-weight:600}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content .review-rate{margin-bottom:5px}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content .review-rate .bs-rating-star:after{font-size:16px}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content .review-comment{font-size:16px;color:var(--body-link-color, #858585)}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content .review-comment .comment-title{font-weight:600;color:var(--body-link-color, #333)}:host .singleProduct .singleProduct-tabs .review-form>.title{margin-bottom:3rem;font-size:1.8rem}:host .singleProduct .singleProduct-tabs .review-form .rate-label{font-weight:600;font-size:16px;color:var(--body-link-color, #000);margin-inline-end:2rem}:host .singleProduct .singleProduct-tabs .review-form .rating{display:inline-block;vertical-align:middle}:host .singleProduct .singleProduct-tabs .review-form .form-control{height:55px;padding:6px 15px}:host .singleProduct .singleProduct-tabs .review-form .form-control::-webkit-input-placeholder{text-transform:capitalize;color:#d2d2d2;font-size:1.6rem}:host .singleProduct .singleProduct-tabs .review-form .custom-btn{background-color:#000;color:#fff;border:none;padding:14px 20px;height:auto;min-width:150px;text-transform:uppercase}:host .singleProduct .singleProduct-tabs .review-form .custom-btn:hover{background-color:var(--main-color, orange);color:#fff}:host .singleProduct .singleProduct-tabs .review-form .custom-btn:disabled:hover{background-color:#333}:host .singleProduct .singleProduct-tabs .review-form .rate-container .circle{height:100px;width:100px;line-height:100px;border:1px solid #d3cac5;border-radius:50%;text-align:center;color:#9e9e9e;font-weight:600;font-size:35px;margin:0 auto 2rem}:host .singleProduct .singleProduct-tabs .review-form .rate-container .stars-wrapper{margin:auto;width:-moz-fit-content;width:fit-content}@media all and (max-width: 767.98px){:host .singleProduct .singleProduct-tabs .review-form>.row>.col-md-9{order:2;margin-top:30px}}:host #attributes-table td:first-child{color:var(--body-link-color, #000);text-transform:uppercase;font-size:18px}:host #attributes-table td:last-child{width:100%;color:var(--body-link-color, gray);font-size:16px}:host .related-items{margin-bottom:5rem}:host .related-items .section-head{position:relative;margin-bottom:8rem;display:flex;align-items:center;justify-content:flex-start}:host .related-items .section-head .title{text-transform:uppercase;position:relative;margin-bottom:0}:host .related-items .section-head .after{position:relative;flex-grow:2}:host .related-items .section-head .after:after{content:\"\";position:absolute;bottom:0;right:0;width:calc(100% - 25px);height:2px;background-color:#cdcccc}[dir=rtl] :host .related-items .section-head .after:after{right:auto;left:0}:host .related-items ::ng-deep .owl-theme .owl-nav{display:none}@media (max-width: 767.98px){:host .easyzoom{pointer-events:none}:host .singleProduct .singleProduct-tabs{margin-bottom:4rem}:host .singleProduct .singleProduct-tabs .product-reviews{width:100%}:host .singleProduct .product-details-content .product-title{font-size:2rem}:host .singleProduct .product-details-content .Product-price{font-size:1.4rem}:host .singleProduct .product-details-content .Product-price .current-price{font-size:2rem}:host .singleProduct .product-details-content .Product-price .original-price{font-size:1.4rem}:host .related-items,:host .related-items .section-head{margin-bottom:3rem}}@media all and (max-width: 450px){:host .singleProduct .product-details-content .product-actions{display:block}:host .singleProduct .product-details-content .product-actions .input-number{margin:0 auto 1rem;width:100%;max-width:100%}:host .singleProduct .product-details-content .product-actions .action-btns{display:block;text-align:center}:host .singleProduct .product-details-content .product-actions .action-btns .custom-btn{display:block;width:100%;max-width:100%;margin-bottom:1rem}}@media all and (max-width: 425px){:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs{display:block;margin-bottom:1rem}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-item{margin-bottom:0}:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-link.active,:host .singleProduct .singleProduct-tabs ::ng-deep .nav-tabs .nav-link.active:hover{border-color:#ececec}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-img{float:none;margin:0 auto 2rem}[dir=rtl] :host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-img{float:none;margin:0 auto 2rem}:host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content{padding:0;text-align:center}[dir=rtl] :host .singleProduct .singleProduct-tabs .product-reviews .review-item .review-item-content .review-rate{margin:0 auto 5px;display:inline-block}:host .singleProduct .singleProduct-tabs .review-form .custom-btn{width:100%}}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }, { type: i13.CarouselComponent, selector: "carousel", inputs: ["noWrap", "noPause", "showIndicators", "pauseOnFocus", "indicatorsByChunk", "itemsPerSlide", "singleSlideOffset", "isAnimated", "startFromIndex", "activeSlide", "interval"], outputs: ["activeSlideChange", "slideRangeChange"] }, { type: i13.SlideComponent, selector: "slide", inputs: ["active"] }, { type: i15.OwlCarousel, selector: "owl-carousel", inputs: ["carouselClasses", "options", "items"] }, { type: i10.RatingComponent, selector: "rating", inputs: ["max", "readonly", "titles", "customTemplate"], outputs: ["onHover", "onLeave"] }, { type: i17.TabsetComponent, selector: "tabset", inputs: ["vertical", "justified", "type"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { type: i6.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i6.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i17.TabDirective, selector: "tab, [tab]", inputs: ["disabled", "removable", "customClass", "active", "heading", "id"], outputs: ["selectTab", "deselect", "removed"], exportAs: ["tab"] }], pipes: { "translate": TranslatePipe, "async": i6.AsyncPipe, "number": i6.DecimalPipe, "noSanitizeHtml": NoSanitizeHtmlPipe, "date": i6.DatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProductAddonsBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-product-addons-base',
                    templateUrl: './product-addons-base.component.html',
                    styleUrls: ['./product-addons-base.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }, { type: LanguageService }, { type: ProductService }, { type: CartService }, { type: WishListService }, { type: CompareService }, { type: BreadcrumbService }, { type: TranslatePipe }, { type: LoginService }, { type: i1$1.FormBuilder }, { type: i5.BsModalService }, { type: i6.Location }, { type: i3$1.ToastrService }, { type: i3.Title }, { type: i3.Meta }, { type: ConfService }, { type: i2.Router }, { type: GoogleAnalyticsService }, { type: LanguageService }, { type: CheckoutService }]; }, propDecorators: { thisImage: [{
                type: ViewChild,
                args: ['thisImage']
            }], productInput: [{
                type: Input
            }], thumbnailWrapper: [{
                type: ViewChild,
                args: ['thumbnailWrapper']
            }] } });

class RequestCache {
}
const maxAge = 30000;
class RequestCacheWithMap {
    constructor() {
        this.cache = new Map();
    }
    get(req) {
        const url = req.urlWithParams;
        const cached = this.cache.get(url);
        if (!cached) {
            return undefined;
        }
        const isExpired = cached.lastRead < (Date.now() - maxAge);
        const expired = isExpired ? 'expired ' : '';
        return isExpired ? undefined : cached.response;
    }
    put(req, response) {
        const url = req.urlWithParams;
        const newEntry = { url, response, lastRead: Date.now() };
        this.cache.set(url, newEntry);
        // remove expired cache entries
        const expired = Date.now() - maxAge;
        this.cache.forEach(entry => {
            if (entry.lastRead < expired) {
                this.cache.delete(entry.url);
            }
        });
    }
}
RequestCacheWithMap.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RequestCacheWithMap, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
RequestCacheWithMap.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RequestCacheWithMap, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RequestCacheWithMap, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class PopupBaseComponent {
    constructor(languageService, confService, renderer) {
        this.languageService = languageService;
        this.confService = confService;
        this.renderer = renderer;
        this.showPopUp = true;
        this.language = {};
        this.popupObject = { title: null, img: null, url: null };
        this.popupObject$ = this.confService.popupObject;
    }
    ngOnInit() {
        this.confService.getConf().subscribe(res => {
            this.mustLoggin = res['mustLogged'];
        });
        const USER_ID = localStorage.getItem('user_id') !== null
            ? localStorage.getItem('user_id')
            : sessionStorage.getItem('user_id');
        this.popupObject$.subscribe(object => {
            this.popupObject = object;
            if (this.popupObject !== null && this.popupObject.img && this.popupObject.title) {
                if (this.mustLoggin == true && USER_ID) {
                    this.windowLocation = window.location.href;
                    this.invokePopup();
                }
                else if (this.mustLoggin == true && USER_ID == null) { }
                else if (this.mustLoggin == false) {
                    this.windowLocation = window.location.href;
                    this.invokePopup();
                }
            }
        });
    }
    invokePopup() {
        const modal = document.querySelector('.modal');
        const overlay = document.querySelector('.overlay');
        const close = document.querySelector('#close');
        close.addEventListener('click', () => {
            this.renderer.removeStyle(document.querySelector('html'), 'overflow');
            this.renderer.setStyle(document.querySelector('html'), 'height', 'auto');
            this.renderer.setStyle(document.querySelector('body'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('body'), 'height', 'auto');
            this.renderer.setStyle(overlay, 'visibility', 'hidden');
            this.renderer.setStyle(overlay, 'opacity', '0');
            this.renderer.setStyle(overlay, 'transform', 'translateY(-1000px)');
        });
        // overlay.addEventListener("click", (e)=>{
        //   this.renderer.removeStyle(document.querySelector('html'), 'overflow');
        //  // this.renderer.removeStyle(document.querySelector('html'), 'pointer-events');
        //   this.renderer.setStyle(overlay, 'visibility', 'hidden');
        //   this.renderer.setStyle(overlay, 'opacity', '0');
        //   this.renderer.setStyle(overlay, 'transform', 'translateY(-100px)');
        // });
        modal.addEventListener('click', (e) => {
            e.stopPropagation();
        });
        setTimeout(() => {
            this.renderer.setStyle(document.querySelector('html'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('html'), 'height', '100%');
            this.renderer.setStyle(document.querySelector('html'), 'margin', '0');
            this.renderer.setStyle(document.querySelector('body'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('body'), 'height', '100%');
            this.renderer.setStyle(document.querySelector('body'), 'margin', '0');
            this.renderer.setStyle(overlay, 'visibility', 'visible');
            this.renderer.setStyle(overlay, 'opacity', '1');
            this.renderer.setStyle(overlay, 'transform', 'translateY(0px)');
            localStorage.setItem('popupStatus', 'lifetime');
            if (this.popupObject.type === 'lifetime') {
                sessionStorage.setItem('popupSeen', 'seen');
                localStorage.setItem('popupObject', JSON.stringify(this.popupObject));
            }
        }, 2000);
    }
    redirectTo(url) {
        url !== 'default' ? window.location.href = url : '';
    }
}
PopupBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PopupBaseComponent, deps: [{ token: LanguageService }, { token: ConfService }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
PopupBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: PopupBaseComponent, selector: "app-base-popup", ngImport: i0, template: "\r\n<div  class=\"overlay\" >\r\n  <div  class=\"modal\">\r\n    <span id=\"close\"><i class=\"fa fa-times\"></i></span>\r\n    <div class=\"title\">\r\n      <h6 *ngIf=\"popupObject && popupObject.title\">{{popupObject.title}}</h6>\r\n\r\n    </div>\r\n  <div (click)=\"redirectTo(popupObject.url ? popupObject.url : 'default')\" [ngStyle]=\"{'cursor': popupObject.url ? 'pointer' : 'default' }\" *ngIf=\"popupObject && popupObject.img\"   class=\"modalContent\" [style.backgroundImage]=\"'url('+ popupObject.img +')'\" >\r\n  \r\n  </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- <div class=\"content\">\r\n  <h1>Other Content</h1>\r\n</div> -->", styles: [".overlay{position:absolute;inset:0;background:rgba(0,0,0,.8);display:flex;justify-content:center;align-items:center;color:#fff;visibility:hidden;opacity:0;transition:all .5s ease;z-index:9999999}.modal{width:700px;max-width:100%;min-height:300px;background:white;color:#666;padding:3.3rem 0 0;display:flex;align-items:center;position:relative;transition:.35s ease;z-index:99999;height:400px;border-radius:15px}.modalContent{width:100%;height:100%;display:flex;align-items:center;flex-wrap:wrap;position:relative;background-repeat:no-repeat;background-size:contain;background-position:center}#close{position:absolute;top:0px;right:0px;padding:5px 10px;background-color:#000;z-index:9999999;color:#fff}.title{position:absolute;top:0px;right:0px;left:0;height:35px;width:100%;text-align:center;margin:auto;background-color:#fff}.title h6{font-size:2rem;line-height:1.5;color:var(--textColor, #000)}#close:hover{cursor:pointer}h1{color:#fff}@media screen and (max-width: 600px){.modalContent{flex-direction:column;align-items:center;justify-content:center}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PopupBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-popup',
                    templateUrl: './popup.base-component.html',
                    styleUrls: ['./popup.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ConfService }, { type: i0.Renderer2 }]; } });

class UserLocationComponent {
    constructor(languageService, confService, renderer, toastr, contactUsService) {
        this.languageService = languageService;
        this.confService = confService;
        this.renderer = renderer;
        this.toastr = toastr;
        this.contactUsService = contactUsService;
        //  @Input()  openPopupModal: boolean;
        this.language = {};
        this.openPopupModal$ = this.confService.openPopupModal;
        this.storeIsMultiLocations = this.confService.storeIsMultiLocations;
        this.showMap = false;
        this.error = '';
        this.icon = {
            path: "M25.148 24.297v19.45h-2v-19.45h2zM24.148 4c5.604 0 10.148 4.544 10.148 10.148s-4.544 10.148-10.148 10.148S14 19.752 14 14.148 18.544 4 24.148 4z",
            fillColor: '#FF0000',
            fillOpacity: .8,
            strokeWeight: 0,
            scale: 1
        };
        this.full_user_address = '';
        this.url = '';
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(language => this.language = language);
        if (this.confService.openPopupModal.getValue() && this.confService.storeIsMultiLocations.getValue()) {
            this.invokePopup();
        }
    }
    invokePopup() {
        const modal = document.querySelector('.modal');
        const overlay = document.querySelector('.overlay');
        const close = document.querySelector('#close');
        modal.addEventListener('click', (e) => {
            e.stopPropagation();
        });
        setTimeout(() => {
            this.renderer.setStyle(document.querySelector('html'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('html'), 'height', '100%');
            this.renderer.setStyle(document.querySelector('html'), 'margin', '0');
            this.renderer.setStyle(document.querySelector('body'), 'overflow', 'hidden');
            this.renderer.setStyle(document.querySelector('body'), 'height', '100%');
            this.renderer.setStyle(document.querySelector('body'), 'margin', '0');
            this.renderer.setStyle(overlay, 'visibility', 'visible');
            this.renderer.setStyle(overlay, 'opacity', '1');
            this.renderer.setStyle(overlay, 'transform', 'translateY(0px)');
            //localStorage.setItem('popupStatus' , 'lifetime');
            this.loadAutoComplete();
        }, 1000);
    }
    ngOnDestroy() {
        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; i++) {
            if (scripts[i].src && scripts[i].src == this.url) {
                document.getElementsByTagName('head')[0].removeChild(scripts[i]);
            }
        }
    }
    closePopup() {
        this.renderer.removeStyle(document.querySelector('html'), 'overflow');
        this.renderer.setStyle(document.querySelector('html'), 'height', 'auto');
        this.renderer.setStyle(document.querySelector('body'), 'overflow', 'hidden');
        this.renderer.setStyle(document.querySelector('body'), 'height', 'auto');
        this.renderer.setStyle(document.querySelector('.overlay'), 'visibility', 'hidden');
        this.renderer.setStyle(document.querySelector('.overlay'), 'opacity', '0');
        this.renderer.setStyle(document.querySelector('.overlay'), 'transform', 'translateY(-1000px)');
        this.openPopupModal$.next(false);
        this.ngOnDestroy();
        location.reload();
    }
    skipPopup() {
        this.renderer.removeStyle(document.querySelector('html'), 'overflow');
        this.renderer.setStyle(document.querySelector('html'), 'height', 'auto');
        this.renderer.setStyle(document.querySelector('body'), 'overflow', 'hidden');
        this.renderer.setStyle(document.querySelector('body'), 'height', 'auto');
        this.renderer.setStyle(document.querySelector('.overlay'), 'visibility', 'hidden');
        this.renderer.setStyle(document.querySelector('.overlay'), 'opacity', '0');
        this.renderer.setStyle(document.querySelector('.overlay'), 'transform', 'translateY(-1000px)');
        const branchId = localStorage.getItem('branchId');
        const branch = JSON.parse(localStorage.getItem('branch'));
        (branch && branch.id && branchId) ? localStorage.setItem('branchStatus', 'skipped-selected') : localStorage.setItem('branchStatus', 'skipped');
        this.ngOnDestroy();
        this.openPopupModal$.next(false);
        // location.reload()
    }
    selectBranch() {
        this.contactUsService.getContactDetailsPostion(this.pos).subscribe({
            next: data => {
                if (data['message']) {
                    this.error = data['message'];
                    return;
                }
                const branchId = localStorage.getItem('branchId');
                const branch = JSON.parse(localStorage.getItem('branch'));
                if (data.branch && data.branch[0] && data.branch[0].id) {
                    this.selectedBranchId = data.branch[0].id.toString();
                    if (branchId && branchId == this.selectedBranchId) {
                        localStorage.setItem('branchId', this.selectedBranchId);
                        localStorage.setItem('street', this.full_user_address);
                        localStorage.setItem('branch', JSON.stringify(data.branch[0]));
                        localStorage.setItem('pos', JSON.stringify(this.pos));
                        this.skipPopup();
                    }
                    else {
                        localStorage.setItem('branchId', this.selectedBranchId);
                        localStorage.setItem('street', this.full_user_address);
                        localStorage.setItem('branch', JSON.stringify(data.branch[0]));
                        localStorage.setItem('pos', JSON.stringify(this.pos));
                        localStorage.removeItem('cartId');
                        localStorage.removeItem('cart-counter');
                        this.confService.branch.next(data.branch[0]);
                        this.closePopup();
                    }
                }
            },
            error: error => {
                if (error.error && error.error['message']) {
                    this.toastr.error(error.error['message'], `${this.language['error']}!`, { enableHtml: true, closeButton: true });
                    //this.error = error.error['message'];
                    return;
                }
            }
        });
    }
    loadAutoComplete() {
        this.storeSubscription = this.confService.store$.subscribe((store) => {
            const mapKey = store.mapsApiKey ? store.mapsApiKey : store.mapsApiKeyDefault;
            const url = `https://maps.googleapis.com/maps/api/js?key=${mapKey}&libraries=places&v=weekly`;
            this.url = url;
            this.loadScript(url).then(() => {
                this.initAutocomplete2();
            });
        });
    }
    loadScript(url) {
        return new Promise((resolve, reject) => {
            const script = this.renderer.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.text = ``;
            script.async = true;
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;
            this.renderer.appendChild(document.getElementsByTagName('head')[0], script);
        });
    }
    initAutocomplete2() {
        this.address1Field = document.querySelector("#ship-address");
        const countryCodes = localStorage.getItem('countryCodes');
        const countryCode = localStorage.getItem('countryCode');
        const componentRestrictions = countryCodes ? { country: JSON.parse(countryCodes) } : countryCode ? { country: countryCode } : { country: 'EG' };
        this.autocomplete = new google.maps.places.Autocomplete(this.address1Field, {
            strictBounds: false,
            componentRestrictions: componentRestrictions,
            types: ["establishment"],
            // fields: ["address_components", "geometry" , "icon", "name"],
            fields: ["formatted_address", "geometry", "name"],
            //types: ["address"],
        });
        //this.address1Field.focus();
        this.autocomplete.addListener("place_changed", () => {
            this.full_user_address = '';
            const place = this.autocomplete.getPlace();
            this.showMap = true;
            this.renderer.setStyle(document.querySelector('#map'), 'display', 'block');
            this.map = new google.maps.Map(document.querySelector('#map'), {
                center: {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                },
                zoom: 18,
            });
            let pos = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.showMap = true;
            this.initMarker(this.icon, pos);
        });
    }
    getAreaAddressString(pos) {
        const google_maps_geocoder = new google.maps.Geocoder();
        google_maps_geocoder.geocode({ 'latLng': pos }, (results, status) => {
            let full_user_address = '';
            for (const component of results[0].address_components) {
                full_user_address += component.short_name;
                full_user_address += ',';
            }
            if (full_user_address.charAt(full_user_address.length - 1) == ',') {
                full_user_address = full_user_address.substr(0, full_user_address.length - 1);
            }
            this.full_user_address = full_user_address;
        });
    }
    initMap() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                this.showMap = true;
                this.address1Field.value = '';
                this.renderer.setStyle(document.querySelector('#map'), 'display', 'block');
                this.map = new google.maps.Map(document.querySelector('#map'), {
                    center: pos,
                    zoom: 18,
                });
                //this.pos = pos;
                this.showMap = true;
                this.initMarker(this.icon, pos);
                let full_user_address = '';
                this.mapEvents(this.map, this.rangeArea, this.marker);
                var google_maps_geocoder = new google.maps.Geocoder();
                google_maps_geocoder.geocode({
                    'latLng': {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }
                }, (results, status) => {
                    full_user_address = '';
                    if (results[0] && results[0].address_components && results[0].address_components.length > 0) {
                        for (const component of results[0].address_components) {
                            // @ts-ignore remove once typings fixed
                            full_user_address += component.short_name;
                            full_user_address += ',';
                        }
                        if (full_user_address.charAt(full_user_address.length - 1) == ',') {
                            full_user_address = full_user_address.substr(0, full_user_address.length - 1);
                        }
                        this.full_user_address = full_user_address;
                    }
                });
            });
        }
    }
    mapEvents(map, rangeArea, marker) {
        google.maps.event.addListener(map, 'click', (event) => {
            //this.addMarker(event.latLng);
            let center = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
            };
            this.setMarker(map, center);
        });
        google.maps.event.addListener(rangeArea, 'click', (event) => {
            let center = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
            };
            this.setMarker(map, center);
            //this.addMarker(event.latLng);
        });
        google.maps.event.addListener(marker, 'dragend', (event) => {
            let center = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
            };
            this.setMarker(map, center);
        });
        google.maps.event.addListener(map, 'dragend', (event) => {
            let center = {
                lat: map.getCenter().lat(),
                lng: map.getCenter().lng(),
            };
            this.setMarker(map, center);
            //this.addMarker(event.latLng);
        });
        google.maps.event.addListener(rangeArea, 'dragend', (event) => {
            let center = {
                lat: map.getCenter().lat(),
                lng: map.getCenter().lng(),
            };
            this.setMarker(map, center);
            //this.addMarker(event.latLng);
        });
    }
    addMarker(location) {
        this.marker.setPosition(location);
    }
    initMarker(icon, pos) {
        this.marker = new google.maps.Marker({
            draggable: true,
            animation: google.maps.Animation.DROP,
            icon: icon
        });
        this.rangeArea = new google.maps.Polygon({
            strokeColor: 'red',
            strokeOpacity: 0.4,
            strokeWeight: 1,
            fillColor: 'red',
            fillOpacity: 0.35,
            clickable: true
        });
        this.setMarker(this.map, pos ? pos : this.map.getCenter());
        this.mapEvents(this.map, this.rangeArea, this.marker);
    }
    setMarker(map, pos) {
        this.error = '';
        this.getAreaAddressString(pos);
        this.marker.setMap(map);
        this.rangeArea.setMap(map);
        this.map.setCenter(pos);
        this.marker.setPosition(pos);
        this.pos = pos;
    }
}
UserLocationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: UserLocationComponent, deps: [{ token: LanguageService }, { token: ConfService }, { token: i0.Renderer2 }, { token: i3$1.ToastrService }, { token: ContactUsService }], target: i0.ɵɵFactoryTarget.Component });
UserLocationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: UserLocationComponent, selector: "app-base-user-location", ngImport: i0, template: "<div class=\"overlay\">\r\n  <div class=\"modal\">\r\n    <div class=\"modalContent\">\r\n\r\n      <form style=\"background-color: #fff;\" id=\"address-form\" action=\"\" method=\"get\" autocomplete=\"off\">\r\n        <p (click)=\"skipPopup()\" id=\"close\" class=\"skip\">{{language['skip'] || 'skip'}} >></p>\r\n        <p class=\"title\"> {{language['showAvailableProductsTitle'] || 'To show you correct available products near you,\r\n          please enter your address'}}</p>\r\n        <label style=\"position: relative; width: 100%;\" class=\"full-field\">\r\n          <svg style=\" position: absolute;top:18px\" xmlns=\"http://www.w3.org/2000/svg\" width=\"27\" height=\"27\"\r\n            viewBox=\"0 0 27 27\">\r\n            <path fill=\"#262626\" fill-rule=\"evenodd\"\r\n              d=\"M5.916 4.384c3.168-3.179 8.305-3.179 11.472 0l.236.243c2.972 3.191 2.908 8.197-.194 11.31l-5.778 5.799-5.777-5.799C2.708 12.758 2.708 7.604 5.87 4.43zm10.764.706c-2.777-2.787-7.278-2.787-10.052-.003l-.23.238c-2.591 2.8-2.53 7.18.185 9.906l5.069 5.087 5.07-5.087c2.715-2.725 2.777-7.106.186-9.906zm-5.028 2.548c1.385 0 2.507 1.126 2.507 2.514s-1.122 2.514-2.507 2.514c-1.384 0-2.506-1.126-2.506-2.514 0-1.387 1.122-2.514 2.506-2.514zm0 1c-.83 0-1.506.678-1.506 1.514s.675 1.514 1.506 1.514c.832 0 1.507-.677 1.507-1.514 0-.836-.675-1.514-1.507-1.514z\" />\r\n          </svg>\r\n          <input id=\"ship-address\" name=\"ship-address\" required autocomplete=\"off\"\r\n            [placeholder]=\"language['enterLocation']\" />\r\n          <svg (click)=\"initMap()\" class=\"initMapBtn\" style=\"  cursor: pointer; position: absolute;\"\r\n            xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\r\n            <path class=\"icon\" fill-opacity=\".7\" fill-rule=\"evenodd\"\r\n              d=\"M8 13.09A5.06 5.06 0 0 1 2.909 8 5.06 5.06 0 0 1 8 2.91 5.06 5.06 0 0 1 13.09 8 5.06 5.06 0 0 1 8 13.09zm6.473-5.817c-.364-3.055-2.764-5.455-5.745-5.745V0H7.273v1.528a6.363 6.363 0 0 0-5.746 5.745H0v1.454h1.527c.364 3.055 2.764 5.455 5.746 5.746V16h1.455v-1.527c3.054-.364 5.454-2.764 5.745-5.746H16V7.273h-1.527zM8 5.091c-1.6 0-2.909 1.31-2.909 2.91S6.401 10.908 8 10.908c1.6 0 2.909-1.309 2.909-2.909C10.909 6.4 9.6 5.091 8 5.091z\" />\r\n          </svg>\r\n        </label>\r\n\r\n        <div id=\"map\"></div>\r\n        <div *ngIf=\"showMap\" class=\"modal-footer\">\r\n          <div>\r\n            <div class=\"p-x-md deliever-address\">\r\n              <p>\r\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 48 48\">\r\n                  <path class=\"color-default\" fill-rule=\"evenodd\"\r\n                    d=\"M25.148 24.297v19.45h-2v-19.45h2zM24.148 4c5.604 0 10.148 4.544 10.148 10.148s-4.544 10.148-10.148 10.148S14 19.752 14 14.148 18.544 4 24.148 4z\" />\r\n                </svg>\r\n\r\n                <span class=\"text-75\">{{language['deliverTo'] || 'Deliver to :'}}&nbsp;</span>\r\n                <span>{{full_user_address}}</span>\r\n              </p>\r\n\r\n            </div>\r\n          </div>\r\n          <div style=\"display: block; width: 100%;\" class=\"row\">\r\n            <button [disabled]=\"error && error.length > 0\" (click)=\"selectBranch()\"\r\n              style=\"border-radius: 10px; height: 55px;font-weight: bold;color: #fff;\"\r\n              class=\"btn   form-control color-main\">\r\n              <span *ngIf=\"!error || (error && error == '')\">{{language['deliverToLocation'] || 'Deliver to this\r\n                location'}}</span>\r\n              <span *ngIf=\"error && error.length > 0\">{{error}}</span>\r\n            </button>\r\n          </div>\r\n        </div>\r\n\r\n\r\n\r\n      </form>\r\n\r\n    </div>\r\n  </div>\r\n</div>", styles: [".overlay{position:absolute;inset:0;background:rgba(0,0,0,.8);display:flex;justify-content:center;align-items:center;color:#fff;visibility:hidden;opacity:0;transition:all .5s ease;z-index:90}.modal{width:750px;max-width:100%;color:#666;display:flex;align-items:center;position:relative;transition:.35s ease;z-index:99999}.modalContent{width:100%;display:flex;align-items:center;flex-wrap:wrap;position:relative;background-repeat:no-repeat;background-size:contain;background-position:center}#close{position:absolute;z-index:9999999}.pac-container,.pac-container .pac-item{text-align:right!important}.title h6{font-size:2rem;line-height:1.5;color:var(--textColor, #000)}#close:hover{cursor:pointer}h1{color:#fff}.pac-container .pac-item{text-align:right!important;font-size:14px!important}[dir=ltr] .pac-container .pac-item{text-align:left!important}[dir=rtl] .pac-item{text-align:right!important}@media screen and (max-width: 600px){form{padding:20px 5px!important}#map{height:600px!important}.modalContent{flex-direction:column;align-items:center;justify-content:center}}:host .skip{position:absolute;top:10px;right:10px;left:unset;cursor:pointer}[dir=rtl] :host .skip{right:unset!important;left:10px!important}:host .initMapBtn{top:20px;left:unset;right:0px}[dir=rtl] :host .initMapBtn{right:unset!important;left:10px!important}:host .branch-selector-modal{text-align:center;width:700px;max-width:700px!important;justify-content:center;align-items:center}:host .popup{background-color:#fff;border-radius:8px;position:relative;text-align:center;margin:auto;min-height:450px;box-shadow:#00000073 0 2px 10px}:host .popup .header{padding:20px 10px 24px}:host .popup .header .top{display:block;height:45px;margin:5px auto 8px;width:45px}:host .popup .header .title{margin:0 22px 18px}:host .popup .header .title h3{color:#000;font-size:36px;font-weight:600;-webkit-font-smoothing:antialiased;letter-spacing:-1.2px}:host .popup-body{position:relative;flex:1 1 auto;padding:2rem;margin-top:20px}:host .popup-body .branch-selector{text-align:left;width:100%;display:flex;justify-content:center;margin-bottom:20px;flex-direction:column;align-items:center}:host .popup-body .save-btn{width:75%;min-height:36px;color:#fff;background:var(--main-color, #000);border:none;border-radius:4px}:host .popup-body .save-btn:disabled{cursor:not-allowed;color:#999;background:#f0f0f0}::ng-deep .pac-container{background-color:#fff;position:absolute!important;z-index:1000;border-radius:2px;border-top:1px solid #d9d9d9;font-family:Arial,sans-serif;box-shadow:0 2px 6px #0000004d;box-sizing:border-box;overflow:hidden}::ng-deep .pac-logo:after{content:\"\";padding:1px 1px 1px 0;height:16px;text-align:right;display:block;background-image:url(https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png);background-position:right;background-repeat:no-repeat;background-size:120px 14px}::ng-deep .pac-item{cursor:default;padding:0 4px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;line-height:30px;text-align:right!important;border-top:1px solid #e6e6e6;font-size:16px}[dir=ltr] ::ng-deep .pac-item{text-align:left!important}::ng-deep [dir=ltr] .pac-item{text-align:left!important}::ng-deep .form-control:disabled{background-color:var(--main-color, #000)!important;opacity:.5666!important}::ng-deep .form-control:focus{background-color:var(--main-color, #000)!important;border:none!important}::ng-deep .whatsApp_link{z-index:90!important}::ng-deep header{z-index:7!important}::ng-deep .modal-dialog{width:700px!important;margin:5rem auto}@media (min-width: 576px){::ng-deep .modal-dialog{width:700px!important;max-width:700px!important;margin:5rem auto}}::ng-deep .modal-open{z-index:1000000}::ng-deep .modal-content{background-color:transparent}::ng-deep .modal-content app-user-geofence{text-align:center;margin:auto;width:100%}form{display:block;text-align:center;flex-wrap:wrap;align-items:center;width:100%;padding:40px 60px;border-radius:10px;min-height:-moz-fit-content;min-height:fit-content;max-height:100vh;overflow-y:auto}input{width:100%;height:40px;margin-top:0;padding:.5em 40px;border:0;font-family:\"Roboto\",sans-serif;font-size:20px}input:focus{border-bottom:2px solid #000}input[type=reset]{width:auto;height:auto;border-bottom:0;background-color:transparent;color:#686868;font-size:14px}.title{padding-top:10px;width:100%;margin-block-end:0;font-weight:500}.note{width:100%;margin-block-start:0;font-size:12px}.form-label{width:100%;padding:.5em}.full-field{display:block;position:relative;width:100%;padding:10px 5px;border:1px solid #eee;border-radius:3px}.slim-field-left{flex:1 150px;margin:15px 15px 15px 0}.slim-field-right{flex:1 150px;margin:15px 0 15px 15px}.my-button{background-color:#000;border-radius:6px;color:#fff;margin:10px;padding:6px 24px;text-decoration:none}.my-button:hover{background-color:#666}.my-button:active{position:relative;top:1px}#map{width:100%!important;height:400PX;display:none}svg .icon{fill:var(--main-color, #666);width:28px;height:28px}.deliever-address{text-align:left!important}[dir=rtl] .deliever-address{text-align:right!important}.dir-right{text-align:right!important}.color-default{fill:var(--main-color, #000)}.color-main{background-color:var(--main-color, #000)}.modal-footer{width:100%;justify-content:unset}\n"], directives: [{ type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: UserLocationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-user-location',
                    templateUrl: './user-location.component.html',
                    styleUrls: ['./user-location.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ConfService }, { type: i0.Renderer2 }, { type: i3$1.ToastrService }, { type: ContactUsService }]; } });

class MiniCartBaseComponent {
    constructor(languageService, cartService, router) {
        this.languageService = languageService;
        this.cartService = cartService;
        this.router = router;
        this.cartCounter$ = this.cartService.getCartCounter();
        this.cartItems$ = this.cartService.cartItems;
        this.language = {};
        this.currencyCode = localStorage.getItem('currentCurrency');
    }
    ngOnInit() {
        this.cartCounter$ = this.cartService.getCartCounter();
        this.cartItems$ = this.cartService.cartItems;
        this.languageService.getLanguage().subscribe(language => {
            this.language = language;
        });
    }
    removeItem(item) {
        this.cartService.removeItem(item);
    }
    goToCollection(e) {
        e.stopPropagation();
        this.router.navigate([`/`, this.language['LANGUAGE_CODE'], 'collection']);
    }
    canOpenCheckout(e) {
        e.stopPropagation();
        this.router.navigate([`/`, this.language['LANGUAGE_CODE'], 'cart']);
    }
}
MiniCartBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MiniCartBaseComponent, deps: [{ token: LanguageService }, { token: CartService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
MiniCartBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: MiniCartBaseComponent, selector: "app-base-mini-cart", ngImport: i0, template: "\r\n\r\n  <div  class=\"cart-item-wrapper\" *ngIf=\"(cartCounter$ | async) > 0 ; else showmessage\">\r\n    <div class=\"single-cart-item d-flex\" *ngFor=\"let item of cartItems$  | async ; let i = index\">\r\n      <div class=\"cart-img\">\r\n        <a\r\n          [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', item.variant.product | translate: 'slug']\">\r\n          <div class=\"cart-item-img\" appImage=\"\" [product]=\"item.variant.product\"></div>\r\n        </a>\r\n      </div>\r\n      <div class=\"cart-text-btn\" *ngIf=\"!item['type']\">\r\n        <div class=\"cart-text\">\r\n          <h5>\r\n            <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'product', item.variant.product | translate: 'slug']\"\r\n              title=\"{{item.variant.product | translate: 'name'}}\">{{ item.variant.product | translate:\r\n              'name' }}\r\n            </a>\r\n          </h5>\r\n          <span class=\"cart-qty\">{{language['quantity']}}: {{item.quantity}}</span>\r\n          <span class=\"cart-price\">{{language['price']}}: {{item.unitsTotal / 100 | number}}\r\n            {{currencyCode}}</span>\r\n        </div>\r\n        <button type=\"button\" (click)=\"removeItem(item)\"><i class=\"fa fa-close\"></i></button>\r\n      </div>\r\n      <div class=\"cart-text-btn\" *ngIf=\"item['type']\">\r\n        <div class=\"cart-text\">\r\n          <h5>\r\n            <a [routerLink]=\"['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', item.variant.product | translate: 'slug']\"\r\n              title=\"{{item.variant.product | translate: 'name'}}\">{{ item.variant.product | translate:\r\n              'name' }}\r\n            </a>\r\n          </h5>\r\n          <span class=\"cart-qty\">{{language['quantity']}}: {{item.quantity}}</span>\r\n          <span class=\"cart-price\">{{language['price']}}: {{item.unitsTotal / 100 | number}}\r\n            {{currencyCode}}</span>\r\n        </div>\r\n        <button type=\"button\" (click)=\"removeItem(item)\"><i class=\"fa fa-close\"></i></button>\r\n      </div>\r\n    </div>\r\n  \r\n    <!-- <div class=\"cart-price-total d-flex justify-content-between\">\r\n        <span>Total:</span>\r\n        <span> {{ cart.total / 100 | number }} {{language['currencyCode']}}</span>\r\n      </div> -->\r\n    <div class=\"cart-links\">\r\n      <a href=\"javascript:void(0)\" (click)=\"goToCollection($event)\">{{language['continueShopping']}}</a>\r\n      <a href=\"javascript:void(0)\" (click)=\"canOpenCheckout($event)\">{{language['proceedToCheckout']}}</a>\r\n    </div>\r\n  </div>\r\n  \r\n\r\n\r\n<ng-template #showmessage>\r\n  <div class=\"cart-item-wrapper\">\r\n    <div class=\"cart-links\">\r\n      <span class=\"help-text\">{{language['emptyCart']}}</span>\r\n      <br>\r\n      <a class=\"custom-btn\" href=\"javascript:void(0)\" (click)=\"goToCollection($event)\">{{language['continueShopping']}}</a>\r\n    </div>\r\n  </div>\r\n</ng-template>", styles: [""], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: ImageDirective, selector: "[appImage]", inputs: ["product", "hover"] }], pipes: { "async": i6.AsyncPipe, "translate": TranslatePipe, "number": i6.DecimalPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MiniCartBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-mini-cart',
                    templateUrl: './mini-cart.base-component.html',
                    styleUrls: ['./mini-cart.base-component.scss']
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CartService }, { type: i2.Router }]; } });

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let VerifyPhoneBaseComponent = class VerifyPhoneBaseComponent {
    // selectedCar:any = this.countries[0];
    constructor(formBuilder, loginService, languageService, confService, router, route, personalInfoService, toastr, checkoutService, renderer) {
        this.formBuilder = formBuilder;
        this.loginService = loginService;
        this.languageService = languageService;
        this.confService = confService;
        this.router = router;
        this.route = route;
        this.personalInfoService = personalInfoService;
        this.toastr = toastr;
        this.checkoutService = checkoutService;
        this.renderer = renderer;
        this.errors = [];
        this.language = {};
        this.pattern = /^[a-zA-Z\u0600-\u06FF]+$/;
        this.patternVerify = /[^0-9]/;
        this.email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        this.logged = this.loginService.logged.getValue();
        this.accountVerified = false;
        this.verifyOTPSettings = {
            length: 4,
            code: '----',
        };
        this.verifyMobileRequired$ = this.confService.verifyMobileRequired;
        this.accessOTP = false;
        router.events
            .subscribe((event) => {
            this.handlePageStyles(false);
            if (event.navigationTrigger === 'popstate') {
                return;
            }
        });
        this.data = this.router.getCurrentNavigation().extras.state;
        this.accessOTP = (this.data && this.data.data && this.data.info && this.data.info.from && this.data.info.to && (this.data.info.from == 'sign-up' || this.data.info.from == 'dashboard')) ? true : false;
        if (this.accessOTP == false) {
            this.router.navigate(['/']);
            return;
        }
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    }
    unloadHandler(event) {
        event.returnValue = false;
    }
    handleKeyboardEvents(event) {
        this.key = event.key;
        if ((event.which || event.keyCode) == 116 || (event.which || event.keyCode) == 82) {
            event.preventDefault();
        }
    }
    handlePageStyles(show) {
        if (show == false) {
            this.renderer.removeStyle(document.querySelector('html'), 'overflow');
            this.renderer.removeStyle(document.querySelector('header'), 'display');
            this.renderer.removeStyle(document.querySelector('footer'), 'display');
        }
        if (show == true) {
            this.renderer.setStyle(document.querySelector('header'), 'display', 'none');
            this.renderer.setStyle(document.querySelector('footer'), 'display', 'none');
            this.renderer.setStyle(document.querySelector('html'), 'overflow', 'hidden');
        }
    }
    ngOnInit() {
        this.handlePageStyles(true);
        this.timerFunI();
        this.confService.storeId.subscribe((id) => {
            this.storeId = id;
        });
        this.phoneNumberRequired = JSON.parse(localStorage.getItem('loginByMobile'));
        this.confService.getConf().subscribe(res => {
            this.mustLoggin = res['mustLogged'];
        });
        this.store$ = this.confService.store$;
        this.currentLang = this.languageService.lastLocale;
        this.languageService.localeChange.subscribe(() => {
            this.currentLang = this.languageService.lastLocale;
        });
        this.logo$ = this.confService.logo$;
        this.languageService.getLanguage().subscribe((language) => {
            this.language = language;
        });
        this.verifyMobileRequired$.subscribe(verifyMobileRequired => {
            this.verifyMobileRequired = verifyMobileRequired;
            this.dataComeToVerify = (this.data && this.data != null && this.data.data && this.data.data != null && this.verifyMobileRequired == true) ? true : false;
            this.statusComeToVerify = (this.data && this.data != null && this.data.data && this.data.data != null && this.verifyMobileRequired == true && this.data.info && this.data.info != null && this.data.info.status && this.data.info.status == 'verified') ? true : false;
            this.timerFunI();
        });
    }
    timerFunI() {
        let timeleft = 29;
        const animationTime = 29;
        const countdownNumber = document.getElementById('countdown-number');
        const circle = document.querySelector('circle');
        const close = document.querySelector('#resendClick');
        close.setAttribute('style', 'pointer-events:none;');
        const downloadTimer = setInterval(function () {
            circle.setAttribute('style', 'animation : countdown ' + animationTime + 's linear infinite forwards;');
            // renderer.setStyle(close, 'pointer-events', 'none');
            if (timeleft <= 0) {
                close.setAttribute('style', 'pointer-events:auto;');
                clearInterval(downloadTimer);
                circle.setAttribute('style', 'animation : initial;');
                // document.getElementById("countdown").innerHTML = "Finished";
                countdownNumber.textContent = '0';
            }
            else {
                countdownNumber.textContent = timeleft.toString();
                // document.getElementById("countdown").innerHTML = timeleft + " seconds remaining";
            }
            timeleft -= 1;
        }, 1000);
    }
    resendCode() {
        this.errors = [];
        const newData = (this.data && this.data.data) ? this.data.data : null;
        const method = (this.data && this.data.info && (this.data.info.from == 'sign-up' || this.data.info.from == 'dashboard')) ? this.data.info.from : null;
        let phoneNumber = null;
        let customerId = null;
        // if(newData != null){
        // }
        if (method == 'dashboard') {
            customerId = localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : sessionStorage.getItem('customer_id');
        }
        if (newData != null) {
            phoneNumber = newData.phoneNumber;
            this.loginService.getphoneNumberOTP(phoneNumber, customerId).subscribe({
                next: data => {
                    if (data && data.success && data.success == 'sms_sent') {
                        this.timerFunI();
                        return;
                    }
                    if (data && data.success && data.success == 'already_verified') {
                        if (method == 'sign-up') {
                            this.signUp(data);
                            return;
                        }
                        if (method == 'dashboard') {
                            this.editUser(data);
                            return;
                        }
                    }
                    (!data.success && data.message) ? this.errors.push(data.message) : '';
                },
                error: error => {
                    (error && error.error && error.error.message) ? this.errors.push(error.error.message) : '';
                }
            });
        }
    }
    setCharAt(str, index, chr, length) {
        if (index > length - 1) {
            return str;
        }
        return str.substring(0, index) + (chr == '' ? '-' : chr) + str.substring(index + 1);
    }
    tabChange(x, n) {
        const postion = n - 1;
        const nextPostion = postion + 1;
        const ele = document.querySelectorAll('.otp');
        this.verifyOTPSettings.code = this.setCharAt(this.verifyOTPSettings.code, postion, ele[postion].value, this.verifyOTPSettings.length);
        if (ele[postion].value != '' && nextPostion <= ele.length - 1) {
            if (postion < 0) {
                return;
            }
            ele[nextPostion].focus();
        }
        if (!this.verifyOTPSettings.code.includes('-')) {
            if (this.data && this.data.info && this.data.info.code && this.data.info.code == this.verifyOTPSettings.code) {
            }
            if (this.data && this.data.info && this.data.info.code && this.data.info.code != this.verifyOTPSettings.code) {
            }
        }
    }
    numberOnly(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        return charCode > 31 && (charCode < 48 || charCode > 57) ? false : true;
    }
    verifyOTP() {
        this.errors = [];
        if ((this.verifyMobileRequired == true && this.statusComeToVerify == false)) {
            let customerId = null;
            if (this.data && this.data.data && this.data.info && this.data.info.from == 'verify-phone') {
                customerId = localStorage.getItem('customer_id') ? localStorage.getItem('customer_id') : sessionStorage.getItem('customer_id');
            }
            this.loginService.sendPhoneNumberOTP(this.data.data.phoneNumber, this.verifyOTPSettings.code, customerId).subscribe({
                next: data => {
                    if (data && data.success && data.success == 'otp_verified' && this.data && this.data.info && this.data.info.from && (this.data.info.from == 'sign-up' || this.data.info.to == 'sign-up')) {
                        this.data['info'] = { to: 'sign-up', from: 'verify-phone', 'status': 'verified', 'phoneNumber': this.data.data.phoneNumber };
                        this.signUp(this.data.data);
                        return;
                    }
                    if (data && data.success && data.success == 'already_verified' && this.data && this.data.info && this.data.info.from && (this.data.info.from == 'sign-up' || this.data.info.to == 'sign-up')) {
                        this.data['info'] = { to: 'sign-up', from: 'verify-phone', 'status': 'verified', 'phoneNumber': this.data.data.phoneNumber };
                        const navigationExtras = {
                            state: this.data
                        };
                        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'accounts', 'sign-up'], navigationExtras);
                        this.handlePageStyles(true);
                        return;
                    }
                    if (data && data.success && data.success == 'otp_verified' && this.data && this.data.info && this.data.info.from && (this.data.info.from == 'dashboard' || this.data.info.to == 'dashboard')) {
                        this.data['info'] = { to: 'dashboard', from: 'verify-phone', 'status': 'verified', 'phoneNumber': this.data.data.phoneNumber };
                        this.editUser(this.data.data);
                        return;
                    }
                    if (data && data.success && data.success == 'already_verified' && this.data && this.data.info && this.data.info.from && (this.data.info.from == 'dashboard' || this.data.info.to == 'dashboard')) {
                        this.data['info'] = { to: 'dashboard', from: 'verify-phone', 'status': 'verified', 'phoneNumber': this.data.data.phoneNumber };
                        this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'profile', 'dashboard']);
                        this.handlePageStyles(true);
                        return;
                    }
                    (!data.success && data.message) ? this.errors.push(data.message) : '';
                },
                error: error => {
                    (error && error.error && error.error.message) ? this.errors.push(error.error.message) : '';
                }
            });
        }
    }
    signUp(newCustomer) {
        this.errors = [];
        if (!newCustomer.firstName ||
            !newCustomer.lastName ||
            !newCustomer.email ||
            !newCustomer.user.plainPassword) {
            // this.errors.push('Please complete your data');
        }
        else {
            this.loginService.signUp(newCustomer).subscribe(() => { }, (httpError) => {
                this.data['errors'] = [];
                if (httpError.status === 401) {
                    this.toastr.info('Thank you for your registration, please wait while the admin approves your account to have an access to your profile.', 'Note');
                    if (this.mustLoggin && !this.logged) {
                        this.router.navigate(['/accounts/login'], { replaceUrl: true, skipLocationChange: true });
                        this.handlePageStyles(false);
                    }
                    else {
                        this.router.navigateByUrl(`/${localStorage.getItem('language')}`);
                        this.handlePageStyles(false);
                    }
                }
                else if (httpError.error.errors.children) {
                    const keys = Object.keys(httpError.error.errors.children);
                    for (const key of keys) {
                        const error = httpError.error.errors.children[key];
                        if (error.errors !== undefined && error.errors.length > 0) {
                            for (const e of error.errors) {
                                // this.errors.push(e);
                                this.data['errors'].push(e);
                            }
                        }
                    }
                    const navigationExtras = {
                        state: this.data
                    };
                    this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'accounts', 'sign-up'], navigationExtras);
                    this.handlePageStyles(false);
                }
                else if (httpError.error.errors) {
                    this.data['errors'].push(httpError.error.errors);
                    const navigationExtras = {
                        state: this.data
                    };
                    this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'accounts', 'sign-up'], navigationExtras);
                    this.handlePageStyles(false);
                }
            });
        }
    }
    editUser(body) {
        this.personalInfoService.updateUserInfo(body).subscribe(() => {
            this.toastr.success(this.language['userDataUpdatedSuccessfully']);
            // Hit local storage to update user cahched data
            localStorage.setItem('user_firstName', body['firstName']);
            localStorage.setItem('user_image', body['image']);
            localStorage.setItem('user_lastName', body['lastName']);
            localStorage.setItem('user_email', body['email']);
            this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'profile', 'dashboard']);
            this.handlePageStyles(false);
        }, err => {
            this.data['errors'].push(err['error'] ? err['error']['message'] : this.language['sorrySomethingWentWrong']);
            const navigationExtras = {
                state: this.data
            };
            this.router.navigate(['/', this.language['LANGUAGE_CODE'], 'accounts', 'sign-up'], navigationExtras);
            this.handlePageStyles(false);
        });
    }
};
VerifyPhoneBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VerifyPhoneBaseComponent, deps: [{ token: i1$1.FormBuilder }, { token: LoginService }, { token: LanguageService }, { token: ConfService }, { token: i2.Router }, { token: i2.ActivatedRoute }, { token: PersonalInfoService }, { token: i3$1.ToastrService }, { token: CheckoutService }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
VerifyPhoneBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: VerifyPhoneBaseComponent, selector: "app-base-verify-phone", host: { listeners: { "window:beforeunload": "unloadHandler($event)" } }, ngImport: i0, template: "<div class=\"page-container\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row no-gutters\">\r\n      <!--Store logo-->\r\n      <div class=\"col-lg-6 col-md-5\">\r\n        <div class=\"image-container\" *ngIf=\"store$ | async as store\">\r\n          <img *ngIf=\"logo$ as logo\" [lazyLoad]=\"logo |async\" alt=\"{{ store.name }}\" [errorImage]=\"defaultImage\" />\r\n        </div>\r\n      </div>\r\n      <!-- Verify  Form -->\r\n      <div class=\"col-lg-6 col-md-7 align-self-center py-0 px-5\">\r\n        <div class=\"accounts-form pt-3 pb-0\">\r\n          <div class=\"accounts-form-head d-flex align-items-center justify-content-between\">\r\n            <ng-container *ngIf=\"store$ | async as store\">\r\n              <a *ngIf=\"!store['mustLogged']\" routerLink=\"/{{language['LANGUAGE_CODE']}}\"\r\n                class=\"backToWebsite align-items-center\">\r\n                <i [ngClass]=\"language['DIR'] === 'rtl'? 'fa fa-angle-right ml-2' : 'fa fa-angle-left mr-2'\"></i>\r\n                {{language['backToWebsite']}}\r\n              </a>\r\n            </ng-container>\r\n          </div>\r\n          <!--  Start Verify if exist -->\r\n          <div class=\"sign-up-accounts-form-content pt-5\">\r\n            <!-- Form -->\r\n            <div class=\"form-container\">\r\n              <h3 class=\"account-title h3--custom\">{{language['verifyAccount'] || 'Verify Phone'}}</h3>\r\n              \r\n              <div class=\"container-fluid\">\r\n               \r\n                <div class=\"row justify-content-md-center\">\r\n                    <div class=\"col-md-12 text-center\">\r\n                      <div class=\"row\">\r\n                        <div class=\"col-sm-12 mt-5  bgWhite\">\r\n                          <div class=\"title mb-5\">\r\n                            {{language['phoneNumberVerification'] || 'Phone Number Verification'}}\r\n                          </div>\r\n                          <div>\r\n                            <span style=\"color: #000; \"> {{language['plzEnterSMSCode'] || 'Please Enter the SMS code sent to'}} </span>\r\n\r\n                          </div>\r\n                          <div>\r\n                            <span style=\"color: #000; font-weight: 600;\"> {{(data&&data.info&&data.info &&data.info.phoneNumber)?data.info.phoneNumber: '' }} </span>\r\n\r\n                          </div>\r\n                          \r\n                          <div class=\"text-center mt-3\">\r\n                           <!-- <span style=\"color: #959292;\"> Enter Code Here</span> -->\r\n\r\n                          </div>\r\n                          <form style=\"direction: ltr !important;\"  action=\"\" class=\"mt-2 mb-4 verify-form\">\r\n                            <input (keypress)=\"numberOnly($event)\" placeholder=\"-\" pattern=\"[0-9]{1}\" class=\"otp\" type=\"text\"  (keyup)='tabChange( $event,1)' maxlength=1 >\r\n                            <input (keypress)=\"numberOnly($event)\" placeholder=\"-\" pattern=\"[0-9]{1}\" class=\"otp\" type=\"text\"  (keyup)='tabChange( $event,2)' maxlength=1 >\r\n                            <input (keypress)=\"numberOnly($event)\" placeholder=\"-\" pattern=\"[0-9]{1}\" class=\"otp\" type=\"text\"  (keyup)='tabChange( $event,3)' maxlength=1 >\r\n                            <input (keypress)=\"numberOnly($event)\" placeholder=\"-\" pattern=\"[0-9]{1}\" class=\"otp\" type=\"text\"  (keyup)='tabChange( $event,4)' maxlength=1 >\r\n                          </form>\r\n                          \r\n\r\n                          <div id=\"countdownCircle\">\r\n                            <div id=\"countdown-number\"></div>\r\n                            <svg>\r\n                              <circle r=\"18\" cx=\"20\" cy=\"20\"></circle>\r\n                            </svg>\r\n                          </div>\r\n                          \r\n                          <!-- <div id=\"countdown\"></div> -->\r\n                          <a name=\"an\" id=\"resendClick\"  (click) = \"resendCode()\" style=\"text-decoration: underline; font-size: small;\" > {{language['resendOTPCode'] || 'Resend Code' }}  </a>\r\n                          <!-- <div  class=\"not-member ng-star-inserted\"><p>Didn't Receive Code yet ? <a   (click)=\"(expireTimer != '2' )? $event.stopPropagation() : resendCode()\"  class=\"btn-link\"  >Resend Code</a></p></div> -->\r\n                          <hr class=\"mt-4\">\r\n\r\n                \r\n                          <button (click) = \"verifyOTP()\" type=\"button\" class=\"main-btn my-4 w-75\" [disabled]=\"verifyOTPSettings.code.includes('-')\">\r\n                            {{language['verifyOTP'] || 'Verify' }}\r\n                          </button>\r\n                         \r\n                              <div class=\"row errors my-4 justify-content-center\">\r\n                                <p *ngFor=\"let error of errors\" class=\"alert alert-danger mx-2\">\r\n                                  {{error}}\r\n                                </p>\r\n                              </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                </div>\r\n              </div>\r\n\r\n\r\n\r\n\r\n            </div>\r\n          </div>\r\n          \r\n         \r\n        <!--  Start Verify if exist -->\r\n        </div>\r\n      </div>\r\n      \r\n    </div>\r\n  </div>\r\n  \r\n \r\n</div>\r\n\r\n", styles: ["@charset \"UTF-8\";:host .page-container .container-fluid{padding:0}:host .page-container .container-fluid>.row{min-height:100vh}:host .page-container .account-title{color:var(--h3-color, #000);font-size:var(--h3-font-size, 28px);text-transform:capitalize;font-weight:600;margin-bottom:10px}:host .page-container .image-container{background:#0d0d0d;min-height:100%;display:flex;align-items:center;justify-content:center;padding:20px}:host .page-container .image-container img{max-width:300px}:host .page-container .accounts-form{padding:10px}:host .page-container .accounts-form .accounts-form-head .backToWebsite{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 16px)}:host .page-container .accounts-form .accounts-form-content{position:absolute;width:400px;transform:translate(-50%,-50%);top:50%;left:50%}@media all and (max-width: 767.98px){:host .page-container .accounts-form .accounts-form-content{position:static;transform:none;width:auto;max-width:400px;margin:30px auto 0}}:host .page-container .accounts-form .form-container .form-control{border-radius:0}:host .page-container .accounts-form .form-container .forget-password{color:var(--body-link-color, #007bff);font-size:var(--body-font-size, 1.4rem)}:host .page-container .with-cursor{cursor:pointer}:host .custom-checkbox{position:relative}:host .custom-checkbox input[type=checkbox]{width:0;height:0;opacity:0;position:absolute}:host .custom-checkbox input[type=checkbox]~.label{position:relative;padding-left:25px;text-transform:capitalize;cursor:pointer}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label{padding-left:0;padding-right:25px}:host .custom-checkbox input[type=checkbox]~.label:after{position:absolute;content:\"\";top:4px;left:0;font-family:\"fontAwesome\";width:17px;height:17px;line-height:14px;text-align:center;border-radius:2px;border:2px solid #d3cac5;color:#000;font-size:14px}[dir=rtl] :host .custom-checkbox input[type=checkbox]~.label:after{left:auto;right:0}:host .custom-checkbox input[type=checkbox]:checked~.label:after{content:\"\\f00c\";border-color:var(--main-color, var(--main-color, orange));background-color:var(--main-color, var(--main-color, orange))}:host .custom-checkbox input[type=checkbox]:focus~.label:after{border-color:var(--main-color, var(--main-color, orange))}:host .social-btns{margin-bottom:10px}:host .main-btn{background:transparent;border:1px solid var(--main-color, orange);color:#444;font-weight:600;transition:all .4s ease;min-width:100px;padding:5px 0;margin:0 auto;text-align:center;display:block}:host .main-btn:enabled:hover{background:var(--main-color, orange);color:#fff!important;cursor:pointer}:host .main-btn:disabled{cursor:not-allowed;background:#999;color:#fff;border-color:#999}:host .or-section hr{width:40%;border-top:1px solid #ced4da}:host hr{border-top:1px solid #ced4da}:host button.social{background:transparent;border:2px solid;border-radius:0;width:110px;height:35px;display:flex;align-items:center;justify-content:center}:host button.social.facebook{border-color:#29487d;transition:all .4s ease;cursor:pointer}:host button.social.facebook i{color:#29487d;margin:0 5px}:host button.social.google{border-color:#dd5347;transition:all .4s ease;cursor:pointer}:host button.social.google i{color:#dd5347;margin:0 5px}:host button.social.facebook:hover{background:#29487d;color:#fff}:host button.social.facebook:hover i{color:#fff}:host button.social.google:hover{background:#dd5347;color:#fff}:host button.social.google:hover i{color:#fff}:host .form-control{box-shadow:none}:host .form-control.ng-invalid.ng-touched{border-color:#bd2130}:host .validation-text{font-size:14px;color:#bd2130;position:relative;top:-10px;margin-top:15px}:host .validation-text span{display:block}:host .not-member{display:flex;justify-content:center;align-items:center;margin-top:10px}footer{display:none!important}header{display:none!important}:host .page-container>.row{min-height:100%}:host .sign-up-accounts-form-content{font-size:1.3rem}@media all and (max-width: 767.98px){:host .sign-up-accounts-form-content{position:static;transform:none;width:auto;max-width:400px;margin:30px auto 0}}:host .form-group{margin:0}:host input{height:3.5rem;padding:0 10px;font-size:1.25rem}:host label{margin-bottom:0}:host .phone-country-selector ::ng-deep .ng-placeholder{font-size:12px}:host .phone-country-selector ::ng-deep .ng-select.ng-select-focused.ng-touched.ng-dirty.ng-invalid>.ng-select-container{border:1px solid red}:host .phone-country-selector .ng-touched.ng-dirty.ng-invalid:not(form){border:1px solid red}:host .phoneNumber{display:flex;align-items:center;justify-content:flex-start}:host .phoneNumber ::ng-deep .ng-select.ng-select-single .ng-select-container{border:1px solid #acacac;height:36px!important;box-shadow:none;min-width:80px}:host .expireTimer{pointer-events:none!important}:host .enableTimer{pointer-events:unset!important}:host #phoneNumberInput{width:100%}body{background:#eee}.bgWhite{background:white}.title{margin-top:20px;font-size:20px}.customBtn{border-radius:0;padding:10px}.verify-form input{display:inline-block;width:50px;height:50px;text-align:center;margin:0 5px}.verify-form :focus{border:2px solid #000}#countdownCircle{position:relative;margin:40px auto auto;height:40px;width:40px;text-align:center}#countdown-number{color:#000;display:inline-block;line-height:40px;font-weight:600}svg{position:absolute;top:0;right:0;width:40px;height:40px;transform:rotateY(-180deg) rotate(-90deg)}svg circle{stroke-dasharray:113px;stroke-dashoffset:0px;stroke-linecap:round;stroke-width:2px;stroke:#000;fill:none}@keyframes countdown{0%{stroke-dashoffset:0px}to{stroke-dashoffset:113px}}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.LazyLoadImageDirective, selector: "[lazyLoad]", inputs: ["lazyLoad", "defaultImage", "errorImage", "scrollTarget", "customObservable", "offset", "useSrcset", "decode", "debug"], outputs: ["onStateChange"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i6.AsyncPipe } });
VerifyPhoneBaseComponent = __decorate([
    HostListener('window:popstate', ['$event']),
    HostListener('document:keypress', ['$event']),
    __metadata("design:paramtypes", [FormBuilder,
        LoginService,
        LanguageService,
        ConfService,
        Router,
        ActivatedRoute,
        PersonalInfoService,
        ToastrService,
        CheckoutService,
        Renderer2])
], VerifyPhoneBaseComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VerifyPhoneBaseComponent, decorators: [{
            type: Component,
            args: [{
                    // host: {
                    //   '(document:keypress)': 'handleKeyboardEvent($event)'
                    // },
                    selector: 'app-base-verify-phone',
                    templateUrl: './verify-phone.base-component.html',
                    styleUrls: ['./verify-phone.base-component.scss'],
                }]
        }, {
            type: HostListener,
            args: ['window:popstate', ['$event']]
        }, {
            type: HostListener,
            args: ['document:keypress', ['$event']]
        }], ctorParameters: function () { return [{ type: i1$1.FormBuilder }, { type: LoginService }, { type: LanguageService }, { type: ConfService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: PersonalInfoService }, { type: i3$1.ToastrService }, { type: CheckoutService }, { type: i0.Renderer2 }]; }, propDecorators: { unloadHandler: [{
                type: HostListener,
                args: ['window:beforeunload', ['$event']]
            }] } });

class AaibComponent {
    constructor(checkoutService, cartService, languageService, route, router) {
        this.checkoutService = checkoutService;
        this.cartService = cartService;
        this.languageService = languageService;
        this.route = route;
        this.router = router;
        this.loading = false;
    }
    ngOnInit() {
        this.languageService.getLanguage().subscribe(lanuage => this.language = lanuage);
        this.route.queryParams.subscribe(params => {
            this.aaibData = params;
            if (this.aaibData['success'] === '1' && this.aaibData['order-number']) {
                this.loading = false;
                const cartIdStorage = localStorage.getItem('cartId');
                this.checkoutService.getOrder(cartIdStorage)
                    .subscribe(data => {
                    const cartId = data['id'];
                    if (cartId != cartIdStorage) {
                        this.router.navigate(['']);
                    }
                    if (data['checkoutState'] != 'completed') {
                        this.router.navigate(['']);
                    }
                    if (data['checkoutState'] && data['checkoutState'] == 'completed' && cartId == cartIdStorage) {
                        const paymentData = {
                            orderNumber: data['number'],
                            total: data['total'],
                            currency: data['currencyCode'],
                            status: 'success'
                        };
                        this.cartService.emptyCartLastStepStripePayment(paymentData, cartId);
                    }
                });
                this.cartService.emptyCartLastStepAaib('', this.aaibData['amount'], this.aaibData['currency']);
            }
            else {
                this.checkoutService.errorMsgAaib.next(true);
                this.router.navigateByUrl('checkout/payment');
            }
        });
    }
}
AaibComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AaibComponent, deps: [{ token: CheckoutService }, { token: CartService }, { token: LanguageService }, { token: i2.ActivatedRoute }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
AaibComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: AaibComponent, selector: "app-aaib", ngImport: i0, template: "<div class=\"container\">\r\n    <div *ngIf=\"loading; else showError\">\r\n      <app-inner-loading></app-inner-loading>\r\n    </div>\r\n    <ng-template #showError>\r\n      <div *ngIf=\"errorFromAaib\">\r\n        An error has occured, please save the following info Transaction ID : {{ payFortTransId }} - Cart ID \r\n        {{ aaibData['order-number'] }} and Contact us immediately <a routerLink=\"/contact-us\">Contact us</a>\r\n      </div>\r\n    </ng-template>\r\n  </div>", styles: [".declined{color:red}.approved{color:green}img{height:60px;width:auto}h1,h3,h4{text-align:center}a{color:#00f}.payment-message{font-size:40px}\n"], components: [{ type: InnerLoadingComponent, selector: "app-inner-loading" }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AaibComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-aaib',
                    templateUrl: './aaib.component.html',
                    styleUrls: ['./aaib.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: CheckoutService }, { type: CartService }, { type: LanguageService }, { type: i2.ActivatedRoute }, { type: i2.Router }]; } });

/**here you can add all factories needed in libraries module instead of writing them into the moudle itself*/
function appConfigFactory(appInitService) {
    return () => {
        return appInitService.init();
    };
}

class NgxBbnZvendoModule {
    static forRoot(projectEnvironment) {
        return {
            ngModule: NgxBbnZvendoModule,
            providers: [
                {
                    provide: 'env',
                    useValue: projectEnvironment
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: appConfigFactory,
                    deps: [AppInitService],
                    multi: true
                },
                RequestCacheWithMap,
                AuthService,
                BreadcrumbService,
                CartService,
                CollectionService,
                ShopService,
                CompareService,
                ConfService,
                ContactUsService,
                LanguageService,
                LoaderService,
                LoginService,
                ProductService,
                StaticPagesService,
                TaxonService,
                WishListService,
                AddressingService,
                ChangePasswordService,
                OrderHistoryService,
                PersonalInfoService,
                QuickViewService,
                TranslatePipe,
                TranslationPipe,
                NoSanitizeHtmlPipe,
                CompleteGuardCheckout,
                CheckoutService,
                CheckoutMyDetailsGuard,
                ShippingGuardCheckout,
                PaymentGuardCheckout,
                CheckoutAddressingGuard,
                WeAcceptService,
                CheckoutOrderSuccessGuard,
                CheckoutOrderInvoiceGuard,
                DisablePurchaseGuard,
                WishListGuard,
                // GoogleAnalyticsService,
                InstagramService,
                BrandsService,
                { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
                // { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
            ]
        };
    }
}
NgxBbnZvendoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NgxBbnZvendoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxBbnZvendoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NgxBbnZvendoModule, declarations: [ChangeVisibilityDirective,
        ImageDirective,
        AccordionDirective,
        NumberDirective,
        FixedWithScrollDirective,
        TranslatePipe,
        TranslationPipe,
        NoSanitizeHtmlPipe,
        AccountContainerBaseComponent,
        ForgetPasswordBaseComponent,
        LoginBaseComponent,
        ResetPasswordBaseComponent,
        SignUpBaseComponent,
        BreadcrumbBaseComponent,
        CartBaseComponent,
        CollectionBaseComponent,
        FilterBaseComponent,
        TaxonBaseComponent,
        SubCategorySliderComponent,
        ProductBaseComponent,
        HomeProductBaseComponent,
        FeatureProductBaseComponent,
        ProductDetailsBaseComponent,
        QuickViewBaseComponent,
        TagsBaseComponent,
        CompareBaseComponent,
        ContactUsBaseComponent,
        FooterBaseComponent,
        HeaderBaseComponent,
        SideMenuBaseComponent,
        SearchBaseComponent,
        HomeBaseComponent,
        LanguageBaseComponent,
        AddressBookBaseComponent,
        DashboardBaseComponent,
        EditAddressBaseComponent,
        OrderHistoryBaseComponent,
        ProfileContainerBaseComponent,
        WishListBaseComponent,
        AppBaseComponent,
        StoreNotAvailableComponent,
        StoreNotActivatedComponent,
        StaticPageComponent,
        VerifyAccountComponent,
        WeAcceptComponent,
        PaytabsComponent,
        KashierCallBacksComponent,
        PayfortComponent,
        UpgCallbackComponent,
        CheckoutSuccessComponent,
        PaymentComponent,
        CompleteComponent,
        AddressingComponent,
        CheckoutComponent,
        ShippingComponent,
        SummaryComponent,
        RadioButtonsComponent,
        OrderInvoiceComponent,
        CheckoutSpinnerComponent,
        AccordionDirective,
        TaxonBaseComponent,
        SubCategorySliderComponent,
        HeaderItemBaseComponent,
        HeaderTaxonBaseComponent,
        StoreNotPublishedComponent,
        SpinnerComponent,
        PageNotFoundComponent,
        InnerLoadingComponent,
        PaginationBaseComponent,
        CurrenciesbaseComponent,
        CurrenciesSideMenuComponent,
        FixedHeaderDirective,
        MpgsCallbackComponent,
        ProductAddonsBaseComponent,
        BranchSelectorModalComponent,
        BranchSelectorComponent,
        GeofenceComponent,
        PopupBaseComponent,
        RecaptchaBaseComponent,
        MiniCartBaseComponent,
        WhatsappBaseComponent,
        VerifyPhoneBaseComponent,
        UserLocationComponent,
        AaibComponent], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        LayoutModule, i1$2.BsDropdownModule, i6$2.BsDatepickerModule, i3$2.TimepickerModule, i4$2.AccordionModule, LazyLoadImageModule, i4$1.PaginationModule, ModalModule, i10.RatingModule, i12.TooltipModule, i17.TabsModule, i13.CarouselModule, OwlModule,
        NouisliderModule,
        ClickOutsideModule,
        NgSelectModule,
        CarouselModule], exports: [LazyLoadImageModule,
        ChangeVisibilityDirective,
        ImageDirective,
        AccordionDirective,
        FixedWithScrollDirective,
        TranslatePipe,
        TranslationPipe,
        NoSanitizeHtmlPipe,
        StoreNotAvailableComponent,
        StoreNotActivatedComponent,
        StaticPageComponent,
        VerifyAccountComponent,
        StoreNotPublishedComponent,
        AccountContainerBaseComponent,
        SignUpBaseComponent,
        LoginBaseComponent,
        ForgetPasswordBaseComponent,
        ResetPasswordBaseComponent,
        QuickViewBaseComponent,
        ProductBaseComponent,
        HomeProductBaseComponent,
        FeatureProductBaseComponent,
        FilterBaseComponent,
        TaxonBaseComponent,
        SubCategorySliderComponent,
        ProductDetailsBaseComponent,
        PaginationBaseComponent,
        ProductAddonsBaseComponent,
        ProfileContainerBaseComponent,
        DashboardBaseComponent,
        AddressBookBaseComponent,
        OrderHistoryBaseComponent,
        EditAddressBaseComponent,
        BreadcrumbBaseComponent,
        CompareBaseComponent,
        WishListBaseComponent,
        ContactUsBaseComponent,
        FooterBaseComponent,
        CartBaseComponent,
        HomeBaseComponent,
        HeaderItemBaseComponent,
        HeaderTaxonBaseComponent,
        LanguageBaseComponent,
        SpinnerComponent,
        PageNotFoundComponent,
        InnerLoadingComponent,
        CurrenciesbaseComponent,
        CurrenciesSideMenuComponent,
        FixedHeaderDirective,
        BranchSelectorComponent,
        PopupBaseComponent,
        RecaptchaBaseComponent,
        MiniCartBaseComponent,
        WhatsappBaseComponent,
        VerifyPhoneBaseComponent,
        UserLocationComponent] });
NgxBbnZvendoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NgxBbnZvendoModule, imports: [[
            CommonModule,
            RouterModule,
            FormsModule,
            ReactiveFormsModule,
            LayoutModule,
            BsDropdownModule.forRoot(),
            BsDatepickerModule.forRoot(),
            TimepickerModule.forRoot(),
            AccordionModule.forRoot(),
            LazyLoadImageModule,
            PaginationModule.forRoot(),
            ModalModule,
            RatingModule.forRoot(),
            TooltipModule.forRoot(),
            TabsModule.forRoot(),
            CarouselModule$1.forRoot(),
            OwlModule,
            NouisliderModule,
            ClickOutsideModule,
            NgSelectModule,
            CarouselModule
        ], LazyLoadImageModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: NgxBbnZvendoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ChangeVisibilityDirective,
                        ImageDirective,
                        AccordionDirective,
                        NumberDirective,
                        FixedWithScrollDirective,
                        TranslatePipe,
                        TranslationPipe,
                        NoSanitizeHtmlPipe,
                        AccountContainerBaseComponent,
                        ForgetPasswordBaseComponent,
                        LoginBaseComponent,
                        ResetPasswordBaseComponent,
                        SignUpBaseComponent,
                        BreadcrumbBaseComponent,
                        CartBaseComponent,
                        CollectionBaseComponent,
                        FilterBaseComponent,
                        TaxonBaseComponent,
                        SubCategorySliderComponent,
                        ProductBaseComponent,
                        HomeProductBaseComponent,
                        FeatureProductBaseComponent,
                        ProductDetailsBaseComponent,
                        QuickViewBaseComponent,
                        TagsBaseComponent,
                        CompareBaseComponent,
                        ContactUsBaseComponent,
                        FooterBaseComponent,
                        HeaderBaseComponent,
                        SideMenuBaseComponent,
                        SearchBaseComponent,
                        HomeBaseComponent,
                        LanguageBaseComponent,
                        AddressBookBaseComponent,
                        DashboardBaseComponent,
                        EditAddressBaseComponent,
                        OrderHistoryBaseComponent,
                        ProfileContainerBaseComponent,
                        WishListBaseComponent,
                        AppBaseComponent,
                        StoreNotAvailableComponent,
                        StoreNotActivatedComponent,
                        StaticPageComponent,
                        VerifyAccountComponent,
                        WeAcceptComponent,
                        PaytabsComponent,
                        KashierCallBacksComponent,
                        PayfortComponent,
                        UpgCallbackComponent,
                        CheckoutSuccessComponent,
                        PaymentComponent,
                        CompleteComponent,
                        AddressingComponent,
                        CheckoutComponent,
                        ShippingComponent,
                        SummaryComponent,
                        RadioButtonsComponent,
                        OrderInvoiceComponent,
                        CheckoutSpinnerComponent,
                        AccordionDirective,
                        TaxonBaseComponent,
                        SubCategorySliderComponent,
                        HeaderItemBaseComponent,
                        HeaderTaxonBaseComponent,
                        StoreNotPublishedComponent,
                        SpinnerComponent,
                        PageNotFoundComponent,
                        InnerLoadingComponent,
                        PaginationBaseComponent,
                        CurrenciesbaseComponent,
                        CurrenciesSideMenuComponent,
                        FixedHeaderDirective,
                        MpgsCallbackComponent,
                        ProductAddonsBaseComponent,
                        BranchSelectorModalComponent,
                        BranchSelectorComponent,
                        GeofenceComponent,
                        PopupBaseComponent,
                        RecaptchaBaseComponent,
                        MiniCartBaseComponent,
                        WhatsappBaseComponent,
                        VerifyPhoneBaseComponent,
                        UserLocationComponent,
                        AaibComponent,
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        FormsModule,
                        ReactiveFormsModule,
                        LayoutModule,
                        BsDropdownModule.forRoot(),
                        BsDatepickerModule.forRoot(),
                        TimepickerModule.forRoot(),
                        AccordionModule.forRoot(),
                        LazyLoadImageModule,
                        PaginationModule.forRoot(),
                        ModalModule,
                        RatingModule.forRoot(),
                        TooltipModule.forRoot(),
                        TabsModule.forRoot(),
                        CarouselModule$1.forRoot(),
                        OwlModule,
                        NouisliderModule,
                        ClickOutsideModule,
                        NgSelectModule,
                        CarouselModule
                    ],
                    exports: [
                        LazyLoadImageModule,
                        ChangeVisibilityDirective,
                        ImageDirective,
                        AccordionDirective,
                        FixedWithScrollDirective,
                        TranslatePipe,
                        TranslationPipe,
                        NoSanitizeHtmlPipe,
                        StoreNotAvailableComponent,
                        StoreNotActivatedComponent,
                        StaticPageComponent,
                        VerifyAccountComponent,
                        StoreNotPublishedComponent,
                        AccountContainerBaseComponent,
                        SignUpBaseComponent,
                        LoginBaseComponent,
                        ForgetPasswordBaseComponent,
                        ResetPasswordBaseComponent,
                        QuickViewBaseComponent,
                        ProductBaseComponent,
                        HomeProductBaseComponent,
                        FeatureProductBaseComponent,
                        FilterBaseComponent,
                        TaxonBaseComponent,
                        SubCategorySliderComponent,
                        ProductDetailsBaseComponent,
                        PaginationBaseComponent,
                        ProductAddonsBaseComponent,
                        ProfileContainerBaseComponent,
                        DashboardBaseComponent,
                        AddressBookBaseComponent,
                        OrderHistoryBaseComponent,
                        EditAddressBaseComponent,
                        BreadcrumbBaseComponent,
                        CompareBaseComponent,
                        WishListBaseComponent,
                        ContactUsBaseComponent,
                        FooterBaseComponent,
                        CartBaseComponent,
                        HomeBaseComponent,
                        HeaderItemBaseComponent,
                        HeaderTaxonBaseComponent,
                        LanguageBaseComponent,
                        SpinnerComponent,
                        PageNotFoundComponent,
                        InnerLoadingComponent,
                        CurrenciesbaseComponent,
                        CurrenciesSideMenuComponent,
                        FixedHeaderDirective,
                        BranchSelectorComponent,
                        PopupBaseComponent,
                        RecaptchaBaseComponent,
                        MiniCartBaseComponent,
                        WhatsappBaseComponent,
                        VerifyPhoneBaseComponent,
                        UserLocationComponent
                    ]
                }]
        }] });

const CheckoutRoute = [
    {
        path: '',
        component: CheckoutComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'mydetails',
            },
            {
                path: 'mydetails',
                component: AddressingComponent,
                canActivate: [DisablePurchaseGuard],
            },
            {
                path: 'shipping',
                component: ShippingComponent,
                canActivate: [ShippingGuardCheckout],
            },
            {
                path: 'payment',
                component: PaymentComponent,
                canActivate: [PaymentGuardCheckout],
            },
        ]
    },
];

const NgxBbnZvendoRouting = [
    {
        path: 'page/:code',
        component: StaticPageComponent
    },
    {
        path: 'mobile/page/:code',
        component: StaticPageComponent
    },
    {
        path: 'verify-account/:email/:token',
        component: VerifyAccountComponent,
    },
    {
        path: 'order-success',
        component: CheckoutSuccessComponent,
        canActivate: [CheckoutOrderSuccessGuard],
    },
    {
        path: 'we-accept',
        component: WeAcceptComponent
    },
    {
        path: 'paytabs',
        component: PaytabsComponent
    },
    {
        path: 'stripe',
        component: PaytabsComponent
    },
    {
        path: 'paymentCallback',
        component: PaytabsComponent
    },
    {
        path: 'paymentCallback/:paymentType/:paymentCallbackId',
        component: PaytabsComponent
    },
    {
        path: 'kashier',
        component: KashierCallBacksComponent
    },
    {
        path: 'payfort',
        component: PayfortComponent
    },
    {
        path: 'cybersource',
        component: AaibComponent
    },
    {
        path: 'upg',
        component: UpgCallbackComponent
    },
    {
        path: 'mpgs',
        component: MpgsCallbackComponent
    },
    {
        path: 'checkout',
        children: CheckoutRoute,
    },
    {
        path: 'order-success/:id',
        component: CheckoutSuccessComponent,
        canActivate: [CheckoutOrderSuccessGuard]
    },
    {
        path: 'download-invoice/:id',
        component: OrderInvoiceComponent,
    },
    {
        path: 'notFound',
        component: PageNotFoundComponent
    },
    {
        path: 'mobile/notFound',
        component: PageNotFoundComponent
    },
    {
        path: ':fbAdds',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];

class PaymentResolver {
    constructor(checkoutService) {
        this.checkoutService = checkoutService;
    }
    resolve(route, rstate) {
        this.checkoutService.getPaymentsMethodsFromApi();
        return this.checkoutService.getFullyCheckoutData();
    }
}
PaymentResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentResolver, deps: [{ token: CheckoutService }], target: i0.ɵɵFactoryTarget.Injectable });
PaymentResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentResolver });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PaymentResolver, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CheckoutService }]; } });

class ProfileGuard {
    constructor(loginService, router) {
        this.loginService = loginService;
        this.router = router;
    }
    canActivate(childRoute, state) {
        const logged = this.loginService.logged.getValue();
        if (!logged) {
            const language = state.url.split('/').filter(data => data !== '')[0];
            this.router.navigate(['/', language, 'accounts', 'login']);
        }
        else {
            return true;
        }
    }
}
ProfileGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProfileGuard, deps: [{ token: LoginService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
ProfileGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProfileGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ProfileGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LoginService }, { type: i2.Router }]; } });

class AccountsGuard {
    constructor(loginService, router) {
        this.loginService = loginService;
        this.router = router;
    }
    canActivate(childRoute, state) {
        const logged = this.loginService.logged.getValue();
        if (logged) {
            const language = state.url.split('/').filter(data => data !== '')[0];
            this.router.navigate(['/', language, 'profile', 'dashboard']);
        }
        else {
            return true;
        }
    }
}
AccountsGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AccountsGuard, deps: [{ token: LoginService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
AccountsGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AccountsGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AccountsGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LoginService }, { type: i2.Router }]; } });

const DropAnimation = trigger('dropAnim', [
    state('void', style({
        opacity: 0.3,
        transform: 'translateY(-30px) perspective(850px) ',
        transformStyle: 'preserve-3d',
    })),
    state('final', style({
        opacity: 1,
        transform: 'translateY(0) perspective(0)',
        transformStyle: 'preserve-3d',
    })),
    transition('void <=> final', animate('300ms ease-in-out'))
]);

const DropRizkalla = trigger('dropRizkalla', [
    state('void', style({
        height: '0',
        overflow: 'hidden'
    })),
    state('final', style({
        height: 'auto',
    })),
    transition('void<=>*', animate('.3s ease-in-out'))
]);

const ShowAnimation = trigger('showanimation', [
    state('show', style({ 'display': 'block' })),
    state('hide', style({ 'display': 'none' })),
    transition('show <=> hide', animate(800))
]);

const ShowAnimationDiscount = trigger('showanimationdiscount', [
    state('show', style({ 'display': 'block' })),
    state('hide', style({ 'display': 'none' })),
    transition('show <=> hide', animate(800))
]);

const ShowAnimationFeatueProduct = trigger('showanimationfeatueproduct', [
    state('show', style({ 'display': 'block' })),
    state('hide', style({ 'display': 'none' })),
    transition('show <=> hide', animate(800))
]);

const SlideMenu = trigger('slideMenu', [
    state('void', style({
        opacity: 0.8,
        left: '-350px'
    })),
    state('final', style({
        opacity: 1,
    })),
    transition('void <=> final', animate('300ms ease-in-out'))
]);

/*
 * Public API Surface of ngx-bbn-zvendo
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessToken, AccordionDirective, AccountContainerBaseComponent, AccountsGuard, AddressBookBaseComponent, AddressingService, AllPage, ApiResponse, AppBaseComponent, Area, Association, Attribute, AttributeValues, AuthService, BranchSelectorComponent, BrandsService, Breadcrumb, BreadcrumbBaseComponent, BreadcrumbService, Cart, CartBaseComponent, CartItem, CartService, Categories, ChangePasswordService, ChangeVisibilityDirective, CheckoutAddressingGuard, CheckoutMyDetailsGuard, CheckoutRoute, CheckoutService, City, CollectionBaseComponent, CollectionService, CompareBaseComponent, CompareService, CompleteGuardCheckout, Conf, ConfService, ContactUsBaseComponent, ContactUsService, Country, CurrenciesSideMenuComponent, CurrenciesbaseComponent, Currency, CustomThemeService, DashboardBaseComponent, DefaultPriceRange, DisablePurchaseGuard, DropAnimation, DropRizkalla, EditAddressBaseComponent, FacebookPixelService, FeatureProductBaseComponent, Features, Filter, FilterBaseComponent, FixedHeaderDirective, FixedWithScrollDirective, FooterBaseComponent, ForgetPasswordBaseComponent, GoogleAnalyticsService, GoogleTagManagerService, HeaderBaseComponent, HeaderItemBaseComponent, HeaderTaxonBaseComponent, HomeBaseComponent, HomeProductBaseComponent, Image$1 as Image, ImageDirective, InnerLoadingComponent, InstagramService, LanguageBaseComponent, LanguageService, LoaderService, Locale, LoginBaseComponent, LoginService, MiniCartBaseComponent, NavigationMenu, NgxBbnZvendoModule, NgxBbnZvendoRouting, NoSanitizeHtmlPipe, OldApiResponse, Option$1 as Option, OptionValue, Order, OrderHistoryBaseComponent, OrderHistoryService, Orders, Page, PageNotFoundComponent, PaginationBaseComponent, PaymentGuardCheckout, PaymentResolver, PersonalInfoService, PopupBaseComponent, Price, PriceRange, Product, Product2, ProductAddonsBaseComponent, ProductBaseComponent, ProductDetailsBaseComponent, ProductService, ProfileContainerBaseComponent, ProfileGuard, QuickViewBaseComponent, QuickViewService, RecaptchaBaseComponent, ResetPasswordBaseComponent, Review, SearchBaseComponent, ShippingGuardCheckout, ShopService, ShowAnimation, ShowAnimationDiscount, ShowAnimationFeatueProduct, SideMenuBaseComponent, SignUpBaseComponent, SliceDownAnimation, SlideMenu, Slider, Sliders, SpinnerComponent, StaticPageComponent, StaticPagesService, StoreIdentity, StoreNotActivatedComponent, StoreNotAvailableComponent, StoreNotPublishedComponent, StoresName, SubCategorySliderComponent, TagsBaseComponent, Taxon, TaxonBaseComponent, TaxonService, Translatable, TranslatePipe, TranslationPipe, UserLocationComponent, Value, Variant, VariantOptionValue, VerifyAccountComponent, VerifyPhoneBaseComponent, WeAcceptService, WhatsappBaseComponent, WishListBaseComponent, WishListGuard, WishListService, dropAcountMobile, environment, listStaggerAnimation };
//# sourceMappingURL=bbndev-ngx-bbn-zvendo.js.map
